import e, { t } from "i18next";
import * as n from "three";
import { AmbientLight as r, AxesHelper as i, Box3 as a, Box3Helper as o, BoxGeometry as s, BufferAttribute as c, BufferGeometry as l, CanvasTexture as u, Clock as d, Color as f, DataTexture as p, DirectionalLight as m, DoubleSide as h, EdgesGeometry as g, Euler as ee, Float32BufferAttribute as te, FloatType as _, FrontSide as v, Frustum as ne, Group as re, HemisphereLight as ie, InstancedBufferAttribute as ae, InstancedBufferGeometry as oe, InstancedMesh as se, Line as ce, LineBasicMaterial as le, LineDashedMaterial as ue, LineSegments as de, LinearFilter as fe, LinearMipMapLinearFilter as pe, MathUtils as me, Matrix3 as he, Matrix4 as y, Mesh as ge, MeshBasicMaterial as _e, MeshStandardMaterial as ve, Object3D as ye, OrthographicCamera as be, PMREMGenerator as xe, PerspectiveCamera as Se, Plane as Ce, PlaneGeometry as we, Quaternion as Te, RGBAFormat as Ee, Ray as De, Raycaster as Oe, Scene as ke, ShaderMaterial as Ae, Sphere as b, SphereGeometry as je, Spherical as Me, SpriteMaterial as Ne, StaticDrawUsage as Pe, Vector2 as Fe, Vector3 as x, Vector4 as Ie, WebGLRenderer as Le } from "three";
import { Signal as Re } from "typed-signals";
import { MeshoptDecoder as ze } from "three/examples/jsm/libs/meshopt_decoder.module.js";
import { GLTFLoader as Be } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OBJLoader as Ve } from "three/examples/jsm/loaders/OBJLoader.js";
import * as He from "@pangenerator/tweakpane-textarea-plugin";
import * as Ue from "@tweakpane/plugin-essentials";
import { FolderApi as We, Pane as Ge } from "tweakpane";
import { estimateBytesUsed as Ke } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { mapRange as qe } from "@tweakpane/core";
import { Sky as Je } from "three/examples/jsm/objects/Sky.js";
import { Heap as Ye } from "heap-js";
import { MeshBVH as S } from "three-mesh-bvh";
import { BufferGeometry as Xe, Vector3 as Ze } from "three/src/Three.js";
import { radToDeg as Qe } from "three/src/math/MathUtils.js";
import { VertexNormalsHelper as $e } from "three/examples/jsm/helpers/VertexNormalsHelper.js";
import et from "camera-controls";
import { ctxmenu as tt } from "ctxmenu";
import { RoomEnvironment as nt } from "three/examples/jsm/environments/RoomEnvironment.js";
import { N8AOPostPass as rt } from "n8ao";
import { CopyPass as it, EffectComposer as at, EffectPass as ot, RenderPass as st, SMAAEffect as ct, SMAAPreset as lt } from "postprocessing";
import { TransformControls as ut } from "three/examples/jsm/controls/TransformControls.js";
//#region \0rolldown/runtime.js
var dt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ft = {
	"components.table.nodata_alert.text": "No data available.",
	"components.toolbar.close_button.label": "Close",
	"components.toolbar.collapse_button.label": "Collapse menus",
	"components.toolbar.expand_button.label": "Expand menus",
	"components.treeView.tree_view_node.expand_node_button.label": "Unfold the treeview node",
	"components.treeView.tree_view_node.load_more_button.label": "Load more",
	"context_menu.clear_scene.text": "Clear scene",
	"context_menu.hide.text_one": "Hide {{count}} selected mesh",
	"context_menu.hide.text_other": "Hide {{count}} selected meshes",
	"context_menu.isolate.text_one": "Isolate {{count}} selected mesh",
	"context_menu.isolate.text_other": "Isolate {{count}} selected meshes",
	"context_menu.remove_all_clipping_planes.text": "Remove all clipping planes",
	"context_menu.remove_all_measure_lines.text": "Remove all measure lines",
	"context_menu.remove_clipping_plane.text": "Remove clipping plane",
	"context_menu.remove_measure_line_anchor.text": "Remove point",
	"context_menu.remove_measure_line.text": "Remove measure line",
	"frame_alert.buttons.cancel.text": "Cancel",
	"frame_alert.buttons.validate.text": "Validate",
	"frame_alert.text": "Validate the operator action",
	"info_banner.memory_not_optimal_warning.text": "Performance is not optimal. Memory used:",
	"info_banner.memory_not_optimal_warning.title": "Memory warning",
	"info_banner.memory_warning.text": "Performance is degraded. Memory used:",
	"info_banner.memory_warning.title": "Memory warning",
	"spotlight.copy_selection.text": "Copy current selection",
	"spotlight.hide_selection.text_one": "Hide current selection ({{count}} selected mesh)",
	"spotlight.hide_selection.text_other": "Hide current selection ({{count}} selected meshes)",
	"spotlight.isolate_selection.text_one": "Isolate current selection ({{count}} selected mesh)",
	"spotlight.isolate_selection.text_other": "Isolate current selection ({{count}} selected meshes)",
	"spotlight.redo.text": "Redo last action",
	"spotlight.select_all.text": "Select all objects",
	"spotlight.undo.text": "Undo last action",
	"spotlight.xray_selection.text": "XRay current selection",
	"teia.context_menu.remove_all_zones.text": "Delete all zones",
	"teia.context_menu.remove_projection.text": "Delete projection",
	"teia.context_menu.remove_zone.text": "Delete zone",
	"teia.info_banner.objects_limit_warning_end.text": "objects will be loaded: performance may be degraded or the twin may not fully load.",
	"teia.info_banner.objects_limit_warning_start.text": "More than",
	"teia.info_banner.objects_limit_warning.title": "Max objects count limition",
	"teia.info_banner.twin_optimization_warning.text": "Twin is being optimized, data may not be available. Optimization status:",
	"teia.info_banner.twin_optimization_warning.title": "Optimization warning",
	"teia.info_banner.twin_process_warning.text": "Twin is being process, data may not be available. Status:",
	"teia.info_banner.twin_process_warning.title": "Processing twin",
	"teia.toolbar.search.button.tooltip": "Advanced Search",
	"teia.toolbar.search.tooltip": "Search",
	"teia.widgets.advanced_search_widget.errors.error_from_api.text": "Error during the search",
	"teia.widgets.advanced_search_widget.errors.no_twin.text": "No Twin available",
	"teia.widgets.advanced_search_widget.filter_on_visible_input.text": "Only visible objects",
	"teia.widgets.advanced_search_widget.search_button.label": "Search",
	"teia.widgets.advanced_search_widget.search_button.text": "Search",
	"teia.widgets.advanced_search_widget.title": "Advanced Search",
	"teia.widgets.floor_plan_widget.add_layer_tab.advanced_search.text": "Advanced Search",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.add.text": "Add",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.family.text": "Field family",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_color.text": "Font color",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_size.text": "Font size",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.position.text": "Position",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.prefix.text": "Prefix",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.remove.text": "Remove",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.suffix.text": "Suffix",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.text": "Annotations",
	"teia.widgets.floor_plan_widget.add_layer_tab.background.text": "Background",
	"teia.widgets.floor_plan_widget.add_layer_tab.cancel.text": "Cancel",
	"teia.widgets.floor_plan_widget.add_layer_tab.customize_style.text": "Customize the style",
	"teia.widgets.floor_plan_widget.add_layer_tab.layer_name.label": "Layer name",
	"teia.widgets.floor_plan_widget.add_layer_tab.line.text": "Line",
	"teia.widgets.floor_plan_widget.add_layer_tab.properties.title": "Select concerned properties",
	"teia.widgets.floor_plan_widget.add_layer_tab.title": "Editing {{name}}",
	"teia.widgets.floor_plan_widget.add_layer_tab.validate.text": "Validate",
	"teia.widgets.floor_plan_widget.add_layer_tab.warnings.invalid_filter.text": "You need to set the concerned properties.",
	"teia.widgets.floor_plan_widget.add_tab.add_layer.text": "Add layer",
	"teia.widgets.floor_plan_widget.add_tab.copy.text": "Copy",
	"teia.widgets.floor_plan_widget.add_tab.delete.text": "Delete",
	"teia.widgets.floor_plan_widget.add_tab.drag.text": "Drag",
	"teia.widgets.floor_plan_widget.add_tab.duplicate.text": "Duplicate",
	"teia.widgets.floor_plan_widget.add_tab.layer.text": "What do you want to project?",
	"teia.widgets.floor_plan_widget.add_tab.params.text": "Parameters",
	"teia.widgets.floor_plan_widget.add_tab.plan_name.label": "Plan name",
	"teia.widgets.floor_plan_widget.add_tab.point_of_view.text": "Select point of view",
	"teia.widgets.floor_plan_widget.add_tab.titles.create.title": "Create a new plan",
	"teia.widgets.floor_plan_widget.add_tab.titles.update.title": "Editing {{name}}",
	"teia.widgets.floor_plan_widget.add_tab.validate.text": "Validate",
	"teia.widgets.floor_plan_widget.add_tab.warnings.at_least_one_layer.text": "You should have at least one layer",
	"teia.widgets.floor_plan_widget.add_tab.warnings.must_have_a_name.text": "You should choose a name for your plan",
	"teia.widgets.floor_plan_widget.add_tab.warnings.must_have_filter.text": "must have at least one concerned property.",
	"teia.widgets.floor_plan_widget.import_tab.button.cancel.text": "Cancel",
	"teia.widgets.floor_plan_widget.import_tab.button.import.text": "Import",
	"teia.widgets.floor_plan_widget.import_tab.delete.text": "Delete",
	"teia.widgets.floor_plan_widget.import_tab.error_length.text": "Some configurations have been removed: maximum 10 files.",
	"teia.widgets.floor_plan_widget.import_tab.error.text": "Error",
	"teia.widgets.floor_plan_widget.import_tab.file_name.label": "File name",
	"teia.widgets.floor_plan_widget.import_tab.import_suffix.text": "Import",
	"teia.widgets.floor_plan_widget.import_tab.import.text": "Drag or click to open the file explorer",
	"teia.widgets.floor_plan_widget.import_tab.max_files.text": "max. 10 files",
	"teia.widgets.floor_plan_widget.import_tab.modal.cancel.text": "Cancel",
	"teia.widgets.floor_plan_widget.import_tab.modal.confirm.text": "Confirm",
	"teia.widgets.floor_plan_widget.import_tab.modal.title": "Plan import",
	"teia.widgets.floor_plan_widget.import_tab.modal.warning.text": "The JSON files will be imported and turned into plan.",
	"teia.widgets.floor_plan_widget.import_tab.success.text": "Success",
	"teia.widgets.floor_plan_widget.import_tab.title": "Import plan",
	"teia.widgets.floor_plan_widget.list_tab.actions.text": "Actions",
	"teia.widgets.floor_plan_widget.list_tab.analyze.text": "Analyze",
	"teia.widgets.floor_plan_widget.list_tab.caption.completed.text": "Completed",
	"teia.widgets.floor_plan_widget.list_tab.caption.error.text": "Failed",
	"teia.widgets.floor_plan_widget.list_tab.caption.expired.text": "Expired or Degraded",
	"teia.widgets.floor_plan_widget.list_tab.caption.loading.text": "Loading",
	"teia.widgets.floor_plan_widget.list_tab.caption.waiting.text": "Waiting",
	"teia.widgets.floor_plan_widget.list_tab.delete.text": "Delete",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.cancel.text": "Cancel",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.confirm.text": "Continue",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.title": "Projection display",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text_one": "This projection contains a large number of projected objects ({{count}}). Displaying them may cause the application to crash. It is recommended to hide the twin before continuing. Do you want to continue?",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text_other": "This projection contains a large number of projected objects ({{count}}). Displaying them may cause the application to crash. It is recommended to hide the twin before continuing. Do you want to continue?",
	"teia.widgets.floor_plan_widget.list_tab.download_dxf.text": "Download DXF",
	"teia.widgets.floor_plan_widget.list_tab.download_pdf.text": "Download PDF",
	"teia.widgets.floor_plan_widget.list_tab.download_svg.text": "Download SVG",
	"teia.widgets.floor_plan_widget.list_tab.download.text": "Download",
	"teia.widgets.floor_plan_widget.list_tab.duplicate.text": "Duplicate",
	"teia.widgets.floor_plan_widget.list_tab.empty_list.search.text": "No plan found",
	"teia.widgets.floor_plan_widget.list_tab.empty_list.text": "No saved plan",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.cancel.text": "Cancel",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.confirm.text": "Confirm",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.title": "Projection export",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.warning.text": "The parameters will be exported into one or more JSON files.",
	"teia.widgets.floor_plan_widget.list_tab.export.text": "Export",
	"teia.widgets.floor_plan_widget.list_tab.import.text": "Import",
	"teia.widgets.floor_plan_widget.list_tab.restart.text": "Restart export",
	"teia.widgets.floor_plan_widget.list_tab.search.label": "Search",
	"teia.widgets.floor_plan_widget.list_tab.select.text": "Select",
	"teia.widgets.floor_plan_widget.list_tab.table.actions.text": "Actions",
	"teia.widgets.floor_plan_widget.list_tab.table.plan_name.text": "Plans",
	"teia.widgets.floor_plan_widget.list_tab.table.status.text": "Status",
	"teia.widgets.floor_plan_widget.list_tab.title": "Saved plan list",
	"teia.widgets.floor_plan_widget.list_tab.update.text": "Update",
	"teia.widgets.floor_plan_widget.no_twin.text": "No Twin",
	"teia.widgets.floor_plan_widget.title": "PLAN(S)",
	"teia.widgets.infobox_widget.icon.tooltip": "Patch Data",
	"teia.widgets.infobox_widget.tabs.alerts.nodata-search.text": "No results",
	"teia.widgets.infobox_widget.tabs.alerts.nodata.text": "No available properties",
	"teia.widgets.infobox_widget.tabs.bimdata_tab.title": "Bim Data",
	"teia.widgets.infobox_widget.tabs.bimdata_tab.tooltip": "Bim Data",
	"teia.widgets.infobox_widget.tabs.docdata_tab.alerts.error.download.text": "An error occurred while retrieving your file.",
	"teia.widgets.infobox_widget.tabs.docdata_tab.title": "Document data",
	"teia.widgets.infobox_widget.tabs.docdata_tab.tooltip": "View document",
	"teia.widgets.infobox_widget.tabs.ifcdata_tab.title": "Ifc Data",
	"teia.widgets.infobox_widget.tabs.ifcdata_tab.tooltip": "Ifc Data",
	"teia.widgets.infobox_widget.tabs.opendata_tab.title": "Open Data",
	"teia.widgets.infobox_widget.tabs.opendata_tab.tooltip": "Open Data",
	"teia.widgets.infobox_widget.tabs.userdata_tab.title": "User Data",
	"teia.widgets.infobox_widget.tabs.userdata_tab.tooltip": "User Data",
	"teia.widgets.navigation_widget.actions.clear_graph.text": "Delete the navigation graph",
	"teia.widgets.navigation_widget.actions.create.text": "Create the twin graph",
	"teia.widgets.navigation_widget.actions.edit.text": "Edit the existing graph",
	"teia.widgets.navigation_widget.actions.export_json.text": "Export JSON",
	"teia.widgets.navigation_widget.actions.import_json.text": "Import JSON",
	"teia.widgets.navigation_widget.actions.more.label": "Import or export the graph",
	"teia.widgets.navigation_widget.creation.title": "Graph creation",
	"teia.widgets.navigation_widget.flood_fill.calculate.text": "Calculate flood fill",
	"teia.widgets.navigation_widget.flood_fill.cancel.text": "Cancel",
	"teia.widgets.navigation_widget.flood_fill.display_category.all.text": "All",
	"teia.widgets.navigation_widget.flood_fill.display_category.empty.text": "Empty",
	"teia.widgets.navigation_widget.flood_fill.display_category.label": "Displayed category",
	"teia.widgets.navigation_widget.flood_fill.display_category.navigable.text": "Navigable",
	"teia.widgets.navigation_widget.flood_fill.display_category.solid.text": "Solid",
	"teia.widgets.navigation_widget.flood_fill.display_category.unclassified.text": "Unclassified",
	"teia.widgets.navigation_widget.flood_fill.display_grid.text": "Display the voxel grid",
	"teia.widgets.navigation_widget.flood_fill.display_level.all.text": "All resolutions",
	"teia.widgets.navigation_widget.flood_fill.display_level.label": "Displayed resolution",
	"teia.widgets.navigation_widget.flood_fill.manual_seeds.text_one": "{{count}} manual seed · right-click it to delete it",
	"teia.widgets.navigation_widget.flood_fill.manual_seeds.text_other": "{{count}} manual seeds · right-click one to delete it",
	"teia.widgets.navigation_widget.flood_fill.needs_update.text": "The displayed result must be recalculated. Navigable voxels are shown in orange.",
	"teia.widgets.navigation_widget.flood_fill.place_seed.text": "Place manual seeds",
	"teia.widgets.navigation_widget.flood_fill.progress.text_one": "{{count}} empty voxel explored…",
	"teia.widgets.navigation_widget.flood_fill.progress.text_other": "{{count}} empty voxels explored…",
	"teia.widgets.navigation_widget.flood_fill.quit_seed_placement.text": "Stop placing manual seeds",
	"teia.widgets.navigation_widget.flood_fill.result.text": "{{components}} navigable component(s) found from {{seeds}} valid seed(s).",
	"teia.widgets.navigation_widget.flood_fill.seed_distance.label": "Maximum empty-voxel search distance",
	"teia.widgets.navigation_widget.flood_fill.seed_types.label": "BIM seed types",
	"teia.widgets.navigation_widget.flood_fill.seed_types.text": "Comma-separated object types, for example IfcDoor.",
	"teia.widgets.navigation_widget.flood_fill.seed_warnings.text_one": "{{count}} seed was moved or ignored.",
	"teia.widgets.navigation_widget.flood_fill.seed_warnings.text_other": "{{count}} seeds were moved or ignored.",
	"teia.widgets.navigation_widget.flood_fill.title": "Navigable spaces",
	"teia.widgets.navigation_widget.flood_fill.voxels_on_top.text": "Display voxels above objects",
	"teia.widgets.navigation_widget.flood_fill.worker_count.label": "Worker count",
	"teia.widgets.navigation_widget.import_modal.cancel.text": "Cancel",
	"teia.widgets.navigation_widget.import_modal.confirm.text": "Import",
	"teia.widgets.navigation_widget.import_modal.title": "Import a navigation graph",
	"teia.widgets.navigation_widget.import_modal.warning.text": "Warning: this graph will replace the existing graph.",
	"teia.widgets.navigation_widget.navmesh.cancel.text": "Cancel",
	"teia.widgets.navigation_widget.navmesh.generate.text": "Generate the 2.5D navigation graph",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.help.label": "About the maximum edge count",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.help.text": "Hard safety limit for the number of generated edges. Generation stops with an error when the graph exceeds this value.",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.label": "Maximum edge count",
	"teia.widgets.navigation_widget.navmesh.maximum_height.help.label": "About the maximum height difference",
	"teia.widgets.navigation_widget.navmesh.maximum_height.help.text": "Largest vertical difference, in metres, that an allowed stair or doorway connector may bridge.",
	"teia.widgets.navigation_widget.navmesh.maximum_height.label": "Maximum height difference",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.label": "About the maximum merge distance",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.text": "XZ distance, in metres, used to merge nearby cells on the same surface. Larger values create fewer nodes but reduce geometric detail.",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.label": "Maximum merge distance",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.help.label": "About the maximum node count",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.help.text": "Hard safety limit for the number of generated nodes. Generation stops with an error when simplification cannot reduce the graph below this value.",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.label": "Maximum node count",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.help.label": "About the maximum slope angle",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.help.text": "Steepest angle, in degrees, allowed between ordinary neighbouring surface cells. Explicit stair connectors use the maximum height difference instead.",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.label": "Maximum slope angle",
	"teia.widgets.navigation_widget.navmesh.needs_update.text": "The navigation graph is outdated and must be regenerated.",
	"teia.widgets.navigation_widget.navmesh.reduction.text": "Reduction: {{nodes}}% of nodes · {{edges}}% of edges",
	"teia.widgets.navigation_widget.navmesh.result.text": "{{nodes}} nodes · {{edges}} edges · {{components}} components",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.label": "About the simplification tolerance",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.text": "Maximum deviation, in metres, allowed when replacing a nearly straight chain with fewer nodes. Larger values simplify curves more aggressively.",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.label": "Simplification tolerance",
	"teia.widgets.navigation_widget.navmesh.target_nodes.help.label": "About the target node count",
	"teia.widgets.navigation_widget.navmesh.target_nodes.help.text": "Preferred node count for adaptive open-area simplification. This is a target, not a hard limit, so the final graph may contain more nodes.",
	"teia.widgets.navigation_widget.navmesh.target_nodes.label": "Target node count",
	"teia.widgets.navigation_widget.navmesh.title": "2.5D navigation mesh",
	"teia.widgets.navigation_widget.navmesh.voxelization_outdated.text": "The IFC type list changed. Run voxelization and flood fill again before generating the graph.",
	"teia.widgets.navigation_widget.no_twin.text": "A twin must be loaded to create a navigation graph.",
	"teia.widgets.navigation_widget.overview.connect_nodes_automatically.label": "Connect nodes automatically",
	"teia.widgets.navigation_widget.overview.edges.text_one": "{{count}} edge",
	"teia.widgets.navigation_widget.overview.edges.text_other": "{{count}} edges",
	"teia.widgets.navigation_widget.overview.merge_threshold.label": "Merge threshold",
	"teia.widgets.navigation_widget.overview.nodes.text_one": "{{count}} node",
	"teia.widgets.navigation_widget.overview.nodes.text_other": "{{count}} nodes",
	"teia.widgets.navigation_widget.routing.back_to_creation.text": "Back to route creation",
	"teia.widgets.navigation_widget.routing.calculate.text": "Calculate route",
	"teia.widgets.navigation_widget.routing.clear_points.text": "Remove both points",
	"teia.widgets.navigation_widget.routing.connection_distance.label": "Maximum connection distance",
	"teia.widgets.navigation_widget.routing.connections.text_one": "{{count}} valid connection",
	"teia.widgets.navigation_widget.routing.connections.text_other": "{{count}} valid connections",
	"teia.widgets.navigation_widget.routing.delete_point.text": "Delete",
	"teia.widgets.navigation_widget.routing.end.label": "End",
	"teia.widgets.navigation_widget.routing.errors.disconnected_components.text": "The start and end connect to separate parts of the graph.",
	"teia.widgets.navigation_widget.routing.errors.invalid_graph.text": "The graph must be valid before calculating a route.",
	"teia.widgets.navigation_widget.routing.errors.missing_end.text": "Place an end point.",
	"teia.widgets.navigation_widget.routing.errors.missing_graph.text": "No navigation graph is available.",
	"teia.widgets.navigation_widget.routing.errors.missing_start.text": "Place a start point.",
	"teia.widgets.navigation_widget.routing.errors.no_route.text": "No route respecting directions and accessibility was found.",
	"teia.widgets.navigation_widget.routing.errors.unconnected_end.text": "No graph access was found from the end point.",
	"teia.widgets.navigation_widget.routing.errors.unconnected_start.text": "No graph access was found from the start point.",
	"teia.widgets.navigation_widget.routing.not_placed.text": "Not placed",
	"teia.widgets.navigation_widget.routing.place_end.text": "Place end",
	"teia.widgets.navigation_widget.routing.place_start.text": "Place start",
	"teia.widgets.navigation_widget.routing.quit_placement.text": "Stop placing this point",
	"teia.widgets.navigation_widget.routing.route_result.text_one": "{{count}} traversed node · {{distance}} m",
	"teia.widgets.navigation_widget.routing.route_result.text_other": "{{count}} traversed nodes · {{distance}} m",
	"teia.widgets.navigation_widget.routing.start.label": "Start",
	"teia.widgets.navigation_widget.routing.title": "Graph usage",
	"teia.widgets.navigation_widget.selection.accessible.label": "Accessible",
	"teia.widgets.navigation_widget.selection.clear.text": "Deselect all",
	"teia.widgets.navigation_widget.selection.connect_nodes.text": "Connect the 2 nodes",
	"teia.widgets.navigation_widget.selection.delete_connected_graph.text": "Delete connected graph",
	"teia.widgets.navigation_widget.selection.delete_connection.text": "Delete connection",
	"teia.widgets.navigation_widget.selection.delete.text": "Delete",
	"teia.widgets.navigation_widget.selection.direction_both.text": "Bidirectional",
	"teia.widgets.navigation_widget.selection.direction_forward.text": "One way",
	"teia.widgets.navigation_widget.selection.edges.text_one": "{{count}} edge",
	"teia.widgets.navigation_widget.selection.edges.text_other": "{{count}} edges",
	"teia.widgets.navigation_widget.selection.empty.text": "No element selected",
	"teia.widgets.navigation_widget.selection.merge_center.text": "Center",
	"teia.widgets.navigation_widget.selection.merge_first.text": "First",
	"teia.widgets.navigation_widget.selection.merge_last.text": "Last",
	"teia.widgets.navigation_widget.selection.merge_nodes.text": "Merge selected nodes:",
	"teia.widgets.navigation_widget.selection.nodes.text_one": "{{count}} node",
	"teia.widgets.navigation_widget.selection.nodes.text_other": "{{count}} nodes",
	"teia.widgets.navigation_widget.selection.reverse_direction.text": "Reverse direction",
	"teia.widgets.navigation_widget.tabs.creation_route_disabled.text": "Stop displaying the route before returning to graph creation.",
	"teia.widgets.navigation_widget.tabs.creation.text": "Graph creation",
	"teia.widgets.navigation_widget.tabs.flood_fill_disabled.text": "Generate a voxel grid before calculating navigable spaces.",
	"teia.widgets.navigation_widget.tabs.flood_fill.text": "Navigable spaces",
	"teia.widgets.navigation_widget.tabs.navmesh_disabled.text": "Complete the flood fill before configuring the 2.5D navigation mesh.",
	"teia.widgets.navigation_widget.tabs.navmesh.text": "2.5D navigation mesh",
	"teia.widgets.navigation_widget.tabs.routing_editing_disabled.text": "Validate or cancel the graph changes before calculating a route.",
	"teia.widgets.navigation_widget.tabs.routing.text": "Route",
	"teia.widgets.navigation_widget.tabs.voxelization_editing_disabled.text": "Validate or cancel the graph changes before generating voxels.",
	"teia.widgets.navigation_widget.tabs.voxelization.text": "Automatic generation",
	"teia.widgets.navigation_widget.title": "Navigation graph",
	"teia.widgets.navigation_widget.validation.errors.duplicate_edge.text": "Duplicate edge.",
	"teia.widgets.navigation_widget.validation.errors.invalid_edge.text": "The edge intersects scene geometry.",
	"teia.widgets.navigation_widget.validation.errors.invalid_position.text": "Invalid node position.",
	"teia.widgets.navigation_widget.validation.errors.missing_node.text": "One of the edge endpoints is missing.",
	"teia.widgets.navigation_widget.validation.errors.self_edge.text": "An edge cannot loop back to the same node.",
	"teia.widgets.navigation_widget.validation.revert.text": "Revert changes",
	"teia.widgets.navigation_widget.validation.validate.text": "Validate",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.help.label": "About the BoxTree level",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.help.text": "Maximum BoxTree depth tested against each root voxel before accepting every leaf below that depth as a candidate. A higher value traverses bounds more precisely and usually reduces expensive geometry BVH tests, while a lower value visits fewer BoxTree nodes but retains more candidates.",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.label": "BoxTree level",
	"teia.widgets.navigation_widget.voxelization.cancel.text": "Cancel",
	"teia.widgets.navigation_widget.voxelization.clear.text": "Clear",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.help.label": "About voxel sampling",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.help.text": "Displays approximately one voxel out of this many using stable spatial sampling. This only reduces the debug rendering and does not alter the generated voxel grid.",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.label": "Display one voxel out of",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.help.label": "About excluded object types",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.help.text": "Comma-separated object types ignored during voxelization. Exclusion takes priority over the inclusion list and applies to every submesh of the object.",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.label": "Excluded object types",
	"teia.widgets.navigation_widget.voxelization.granularities.help.label": "About voxel granularities",
	"teia.widgets.navigation_widget.voxelization.granularities.help.text": "Voxel sizes in metres, ordered from largest to smallest. Empty voxels remain at their current size; only solid voxels are subdivided using the next value. Each value must divide the preceding size exactly.",
	"teia.widgets.navigation_widget.voxelization.granularities.label": "Granularities (m)",
	"teia.widgets.navigation_widget.voxelization.included_object_types.help.label": "About included object types",
	"teia.widgets.navigation_widget.voxelization.included_object_types.help.text": "Comma-separated object types allowed to participate. When this list is empty, every type is included unless explicitly excluded.",
	"teia.widgets.navigation_widget.voxelization.included_object_types.label": "Included object types",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.help.label": "About the maximum voxel count",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.help.text": "Maximum global safety limit for retained leaf voxels and voxels waiting to be processed, divided equally between workers. A worker reaching its share stops the calculation, even if the combined total remains below the global limit.",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.label": "Maximum voxel count",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.help.label": "About passable object types",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.help.text": "Comma-separated object types that navigation edges may cross. Horizontal types such as doors mark non-blocking passages; types also configured as vertical connectors, such as stairs, remain solid supports.",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.label": "Passable object types",
	"teia.widgets.navigation_widget.voxelization.progress.text_one": "{{count}} voxel processed",
	"teia.widgets.navigation_widget.voxelization.progress.text_other": "{{count}} voxels processed",
	"teia.widgets.navigation_widget.voxelization.result.text_one": "{{count}} voxel generated · {{solid}} solid · {{empty}} empty",
	"teia.widgets.navigation_widget.voxelization.result.text_other": "{{count}} voxels generated · {{solid}} solid · {{empty}} empty",
	"teia.widgets.navigation_widget.voxelization.start.text": "Generate voxels",
	"teia.widgets.navigation_widget.voxelization.title": "Voxelization",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.label": "About vertical connection object types",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.text": "Comma-separated object types whose solid voxels may connect surfaces at different heights, such as stairs and ramps. This classification is stored during voxelization, so changing the list requires generating the voxels again.",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.label": "Object types allowing vertical connections",
	"teia.widgets.navigation_widget.voxelization.warning.missing_object_types.text": "The scene objects do not provide object types, so the voxelization type filters cannot be applied.",
	"teia.widgets.navigation_widget.voxelization.worker_count.help.label": "About the worker count",
	"teia.widgets.navigation_widget.voxelization.worker_count.help.text": "Number of workers processing voxel roots in parallel. More workers can reduce calculation time, but use more CPU and memory.",
	"teia.widgets.navigation_widget.voxelization.worker_count.label": "Worker count",
	"teia.widgets.projection_widget.add_layer_tab.advanced_search.text": "Advanced Search",
	"teia.widgets.projection_widget.add_layer_tab.annotations_to_display.text": "Annotations to display",
	"teia.widgets.projection_widget.add_layer_tab.available_annotation_list.text": "Available annotation list",
	"teia.widgets.projection_widget.add_layer_tab.background.text": "Background",
	"teia.widgets.projection_widget.add_layer_tab.cancel.text": "Cancel",
	"teia.widgets.projection_widget.add_layer_tab.customize_style.text": "Customize the style",
	"teia.widgets.projection_widget.add_layer_tab.layer_name.label": "Layer name",
	"teia.widgets.projection_widget.add_layer_tab.line.text": "Line",
	"teia.widgets.projection_widget.add_layer_tab.properties.title": "Select concerned properties",
	"teia.widgets.projection_widget.add_layer_tab.title": "Editing {{name}}",
	"teia.widgets.projection_widget.add_layer_tab.validate.text": "Validate",
	"teia.widgets.projection_widget.add_layer_tab.warnings.invalid_filter.text": "You need to set the concerned properties.",
	"teia.widgets.projection_widget.add_tab.add_layer.text": "Add layer",
	"teia.widgets.projection_widget.add_tab.copy.text": "Copy",
	"teia.widgets.projection_widget.add_tab.custom_point_of_view.text": "Custom point of view",
	"teia.widgets.projection_widget.add_tab.delete.text": "Delete",
	"teia.widgets.projection_widget.add_tab.drag.text": "Drag",
	"teia.widgets.projection_widget.add_tab.duplicate.text": "Duplicate",
	"teia.widgets.projection_widget.add_tab.layer.text": "What do you want to project?",
	"teia.widgets.projection_widget.add_tab.params.text": "Parameters",
	"teia.widgets.projection_widget.add_tab.point_of_view.text": "Select point of view",
	"teia.widgets.projection_widget.add_tab.projection_name.label": "Projection name",
	"teia.widgets.projection_widget.add_tab.titles.create.title": "Create a new projection",
	"teia.widgets.projection_widget.add_tab.titles.update.title": "Editing {{name}}",
	"teia.widgets.projection_widget.add_tab.validate.text": "Validate",
	"teia.widgets.projection_widget.add_tab.warnings.at_least_one_layer.text": "You should have at least one layer",
	"teia.widgets.projection_widget.add_tab.warnings.must_have_a_name.text": "You should choose a name for your projection",
	"teia.widgets.projection_widget.add_tab.warnings.must_have_filter.text": "must have at least one concerned property.",
	"teia.widgets.projection_widget.analysis_tab.back_button.text": "Go back",
	"teia.widgets.projection_widget.analysis_tab.deprecated_objects.text": "Deprecated objects:",
	"teia.widgets.projection_widget.analysis_tab.download_label.text": "Download the analysis report",
	"teia.widgets.projection_widget.analysis_tab.error.text": "An error occurred during the analysis.",
	"teia.widgets.projection_widget.analysis_tab.failed_objects.text": "Failed objects:",
	"teia.widgets.projection_widget.analysis_tab.generate_label.text": "Generate analysis report",
	"teia.widgets.projection_widget.analysis_tab.layer_list.text": "Layer list:",
	"teia.widgets.projection_widget.analysis_tab.processed_objects.text": "Processed objects:",
	"teia.widgets.projection_widget.analysis_tab.succeeded_objects.text": "Succeeded objects:",
	"teia.widgets.projection_widget.analysis_tab.title.text": "Analysis report",
	"teia.widgets.projection_widget.import_tab.button.cancel.text": "Cancel",
	"teia.widgets.projection_widget.import_tab.button.import.text": "Import",
	"teia.widgets.projection_widget.import_tab.delete.text": "Delete",
	"teia.widgets.projection_widget.import_tab.error_length.text": "Some configurations have been removed: maximum 10 files.",
	"teia.widgets.projection_widget.import_tab.error.text": "Error",
	"teia.widgets.projection_widget.import_tab.file_name.label": "File name",
	"teia.widgets.projection_widget.import_tab.import_suffix.text": "Import",
	"teia.widgets.projection_widget.import_tab.import.text": "Drag or click to open the file explorer",
	"teia.widgets.projection_widget.import_tab.max_files.text": "max. 10 files",
	"teia.widgets.projection_widget.import_tab.modal.cancel.text": "Cancel",
	"teia.widgets.projection_widget.import_tab.modal.confirm.text": "Confirm",
	"teia.widgets.projection_widget.import_tab.modal.title": "Projection import",
	"teia.widgets.projection_widget.import_tab.modal.warning.text": "The JSON files will be imported and turned into projections.",
	"teia.widgets.projection_widget.import_tab.success.text": "Success",
	"teia.widgets.projection_widget.import_tab.title": "Import projections",
	"teia.widgets.projection_widget.list_tab.actions.text": "Actions",
	"teia.widgets.projection_widget.list_tab.analyze.text": "Analyze",
	"teia.widgets.projection_widget.list_tab.caption.completed.text": "Completed",
	"teia.widgets.projection_widget.list_tab.caption.degraded.text": "Degraded",
	"teia.widgets.projection_widget.list_tab.caption.error.text": "Failed",
	"teia.widgets.projection_widget.list_tab.caption.loading.text": "Loading",
	"teia.widgets.projection_widget.list_tab.caption.waiting.text": "Waiting",
	"teia.widgets.projection_widget.list_tab.copy.text": "Copy",
	"teia.widgets.projection_widget.list_tab.delete.text": "Delete",
	"teia.widgets.projection_widget.list_tab.download_pdf.text": "Download PDF",
	"teia.widgets.projection_widget.list_tab.download_svg.text": "Download SVG",
	"teia.widgets.projection_widget.list_tab.duplicate.text": "Duplicate",
	"teia.widgets.projection_widget.list_tab.empty_list.search.text": "No projections found",
	"teia.widgets.projection_widget.list_tab.empty_list.text": "No saved projections",
	"teia.widgets.projection_widget.list_tab.export_modal.cancel.text": "Cancel",
	"teia.widgets.projection_widget.list_tab.export_modal.confirm.text": "Confirm",
	"teia.widgets.projection_widget.list_tab.export_modal.title": "Projection export",
	"teia.widgets.projection_widget.list_tab.export_modal.warning.text": "The parameters will be exported into one or more JSON files.",
	"teia.widgets.projection_widget.list_tab.export.text": "Export",
	"teia.widgets.projection_widget.list_tab.import.text": "Import",
	"teia.widgets.projection_widget.list_tab.search.label": "Search",
	"teia.widgets.projection_widget.list_tab.select.text": "Select",
	"teia.widgets.projection_widget.list_tab.table.actions.text": "Actions",
	"teia.widgets.projection_widget.list_tab.table.projection_name.text": "Projections",
	"teia.widgets.projection_widget.list_tab.table.status.text": "Status",
	"teia.widgets.projection_widget.list_tab.title": "Saved projection list",
	"teia.widgets.projection_widget.list_tab.update.text": "Update",
	"teia.widgets.projection_widget.no_twin.text": "No Twin",
	"teia.widgets.projection_widget.title": "PROJECTION(S)",
	"teia.widgets.settings_widget.tabs.map.title": "Map",
	"teia.widgets.shortcuts_widget.shortcuts.show_map.text": "Show/hide map",
	"teiaSearchFilterEditor.ai.button.help_text": "Need help? Ask Elliot",
	"teiaSearchFilterEditor.ai.button.label": "Generate the filter with AI",
	"teiaSearchFilterEditor.ai.disclaimer.text": "Elliot is an AI trained to provide you with reliable assistance and answers, however errors may occur.",
	"teiaSearchFilterEditor.ai.errors.default.text": "Error generating the AI filter",
	"teiaSearchFilterEditor.ai.errors.no_more_token.text": "Error generating the AI filter: not enough AI tokens available",
	"teiaSearchFilterEditor.ai.generate_button.label": "Generate the filter",
	"teiaSearchFilterEditor.ai.textarea.placeholder": "Describe your search filter in natural language...",
	"teiaSearchFilterEditor.condition_input.conditions.label": "conditions",
	"teiaSearchFilterEditor.condition_input.label": "Applies to",
	"teiaSearchFilterEditor.condition_input.text_field.and.label": "All",
	"teiaSearchFilterEditor.condition_input.text_field.or.label": "≥ ONE",
	"teiaSearchFilterEditor.condition_select.label": "Condition",
	"teiaSearchFilterEditor.condition_select.placeholder": "Condition",
	"teiaSearchFilterEditor.errors.text": "All fields must be filled in for the filter to be valid.",
	"teiaSearchFilterEditor.group.add_condition_tooltip.label": "Add condition",
	"teiaSearchFilterEditor.group.add_group_menu.label": "Add group",
	"teiaSearchFilterEditor.group.category.label": "Groups",
	"teiaSearchFilterEditor.group.remove_group_tooltip.label": "Remove group",
	"teiaSearchFilterEditor.guidCondition.value_text_field.label": "Value",
	"teiaSearchFilterEditor.json.apply_button.label": "Apply the JSON to the filter",
	"teiaSearchFilterEditor.json.button.label": "Open the JSON editor",
	"teiaSearchFilterEditor.json.copy_button.copied_label": "JSON copied to the clipboard",
	"teiaSearchFilterEditor.json.copy_button.label": "Copy the JSON",
	"teiaSearchFilterEditor.json.download_button.label": "Download the JSON",
	"teiaSearchFilterEditor.json.download_modal.cancel_button.text": "Cancel",
	"teiaSearchFilterEditor.json.download_modal.confirm_button.text": "Download",
	"teiaSearchFilterEditor.json.download_modal.file_name.label": "File name",
	"teiaSearchFilterEditor.json.download_modal.title": "Download the JSON file",
	"teiaSearchFilterEditor.json.format_button.label": "Format the JSON",
	"teiaSearchFilterEditor.openDataAllCondition.value_text_field.label": "Value",
	"teiaSearchFilterEditor.openDataCondition.key_text_field.label": "Key",
	"teiaSearchFilterEditor.openDataCondition.value_text_field.label": "Value",
	"teiaSearchFilterEditor.operatorSelector.operator.label": "Operator",
	"teiaSearchFilterEditor.parentGuidCondition.textField.label": "Value",
	"teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field.label": "Name",
	"teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field.label": "Property",
	"teiaSearchFilterEditor.propertyCondition.values_autocomplete.text_field.label": "Value",
	"teiaSearchFilterEditor.remove_condition_button.label": "Remove condition",
	"teiaSearchFilterEditor.remove_condition_tooltip.label": "Remove condition",
	"teiaSearchFilterEditor.typeCondition.values_autocomplete.text_field.label": "Value",
	"teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label": "Application Name",
	"teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label": "Name",
	"teiaSearchFilterEditor.userDataByApplicationCondition.value_text_field.label": "Value",
	"toasts.loading_scene.text": "Loading",
	"toasts.preparing_scene.text": "Preparing",
	"toolbar.camera_mode.default.tooltip": "Default Camera",
	"toolbar.camera_mode.floor_plan_on_click.tooltip": "Floor plan Camera",
	"toolbar.camera_mode.fps.tooltip": "First Person Camera",
	"toolbar.camera_mode.orbital.tooltip": "Orbital Camera",
	"toolbar.camera_mode.selector.tooltip": "Camera mode",
	"toolbar.clipping_planes.add_plane_on_x_axis.tooltip": "Add clipping plane on X axis",
	"toolbar.clipping_planes.add_plane_on_y_axis.tooltip": "Add clipping plane on Y axis",
	"toolbar.clipping_planes.add_plane_on_z_axis.tooltip": "Add clipping plane on Z axis",
	"toolbar.clipping_planes.delete_all_planes.tooltip": "Delete all clipping planes",
	"toolbar.clipping_planes.hide_show_all_planes.tooltip": "Hide/Show all clipping planes",
	"toolbar.clipping_planes.tooltip": "Clipping planes tool",
	"toolbar.export_plan.tooltip": "Export plan tool",
	"toolbar.focus_objects.tooltip": "Focus objects",
	"toolbar.hide_object.tooltip": "Hide selected objects",
	"toolbar.isolate_object.tooltip": "Isolate selected objects",
	"toolbar.measure_lines.tooltip": "Measure lines tool",
	"toolbar.notificationCenter.tooltip": "Notification center",
	"toolbar.object_translations_download.tooltip": "Download",
	"toolbar.object_translations_import.tooltip": "Import",
	"toolbar.object_translations_widget.tooltip": "Move",
	"toolbar.object_translations.tooltip": "Object move tool",
	"toolbar.projection.tooltip": "Projection tool",
	"toolbar.redo.tooltip": "Redo",
	"toolbar.render_mode.noEdges.tooltip": "No Edges",
	"toolbar.render_mode.selector.tooltip": "Render Mode",
	"toolbar.render_mode.textured.tooltip": "Textured",
	"toolbar.render_mode.wireframe.tooltip": "Wireframe",
	"toolbar.render_mode.xray.tooltip": "XRay",
	"toolbar.render_mode.xrayNoEdges.tooltip": "XRay without edges",
	"toolbar.reset_scene.tooltip": "Reset scene",
	"toolbar.screenshot.tooltip": "Take a screenshot",
	"toolbar.search.input.label": "Search",
	"toolbar.search.input.placeholder": "Search",
	"toolbar.search.input.tooltip": "Simple Search",
	"toolbar.search.tooltip": "Search",
	"toolbar.selection_info.label": "Selection",
	"toolbar.selection_info.object_count.text_one": "Object",
	"toolbar.selection_info.object_count.text_other": "Objects",
	"toolbar.show_devtools.tooltip": "Show Dev tools",
	"toolbar.show_history.tooltip": "Show History",
	"toolbar.show_infobox.tooltip": "Show Infobox",
	"toolbar.show_settings.tooltip": "Settings",
	"toolbar.show_tools.label": "Show tools",
	"toolbar.show_treeview.tooltip": "Show TreeView",
	"toolbar.undo.tooltip": "Undo",
	"toolbar.zone_cube.tooltip": "Create a cube around an object",
	"toolbar.zone_duplicate.tooltip": "Create a zone from the shape of an object",
	"toolbar.zone_sphere.tooltip": "Create a sphere around an object",
	"toolbar.zone_widget.tooltip": "Open the settings widget",
	"toolbar.zone.tooltip": "Zone creation tool",
	"toolbar.zoom_in.tooltip": "Zoom in",
	"toolbar.zoom_out.tooltip": "Zoom out",
	"widgets.history_widget.empty_history.text": "The history is empty.",
	"widgets.history_widget.redo_history.text": "Redo history",
	"widgets.history_widget.title": "History",
	"widgets.history_widget.undo_history.text": "Undo history",
	"widgets.infobox_widget.alerts.no_selected_objects.text": "Please select an object to see its data.",
	"widgets.infobox_widget.alerts.no_tabs.text": "No tabs available for the infobox",
	"widgets.infobox_widget.lock_button.label": "Lock infobox",
	"widgets.infobox_widget.lock_button.title": "Click to lock the content of the info",
	"widgets.infobox_widget.search.text": "Search",
	"widgets.infobox_widget.selected_objects.label_one": "{{count}} selected object",
	"widgets.infobox_widget.selected_objects.label_other": "{{count}} selected objects",
	"widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata_search.text": "No 3d data available for this search.",
	"widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata.text": "No 3d data available for this object.",
	"widgets.infobox_widget.tabs.3Ddata_tab.title": "3D Data",
	"widgets.infobox_widget.tabs.3Ddata_tab.tooltip": "3D Data",
	"widgets.infobox_widget.title": "Infobox",
	"widgets.map_widget.elevation.text": "Height",
	"widgets.map_widget.latitude.text": "Latitude",
	"widgets.map_widget.longitude.text": "Longitude",
	"widgets.map_widget.maps.cadastral.text": "Cadastral",
	"widgets.map_widget.maps.default.text": "Default",
	"widgets.map_widget.maps.satellite.text": "Satellite",
	"widgets.map_widget.maps.simple.text": "Simple",
	"widgets.map_widget.plan_type.text": "Map type",
	"widgets.map_widget.rotation.text": "Rotation",
	"widgets.map_widget.shape_type.text": "Map shape",
	"widgets.map_widget.shapes.circle.text": "Circular",
	"widgets.map_widget.shapes.square.text": "Square",
	"widgets.map_widget.validate.text": "Validate",
	"widgets.map_widget.warning_no_twin.text": "You must load a Twin to edit the map.",
	"widgets.map_widget.warning.text": "The changes apply to all users of this smartscene.",
	"widgets.notification_center_widget.close_icon.label": "close the notification",
	"widgets.notification_center_widget.delete_icon.label": "Delete",
	"widgets.notification_center_widget.empty_list.text": "No notification",
	"widgets.notification_center_widget.mark_as_read.label": "Mark as read / unread",
	"widgets.notification_center_widget.not_read.label": "Unread",
	"widgets.notification_center_widget.notification_number.text_one": "{{count}} visible notification out of",
	"widgets.notification_center_widget.notification_number.text_other": "{{count}} visible notifications out of",
	"widgets.notification_center_widget.status_icons.error.label": "Error filter",
	"widgets.notification_center_widget.status_icons.info.label": "Information filter",
	"widgets.notification_center_widget.status_icons.success.label": "Success filter",
	"widgets.notification_center_widget.status_icons.warning.label": "Warning filter",
	"widgets.notification_center_widget.title": "Notification center",
	"widgets.object_translations.export_sucess.text": "The export of object translations was executed successfully.",
	"widgets.object_translations.export_sucess.title": "Export executed successfully",
	"widgets.object_translations.import_error.text": "An error occurred during import.",
	"widgets.object_translations.import_error.title": "Import error",
	"widgets.object_translations.import_success.text": "Object translations have been successfully imported.",
	"widgets.object_translations.import_success.title": "Import executed successfully",
	"widgets.object_translations.import_warning.text": "The JSON file seems incorrect.",
	"widgets.object_translations.import_warning.title": "Incorrect JSON file",
	"widgets.object_translations.rotate.label": "Select rotation gizmo",
	"widgets.object_translations.scale.label": "Object scaling",
	"widgets.object_translations.translate.label": "Select translation gizmo",
	"widgets.settings_widget.tabs.shortcuts.title": "Shortcuts",
	"widgets.settings_widget.title": "Settings",
	"widgets.shortcuts_widget.click_maintained.text": "Click maintained",
	"widgets.shortcuts_widget.click.text": "Click",
	"widgets.shortcuts_widget.shortcuts.focus_selected_objects.text": "Focus the selected objects",
	"widgets.shortcuts_widget.shortcuts.hide_selected_objects.text": "Hide selection",
	"widgets.shortcuts_widget.shortcuts.isolate_selected_objects.text": "Isolate selection",
	"widgets.shortcuts_widget.shortcuts.move_camera_down.text": "Move the camera down",
	"widgets.shortcuts_widget.shortcuts.move_camera_left.text": "Move the camera left",
	"widgets.shortcuts_widget.shortcuts.move_camera_right.text": "Move the camera right",
	"widgets.shortcuts_widget.shortcuts.move_camera_up.text": "Move the camera up",
	"widgets.shortcuts_widget.shortcuts.open_infobox.text": "Open infobox",
	"widgets.shortcuts_widget.shortcuts.redo.text": "Redo",
	"widgets.shortcuts_widget.shortcuts.select_all_visible_objects.text": "Select all visible objects",
	"widgets.shortcuts_widget.shortcuts.select_several_objects.text": "Select several objects",
	"widgets.shortcuts_widget.shortcuts.select_several_transparent_objects.text": "Select several transparent objects",
	"widgets.shortcuts_widget.shortcuts.select_transparent_object.text": "Select transparent object",
	"widgets.shortcuts_widget.shortcuts.selection_path.text": "Selection path",
	"widgets.shortcuts_widget.shortcuts.show_spotlight.text": "Access to Spotlight",
	"widgets.shortcuts_widget.shortcuts.undo.text": "Undo",
	"widgets.shortcuts_widget.warning.text": "Warning: AZERTY keyboard by default, please press the Z key to detect the keyboard type.",
	"widgets.treeView.computing_treeview.text": "Loading twin...",
	"widgets.treeView.no_scene.text": "No scene is loaded",
	"widgets.treeView.title": "Tree View"
}, pt = {
	"components.table.nodata_alert.text": "Aucune donnée disponible.",
	"components.toolbar.close_button.label": "Fermer",
	"components.toolbar.collapse_button.label": "Réduire les menus",
	"components.toolbar.expand_button.label": "Développer les menus",
	"components.treeView.tree_view_node.expand_node_button.label": "Déplier le noeud courant",
	"components.treeView.tree_view_node.load_more_button.label": "Charger plus",
	"context_menu.clear_scene.text": "Effacer la scène",
	"context_menu.hide.text_one": "Cacher {{count}} mesh sélectionné",
	"context_menu.hide.text_many": "Cacher {{count}} meshes sélectionnés",
	"context_menu.hide.text_other": "Cacher {{count}} meshes sélectionnés",
	"context_menu.isolate.text_one": "Isoler {{count}} mesh sélectionné",
	"context_menu.isolate.text_many": "Isoler {{count}} meshes sélectionnés",
	"context_menu.isolate.text_other": "Isoler {{count}} meshes sélectionnés",
	"context_menu.remove_all_clipping_planes.text": "Supprimer tous les plans de coupe",
	"context_menu.remove_all_measure_lines.text": "Supprimer toutes les lignes de mesure",
	"context_menu.remove_clipping_plane.text": "Supprimer le plan de coupe",
	"context_menu.remove_measure_line_anchor.text": "Supprimer le point",
	"context_menu.remove_measure_line.text": "Supprimer une ligne de mesure",
	"frame_alert.buttons.cancel.text": "Annuler",
	"frame_alert.buttons.validate.text": "Valider",
	"frame_alert.text": "Valider l'action en cours",
	"info_banner.memory_not_optimal_warning.text": "Les performances ne sont pas optimales. Mémoire utilisée :",
	"info_banner.memory_not_optimal_warning.title": "Avertissement mémoire",
	"info_banner.memory_warning.text": "Les performances sont dégradées. Mémoire utilisée :",
	"info_banner.memory_warning.title": "Avertissement mémoire",
	"spotlight.copy_selection.text": "Copier la sélection",
	"spotlight.hide_selection.text_one": "Cacher la sélection ({{count}} mesh sélectionné)",
	"spotlight.hide_selection.text_many": "Cacher la sélection ({{count}} meshes sélectionnés)",
	"spotlight.hide_selection.text_other": "Cacher la sélection ({{count}} meshes sélectionnés)",
	"spotlight.isolate_selection.text_one": "Isoler la sélection ({{count}} mesh sélectionné)",
	"spotlight.isolate_selection.text_many": "Isoler la sélection ({{count}} meshes sélectionnés)",
	"spotlight.isolate_selection.text_other": "Isoler la sélection ({{count}} meshes sélectionnés)",
	"spotlight.redo.text": "Refaire l'action précédemment annulée",
	"spotlight.select_all.text": "Sélectionner tous les objets visibles",
	"spotlight.undo.text": "Annuler l'action précédente",
	"spotlight.xray_selection.text": "XRay la sélection",
	"teia.context_menu.remove_all_zones.text": "Supprimer toutes les zones",
	"teia.context_menu.remove_projection.text": "Supprimer la projection",
	"teia.context_menu.remove_zone.text": "Supprimer la zone",
	"teia.info_banner.objects_limit_warning_end.text": "objets vont être chargés : les performances peuvent être dégradées ou le jumeau peut ne pas se charger complètement.",
	"teia.info_banner.objects_limit_warning_start.text": "Plus de",
	"teia.info_banner.objects_limit_warning.title": "Limitation du nombre maximal d'objets",
	"teia.info_banner.twin_optimization_warning.text": "Le jumeau est en cours d'optimisation, les données peuvent ne pas être disponibles. Statut d'optimisation :",
	"teia.info_banner.twin_optimization_warning.title": "Avertissement d'optimisation",
	"teia.info_banner.twin_process_warning.text": "le jumeau est en cours de traitement, les données peuvent ne pas être disponibles. Statut :",
	"teia.info_banner.twin_process_warning.title": "Traitement du jumeau",
	"teia.toolbar.search.button.tooltip": "Recherche avancée",
	"teia.toolbar.search.tooltip": "Recherche",
	"teia.widgets.advanced_search_widget.errors.error_from_api.text": "Erreur lors de la recherche",
	"teia.widgets.advanced_search_widget.errors.no_twin.text": "Aucun Twin disponible",
	"teia.widgets.advanced_search_widget.filter_on_visible_input.text": "Uniquement les objets visibles",
	"teia.widgets.advanced_search_widget.search_button.label": "Rechercher",
	"teia.widgets.advanced_search_widget.search_button.text": "Rechercher",
	"teia.widgets.advanced_search_widget.title": "Recherche avancée",
	"teia.widgets.floor_plan_widget.add_layer_tab.advanced_search.text": "Recherche avancée",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.add.text": "Ajouter",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.family.text": "Famille du champ",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_color.text": "Couleur de la police",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_size.text": "Taill de la police",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.position.text": "Position",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.prefix.text": "Prefix",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.remove.text": "Supprimer",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.suffix.text": "Suffix",
	"teia.widgets.floor_plan_widget.add_layer_tab.annotations.text": "Annotations",
	"teia.widgets.floor_plan_widget.add_layer_tab.background.text": "Fond",
	"teia.widgets.floor_plan_widget.add_layer_tab.cancel.text": "Annuler",
	"teia.widgets.floor_plan_widget.add_layer_tab.customize_style.text": "Personnaliser le style",
	"teia.widgets.floor_plan_widget.add_layer_tab.layer_name.label": "Nom du calque",
	"teia.widgets.floor_plan_widget.add_layer_tab.line.text": "Ligne",
	"teia.widgets.floor_plan_widget.add_layer_tab.properties.title": "Sélectionnez les propriétés concernées",
	"teia.widgets.floor_plan_widget.add_layer_tab.title": "Modification de {{name}}",
	"teia.widgets.floor_plan_widget.add_layer_tab.validate.text": "Valider",
	"teia.widgets.floor_plan_widget.add_layer_tab.warnings.invalid_filter.text": "Vous devez définir les propriétés concernées.",
	"teia.widgets.floor_plan_widget.add_tab.add_layer.text": "Ajouter un calque",
	"teia.widgets.floor_plan_widget.add_tab.copy.text": "Copier",
	"teia.widgets.floor_plan_widget.add_tab.delete.text": "Supprimer",
	"teia.widgets.floor_plan_widget.add_tab.drag.text": "Glisser",
	"teia.widgets.floor_plan_widget.add_tab.duplicate.text": "Dupliquer",
	"teia.widgets.floor_plan_widget.add_tab.layer.text": "Que souhaitez-vous projeter ?",
	"teia.widgets.floor_plan_widget.add_tab.params.text": "Paramètres",
	"teia.widgets.floor_plan_widget.add_tab.plan_name.label": "Nom du plan",
	"teia.widgets.floor_plan_widget.add_tab.point_of_view.text": "Sélectionnez le point de vue",
	"teia.widgets.floor_plan_widget.add_tab.titles.create.title": "Créer un nouveau plan",
	"teia.widgets.floor_plan_widget.add_tab.titles.update.title": "Modification de {{name}}",
	"teia.widgets.floor_plan_widget.add_tab.validate.text": "Valider",
	"teia.widgets.floor_plan_widget.add_tab.warnings.at_least_one_layer.text": "Vous devez avoir au moins un calque",
	"teia.widgets.floor_plan_widget.add_tab.warnings.must_have_a_name.text": "Vous devez choisir un nom pour votre plan",
	"teia.widgets.floor_plan_widget.add_tab.warnings.must_have_filter.text": "doit avoir au moins une propriété concernée.",
	"teia.widgets.floor_plan_widget.import_tab.button.cancel.text": "Annuler",
	"teia.widgets.floor_plan_widget.import_tab.button.import.text": "Importer",
	"teia.widgets.floor_plan_widget.import_tab.delete.text": "Supprimer",
	"teia.widgets.floor_plan_widget.import_tab.error_length.text": "Certaines configurations ont été supprimées : maximum 10 fichiers.",
	"teia.widgets.floor_plan_widget.import_tab.error.text": "Erreur",
	"teia.widgets.floor_plan_widget.import_tab.file_name.label": "Nom du fichier",
	"teia.widgets.floor_plan_widget.import_tab.import_suffix.text": "Importer",
	"teia.widgets.floor_plan_widget.import_tab.import.text": "Glissez ou cliquez pour ouvrir l'explorateur de fichiers",
	"teia.widgets.floor_plan_widget.import_tab.max_files.text": "max. 10 fichiers",
	"teia.widgets.floor_plan_widget.import_tab.modal.cancel.text": "Annuler",
	"teia.widgets.floor_plan_widget.import_tab.modal.confirm.text": "Confirmer",
	"teia.widgets.floor_plan_widget.import_tab.modal.title": "Importation de plan",
	"teia.widgets.floor_plan_widget.import_tab.modal.warning.text": "Les fichiers JSON seront importés et convertis en plans.",
	"teia.widgets.floor_plan_widget.import_tab.success.text": "Succès",
	"teia.widgets.floor_plan_widget.import_tab.title": "Importer un plan",
	"teia.widgets.floor_plan_widget.list_tab.actions.text": "Actions",
	"teia.widgets.floor_plan_widget.list_tab.analyze.text": "Analyser",
	"teia.widgets.floor_plan_widget.list_tab.caption.completed.text": "Terminé",
	"teia.widgets.floor_plan_widget.list_tab.caption.error.text": "Échec",
	"teia.widgets.floor_plan_widget.list_tab.caption.expired.text": "Expiré ou Degradé",
	"teia.widgets.floor_plan_widget.list_tab.caption.loading.text": "Chargement",
	"teia.widgets.floor_plan_widget.list_tab.caption.waiting.text": "En attente",
	"teia.widgets.floor_plan_widget.list_tab.delete.text": "Supprimer",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.cancel.text": "Annuler",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.confirm.text": "Continuer",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.title": "Affichage de la projection",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text_one": "La projection comporte beaucoup d'objets projetés ({{count}}). L'afficher pourrait entraîner un crash de l'application. Il est recommandé de masquer le jumeau avant de continuer. Voulez-vous continuer ?",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text_many": "La projection comporte beaucoup d'objets projetés ({{count}}). L'afficher pourrait entraîner un crash de l'application. Il est recommandé de masquer le jumeau avant de continuer. Voulez-vous continuer ?",
	"teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text_other": "La projection comporte beaucoup d'objets projetés ({{count}}). L'afficher pourrait entraîner un crash de l'application. Il est recommandé de masquer le jumeau avant de continuer. Voulez-vous continuer ?",
	"teia.widgets.floor_plan_widget.list_tab.download_dxf.text": "Télécharger DXF",
	"teia.widgets.floor_plan_widget.list_tab.download_pdf.text": "Télécharger PDF",
	"teia.widgets.floor_plan_widget.list_tab.download_svg.text": "Télécharger SVG",
	"teia.widgets.floor_plan_widget.list_tab.download.text": "Télécharger",
	"teia.widgets.floor_plan_widget.list_tab.duplicate.text": "Dupliquer",
	"teia.widgets.floor_plan_widget.list_tab.empty_list.search.text": "Aucun plan trouvé",
	"teia.widgets.floor_plan_widget.list_tab.empty_list.text": "Aucun plan enregistré",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.cancel.text": "Annuler",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.confirm.text": "Confirmer",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.title": "Export de projection",
	"teia.widgets.floor_plan_widget.list_tab.export_modal.warning.text": "Les paramètres seront exportés dans un ou plusieurs fichiers JSON.",
	"teia.widgets.floor_plan_widget.list_tab.export.text": "Exporter",
	"teia.widgets.floor_plan_widget.list_tab.import.text": "Importer",
	"teia.widgets.floor_plan_widget.list_tab.restart.text": "Relancer l'export",
	"teia.widgets.floor_plan_widget.list_tab.search.label": "Rechercher",
	"teia.widgets.floor_plan_widget.list_tab.select.text": "Selectionner",
	"teia.widgets.floor_plan_widget.list_tab.table.actions.text": "Actions",
	"teia.widgets.floor_plan_widget.list_tab.table.plan_name.text": "Plans",
	"teia.widgets.floor_plan_widget.list_tab.table.status.text": "Statut",
	"teia.widgets.floor_plan_widget.list_tab.title": "Liste des plans enregistrés",
	"teia.widgets.floor_plan_widget.list_tab.update.text": "Mettre à jour",
	"teia.widgets.floor_plan_widget.no_twin.text": "Aucun Twin",
	"teia.widgets.floor_plan_widget.title": "PLAN(S)",
	"teia.widgets.infobox_widget.icon.tooltip": "Patch Data",
	"teia.widgets.infobox_widget.tabs.alerts.nodata-search.text": "Pas de résultats",
	"teia.widgets.infobox_widget.tabs.alerts.nodata.text": "Pas de propriétés disponibles",
	"teia.widgets.infobox_widget.tabs.bimdata_tab.title": "Données BIM",
	"teia.widgets.infobox_widget.tabs.bimdata_tab.tooltip": "Données BIM",
	"teia.widgets.infobox_widget.tabs.docdata_tab.alerts.error.download.text": "Une erreur est apparue lors de la récupération de votre fichier.",
	"teia.widgets.infobox_widget.tabs.docdata_tab.title": "Données Document",
	"teia.widgets.infobox_widget.tabs.docdata_tab.tooltip": "Visionner document",
	"teia.widgets.infobox_widget.tabs.ifcdata_tab.title": "Données IFC",
	"teia.widgets.infobox_widget.tabs.ifcdata_tab.tooltip": "Données IFC",
	"teia.widgets.infobox_widget.tabs.opendata_tab.title": "Open Data",
	"teia.widgets.infobox_widget.tabs.opendata_tab.tooltip": "Open Data",
	"teia.widgets.infobox_widget.tabs.userdata_tab.title": "Données Utilisateur",
	"teia.widgets.infobox_widget.tabs.userdata_tab.tooltip": "Données Utilisateur",
	"teia.widgets.navigation_widget.actions.clear_graph.text": "Supprimer le graphe de navigation",
	"teia.widgets.navigation_widget.actions.create.text": "Créer le graphe du jumeau",
	"teia.widgets.navigation_widget.actions.edit.text": "Éditer le graphe existant",
	"teia.widgets.navigation_widget.actions.export_json.text": "Exporter JSON",
	"teia.widgets.navigation_widget.actions.import_json.text": "Importer JSON",
	"teia.widgets.navigation_widget.actions.more.label": "Importer ou exporter le graphe",
	"teia.widgets.navigation_widget.creation.title": "Création du graphe",
	"teia.widgets.navigation_widget.flood_fill.calculate.text": "Calculer le flood fill",
	"teia.widgets.navigation_widget.flood_fill.cancel.text": "Annuler",
	"teia.widgets.navigation_widget.flood_fill.display_category.all.text": "Tout",
	"teia.widgets.navigation_widget.flood_fill.display_category.empty.text": "Vide",
	"teia.widgets.navigation_widget.flood_fill.display_category.label": "Catégorie affichée",
	"teia.widgets.navigation_widget.flood_fill.display_category.navigable.text": "Navigable",
	"teia.widgets.navigation_widget.flood_fill.display_category.solid.text": "Solide",
	"teia.widgets.navigation_widget.flood_fill.display_category.unclassified.text": "Non classé",
	"teia.widgets.navigation_widget.flood_fill.display_grid.text": "Afficher la grille de voxels",
	"teia.widgets.navigation_widget.flood_fill.display_level.all.text": "Toutes les résolutions",
	"teia.widgets.navigation_widget.flood_fill.display_level.label": "Résolution affichée",
	"teia.widgets.navigation_widget.flood_fill.manual_seeds.text_one": "{{count}} graine manuelle · clic droit pour la supprimer",
	"teia.widgets.navigation_widget.flood_fill.manual_seeds.text_many": "{{count}} graines manuelles · clic droit sur une graine pour la supprimer",
	"teia.widgets.navigation_widget.flood_fill.manual_seeds.text_other": "{{count}} graines manuelles · clic droit sur une graine pour la supprimer",
	"teia.widgets.navigation_widget.flood_fill.needs_update.text": "Le résultat affiché doit être recalculé. Les voxels navigables sont affichés en orange.",
	"teia.widgets.navigation_widget.flood_fill.place_seed.text": "Placer des graines manuelles",
	"teia.widgets.navigation_widget.flood_fill.progress.text_one": "{{count}} voxel vide exploré…",
	"teia.widgets.navigation_widget.flood_fill.progress.text_many": "{{count}} voxels vides explorés…",
	"teia.widgets.navigation_widget.flood_fill.progress.text_other": "{{count}} voxels vides explorés…",
	"teia.widgets.navigation_widget.flood_fill.quit_seed_placement.text": "Arrêter de placer des graines manuelles",
	"teia.widgets.navigation_widget.flood_fill.result.text": "{{components}} composante(s) navigable(s) trouvée(s) depuis {{seeds}} graine(s) valide(s).",
	"teia.widgets.navigation_widget.flood_fill.seed_distance.label": "Distance maximale de recherche d’un voxel vide",
	"teia.widgets.navigation_widget.flood_fill.seed_types.label": "Types de graines BIM",
	"teia.widgets.navigation_widget.flood_fill.seed_types.text": "Types d’objets séparés par des virgules, par exemple IfcDoor.",
	"teia.widgets.navigation_widget.flood_fill.seed_warnings.text_one": "{{count}} graine a été déplacée ou ignorée.",
	"teia.widgets.navigation_widget.flood_fill.seed_warnings.text_many": "{{count}} graines ont été déplacées ou ignorées.",
	"teia.widgets.navigation_widget.flood_fill.seed_warnings.text_other": "{{count}} graines ont été déplacées ou ignorées.",
	"teia.widgets.navigation_widget.flood_fill.title": "Espaces navigables",
	"teia.widgets.navigation_widget.flood_fill.voxels_on_top.text": "Afficher les voxels au-dessus des objets",
	"teia.widgets.navigation_widget.flood_fill.worker_count.label": "Nombre de workers",
	"teia.widgets.navigation_widget.import_modal.cancel.text": "Annuler",
	"teia.widgets.navigation_widget.import_modal.confirm.text": "Importer",
	"teia.widgets.navigation_widget.import_modal.title": "Importer un graphe de navigation",
	"teia.widgets.navigation_widget.import_modal.warning.text": "Attention, ce graphe remplacera le graphe existant.",
	"teia.widgets.navigation_widget.navmesh.cancel.text": "Annuler",
	"teia.widgets.navigation_widget.navmesh.generate.text": "Générer le graphe de navigation 2.5D",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.help.label": "À propos du nombre maximal d’arêtes",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.help.text": "Limite de sécurité stricte du nombre d’arêtes générées. La génération s’arrête avec une erreur si le graphe dépasse cette valeur.",
	"teia.widgets.navigation_widget.navmesh.maximum_edges.label": "Nombre maximal d’arêtes",
	"teia.widgets.navigation_widget.navmesh.maximum_height.help.label": "À propos de la différence de hauteur maximale",
	"teia.widgets.navigation_widget.navmesh.maximum_height.help.text": "Plus grande différence verticale, en mètres, qu’un connecteur d’escalier ou de passage autorisé peut franchir.",
	"teia.widgets.navigation_widget.navmesh.maximum_height.label": "Différence de hauteur maximale",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.label": "À propos de la distance maximale de fusion",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.text": "Distance XZ, en mètres, utilisée pour fusionner les cellules proches d’une même surface. Une valeur plus grande crée moins de nœuds, mais réduit les détails géométriques.",
	"teia.widgets.navigation_widget.navmesh.maximum_merge_distance.label": "Distance maximale de fusion",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.help.label": "À propos du nombre maximal de nœuds",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.help.text": "Limite de sécurité stricte du nombre de nœuds générés. La génération s’arrête avec une erreur si la simplification ne peut pas réduire le graphe sous cette valeur.",
	"teia.widgets.navigation_widget.navmesh.maximum_nodes.label": "Nombre maximal de nœuds",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.help.label": "À propos de l’angle de pente maximal",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.help.text": "Angle maximal, en degrés, autorisé entre des cellules voisines d’une surface ordinaire. Les connecteurs d’escalier explicites utilisent plutôt la différence de hauteur maximale.",
	"teia.widgets.navigation_widget.navmesh.maximum_slope.label": "Angle de pente maximal",
	"teia.widgets.navigation_widget.navmesh.needs_update.text": "Le graphe de navigation est obsolète et doit être régénéré.",
	"teia.widgets.navigation_widget.navmesh.reduction.text": "Réduction : {{nodes}} % des nœuds · {{edges}} % des arêtes",
	"teia.widgets.navigation_widget.navmesh.result.text": "{{nodes}} nœuds · {{edges}} arêtes · {{components}} composantes",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.label": "À propos de la tolérance de simplification",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.text": "Écart maximal, en mètres, autorisé lors du remplacement d’une chaîne presque droite par moins de nœuds. Une valeur plus grande simplifie les courbes plus fortement.",
	"teia.widgets.navigation_widget.navmesh.simplification_tolerance.label": "Tolérance de simplification",
	"teia.widgets.navigation_widget.navmesh.target_nodes.help.label": "À propos du nombre de nœuds cible",
	"teia.widgets.navigation_widget.navmesh.target_nodes.help.text": "Nombre de nœuds souhaité pour la simplification adaptative des zones ouvertes. Il s’agit d’une cible et non d’une limite stricte : le graphe final peut contenir davantage de nœuds.",
	"teia.widgets.navigation_widget.navmesh.target_nodes.label": "Nombre de nœuds cible",
	"teia.widgets.navigation_widget.navmesh.title": "Navmesh 2.5D",
	"teia.widgets.navigation_widget.navmesh.voxelization_outdated.text": "La liste des types IFC a changé. Relancez la voxelisation et le flood fill avant de générer le graphe.",
	"teia.widgets.navigation_widget.no_twin.text": "Un jumeau doit être chargé pour créer un graphe de navigation.",
	"teia.widgets.navigation_widget.overview.connect_nodes_automatically.label": "Relier automatiquement les noeuds",
	"teia.widgets.navigation_widget.overview.edges.text_one": "{{count}} arête",
	"teia.widgets.navigation_widget.overview.edges.text_many": "{{count}} arêtes",
	"teia.widgets.navigation_widget.overview.edges.text_other": "{{count}} arêtes",
	"teia.widgets.navigation_widget.overview.merge_threshold.label": "Seuil de fusion",
	"teia.widgets.navigation_widget.overview.nodes.text_one": "{{count}} noeud",
	"teia.widgets.navigation_widget.overview.nodes.text_many": "{{count}} noeuds",
	"teia.widgets.navigation_widget.overview.nodes.text_other": "{{count}} noeuds",
	"teia.widgets.navigation_widget.routing.back_to_creation.text": "Retour à la création",
	"teia.widgets.navigation_widget.routing.calculate.text": "Calculer l’itinéraire",
	"teia.widgets.navigation_widget.routing.clear_points.text": "Supprimer les deux points",
	"teia.widgets.navigation_widget.routing.connection_distance.label": "Distance maximale de raccordement",
	"teia.widgets.navigation_widget.routing.connections.text_one": "{{count}} raccordement valide",
	"teia.widgets.navigation_widget.routing.connections.text_many": "{{count}} raccordements valides",
	"teia.widgets.navigation_widget.routing.connections.text_other": "{{count}} raccordements valides",
	"teia.widgets.navigation_widget.routing.delete_point.text": "Supprimer",
	"teia.widgets.navigation_widget.routing.end.label": "Arrivée",
	"teia.widgets.navigation_widget.routing.errors.disconnected_components.text": "Le départ et l’arrivée sont raccordés à des parties séparées du graphe.",
	"teia.widgets.navigation_widget.routing.errors.invalid_graph.text": "Le graphe doit être valide avant de calculer un itinéraire.",
	"teia.widgets.navigation_widget.routing.errors.missing_end.text": "Placez un point d’arrivée.",
	"teia.widgets.navigation_widget.routing.errors.missing_graph.text": "Aucun graphe de navigation n’est disponible.",
	"teia.widgets.navigation_widget.routing.errors.missing_start.text": "Placez un point de départ.",
	"teia.widgets.navigation_widget.routing.errors.no_route.text": "Aucun itinéraire respectant les directions et l’accessibilité n’a été trouvé.",
	"teia.widgets.navigation_widget.routing.errors.unconnected_end.text": "Aucun accès au graphe n’a été trouvé depuis l’arrivée.",
	"teia.widgets.navigation_widget.routing.errors.unconnected_start.text": "Aucun accès au graphe n’a été trouvé depuis le départ.",
	"teia.widgets.navigation_widget.routing.not_placed.text": "Non placé",
	"teia.widgets.navigation_widget.routing.place_end.text": "Placer l’arrivée",
	"teia.widgets.navigation_widget.routing.place_start.text": "Placer le départ",
	"teia.widgets.navigation_widget.routing.quit_placement.text": "Arrêter de placer ce point",
	"teia.widgets.navigation_widget.routing.route_result.text_one": "{{count}} nœud parcouru · {{distance}} m",
	"teia.widgets.navigation_widget.routing.route_result.text_many": "{{count}} nœuds parcourus · {{distance}} m",
	"teia.widgets.navigation_widget.routing.route_result.text_other": "{{count}} nœuds parcourus · {{distance}} m",
	"teia.widgets.navigation_widget.routing.start.label": "Départ",
	"teia.widgets.navigation_widget.routing.title": "Utilisation du graphe",
	"teia.widgets.navigation_widget.selection.accessible.label": "Accessible",
	"teia.widgets.navigation_widget.selection.clear.text": "Tout désélectionner",
	"teia.widgets.navigation_widget.selection.connect_nodes.text": "Relier les 2 nœuds",
	"teia.widgets.navigation_widget.selection.delete_connected_graph.text": "Supprimer le graphe connecté",
	"teia.widgets.navigation_widget.selection.delete_connection.text": "Supprimer la connexion",
	"teia.widgets.navigation_widget.selection.delete.text": "Supprimer",
	"teia.widgets.navigation_widget.selection.direction_both.text": "Bidirectionnelle",
	"teia.widgets.navigation_widget.selection.direction_forward.text": "Sens unique",
	"teia.widgets.navigation_widget.selection.edges.text_one": "{{count}} arête",
	"teia.widgets.navigation_widget.selection.edges.text_many": "{{count}} arêtes",
	"teia.widgets.navigation_widget.selection.edges.text_other": "{{count}} arêtes",
	"teia.widgets.navigation_widget.selection.empty.text": "Aucun élément sélectionné",
	"teia.widgets.navigation_widget.selection.merge_center.text": "Centre",
	"teia.widgets.navigation_widget.selection.merge_first.text": "Premier",
	"teia.widgets.navigation_widget.selection.merge_last.text": "Dernier",
	"teia.widgets.navigation_widget.selection.merge_nodes.text": "Fusionner les noeuds sélectionnés :",
	"teia.widgets.navigation_widget.selection.nodes.text_one": "{{count}} noeud",
	"teia.widgets.navigation_widget.selection.nodes.text_many": "{{count}} noeuds",
	"teia.widgets.navigation_widget.selection.nodes.text_other": "{{count}} noeuds",
	"teia.widgets.navigation_widget.selection.reverse_direction.text": "Inverser le sens",
	"teia.widgets.navigation_widget.tabs.creation_route_disabled.text": "Arrêtez l’affichage de l’itinéraire avant de revenir à la création du graphe.",
	"teia.widgets.navigation_widget.tabs.creation.text": "Création du graphe",
	"teia.widgets.navigation_widget.tabs.flood_fill_disabled.text": "Générez une grille de voxels avant de calculer les espaces navigables.",
	"teia.widgets.navigation_widget.tabs.flood_fill.text": "Espaces navigables",
	"teia.widgets.navigation_widget.tabs.navmesh_disabled.text": "Terminez le flood fill avant de configurer le navmesh 2.5D.",
	"teia.widgets.navigation_widget.tabs.navmesh.text": "Navmesh 2.5D",
	"teia.widgets.navigation_widget.tabs.routing_editing_disabled.text": "Validez ou annulez les modifications du graphe avant de calculer un itinéraire.",
	"teia.widgets.navigation_widget.tabs.routing.text": "Itinéraire",
	"teia.widgets.navigation_widget.tabs.voxelization_editing_disabled.text": "Validez ou annulez les modifications du graphe avant de générer les voxels.",
	"teia.widgets.navigation_widget.tabs.voxelization.text": "Génération automatique",
	"teia.widgets.navigation_widget.title": "Graphe de navigation",
	"teia.widgets.navigation_widget.validation.errors.duplicate_edge.text": "Arête dupliquée.",
	"teia.widgets.navigation_widget.validation.errors.invalid_edge.text": "L’arête rencontre la géométrie de la scène.",
	"teia.widgets.navigation_widget.validation.errors.invalid_position.text": "Position de nœud invalide.",
	"teia.widgets.navigation_widget.validation.errors.missing_node.text": "Une extrémité de l’arête est absente.",
	"teia.widgets.navigation_widget.validation.errors.self_edge.text": "Une arête ne peut pas former une boucle sur un nœud.",
	"teia.widgets.navigation_widget.validation.revert.text": "Annuler les modifications",
	"teia.widgets.navigation_widget.validation.validate.text": "Valider",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.help.label": "À propos du niveau du BoxTree",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.help.text": "Profondeur maximale du BoxTree testée contre chaque voxel racine avant d’accepter comme candidats tous les objets situés sous ce niveau. Une valeur élevée parcourt les limites plus précisément et réduit généralement les tests coûteux des BVH géométriques ; une valeur faible visite moins de nœuds du BoxTree, mais conserve davantage de candidats.",
	"teia.widgets.navigation_widget.voxelization.box_tree_level.label": "Niveau du BoxTree",
	"teia.widgets.navigation_widget.voxelization.cancel.text": "Annuler",
	"teia.widgets.navigation_widget.voxelization.clear.text": "Effacer",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.help.label": "À propos de l’échantillonnage des voxels",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.help.text": "Affiche approximativement un voxel sur ce nombre grâce à un échantillonnage spatial stable. Seul le rendu de debug est allégé ; la grille de voxels générée reste complète.",
	"teia.widgets.navigation_widget.voxelization.debug.display_stride.label": "Afficher un voxel sur",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.help.label": "À propos des types d’objets exclus",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.help.text": "Types d’objets séparés par des virgules et ignorés pendant la voxelisation. L’exclusion est prioritaire sur l’inclusion et s’applique à tous les sous-maillages de l’objet.",
	"teia.widgets.navigation_widget.voxelization.excluded_object_types.label": "Types d’objets exclus",
	"teia.widgets.navigation_widget.voxelization.granularities.help.label": "À propos des granularités",
	"teia.widgets.navigation_widget.voxelization.granularities.help.text": "Tailles des voxels en mètres, de la plus grande à la plus petite. Les voxels vides conservent leur taille ; seuls les voxels solides sont subdivisés avec la valeur suivante. Chaque valeur doit diviser exactement la taille précédente.",
	"teia.widgets.navigation_widget.voxelization.granularities.label": "Granularités (m)",
	"teia.widgets.navigation_widget.voxelization.included_object_types.help.label": "À propos des types d’objets inclus",
	"teia.widgets.navigation_widget.voxelization.included_object_types.help.text": "Types d’objets autorisés à participer, séparés par des virgules. Lorsque cette liste est vide, tous les types sont inclus sauf ceux explicitement exclus.",
	"teia.widgets.navigation_widget.voxelization.included_object_types.label": "Types d’objets inclus",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.help.label": "À propos du nombre maximal de voxels",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.help.text": "Limite maximale globale de sécurité pour les voxels feuilles conservés et ceux en attente de traitement, répartie équitablement entre les workers. Un worker qui atteint sa part arrête le calcul, même si le total reste inférieur à la limite globale.",
	"teia.widgets.navigation_widget.voxelization.max_voxel_count.label": "Nombre maximal de voxels",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.help.label": "À propos des types d’objets traversables",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.help.text": "Types d’objets séparés par des virgules que les arêtes de navigation peuvent traverser. Les types horizontaux comme les portes marquent des passages non bloquants ; les types également configurés comme connecteurs verticaux, comme les escaliers, restent des supports solides.",
	"teia.widgets.navigation_widget.voxelization.passable_object_types.label": "Types d’objets traversables",
	"teia.widgets.navigation_widget.voxelization.progress.text_one": "{{count}} voxel traité",
	"teia.widgets.navigation_widget.voxelization.progress.text_many": "{{count}} voxels traités",
	"teia.widgets.navigation_widget.voxelization.progress.text_other": "{{count}} voxels traités",
	"teia.widgets.navigation_widget.voxelization.result.text_one": "{{count}} voxel généré · {{solid}} solide · {{empty}} vide",
	"teia.widgets.navigation_widget.voxelization.result.text_many": "{{count}} voxels générés · {{solid}} solides · {{empty}} vides",
	"teia.widgets.navigation_widget.voxelization.result.text_other": "{{count}} voxels générés · {{solid}} solides · {{empty}} vides",
	"teia.widgets.navigation_widget.voxelization.start.text": "Générer les voxels",
	"teia.widgets.navigation_widget.voxelization.title": "Voxelisation",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.label": "À propos des types d’objets autorisant les connexions verticales",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.text": "Types d’objets séparés par des virgules dont les voxels solides peuvent relier des surfaces à différentes hauteurs, comme les escaliers et les rampes. Cette classification est enregistrée pendant la voxelisation : modifier la liste nécessite donc de générer à nouveau les voxels.",
	"teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.label": "Types d’objets autorisant les connexions verticales",
	"teia.widgets.navigation_widget.voxelization.warning.missing_object_types.text": "Les objets de la scène ne fournissent pas leur type : les filtres de voxelisation par type ne peuvent donc pas être appliqués.",
	"teia.widgets.navigation_widget.voxelization.worker_count.help.label": "À propos du nombre de workers",
	"teia.widgets.navigation_widget.voxelization.worker_count.help.text": "Nombre de workers traitant les voxels racines en parallèle. Un nombre plus élevé peut réduire le temps de calcul, mais utilise davantage de CPU et de mémoire.",
	"teia.widgets.navigation_widget.voxelization.worker_count.label": "Nombre de workers",
	"teia.widgets.projection_widget.add_layer_tab.advanced_search.text": "Recherche avancée",
	"teia.widgets.projection_widget.add_layer_tab.annotations_to_display.text": "Annotations à afficher",
	"teia.widgets.projection_widget.add_layer_tab.available_annotation_list.text": "Liste des annotations disponibles",
	"teia.widgets.projection_widget.add_layer_tab.background.text": "Fond",
	"teia.widgets.projection_widget.add_layer_tab.cancel.text": "Annuler",
	"teia.widgets.projection_widget.add_layer_tab.customize_style.text": "Personnaliser le style",
	"teia.widgets.projection_widget.add_layer_tab.layer_name.label": "Nom du layer",
	"teia.widgets.projection_widget.add_layer_tab.line.text": "Contour",
	"teia.widgets.projection_widget.add_layer_tab.properties.title": "Sélectionner les propriétés concernées",
	"teia.widgets.projection_widget.add_layer_tab.title": "Edition de {{name}}",
	"teia.widgets.projection_widget.add_layer_tab.validate.text": "Valider",
	"teia.widgets.projection_widget.add_layer_tab.warnings.invalid_filter.text": "Vous devez définir les propriétés concernées.",
	"teia.widgets.projection_widget.add_tab.add_layer.text": "Ajouter un calque",
	"teia.widgets.projection_widget.add_tab.copy.text": "Copie",
	"teia.widgets.projection_widget.add_tab.custom_point_of_view.text": "Personnalisation du point de vue",
	"teia.widgets.projection_widget.add_tab.delete.text": "Supprimer",
	"teia.widgets.projection_widget.add_tab.drag.text": "Drag",
	"teia.widgets.projection_widget.add_tab.duplicate.text": "Dupliquer",
	"teia.widgets.projection_widget.add_tab.layer.text": "Que voulez-vous projeter ?",
	"teia.widgets.projection_widget.add_tab.params.text": "Paramètres",
	"teia.widgets.projection_widget.add_tab.point_of_view.text": "Sélectionner le point de vue",
	"teia.widgets.projection_widget.add_tab.projection_name.label": "Nom de la projection",
	"teia.widgets.projection_widget.add_tab.titles.create.title": "Créer une nouvelle projection",
	"teia.widgets.projection_widget.add_tab.titles.update.title": "Edition de {{name}}",
	"teia.widgets.projection_widget.add_tab.validate.text": "Valider",
	"teia.widgets.projection_widget.add_tab.warnings.at_least_one_layer.text": "Vous devez avoir un moins un layer",
	"teia.widgets.projection_widget.add_tab.warnings.must_have_a_name.text": "Vous devez choisir un nom pour votre projection",
	"teia.widgets.projection_widget.add_tab.warnings.must_have_filter.text": "doit avoir au moins une propriété concernée.",
	"teia.widgets.projection_widget.analysis_tab.back_button.text": "Retour",
	"teia.widgets.projection_widget.analysis_tab.deprecated_objects.text": "Objets obsolètes :",
	"teia.widgets.projection_widget.analysis_tab.download_label.text": "Télécharger le rapport d'analyse",
	"teia.widgets.projection_widget.analysis_tab.error.text": "Une erreur s'est produite lors de l'analyse.",
	"teia.widgets.projection_widget.analysis_tab.failed_objects.text": "Objets en échec :",
	"teia.widgets.projection_widget.analysis_tab.generate_label.text": "Générer un rapport d'analyse",
	"teia.widgets.projection_widget.analysis_tab.layer_list.text": "Liste des layers :",
	"teia.widgets.projection_widget.analysis_tab.processed_objects.text": "Objets traités :",
	"teia.widgets.projection_widget.analysis_tab.succeeded_objects.text": "Objets réussis :",
	"teia.widgets.projection_widget.analysis_tab.title.text": "Rapport d'analyses",
	"teia.widgets.projection_widget.import_tab.button.cancel.text": "Annuler",
	"teia.widgets.projection_widget.import_tab.button.import.text": "Importer",
	"teia.widgets.projection_widget.import_tab.delete.text": "Supprimer",
	"teia.widgets.projection_widget.import_tab.error_length.text": "Certaines configurations ont été enlevées : maximum 10 fichiers.",
	"teia.widgets.projection_widget.import_tab.error.text": "Erreur",
	"teia.widgets.projection_widget.import_tab.file_name.label": "Nom du fichier",
	"teia.widgets.projection_widget.import_tab.import_suffix.text": "Import",
	"teia.widgets.projection_widget.import_tab.import.text": "Glisser ou cliquer pour ouvrir l'explorateur de fichier",
	"teia.widgets.projection_widget.import_tab.max_files.text": "max.10 fichiers",
	"teia.widgets.projection_widget.import_tab.modal.cancel.text": "Annuler",
	"teia.widgets.projection_widget.import_tab.modal.confirm.text": "Confirmer",
	"teia.widgets.projection_widget.import_tab.modal.title": "Importation de projection(s)",
	"teia.widgets.projection_widget.import_tab.modal.warning.text": "Les fichiers json seront importés et transformés en projections.",
	"teia.widgets.projection_widget.import_tab.success.text": "Succès",
	"teia.widgets.projection_widget.import_tab.title": "Importer des projections",
	"teia.widgets.projection_widget.list_tab.actions.text": "Actions",
	"teia.widgets.projection_widget.list_tab.analyze.text": "Analyser",
	"teia.widgets.projection_widget.list_tab.caption.completed.text": "Complet",
	"teia.widgets.projection_widget.list_tab.caption.degraded.text": "Dégradé",
	"teia.widgets.projection_widget.list_tab.caption.error.text": "Echoué",
	"teia.widgets.projection_widget.list_tab.caption.loading.text": "En cours",
	"teia.widgets.projection_widget.list_tab.caption.waiting.text": "En attente",
	"teia.widgets.projection_widget.list_tab.copy.text": "Copie",
	"teia.widgets.projection_widget.list_tab.delete.text": "Supprimer",
	"teia.widgets.projection_widget.list_tab.download_pdf.text": "Télécharger le PDF",
	"teia.widgets.projection_widget.list_tab.download_svg.text": "Télécharger le SVG",
	"teia.widgets.projection_widget.list_tab.duplicate.text": "Dupliquer",
	"teia.widgets.projection_widget.list_tab.empty_list.search.text": "Aucune projection trouvée",
	"teia.widgets.projection_widget.list_tab.empty_list.text": "Aucune projection enregistrée",
	"teia.widgets.projection_widget.list_tab.export_modal.cancel.text": "Annuler",
	"teia.widgets.projection_widget.list_tab.export_modal.confirm.text": "Confirmer",
	"teia.widgets.projection_widget.list_tab.export_modal.title": "Exportation de projection(s)",
	"teia.widgets.projection_widget.list_tab.export_modal.warning.text": "Les paramètres seront exportés dans un ou des fichiers Json.",
	"teia.widgets.projection_widget.list_tab.export.text": "Exporter",
	"teia.widgets.projection_widget.list_tab.import.text": "Importer",
	"teia.widgets.projection_widget.list_tab.search.label": "Rechercher",
	"teia.widgets.projection_widget.list_tab.select.text": "Sélectionner",
	"teia.widgets.projection_widget.list_tab.table.actions.text": "Actions",
	"teia.widgets.projection_widget.list_tab.table.projection_name.text": "Projections",
	"teia.widgets.projection_widget.list_tab.table.status.text": "Statut",
	"teia.widgets.projection_widget.list_tab.title": "Liste des projections enregistrées",
	"teia.widgets.projection_widget.list_tab.update.text": "Modifier",
	"teia.widgets.projection_widget.no_twin.text": "Aucun Twin",
	"teia.widgets.projection_widget.title": "PROJECTION(S)",
	"teia.widgets.settings_widget.tabs.map.title": "Carte",
	"teia.widgets.shortcuts_widget.shortcuts.show_map.text": "Afficher/cacher la carte",
	"teiaSearchFilterEditor.ai.button.help_text": "Besoin d’aide ? Demandez à Elliot",
	"teiaSearchFilterEditor.ai.button.label": "Générer le filtre avec l’IA",
	"teiaSearchFilterEditor.ai.disclaimer.text": "Elliot est une IA entraînée pour vous fournir une assistance et des réponses fiables, néanmoins des erreurs peuvent survenir.",
	"teiaSearchFilterEditor.ai.errors.default.text": "Erreur lors de la génération du filtre IA",
	"teiaSearchFilterEditor.ai.errors.no_more_token.text": "Erreur lors de la génération du filtre IA : pas assez de tokens IA disponibles",
	"teiaSearchFilterEditor.ai.generate_button.label": "Générer le filtre",
	"teiaSearchFilterEditor.ai.textarea.placeholder": "Décrivez votre recherche en langage naturel...",
	"teiaSearchFilterEditor.condition_input.conditions.label": "conditions",
	"teiaSearchFilterEditor.condition_input.label": "S'applique à",
	"teiaSearchFilterEditor.condition_input.text_field.and.label": "Tous",
	"teiaSearchFilterEditor.condition_input.text_field.or.label": "≥ UN",
	"teiaSearchFilterEditor.condition_select.label": "Condition",
	"teiaSearchFilterEditor.condition_select.placeholder": "Condition",
	"teiaSearchFilterEditor.errors.text": "Tous les champs doivent être remplis pour que le filtre soit valide.",
	"teiaSearchFilterEditor.group.add_condition_tooltip.label": "Ajouter une condition",
	"teiaSearchFilterEditor.group.add_group_menu.label": "Ajouter un groupe",
	"teiaSearchFilterEditor.group.category.label": "Groupes",
	"teiaSearchFilterEditor.group.remove_group_tooltip.label": "Supprimer le groupe",
	"teiaSearchFilterEditor.guidCondition.value_text_field.label": "Valeur",
	"teiaSearchFilterEditor.json.apply_button.label": "Appliquer le JSON au filtre",
	"teiaSearchFilterEditor.json.button.label": "Ouvrir l’éditeur JSON",
	"teiaSearchFilterEditor.json.copy_button.copied_label": "JSON copié dans le presse-papiers",
	"teiaSearchFilterEditor.json.copy_button.label": "Copier le JSON",
	"teiaSearchFilterEditor.json.download_button.label": "Télécharger le JSON",
	"teiaSearchFilterEditor.json.download_modal.cancel_button.text": "Annuler",
	"teiaSearchFilterEditor.json.download_modal.confirm_button.text": "Télécharger",
	"teiaSearchFilterEditor.json.download_modal.file_name.label": "Nom du fichier",
	"teiaSearchFilterEditor.json.download_modal.title": "Télécharger le fichier JSON",
	"teiaSearchFilterEditor.json.format_button.label": "Mettre en forme le JSON",
	"teiaSearchFilterEditor.openDataAllCondition.value_text_field.label": "Valeur",
	"teiaSearchFilterEditor.openDataCondition.key_text_field.label": "Clé",
	"teiaSearchFilterEditor.openDataCondition.value_text_field.label": "Valeur",
	"teiaSearchFilterEditor.operatorSelector.operator.label": "Opérateur",
	"teiaSearchFilterEditor.parentGuidCondition.textField.label": "Valeur",
	"teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field.label": "Nom",
	"teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field.label": "Propriété",
	"teiaSearchFilterEditor.propertyCondition.values_autocomplete.text_field.label": "Valeur",
	"teiaSearchFilterEditor.remove_condition_button.label": "Supprimer la condition",
	"teiaSearchFilterEditor.remove_condition_tooltip.label": "Supprimer la condition",
	"teiaSearchFilterEditor.typeCondition.values_autocomplete.text_field.label": "Valeur",
	"teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label": "Nom de l'application",
	"teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label": "Nom",
	"teiaSearchFilterEditor.userDataByApplicationCondition.value_text_field.label": "Valeur",
	"toasts.loading_scene.text": "Chargement",
	"toasts.preparing_scene.text": "Préparation",
	"toolbar.camera_mode.default.tooltip": "Caméra par défaut",
	"toolbar.camera_mode.floor_plan_on_click.tooltip": "Caméra en plan au sol",
	"toolbar.camera_mode.fps.tooltip": "Caméra première personne",
	"toolbar.camera_mode.orbital.tooltip": "Caméra orbitale",
	"toolbar.camera_mode.selector.tooltip": "Mode de caméra",
	"toolbar.clipping_planes.add_plane_on_x_axis.tooltip": "Ajouter un plan de coupe sur l'axe X",
	"toolbar.clipping_planes.add_plane_on_y_axis.tooltip": "Ajouter un plan de coupe sur l'axe Y",
	"toolbar.clipping_planes.add_plane_on_z_axis.tooltip": "Ajouter un plan de coupe sur l'axe Z",
	"toolbar.clipping_planes.delete_all_planes.tooltip": "Supprimer tous les plans de coupe",
	"toolbar.clipping_planes.hide_show_all_planes.tooltip": "Cacher/Afficher tous les plans de coupe",
	"toolbar.clipping_planes.tooltip": "Outil plans de coupe",
	"toolbar.export_plan.tooltip": "Outil d'export de plan",
	"toolbar.focus_objects.tooltip": "Centrer sur les objets",
	"toolbar.hide_object.tooltip": "Masquer les objets",
	"toolbar.isolate_object.tooltip": "Isoler les objets",
	"toolbar.measure_lines.tooltip": "Outil lignes de mesure",
	"toolbar.notificationCenter.tooltip": "Centre de notifications",
	"toolbar.object_translations_download.tooltip": "Télécharger",
	"toolbar.object_translations_import.tooltip": "Importer",
	"toolbar.object_translations_widget.tooltip": "Déplacer",
	"toolbar.object_translations.tooltip": "Outil déplacement d'objets",
	"toolbar.projection.tooltip": "Outil de projection",
	"toolbar.redo.tooltip": "Refaire",
	"toolbar.render_mode.noEdges.tooltip": "Mode sans arêtes",
	"toolbar.render_mode.selector.tooltip": "Mode de rendu",
	"toolbar.render_mode.textured.tooltip": "Mode texturé",
	"toolbar.render_mode.wireframe.tooltip": "Mode fils de fer",
	"toolbar.render_mode.xray.tooltip": "Mode rayons X",
	"toolbar.render_mode.xrayNoEdges.tooltip": "Mode rayons X sans arêtes",
	"toolbar.reset_scene.tooltip": "Réinitialiser la scène",
	"toolbar.screenshot.tooltip": "Capture d'écran",
	"toolbar.search.input.label": "Rechercher",
	"toolbar.search.input.placeholder": "Rechercher",
	"toolbar.search.input.tooltip": "Recherche simple",
	"toolbar.search.tooltip": "Recherche",
	"toolbar.selection_info.label": "Sélection",
	"toolbar.selection_info.object_count.text_one": "Objet",
	"toolbar.selection_info.object_count.text_many": "Objets",
	"toolbar.selection_info.object_count.text_other": "Objets",
	"toolbar.show_devtools.tooltip": "Afficher les outils développeurs",
	"toolbar.show_history.tooltip": "Afficher l'historique",
	"toolbar.show_infobox.tooltip": "Afficher l'infobox",
	"toolbar.show_settings.tooltip": "Réglages",
	"toolbar.show_tools.label": "Afficher les outils",
	"toolbar.show_treeview.tooltip": "Afficher l'arborescence de scène",
	"toolbar.undo.tooltip": "Défaire",
	"toolbar.zone_cube.tooltip": "Créer un cube autour d'un objet",
	"toolbar.zone_duplicate.tooltip": "Créer une zone depuis la forme d'un objet",
	"toolbar.zone_sphere.tooltip": "Créer une sphère autour d'un objet",
	"toolbar.zone_widget.tooltip": "Ouvrir le widget de paramètres",
	"toolbar.zone.tooltip": "Outil de création de zones",
	"toolbar.zoom_in.tooltip": "Zoom avant",
	"toolbar.zoom_out.tooltip": "Zoom arrière",
	"widgets.history_widget.empty_history.text": "L'historique est vide.",
	"widgets.history_widget.redo_history.text": "Historique à refaire",
	"widgets.history_widget.title": "Historique",
	"widgets.history_widget.undo_history.text": "Historique à défaire",
	"widgets.infobox_widget.alerts.no_selected_objects.text": "Veuillez sélectionner un object pour visualiser ses données.",
	"widgets.infobox_widget.alerts.no_tabs.text": "Aucun onglet disponible pour l'infobox",
	"widgets.infobox_widget.lock_button.label": "Verrouiller l'infobox",
	"widgets.infobox_widget.lock_button.title": "Cliquer pour verrouiller le contenu de l'infobox",
	"widgets.infobox_widget.search.text": "Recherche",
	"widgets.infobox_widget.selected_objects.label_one": "{{count}} objet sélectionné",
	"widgets.infobox_widget.selected_objects.label_many": "{{count}} objets sélectionnés",
	"widgets.infobox_widget.selected_objects.label_other": "{{count}} objets sélectionnés",
	"widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata_search.text": "Aucune donnée 3D disponible pour cette recherche.",
	"widgets.infobox_widget.tabs.3Ddata_tab.alerts.nodata.text": "Aucune donnée 3D disponible pour cet objet.",
	"widgets.infobox_widget.tabs.3Ddata_tab.title": "Données 3D",
	"widgets.infobox_widget.tabs.3Ddata_tab.tooltip": "Données 3D",
	"widgets.infobox_widget.title": "Infobox",
	"widgets.map_widget.elevation.text": "Hauteur",
	"widgets.map_widget.latitude.text": "Latitude",
	"widgets.map_widget.longitude.text": "Longitude",
	"widgets.map_widget.maps.cadastral.text": "Cadastral",
	"widgets.map_widget.maps.default.text": "Par défaut",
	"widgets.map_widget.maps.satellite.text": "Satellite",
	"widgets.map_widget.maps.simple.text": "Simple",
	"widgets.map_widget.plan_type.text": "Type de plan",
	"widgets.map_widget.rotation.text": "Rotation",
	"widgets.map_widget.shape_type.text": "Forme de plan",
	"widgets.map_widget.shapes.circle.text": "Circulaire",
	"widgets.map_widget.shapes.square.text": "Carré",
	"widgets.map_widget.validate.text": "Valider",
	"widgets.map_widget.warning_no_twin.text": "Vous devez charger un Twin pour modifier la carte.",
	"widgets.map_widget.warning.text": "Les changements s'appliquent pour tout les utilisateurs de cette smartscene",
	"widgets.notification_center_widget.close_icon.label": "fermer la notification",
	"widgets.notification_center_widget.delete_icon.label": "Supprimer",
	"widgets.notification_center_widget.empty_list.text": "Aucune notification",
	"widgets.notification_center_widget.mark_as_read.label": "Marquer comme lu / non lu",
	"widgets.notification_center_widget.not_read.label": "Non lues",
	"widgets.notification_center_widget.notification_number.text_one": "{{count}} notification visible sur",
	"widgets.notification_center_widget.notification_number.text_many": "{{count}} notifications visibles sur",
	"widgets.notification_center_widget.notification_number.text_other": "{{count}} notifications visibles sur",
	"widgets.notification_center_widget.status_icons.error.label": "Filtre sur les erreurs",
	"widgets.notification_center_widget.status_icons.info.label": "Filtre sur les informations",
	"widgets.notification_center_widget.status_icons.success.label": "Filtre sur les succès",
	"widgets.notification_center_widget.status_icons.warning.label": "Filtre sur les avertissements",
	"widgets.notification_center_widget.title": "Centre de notifications",
	"widgets.object_translations.export_sucess.text": "L'export des déplacements d'objets a été executé avec succès.",
	"widgets.object_translations.export_sucess.title": "Export executé avec succès",
	"widgets.object_translations.import_error.text": "Une erreur s'est produite lors de l'importation.",
	"widgets.object_translations.import_error.title": "Erreur lors de l'import",
	"widgets.object_translations.import_success.text": "Les déplacements d'objets ont été importés avec succès.",
	"widgets.object_translations.import_success.title": "Import executé avec succès",
	"widgets.object_translations.import_warning.text": "Le fichier json semble incorrect.",
	"widgets.object_translations.import_warning.title": "Fichier json incorrect",
	"widgets.object_translations.rotate.label": "Sélectionne le gizmo de rotation",
	"widgets.object_translations.scale.label": "Redimensionnement d'objet",
	"widgets.object_translations.translate.label": "Sélectionne le gizmo de translation",
	"widgets.settings_widget.tabs.shortcuts.title": "Raccourcis clavier",
	"widgets.settings_widget.title": "Réglages",
	"widgets.shortcuts_widget.click_maintained.text": "Clic maintenu",
	"widgets.shortcuts_widget.click.text": "Clic",
	"widgets.shortcuts_widget.shortcuts.focus_selected_objects.text": "Focus les objets sélectionnés",
	"widgets.shortcuts_widget.shortcuts.hide_selected_objects.text": "Cacher la sélection",
	"widgets.shortcuts_widget.shortcuts.isolate_selected_objects.text": "Isoler la sélection",
	"widgets.shortcuts_widget.shortcuts.move_camera_down.text": "Bouger la caméra vers le bas",
	"widgets.shortcuts_widget.shortcuts.move_camera_left.text": "Bouger la caméra vers la gauche",
	"widgets.shortcuts_widget.shortcuts.move_camera_right.text": "Bouger la caméra vers la droite",
	"widgets.shortcuts_widget.shortcuts.move_camera_up.text": "Bouger la caméra vers le haut",
	"widgets.shortcuts_widget.shortcuts.open_infobox.text": "Ouvrir l'infobox",
	"widgets.shortcuts_widget.shortcuts.redo.text": "Refaire l'action précédemment annulée",
	"widgets.shortcuts_widget.shortcuts.select_all_visible_objects.text": "Sélectionner tous les objets visibles",
	"widgets.shortcuts_widget.shortcuts.select_several_objects.text": "Sélectionner plusieurs objets",
	"widgets.shortcuts_widget.shortcuts.select_several_transparent_objects.text": "Sélectionner plusieurs objets transparents",
	"widgets.shortcuts_widget.shortcuts.select_transparent_object.text": "Sélectionner un objet transparent",
	"widgets.shortcuts_widget.shortcuts.selection_path.text": "Chemin de sélection",
	"widgets.shortcuts_widget.shortcuts.show_spotlight.text": "Accéder à Spotlight",
	"widgets.shortcuts_widget.shortcuts.undo.text": "Annuler l'action précédente",
	"widgets.shortcuts_widget.warning.text": "Attention : clavier AZERTY par défaut, merci de presser la touche Z pour détecter le type de clavier.",
	"widgets.treeView.computing_treeview.text": "Chargement du jumeau..",
	"widgets.treeView.no_scene.text": "Pas de scène chargée",
	"widgets.treeView.title": "Arborescence de scène"
};
//#endregion
//#region src/translation/i18n.ts
function mt() {
	e.addResourceBundle("en", "teiaviewer", ft), e.addResourceBundle("fr", "teiaviewer", pt), e.loadNamespaces("teiaviewer");
}
Object.defineProperty(Array.prototype, "clear", {
	enumerable: !1,
	writable: !0
}), Array.prototype.clear = function() {
	return this.splice(0, this.length), this;
}, Object.defineProperty(Array.prototype, "remove", {
	enumerable: !1,
	writable: !0
}), Array.prototype.remove = function(...e) {
	let t = !0;
	for (let n of e) {
		let e = this.indexOf(n);
		e === -1 && (t = !1), this.splice(e, 1);
	}
	return t;
}, Object.defineProperty(Array.prototype, "toArray", {
	enumerable: !1,
	writable: !0
}), Array.prototype.toArray = function(e) {
	return Array.isArray(e) ? e : [e];
}, Object.defineProperty(Set.prototype, "addAll", {
	enumerable: !1,
	writable: !0
}), Set.prototype.addAll = function(e) {
	for (let t of e) this.add(t);
}, Object.defineProperty(Set.prototype, "map", {
	enumerable: !1,
	writable: !0
}), Set.prototype.map = function(e) {
	let t = 0, n = [];
	for (let r of this) n.push(e(r, t)), t++;
	return n;
}, Object.defineProperty(Set.prototype, "join", {
	enumerable: !1,
	writable: !0
}), Set.prototype.join = function(e = "") {
	return Array.from(this).join(e);
}, Object.defineProperty(Map.prototype, "map", {
	enumerable: !1,
	writable: !0
}), Map.prototype.map = function(e) {
	let t = 0, n = [];
	for (let r of this) n.push(e(r, t)), t++;
	return n;
};
//#endregion
//#region src/utils/Debug.ts
var C = class {
	static {
		this.enableLog = !0;
	}
	static {
		this.enableInfo = !1;
	}
	static {
		this.enableWarn = !0;
	}
	static {
		this.enableTime = !1;
	}
	static {
		this.enableError = !1;
	}
	static log(...e) {
		this.enableLog && console.log(...e);
	}
	static info(...e) {
		this.enableInfo && console.info(...e);
	}
	static warn(...e) {
		this.enableWarn && console.warn(...e);
	}
	static error(...e) {
		this.enableError && console.error(...e);
	}
	static time(e) {
		this.enableTime && console.time(e);
	}
	static timeEnd(e) {
		this.enableTime && console.timeEnd(e);
	}
}, w = class extends Re {
	constructor(...e) {
		super(...e), this.subscribe = (e) => {
			let t = this.connect(e);
			return () => t.disconnect();
		};
	}
	connect(e, { order: t = 0, isPublic: n = !1 } = {}) {
		return super.connect(e, {
			order: t,
			isPublic: n
		});
	}
}, ht = class e {
	static {
		this._instance = null;
	}
	constructor() {
		this.signals = {
			onNotificationAdded: new w(),
			onNotificationDeleted: new w(),
			onNotificationDeletedAll: new w(),
			onNotificationReadStatusUpdated: new w()
		}, this._notificationList = [];
	}
	static get instance() {
		return this._instance ??= new e(), this._instance;
	}
	get count() {
		return this._notificationList.length;
	}
	get unreadCount() {
		return this._notificationList.filter((e) => !e.read && (e.status === "error" || e.status === "warning")).length;
	}
	get isLoading() {
		return this._notificationList.some((e) => e.status === "pending");
	}
	get types() {
		let e = this._notificationList.map((e) => e.type);
		return e.push("all"), new Set(e);
	}
	*getNotifications() {
		for (let e of this._notificationList) yield e;
	}
	*getUnreadNotifications() {
		for (let e of this._notificationList) e.read || (yield e);
	}
	pushNotification(e, t) {
		let n = this._notificationList.findIndex((e) => e.id === t), r;
		n !== -1 && (r = this._notificationList[n], this._notificationList.splice(n, 1));
		let i = Date.now(), a = {
			type: e.type,
			status: e.status,
			title: e.title,
			timestamp: i,
			message: e.message,
			id: t ?? me.generateUUID(),
			read: !1,
			displayed: e.displayed ?? (e.status === "error" || e.status === "warning"),
			definitlyClosed: r?.definitlyClosed ?? !1
		};
		return this._notificationList.unshift(a), this.signals.onNotificationAdded.emit(a), a.id;
	}
	closeNotification(e) {
		e.definitlyClosed = !0;
	}
	removeNotifications(e) {
		if (Array.isArray(e)) for (let t of e) {
			let e = this._notificationList.findIndex((e) => e.id === t);
			this._notificationList.splice(e, 1);
		}
		else {
			let t = this._notificationList.findIndex((t) => t.id === e);
			this._notificationList.splice(t, 1);
		}
		this.signals.onNotificationDeleted.emit(e);
	}
	updateReadStatusNotifications(e, t) {
		if (Array.isArray(e)) for (let n of e) n.read = t;
		else e.read = t;
		this.signals.onNotificationReadStatusUpdated.emit(this.unreadCount);
	}
	clear() {
		this._notificationList.clear(), this.signals.onNotificationDeletedAll.emit();
	}
}, gt = async () => {}, _t = class {
	constructor(e, t, n) {
		this.ignoreWorkerMessage = !1, this._workers = [], this._busy = [], this.onmessage = gt, this.onerror = gt, this.onmessageerror = gt, this.onWorkerMessage = (e, t) => {
			this.onmessage && !this.ignoreWorkerMessage && this.onmessage(e, t);
		}, this.onWorkerError = (e, t) => {
			this.onerror && !this.ignoreWorkerMessage && this.onerror(e, t);
		}, this.onWorkerMessageError = (e, t) => {
			this.onmessageerror && !this.ignoreWorkerMessage && this.onmessageerror(e, t);
		}, this._WorkerConstructor = e, this._workerName = t, this._maxWorkers = n ?? navigator.hardwareConcurrency, this._initArrays();
	}
	stop() {
		this.ignoreWorkerMessage = !0, this.freeAllWorkers();
	}
	reset() {
		this.ignoreWorkerMessage = !1, this.freeAllWorkers();
	}
	areAllWorkersFree() {
		for (let e of this._busy) if (e) return !1;
		return !0;
	}
	hasFreeWorkers() {
		return this.nextFreeWorker() !== null;
	}
	get maxWorkers() {
		return this._maxWorkers;
	}
	set maxWorkers(e) {
		this._maxWorkers = e, this._initArrays();
	}
	terminateWorker(e) {
		if (e >= this._workers.length) throw Error(`WorkerId is out of range ${e}/${this._workers.length}`);
		let t = this._workers[e];
		t && t.terminate(), this._workers[e] = null, this._busy[e] = !1;
	}
	terminateWorkers() {
		for (let e of this._workers) e && e.terminate();
		this._busy.fill(!1), this._workers.fill(null);
	}
	postMessage(e, t = []) {
		let n = this.nextFreeWorker();
		if (n === null) throw Error("No workers available, please free one");
		return this._getWorker(n).postMessage({
			...e,
			workerId: n
		}, t), n;
	}
	freeWorker(e) {
		this._busy[e] = !1;
	}
	lockWorker(e) {
		this._busy[e] = !0;
	}
	freeAllWorkers() {
		this._busy.fill(!1);
	}
	postMessageWithId(e, t, n = []) {
		this._getWorker(e).postMessage(t, n);
	}
	nextFreeWorker() {
		for (let e = 0; e < this._workers.length; e++) if (!this._busy[e]) return e;
		return null;
	}
	_initArrays() {
		for (let e = this._busy.length; e < this._maxWorkers; e++) this._busy.push(!1), this._workers.push(null);
	}
	_getWorker(e) {
		if (e >= this._workers.length) throw Error(`WorkerId is out of range ${e}/${this._workers.length}`);
		let t = this._workers[e];
		return t === null && (C.time(`Initialized ${this._workerName} #${e}`), t = new this._WorkerConstructor({ name: this._workerName }), t.onmessage = (t) => this.onWorkerMessage(t, e), t.onerror = (t) => this.onWorkerError(t, e), t.onmessageerror = (t) => this.onWorkerMessageError(t, e), this._workers[e] = t, C.timeEnd(`Initialized ${this._workerName} #${e}`)), t;
	}
}, vt = class e {
	static {
		this._instance = null;
	}
	constructor() {
		this._localStorageMap = /* @__PURE__ */ new Map();
	}
	static get instance() {
		return this._instance ??= new e(), this._instance;
	}
	setLocalStorageMap(e, t) {
		let n = e.shift();
		if (!n) return;
		let r = { ...t }, i = {};
		for (let t of e.toReversed()) i[t] = r, r = i, i = {};
		let a = this._localStorageMap.get(n);
		this._localStorageMap.set(n, {
			...a,
			...r
		});
	}
	getFromLocalStorageMap(e) {
		if (e.length === 0) return {};
		if (!this._localStorageMap.get(e[0])) {
			let t = {}, n = localStorage.getItem(e[0]);
			n && (t = JSON.parse(n)), this._localStorageMap.set(e[0], t);
		}
		return this._getCfgRecursively(e) ?? {};
	}
	_getCfgRecursively(e) {
		let t = (e, n) => {
			let r = e.shift();
			if (r) {
				let i = n[r];
				return typeof i == "object" ? t(e, i) : i;
			}
			return n;
		};
		return t(e, Object.fromEntries(this._localStorageMap));
	}
	saveSettingsToLocalStorage() {
		for (let [e, t] of this._localStorageMap) localStorage.setItem(e, JSON.stringify(t));
	}
}, yt = class {};
//#endregion
//#region src/utils/tsUtils.ts
function bt(e) {
	let t = e.next();
	return t.done ? null : t.value;
}
function* xt(e, t) {
	let n = e.next(), r = 0;
	for (; !n.done && r < t;) yield n.value, r++, n = e.next();
}
var T = (...e) => {}, St = class {
	constructor(e) {
		this._viewer = e;
	}
	async prepare(e) {}
	getInitialObjects() {
		return [];
	}
	canProcessObject(e) {
		return !0;
	}
	shouldKeepObject(e, t) {
		return !0;
	}
	getObject(e) {
		return null;
	}
	updateObject(e) {}
	clean() {}
}, Ct = class {
	static async load(e) {
		try {
			let t = new Request(e.url, { ...e }), n = await (await fetch(t)).blob();
			switch (e.format) {
				case "OBJ": return await Tt(n);
				case "GLTF": return await wt(n);
			}
		} catch {
			throw console.error(`Failed to load file ${e.format} ${e.url}`), Error(`Failed to load file ${e.format} ${e.url}`);
		}
	}
};
async function wt(e) {
	try {
		let t = new Be();
		t.setMeshoptDecoder(ze);
		let n = await e.arrayBuffer();
		return (await t.parseAsync(n, "")).scene;
	} catch {
		throw Error("Failed to load GLTF file");
	}
}
async function Tt(e) {
	try {
		let t = new Ve(), n = await e.text();
		return t.parse(n);
	} catch {
		throw Error("Failed to load OBJ file");
	}
}
//#endregion
//#region src/io/JsHeapMemoryTracker.ts
var Et = class e {
	static {
		this._instance = null;
	}
	constructor() {
		this.percentageOfUsedMemory = 0, this.isAvailable = !0;
	}
	static get instance() {
		return this._instance ??= new e(), this._instance;
	}
	update() {
		let e = performance;
		if (!e.memory) {
			this.isAvailable = !1;
			return;
		}
		this.percentageOfUsedMemory = e.memory.usedJSHeapSize / e.memory.jsHeapSizeLimit;
	}
}, Dt = class {
	constructor(e = {}) {
		this.instancingMeshCountThreshold = -1, this.maxBatchingVertexCount = -1, this.maxBatchingIndexCount = -1, this.maxBatchingProxyCount = -1, this._batchingContexts = [];
		let { maxBatchingProxyCount: t = 3e3, maxBatchingIndexCount: n = 1e7, maxBatchingVertexCount: r = 1e7 } = e;
		this.maxBatchingProxyCount = t, this.maxBatchingIndexCount = n, this.maxBatchingVertexCount = r, this._currentMeshBatchingContext = Ot(), this._currentLineBatchingContext = kt();
	}
	addMeshes(e, t) {
		let n = this._currentMeshBatchingContext;
		n.meshes.set(e, t), n.indexCount += e.indexCount * t.length, n.vertexCount += e.vertexCount * t.length, n.count += t.length, (n.indexCount >= this.maxBatchingIndexCount || n.vertexCount >= this.maxBatchingVertexCount || n.count >= this.maxBatchingProxyCount) && this._swapMeshContext();
	}
	addLines(e, t) {
		if (e.indexCount > 0) {
			console.warn("Indexed line geometries are not supported.");
			return;
		}
		let n = this._currentLineBatchingContext;
		n.lines.set(e, t), n.vertexCount += e.vertexCount * t.length, n.count += t.length, (n.vertexCount >= this.maxBatchingVertexCount || n.count >= this.maxBatchingProxyCount) && this._swapLineContext();
	}
	_swapMeshContext() {
		this._batchingContexts.push(this._currentMeshBatchingContext), this._currentMeshBatchingContext = Ot();
	}
	_swapLineContext() {
		this._batchingContexts.push(this._currentLineBatchingContext), this._currentLineBatchingContext = kt();
	}
	get isEmpty() {
		return this._batchingContexts.length === 0 && this._currentMeshBatchingContext.count === 0 && this._currentLineBatchingContext.count === 0;
	}
	nextBatchingContext(e = !1) {
		return e && this._currentMeshBatchingContext.count > 0 && this._batchingContexts.length === 0 && this._swapMeshContext(), e && this._currentLineBatchingContext.count > 0 && this._batchingContexts.length === 0 && this._swapLineContext(), this._batchingContexts.shift() || null;
	}
	clear() {
		this._batchingContexts.clear(), this._currentMeshBatchingContext = Ot(), this._currentLineBatchingContext = kt();
	}
};
function Ot() {
	return {
		type: "MeshBatchingContext",
		meshes: /* @__PURE__ */ new Map(),
		vertexCount: 0,
		indexCount: 0,
		count: 0
	};
}
function kt() {
	return {
		type: "LineBatchingContext",
		lines: /* @__PURE__ */ new Map(),
		vertexCount: 0,
		count: 0
	};
}
//#endregion
//#region src/workers/FileLoadingWorker.ts?worker&inline
var At = "(function(){\n/**\n* @license\n* Copyright 2010-2026 Three.js Authors\n* SPDX-License-Identifier: MIT\n*/\nlet e=1e3,t=1001,n=1002,r=1003,i=1006,a=1008,o=1009,s=1015,c=1023,l=2300,u=2301,d=2302,f=2303,p=2400,m=2401,h=2402,g=`srgb`,_=`srgb-linear`,v=`linear`,y=7680,b=35044,x=2e3;function S(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function C(e){return ArrayBuffer.isView(e)&&!(e instanceof DataView)}function w(e){return document.createElementNS(`http://www.w3.org/1999/xhtml`,e)}let T={};function E(...e){let t=`THREE.`+e.shift();console.log(t,...e)}function D(e){let t=e[0];if(typeof t==`string`&&t.startsWith(`TSL:`)){let t=e[1];t&&t.isStackTrace?e[0]+=` `+t.getLocation():e[1]=`Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.`}return e}function O(...e){e=D(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.warn(n.getError(t)):console.warn(t,...e)}}function k(...e){e=D(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.error(n.getError(t)):console.error(t,...e)}}function A(...e){let t=e.join(` `);t in T||(T[t]=!0,O(...e))}var j=class{addEventListener(e,t){this._listeners===void 0&&(this._listeners={});let n=this._listeners;n[e]===void 0&&(n[e]=[]),n[e].indexOf(t)===-1&&n[e].push(t)}hasEventListener(e,t){let n=this._listeners;return n!==void 0&&n[e]!==void 0&&n[e].indexOf(t)!==-1}removeEventListener(e,t){let n=this._listeners;if(n===void 0)return;let r=n[e];if(r!==void 0){let e=r.indexOf(t);e!==-1&&r.splice(e,1)}}dispatchEvent(e){let t=this._listeners;if(t===void 0)return;let n=t[e.type];if(n!==void 0){e.target=this;let t=n.slice(0);for(let n=0,r=t.length;n<r;n++)t[n].call(this,e);e.target=null}}};let M=/* @__PURE__ */ `00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff`.split(`.`),N=1234567,P=Math.PI/180,F=180/Math.PI;function I(){let e=Math.random()*4294967295|0,t=Math.random()*4294967295|0,n=Math.random()*4294967295|0,r=Math.random()*4294967295|0;return(M[e&255]+M[e>>8&255]+M[e>>16&255]+M[e>>24&255]+`-`+M[t&255]+M[t>>8&255]+`-`+M[t>>16&15|64]+M[t>>24&255]+`-`+M[n&63|128]+M[n>>8&255]+`-`+M[n>>16&255]+M[n>>24&255]+M[r&255]+M[r>>8&255]+M[r>>16&255]+M[r>>24&255]).toLowerCase()}function L(e,t,n){return Math.max(t,Math.min(n,e))}function ee(e,t){return(e%t+t)%t}function te(e,t,n,r,i){return r+(e-t)*(i-r)/(n-t)}function ne(e,t,n){return e===t?0:(n-e)/(t-e)}function re(e,t,n){return(1-n)*e+n*t}function ie(e,t,n,r){return re(e,t,1-Math.exp(-n*r))}function ae(e,t=1){return t-Math.abs(ee(e,t*2)-t)}function oe(e,t,n){return e<=t?0:e>=n?1:(e=(e-t)/(n-t),e*e*(3-2*e))}function se(e,t,n){return e<=t?0:e>=n?1:(e=(e-t)/(n-t),e*e*e*(e*(e*6-15)+10))}function ce(e,t){return e+Math.floor(Math.random()*(t-e+1))}function le(e,t){return e+Math.random()*(t-e)}function ue(e){return e*(.5-Math.random())}function de(e){e!==void 0&&(N=e);let t=N+=1831565813;return t=Math.imul(t^t>>>15,t|1),t^=t+Math.imul(t^t>>>7,t|61),((t^t>>>14)>>>0)/4294967296}function fe(e){return e*P}function pe(e){return e*F}function me(e){return e>0&&Number.isInteger(e)&&2**Math.round(Math.log2(e))===e}function he(e){return 2**Math.ceil(Math.log(e)/Math.LN2)}function ge(e){return 2**Math.floor(Math.log(e)/Math.LN2)}function _e(e,t,n,r,i){let a=Math.cos,o=Math.sin,s=a(n/2),c=o(n/2),l=a((t+r)/2),u=o((t+r)/2),d=a((t-r)/2),f=o((t-r)/2),p=a((r-t)/2),m=o((r-t)/2);switch(i){case`XYX`:e.set(s*u,c*d,c*f,s*l);break;case`YZY`:e.set(c*f,s*u,c*d,s*l);break;case`ZXZ`:e.set(c*d,c*f,s*u,s*l);break;case`XZX`:e.set(s*u,c*m,c*p,s*l);break;case`YXY`:e.set(c*p,s*u,c*m,s*l);break;case`ZYZ`:e.set(c*m,c*p,s*u,s*l);break;default:O(`MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: `+i)}}function ve(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:case Uint8ClampedArray:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}function R(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(e*4294967295);case Uint16Array:return Math.round(e*65535);case Uint8Array:case Uint8ClampedArray:return Math.round(e*255);case Int32Array:return Math.round(e*2147483647);case Int16Array:return Math.round(e*32767);case Int8Array:return Math.round(e*127);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}let ye={DEG2RAD:P,RAD2DEG:F,generateUUID:I,clamp:L,euclideanModulo:ee,mapLinear:te,inverseLerp:ne,lerp:re,damp:ie,pingpong:ae,smoothstep:oe,smootherstep:se,randInt:ce,randFloat:le,randFloatSpread:ue,seededRandom:de,degToRad:fe,radToDeg:pe,isPowerOfTwo:me,ceilPowerOfTwo:he,floorPowerOfTwo:ge,setQuaternionFromProperEuler:_e,normalize:R,denormalize:ve};var z=class e{static{e.prototype.isVector2=!0}constructor(e=0,t=0){this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw Error(`THREE.Vector2: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw Error(`THREE.Vector2: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){let t=this.x,n=this.y,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6],this.y=r[1]*t+r[4]*n+r[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=L(this.x,e.x,t.x),this.y=L(this.y,e.y,t.y),this}clampScalar(e,t){return this.x=L(this.x,e,t),this.y=L(this.y,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(L(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(L(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){let n=Math.cos(t),r=Math.sin(t),i=this.x-e.x,a=this.y-e.y;return this.x=i*n-a*r+e.x,this.y=i*r+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}},be=class{constructor(e=0,t=0,n=0,r=1){this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=r}static slerpFlat(e,t,n,r,i,a,o){let s=n[r+0],c=n[r+1],l=n[r+2],u=n[r+3],d=i[a+0],f=i[a+1],p=i[a+2],m=i[a+3];if(u!==m||s!==d||c!==f||l!==p){let e=s*d+c*f+l*p+u*m;e<0&&(d=-d,f=-f,p=-p,m=-m,e=-e);let t=1-o;if(e<.9995){let n=Math.acos(e),r=Math.sin(n);t=Math.sin(t*n)/r,o=Math.sin(o*n)/r,s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o}else{s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o;let e=1/Math.sqrt(s*s+c*c+l*l+u*u);s*=e,c*=e,l*=e,u*=e}}e[t]=s,e[t+1]=c,e[t+2]=l,e[t+3]=u}static multiplyQuaternionsFlat(e,t,n,r,i,a){let o=n[r],s=n[r+1],c=n[r+2],l=n[r+3],u=i[a],d=i[a+1],f=i[a+2],p=i[a+3];return e[t]=o*p+l*u+s*f-c*d,e[t+1]=s*p+l*d+c*u-o*f,e[t+2]=c*p+l*f+o*d-s*u,e[t+3]=l*p-o*u-s*d-c*f,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,r){return this._x=e,this._y=t,this._z=n,this._w=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t=!0){let n=e._x,r=e._y,i=e._z,a=e._order,o=Math.cos,s=Math.sin,c=o(n/2),l=o(r/2),u=o(i/2),d=s(n/2),f=s(r/2),p=s(i/2);switch(a){case`XYZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`YXZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`ZXY`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`ZYX`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`YZX`:this._x=d*l*u+c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u-d*f*p;break;case`XZY`:this._x=d*l*u-c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u+d*f*p;break;default:O(`Quaternion: .setFromEuler() encountered an unknown order: `+a)}return t===!0&&this._onChangeCallback(),this}setFromAxisAngle(e,t){let n=t/2,r=Math.sin(n);return this._x=e.x*r,this._y=e.y*r,this._z=e.z*r,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){let t=e.elements,n=t[0],r=t[4],i=t[8],a=t[1],o=t[5],s=t[9],c=t[2],l=t[6],u=t[10],d=n+o+u;if(d>0){let e=.5/Math.sqrt(d+1);this._w=.25/e,this._x=(l-s)*e,this._y=(i-c)*e,this._z=(a-r)*e}else if(n>o&&n>u){let e=2*Math.sqrt(1+n-o-u);this._w=(l-s)/e,this._x=.25*e,this._y=(r+a)/e,this._z=(i+c)/e}else if(o>u){let e=2*Math.sqrt(1+o-n-u);this._w=(i-c)/e,this._x=(r+a)/e,this._y=.25*e,this._z=(s+l)/e}else{let e=2*Math.sqrt(1+u-n-o);this._w=(a-r)/e,this._x=(i+c)/e,this._y=(s+l)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<1e-8?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(L(this.dot(e),-1,1)))}rotateTowards(e,t){let n=this.angleTo(e);if(n===0)return this;let r=Math.min(1,t/n);return this.slerp(e,r),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return e===0?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x*=e,this._y*=e,this._z*=e,this._w*=e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=t._x,s=t._y,c=t._z,l=t._w;return this._x=n*l+a*o+r*c-i*s,this._y=r*l+a*s+i*o-n*c,this._z=i*l+a*c+n*s-r*o,this._w=a*l-n*o-r*s-i*c,this._onChangeCallback(),this}slerp(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=this.dot(e);o<0&&(n=-n,r=-r,i=-i,a=-a,o=-o);let s=1-t;if(o<.9995){let e=Math.acos(o),c=Math.sin(e);s=Math.sin(s*e)/c,t=Math.sin(t*e)/c,this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this._onChangeCallback()}else this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this.normalize();return this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){let e=2*Math.PI*Math.random(),t=2*Math.PI*Math.random(),n=Math.random(),r=Math.sqrt(1-n),i=Math.sqrt(n);return this.set(r*Math.sin(e),r*Math.cos(e),i*Math.sin(t),i*Math.cos(t))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e,t=0){return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this._onChangeCallback(),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}},B=class e{static{e.prototype.isVector3=!0}constructor(e=0,t=0,n=0){this.x=e,this.y=t,this.z=n}set(e,t,n){return n===void 0&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw Error(`THREE.Vector3: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw Error(`THREE.Vector3: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(Se.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(Se.setFromAxisAngle(e,t))}applyMatrix3(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6]*r,this.y=i[1]*t+i[4]*n+i[7]*r,this.z=i[2]*t+i[5]*n+i[8]*r,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=e.elements,a=1/(i[3]*t+i[7]*n+i[11]*r+i[15]);return this.x=(i[0]*t+i[4]*n+i[8]*r+i[12])*a,this.y=(i[1]*t+i[5]*n+i[9]*r+i[13])*a,this.z=(i[2]*t+i[6]*n+i[10]*r+i[14])*a,this}applyQuaternion(e){let t=this.x,n=this.y,r=this.z,i=e.x,a=e.y,o=e.z,s=e.w,c=2*(a*r-o*n),l=2*(o*t-i*r),u=2*(i*n-a*t);return this.x=t+s*c+a*u-o*l,this.y=n+s*l+o*c-i*u,this.z=r+s*u+i*l-a*c,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[4]*n+i[8]*r,this.y=i[1]*t+i[5]*n+i[9]*r,this.z=i[2]*t+i[6]*n+i[10]*r,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=L(this.x,e.x,t.x),this.y=L(this.y,e.y,t.y),this.z=L(this.z,e.z,t.z),this}clampScalar(e,t){return this.x=L(this.x,e,t),this.y=L(this.y,e,t),this.z=L(this.z,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(L(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){let n=e.x,r=e.y,i=e.z,a=t.x,o=t.y,s=t.z;return this.x=r*s-i*o,this.y=i*a-n*s,this.z=n*o-r*a,this}projectOnVector(e){let t=e.lengthSq();if(t===0)return this.set(0,0,0);let n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return xe.copy(this).projectOnVector(e),this.sub(xe)}reflect(e){return this.sub(xe.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(L(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y,r=this.z-e.z;return t*t+n*n+r*r}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){let r=Math.sin(t)*e;return this.x=r*Math.sin(n),this.y=Math.cos(t)*e,this.z=r*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){let t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),r=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=r,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,t*4)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,t*3)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){let e=Math.random()*Math.PI*2,t=Math.random()*2-1,n=Math.sqrt(1-t*t);return this.x=n*Math.cos(e),this.y=t,this.z=n*Math.sin(e),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}};let xe=/*@__PURE__*/ new B,Se=/*@__PURE__*/ new be;var Ce=class e{static{e.prototype.isMatrix3=!0}constructor(e,t,n,r,i,a,o,s,c){this.elements=[1,0,0,0,1,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c)}set(e,t,n,r,i,a,o,s,c){let l=this.elements;return l[0]=e,l[1]=r,l[2]=o,l[3]=t,l[4]=i,l[5]=s,l[6]=n,l[7]=a,l[8]=c,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){let t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[3],s=n[6],c=n[1],l=n[4],u=n[7],d=n[2],f=n[5],p=n[8],m=r[0],h=r[3],g=r[6],_=r[1],v=r[4],y=r[7],b=r[2],x=r[5],S=r[8];return i[0]=a*m+o*_+s*b,i[3]=a*h+o*v+s*x,i[6]=a*g+o*y+s*S,i[1]=c*m+l*_+u*b,i[4]=c*h+l*v+u*x,i[7]=c*g+l*y+u*S,i[2]=d*m+f*_+p*b,i[5]=d*h+f*v+p*x,i[8]=d*g+f*y+p*S,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8];return t*a*l-t*o*c-n*i*l+n*o*s+r*i*c-r*a*s}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=l*a-o*c,d=o*s-l*i,f=c*i-a*s,p=t*u+n*d+r*f;if(p===0)return this.set(0,0,0,0,0,0,0,0,0);let m=1/p;return e[0]=u*m,e[1]=(r*c-l*n)*m,e[2]=(o*n-r*a)*m,e[3]=d*m,e[4]=(l*t-r*s)*m,e[5]=(r*i-o*t)*m,e[6]=f*m,e[7]=(n*s-c*t)*m,e[8]=(a*t-n*i)*m,this}transpose(){let e,t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){let t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,r,i,a,o){let s=Math.cos(i),c=Math.sin(i);return this.set(n*s,n*c,-n*(s*a+c*o)+a+e,-r*c,r*s,-r*(-c*a+s*o)+o+t,0,0,1),this}scale(e,t){return A(`Matrix3: .scale() is deprecated. Use .makeScale() instead.`),this.premultiply(we.makeScale(e,t)),this}rotate(e){return A(`Matrix3: .rotate() is deprecated. Use .makeRotation() instead.`),this.premultiply(we.makeRotation(-e)),this}translate(e,t){return A(`Matrix3: .translate() is deprecated. Use .makeTranslation() instead.`),this.premultiply(we.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return new this.constructor().fromArray(this.elements)}};let we=/*@__PURE__*/ new Ce,Te=/*@__PURE__*/ new Ce().set(.4123908,.3575843,.1804808,.212639,.7151687,.0721923,.0193308,.1191948,.9505322),Ee=/*@__PURE__*/ new Ce().set(3.2409699,-1.5373832,-.4986108,-.9692436,1.8759675,.0415551,.0556301,-.203977,1.0569715);function De(){let e={enabled:!0,workingColorSpace:_,spaces:{},convert:function(e,t,n){return this.enabled===!1||t===n||!t||!n?e:(this.spaces[t].transfer===`srgb`&&(e.r=Oe(e.r),e.g=Oe(e.g),e.b=Oe(e.b)),this.spaces[t].primaries!==this.spaces[n].primaries&&(e.applyMatrix3(this.spaces[t].toXYZ),e.applyMatrix3(this.spaces[n].fromXYZ)),this.spaces[n].transfer===`srgb`&&(e.r=ke(e.r),e.g=ke(e.g),e.b=ke(e.b)),e)},workingToColorSpace:function(e,t){return this.convert(e,this.workingColorSpace,t)},colorSpaceToWorking:function(e,t){return this.convert(e,t,this.workingColorSpace)},getPrimaries:function(e){return this.spaces[e].primaries},getTransfer:function(e){return e===``?v:this.spaces[e].transfer},getToneMappingMode:function(e){return this.spaces[e].outputColorSpaceConfig.toneMappingMode||`standard`},getLuminanceCoefficients:function(e,t=this.workingColorSpace){return e.fromArray(this.spaces[t].luminanceCoefficients)},define:function(e){Object.assign(this.spaces,e)},_getMatrix:function(e,t,n){return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ)},_getDrawingBufferColorSpace:function(e){return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace},_getUnpackColorSpace:function(e=this.workingColorSpace){return this.spaces[e].workingColorSpaceConfig.unpackColorSpace},fromWorkingColorSpace:function(t,n){return A(`ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().`),e.workingToColorSpace(t,n)},toWorkingColorSpace:function(t,n){return A(`ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().`),e.colorSpaceToWorking(t,n)}},t=[.64,.33,.3,.6,.15,.06],n=[.2126,.7152,.0722],r=[.3127,.329];return e.define({[_]:{primaries:t,whitePoint:r,transfer:v,toXYZ:Te,fromXYZ:Ee,luminanceCoefficients:n,workingColorSpaceConfig:{unpackColorSpace:g},outputColorSpaceConfig:{drawingBufferColorSpace:g}},[g]:{primaries:t,whitePoint:r,transfer:`srgb`,toXYZ:Te,fromXYZ:Ee,luminanceCoefficients:n,outputColorSpaceConfig:{drawingBufferColorSpace:g}}}),e}let V=/*@__PURE__*/ De();function Oe(e){return e<.04045?e*.0773993808:(e*.9478672986+.0521327014)**2.4}function ke(e){return e<.0031308?e*12.92:1.055*e**.41666-.055}let Ae;var je=class{static getDataURL(e,t=`image/png`){if(/^data:/i.test(e.src)||typeof HTMLCanvasElement>`u`)return e.src;let n;if(e instanceof HTMLCanvasElement)n=e;else{Ae===void 0&&(Ae=w(`canvas`)),Ae.width=e.width,Ae.height=e.height;let t=Ae.getContext(`2d`);e instanceof ImageData?t.putImageData(e,0,0):t.drawImage(e,0,0,e.width,e.height),n=Ae}return n.toDataURL(t)}static sRGBToLinear(e){if(typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap){let t=w(`canvas`);t.width=e.width,t.height=e.height;let n=t.getContext(`2d`);n.drawImage(e,0,0,e.width,e.height);let r=n.getImageData(0,0,e.width,e.height),i=r.data;for(let e=0;e<i.length;e++)i[e]=Oe(i[e]/255)*255;return n.putImageData(r,0,0),t}if(e.data){let t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(Oe(t[e]/255)*255):t[e]=Oe(t[e]);return{data:t,width:e.width,height:e.height}}return O(`ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.`),e}};let Me=0;var Ne=class{constructor(e=null){this.isTextureSource=!0,Object.defineProperty(this,\"id\",{value:Me++}),this.uuid=I(),this.data=e,this.dataReady=!0,this.version=0}getSize(e){let t=this.data;return typeof HTMLVideoElement<`u`&&t instanceof HTMLVideoElement?e.set(t.videoWidth,t.videoHeight,0):typeof VideoFrame<`u`&&t instanceof VideoFrame?e.set(t.displayWidth,t.displayHeight,0):t===null?e.set(0,0,0):e.set(t.width,t.height,t.depth||0),e}set needsUpdate(e){e===!0&&this.version++}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.images[this.uuid]!==void 0)return e.images[this.uuid];let n={uuid:this.uuid,url:``},r=this.data;if(r!==null){let e;if(Array.isArray(r)){e=[];for(let t=0,n=r.length;t<n;t++)r[t].isDataTexture?e.push(Pe(r[t].image)):e.push(Pe(r[t]))}else e=Pe(r);n.url=e}return t||(e.images[this.uuid]=n),n}};function Pe(e){return typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap?je.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(O(`Texture: Unable to serialize Texture.`),{})}let Fe=0,Ie=/*@__PURE__*/ new B;var Le=class r extends j{constructor(e=r.DEFAULT_IMAGE,n=r.DEFAULT_MAPPING,s=t,l=t,u=i,d=a,f=c,p=o,m=r.DEFAULT_ANISOTROPY,h=``){super(),this.isTexture=!0,Object.defineProperty(this,\"id\",{value:Fe++}),this.uuid=I(),this.name=``,this.source=new Ne(e),this.mipmaps=[],this.mapping=n,this.channel=0,this.wrapS=s,this.wrapT=l,this.magFilter=u,this.minFilter=d,this.anisotropy=m,this.format=f,this.internalFormat=null,this.type=p,this.offset=new z(0,0),this.repeat=new z(1,1),this.center=new z(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new Ce,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.colorSpace=h,this.userData={},this.updateRanges=[],this.version=0,this.onUpdate=null,this.renderTarget=null,this.isRenderTargetTexture=!1,this.isArrayTexture=!!(e&&e.depth&&e.depth>1),this.pmremVersion=0,this.normalized=!1}get width(){return this.source.getSize(Ie).x}get height(){return this.source.getSize(Ie).y}get depth(){return this.source.getSize(Ie).z}get image(){return this.source.data}set image(e){this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}clone(){return new this.constructor().copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.normalized=e.normalized,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.renderTarget=e.renderTarget,this.isRenderTargetTexture=e.isRenderTargetTexture,this.isArrayTexture=e.isArrayTexture,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}setValues(e){for(let t in e){let n=e[t];if(n===void 0){O(`Texture.setValues(): parameter '${t}' has value of undefined.`);continue}let r=this[t];if(r===void 0){O(`Texture.setValues(): property '${t}' does not exist.`);continue}r&&n&&r.isVector2&&n.isVector2||r&&n&&r.isVector3&&n.isVector3||r&&n&&r.isMatrix3&&n.isMatrix3?r.copy(n):this[t]=n}}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.textures[this.uuid]!==void 0)return e.textures[this.uuid];let n={metadata:{version:4.7,type:`Texture`,generator:`Texture.toJSON`},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,normalized:this.normalized,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:`dispose`})}transformUv(r){if(this.mapping!==300)return r;if(r.applyMatrix3(this.matrix),r.x<0||r.x>1)switch(this.wrapS){case e:r.x-=Math.floor(r.x);break;case t:r.x=r.x<0?0:1;break;case n:Math.abs(Math.floor(r.x)%2)===1?r.x=Math.ceil(r.x)-r.x:r.x-=Math.floor(r.x)}if(r.y<0||r.y>1)switch(this.wrapT){case e:r.y-=Math.floor(r.y);break;case t:r.y=r.y<0?0:1;break;case n:Math.abs(Math.floor(r.y)%2)===1?r.y=Math.ceil(r.y)-r.y:r.y-=Math.floor(r.y)}return this.flipY&&(r.y=1-r.y),r}set needsUpdate(e){e===!0&&(this.version++,this.source.needsUpdate=!0)}set needsPMREMUpdate(e){e===!0&&this.pmremVersion++}};Le.DEFAULT_IMAGE=null,Le.DEFAULT_MAPPING=300,Le.DEFAULT_ANISOTROPY=1;var Re=class e{static{e.prototype.isVector4=!0}constructor(e=0,t=0,n=0,r=1){this.x=e,this.y=t,this.z=n,this.w=r}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,r){return this.x=e,this.y=t,this.z=n,this.w=r,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw Error(`THREE.Vector4: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw Error(`THREE.Vector4: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=e.w===void 0?1:e.w,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*r+a[12]*i,this.y=a[1]*t+a[5]*n+a[9]*r+a[13]*i,this.z=a[2]*t+a[6]*n+a[10]*r+a[14]*i,this.w=a[3]*t+a[7]*n+a[11]*r+a[15]*i,this}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this.w/=e.w,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);let t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,r,i,a=.01,o=.1,s=e.elements,c=s[0],l=s[4],u=s[8],d=s[1],f=s[5],p=s[9],m=s[2],h=s[6],g=s[10];if(Math.abs(l-d)<a&&Math.abs(u-m)<a&&Math.abs(p-h)<a){if(Math.abs(l+d)<o&&Math.abs(u+m)<o&&Math.abs(p+h)<o&&Math.abs(c+f+g-3)<o)return this.set(1,0,0,0),this;t=Math.PI;let e=(c+1)/2,s=(f+1)/2,_=(g+1)/2,v=(l+d)/4,y=(u+m)/4,b=(p+h)/4;return e>s&&e>_?e<a?(n=0,r=.707106781,i=.707106781):(n=Math.sqrt(e),r=v/n,i=y/n):s>_?s<a?(n=.707106781,r=0,i=.707106781):(r=Math.sqrt(s),n=v/r,i=b/r):_<a?(n=.707106781,r=.707106781,i=0):(i=Math.sqrt(_),n=y/i,r=b/i),this.set(n,r,i,t),this}let _=Math.sqrt((h-p)*(h-p)+(u-m)*(u-m)+(d-l)*(d-l));return Math.abs(_)<.001&&(_=1),this.x=(h-p)/_,this.y=(u-m)/_,this.z=(d-l)/_,this.w=Math.acos((c+f+g-1)/2),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this.w=t[15],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=L(this.x,e.x,t.x),this.y=L(this.y,e.y,t.y),this.z=L(this.z,e.z,t.z),this.w=L(this.w,e.w,t.w),this}clampScalar(e,t){return this.x=L(this.x,e,t),this.y=L(this.y,e,t),this.z=L(this.z,e,t),this.w=L(this.w,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(L(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}},H=class e{static{e.prototype.isMatrix4=!0}constructor(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h)}set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){let g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=r,g[1]=i,g[5]=a,g[9]=o,g[13]=s,g[2]=c,g[6]=l,g[10]=u,g[14]=d,g[3]=f,g[7]=p,g[11]=m,g[15]=h,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return new e().fromArray(this.elements)}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){let t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){let t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return this.determinantAffine()===0?(e.set(1,0,0),t.set(0,1,0),n.set(0,0,1),this):(e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this)}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){if(e.determinantAffine()===0)return this.identity();let t=this.elements,n=e.elements,r=1/ze.setFromMatrixColumn(e,0).length(),i=1/ze.setFromMatrixColumn(e,1).length(),a=1/ze.setFromMatrixColumn(e,2).length();return t[0]=n[0]*r,t[1]=n[1]*r,t[2]=n[2]*r,t[3]=0,t[4]=n[4]*i,t[5]=n[5]*i,t[6]=n[6]*i,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){let t=this.elements,n=e.x,r=e.y,i=e.z,a=Math.cos(n),o=Math.sin(n),s=Math.cos(r),c=Math.sin(r),l=Math.cos(i),u=Math.sin(i);if(e.order===`XYZ`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=-s*u,t[8]=c,t[1]=n+r*c,t[5]=e-i*c,t[9]=-o*s,t[2]=i-e*c,t[6]=r+n*c,t[10]=a*s}else if(e.order===`YXZ`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e+i*o,t[4]=r*o-n,t[8]=a*c,t[1]=a*u,t[5]=a*l,t[9]=-o,t[2]=n*o-r,t[6]=i+e*o,t[10]=a*s}else if(e.order===`ZXY`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e-i*o,t[4]=-a*u,t[8]=r+n*o,t[1]=n+r*o,t[5]=a*l,t[9]=i-e*o,t[2]=-a*c,t[6]=o,t[10]=a*s}else if(e.order===`ZYX`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=r*c-n,t[8]=e*c+i,t[1]=s*u,t[5]=i*c+e,t[9]=n*c-r,t[2]=-c,t[6]=o*s,t[10]=a*s}else if(e.order===`YZX`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=i-e*u,t[8]=r*u+n,t[1]=u,t[5]=a*l,t[9]=-o*l,t[2]=-c*l,t[6]=n*u+r,t[10]=e-i*u}else if(e.order===`XZY`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=-u,t[8]=c*l,t[1]=e*u+i,t[5]=a*l,t[9]=n*u-r,t[2]=r*u-n,t[6]=o*l,t[10]=i*u+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(Ve,e,He)}lookAt(e,t,n){let r=this.elements;return U.subVectors(e,t),U.lengthSq()===0&&(U.z=1),U.normalize(),Ue.crossVectors(n,U),Ue.lengthSq()===0&&(Math.abs(n.z)===1?U.x+=1e-4:U.z+=1e-4,U.normalize(),Ue.crossVectors(n,U)),Ue.normalize(),We.crossVectors(U,Ue),r[0]=Ue.x,r[4]=We.x,r[8]=U.x,r[1]=Ue.y,r[5]=We.y,r[9]=U.y,r[2]=Ue.z,r[6]=We.z,r[10]=U.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[4],s=n[8],c=n[12],l=n[1],u=n[5],d=n[9],f=n[13],p=n[2],m=n[6],h=n[10],g=n[14],_=n[3],v=n[7],y=n[11],b=n[15],x=r[0],S=r[4],C=r[8],w=r[12],T=r[1],E=r[5],D=r[9],O=r[13],k=r[2],A=r[6],j=r[10],M=r[14],N=r[3],P=r[7],F=r[11],I=r[15];return i[0]=a*x+o*T+s*k+c*N,i[4]=a*S+o*E+s*A+c*P,i[8]=a*C+o*D+s*j+c*F,i[12]=a*w+o*O+s*M+c*I,i[1]=l*x+u*T+d*k+f*N,i[5]=l*S+u*E+d*A+f*P,i[9]=l*C+u*D+d*j+f*F,i[13]=l*w+u*O+d*M+f*I,i[2]=p*x+m*T+h*k+g*N,i[6]=p*S+m*E+h*A+g*P,i[10]=p*C+m*D+h*j+g*F,i[14]=p*w+m*O+h*M+g*I,i[3]=_*x+v*T+y*k+b*N,i[7]=_*S+v*E+y*A+b*P,i[11]=_*C+v*D+y*j+b*F,i[15]=_*w+v*O+y*M+b*I,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[12],a=e[1],o=e[5],s=e[9],c=e[13],l=e[2],u=e[6],d=e[10],f=e[14],p=e[3],m=e[7],h=e[11],g=e[15],_=s*f-c*d,v=o*f-c*u,y=o*d-s*u,b=a*f-c*l,x=a*d-s*l,S=a*u-o*l;return t*(m*_-h*v+g*y)-n*(p*_-h*b+g*x)+r*(p*v-m*b+g*S)-i*(p*y-m*x+h*S)}determinantAffine(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[1],a=e[5],o=e[9],s=e[2],c=e[6],l=e[10];return t*(a*l-o*c)-n*(i*l-o*s)+r*(i*c-a*s)}transpose(){let e=this.elements,t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){let r=this.elements;return e.isVector3?(r[12]=e.x,r[13]=e.y,r[14]=e.z):(r[12]=e,r[13]=t,r[14]=n),this}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=e[9],d=e[10],f=e[11],p=e[12],m=e[13],h=e[14],g=e[15],_=t*o-n*a,v=t*s-r*a,y=t*c-i*a,b=n*s-r*o,x=n*c-i*o,S=r*c-i*s,C=l*m-u*p,w=l*h-d*p,T=l*g-f*p,E=u*h-d*m,D=u*g-f*m,O=d*g-f*h,k=_*O-v*D+y*E+b*T-x*w+S*C;if(k===0)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);let A=1/k;return e[0]=(o*O-s*D+c*E)*A,e[1]=(r*D-n*O-i*E)*A,e[2]=(m*S-h*x+g*b)*A,e[3]=(d*x-u*S-f*b)*A,e[4]=(s*T-a*O-c*w)*A,e[5]=(t*O-r*T+i*w)*A,e[6]=(h*y-p*S-g*v)*A,e[7]=(l*S-d*y+f*v)*A,e[8]=(a*D-o*T+c*C)*A,e[9]=(n*T-t*D-i*C)*A,e[10]=(p*x-m*y+g*_)*A,e[11]=(u*y-l*x-f*_)*A,e[12]=(o*w-a*E-s*C)*A,e[13]=(t*E-n*w+r*C)*A,e[14]=(m*v-p*b-h*_)*A,e[15]=(l*b-u*v+d*_)*A,this}scale(e){let t=this.elements,n=e.x,r=e.y,i=e.z;return t[0]*=n,t[4]*=r,t[8]*=i,t[1]*=n,t[5]*=r,t[9]*=i,t[2]*=n,t[6]*=r,t[10]*=i,t[3]*=n,t[7]*=r,t[11]*=i,this}getMaxScaleOnAxis(){let e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],r=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,r))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){let t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){let n=Math.cos(t),r=Math.sin(t),i=1-n,a=e.x,o=e.y,s=e.z,c=i*a,l=i*o;return this.set(c*a+n,c*o-r*s,c*s+r*o,0,c*o+r*s,l*o+n,l*s-r*a,0,c*s-r*o,l*s+r*a,i*s*s+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,r,i,a){return this.set(1,n,i,0,e,1,a,0,t,r,1,0,0,0,0,1),this}compose(e,t,n){let r=this.elements,i=t._x,a=t._y,o=t._z,s=t._w,c=i+i,l=a+a,u=o+o,d=i*c,f=i*l,p=i*u,m=a*l,h=a*u,g=o*u,_=s*c,v=s*l,y=s*u,b=n.x,x=n.y,S=n.z;return r[0]=(1-(m+g))*b,r[1]=(f+y)*b,r[2]=(p-v)*b,r[3]=0,r[4]=(f-y)*x,r[5]=(1-(d+g))*x,r[6]=(h+_)*x,r[7]=0,r[8]=(p+v)*S,r[9]=(h-_)*S,r[10]=(1-(d+m))*S,r[11]=0,r[12]=e.x,r[13]=e.y,r[14]=e.z,r[15]=1,this}decompose(e,t,n){let r=this.elements;e.x=r[12],e.y=r[13],e.z=r[14];let i=this.determinantAffine();if(i===0)return n.set(1,1,1),t.identity(),this;let a=ze.set(r[0],r[1],r[2]).length(),o=ze.set(r[4],r[5],r[6]).length(),s=ze.set(r[8],r[9],r[10]).length();i<0&&(a=-a),Be.copy(this);let c=1/a,l=1/o,u=1/s;return Be.elements[0]*=c,Be.elements[1]*=c,Be.elements[2]*=c,Be.elements[4]*=l,Be.elements[5]*=l,Be.elements[6]*=l,Be.elements[8]*=u,Be.elements[9]*=u,Be.elements[10]*=u,t.setFromRotationMatrix(Be),n.x=a,n.y=o,n.z=s,this}makePerspective(e,t,n,r,i,a,o=x,s=!1){let c=this.elements,l=2*i/(t-e),u=2*i/(n-r),d=(t+e)/(t-e),f=(n+r)/(n-r),p,m;if(s)p=i/(a-i),m=a*i/(a-i);else if(o===2e3)p=-(a+i)/(a-i),m=-2*a*i/(a-i);else if(o===2001)p=-a/(a-i),m=-a*i/(a-i);else throw Error(`THREE.Matrix4.makePerspective(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=d,c[12]=0,c[1]=0,c[5]=u,c[9]=f,c[13]=0,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=-1,c[15]=0,this}makeOrthographic(e,t,n,r,i,a,o=x,s=!1){let c=this.elements,l=2/(t-e),u=2/(n-r),d=-(t+e)/(t-e),f=-(n+r)/(n-r),p,m;if(s)p=1/(a-i),m=a/(a-i);else if(o===2e3)p=-2/(a-i),m=-(a+i)/(a-i);else if(o===2001)p=-1/(a-i),m=-i/(a-i);else throw Error(`THREE.Matrix4.makeOrthographic(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=0,c[12]=d,c[1]=0,c[5]=u,c[9]=0,c[13]=f,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=0,c[15]=1,this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}};let ze=/*@__PURE__*/ new B,Be=/*@__PURE__*/ new H,Ve=/*@__PURE__*/ new B(0,0,0),He=/*@__PURE__*/ new B(1,1,1),Ue=/*@__PURE__*/ new B,We=/*@__PURE__*/ new B,U=/*@__PURE__*/ new B,Ge=/*@__PURE__*/ new H,Ke=/*@__PURE__*/ new be;var qe=class e{constructor(t=0,n=0,r=0,i=e.DEFAULT_ORDER){this.isEuler=!0,this._x=t,this._y=n,this._z=r,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n,r=this._order){return this._x=e,this._y=t,this._z=n,this._order=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e,t=this._order,n=!0){let r=e.elements,i=r[0],a=r[4],o=r[8],s=r[1],c=r[5],l=r[9],u=r[2],d=r[6],f=r[10];switch(t){case`XYZ`:this._y=Math.asin(L(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-l,f),this._z=Math.atan2(-a,i)):(this._x=Math.atan2(d,c),this._z=0);break;case`YXZ`:this._x=Math.asin(-L(l,-1,1)),Math.abs(l)<.9999999?(this._y=Math.atan2(o,f),this._z=Math.atan2(s,c)):(this._y=Math.atan2(-u,i),this._z=0);break;case`ZXY`:this._x=Math.asin(L(d,-1,1)),Math.abs(d)<.9999999?(this._y=Math.atan2(-u,f),this._z=Math.atan2(-a,c)):(this._y=0,this._z=Math.atan2(s,i));break;case`ZYX`:this._y=Math.asin(-L(u,-1,1)),Math.abs(u)<.9999999?(this._x=Math.atan2(d,f),this._z=Math.atan2(s,i)):(this._x=0,this._z=Math.atan2(-a,c));break;case`YZX`:this._z=Math.asin(L(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-l,c),this._y=Math.atan2(-u,i)):(this._x=0,this._y=Math.atan2(o,f));break;case`XZY`:this._z=Math.asin(-L(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(d,c),this._y=Math.atan2(o,i)):(this._x=Math.atan2(-l,f),this._y=0);break;default:O(`Euler: .setFromRotationMatrix() encountered an unknown order: `+t)}return this._order=t,n===!0&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return Ge.makeRotationFromQuaternion(e),this.setFromRotationMatrix(Ge,t,n)}setFromVector3(e,t=this._order){return this.set(e.x,e.y,e.z,t)}reorder(e){return Ke.setFromEuler(this),this.setFromQuaternion(Ke,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],e[3]!==void 0&&(this._order=e[3]),this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}};qe.DEFAULT_ORDER=`XYZ`;var Je=class{constructor(){this.mask=1}set(e){this.mask=(1<<e|0)>>>0}enable(e){this.mask|=1<<e|0}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e|0}disable(e){this.mask&=~(1<<e|0)}disableAll(){this.mask=0}test(e){return(this.mask&e.mask)!==0}isEnabled(e){return!!(this.mask&(1<<e|0))}};let Ye=0,Xe=/*@__PURE__*/ new B,Ze=/*@__PURE__*/ new be,Qe=/*@__PURE__*/ new H,$e=/*@__PURE__*/ new B,et=/*@__PURE__*/ new B,tt=/*@__PURE__*/ new B,nt=/*@__PURE__*/ new be,rt=/*@__PURE__*/ new B(1,0,0),it=/*@__PURE__*/ new B(0,1,0),at=/*@__PURE__*/ new B(0,0,1),ot={type:`added`},st={type:`removed`},ct={type:`childadded`,child:null},lt={type:`childremoved`,child:null};var W=class e extends j{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,\"id\",{value:Ye++}),this.uuid=I(),this.name=``,this.type=`Object3D`,this.parent=null,this.children=[],this.up=e.DEFAULT_UP.clone();let t=new B,n=new qe,r=new be,i=new B(1,1,1);function a(){r.setFromEuler(n,!1)}function o(){n.setFromQuaternion(r,void 0,!1)}n._onChange(a),r._onChange(o),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:t},rotation:{configurable:!0,enumerable:!0,value:n},quaternion:{configurable:!0,enumerable:!0,value:r},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new H},normalMatrix:{value:new Ce}}),this.matrix=new H,this.matrixWorld=new H,this.matrixAutoUpdate=e.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldAutoUpdate=e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.layers=new Je,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.customDepthMaterial=void 0,this.customDistanceMaterial=void 0,this.static=!1,this.userData={},this.pivot=null}onBeforeShadow(){}onAfterShadow(){}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return Ze.setFromAxisAngle(e,t),this.quaternion.multiply(Ze),this}rotateOnWorldAxis(e,t){return Ze.setFromAxisAngle(e,t),this.quaternion.premultiply(Ze),this}rotateX(e){return this.rotateOnAxis(rt,e)}rotateY(e){return this.rotateOnAxis(it,e)}rotateZ(e){return this.rotateOnAxis(at,e)}translateOnAxis(e,t){return Xe.copy(e).applyQuaternion(this.quaternion),this.position.add(Xe.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(rt,e)}translateY(e){return this.translateOnAxis(it,e)}translateZ(e){return this.translateOnAxis(at,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(Qe.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?$e.copy(e):$e.set(e,t,n);let r=this.parent;this.updateWorldMatrix(!0,!1),et.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?Qe.lookAt(et,$e,this.up):Qe.lookAt($e,et,this.up),this.quaternion.setFromRotationMatrix(Qe),r&&(Qe.extractRotation(r.matrixWorld),Ze.setFromRotationMatrix(Qe),this.quaternion.premultiply(Ze.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(k(`Object3D.add: object can't be added as a child of itself.`,e),this):(e&&e.isObject3D?(e.removeFromParent(),e.parent=this,this.children.push(e),e.dispatchEvent(ot),ct.child=e,this.dispatchEvent(ct),ct.child=null):k(`Object3D.add: object not an instance of THREE.Object3D.`,e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}let t=this.children.indexOf(e);return t!==-1&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(st),lt.child=e,this.dispatchEvent(lt),lt.child=null),this}removeFromParent(){let e=this.parent;return e!==null&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),Qe.copy(this.matrixWorld).invert(),e.parent!==null&&(e.parent.updateWorldMatrix(!0,!1),Qe.multiply(e.parent.matrixWorld)),e.applyMatrix4(Qe),e.removeFromParent(),e.parent=this,this.children.push(e),e.updateWorldMatrix(!1,!0),e.dispatchEvent(ot),ct.child=e,this.dispatchEvent(ct),ct.child=null,this}getObjectById(e){return this.getObjectByProperty(`id`,e)}getObjectByName(e){return this.getObjectByProperty(`name`,e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,r=this.children.length;n<r;n++){let r=this.children[n].getObjectByProperty(e,t);if(r!==void 0)return r}}getObjectsByProperty(e,t,n=[]){this[e]===t&&n.push(this);let r=this.children;for(let i=0,a=r.length;i<a;i++)r[i].getObjectsByProperty(e,t,n);return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(et,e,tt),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(et,nt,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);let t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}intersectsFrustum(){}traverse(e){e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverse(e)}traverseVisible(e){if(this.visible===!1)return;e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverseVisible(e)}traverseAncestors(e){let t=this.parent;t!==null&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale);let e=this.pivot;if(e!==null){let t=e.x,n=e.y,r=e.z,i=this.matrix.elements;i[12]+=t-i[0]*t-i[4]*n-i[8]*r,i[13]+=n-i[1]*t-i[5]*n-i[9]*r,i[14]+=r-i[2]*t-i[6]*n-i[10]*r}this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,e=!0);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].updateMatrixWorld(e)}updateWorldMatrix(e,t,n=!1){let r=this.parent;if(e===!0&&r!==null&&r.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||n)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,n=!0),t===!0){let e=this.children;for(let t=0,r=e.length;t<r;t++)e[t].updateWorldMatrix(!1,!0,n)}}toJSON(e){let t=e===void 0||typeof e==`string`,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.7,type:`Object`,generator:`Object3D.toJSON`});let r={};r.uuid=this.uuid,r.type=this.type,r.name=this.name,r.castShadow=this.castShadow,r.receiveShadow=this.receiveShadow,r.visible=this.visible,r.frustumCulled=this.frustumCulled,r.renderOrder=this.renderOrder,r.static=this.static,r.matrixAutoUpdate=this.matrixAutoUpdate,Object.keys(this.userData).length>0&&(r.userData=this.userData),r.layers=this.layers.mask,r.matrix=this.matrix.toArray(),r.up=this.up.toArray(),this.pivot!==null&&(r.pivot=this.pivot.toArray()),this.morphTargetDictionary!==void 0&&(r.morphTargetDictionary=Object.assign({},this.morphTargetDictionary)),this.morphTargetInfluences!==void 0&&(r.morphTargetInfluences=this.morphTargetInfluences.slice()),this.isInstancedMesh&&(r.type=`InstancedMesh`,r.count=this.count,r.instanceMatrix=this.instanceMatrix.toJSON(),this.instanceColor!==null&&(r.instanceColor=this.instanceColor.toJSON())),this.isBatchedMesh&&(r.type=`BatchedMesh`,r.perObjectFrustumCulled=this.perObjectFrustumCulled,r.sortObjects=this.sortObjects,r.drawRanges=this._drawRanges,r.reservedRanges=this._reservedRanges,r.geometryInfo=this._geometryInfo.map(e=>({...e,boundingBox:e.boundingBox?e.boundingBox.toJSON():void 0,boundingSphere:e.boundingSphere?e.boundingSphere.toJSON():void 0})),r.instanceInfo=this._instanceInfo.map(e=>({...e})),r.availableInstanceIds=this._availableInstanceIds.slice(),r.availableGeometryIds=this._availableGeometryIds.slice(),r.nextIndexStart=this._nextIndexStart,r.nextVertexStart=this._nextVertexStart,r.geometryCount=this._geometryCount,r.maxInstanceCount=this._maxInstanceCount,r.maxVertexCount=this._maxVertexCount,r.maxIndexCount=this._maxIndexCount,r.geometryInitialized=this._geometryInitialized,r.matricesTexture=this._matricesTexture.toJSON(e),r.indirectTexture=this._indirectTexture.toJSON(e),this._colorsTexture!==null&&(r.colorsTexture=this._colorsTexture.toJSON(e)),this.boundingSphere!==null&&(r.boundingSphere=this.boundingSphere.toJSON()),this.boundingBox!==null&&(r.boundingBox=this.boundingBox.toJSON()));function i(t,n){return t[n.uuid]===void 0&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(this.isScene)this.background&&(this.background.isColor?r.background=this.background.toJSON():this.background.isTexture&&(r.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&this.environment.isRenderTargetTexture!==!0&&(r.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){r.geometry=i(e.geometries,this.geometry);let t=this.geometry.parameters;if(t!==void 0&&t.shapes!==void 0){let n=t.shapes;if(Array.isArray(n))for(let t=0,r=n.length;t<r;t++){let r=n[t];i(e.shapes,r)}else i(e.shapes,n)}}if(this.isSkinnedMesh&&(r.bindMode=this.bindMode,r.bindMatrix=this.bindMatrix.toArray(),this.skeleton!==void 0&&(i(e.skeletons,this.skeleton),r.skeleton=this.skeleton.uuid)),this.material!==void 0){if(Array.isArray(this.material)){let t=[];for(let n=0,r=this.material.length;n<r;n++)t.push(i(e.materials,this.material[n]));r.material=t}else r.material=i(e.materials,this.material)}if(this.children.length>0){r.children=[];for(let t=0;t<this.children.length;t++)r.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){r.animations=[];for(let t=0;t<this.animations.length;t++){let n=this.animations[t];r.animations.push(i(e.animations,n))}}if(t){let t=a(e.geometries),r=a(e.materials),i=a(e.textures),o=a(e.images),s=a(e.shapes),c=a(e.skeletons),l=a(e.animations),u=a(e.nodes);t.length>0&&(n.geometries=t),r.length>0&&(n.materials=r),i.length>0&&(n.textures=i),o.length>0&&(n.images=o),s.length>0&&(n.shapes=s),c.length>0&&(n.skeletons=c),l.length>0&&(n.animations=l),u.length>0&&(n.nodes=u)}return n.object=r,n;function a(e){let t=[];for(let n in e){let r=e[n];delete r.metadata,t.push(r)}return t}}clone(e){return new this.constructor().copy(this,e)}copy(e,t=!0){if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.pivot=e.pivot===null?null:e.pivot.clone(),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.static=e.static,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),t===!0)for(let t=0;t<e.children.length;t++){let n=e.children[t];this.add(n.clone())}return this}dispose(){this.dispatchEvent({type:`dispose`})}};W.DEFAULT_UP=/*@__PURE__*/ new B(0,1,0),W.DEFAULT_MATRIX_AUTO_UPDATE=!0,W.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;var ut=class extends W{constructor(){super(),this.isGroup=!0,this.type=`Group`}};let dt={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},ft={h:0,s:0,l:0},pt={h:0,s:0,l:0};function mt(e,t,n){return n<0&&(n+=1),n>1&&--n,n<1/6?e+(t-e)*6*n:n<1/2?t:n<2/3?e+(t-e)*6*(2/3-n):e}var G=class{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(t===void 0&&n===void 0){let t=e;t&&t.isColor?this.copy(t):typeof t==`number`?this.setHex(t):typeof t==`string`&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e,t=g){return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(e&255)/255,V.colorSpaceToWorking(this,t),this}setRGB(e,t,n,r=V.workingColorSpace){return this.r=e,this.g=t,this.b=n,V.colorSpaceToWorking(this,r),this}setHSL(e,t,n,r=V.workingColorSpace){if(e=ee(e,1),t=L(t,0,1),n=L(n,0,1),t===0)this.r=this.g=this.b=n;else{let r=n<=.5?n*(1+t):n+t-n*t,i=2*n-r;this.r=mt(i,r,e+1/3),this.g=mt(i,r,e),this.b=mt(i,r,e-1/3)}return V.colorSpaceToWorking(this,r),this}setStyle(e,t=g){function n(t){t!==void 0&&parseFloat(t)<1&&O(`Color: Alpha component of `+e+` will be ignored.`)}let r;if(r=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let i,a=r[1],o=r[2];switch(a){case`rgb`:case`rgba`:if(i=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(255,parseInt(i[1],10))/255,Math.min(255,parseInt(i[2],10))/255,Math.min(255,parseInt(i[3],10))/255,t);if(i=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(100,parseInt(i[1],10))/100,Math.min(100,parseInt(i[2],10))/100,Math.min(100,parseInt(i[3],10))/100,t);break;case`hsl`:case`hsla`:if(i=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setHSL(parseFloat(i[1])/360,parseFloat(i[2])/100,parseFloat(i[3])/100,t);break;default:O(`Color: Unknown color model `+e)}}else if(r=/^\\#([A-Fa-f\\d]+)$/.exec(e)){let n=r[1],i=n.length;if(i===3)return this.setRGB(parseInt(n.charAt(0),16)/15,parseInt(n.charAt(1),16)/15,parseInt(n.charAt(2),16)/15,t);if(i===6)return this.setHex(parseInt(n,16),t);O(`Color: Invalid hex color `+e)}else if(e&&e.length>0)return this.setColorName(e,t);return this}setColorName(e,t=g){let n=dt[e.toLowerCase()];return n===void 0?O(`Color: Unknown color `+e):this.setHex(n,t),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=Oe(e.r),this.g=Oe(e.g),this.b=Oe(e.b),this}copyLinearToSRGB(e){return this.r=ke(e.r),this.g=ke(e.g),this.b=ke(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(e=g){return V.workingToColorSpace(K.copy(this),e),Math.round(L(K.r*255,0,255))*65536+Math.round(L(K.g*255,0,255))*256+Math.round(L(K.b*255,0,255))}getHexString(e=g){return(`000000`+this.getHex(e).toString(16)).slice(-6)}getHSL(e,t=V.workingColorSpace){V.workingToColorSpace(K.copy(this),t);let n=K.r,r=K.g,i=K.b,a=Math.max(n,r,i),o=Math.min(n,r,i),s,c,l=(o+a)/2;if(o===a)s=0,c=0;else{let e=a-o;switch(c=l<=.5?e/(a+o):e/(2-a-o),a){case n:s=(r-i)/e+(r<i?6:0);break;case r:s=(i-n)/e+2;break;case i:s=(n-r)/e+4}s/=6}return e.h=s,e.s=c,e.l=l,e}getRGB(e,t=V.workingColorSpace){return V.workingToColorSpace(K.copy(this),t),e.r=K.r,e.g=K.g,e.b=K.b,e}getStyle(e=g){V.workingToColorSpace(K.copy(this),e);let t=K.r,n=K.g,r=K.b;return e===`srgb`?`rgb(${Math.round(t*255)},${Math.round(n*255)},${Math.round(r*255)})`:`color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`}offsetHSL(e,t,n){return this.getHSL(ft),this.setHSL(ft.h+e,ft.s+t,ft.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(ft),e.getHSL(pt);let n=re(ft.h,pt.h,t),r=re(ft.s,pt.s,t),i=re(ft.l,pt.l,t);return this.setHSL(n,r,i),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){let t=this.r,n=this.g,r=this.b,i=e.elements;return this.r=i[0]*t+i[3]*n+i[6]*r,this.g=i[1]*t+i[4]*n+i[7]*r,this.b=i[2]*t+i[5]*n+i[8]*r,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e,t=0){return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(e=[],t=0){return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}};let K=/*@__PURE__*/ new G;G.NAMES=dt;let ht=/*@__PURE__*/ new B,gt=/*@__PURE__*/ new B,_t=/*@__PURE__*/ new B,vt=/*@__PURE__*/ new B,yt=/*@__PURE__*/ new B,bt=/*@__PURE__*/ new B,xt=/*@__PURE__*/ new B,St=/*@__PURE__*/ new B,Ct=/*@__PURE__*/ new B,wt=/*@__PURE__*/ new B,Tt=/*@__PURE__*/ new Re,Et=/*@__PURE__*/ new Re,Dt=/*@__PURE__*/ new Re;var Ot=class e{constructor(e=new B,t=new B,n=new B){this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,r){r.subVectors(n,t),ht.subVectors(e,t),r.cross(ht);let i=r.lengthSq();return i>0?r.multiplyScalar(1/Math.sqrt(i)):r.set(0,0,0)}static getBarycoord(e,t,n,r,i){ht.subVectors(r,t),gt.subVectors(n,t),_t.subVectors(e,t);let a=ht.dot(ht),o=ht.dot(gt),s=ht.dot(_t),c=gt.dot(gt),l=gt.dot(_t),u=a*c-o*o;if(u===0)return i.set(0,0,0),null;let d=1/u,f=(c*s-o*l)*d,p=(a*l-o*s)*d;return i.set(1-f-p,p,f)}static containsPoint(e,t,n,r){return this.getBarycoord(e,t,n,r,vt)!==null&&vt.x>=0&&vt.y>=0&&vt.x+vt.y<=1}static getInterpolation(e,t,n,r,i,a,o,s){return this.getBarycoord(e,t,n,r,vt)===null?(s.x=0,s.y=0,`z`in s&&(s.z=0),`w`in s&&(s.w=0),null):(s.setScalar(0),s.addScaledVector(i,vt.x),s.addScaledVector(a,vt.y),s.addScaledVector(o,vt.z),s)}static getInterpolatedAttribute(e,t,n,r,i,a){return Tt.setScalar(0),Et.setScalar(0),Dt.setScalar(0),Tt.fromBufferAttribute(e,t),Et.fromBufferAttribute(e,n),Dt.fromBufferAttribute(e,r),a.setScalar(0),a.addScaledVector(Tt,i.x),a.addScaledVector(Et,i.y),a.addScaledVector(Dt,i.z),a}static isFrontFacing(e,t,n,r){return ht.subVectors(n,t),gt.subVectors(e,t),ht.cross(gt).dot(r)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,r){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[r]),this}setFromAttributeAndIndices(e,t,n,r){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,r),this}clone(){return new this.constructor().copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return ht.subVectors(this.c,this.b),gt.subVectors(this.a,this.b),ht.cross(gt).length()*.5}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(t){return e.getNormal(this.a,this.b,this.c,t)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(t,n){return e.getBarycoord(t,this.a,this.b,this.c,n)}getInterpolation(t,n,r,i,a){return e.getInterpolation(t,this.a,this.b,this.c,n,r,i,a)}containsPoint(t){return e.containsPoint(t,this.a,this.b,this.c)}isFrontFacing(t){return e.isFrontFacing(this.a,this.b,this.c,t)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){let n=this.a,r=this.b,i=this.c,a,o;yt.subVectors(r,n),bt.subVectors(i,n),St.subVectors(e,n);let s=yt.dot(St),c=bt.dot(St);if(s<=0&&c<=0)return t.copy(n);Ct.subVectors(e,r);let l=yt.dot(Ct),u=bt.dot(Ct);if(l>=0&&u<=l)return t.copy(r);let d=s*u-l*c;if(d<=0&&s>=0&&l<=0)return a=s/(s-l),t.copy(n).addScaledVector(yt,a);wt.subVectors(e,i);let f=yt.dot(wt),p=bt.dot(wt);if(p>=0&&f<=p)return t.copy(i);let m=f*c-s*p;if(m<=0&&c>=0&&p<=0)return o=c/(c-p),t.copy(n).addScaledVector(bt,o);let h=l*p-f*u;if(h<=0&&u-l>=0&&f-p>=0)return xt.subVectors(i,r),o=(u-l)/(u-l+(f-p)),t.copy(r).addScaledVector(xt,o);let g=1/(h+m+d);return a=m*g,o=d*g,t.copy(n).addScaledVector(yt,a).addScaledVector(bt,o)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}},kt=class{constructor(e=new B(1/0,1/0,1/0),t=new B(-1/0,-1/0,-1/0)){this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(jt.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(jt.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){let n=jt.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e,t=!1){return this.makeEmpty(),this.expandByObject(e,t)}clone(){return new this.constructor().copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e,t=!1){e.updateWorldMatrix(!1,!1);let n=e.geometry;if(n!==void 0){let r=n.getAttribute(`position`);if(t===!0&&r!==void 0&&e.isInstancedMesh!==!0)for(let t=0,n=r.count;t<n;t++)e.isMesh===!0?e.getVertexPosition(t,jt):jt.fromBufferAttribute(r,t),jt.applyMatrix4(e.matrixWorld),this.expandByPoint(jt);else e.boundingBox===void 0?(n.boundingBox===null&&n.computeBoundingBox(),Mt.copy(n.boundingBox)):(e.boundingBox===null&&e.computeBoundingBox(),Mt.copy(e.boundingBox)),Mt.applyMatrix4(e.matrixWorld),this.union(Mt)}let r=e.children;for(let e=0,n=r.length;e<n;e++)this.expandByObject(r[e],t);return this}containsPoint(e){return e.x>=this.min.x&&e.x<=this.max.x&&e.y>=this.min.y&&e.y<=this.max.y&&e.z>=this.min.z&&e.z<=this.max.z}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return e.max.x>=this.min.x&&e.min.x<=this.max.x&&e.max.y>=this.min.y&&e.min.y<=this.max.y&&e.max.z>=this.min.z&&e.min.z<=this.max.z}intersectsSphere(e){return this.clampPoint(e.center,jt),jt.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(zt),Bt.subVectors(this.max,zt),Nt.subVectors(e.a,zt),Pt.subVectors(e.b,zt),Ft.subVectors(e.c,zt),It.subVectors(Pt,Nt),Lt.subVectors(Ft,Pt),Rt.subVectors(Nt,Ft);let t=[0,-It.z,It.y,0,-Lt.z,Lt.y,0,-Rt.z,Rt.y,It.z,0,-It.x,Lt.z,0,-Lt.x,Rt.z,0,-Rt.x,-It.y,It.x,0,-Lt.y,Lt.x,0,-Rt.y,Rt.x,0];return!Ut(t,Nt,Pt,Ft,Bt)||(t=[1,0,0,0,1,0,0,0,1],!Ut(t,Nt,Pt,Ft,Bt))?!1:(Vt.crossVectors(It,Lt),t=[Vt.x,Vt.y,Vt.z],Ut(t,Nt,Pt,Ft,Bt))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,jt).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=this.getSize(jt).length()*.5),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()?this:(At[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),At[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),At[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),At[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),At[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),At[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),At[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),At[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(At),this)}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}toJSON(){return{min:this.min.toArray(),max:this.max.toArray()}}fromJSON(e){return this.min.fromArray(e.min),this.max.fromArray(e.max),this}};let At=[/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B,/*@__PURE__*/ new B],jt=/*@__PURE__*/ new B,Mt=/*@__PURE__*/ new kt,Nt=/*@__PURE__*/ new B,Pt=/*@__PURE__*/ new B,Ft=/*@__PURE__*/ new B,It=/*@__PURE__*/ new B,Lt=/*@__PURE__*/ new B,Rt=/*@__PURE__*/ new B,zt=/*@__PURE__*/ new B,Bt=/*@__PURE__*/ new B,Vt=/*@__PURE__*/ new B,Ht=/*@__PURE__*/ new B;function Ut(e,t,n,r,i){for(let a=0,o=e.length-3;a<=o;a+=3){Ht.fromArray(e,a);let o=i.x*Math.abs(Ht.x)+i.y*Math.abs(Ht.y)+i.z*Math.abs(Ht.z),s=t.dot(Ht),c=n.dot(Ht),l=r.dot(Ht);if(Math.max(-Math.max(s,c,l),Math.min(s,c,l))>o)return!1}return!0}let q=/*@__PURE__*/ new B,Wt=/*@__PURE__*/ new z,Gt=0;var Kt=class extends j{constructor(e,t,n=!1){if(super(),Array.isArray(e))throw TypeError(`THREE.BufferAttribute: array should be a Typed Array.`);this.isBufferAttribute=!0,Object.defineProperty(this,\"id\",{value:Gt++}),this.name=``,this.array=e,this.itemSize=t,this.count=e===void 0?0:e.length/t,this.normalized=n,this.usage=b,this.updateRanges=[],this.gpuType=s,this.version=0}onUploadCallback(){}set needsUpdate(e){e===!0&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let r=0,i=this.itemSize;r<i;r++)this.array[e+r]=t.array[n+r];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(this.itemSize===2)for(let t=0,n=this.count;t<n;t++)Wt.fromBufferAttribute(this,t),Wt.applyMatrix3(e),this.setXY(t,Wt.x,Wt.y);else if(this.itemSize===3)for(let t=0,n=this.count;t<n;t++)q.fromBufferAttribute(this,t),q.applyMatrix3(e),this.setXYZ(t,q.x,q.y,q.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)q.fromBufferAttribute(this,t),q.applyMatrix4(e),this.setXYZ(t,q.x,q.y,q.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)q.fromBufferAttribute(this,t),q.applyNormalMatrix(e),this.setXYZ(t,q.x,q.y,q.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)q.fromBufferAttribute(this,t),q.transformDirection(e),this.setXYZ(t,q.x,q.y,q.z);return this}set(e,t=0){return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=ve(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=R(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=ve(t,this.array)),t}setX(e,t){return this.normalized&&(t=R(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=ve(t,this.array)),t}setY(e,t){return this.normalized&&(t=R(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=ve(t,this.array)),t}setZ(e,t){return this.normalized&&(t=R(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=ve(t,this.array)),t}setW(e,t){return this.normalized&&(t=R(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=R(t,this.array),n=R(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,r){return e*=this.itemSize,this.normalized&&(t=R(t,this.array),n=R(n,this.array),r=R(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this}setXYZW(e,t,n,r,i){return e*=this.itemSize,this.normalized&&(t=R(t,this.array),n=R(n,this.array),r=R(r,this.array),i=R(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this.array[e+3]=i,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){let e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return e.name=this.name,e.usage=this.usage,e.gpuType=this.gpuType,e}dispose(){this.dispatchEvent({type:`dispose`})}},qt=class extends Kt{constructor(e,t,n){super(new Uint16Array(e),t,n)}},Jt=class extends Kt{constructor(e,t,n){super(new Uint32Array(e),t,n)}},Yt=class extends Kt{constructor(e,t,n){super(new Float32Array(e),t,n)}};let Xt=/*@__PURE__*/ new kt,Zt=/*@__PURE__*/ new B,Qt=/*@__PURE__*/ new B;var $t=class{constructor(e=new B,t=-1){this.isSphere=!0,this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){let n=this.center;t===void 0?Xt.setFromPoints(e).getCenter(n):n.copy(t);let r=0;for(let t=0,i=e.length;t<i;t++)r=Math.max(r,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(r),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){let t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){let n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius*=e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;Zt.subVectors(e,this.center);let t=Zt.lengthSq();if(t>this.radius*this.radius){let e=Math.sqrt(t),n=(e-this.radius)*.5;this.center.addScaledVector(Zt,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(this.center.equals(e.center)===!0?this.radius=Math.max(this.radius,e.radius):(Qt.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(Zt.copy(e.center).add(Qt)),this.expandByPoint(Zt.copy(e.center).sub(Qt))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return new this.constructor().copy(this)}toJSON(){return{radius:this.radius,center:this.center.toArray()}}fromJSON(e){return this.radius=e.radius,this.center.fromArray(e.center),this}};let en=0,tn=/*@__PURE__*/ new H,nn=/*@__PURE__*/ new W,rn=/*@__PURE__*/ new B,J=/*@__PURE__*/ new kt,an=/*@__PURE__*/ new kt,Y=/*@__PURE__*/ new B;var on=class e extends j{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,\"id\",{value:en++}),this.uuid=I(),this.name=``,this.type=`BufferGeometry`,this.index=null,this.indirect=null,this.indirectOffset=0,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={},this._transformed=!1}getIndex(){return this.index}setIndex(e){return this.index=Array.isArray(e)?new(S(e)?Jt:qt)(e,1):e,this}setIndirect(e,t=0){return this.indirect=e,this.indirectOffset=t,this}getIndirect(){return this.indirect}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return this.attributes[e]!==void 0}addGroup(e,t,n=0){this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){let t=this.attributes.position;t!==void 0&&(t.applyMatrix4(e),t.needsUpdate=!0);let n=this.attributes.normal;if(n!==void 0){let t=new Ce().getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}let r=this.attributes.tangent;return r!==void 0&&(r.transformDirection(e),r.needsUpdate=!0),this.boundingBox!==null&&this.computeBoundingBox(),this.boundingSphere!==null&&this.computeBoundingSphere(),this._transformed=!0,this}applyQuaternion(e){return tn.makeRotationFromQuaternion(e),this.applyMatrix4(tn),this}rotateX(e){return tn.makeRotationX(e),this.applyMatrix4(tn),this}rotateY(e){return tn.makeRotationY(e),this.applyMatrix4(tn),this}rotateZ(e){return tn.makeRotationZ(e),this.applyMatrix4(tn),this}translate(e,t,n){return tn.makeTranslation(e,t,n),this.applyMatrix4(tn),this}scale(e,t,n){return tn.makeScale(e,t,n),this.applyMatrix4(tn),this}lookAt(e){return nn.lookAt(e),nn.updateMatrix(),this.applyMatrix4(nn.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter(rn).negate(),this.translate(rn.x,rn.y,rn.z),this}setFromPoints(e){let t=this.getAttribute(`position`);if(t===void 0){let t=[];for(let n=0,r=e.length;n<r;n++){let r=e[n];t.push(r.x,r.y,r.z||0)}this.setAttribute(`position`,new Yt(t,3))}else{let n=Math.min(e.length,t.count);for(let r=0;r<n;r++){let n=e[r];t.setXYZ(r,n.x,n.y,n.z||0)}e.length>t.count&&O(`BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.`),t.needsUpdate=!0}return this}computeBoundingBox(){this.boundingBox===null&&(this.boundingBox=new kt);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){k(`BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.`,this),this.boundingBox.set(new B(-1/0,-1/0,-1/0),new B(1/0,1/0,1/0));return}if(e!==void 0){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];J.setFromBufferAttribute(n),this.morphTargetsRelative?(Y.addVectors(this.boundingBox.min,J.min),this.boundingBox.expandByPoint(Y),Y.addVectors(this.boundingBox.max,J.max),this.boundingBox.expandByPoint(Y)):(this.boundingBox.expandByPoint(J.min),this.boundingBox.expandByPoint(J.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&k(`BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.`,this)}computeBoundingSphere(){this.boundingSphere===null&&(this.boundingSphere=new $t);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){k(`BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.`,this),this.boundingSphere.set(new B,1/0);return}if(e){let n=this.boundingSphere.center;if(J.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];an.setFromBufferAttribute(n),this.morphTargetsRelative?(Y.addVectors(J.min,an.min),J.expandByPoint(Y),Y.addVectors(J.max,an.max),J.expandByPoint(Y)):(J.expandByPoint(an.min),J.expandByPoint(an.max))}J.getCenter(n);let r=0;for(let t=0,i=e.count;t<i;t++)Y.fromBufferAttribute(e,t),r=Math.max(r,n.distanceToSquared(Y));if(t)for(let i=0,a=t.length;i<a;i++){let a=t[i],o=this.morphTargetsRelative;for(let t=0,i=a.count;t<i;t++)Y.fromBufferAttribute(a,t),o&&(rn.fromBufferAttribute(e,t),Y.add(rn)),r=Math.max(r,n.distanceToSquared(Y))}this.boundingSphere.radius=Math.sqrt(r),isNaN(this.boundingSphere.radius)&&k(`BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.`,this)}}computeTangents(){let e=this.index,t=this.attributes;if(e===null||t.position===void 0||t.normal===void 0||t.uv===void 0){k(`BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)`);return}let n=t.position,r=t.normal,i=t.uv,a=this.getAttribute(`tangent`);(a===void 0||a.count!==n.count)&&(a=new Kt(new Float32Array(4*n.count),4),this.setAttribute(`tangent`,a));let o=[],s=[];for(let e=0;e<n.count;e++)o[e]=new B,s[e]=new B;let c=new B,l=new B,u=new B,d=new z,f=new z,p=new z,m=new B,h=new B;function g(e,t,r){c.fromBufferAttribute(n,e),l.fromBufferAttribute(n,t),u.fromBufferAttribute(n,r),d.fromBufferAttribute(i,e),f.fromBufferAttribute(i,t),p.fromBufferAttribute(i,r),l.sub(c),u.sub(c),f.sub(d),p.sub(d);let a=1/(f.x*p.y-p.x*f.y);isFinite(a)&&(m.copy(l).multiplyScalar(p.y).addScaledVector(u,-f.y).multiplyScalar(a),h.copy(u).multiplyScalar(f.x).addScaledVector(l,-p.x).multiplyScalar(a),o[e].add(m),o[t].add(m),o[r].add(m),s[e].add(h),s[t].add(h),s[r].add(h))}let _=this.groups;_.length===0&&(_=[{start:0,count:e.count}]);for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)g(e.getX(t+0),e.getX(t+1),e.getX(t+2))}let v=new B,y=new B,b=new B,x=new B;function S(e){b.fromBufferAttribute(r,e),x.copy(b);let t=o[e];v.copy(t),v.sub(b.multiplyScalar(b.dot(t))).normalize(),y.crossVectors(x,t);let n=y.dot(s[e])<0?-1:1;a.setXYZW(e,v.x,v.y,v.z,n)}for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)S(e.getX(t+0)),S(e.getX(t+1)),S(e.getX(t+2))}this._transformed=!0}computeVertexNormals(){let e=this.index,t=this.getAttribute(`position`);if(t!==void 0){let n=this.getAttribute(`normal`);if(n===void 0||n.count!==t.count)n=new Kt(new Float32Array(t.count*3),3),this.setAttribute(`normal`,n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);let r=new B,i=new B,a=new B,o=new B,s=new B,c=new B,l=new B,u=new B;if(e)for(let d=0,f=e.count;d<f;d+=3){let f=e.getX(d+0),p=e.getX(d+1),m=e.getX(d+2);r.fromBufferAttribute(t,f),i.fromBufferAttribute(t,p),a.fromBufferAttribute(t,m),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),o.fromBufferAttribute(n,f),s.fromBufferAttribute(n,p),c.fromBufferAttribute(n,m),o.add(l),s.add(l),c.add(l),n.setXYZ(f,o.x,o.y,o.z),n.setXYZ(p,s.x,s.y,s.z),n.setXYZ(m,c.x,c.y,c.z)}else for(let e=0,o=t.count;e<o;e+=3)r.fromBufferAttribute(t,e+0),i.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),n.setXYZ(e+0,l.x,l.y,l.z),n.setXYZ(e+1,l.x,l.y,l.z),n.setXYZ(e+2,l.x,l.y,l.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){let e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)Y.fromBufferAttribute(e,t),Y.normalize(),e.setXYZ(t,Y.x,Y.y,Y.z)}toNonIndexed(){function t(e,t){let n=e.array,r=e.itemSize,i=e.normalized,a=new n.constructor(t.length*r),o=0,s=0;for(let i=0,c=t.length;i<c;i++){o=e.isInterleavedBufferAttribute?t[i]*e.data.stride+e.offset:t[i]*r;for(let e=0;e<r;e++)a[s++]=n[o++]}return new Kt(a,r,i)}if(this.index===null)return O(`BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.`),this;let n=new e,r=this.index.array,i=this.attributes;for(let e in i){let a=i[e],o=t(a,r);n.setAttribute(e,o)}let a=this.morphAttributes;for(let e in a){let i=[],o=a[e];for(let e=0,n=o.length;e<n;e++){let n=o[e],a=t(n,r);i.push(a)}n.morphAttributes[e]=i}n.morphTargetsRelative=this.morphTargetsRelative;let o=this.groups;for(let e=0,t=o.length;e<t;e++){let t=o[e];n.addGroup(t.start,t.count,t.materialIndex)}return n}toJSON(){let e={metadata:{version:4.7,type:`BufferGeometry`,generator:`BufferGeometry.toJSON`}};if(e.uuid=this.uuid,e.type=this.parameters!==void 0&&this._transformed===!0?`BufferGeometry`:this.type,e.name=this.name,Object.keys(this.userData).length>0&&(e.userData=this.userData),this.parameters!==void 0&&this._transformed!==!0){let t=this.parameters;for(let n in t)t[n]!==void 0&&(e[n]=t[n]);return e}e.data={attributes:{}};let t=this.index;t!==null&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});let n=this.attributes;for(let t in n){let r=n[t];e.data.attributes[t]=r.toJSON(e.data)}let r={},i=!1;for(let t in this.morphAttributes){let n=this.morphAttributes[t],a=[];for(let t=0,r=n.length;t<r;t++){let r=n[t];a.push(r.toJSON(e.data))}a.length>0&&(r[t]=a,i=!0)}i&&(e.data.morphAttributes=r,e.data.morphTargetsRelative=this.morphTargetsRelative);let a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));let o=this.boundingSphere;return o!==null&&(e.data.boundingSphere=o.toJSON()),e}clone(){return new this.constructor().copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;let t={};this.name=e.name;let n=e.index;n!==null&&this.setIndex(n.clone());let r=e.attributes;for(let e in r){let n=r[e];this.setAttribute(e,n.clone(t))}let i=e.morphAttributes;for(let e in i){let n=[],r=i[e];for(let e=0,i=r.length;e<i;e++)n.push(r[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;let a=e.groups;for(let e=0,t=a.length;e<t;e++){let t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}let o=e.boundingBox;o!==null&&(this.boundingBox=o.clone());let s=e.boundingSphere;return s!==null&&(this.boundingSphere=s.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this._transformed=e._transformed,this}dispose(){this.dispatchEvent({type:`dispose`})}},sn=class{constructor(e,t){this.isInterleavedBuffer=!0,this.array=e,this.stride=t,this.count=e===void 0?0:e.length/t,this.usage=b,this.updateRanges=[],this.version=0,this.uuid=I()}onUploadCallback(){}set needsUpdate(e){e===!0&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.array=new e.array.constructor(e.array),this.count=e.count,this.stride=e.stride,this.usage=e.usage,this}copyAt(e,t,n){e*=this.stride,n*=t.stride;for(let r=0,i=this.stride;r<i;r++)this.array[e+r]=t.array[n+r];return this}set(e,t=0){return this.array.set(e,t),this}clone(e){e.arrayBuffers===void 0&&(e.arrayBuffers={}),this.array.buffer._uuid===void 0&&(this.array.buffer._uuid=I()),e.arrayBuffers[this.array.buffer._uuid]===void 0&&(e.arrayBuffers[this.array.buffer._uuid]=this.array.slice(0).buffer);let t=new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]),n=new this.constructor(t,this.stride);return n.setUsage(this.usage),n}onUpload(e){return this.onUploadCallback=e,this}toJSON(e){e.arrayBuffers===void 0&&(e.arrayBuffers={}),this.array.buffer._uuid===void 0&&(this.array.buffer._uuid=I()),e.arrayBuffers[this.array.buffer._uuid]===void 0&&(e.arrayBuffers[this.array.buffer._uuid]=Array.from(new Uint32Array(this.array.buffer)));let t={uuid:this.uuid,buffer:this.array.buffer._uuid,type:this.array.constructor.name,stride:this.stride};return t.usage=this.usage,t}};let X=/*@__PURE__*/ new B;var cn=class e{constructor(e,t,n,r=!1){this.isInterleavedBufferAttribute=!0,this.name=``,this.data=e,this.itemSize=t,this.offset=n,this.normalized=r}get count(){return this.data.count}get array(){return this.data.array}set needsUpdate(e){this.data.needsUpdate=e}applyMatrix4(e){for(let t=0,n=this.data.count;t<n;t++)X.fromBufferAttribute(this,t),X.applyMatrix4(e),this.setXYZ(t,X.x,X.y,X.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)X.fromBufferAttribute(this,t),X.applyNormalMatrix(e),this.setXYZ(t,X.x,X.y,X.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)X.fromBufferAttribute(this,t),X.transformDirection(e),this.setXYZ(t,X.x,X.y,X.z);return this}getComponent(e,t){let n=this.array[e*this.data.stride+this.offset+t];return this.normalized&&(n=ve(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=R(n,this.array)),this.data.array[e*this.data.stride+this.offset+t]=n,this}setX(e,t){return this.normalized&&(t=R(t,this.array)),this.data.array[e*this.data.stride+this.offset]=t,this}setY(e,t){return this.normalized&&(t=R(t,this.array)),this.data.array[e*this.data.stride+this.offset+1]=t,this}setZ(e,t){return this.normalized&&(t=R(t,this.array)),this.data.array[e*this.data.stride+this.offset+2]=t,this}setW(e,t){return this.normalized&&(t=R(t,this.array)),this.data.array[e*this.data.stride+this.offset+3]=t,this}getX(e){let t=this.data.array[e*this.data.stride+this.offset];return this.normalized&&(t=ve(t,this.array)),t}getY(e){let t=this.data.array[e*this.data.stride+this.offset+1];return this.normalized&&(t=ve(t,this.array)),t}getZ(e){let t=this.data.array[e*this.data.stride+this.offset+2];return this.normalized&&(t=ve(t,this.array)),t}getW(e){let t=this.data.array[e*this.data.stride+this.offset+3];return this.normalized&&(t=ve(t,this.array)),t}setXY(e,t,n){return e=e*this.data.stride+this.offset,this.normalized&&(t=R(t,this.array),n=R(n,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=n,this}setXYZ(e,t,n,r){return e=e*this.data.stride+this.offset,this.normalized&&(t=R(t,this.array),n=R(n,this.array),r=R(r,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=n,this.data.array[e+2]=r,this}setXYZW(e,t,n,r,i){return e=e*this.data.stride+this.offset,this.normalized&&(t=R(t,this.array),n=R(n,this.array),r=R(r,this.array),i=R(i,this.array)),this.data.array[e+0]=t,this.data.array[e+1]=n,this.data.array[e+2]=r,this.data.array[e+3]=i,this}clone(t){if(t===void 0){E(`InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.`);let e=[];for(let t=0;t<this.count;t++){let n=t*this.data.stride+this.offset;for(let t=0;t<this.itemSize;t++)e.push(this.data.array[n+t])}return new Kt(new this.array.constructor(e),this.itemSize,this.normalized)}return t.interleavedBuffers===void 0&&(t.interleavedBuffers={}),t.interleavedBuffers[this.data.uuid]===void 0&&(t.interleavedBuffers[this.data.uuid]=this.data.clone(t)),new e(t.interleavedBuffers[this.data.uuid],this.itemSize,this.offset,this.normalized)}toJSON(e){if(e===void 0){E(`InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.`);let e=[];for(let t=0;t<this.count;t++){let n=t*this.data.stride+this.offset;for(let t=0;t<this.itemSize;t++)e.push(this.data.array[n+t])}return{itemSize:this.itemSize,type:this.array.constructor.name,array:e,normalized:this.normalized}}return e.interleavedBuffers===void 0&&(e.interleavedBuffers={}),e.interleavedBuffers[this.data.uuid]===void 0&&(e.interleavedBuffers[this.data.uuid]=this.data.toJSON(e)),{isInterleavedBufferAttribute:!0,itemSize:this.itemSize,data:this.data.uuid,offset:this.offset,normalized:this.normalized}}};let ln=/*@__PURE__*/ new B,un=/*@__PURE__*/ new B,dn=/*@__PURE__*/ new Ce;var fn=class{constructor(e=new B(1,0,0),t=0){this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,r){return this.normal.set(e,t,n),this.constant=r,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){let r=ln.subVectors(n,t).cross(un.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(r,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){let e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t,n=!0){let r=e.delta(ln),i=this.normal.dot(r);if(i===0)return this.distanceToPoint(e.start)===0?t.copy(e.start):null;let a=-(e.start.dot(this.normal)+this.constant)/i;return n===!0&&(a<0||a>1)?null:t.copy(e.start).addScaledVector(r,a)}intersectsLine(e){let t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){let n=t||dn.getNormalMatrix(e),r=this.coplanarPoint(ln).applyMatrix4(e),i=this.normal.applyMatrix3(n).normalize();return this.constant=-r.dot(i),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return new this.constructor().copy(this)}toJSON(){return{normal:this.normal.toArray(),constant:this.constant}}fromJSON(e){return this.normal.fromArray(e.normal),this.constant=e.constant,this}};let pn=0;var mn=class extends j{constructor(){super(),this.isMaterial=!0,Object.defineProperty(this,\"id\",{value:pn++}),this.uuid=I(),this.name=``,this.type=`Material`,this.blending=1,this.side=0,this.vertexColors=!1,this.opacity=1,this.transparent=!1,this.alphaHash=!1,this.blendSrc=204,this.blendDst=205,this.blendEquation=100,this.blendSrcAlpha=null,this.blendDstAlpha=null,this.blendEquationAlpha=null,this.blendColor=new G(0,0,0),this.blendAlpha=0,this.depthFunc=3,this.depthTest=!0,this.depthWrite=!0,this.stencilWriteMask=255,this.stencilFunc=519,this.stencilRef=0,this.stencilFuncMask=255,this.stencilFail=y,this.stencilZFail=y,this.stencilZPass=y,this.stencilWrite=!1,this.clippingPlanes=null,this.clipIntersection=!1,this.clipShadows=!1,this.shadowSide=null,this.colorWrite=!0,this.precision=null,this.polygonOffset=!1,this.polygonOffsetFactor=0,this.polygonOffsetUnits=0,this.dithering=!1,this.alphaToCoverage=!1,this.premultipliedAlpha=!1,this.forceSinglePass=!1,this.allowOverride=!0,this.visible=!0,this.toneMapped=!0,this.userData={},this.version=0,this._alphaTest=0}get alphaTest(){return this._alphaTest}set alphaTest(e){this._alphaTest>0!=e>0&&this.version++,this._alphaTest=e}onBeforeRender(){}onBeforeCompile(){}customProgramCacheKey(){return this.onBeforeCompile.toString()}setValues(e){if(e!==void 0)for(let t in e){let n=e[t];if(n===void 0){O(`Material: parameter '${t}' has value of undefined.`);continue}let r=this[t];if(r===void 0){O(`Material: '${t}' is not a property of THREE.${this.type}.`);continue}r&&r.isColor?r.set(n):r&&r.isVector2&&n&&n.isVector2||r&&r.isEuler&&n&&n.isEuler||r&&r.isVector3&&n&&n.isVector3?r.copy(n):this[t]=n}}toJSON(e){let t=e===void 0||typeof e==`string`;t&&(e={textures:{},images:{}});let n={metadata:{version:4.7,type:`Material`,generator:`Material.toJSON`}};n.uuid=this.uuid,n.type=this.type,n.blending=this.blending,n.side=this.side,n.shadowSide=this.shadowSide,n.vertexColors=this.vertexColors,n.opacity=this.opacity,n.transparent=this.transparent,n.blendSrc=this.blendSrc,n.blendDst=this.blendDst,n.blendEquation=this.blendEquation,n.blendSrcAlpha=this.blendSrcAlpha,n.blendDstAlpha=this.blendDstAlpha,n.blendEquationAlpha=this.blendEquationAlpha,n.blendColor=this.blendColor.getHex(),n.blendAlpha=this.blendAlpha,n.depthFunc=this.depthFunc,n.depthTest=this.depthTest,n.depthWrite=this.depthWrite,n.colorWrite=this.colorWrite,n.clipIntersection=this.clipIntersection,n.clipShadows=this.clipShadows,n.stencilWriteMask=this.stencilWriteMask,n.stencilFunc=this.stencilFunc,n.stencilRef=this.stencilRef,n.stencilFuncMask=this.stencilFuncMask,n.stencilFail=this.stencilFail,n.stencilZFail=this.stencilZFail,n.stencilZPass=this.stencilZPass,n.stencilWrite=this.stencilWrite,n.polygonOffset=this.polygonOffset,n.polygonOffsetFactor=this.polygonOffsetFactor,n.polygonOffsetUnits=this.polygonOffsetUnits,n.dithering=this.dithering,n.alphaTest=this.alphaTest,n.alphaHash=this.alphaHash,n.alphaToCoverage=this.alphaToCoverage,n.premultipliedAlpha=this.premultipliedAlpha,n.forceSinglePass=this.forceSinglePass,n.allowOverride=this.allowOverride,n.visible=this.visible,n.toneMapped=this.toneMapped,n.name=this.name,this.color&&this.color.isColor&&(n.color=this.color.getHex()),this.roughness!==void 0&&(n.roughness=this.roughness),this.metalness!==void 0&&(n.metalness=this.metalness),this.sheen!==void 0&&(n.sheen=this.sheen),this.sheenColor&&this.sheenColor.isColor&&(n.sheenColor=this.sheenColor.getHex()),this.sheenRoughness!==void 0&&(n.sheenRoughness=this.sheenRoughness),this.emissive&&this.emissive.isColor&&(n.emissive=this.emissive.getHex()),this.emissiveIntensity!==void 0&&(n.emissiveIntensity=this.emissiveIntensity),this.specular&&this.specular.isColor&&(n.specular=this.specular.getHex()),this.specularIntensity!==void 0&&(n.specularIntensity=this.specularIntensity),this.specularColor&&this.specularColor.isColor&&(n.specularColor=this.specularColor.getHex()),this.shininess!==void 0&&(n.shininess=this.shininess),this.clearcoat!==void 0&&(n.clearcoat=this.clearcoat),this.clearcoatRoughness!==void 0&&(n.clearcoatRoughness=this.clearcoatRoughness),this.clearcoatMap&&this.clearcoatMap.isTexture&&(n.clearcoatMap=this.clearcoatMap.toJSON(e).uuid),this.clearcoatRoughnessMap&&this.clearcoatRoughnessMap.isTexture&&(n.clearcoatRoughnessMap=this.clearcoatRoughnessMap.toJSON(e).uuid),this.clearcoatNormalMap&&this.clearcoatNormalMap.isTexture&&(n.clearcoatNormalMap=this.clearcoatNormalMap.toJSON(e).uuid,n.clearcoatNormalScale=this.clearcoatNormalScale.toArray()),this.sheenColorMap&&this.sheenColorMap.isTexture&&(n.sheenColorMap=this.sheenColorMap.toJSON(e).uuid),this.sheenRoughnessMap&&this.sheenRoughnessMap.isTexture&&(n.sheenRoughnessMap=this.sheenRoughnessMap.toJSON(e).uuid),this.dispersion!==void 0&&(n.dispersion=this.dispersion),this.retroreflectivity!==void 0&&(n.retroreflectivity=this.retroreflectivity),this.iridescence!==void 0&&(n.iridescence=this.iridescence),this.iridescenceIOR!==void 0&&(n.iridescenceIOR=this.iridescenceIOR),this.iridescenceThicknessRange!==void 0&&(n.iridescenceThicknessRange=this.iridescenceThicknessRange),this.iridescenceMap&&this.iridescenceMap.isTexture&&(n.iridescenceMap=this.iridescenceMap.toJSON(e).uuid),this.iridescenceThicknessMap&&this.iridescenceThicknessMap.isTexture&&(n.iridescenceThicknessMap=this.iridescenceThicknessMap.toJSON(e).uuid),this.anisotropy!==void 0&&(n.anisotropy=this.anisotropy),this.anisotropyRotation!==void 0&&(n.anisotropyRotation=this.anisotropyRotation),this.anisotropyMap&&this.anisotropyMap.isTexture&&(n.anisotropyMap=this.anisotropyMap.toJSON(e).uuid),this.map&&this.map.isTexture&&(n.map=this.map.toJSON(e).uuid),this.matcap&&this.matcap.isTexture&&(n.matcap=this.matcap.toJSON(e).uuid),this.alphaMap&&this.alphaMap.isTexture&&(n.alphaMap=this.alphaMap.toJSON(e).uuid),this.lightMap&&this.lightMap.isTexture&&(n.lightMap=this.lightMap.toJSON(e).uuid,n.lightMapIntensity=this.lightMapIntensity),this.aoMap&&this.aoMap.isTexture&&(n.aoMap=this.aoMap.toJSON(e).uuid,n.aoMapIntensity=this.aoMapIntensity),this.bumpMap&&this.bumpMap.isTexture&&(n.bumpMap=this.bumpMap.toJSON(e).uuid,n.bumpScale=this.bumpScale),this.normalMap&&this.normalMap.isTexture&&(n.normalMap=this.normalMap.toJSON(e).uuid,n.normalMapType=this.normalMapType,n.normalScale=this.normalScale.toArray()),this.displacementMap&&this.displacementMap.isTexture&&(n.displacementMap=this.displacementMap.toJSON(e).uuid,n.displacementScale=this.displacementScale,n.displacementBias=this.displacementBias),this.roughnessMap&&this.roughnessMap.isTexture&&(n.roughnessMap=this.roughnessMap.toJSON(e).uuid),this.metalnessMap&&this.metalnessMap.isTexture&&(n.metalnessMap=this.metalnessMap.toJSON(e).uuid),this.emissiveMap&&this.emissiveMap.isTexture&&(n.emissiveMap=this.emissiveMap.toJSON(e).uuid),this.specularMap&&this.specularMap.isTexture&&(n.specularMap=this.specularMap.toJSON(e).uuid),this.specularIntensityMap&&this.specularIntensityMap.isTexture&&(n.specularIntensityMap=this.specularIntensityMap.toJSON(e).uuid),this.specularColorMap&&this.specularColorMap.isTexture&&(n.specularColorMap=this.specularColorMap.toJSON(e).uuid),this.envMap&&this.envMap.isTexture&&(n.envMap=this.envMap.toJSON(e).uuid,this.combine!==void 0&&(n.combine=this.combine)),this.envMapRotation!==void 0&&(n.envMapRotation=this.envMapRotation.toArray()),this.envMapIntensity!==void 0&&(n.envMapIntensity=this.envMapIntensity),this.reflectivity!==void 0&&(n.reflectivity=this.reflectivity),this.refractionRatio!==void 0&&(n.refractionRatio=this.refractionRatio),this.gradientMap&&this.gradientMap.isTexture&&(n.gradientMap=this.gradientMap.toJSON(e).uuid),this.transmission!==void 0&&(n.transmission=this.transmission),this.transmissionMap&&this.transmissionMap.isTexture&&(n.transmissionMap=this.transmissionMap.toJSON(e).uuid),this.thickness!==void 0&&(n.thickness=this.thickness),this.thicknessMap&&this.thicknessMap.isTexture&&(n.thicknessMap=this.thicknessMap.toJSON(e).uuid),this.attenuationDistance!==void 0&&(n.attenuationDistance=this.attenuationDistance),this.attenuationColor!==void 0&&(n.attenuationColor=this.attenuationColor.getHex()),this.size!==void 0&&(n.size=this.size),this.sizeAttenuation!==void 0&&(n.sizeAttenuation=this.sizeAttenuation),Array.isArray(this.clippingPlanes)&&this.clippingPlanes.length>0&&(n.clippingPlanes=this.clippingPlanes.map(e=>e.toJSON())),this.rotation!==void 0&&(n.rotation=this.rotation),this.depthPacking!==void 0&&(n.depthPacking=this.depthPacking),this.linewidth!==void 0&&(n.linewidth=this.linewidth),this.linecap!==void 0&&(n.linecap=this.linecap),this.linejoin!==void 0&&(n.linejoin=this.linejoin),this.dashSize!==void 0&&(n.dashSize=this.dashSize),this.gapSize!==void 0&&(n.gapSize=this.gapSize),this.scale!==void 0&&(n.scale=this.scale),this.wireframe!==void 0&&(n.wireframe=this.wireframe),this.wireframeLinewidth!==void 0&&(n.wireframeLinewidth=this.wireframeLinewidth),this.wireframeLinecap!==void 0&&(n.wireframeLinecap=this.wireframeLinecap),this.wireframeLinejoin!==void 0&&(n.wireframeLinejoin=this.wireframeLinejoin),this.flatShading!==void 0&&(n.flatShading=this.flatShading),this.fog!==void 0&&(n.fog=this.fog),Object.keys(this.userData).length>0&&(n.userData=this.userData);function r(e){let t=[];for(let n in e){let r=e[n];delete r.metadata,t.push(r)}return t}if(t){let t=r(e.textures),i=r(e.images);t.length>0&&(n.textures=t),i.length>0&&(n.images=i)}return n}fromJSON(e,t){if(e.uuid!==void 0&&(this.uuid=e.uuid),e.name!==void 0&&(this.name=e.name),e.color!==void 0&&this.color!==void 0&&this.color.setHex(e.color),e.roughness!==void 0&&(this.roughness=e.roughness),e.metalness!==void 0&&(this.metalness=e.metalness),e.sheen!==void 0&&(this.sheen=e.sheen),e.sheenColor!==void 0&&(this.sheenColor=new G().setHex(e.sheenColor)),e.sheenRoughness!==void 0&&(this.sheenRoughness=e.sheenRoughness),e.emissive!==void 0&&this.emissive!==void 0&&this.emissive.setHex(e.emissive),e.specular!==void 0&&this.specular!==void 0&&this.specular.setHex(e.specular),e.specularIntensity!==void 0&&(this.specularIntensity=e.specularIntensity),e.specularColor!==void 0&&this.specularColor!==void 0&&this.specularColor.setHex(e.specularColor),e.shininess!==void 0&&(this.shininess=e.shininess),e.clearcoat!==void 0&&(this.clearcoat=e.clearcoat),e.clearcoatRoughness!==void 0&&(this.clearcoatRoughness=e.clearcoatRoughness),e.dispersion!==void 0&&(this.dispersion=e.dispersion),e.retroreflectivity!==void 0&&(this.retroreflectivity=e.retroreflectivity),e.iridescence!==void 0&&(this.iridescence=e.iridescence),e.iridescenceIOR!==void 0&&(this.iridescenceIOR=e.iridescenceIOR),e.iridescenceThicknessRange!==void 0&&(this.iridescenceThicknessRange=e.iridescenceThicknessRange),e.transmission!==void 0&&(this.transmission=e.transmission),e.thickness!==void 0&&(this.thickness=e.thickness),e.attenuationDistance!==void 0&&(this.attenuationDistance=e.attenuationDistance),e.attenuationColor!==void 0&&this.attenuationColor!==void 0&&this.attenuationColor.setHex(e.attenuationColor),e.anisotropy!==void 0&&(this.anisotropy=e.anisotropy),e.anisotropyRotation!==void 0&&(this.anisotropyRotation=e.anisotropyRotation),e.fog!==void 0&&(this.fog=e.fog),e.flatShading!==void 0&&(this.flatShading=e.flatShading),e.blending!==void 0&&(this.blending=e.blending),e.combine!==void 0&&(this.combine=e.combine),e.side!==void 0&&(this.side=e.side),e.shadowSide!==void 0&&(this.shadowSide=e.shadowSide),e.opacity!==void 0&&(this.opacity=e.opacity),e.transparent!==void 0&&(this.transparent=e.transparent),e.alphaTest!==void 0&&(this.alphaTest=e.alphaTest),e.alphaHash!==void 0&&(this.alphaHash=e.alphaHash),e.depthFunc!==void 0&&(this.depthFunc=e.depthFunc),e.depthTest!==void 0&&(this.depthTest=e.depthTest),e.depthWrite!==void 0&&(this.depthWrite=e.depthWrite),e.colorWrite!==void 0&&(this.colorWrite=e.colorWrite),e.clippingPlanes!==void 0&&(this.clippingPlanes=e.clippingPlanes.map(e=>new fn().fromJSON(e))),e.clipIntersection!==void 0&&(this.clipIntersection=e.clipIntersection),e.clipShadows!==void 0&&(this.clipShadows=e.clipShadows),e.depthPacking!==void 0&&(this.depthPacking=e.depthPacking),e.blendSrc!==void 0&&(this.blendSrc=e.blendSrc),e.blendDst!==void 0&&(this.blendDst=e.blendDst),e.blendEquation!==void 0&&(this.blendEquation=e.blendEquation),e.blendSrcAlpha!==void 0&&(this.blendSrcAlpha=e.blendSrcAlpha),e.blendDstAlpha!==void 0&&(this.blendDstAlpha=e.blendDstAlpha),e.blendEquationAlpha!==void 0&&(this.blendEquationAlpha=e.blendEquationAlpha),e.blendColor!==void 0&&this.blendColor!==void 0&&this.blendColor.setHex(e.blendColor),e.blendAlpha!==void 0&&(this.blendAlpha=e.blendAlpha),e.stencilWriteMask!==void 0&&(this.stencilWriteMask=e.stencilWriteMask),e.stencilFunc!==void 0&&(this.stencilFunc=e.stencilFunc),e.stencilRef!==void 0&&(this.stencilRef=e.stencilRef),e.stencilFuncMask!==void 0&&(this.stencilFuncMask=e.stencilFuncMask),e.stencilFail!==void 0&&(this.stencilFail=e.stencilFail),e.stencilZFail!==void 0&&(this.stencilZFail=e.stencilZFail),e.stencilZPass!==void 0&&(this.stencilZPass=e.stencilZPass),e.stencilWrite!==void 0&&(this.stencilWrite=e.stencilWrite),e.wireframe!==void 0&&(this.wireframe=e.wireframe),e.wireframeLinewidth!==void 0&&(this.wireframeLinewidth=e.wireframeLinewidth),e.wireframeLinecap!==void 0&&(this.wireframeLinecap=e.wireframeLinecap),e.wireframeLinejoin!==void 0&&(this.wireframeLinejoin=e.wireframeLinejoin),e.rotation!==void 0&&(this.rotation=e.rotation),e.linewidth!==void 0&&(this.linewidth=e.linewidth),e.linecap!==void 0&&(this.linecap=e.linecap),e.linejoin!==void 0&&(this.linejoin=e.linejoin),e.dashSize!==void 0&&(this.dashSize=e.dashSize),e.gapSize!==void 0&&(this.gapSize=e.gapSize),e.scale!==void 0&&(this.scale=e.scale),e.polygonOffset!==void 0&&(this.polygonOffset=e.polygonOffset),e.polygonOffsetFactor!==void 0&&(this.polygonOffsetFactor=e.polygonOffsetFactor),e.polygonOffsetUnits!==void 0&&(this.polygonOffsetUnits=e.polygonOffsetUnits),e.dithering!==void 0&&(this.dithering=e.dithering),e.alphaToCoverage!==void 0&&(this.alphaToCoverage=e.alphaToCoverage),e.premultipliedAlpha!==void 0&&(this.premultipliedAlpha=e.premultipliedAlpha),e.forceSinglePass!==void 0&&(this.forceSinglePass=e.forceSinglePass),e.allowOverride!==void 0&&(this.allowOverride=e.allowOverride),e.visible!==void 0&&(this.visible=e.visible),e.toneMapped!==void 0&&(this.toneMapped=e.toneMapped),e.userData!==void 0&&(this.userData=e.userData),e.vertexColors!==void 0&&(this.vertexColors=typeof e.vertexColors==`number`?e.vertexColors>0:e.vertexColors),e.size!==void 0&&(this.size=e.size),e.sizeAttenuation!==void 0&&(this.sizeAttenuation=e.sizeAttenuation),e.map!==void 0&&(this.map=t[e.map]||null),e.matcap!==void 0&&(this.matcap=t[e.matcap]||null),e.alphaMap!==void 0&&(this.alphaMap=t[e.alphaMap]||null),e.bumpMap!==void 0&&(this.bumpMap=t[e.bumpMap]||null),e.bumpScale!==void 0&&(this.bumpScale=e.bumpScale),e.normalMap!==void 0&&(this.normalMap=t[e.normalMap]||null),e.normalMapType!==void 0&&(this.normalMapType=e.normalMapType),e.normalScale!==void 0){let t=e.normalScale;Array.isArray(t)===!1&&(t=[t,t]),this.normalScale=new z().fromArray(t)}return e.displacementMap!==void 0&&(this.displacementMap=t[e.displacementMap]||null),e.displacementScale!==void 0&&(this.displacementScale=e.displacementScale),e.displacementBias!==void 0&&(this.displacementBias=e.displacementBias),e.roughnessMap!==void 0&&(this.roughnessMap=t[e.roughnessMap]||null),e.metalnessMap!==void 0&&(this.metalnessMap=t[e.metalnessMap]||null),e.emissiveMap!==void 0&&(this.emissiveMap=t[e.emissiveMap]||null),e.emissiveIntensity!==void 0&&(this.emissiveIntensity=e.emissiveIntensity),e.specularMap!==void 0&&(this.specularMap=t[e.specularMap]||null),e.specularIntensityMap!==void 0&&(this.specularIntensityMap=t[e.specularIntensityMap]||null),e.specularColorMap!==void 0&&(this.specularColorMap=t[e.specularColorMap]||null),e.envMap!==void 0&&(this.envMap=t[e.envMap]||null),e.envMapRotation!==void 0&&this.envMapRotation.fromArray(e.envMapRotation),e.envMapIntensity!==void 0&&(this.envMapIntensity=e.envMapIntensity),e.reflectivity!==void 0&&(this.reflectivity=e.reflectivity),e.refractionRatio!==void 0&&(this.refractionRatio=e.refractionRatio),e.lightMap!==void 0&&(this.lightMap=t[e.lightMap]||null),e.lightMapIntensity!==void 0&&(this.lightMapIntensity=e.lightMapIntensity),e.aoMap!==void 0&&(this.aoMap=t[e.aoMap]||null),e.aoMapIntensity!==void 0&&(this.aoMapIntensity=e.aoMapIntensity),e.gradientMap!==void 0&&(this.gradientMap=t[e.gradientMap]||null),e.clearcoatMap!==void 0&&(this.clearcoatMap=t[e.clearcoatMap]||null),e.clearcoatRoughnessMap!==void 0&&(this.clearcoatRoughnessMap=t[e.clearcoatRoughnessMap]||null),e.clearcoatNormalMap!==void 0&&(this.clearcoatNormalMap=t[e.clearcoatNormalMap]||null),e.clearcoatNormalScale!==void 0&&(this.clearcoatNormalScale=new z().fromArray(e.clearcoatNormalScale)),e.iridescenceMap!==void 0&&(this.iridescenceMap=t[e.iridescenceMap]||null),e.iridescenceThicknessMap!==void 0&&(this.iridescenceThicknessMap=t[e.iridescenceThicknessMap]||null),e.transmissionMap!==void 0&&(this.transmissionMap=t[e.transmissionMap]||null),e.thicknessMap!==void 0&&(this.thicknessMap=t[e.thicknessMap]||null),e.anisotropyMap!==void 0&&(this.anisotropyMap=t[e.anisotropyMap]||null),e.sheenColorMap!==void 0&&(this.sheenColorMap=t[e.sheenColorMap]||null),e.sheenRoughnessMap!==void 0&&(this.sheenRoughnessMap=t[e.sheenRoughnessMap]||null),this}clone(){return new this.constructor().copy(this)}copy(e){this.name=e.name,this.blending=e.blending,this.side=e.side,this.vertexColors=e.vertexColors,this.opacity=e.opacity,this.transparent=e.transparent,this.blendSrc=e.blendSrc,this.blendDst=e.blendDst,this.blendEquation=e.blendEquation,this.blendSrcAlpha=e.blendSrcAlpha,this.blendDstAlpha=e.blendDstAlpha,this.blendEquationAlpha=e.blendEquationAlpha,this.blendColor.copy(e.blendColor),this.blendAlpha=e.blendAlpha,this.depthFunc=e.depthFunc,this.depthTest=e.depthTest,this.depthWrite=e.depthWrite,this.stencilWriteMask=e.stencilWriteMask,this.stencilFunc=e.stencilFunc,this.stencilRef=e.stencilRef,this.stencilFuncMask=e.stencilFuncMask,this.stencilFail=e.stencilFail,this.stencilZFail=e.stencilZFail,this.stencilZPass=e.stencilZPass,this.stencilWrite=e.stencilWrite;let t=e.clippingPlanes,n=null;if(t!==null){let e=t.length;n=Array(e);for(let r=0;r!==e;++r)n[r]=t[r].clone()}return this.clippingPlanes=n,this.clipIntersection=e.clipIntersection,this.clipShadows=e.clipShadows,this.shadowSide=e.shadowSide,this.colorWrite=e.colorWrite,this.precision=e.precision,this.polygonOffset=e.polygonOffset,this.polygonOffsetFactor=e.polygonOffsetFactor,this.polygonOffsetUnits=e.polygonOffsetUnits,this.dithering=e.dithering,this.alphaTest=e.alphaTest,this.alphaHash=e.alphaHash,this.alphaToCoverage=e.alphaToCoverage,this.premultipliedAlpha=e.premultipliedAlpha,this.forceSinglePass=e.forceSinglePass,this.allowOverride=e.allowOverride,this.visible=e.visible,this.toneMapped=e.toneMapped,this.userData=JSON.parse(JSON.stringify(e.userData)),this}dispose(){this.dispatchEvent({type:`dispose`})}set needsUpdate(e){e===!0&&this.version++}};let hn=/*@__PURE__*/ new B,gn=/*@__PURE__*/ new B,_n=/*@__PURE__*/ new B,vn=/*@__PURE__*/ new B;var yn=class{constructor(e=new B,t=new B(0,0,-1)){this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,hn)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);let n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){let t=hn.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(hn.copy(this.origin).addScaledVector(this.direction,t),hn.distanceToSquared(e))}distanceSqToSegment(e,t,n,r){gn.copy(e).add(t).multiplyScalar(.5),_n.copy(t).sub(e).normalize(),vn.copy(this.origin).sub(gn);let i=e.distanceTo(t)*.5,a=-this.direction.dot(_n),o=vn.dot(this.direction),s=-vn.dot(_n),c=vn.lengthSq(),l=Math.abs(1-a*a),u,d,f,p;if(l>0){if(u=a*s-o,d=a*o-s,p=i*l,u>=0){if(d>=-p){if(d<=p){let e=1/l;u*=e,d*=e,f=u*(u+a*d+2*o)+d*(a*u+d+2*s)+c}else d=i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d=-i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d<=-p?(u=Math.max(0,-(-a*i+o)),d=u>0?-i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c):d<=p?(u=0,d=Math.min(Math.max(-i,-s),i),f=d*(d+2*s)+c):(u=Math.max(0,-(a*i+o)),d=u>0?i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c)}else d=a>0?-i:i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c;return n&&n.copy(this.origin).addScaledVector(this.direction,u),r&&r.copy(gn).addScaledVector(_n,d),f}intersectSphere(e,t){if(e.radius<0)return null;hn.subVectors(e.center,this.origin);let n=hn.dot(this.direction),r=hn.dot(hn)-n*n,i=e.radius*e.radius;if(r>i)return null;let a=Math.sqrt(i-r),o=n-a,s=n+a;return s<0?null:o<0?this.at(s,t):this.at(o,t)}intersectsSphere(e){return e.radius<0?!1:this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){let t=e.normal.dot(this.direction);if(t===0)return e.distanceToPoint(this.origin)===0?0:null;let n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){let n=this.distanceToPlane(e);return n===null?null:this.at(n,t)}intersectsPlane(e){let t=e.distanceToPoint(this.origin);return t===0||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,r,i,a,o,s,c=1/this.direction.x,l=1/this.direction.y,u=1/this.direction.z,d=this.origin;return c>=0?(n=(e.min.x-d.x)*c,r=(e.max.x-d.x)*c):(n=(e.max.x-d.x)*c,r=(e.min.x-d.x)*c),l>=0?(i=(e.min.y-d.y)*l,a=(e.max.y-d.y)*l):(i=(e.max.y-d.y)*l,a=(e.min.y-d.y)*l),n>a||i>r||((i>n||isNaN(n))&&(n=i),(a<r||isNaN(r))&&(r=a),u>=0?(o=(e.min.z-d.z)*u,s=(e.max.z-d.z)*u):(o=(e.max.z-d.z)*u,s=(e.min.z-d.z)*u),n>s||o>r)||((o>n||n!==n)&&(n=o),(s<r||r!==r)&&(r=s),r<0)?null:this.at(n>=0?n:r,t)}intersectsBox(e){return this.intersectBox(e,hn)!==null}intersectTriangle(e,t,n,r,i){let a=this.origin,o=this.direction,s=o.x,c=o.y,l=o.z,u=e.x-a.x,d=e.y-a.y,f=e.z-a.z,p=t.x-a.x,m=t.y-a.y,h=t.z-a.z,g=n.x-a.x,_=n.y-a.y,v=n.z-a.z,y=Math.abs(s),b=Math.abs(c),x=Math.abs(l),S,C,w,T,E,D,O,k,A,j,M,N;if(y>=b&&y>=x?(w=s,D=u,A=p,N=g,s>=0?(S=c,C=l,T=d,E=f,O=m,k=h,j=_,M=v):(S=l,C=c,T=f,E=d,O=h,k=m,j=v,M=_)):b>=x?(w=c,D=d,A=m,N=_,c>=0?(S=l,C=s,T=f,E=u,O=h,k=p,j=v,M=g):(S=s,C=l,T=u,E=f,O=p,k=h,j=g,M=v)):(w=l,D=f,A=h,N=v,l>=0?(S=s,C=c,T=u,E=d,O=p,k=m,j=g,M=_):(S=c,C=s,T=d,E=u,O=m,k=p,j=_,M=g)),w===0)return null;let P=S/w,F=C/w,I=1/w,L=T-P*D,ee=E-F*D,te=O-P*A,ne=k-F*A,re=j-P*N,ie=M-F*N,ae=re*ne-ie*te,oe=L*ie-ee*re,se=te*ee-ne*L;if(r){if(ae<0||oe<0||se<0)return null}else if((ae<0||oe<0||se<0)&&(ae>0||oe>0||se>0))return null;let ce=ae+oe+se;if(ce===0)return null;let le=I*(ae*D+oe*A+se*N);return(ce>0?le<0:le>0)?null:this.at(le/ce,i)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return new this.constructor().copy(this)}},bn=class extends mn{constructor(e){super(),this.isMeshBasicMaterial=!0,this.type=`MeshBasicMaterial`,this.color=new G(16777215),this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new qe,this.combine=0,this.reflectivity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap=`round`,this.wireframeLinejoin=`round`,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.combine=e.combine,this.reflectivity=e.reflectivity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.fog=e.fog,this}};let xn=/*@__PURE__*/ new H,Sn=/*@__PURE__*/ new yn,Cn=/*@__PURE__*/ new $t,wn=/*@__PURE__*/ new B,Tn=/*@__PURE__*/ new B,En=/*@__PURE__*/ new B,Dn=/*@__PURE__*/ new B,On=/*@__PURE__*/ new B,kn=/*@__PURE__*/ new B,An=/*@__PURE__*/ new B,jn=/*@__PURE__*/ new B;var Mn=class extends W{constructor(e=new on,t=new bn){super(),this.isMesh=!0,this.type=`Mesh`,this.geometry=e,this.material=t,this.morphTargetDictionary=void 0,this.morphTargetInfluences=void 0,this.count=1,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),e.morphTargetInfluences!==void 0&&(this.morphTargetInfluences=e.morphTargetInfluences.slice()),e.morphTargetDictionary!==void 0&&(this.morphTargetDictionary=Object.assign({},e.morphTargetDictionary)),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}updateMorphTargets(){let e=this.geometry.morphAttributes,t=Object.keys(e);if(t.length>0){let n=e[t[0]];if(n!==void 0){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=n.length;e<t;e++){let t=n[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[t]=e}}}}getVertexPosition(e,t){let n=this.geometry,r=n.attributes.position,i=n.morphAttributes.position,a=n.morphTargetsRelative;t.fromBufferAttribute(r,e);let o=this.morphTargetInfluences;if(i&&o){kn.set(0,0,0);for(let n=0,r=i.length;n<r;n++){let r=o[n],s=i[n];r!==0&&(On.fromBufferAttribute(s,e),a?kn.addScaledVector(On,r):kn.addScaledVector(On.sub(t),r))}t.add(kn)}return t}intersectsFrustum(e){return e.intersectsObject(this)}raycast(e,t){let n=this.geometry,r=this.material,i=this.matrixWorld;r!==void 0&&(n.boundingSphere===null&&n.computeBoundingSphere(),Cn.copy(n.boundingSphere),Cn.applyMatrix4(i),Sn.copy(e.ray).recast(e.near),!(Cn.containsPoint(Sn.origin)===!1&&(Sn.intersectSphere(Cn,wn)===null||Sn.origin.distanceToSquared(wn)>(e.far-e.near)**2))&&(xn.copy(i).invert(),Sn.copy(e.ray).applyMatrix4(xn),(n.boundingBox===null||Sn.intersectsBox(n.boundingBox)!==!1)&&this._computeIntersections(e,t,Sn)))}_computeIntersections(e,t,n){let r,i=this.geometry,a=this.material,o=i.index,s=i.attributes.position,c=i.attributes.uv,l=i.attributes.uv1,u=i.attributes.normal,d=i.groups,f=i.drawRange;if(o!==null){if(Array.isArray(a))for(let i=0,s=d.length;i<s;i++){let s=d[i],p=a[s.materialIndex],m=Math.max(s.start,f.start),h=Math.min(o.count,Math.min(s.start+s.count,f.start+f.count));for(let i=m,a=h;i<a;i+=3){let a=o.getX(i),d=o.getX(i+1),f=o.getX(i+2);r=Pn(this,p,e,n,c,l,u,a,d,f),r&&(r.faceIndex=Math.floor(i/3),r.face.materialIndex=s.materialIndex,t.push(r))}}else{let i=Math.max(0,f.start),s=Math.min(o.count,f.start+f.count);for(let d=i,f=s;d<f;d+=3){let i=o.getX(d),s=o.getX(d+1),f=o.getX(d+2);r=Pn(this,a,e,n,c,l,u,i,s,f),r&&(r.faceIndex=Math.floor(d/3),t.push(r))}}}else if(s!==void 0){if(Array.isArray(a))for(let i=0,o=d.length;i<o;i++){let o=d[i],p=a[o.materialIndex],m=Math.max(o.start,f.start),h=Math.min(s.count,Math.min(o.start+o.count,f.start+f.count));for(let i=m,a=h;i<a;i+=3){let a=i,s=i+1,d=i+2;r=Pn(this,p,e,n,c,l,u,a,s,d),r&&(r.faceIndex=Math.floor(i/3),r.face.materialIndex=o.materialIndex,t.push(r))}}else{let i=Math.max(0,f.start),o=Math.min(s.count,f.start+f.count);for(let s=i,d=o;s<d;s+=3){let i=s,o=s+1,d=s+2;r=Pn(this,a,e,n,c,l,u,i,o,d),r&&(r.faceIndex=Math.floor(s/3),t.push(r))}}}}};function Nn(e,t,n,r,i,a,o,s){let c;if(c=t.side===1?r.intersectTriangle(o,a,i,!0,s):r.intersectTriangle(i,a,o,t.side===0,s),c===null)return null;jn.copy(s),jn.applyMatrix4(e.matrixWorld);let l=n.ray.origin.distanceTo(jn);return l<n.near||l>n.far?null:{distance:l,point:jn.clone(),object:e}}function Pn(e,t,n,r,i,a,o,s,c,l){e.getVertexPosition(s,Tn),e.getVertexPosition(c,En),e.getVertexPosition(l,Dn);let u=Nn(e,t,n,r,Tn,En,Dn,An);if(u){let e=new B;Ot.getBarycoord(An,Tn,En,Dn,e),i&&(u.uv=Ot.getInterpolatedAttribute(i,s,c,l,e,new z)),a&&(u.uv1=Ot.getInterpolatedAttribute(a,s,c,l,e,new z)),o&&(u.normal=Ot.getInterpolatedAttribute(o,s,c,l,e,new B),u.normal.dot(r.direction)>0&&u.normal.multiplyScalar(-1));let t={a:s,b:c,c:l,normal:new B,materialIndex:0};Ot.getNormal(Tn,En,Dn,t.normal),u.face=t,u.barycoord=e}return u}let Fn=/*@__PURE__*/ new Re,In=/*@__PURE__*/ new Re,Ln=/*@__PURE__*/ new Re,Rn=/*@__PURE__*/ new Re,zn=/*@__PURE__*/ new H,Bn=/*@__PURE__*/ new B,Vn=/*@__PURE__*/ new $t,Hn=/*@__PURE__*/ new H,Un=/*@__PURE__*/ new yn;var Wn=class extends Mn{constructor(e,t){super(e,t),this.isSkinnedMesh=!0,this.type=`SkinnedMesh`,this.bindMode=`attached`,this.bindMatrix=new H,this.bindMatrixInverse=new H,this.boundingBox=null,this.boundingSphere=null}computeBoundingBox(){let e=this.geometry;this.boundingBox===null&&(this.boundingBox=new kt),this.boundingBox.makeEmpty();let t=e.getAttribute(`position`);for(let e=0;e<t.count;e++)this.getVertexPosition(e,Bn),this.boundingBox.expandByPoint(Bn)}computeBoundingSphere(){let e=this.geometry;this.boundingSphere===null&&(this.boundingSphere=new $t),this.boundingSphere.makeEmpty();let t=e.getAttribute(`position`);for(let e=0;e<t.count;e++)this.getVertexPosition(e,Bn),this.boundingSphere.expandByPoint(Bn)}copy(e,t){return super.copy(e,t),this.bindMode=e.bindMode,this.bindMatrix.copy(e.bindMatrix),this.bindMatrixInverse.copy(e.bindMatrixInverse),this.skeleton=e.skeleton,e.boundingBox!==null&&(this.boundingBox=e.boundingBox.clone()),e.boundingSphere!==null&&(this.boundingSphere=e.boundingSphere.clone()),this}raycast(e,t){let n=this.material,r=this.matrixWorld;n!==void 0&&(this.boundingSphere===null&&this.computeBoundingSphere(),Vn.copy(this.boundingSphere),Vn.applyMatrix4(r),e.ray.intersectsSphere(Vn)!==!1&&(Hn.copy(r).invert(),Un.copy(e.ray).applyMatrix4(Hn),(this.boundingBox===null||Un.intersectsBox(this.boundingBox)!==!1)&&this._computeIntersections(e,t,Un)))}getVertexPosition(e,t){return super.getVertexPosition(e,t),this.applyBoneTransform(e,t),t}bind(e,t){this.skeleton=e,t===void 0&&(this.updateMatrixWorld(!0),this.skeleton.calculateInverses(),t=this.matrixWorld),this.bindMatrix.copy(t),this.bindMatrixInverse.copy(t).invert()}pose(){this.skeleton.pose()}normalizeSkinWeights(){let e=new Re,t=this.geometry.attributes.skinWeight;for(let n=0,r=t.count;n<r;n++){e.fromBufferAttribute(t,n);let r=1/e.manhattanLength();r===1/0?e.set(1,0,0,0):e.multiplyScalar(r),t.setXYZW(n,e.x,e.y,e.z,e.w)}}updateMatrixWorld(e){super.updateMatrixWorld(e),this.bindMode===`attached`?this.bindMatrixInverse.copy(this.matrixWorld).invert():this.bindMode===`detached`?this.bindMatrixInverse.copy(this.bindMatrix).invert():O(`SkinnedMesh: Unrecognized bindMode: `+this.bindMode)}applyBoneTransform(e,t){let n=this.skeleton,r=this.geometry;In.fromBufferAttribute(r.attributes.skinIndex,e),Ln.fromBufferAttribute(r.attributes.skinWeight,e),t.isVector4?(Fn.copy(t),t.set(0,0,0,0)):(Fn.set(...t,1),t.set(0,0,0)),Fn.applyMatrix4(this.bindMatrix);for(let e=0;e<4;e++){let r=Ln.getComponent(e);if(r!==0){let i=In.getComponent(e);zn.multiplyMatrices(n.bones[i].matrixWorld,n.boneInverses[i]),t.addScaledVector(Rn.copy(Fn).applyMatrix4(zn),r)}}return t.isVector4&&(t.w=Fn.w),t.applyMatrix4(this.bindMatrixInverse)}},Gn=class extends W{constructor(){super(),this.isBone=!0,this.type=`Bone`}},Kn=class extends Le{constructor(e=null,t=1,n=1,i,a,o,s,c,l=r,u=r,d,f){super(null,o,s,c,l,u,i,a,d,f),this.isDataTexture=!0,this.image={data:e,width:t,height:n},this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}};let qn=/*@__PURE__*/ new H,Jn=/*@__PURE__*/ new H;var Yn=class e{constructor(e=[],t=[]){this.uuid=I(),this.bones=e.slice(0),this.boneInverses=t,this.boneMatrices=null,this.boneTexture=null,this.init()}init(){let e=this.bones,t=this.boneInverses;if(this.boneMatrices=new Float32Array(e.length*16),t.length===0)this.calculateInverses();else if(e.length!==t.length){O(`Skeleton: Number of inverse bone matrices does not match amount of bones.`),this.boneInverses=[];for(let e=0,t=this.bones.length;e<t;e++)this.boneInverses.push(new H)}}calculateInverses(){this.boneInverses.length=0;for(let e=0,t=this.bones.length;e<t;e++){let t=new H;this.bones[e]&&t.copy(this.bones[e].matrixWorld).invert(),this.boneInverses.push(t)}}pose(){for(let e=0,t=this.bones.length;e<t;e++){let t=this.bones[e];t&&t.matrixWorld.copy(this.boneInverses[e]).invert()}for(let e=0,t=this.bones.length;e<t;e++){let t=this.bones[e];t&&(t.parent&&t.parent.isBone?(t.matrix.copy(t.parent.matrixWorld).invert(),t.matrix.multiply(t.matrixWorld)):t.matrix.copy(t.matrixWorld),t.matrix.decompose(t.position,t.quaternion,t.scale))}}update(){let e=this.bones,t=this.boneInverses,n=this.boneMatrices,r=this.boneTexture;for(let r=0,i=e.length;r<i;r++){let i=e[r]?e[r].matrixWorld:Jn;qn.multiplyMatrices(i,t[r]),qn.toArray(n,r*16)}r!==null&&(r.needsUpdate=!0)}clone(){return new e(this.bones,this.boneInverses)}computeBoneTexture(){let e=Math.sqrt(this.bones.length*4);e=Math.ceil(e/4)*4,e=Math.max(e,4);let t=new Float32Array(e*e*4);t.set(this.boneMatrices);let n=new Kn(t,e,e,c,s);return n.needsUpdate=!0,this.boneMatrices=t,this.boneTexture=n,this}getBoneByName(e){for(let t=0,n=this.bones.length;t<n;t++){let n=this.bones[t];if(n.name===e)return n}}dispose(){this.boneTexture!==null&&(this.boneTexture.dispose(),this.boneTexture=null)}fromJSON(e,t){this.uuid=e.uuid;for(let n=0,r=e.bones.length;n<r;n++){let r=e.bones[n],i=t[r];i===void 0&&(O(`Skeleton: No bone found with UUID:`,r),i=new Gn),this.bones.push(i),this.boneInverses.push(new H().fromArray(e.boneInverses[n]))}return this.init(),this}toJSON(){let e={metadata:{version:4.7,type:`Skeleton`,generator:`Skeleton.toJSON`},bones:[],boneInverses:[]};e.uuid=this.uuid;let t=this.bones,n=this.boneInverses;for(let r=0,i=t.length;r<i;r++){let i=t[r];e.bones.push(i.uuid);let a=n[r];e.boneInverses.push(a.toArray())}return e}},Xn=class extends Kt{constructor(e,t,n,r=1){super(e,t,n),this.isInstancedBufferAttribute=!0,this.meshPerAttribute=r}copy(e){return super.copy(e),this.meshPerAttribute=e.meshPerAttribute,this}toJSON(){let e=super.toJSON();return e.meshPerAttribute=this.meshPerAttribute,e.isInstancedBufferAttribute=!0,e}};let Zn=/*@__PURE__*/ new H,Qn=/*@__PURE__*/ new H,$n=[],er=/*@__PURE__*/ new kt,tr=/*@__PURE__*/ new H,nr=/*@__PURE__*/ new Mn,rr=/*@__PURE__*/ new $t;var ir=class extends Mn{constructor(e,t,n){super(e,t),this.isInstancedMesh=!0,this.instanceMatrix=new Xn(new Float32Array(n*16),16),this.instanceColor=null,this.morphTexture=null,this.count=n,this.boundingBox=null,this.boundingSphere=null;for(let e=0;e<n;e++)this.setMatrixAt(e,tr)}computeBoundingBox(){let e=this.geometry,t=this.count;this.boundingBox===null&&(this.boundingBox=new kt),e.boundingBox===null&&e.computeBoundingBox(),this.boundingBox.makeEmpty();for(let n=0;n<t;n++)this.getMatrixAt(n,Zn),er.copy(e.boundingBox).applyMatrix4(Zn),this.boundingBox.union(er)}computeBoundingSphere(){let e=this.geometry,t=this.count;this.boundingSphere===null&&(this.boundingSphere=new $t),e.boundingSphere===null&&e.computeBoundingSphere(),this.boundingSphere.makeEmpty();for(let n=0;n<t;n++)this.getMatrixAt(n,Zn),rr.copy(e.boundingSphere).applyMatrix4(Zn),this.boundingSphere.union(rr)}copy(e,t){return super.copy(e,t),this.instanceMatrix.copy(e.instanceMatrix),e.morphTexture!==null&&(this.morphTexture=e.morphTexture.clone()),e.instanceColor!==null&&(this.instanceColor=e.instanceColor.clone()),this.count=e.count,e.boundingBox!==null&&(this.boundingBox=e.boundingBox.clone()),e.boundingSphere!==null&&(this.boundingSphere=e.boundingSphere.clone()),this}getColorAt(e,t){return this.instanceColor===null?t.setRGB(1,1,1):t.fromArray(this.instanceColor.array,e*3)}getMatrixAt(e,t){return t.fromArray(this.instanceMatrix.array,e*16)}getMorphAt(e,t){let n=t.morphTargetInfluences,r=this.morphTexture.source.data.data,i=e*(n.length+1)+1;for(let e=0;e<n.length;e++)n[e]=r[i+e]}raycast(e,t){let n=this.matrixWorld,r=this.count;if(nr.geometry=this.geometry,nr.material=this.material,nr.material!==void 0&&(this.boundingSphere===null&&this.computeBoundingSphere(),rr.copy(this.boundingSphere),rr.applyMatrix4(n),e.ray.intersectsSphere(rr)!==!1))for(let i=0;i<r;i++){this.getMatrixAt(i,Zn),Qn.multiplyMatrices(n,Zn),nr.matrixWorld=Qn,nr.raycast(e,$n);for(let e=0,n=$n.length;e<n;e++){let n=$n[e];n.instanceId=i,n.object=this,t.push(n)}$n.length=0}}setColorAt(e,t){return this.instanceColor===null&&(this.instanceColor=new Xn(new Float32Array(this.instanceMatrix.count*3).fill(1),3)),t.toArray(this.instanceColor.array,e*3),this}setMatrixAt(e,t){return t.toArray(this.instanceMatrix.array,e*16),this}setMorphAt(e,t){let n=t.morphTargetInfluences,r=n.length+1;this.morphTexture===null&&(this.morphTexture=new Kn(new Float32Array(r*this.count),r,this.count,1028,s));let i=this.morphTexture.source.data.data,a=0;for(let e=0;e<n.length;e++)a+=n[e];let o=this.geometry.morphTargetsRelative?1:1-a,c=r*e;return i[c]=o,i.set(n,c+1),this}updateMorphTargets(){}dispose(){super.dispose(),this.morphTexture!==null&&(this.morphTexture.dispose(),this.morphTexture=null)}};let ar=/*@__PURE__*/ new $t,or=/*@__PURE__*/ new z(.5,.5),sr=/*@__PURE__*/ new B;var cr=class{constructor(e=new fn,t=new fn,n=new fn,r=new fn,i=new fn,a=new fn){this.planes=[e,t,n,r,i,a]}set(e,t,n,r,i,a){let o=this.planes;return o[0].copy(e),o[1].copy(t),o[2].copy(n),o[3].copy(r),o[4].copy(i),o[5].copy(a),this}copy(e){let t=this.planes;for(let n=0;n<6;n++)t[n].copy(e.planes[n]);return this}setFromProjectionMatrix(e,t=x,n=!1){let r=this.planes,i=e.elements,a=i[0],o=i[1],s=i[2],c=i[3],l=i[4],u=i[5],d=i[6],f=i[7],p=i[8],m=i[9],h=i[10],g=i[11],_=i[12],v=i[13],y=i[14],b=i[15];if(r[0].setComponents(c-a,f-l,g-p,b-_).normalize(),r[1].setComponents(c+a,f+l,g+p,b+_).normalize(),r[2].setComponents(c+o,f+u,g+m,b+v).normalize(),r[3].setComponents(c-o,f-u,g-m,b-v).normalize(),n)r[4].setComponents(s,d,h,y).normalize(),r[5].setComponents(c-s,f-d,g-h,b-y).normalize();else if(r[4].setComponents(c-s,f-d,g-h,b-y).normalize(),t===2e3)r[5].setComponents(c+s,f+d,g+h,b+y).normalize();else if(t===2001)r[5].setComponents(s,d,h,y).normalize();else throw Error(`THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: `+t);return this}intersectsObject(e){if(e.boundingSphere!==void 0)e.boundingSphere===null&&e.computeBoundingSphere(),ar.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);else{let t=e.geometry;t.boundingSphere===null&&t.computeBoundingSphere(),ar.copy(t.boundingSphere).applyMatrix4(e.matrixWorld)}return this.intersectsSphere(ar)}intersectsSprite(e){ar.center.set(0,0,0);let t=or.distanceTo(e.center);return ar.radius=.7071067811865476+t,ar.applyMatrix4(e.matrixWorld),this.intersectsSphere(ar)}intersectsSphere(e){let t=this.planes,n=e.center,r=-e.radius;for(let e=0;e<6;e++)if(t[e].distanceToPoint(n)<r)return!1;return!0}intersectsBox(e){let t=this.planes;for(let n=0;n<6;n++){let r=t[n];if(sr.x=r.normal.x>0?e.max.x:e.min.x,sr.y=r.normal.y>0?e.max.y:e.min.y,sr.z=r.normal.z>0?e.max.z:e.min.z,r.distanceToPoint(sr)<0)return!1}return!0}containsPoint(e){let t=this.planes;for(let n=0;n<6;n++)if(t[n].distanceToPoint(e)<0)return!1;return!0}clone(){return new this.constructor().copy(this)}},lr=class extends mn{constructor(e){super(),this.isLineBasicMaterial=!0,this.type=`LineBasicMaterial`,this.color=new G(16777215),this.map=null,this.linewidth=1,this.linecap=`round`,this.linejoin=`round`,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.linewidth=e.linewidth,this.linecap=e.linecap,this.linejoin=e.linejoin,this.fog=e.fog,this}};let ur=/*@__PURE__*/ new B,dr=/*@__PURE__*/ new B,fr=/*@__PURE__*/ new H,pr=/*@__PURE__*/ new yn,mr=/*@__PURE__*/ new $t,hr=/*@__PURE__*/ new B,gr=/*@__PURE__*/ new B;var _r=class extends W{constructor(e=new on,t=new lr){super(),this.isLine=!0,this.type=`Line`,this.geometry=e,this.material=t,this.morphTargetDictionary=void 0,this.morphTargetInfluences=void 0,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}computeLineDistances(){let e=this.geometry;if(e.index===null){let t=e.attributes.position,n=[0];for(let e=1,r=t.count;e<r;e++)ur.fromBufferAttribute(t,e-1),dr.fromBufferAttribute(t,e),n[e]=n[e-1],n[e]+=ur.distanceTo(dr);e.setAttribute(`lineDistance`,new Yt(n,1))}else O(`Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.`);return this}intersectsFrustum(e){return e.intersectsObject(this)}raycast(e,t){let n=this.geometry,r=this.matrixWorld,i=e.params.Line.threshold,a=n.drawRange;if(n.boundingSphere===null&&n.computeBoundingSphere(),mr.copy(n.boundingSphere),mr.applyMatrix4(r),mr.radius+=i,e.ray.intersectsSphere(mr)===!1)return;fr.copy(r).invert(),pr.copy(e.ray).applyMatrix4(fr);let o=i/((this.scale.x+this.scale.y+this.scale.z)/3),s=o*o,c=this.isLineSegments?2:1,l=n.index,u=n.attributes.position;if(l!==null){let n=Math.max(0,a.start),r=Math.min(l.count,a.start+a.count);for(let i=n,a=r-1;i<a;i+=c){let n=l.getX(i),r=l.getX(i+1),a=vr(this,e,pr,s,n,r,i);a&&t.push(a)}if(this.isLineLoop){let i=l.getX(r-1),a=l.getX(n),o=vr(this,e,pr,s,i,a,r-1);o&&t.push(o)}}else{let n=Math.max(0,a.start),r=Math.min(u.count,a.start+a.count);for(let i=n,a=r-1;i<a;i+=c){let n=vr(this,e,pr,s,i,i+1,i);n&&t.push(n)}if(this.isLineLoop){let i=vr(this,e,pr,s,r-1,n,r-1);i&&t.push(i)}}}updateMorphTargets(){let e=this.geometry.morphAttributes,t=Object.keys(e);if(t.length>0){let n=e[t[0]];if(n!==void 0){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=n.length;e<t;e++){let t=n[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[t]=e}}}}};function vr(e,t,n,r,i,a,o){let s=e.geometry.attributes.position;if(ur.fromBufferAttribute(s,i),dr.fromBufferAttribute(s,a),n.distanceSqToSegment(ur,dr,hr,gr)>r)return;hr.applyMatrix4(e.matrixWorld);let c=t.ray.origin.distanceTo(hr);if(!(c<t.near||c>t.far))return{distance:c,point:gr.clone().applyMatrix4(e.matrixWorld),index:o,face:null,faceIndex:null,barycoord:null,object:e}}let yr=/*@__PURE__*/ new B,br=/*@__PURE__*/ new B;var xr=class extends _r{constructor(e,t){super(e,t),this.isLineSegments=!0,this.type=`LineSegments`}computeLineDistances(){let e=this.geometry;if(e.index===null){let t=e.attributes.position,n=[];for(let e=0,r=t.count;e<r;e+=2)yr.fromBufferAttribute(t,e),br.fromBufferAttribute(t,e+1),n[e]=e===0?0:n[e-1],n[e+1]=n[e]+yr.distanceTo(br);e.setAttribute(`lineDistance`,new Yt(n,1))}else O(`LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.`);return this}},Sr=class extends _r{constructor(e,t){super(e,t),this.isLineLoop=!0,this.type=`LineLoop`}},Cr=class extends mn{constructor(e){super(),this.isPointsMaterial=!0,this.type=`PointsMaterial`,this.color=new G(16777215),this.map=null,this.alphaMap=null,this.size=1,this.sizeAttenuation=!0,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.alphaMap=e.alphaMap,this.size=e.size,this.sizeAttenuation=e.sizeAttenuation,this.fog=e.fog,this}};let wr=/*@__PURE__*/ new H,Tr=/*@__PURE__*/ new yn,Er=/*@__PURE__*/ new $t,Dr=/*@__PURE__*/ new B;var Or=class extends W{constructor(e=new on,t=new Cr){super(),this.isPoints=!0,this.type=`Points`,this.geometry=e,this.material=t,this.morphTargetDictionary=void 0,this.morphTargetInfluences=void 0,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}intersectsFrustum(e){return e.intersectsObject(this)}raycast(e,t){let n=this.geometry,r=this.matrixWorld,i=e.params.Points.threshold,a=n.drawRange;if(n.boundingSphere===null&&n.computeBoundingSphere(),Er.copy(n.boundingSphere),Er.applyMatrix4(r),Er.radius+=i,e.ray.intersectsSphere(Er)===!1)return;wr.copy(r).invert(),Tr.copy(e.ray).applyMatrix4(wr);let o=i/((this.scale.x+this.scale.y+this.scale.z)/3),s=o*o,c=n.index,l=n.attributes.position;if(c!==null){let n=Math.max(0,a.start),i=Math.min(c.count,a.start+a.count);for(let a=n,o=i;a<o;a++){let n=c.getX(a);Dr.fromBufferAttribute(l,n),kr(Dr,n,s,r,e,t,this)}}else{let n=Math.max(0,a.start),i=Math.min(l.count,a.start+a.count);for(let a=n,o=i;a<o;a++)Dr.fromBufferAttribute(l,a),kr(Dr,a,s,r,e,t,this)}}updateMorphTargets(){let e=this.geometry.morphAttributes,t=Object.keys(e);if(t.length>0){let n=e[t[0]];if(n!==void 0){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=n.length;e<t;e++){let t=n[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[t]=e}}}}};function kr(e,t,n,r,i,a,o){let s=Tr.distanceSqToPoint(e);if(s<n){let n=new B;Tr.closestPointToPoint(e,n),n.applyMatrix4(r);let c=i.ray.origin.distanceTo(n);if(c<i.near||c>i.far)return;a.push({distance:c,distanceToRay:Math.sqrt(s),point:n,index:t,face:null,faceIndex:null,barycoord:null,object:o})}}var Ar=class extends mn{constructor(e){super(),this.isMeshStandardMaterial=!0,this.type=`MeshStandardMaterial`,this.defines={STANDARD:``},this.color=new G(16777215),this.roughness=1,this.metalness=0,this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.emissive=new G(0),this.emissiveIntensity=1,this.emissiveMap=null,this.bumpMap=null,this.bumpScale=1,this.normalMap=null,this.normalMapType=0,this.normalScale=new z(1,1),this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.roughnessMap=null,this.metalnessMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new qe,this.envMapIntensity=1,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap=`round`,this.wireframeLinejoin=`round`,this.flatShading=!1,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.defines={STANDARD:``},this.color.copy(e.color),this.roughness=e.roughness,this.metalness=e.metalness,this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.emissive.copy(e.emissive),this.emissiveMap=e.emissiveMap,this.emissiveIntensity=e.emissiveIntensity,this.bumpMap=e.bumpMap,this.bumpScale=e.bumpScale,this.normalMap=e.normalMap,this.normalMapType=e.normalMapType,this.normalScale.copy(e.normalScale),this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.roughnessMap=e.roughnessMap,this.metalnessMap=e.metalnessMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.envMapIntensity=e.envMapIntensity,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.flatShading=e.flatShading,this.fog=e.fog,this}},jr=class extends Ar{constructor(e){super(),this.isMeshPhysicalMaterial=!0,this.defines={STANDARD:``,PHYSICAL:``},this.type=`MeshPhysicalMaterial`,this.anisotropyRotation=0,this.anisotropyMap=null,this.clearcoatMap=null,this.clearcoatRoughness=0,this.clearcoatRoughnessMap=null,this.clearcoatNormalScale=new z(1,1),this.clearcoatNormalMap=null,this.ior=1.5,Object.defineProperty(this,\"reflectivity\",{get:function(){return L(2.5*(this.ior-1)/(this.ior+1),0,1)},set:function(e){this.ior=(1+.4*e)/(1-.4*e)}}),this.iridescenceMap=null,this.iridescenceIOR=1.3,this.iridescenceThicknessRange=[100,400],this.iridescenceThicknessMap=null,this.sheenColor=new G(0),this.sheenColorMap=null,this.sheenRoughness=1,this.sheenRoughnessMap=null,this.transmissionMap=null,this.thickness=0,this.thicknessMap=null,this.attenuationDistance=1/0,this.attenuationColor=new G(1,1,1),this.specularIntensity=1,this.specularIntensityMap=null,this.specularColor=new G(1,1,1),this.specularColorMap=null,this._anisotropy=0,this._clearcoat=0,this._dispersion=0,this._iridescence=0,this._retroreflectivity=0,this._sheen=0,this._transmission=0,this.setValues(e)}get anisotropy(){return this._anisotropy}set anisotropy(e){this._anisotropy>0!=e>0&&this.version++,this._anisotropy=e}get clearcoat(){return this._clearcoat}set clearcoat(e){this._clearcoat>0!=e>0&&this.version++,this._clearcoat=e}get iridescence(){return this._iridescence}set iridescence(e){this._iridescence>0!=e>0&&this.version++,this._iridescence=e}get dispersion(){return this._dispersion}set dispersion(e){this._dispersion>0!=e>0&&this.version++,this._dispersion=e}get retroreflectivity(){return this._retroreflectivity}set retroreflectivity(e){this._retroreflectivity>0!=e>0&&this.version++,this._retroreflectivity=e}get sheen(){return this._sheen}set sheen(e){this._sheen>0!=e>0&&this.version++,this._sheen=e}get transmission(){return this._transmission}set transmission(e){this._transmission>0!=e>0&&this.version++,this._transmission=e}copy(e){return super.copy(e),this.defines={STANDARD:``,PHYSICAL:``},this.anisotropy=e.anisotropy,this.anisotropyRotation=e.anisotropyRotation,this.anisotropyMap=e.anisotropyMap,this.clearcoat=e.clearcoat,this.clearcoatMap=e.clearcoatMap,this.clearcoatRoughness=e.clearcoatRoughness,this.clearcoatRoughnessMap=e.clearcoatRoughnessMap,this.clearcoatNormalMap=e.clearcoatNormalMap,this.clearcoatNormalScale.copy(e.clearcoatNormalScale),this.dispersion=e.dispersion,this.ior=e.ior,this.iridescence=e.iridescence,this.iridescenceMap=e.iridescenceMap,this.iridescenceIOR=e.iridescenceIOR,this.iridescenceThicknessRange=[...e.iridescenceThicknessRange],this.iridescenceThicknessMap=e.iridescenceThicknessMap,this.retroreflectivity=e.retroreflectivity,this.sheen=e.sheen,this.sheenColor.copy(e.sheenColor),this.sheenColorMap=e.sheenColorMap,this.sheenRoughness=e.sheenRoughness,this.sheenRoughnessMap=e.sheenRoughnessMap,this.transmission=e.transmission,this.transmissionMap=e.transmissionMap,this.thickness=e.thickness,this.thicknessMap=e.thicknessMap,this.attenuationDistance=e.attenuationDistance,this.attenuationColor.copy(e.attenuationColor),this.specularIntensity=e.specularIntensity,this.specularIntensityMap=e.specularIntensityMap,this.specularColor.copy(e.specularColor),this.specularColorMap=e.specularColorMap,this}},Mr=class extends mn{constructor(e){super(),this.isMeshPhongMaterial=!0,this.type=`MeshPhongMaterial`,this.color=new G(16777215),this.specular=new G(1118481),this.shininess=30,this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.emissive=new G(0),this.emissiveIntensity=1,this.emissiveMap=null,this.bumpMap=null,this.bumpScale=1,this.normalMap=null,this.normalMapType=0,this.normalScale=new z(1,1),this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.envMapRotation=new qe,this.combine=0,this.reflectivity=1,this.envMapIntensity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap=`round`,this.wireframeLinejoin=`round`,this.flatShading=!1,this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.specular.copy(e.specular),this.shininess=e.shininess,this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.emissive.copy(e.emissive),this.emissiveMap=e.emissiveMap,this.emissiveIntensity=e.emissiveIntensity,this.bumpMap=e.bumpMap,this.bumpScale=e.bumpScale,this.normalMap=e.normalMap,this.normalMapType=e.normalMapType,this.normalScale.copy(e.normalScale),this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.envMapRotation.copy(e.envMapRotation),this.combine=e.combine,this.reflectivity=e.reflectivity,this.envMapIntensity=e.envMapIntensity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.flatShading=e.flatShading,this.fog=e.fog,this}};function Nr(e,t){return!e||e.constructor===t?e:typeof t.BYTES_PER_ELEMENT==`number`?new t(e):Array.prototype.slice.call(e)}function Pr(e){return e!==void 0&&e.inTangents!==void 0&&e.outTangents!==void 0}function Fr(e){function t(t,n){return e[t]-e[n]}let n=e.length,r=Array(n);for(let e=0;e!==n;++e)r[e]=e;return r.sort(t),r}function Ir(e,t,n){let r=e.length,i=new e.constructor(r);for(let a=0,o=0;o!==r;++a){let r=n[a]*t;for(let n=0;n!==t;++n)i[o++]=e[r+n]}return i}function Lr(e,t,n,r){let i=1,a=e[0];for(;a!==void 0&&a[r]===void 0;)a=e[i++];if(a===void 0)return;let o=a[r];if(o!==void 0){if(Array.isArray(o))do o=a[r],o!==void 0&&(t.push(a.time),n.push(...o)),a=e[i++];while(a!==void 0);else if(o.toArray!==void 0)do o=a[r],o!==void 0&&(t.push(a.time),o.toArray(n,n.length)),a=e[i++];while(a!==void 0);else do o=a[r],o!==void 0&&(t.push(a.time),n.push(o)),a=e[i++];while(a!==void 0)}}var Rr=class{constructor(e,t,n,r){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=r===void 0?new t.constructor(n):r,this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){let t=this.parameterPositions,n=this._cachedIndex,r=t[n],i=t[n-1];validate_interval:{seek:{let a;linear_scan:{forward_scan:if(!(e<r)){for(let a=n+2;;){if(r===void 0){if(e<i)break forward_scan;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(i=r,r=t[++n],e<r)break seek}a=t.length;break linear_scan}if(!(e>=i)){let o=t[1];e<o&&(n=2,i=o);for(let a=n-2;;){if(i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(r=i,i=t[--n-1],e>=i)break seek}a=n,n=0;break linear_scan}break validate_interval}for(;n<a;){let r=n+a>>>1;e<t[r]?a=r:n=r+1}if(r=t[n],i=t[n-1],i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(r===void 0)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,i,r)}return this.interpolate_(n,i,e,r)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){let t=this.resultBuffer,n=this.sampleValues,r=this.valueSize,i=e*r;for(let e=0;e!==r;++e)t[e]=n[i+e];return t}interpolate_(){throw Error(`THREE.Interpolant: Call to abstract method.`)}intervalChanged_(){}},zr=class extends Rr{constructor(e,t,n,r){super(e,t,n,r),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:p,endingEnd:p}}intervalChanged_(e,t,n){let r=this.parameterPositions,i=e-2,a=e+1,o=r[i],s=r[a];if(o===void 0)switch(this.getSettings_().endingStart){case m:i=e,o=2*t-n;break;case h:i=r.length-2,o=t+r[i]-r[i+1];break;default:i=e,o=n}if(s===void 0)switch(this.getSettings_().endingEnd){case m:a=e,s=2*n-t;break;case h:a=1,s=n+r[1]-r[0];break;default:a=e-1,s=t}let c=(n-t)*.5,l=this.valueSize;this._weightPrev=c/(t-o),this._weightNext=c/(s-n),this._offsetPrev=i*l,this._offsetNext=a*l}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this._offsetPrev,u=this._offsetNext,d=this._weightPrev,f=this._weightNext,p=(n-t)/(r-t),m=p*p,h=m*p,g=-d*h+2*d*m-d*p,_=(1+d)*h+(-1.5-2*d)*m+(-.5+d)*p+1,v=(-1-f)*h+(1.5+f)*m+.5*p,y=f*h-f*m;for(let e=0;e!==o;++e)i[e]=g*a[l+e]+_*a[c+e]+v*a[s+e]+y*a[u+e];return i}},Br=class extends Rr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=(n-t)/(r-t),u=1-l;for(let e=0;e!==o;++e)i[e]=a[c+e]*u+a[s+e]*l;return i}},Vr=class extends Rr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e){return this.copySampleValue_(e-1)}},Hr=class extends Rr{interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this.inTangents,u=this.outTangents;if(!l||!u){let e=(n-t)/(r-t),l=1-e;for(let t=0;t!==o;++t)i[t]=a[c+t]*l+a[s+t]*e;return i}let d=o*2,f=e-1;for(let p=0;p!==o;++p){let o=a[c+p],m=a[s+p],h=f*d+p*2,g=u[h],_=u[h+1],v=e*d+p*2,y=l[v],b=l[v+1],x=Gr(n,t,g,y,r);i[p]=Ur(x,o,_,b,m)}return i}};function Ur(e,t,n,r,i){let a=1-e;return a*a*a*t+3*a*a*e*n+3*a*e*e*r+e*e*e*i}function Wr(e,t,n,r,i){let a=1-e;return 3*a*a*(n-t)+6*a*e*(r-n)+3*e*e*(i-r)}function Gr(e,t,n,r,i){let a=(e-t)/(i-t);for(let o=0;o<8;o++){let o=Ur(a,t,n,r,i)-e;if(Math.abs(o)<1e-10)break;let s=Wr(a,t,n,r,i);if(Math.abs(s)<1e-10)break;a=Math.max(0,Math.min(1,a-o/s))}return a}var Kr=class{constructor(e,t,n,r){if(e===void 0)throw Error(`THREE.KeyframeTrack: track name is undefined`);if(t===void 0||t.length===0)throw Error(`THREE.KeyframeTrack: no keyframes in track named `+e);this.name=e,this.times=Nr(t,this.TimeBufferType),this.values=Nr(n,this.ValueBufferType),this.setInterpolation(r||this.DefaultInterpolation)}static toJSON(e){let t=e.constructor,n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:Nr(e.times,Array),values:Nr(e.values,Array)};let t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t),Pr(e.settings)&&(n.settings={inTangents:Nr(e.settings.inTangents,Array),outTangents:Nr(e.settings.outTangents,Array)})}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new Vr(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new Br(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new zr(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodBezier(e){let t=new Hr(this.times,this.values,this.getValueSize(),e);return this.settings&&(t.inTangents=this.settings.inTangents,t.outTangents=this.settings.outTangents),t}setInterpolation(e){let t;switch(e){case l:t=this.InterpolantFactoryMethodDiscrete;break;case u:t=this.InterpolantFactoryMethodLinear;break;case d:t=this.InterpolantFactoryMethodSmooth;break;case f:t=this.InterpolantFactoryMethodBezier}if(t===void 0){let t=`unsupported interpolation for `+this.ValueTypeName+` keyframe track named `+this.name;if(this.createInterpolant===void 0){if(e!==this.DefaultInterpolation)this.setInterpolation(this.DefaultInterpolation);else throw Error(t)}return O(`KeyframeTrack:`,t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return l;case this.InterpolantFactoryMethodLinear:return u;case this.InterpolantFactoryMethodSmooth:return d;case this.InterpolantFactoryMethodBezier:return f}}getValueSize(){return this.values.length/this.times.length}shift(e){if(e!==0){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]+=e}return this}scale(e){if(e!==1){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]*=e;Pr(this.settings)&&(qr(this.settings.inTangents,e),qr(this.settings.outTangents,e))}return this}trim(e,t){let n=this.times,r=n.length,i=0,a=r-1;for(;i!==r&&n[i]<e;)++i;for(;a!==-1&&n[a]>t;)--a;if(++a,i!==0||a!==r){i>=a&&(a=Math.max(a,1),i=a-1);let e=this.getValueSize();this.times=n.slice(i,a),this.values=this.values.slice(i*e,a*e)}return this}validate(){let e=!0,t=this.getValueSize();t-Math.floor(t)!==0&&(k(`KeyframeTrack: Invalid value size in track.`,this),e=!1);let n=this.times,r=this.values,i=n.length;i===0&&(k(`KeyframeTrack: Track is empty.`,this),e=!1);let a=null;for(let t=0;t!==i;t++){let r=n[t];if(typeof r==`number`&&isNaN(r)){k(`KeyframeTrack: Time is not a valid number.`,this,t,r),e=!1;break}if(a!==null&&a>r){k(`KeyframeTrack: Out of order keys.`,this,t,r,a),e=!1;break}a=r}if(r!==void 0&&C(r))for(let t=0,n=r.length;t!==n;++t){let n=r[t];if(isNaN(n)){k(`KeyframeTrack: Value is not a valid number.`,this,t,n),e=!1;break}}return e}optimize(){let e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),r=this.getInterpolation()===d,i=e.length-1,a=1;for(let o=1;o<i;++o){let i=!1,s=e[o];if(s!==e[o+1]&&(o!==1||s!==e[0])){if(r)i=!0;else{let e=o*n,r=e-n,a=e+n;for(let o=0;o!==n;++o){let n=t[e+o];if(n!==t[r+o]||n!==t[a+o]){i=!0;break}}}}if(i){if(o!==a){e[a]=e[o];let r=o*n,i=a*n;for(let e=0;e!==n;++e)t[i+e]=t[r+e]}++a}}if(i>0){e[a]=e[i];for(let e=i*n,r=a*n,o=0;o!==n;++o)t[r+o]=t[e+o];++a}return a===e.length?(this.times=e,this.values=t):(this.times=e.slice(0,a),this.values=t.slice(0,a*n)),this}clone(){let e=this.times.slice(),t=this.values.slice(),n=this.constructor,r=new n(this.name,e,t);return r.createInterpolant=this.createInterpolant,Pr(this.settings)&&(r.settings={inTangents:this.settings.inTangents.slice(),outTangents:this.settings.outTangents.slice()}),r}};function qr(e,t){for(let n=0,r=e.length;n!==r;n+=2)e[n]*=t}Kr.prototype.ValueTypeName=``,Kr.prototype.TimeBufferType=Float32Array,Kr.prototype.ValueBufferType=Float32Array,Kr.prototype.DefaultInterpolation=u;var Jr=class extends Kr{constructor(e,t,n){super(e,t,n)}};Jr.prototype.ValueTypeName=`bool`,Jr.prototype.ValueBufferType=Array,Jr.prototype.DefaultInterpolation=l,Jr.prototype.InterpolantFactoryMethodLinear=void 0,Jr.prototype.InterpolantFactoryMethodSmooth=void 0;var Yr=class extends Kr{constructor(e,t,n,r){super(e,t,n,r)}};Yr.prototype.ValueTypeName=`color`;var Xr=class extends Kr{constructor(e,t,n,r){super(e,t,n,r)}};Xr.prototype.ValueTypeName=`number`;var Zr=class extends Rr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=(n-t)/(r-t),c=e*o;for(let e=c+o;c!==e;c+=4)be.slerpFlat(i,0,a,c-o,a,c,s);return i}},Qr=class extends Kr{constructor(e,t,n,r){super(e,t,n,r)}InterpolantFactoryMethodLinear(e){return new Zr(this.times,this.values,this.getValueSize(),e)}};Qr.prototype.ValueTypeName=`quaternion`,Qr.prototype.InterpolantFactoryMethodSmooth=void 0;var $r=class extends Kr{constructor(e,t,n){super(e,t,n)}};$r.prototype.ValueTypeName=`string`,$r.prototype.ValueBufferType=Array,$r.prototype.DefaultInterpolation=l,$r.prototype.InterpolantFactoryMethodLinear=void 0,$r.prototype.InterpolantFactoryMethodSmooth=void 0;var ei=class extends Kr{constructor(e,t,n,r){super(e,t,n,r)}};ei.prototype.ValueTypeName=`vector`;var ti=class{constructor(e=``,t=-1,n=[],r=2500){this.name=e,this.tracks=n,this.duration=t,this.blendMode=r,this.uuid=I(),this.userData={},this.duration<0&&this.resetDuration()}static parse(e){let t=[],n=e.tracks,r=1/(e.fps||1);for(let e=0,i=n.length;e!==i;++e)t.push(ri(n[e]).scale(r));let i=new this(e.name,e.duration,t,e.blendMode);return i.uuid=e.uuid,i.userData=JSON.parse(e.userData||`{}`),i}static toJSON(e){let t=[],n=e.tracks,r={name:e.name,duration:e.duration,tracks:t,uuid:e.uuid,blendMode:e.blendMode,userData:JSON.stringify(e.userData)};for(let e=0,r=n.length;e!==r;++e)t.push(Kr.toJSON(n[e]));return r}static CreateFromMorphTargetSequence(e,t,n,r){let i=t.length,a=[];for(let e=0;e<i;e++){let o=[],s=[];o.push((e+i-1)%i,e,(e+1)%i),s.push(0,1,0);let c=Fr(o);o=Ir(o,1,c),s=Ir(s,1,c),!r&&o[0]===0&&(o.push(i),s.push(s[0])),a.push(new Xr(`.morphTargetInfluences[`+t[e].name+`]`,o,s).scale(1/n))}return new this(e,-1,a)}static findByName(e,t){let n=e;if(!Array.isArray(e)){let t=e;n=t.geometry&&t.geometry.animations||t.animations}for(let e=0;e<n.length;e++)if(n[e].name===t)return n[e];return null}static CreateClipsFromMorphTargetSequences(e,t,n){let r={},i=/^([\\w-]*?)([\\d]+)$/;for(let t=0,n=e.length;t<n;t++){let n=e[t],a=n.name.match(i);if(a&&a.length>1){let e=a[1],t=r[e];t||(r[e]=t=[]),t.push(n)}}let a=[];for(let e in r)a.push(this.CreateFromMorphTargetSequence(e,r[e],t,n));return a}resetDuration(){let e=this.tracks,t=0;for(let n=0,r=e.length;n!==r;++n){let e=this.tracks[n];t=Math.max(t,e.times[e.times.length-1])}return this.duration=t,this}trim(){for(let e=0;e<this.tracks.length;e++)this.tracks[e].trim(0,this.duration);return this}validate(){let e=!0;for(let t=0;t<this.tracks.length;t++)e&&=this.tracks[t].validate();return e}optimize(){for(let e=0;e<this.tracks.length;e++)this.tracks[e].optimize();return this}clone(){let e=[];for(let t=0;t<this.tracks.length;t++)e.push(this.tracks[t].clone());let t=new this.constructor(this.name,this.duration,e,this.blendMode);return t.userData=JSON.parse(JSON.stringify(this.userData)),t}toJSON(){return this.constructor.toJSON(this)}};function ni(e){switch(e.toLowerCase()){case`scalar`:case`double`:case`float`:case`number`:case`integer`:return Xr;case`vector`:case`vector2`:case`vector3`:case`vector4`:return ei;case`color`:return Yr;case`quaternion`:return Qr;case`bool`:case`boolean`:return Jr;case`string`:return $r}throw Error(`THREE.KeyframeTrack: Unsupported typeName: `+e)}function ri(e){if(e.type===void 0)throw Error(`THREE.KeyframeTrack: track type undefined, can not parse`);let t=ni(e.type);if(e.times===void 0){let t=[],n=[];Lr(e.keys,t,n,`value`),e.times=t,e.values=n}let n;return n=t.parse===void 0?new t(e.name,e.times,e.values,e.interpolation):t.parse(e),Pr(e.settings)&&(n.settings={inTangents:Nr(e.settings.inTangents,Float32Array),outTangents:Nr(e.settings.outTangents,Float32Array)}),n}let ii={enabled:!1,files:{},add:function(e,t){this.enabled!==!1&&(ai(e)||(this.files[e]=t))},get:function(e){if(this.enabled!==!1&&!ai(e))return this.files[e]},remove:function(e){delete this.files[e]},clear:function(){this.files={}}};function ai(e){try{let t=e.slice(e.indexOf(`:`)+1);return new URL(t).protocol===`blob:`}catch{return!1}}let oi=/*@__PURE__*/ new class{constructor(e,t,n){let r=this,i=!1,a=0,o=0,s,c=[];this.onStart=void 0,this.onLoad=e,this.onProgress=t,this.onError=n,this._abortController=null,this.itemStart=function(e){o++,i===!1&&r.onStart!==void 0&&r.onStart(e,a,o),i=!0},this.itemEnd=function(e){a++,r.onProgress!==void 0&&r.onProgress(e,a,o),a===o&&(i=!1,r.onLoad!==void 0&&r.onLoad())},this.itemError=function(e){r.onError!==void 0&&r.onError(e)},this.resolveURL=function(e){return e=e.normalize(`NFC`),s?s(e):e},this.setURLModifier=function(e){return s=e,this},this.addHandler=function(e,t){return c.push(e,t),this},this.removeHandler=function(e){let t=c.indexOf(e);return t!==-1&&c.splice(t,2),this},this.getHandler=function(e){for(let t=0,n=c.length;t<n;t+=2){let n=c[t],r=c[t+1];if(n.global&&(n.lastIndex=0),n.test(e))return r}return null},this.abort=function(){return this.abortController.abort(),this._abortController=null,this}}get abortController(){return this._abortController||=new AbortController,this._abortController}};var si=class{constructor(e){this.manager=e===void 0?oi:e,this.crossOrigin=`anonymous`,this.withCredentials=!1,this.path=``,this.resourcePath=``,this.requestHeader={},typeof __THREE_DEVTOOLS__<`u`&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`observe`,{detail:this}))}load(){}loadAsync(e,t){let n=this;return new Promise(function(r,i){n.load(e,r,t,i)})}parse(){}setCrossOrigin(e){return this.crossOrigin=e,this}setWithCredentials(e){return this.withCredentials=e,this}setPath(e){return this.path=e,this}setResourcePath(e){return this.resourcePath=e,this}setRequestHeader(e){return this.requestHeader=e,this}abort(){return this}};si.DEFAULT_MATERIAL_NAME=`__DEFAULT`;let ci={};var li=class extends Error{constructor(e,t){super(e),this.response=t}},ui=class extends si{constructor(e){super(e),this.mimeType=``,this.responseType=``,this._abortController=new AbortController}load(e,t,n,r){e===void 0&&(e=``),this.path!==void 0&&(e=this.path+e),e=this.manager.resolveURL(e);let i=ii.get(`file:${e}`);if(i!==void 0){this.manager.itemStart(e),setTimeout(()=>{t&&t(i),this.manager.itemEnd(e)},0);return}if(ci[e]!==void 0){ci[e].push({onLoad:t,onProgress:n,onError:r});return}ci[e]=[],ci[e].push({onLoad:t,onProgress:n,onError:r});let a=new Request(e,{headers:new Headers(this.requestHeader),credentials:this.withCredentials?`include`:`same-origin`,signal:typeof AbortSignal.any==`function`?AbortSignal.any([this._abortController.signal,this.manager.abortController.signal]):this._abortController.signal}),o=this.mimeType,s=this.responseType;fetch(a).then(t=>{if(t.status===200||t.status===0){if(t.status===0&&O(`FileLoader: HTTP Status 0 received.`),typeof ReadableStream>`u`||t.body===void 0||t.body.getReader===void 0)return t;let n=ci[e],r=t.body.getReader(),i=t.headers.get(`X-File-Size`)||t.headers.get(`Content-Length`),a=i?parseInt(i):0,o=a!==0,s=0,c=new ReadableStream({start(e){t();function t(){r.read().then(({done:r,value:i})=>{if(r)e.close();else{s+=i.byteLength;let r=new ProgressEvent(`progress`,{lengthComputable:o,loaded:s,total:a});for(let e=0,t=n.length;e<t;e++){let t=n[e];t.onProgress&&t.onProgress(r)}e.enqueue(i),t()}},t=>{e.error(t)})}}});return new Response(c)}throw new li(`fetch for \"${t.url}\" responded with ${t.status}: ${t.statusText}`,t)}).then(e=>{switch(s){case`arraybuffer`:return e.arrayBuffer();case`blob`:return e.blob();case`document`:return e.text().then(e=>new DOMParser().parseFromString(e,o));case`json`:return e.json();default:if(o===``)return e.text();{let t=/charset=\"?([^;\"\\s]*)\"?/i.exec(o),n=t&&t[1]?t[1].toLowerCase():void 0,r=new TextDecoder(n);return e.arrayBuffer().then(e=>r.decode(e))}}}).then(t=>{ii.add(`file:${e}`,t);let n=ci[e];delete ci[e];for(let e=0,r=n.length;e<r;e++){let r=n[e];r.onLoad&&r.onLoad(t)}}).catch(t=>{let n=ci[e];if(n===void 0)throw this.manager.itemError(e),t;delete ci[e];for(let e=0,r=n.length;e<r;e++){let r=n[e];r.onError&&r.onError(t)}this.manager.itemError(e)}).finally(()=>{this.manager.itemEnd(e)}),this.manager.itemStart(e)}setResponseType(e){return this.responseType=e,this}setMimeType(e){return this.mimeType=e,this}abort(){return this._abortController.abort(),this._abortController=new AbortController,this}};let di=/* @__PURE__ */ new WeakMap;var fi=class extends si{constructor(e){super(e)}load(e,t,n,r){this.path!==void 0&&(e=this.path+e),e=this.manager.resolveURL(e);let i=this,a=ii.get(`image:${e}`);if(a!==void 0){if(a.complete===!0)i.manager.itemStart(e),setTimeout(function(){t&&t(a),i.manager.itemEnd(e)},0);else{let e=di.get(a);e===void 0&&(e=[],di.set(a,e)),e.push({onLoad:t,onError:r})}return a}let o=w(`img`);function s(){l(),t&&t(this);let n=di.get(this)||[];for(let e=0;e<n.length;e++){let t=n[e];t.onLoad&&t.onLoad(this)}di.delete(this),i.manager.itemEnd(e)}function c(t){l(),r&&r(t),ii.remove(`image:${e}`);let n=di.get(this)||[];for(let e=0;e<n.length;e++){let r=n[e];r.onError&&r.onError(t)}di.delete(this),i.manager.itemError(e),i.manager.itemEnd(e)}function l(){o.removeEventListener(`load`,s,!1),o.removeEventListener(`error`,c,!1)}return o.addEventListener(`load`,s,!1),o.addEventListener(`error`,c,!1),e.slice(0,5)!==`data:`&&this.crossOrigin!==void 0&&(o.crossOrigin=this.crossOrigin),ii.add(`image:${e}`,o),i.manager.itemStart(e),o.src=e,o}},pi=class extends si{constructor(e){super(e)}load(e,t,n,r){let i=new Le,a=new fi(this.manager);return a.setCrossOrigin(this.crossOrigin),a.setPath(this.path),a.load(e,function(e){i.image=e,i.needsUpdate=!0,t!==void 0&&t(i)},n,r),i}},mi=class extends W{constructor(e,t=1){super(),this.isLight=!0,this.type=`Light`,this.color=new G(e),this.intensity=t}copy(e,t){return super.copy(e,t),this.color.copy(e.color),this.intensity=e.intensity,this}toJSON(e){let t=super.toJSON(e);return t.object.color=this.color.getHex(),t.object.intensity=this.intensity,t}};let hi=/*@__PURE__*/ new H,gi=/*@__PURE__*/ new B,_i=/*@__PURE__*/ new B;var vi=class{constructor(e){this.camera=e,this.intensity=1,this.bias=0,this.biasNode=null,this.normalBias=0,this.radius=1,this.blurSamples=8,this.mapSize=new z(512,512),this.mapType=o,this.map=null,this.mapPass=null,this.matrix=new H,this.autoUpdate=!0,this.needsUpdate=!1,this._frustum=new cr,this._frameExtents=new z(1,1),this._viewportCount=1,this._viewports=[new Re(0,0,1,1)]}getViewportCount(){return this._viewportCount}getCamera(){return this.camera}getFrustum(){return this._frustum}updateMatrices(e){let t=this.camera;gi.setFromMatrixPosition(e.matrixWorld),t.position.copy(gi),_i.setFromMatrixPosition(e.target.matrixWorld),t.lookAt(_i),t.updateMatrixWorld(),this._updateMatrix(t,this.matrix,this._frustum)}_updateMatrix(e,t,n,r){hi.multiplyMatrices(e.projectionMatrix,e.matrixWorldInverse),n.setFromProjectionMatrix(hi,e.coordinateSystem,e.reversedDepth);let i=this._frameExtents,a=r?r.z/i.x:1,o=r?r.w/i.y:1,s=r?r.x/i.x:0,c=r?r.y/i.y:0;e.coordinateSystem===2001||e.reversedDepth?t.set(.5*a,0,0,.5*a+s,0,.5*o,0,.5*o+c,0,0,1,0,0,0,0,1):t.set(.5*a,0,0,.5*a+s,0,.5*o,0,.5*o+c,0,0,.5,.5,0,0,0,1),t.multiply(hi)}getViewport(e){return this._viewports[e]}getFrameExtents(){return this._frameExtents}dispose(){this.map&&this.map.dispose(),this.mapPass&&this.mapPass.dispose()}copy(e){return this.camera=e.camera.clone(),this.intensity=e.intensity,this.bias=e.bias,this.radius=e.radius,this.autoUpdate=e.autoUpdate,this.needsUpdate=e.needsUpdate,this.normalBias=e.normalBias,this.blurSamples=e.blurSamples,this.mapSize.copy(e.mapSize),this.biasNode=e.biasNode,this}clone(){return new this.constructor().copy(this)}toJSON(){let e={};return e.intensity=this.intensity,e.bias=this.bias,e.normalBias=this.normalBias,e.radius=this.radius,e.blurSamples=this.blurSamples,e.mapSize=this.mapSize.toArray(),e.camera=this.camera.toJSON(!1).object,delete e.camera.matrix,e}};let yi=/*@__PURE__*/ new B,bi=/*@__PURE__*/ new be,xi=/*@__PURE__*/ new B;var Si=class extends W{constructor(){super(),this.isCamera=!0,this.type=`Camera`,this.matrixWorldInverse=new H,this.projectionMatrix=new H,this.projectionMatrixInverse=new H,this.coordinateSystem=x,this._reversedDepth=!1}get reversedDepth(){return this._reversedDepth}copy(e,t){return super.copy(e,t),this.matrixWorldInverse.copy(e.matrixWorldInverse),this.projectionMatrix.copy(e.projectionMatrix),this.projectionMatrixInverse.copy(e.projectionMatrixInverse),this.coordinateSystem=e.coordinateSystem,this}getWorldDirection(e){return super.getWorldDirection(e).negate()}updateMatrixWorld(e){super.updateMatrixWorld(e),this.matrixWorld.decompose(yi,bi,xi),xi.x===1&&xi.y===1&&xi.z===1?this.matrixWorldInverse.copy(this.matrixWorld).invert():this.matrixWorldInverse.compose(yi,bi,xi.set(1,1,1)).invert()}updateWorldMatrix(e,t,n=!1){super.updateWorldMatrix(e,t,n),this.matrixWorld.decompose(yi,bi,xi),xi.x===1&&xi.y===1&&xi.z===1?this.matrixWorldInverse.copy(this.matrixWorld).invert():this.matrixWorldInverse.compose(yi,bi,xi.set(1,1,1)).invert()}clone(){return new this.constructor().copy(this)}};let Ci=/*@__PURE__*/ new B,wi=/*@__PURE__*/ new z,Ti=/*@__PURE__*/ new z;var Ei=class extends Si{constructor(e=50,t=1,n=.1,r=2e3){super(),this.isPerspectiveCamera=!0,this.type=`PerspectiveCamera`,this.fov=e,this.zoom=1,this.near=n,this.far=r,this.focus=10,this.aspect=t,this.view=null,this.filmGauge=35,this.filmOffset=0,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.fov=e.fov,this.zoom=e.zoom,this.near=e.near,this.far=e.far,this.focus=e.focus,this.aspect=e.aspect,this.view=e.view===null?null:Object.assign({},e.view),this.filmGauge=e.filmGauge,this.filmOffset=e.filmOffset,this}setFocalLength(e){let t=.5*this.getFilmHeight()/e;this.fov=F*2*Math.atan(t),this.updateProjectionMatrix()}getFocalLength(){let e=Math.tan(P*.5*this.fov);return .5*this.getFilmHeight()/e}getEffectiveFOV(){return F*2*Math.atan(Math.tan(P*.5*this.fov)/this.zoom)}getFilmWidth(){return this.filmGauge*Math.min(this.aspect,1)}getFilmHeight(){return this.filmGauge/Math.max(this.aspect,1)}getViewBounds(e,t,n){Ci.set(-1,-1,.5).applyMatrix4(this.projectionMatrixInverse),t.set(Ci.x,Ci.y).multiplyScalar(-e/Ci.z),Ci.set(1,1,.5).applyMatrix4(this.projectionMatrixInverse),n.set(Ci.x,Ci.y).multiplyScalar(-e/Ci.z)}getViewSize(e,t){return this.getViewBounds(e,wi,Ti),t.subVectors(Ti,wi)}setViewOffset(e,t,n,r,i,a){this.aspect=e/t,this.view===null&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=r,this.view.width=i,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){this.view!==null&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){let e=this.near,t=e*Math.tan(P*.5*this.fov)/this.zoom,n=2*t,r=this.aspect*n,i=-.5*r,a=this.view;if(this.view!==null&&this.view.enabled){let e=a.fullWidth,o=a.fullHeight;i+=a.offsetX*r/e,t-=a.offsetY*n/o,r*=a.width/e,n*=a.height/o}let o=this.filmOffset;o!==0&&(i+=e*o/this.getFilmWidth()),this.projectionMatrix.makePerspective(i,i+r,t,t-n,e,this.far,this.coordinateSystem,this.reversedDepth),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){let t=super.toJSON(e);return t.object.fov=this.fov,t.object.zoom=this.zoom,t.object.near=this.near,t.object.far=this.far,t.object.focus=this.focus,t.object.aspect=this.aspect,this.view!==null&&(t.object.view=Object.assign({},this.view)),t.object.filmGauge=this.filmGauge,t.object.filmOffset=this.filmOffset,t}},Di=class extends vi{constructor(){super(new Ei(50,1,.5,500)),this.isSpotLightShadow=!0,this.focus=1,this.aspect=1}updateMatrices(e){let t=this.camera,n=F*2*e.angle*this.focus,r=this.mapSize.width/this.mapSize.height*this.aspect,i=e.distance||t.far;(n!==t.fov||r!==t.aspect||i!==t.far)&&(t.fov=n,t.aspect=r,t.far=i,t.updateProjectionMatrix()),super.updateMatrices(e)}copy(e){return super.copy(e),this.focus=e.focus,this.aspect=e.aspect,this}toJSON(){let e=super.toJSON();return e.focus=this.focus,e.aspect=this.aspect,e}},Oi=class extends mi{constructor(e,t,n=0,r=Math.PI/3,i=0,a=2){super(e,t),this.isSpotLight=!0,this.type=`SpotLight`,this.position.copy(W.DEFAULT_UP),this.updateMatrix(),this.target=new W,this.distance=n,this.angle=r,this.penumbra=i,this.decay=a,this.map=null,this.shadow=new Di}get power(){return this.intensity*Math.PI}set power(e){this.intensity=e/Math.PI}dispose(){super.dispose(),this.shadow.dispose()}copy(e,t){return super.copy(e,t),this.distance=e.distance,this.angle=e.angle,this.penumbra=e.penumbra,this.decay=e.decay,this.target=e.target.clone(),this.map=e.map,this.shadow=e.shadow.clone(),this}toJSON(e){let t=super.toJSON(e);return t.object.distance=this.distance,t.object.angle=this.angle,t.object.decay=this.decay,t.object.penumbra=this.penumbra,t.object.target=this.target.uuid,this.map&&this.map.isTexture&&(t.object.map=this.map.toJSON(e).uuid),t.object.shadow=this.shadow.toJSON(),t}},ki=class extends vi{constructor(){super(new Ei(90,1,.5,500)),this.isPointLightShadow=!0}},Ai=class extends mi{constructor(e,t,n=0,r=2){super(e,t),this.isPointLight=!0,this.type=`PointLight`,this.distance=n,this.decay=r,this.shadow=new ki}get power(){return this.intensity*4*Math.PI}set power(e){this.intensity=e/(4*Math.PI)}dispose(){super.dispose(),this.shadow.dispose()}copy(e,t){return super.copy(e,t),this.distance=e.distance,this.decay=e.decay,this.shadow=e.shadow.clone(),this}toJSON(e){let t=super.toJSON(e);return t.object.distance=this.distance,t.object.decay=this.decay,t.object.shadow=this.shadow.toJSON(),t}},ji=class extends Si{constructor(e=-1,t=1,n=1,r=-1,i=.1,a=2e3){super(),this.isOrthographicCamera=!0,this.type=`OrthographicCamera`,this.zoom=1,this.view=null,this.left=e,this.right=t,this.top=n,this.bottom=r,this.near=i,this.far=a,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.left=e.left,this.right=e.right,this.top=e.top,this.bottom=e.bottom,this.near=e.near,this.far=e.far,this.zoom=e.zoom,this.view=e.view===null?null:Object.assign({},e.view),this}setViewOffset(e,t,n,r,i,a){this.view===null&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=r,this.view.width=i,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){this.view!==null&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){let e=(this.right-this.left)/(2*this.zoom),t=(this.top-this.bottom)/(2*this.zoom),n=(this.right+this.left)/2,r=(this.top+this.bottom)/2,i=n-e,a=n+e,o=r+t,s=r-t;if(this.view!==null&&this.view.enabled){let e=(this.right-this.left)/this.view.fullWidth/this.zoom,t=(this.top-this.bottom)/this.view.fullHeight/this.zoom;i+=e*this.view.offsetX,a=i+e*this.view.width,o-=t*this.view.offsetY,s=o-t*this.view.height}this.projectionMatrix.makeOrthographic(i,a,o,s,this.near,this.far,this.coordinateSystem,this.reversedDepth),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){let t=super.toJSON(e);return t.object.zoom=this.zoom,t.object.left=this.left,t.object.right=this.right,t.object.top=this.top,t.object.bottom=this.bottom,t.object.near=this.near,t.object.far=this.far,this.view!==null&&(t.object.view=Object.assign({},this.view)),t}},Mi=class extends vi{constructor(){super(new ji(-5,5,5,-5,.5,500)),this.isDirectionalLightShadow=!0}},Ni=class extends mi{constructor(e,t){super(e,t),this.isDirectionalLight=!0,this.type=`DirectionalLight`,this.position.copy(W.DEFAULT_UP),this.updateMatrix(),this.target=new W,this.shadow=new Mi}dispose(){super.dispose(),this.shadow.dispose()}copy(e){return super.copy(e),this.target=e.target.clone(),this.shadow=e.shadow.clone(),this}toJSON(e){let t=super.toJSON(e);return t.object.shadow=this.shadow.toJSON(),t.object.target=this.target.uuid,t}},Pi=class{static extractUrlBase(e){let t=e.lastIndexOf(`/`);return t===-1?`./`:e.slice(0,t+1)}static resolveURL(e,t){return typeof e!=`string`||e===``?``:(/^https?:\\/\\//i.test(t)&&/^\\//.test(e)&&(t=t.replace(/(^https?:\\/\\/[^\\/]+).*/i,`$1`)),/^(https?:)?\\/\\//i.test(e)||/^data:.*,.*$/i.test(e)||/^blob:.*$/i.test(e)?e:t+e)}};let Fi=/* @__PURE__ */ new WeakMap;var Ii=class extends si{constructor(e){super(e),this.isImageBitmapLoader=!0,typeof createImageBitmap>`u`&&O(`ImageBitmapLoader: createImageBitmap() not supported.`),typeof fetch>`u`&&O(`ImageBitmapLoader: fetch() not supported.`),this.options={premultiplyAlpha:`none`},this._abortController=new AbortController}setOptions(e){return this.options=e,this}load(e,t,n,r){e===void 0&&(e=``),this.path!==void 0&&(e=this.path+e),e=this.manager.resolveURL(e);let i=this,a=ii.get(`image-bitmap:${e}`);if(a!==void 0){if(i.manager.itemStart(e),a.then){a.then(n=>{Fi.has(a)===!0?(r&&r(Fi.get(a)),i.manager.itemError(e),i.manager.itemEnd(e)):(t&&t(n),i.manager.itemEnd(e))});return}setTimeout(function(){t&&t(a),i.manager.itemEnd(e)},0);return}let o={};o.credentials=this.crossOrigin===`anonymous`?`same-origin`:`include`,o.headers=this.requestHeader,o.signal=typeof AbortSignal.any==`function`?AbortSignal.any([this._abortController.signal,this.manager.abortController.signal]):this._abortController.signal;let s=fetch(e,o).then(function(e){return e.blob()}).then(function(e){return createImageBitmap(e,Object.assign({},i.options,{colorSpaceConversion:`none`}))}).then(function(n){return ii.add(`image-bitmap:${e}`,n),t&&t(n),i.manager.itemEnd(e),n}).catch(function(t){r&&r(t),Fi.set(s,t),ii.remove(`image-bitmap:${e}`),i.manager.itemError(e),i.manager.itemEnd(e)});ii.add(`image-bitmap:${e}`,s),i.manager.itemStart(e)}abort(){return this._abortController.abort(),this._abortController=new AbortController,this}};let Li=/* @__PURE__ */ RegExp(`[\\\\[\\\\]\\\\.:\\\\/]`,`g`),Ri=/* @__PURE__ */ RegExp(`^((?:[^\\\\[\\\\]\\\\.:\\\\/]+[\\\\/:])*)([^\\\\[\\\\]:\\\\/]+)?(?:\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?)?\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?$`),zi=[`material`,`materials`,`bones`,`map`];var Bi=class{constructor(e,t,n){let r=n||Z.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,r)}getValue(e,t){this.bind();let n=this._targetGroup.nCachedObjects_,r=this._bindings[n];r!==void 0&&r.getValue(e,t)}setValue(e,t){let n=this._bindings;for(let r=this._targetGroup.nCachedObjects_,i=n.length;r!==i;++r)n[r].setValue(e,t)}bind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},Z=class e{constructor(t,n,r){this.path=n,this.parsedPath=r||e.parseTrackName(n),this.node=e.findNode(t,this.parsedPath.nodeName),this.rootNode=t,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(t,n,r){return t&&t.isAnimationObjectGroup?new e.Composite(t,n,r):new e(t,n,r)}static sanitizeNodeName(e){return e.replace(/\\s/g,`_`).replace(Li,``)}static parseTrackName(e){let t=Ri.exec(e);if(t===null)throw Error(`THREE.PropertyBinding: Cannot parse trackName: `+e);let n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},r=n.nodeName&&n.nodeName.lastIndexOf(`.`);if(r!==void 0&&r!==-1){let e=n.nodeName.substring(r+1);zi.indexOf(e)!==-1&&(n.nodeName=n.nodeName.substring(0,r),n.objectName=e)}if(n.propertyName===null||n.propertyName.length===0)throw Error(`THREE.PropertyBinding: can not parse propertyName from trackName: `+e);return n}static findNode(e,t){if(t===void 0||t===``||t===`.`||t===-1||t===e.name||t===e.uuid)return e;if(e.skeleton){let n=e.skeleton.getBoneByName(t);if(n!==void 0)return n}if(e.children){let n=function(e){for(let r=0;r<e.length;r++){let i=e[r];if(i.name===t||i.uuid===t)return i;let a=n(i.children);if(a)return a}return null},r=n(e.children);if(r)return r}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)e[t++]=n[r]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++]}_setValue_array_setNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let t=this.node,n=this.parsedPath,r=n.objectName,i=n.propertyName,a=n.propertyIndex;if(t||(t=e.findNode(this.rootNode,n.nodeName),this.node=t),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!t){O(`PropertyBinding: No target node found for track: `+this.path+`.`);return}if(r){let e=n.objectIndex;switch(r){case`materials`:if(!t.material){k(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.materials){k(`PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.`,this);return}t=t.material.materials;break;case`bones`:if(!t.skeleton){k(`PropertyBinding: Can not bind to bones as node does not have a skeleton.`,this);return}t=t.skeleton.bones;for(let n=0;n<t.length;n++)if(t[n].name===e){e=n;break}break;case`map`:if(`map`in t){t=t.map;break}if(!t.material){k(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.map){k(`PropertyBinding: Can not bind to material.map as node.material does not have a map.`,this);return}t=t.material.map;break;default:if(t[r]===void 0){k(`PropertyBinding: Can not bind to objectName of node undefined.`,this);return}t=t[r]}if(e!==void 0){if(t[e]===void 0){k(`PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.`,this,t);return}t=t[e]}}let o=t[i];if(o===void 0){let e=n.nodeName;k(`PropertyBinding: Trying to update property for track: `+e+`.`+i+` but it wasn't found.`,t);return}let s=this.Versioning.None;this.targetObject=t,t.isMaterial===!0?s=this.Versioning.NeedsUpdate:t.isObject3D===!0&&(s=this.Versioning.MatrixWorldNeedsUpdate);let c=this.BindingType.Direct;if(a!==void 0){if(i===`morphTargetInfluences`){if(!t.geometry){k(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.`,this);return}if(!t.geometry.morphAttributes){k(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.`,this);return}t.morphTargetDictionary[a]!==void 0&&(a=t.morphTargetDictionary[a])}c=this.BindingType.ArrayElement,this.resolvedProperty=o,this.propertyIndex=a}else o.fromArray!==void 0&&o.toArray!==void 0?(c=this.BindingType.HasFromToArray,this.resolvedProperty=o):Array.isArray(o)?(c=this.BindingType.EntireArray,this.resolvedProperty=o):this.propertyName=i;this.getValue=this.GetterByBindingType[c],this.setValue=this.SetterByBindingTypeAndVersioning[c][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}};Z.Composite=Bi,Z.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},Z.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},Z.prototype.GetterByBindingType=[Z.prototype._getValue_direct,Z.prototype._getValue_array,Z.prototype._getValue_arrayElement,Z.prototype._getValue_toArray],Z.prototype.SetterByBindingTypeAndVersioning=[[Z.prototype._setValue_direct,Z.prototype._setValue_direct_setNeedsUpdate,Z.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[Z.prototype._setValue_array,Z.prototype._setValue_array_setNeedsUpdate,Z.prototype._setValue_array_setMatrixWorldNeedsUpdate],[Z.prototype._setValue_arrayElement,Z.prototype._setValue_arrayElement_setNeedsUpdate,Z.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[Z.prototype._setValue_fromArray,Z.prototype._setValue_fromArray_setNeedsUpdate,Z.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],class e{static{e.prototype.isMatrix2=!0}constructor(e,t,n,r){this.elements=[1,0,0,1],e!==void 0&&this.set(e,t,n,r)}identity(){return this.set(1,0,0,1),this}fromArray(e,t=0){for(let n=0;n<4;n++)this.elements[n]=e[n+t];return this}set(e,t,n,r){let i=this.elements;return i[0]=e,i[2]=t,i[1]=n,i[3]=r,this}},typeof __THREE_DEVTOOLS__<`u`&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`register`,{detail:{revision:`186`}})),typeof window<`u`&&(window.__THREE__?O(`WARNING: Multiple instances of Three.js being imported.`):window.__THREE__=`186`);function Vi(e,t=1e-4){t=Math.max(t,2**-52);let n={},r=e.getIndex(),i=e.getAttribute(`position`),a=r?r.count:i.count,o=0,s=Object.keys(e.attributes),c={},l={},u=[],d=[`getX`,`getY`,`getZ`,`getW`],f=[`setX`,`setY`,`setZ`,`setW`];for(let t=0,n=s.length;t<n;t++){let n=s[t],r=e.attributes[n];c[n]=new r.constructor(new r.array.constructor(r.count*r.itemSize),r.itemSize,r.normalized);let i=e.morphAttributes[n];i&&(l[n]||(l[n]=[]),i.forEach((e,t)=>{let r=new e.array.constructor(e.count*e.itemSize);l[n][t]=new e.constructor(r,e.itemSize,e.normalized)}))}let p=t*.5,m=10**Math.log10(1/t),h=p*m;for(let t=0;t<a;t++){let i=r?r.getX(t):t,a=``;for(let t=0,n=s.length;t<n;t++){let n=s[t],r=e.getAttribute(n),o=r.itemSize;for(let e=0;e<o;e++)a+=`${Math.trunc(r[d[e]](i)*m+h)},`}if(a in n)u.push(n[a]);else{for(let t=0,n=s.length;t<n;t++){let n=s[t],r=e.getAttribute(n),a=e.morphAttributes[n],u=r.itemSize,p=c[n],m=l[n];for(let e=0;e<u;e++){let t=d[e],n=f[e];if(p[n](o,r[t](i)),a)for(let e=0,r=a.length;e<r;e++)m[e][n](o,a[e][t](i))}}n[a]=o,u.push(o),o++}}let g=e.clone();for(let t in e.attributes){let e=c[t];if(g.setAttribute(t,new e.constructor(e.array.slice(0,o*e.itemSize),e.itemSize,e.normalized)),t in l)for(let e=0;e<l[t].length;e++){let n=l[t][e];g.morphAttributes[t][e]=new n.constructor(n.array.slice(0,o*n.itemSize),n.itemSize,n.normalized)}}return g.setIndex(u),g}function Hi(e,t){if(t===0)return console.warn(`THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.`),e;if(t===2||t===1){let n=e.getIndex();if(n===null){let t=[],r=e.getAttribute(`position`);if(r!==void 0){for(let e=0;e<r.count;e++)t.push(e);e.setIndex(t),n=e.getIndex()}else return console.error(`THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.`),e}let r=n.count-2,i=[];if(t===2)for(let e=1;e<=r;e++)i.push(n.getX(0)),i.push(n.getX(e)),i.push(n.getX(e+1));else for(let e=0;e<r;e++)e%2==0?(i.push(n.getX(e)),i.push(n.getX(e+1)),i.push(n.getX(e+2))):(i.push(n.getX(e+2)),i.push(n.getX(e+1)),i.push(n.getX(e)));return i.length/3!==r&&console.error(`THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.`),e.setIndex(i),e.clearGroups(),e}return console.error(`THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:`,t),e}var Ui=(function(){var e=`b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuixkbeeeddddillviebeoweuecj:Gdkr;Neqo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949WboY9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVJ9V29VVbrl79IV9Rbwq:VZkdbk:XYi5ud9:du8Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnalTmbcuhoaiRbbgrc;WeGc:Ge9hmbarcsGgwce0mbc9:hoalcufadcd4cbawEgDadfgrcKcaawEgqaraq0Egk6mbaicefhxcj;abad9Uc;WFbGcjdadca0EhmaialfgPar9Rgoadfhsavaoadz:jjjjbgzceVhHcbhOdndninaeaO9nmeaPax9RaD6mdamaeaO9RaOamfgoae6EgAcsfglc9WGhCabaOad2fhXaAcethQaxaDfhiaOaeaoaeao6E9RhLalcl4cifcd4hKazcj;cbfaAfhYcbh8AazcjdfhEaHh3incbh5dnawTmbaxa8Acd4fRbbh5kcbh8Eazcj;cbfhqinaih8Fdndndndna5a8Ecet4ciGgoc9:fPdebdkaPa8F9RaA6mrazcj;cbfa8EaA2fa8FaAz:jjjjb8Aa8FaAfhixdkazcj;cbfa8EaA2fcbaAz:kjjjb8Aa8FhixekaPa8F9RaK6mva8FaKfhidnaCTmbaPai9RcK6mbaocdtc:q:G:cjbfcj:G:cjbawEhaczhrcbhlinargoc9Wfghaqfhrdndndndndndnaaa8Fahco4fRbbalcoG4ciGcdtfydbPDbedvivvvlvkar9cb83bwar9cb83bbxlkarcbaiRbdai8Xbb9c:c:qj:bw9:9c:q;c1:I1e:d9c:b:c:e1z9:gg9cjjjjjz:dg8J9qE86bbaqaofgrcGfcbaicdfa8J9c8N1:NfghRbbag9cjjjjjw:dg8J9qE86bbarcVfcbaha8J9c8M1:NfghRbbag9cjjjjjl:dg8J9qE86bbarc7fcbaha8J9c8L1:NfghRbbag9cjjjjjd:dg8J9qE86bbarctfcbaha8J9c8K1:NfghRbbag9cjjjjje:dg8J9qE86bbarc91fcbaha8J9c8J1:NfghRbbag9cjjjj;ab:dg8J9qE86bbarc4fcbaha8J9cg1:NfghRbbag9cjjjja:dg8J9qE86bbarc93fcbaha8J9ch1:NfghRbbag9cjjjjz:dgg9qE86bbarc94fcbahag9ca1:NfghRbbai8Xbe9c:c:qj:bw9:9c:q;c1:I1e:d9c:b:c:e1z9:gg9cjjjjjz:dg8J9qE86bbarc95fcbaha8J9c8N1:NfgiRbbag9cjjjjjw:dg8J9qE86bbarc96fcbaia8J9c8M1:NfgiRbbag9cjjjjjl:dg8J9qE86bbarc97fcbaia8J9c8L1:NfgiRbbag9cjjjjjd:dg8J9qE86bbarc98fcbaia8J9c8K1:NfgiRbbag9cjjjjje:dg8J9qE86bbarc99fcbaia8J9c8J1:NfgiRbbag9cjjjj;ab:dg8J9qE86bbarc9:fcbaia8J9cg1:NfgiRbbag9cjjjja:dg8J9qE86bbarcufcbaia8J9ch1:NfgiRbbag9cjjjjz:dgg9qE86bbaiag9ca1:NfhixikaraiRblaiRbbghco4g8Ka8KciSg8KE86bbaqaofgrcGfaiclfa8Kfg8KRbbahcl4ciGg8La8LciSg8LE86bbarcVfa8Ka8Lfg8KRbbahcd4ciGg8La8LciSg8LE86bbarc7fa8Ka8Lfg8KRbbahciGghahciSghE86bbarctfa8Kahfg8KRbbaiRbeghco4g8La8LciSg8LE86bbarc91fa8Ka8Lfg8KRbbahcl4ciGg8La8LciSg8LE86bbarc4fa8Ka8Lfg8KRbbahcd4ciGg8La8LciSg8LE86bbarc93fa8Ka8Lfg8KRbbahciGghahciSghE86bbarc94fa8Kahfg8KRbbaiRbdghco4g8La8LciSg8LE86bbarc95fa8Ka8Lfg8KRbbahcl4ciGg8La8LciSg8LE86bbarc96fa8Ka8Lfg8KRbbahcd4ciGg8La8LciSg8LE86bbarc97fa8Ka8Lfg8KRbbahciGghahciSghE86bbarc98fa8KahfghRbbaiRbigico4g8Ka8KciSg8KE86bbarc99faha8KfghRbbaicl4ciGg8Ka8KciSg8KE86bbarc9:faha8KfghRbbaicd4ciGg8Ka8KciSg8KE86bbarcufaha8KfgrRbbaiciGgiaiciSgiE86bbaraifhixdkaraiRbwaiRbbghcl4g8Ka8KcsSg8KE86bbaqaofgrcGfaicwfa8Kfg8KRbbahcsGghahcsSghE86bbarcVfa8KahfghRbbaiRbeg8Kcl4g8La8LcsSg8LE86bbarc7faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarctfaha8KfghRbbaiRbdg8Kcl4g8La8LcsSg8LE86bbarc91faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarc4faha8KfghRbbaiRbig8Kcl4g8La8LcsSg8LE86bbarc93faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarc94faha8KfghRbbaiRblg8Kcl4g8La8LcsSg8LE86bbarc95faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarc96faha8KfghRbbaiRbvg8Kcl4g8La8LcsSg8LE86bbarc97faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarc98faha8KfghRbbaiRbog8Kcl4g8La8LcsSg8LE86bbarc99faha8LfghRbba8KcsGg8Ka8KcsSg8KE86bbarc9:faha8KfghRbbaiRbrgicl4g8Ka8KcsSg8KE86bbarcufaha8KfgrRbbaicsGgiaicsSgiE86bbaraifhixekarai8Pbw83bwarai8Pbb83bbaiczfhikdnaoaC9pmbalcdfhlaoczfhraPai9RcL0mekkaoaC6moaimexokaCmva8FTmvkaqaAfhqa8Ecefg8Ecl9hmbkdndndndnawTmbasa8Acd4fRbbgociGPlbedrbkaATmdaza8Afh8Fazcj;cbfhhcbh8EaEhaina8FRbbhraahocbhlinaoahalfRbbgqce4cbaqceG9R7arfgr86bbaoadfhoaAalcefgl9hmbkaacefhaa8Fcefh8FahaAfhha8Ecefg8Ecl9hmbxikkaATmeaza8Afhaazcj;cbfhhcbhoceh8EaYh8FinaEaofhlaa8Vbbhrcbhoinala8FaofRbbcwtahaofRbbgqVc;:FiGce4cbaqceG9R7arfgr87bbaladfhlaLaocefgofmbka8FaQfh8FcdhoaacdfhaahaQfhha8EceGhlcbh8EalmbxdkkaATmbaocl4h8Eaza8AfRbbhqcwhoa3hlinalRbbaotaqVhqalcefhlaocwfgoca9hmbkcbhhaEh8FaYhainazcj;cbfahfRbbhrcwhoaahlinalRbbaotarVhralaAfhlaocwfgoca9hmbkara8E94aq7hqcbhoa8Fhlinalaqao486bbalcefhlaocwfgoca9hmbka8Fadfh8FaacefhaahcefghaA9hmbkkaEclfhEa3clfh3a8Aclfg8Aad6mbkaXazcjdfaAad2z:jjjjb8AazazcjdfaAcufad2fadz:jjjjb8AaAaOfhOaihxaimbkc9:hoxdkcbc99aPax9RakSEhoxekc9:hokavcj;kbf8Kjjjjbaok:ysezu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnalaeci9UgrcHf6mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:kjjjb8Aav9cu83iUav9cu83i8Wav9cu83iyav9cu83iaav9cu83iKav9cu83izav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhldnaeTmbcmcsaDceSEhkcbhxcbhmcbhrcbhicbhoindnalaq9nmbc9:hoxikdndnawRbbgDc;Ve0mbavc;abfaoaDcu7gPcl4fcsGcitfgsydlhzasydbhHdndnaDcsGgsak9pmbavaiaPfcsGcdtfydbaxasEhDaxasTgOfhxxekdndnascsSmbcehOasc987asamffcefhDxekalcefhDal8SbbgscFeGhPdndnascu9mmbaDhlxekalcvfhlaPcFbGhPcrhsdninaD8SbbgOcFbGastaPVhPaOcu9kmeaDcefhDascrfgsc8J9hmbxdkkaDcefhlkcehOaPce4cbaPceG9R7amfhDkaDhmkavc;abfaocitfgsaDBdbasazBdlavaicdtfaDBdbavc;abfaocefcsGcitfgsaHBdbasaDBdlaocdfhoaOaifhidnadcd9hmbabarcetfgsaH87ebasclfaD87ebascdfaz87ebxdkabarcdtfgsaHBdbascwfaDBdbasclfazBdbxekdnaDcpe0mbavaiaqaDcsGfRbbgscl4gP9RcsGcdtfydbaxcefgOaPEhDavaias9RcsGcdtfydbaOaPTgzfgOascsGgPEhsaPThPdndnadcd9hmbabarcetfgHax87ebaHclfas87ebaHcdfaD87ebxekabarcdtfgHaxBdbaHcwfasBdbaHclfaDBdbkavaicdtfaxBdbavc;abfaocitfgHaDBdbaHaxBdlavaicefgicsGcdtfaDBdbavc;abfaocefcsGcitfgHasBdbaHaDBdlavaiazfgicsGcdtfasBdbavc;abfaocdfcsGcitfgDaxBdbaDasBdlaocifhoaiaPfhiaOaPfhxxekaxcbalRbbgsEgHaDc;:eSgDfhOascsGhAdndnascl4gCmbaOcefhzxekaOhzavaiaC9RcsGcdtfydbhOkdndnaAmbazcefhxxekazhxavaias9RcsGcdtfydbhzkdndnaDTmbalcefhDxekalcdfhDal8SbegPcFeGhsdnaPcu9kmbalcofhHascFbGhscrhldninaD8SbbgPcFbGaltasVhsaPcu9kmeaDcefhDalcrfglc8J9hmbkaHhDxekaDcefhDkasce4cbasceG9R7amfgmhHkdndnaCcsSmbaDhsxekaDcefhsaD8SbbglcFeGhPdnalcu9kmbaDcvfhOaPcFbGhPcrhldninas8SbbgDcFbGaltaPVhPaDcu9kmeascefhsalcrfglc8J9hmbkaOhsxekascefhskaPce4cbaPceG9R7amfgmhOkdndnaAcsSmbashlxekascefhlas8SbbgDcFeGhPdnaDcu9kmbascvfhzaPcFbGhPcrhDdninal8SbbgscFbGaDtaPVhPascu9kmealcefhlaDcrfgDc8J9hmbkazhlxekalcefhlkaPce4cbaPceG9R7amfgmhzkdndnadcd9hmbabarcetfgDaH87ebaDclfaz87ebaDcdfaO87ebxekabarcdtfgDaHBdbaDcwfazBdbaDclfaOBdbkavc;abfaocitfgDaOBdbaDaHBdlavaicdtfaHBdbavc;abfaocefcsGcitfgDazBdbaDaOBdlavaicefgicsGcdtfaOBdbavc;abfaocdfcsGcitfgDaHBdbaDazBdlavaiaCTaCcsSVfgicsGcdtfazBdbaiaATaAcsSVfhiaocifhokawcefhwaocsGhoaicsGhiarcifgrae6mbkkcbc99alaqSEhokavc;aef8Kjjjjbaok:clevu8Jjjjjbcz9Rhvdnalaecvf9pmbc9:skdnaiRbbc;:eGc;qeSmbcuskav9cb83iwaicefhoaialfc98fhrdnaeTmbdnadcdSmbcbhwindnaoar6mbc9:skaocefhlao8SbbgicFeGhddndnaicu9mmbalhoxekaocvfhoadcFbGhdcrhidninal8SbbgDcFbGaitadVhdaDcu9kmealcefhlaicrfgic8J9hmbxdkkalcefhokabawcdtfadc8Etc8F91adcd47avcwfadceGcdtVglydbfgiBdbalaiBdbawcefgwae9hmbxdkkcbhwindnaoar6mbc9:skaocefhlao8SbbgicFeGhddndnaicu9mmbalhoxekaocvfhoadcFbGhdcrhidninal8SbbgDcFbGaitadVhdaDcu9kmealcefhlaicrfgic8J9hmbxdkkalcefhokabawcetfadc8Etc8F91adcd47avcwfadceGcdtVglydbfgi87ebalaiBdbawcefgwae9hmbkkcbc99aoarSEk:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk:4ioiue99dud99dud99dnaeTmbcbhiabhlindndnal8Uebgv:YgoJ:ji:1Salcof8UebgrciVgw:Y:vgDNJbbbZJbbb:;avcu9kEMgq:lJbbb9p9DTmbaq:Ohkxekcjjjj94hkkalclf8Uebhvalcdf8UebhxalarcefciGcetfak87ebdndnax:YgqaDNJbbbZJbbb:;axcu9kEMgm:lJbbb9p9DTmbam:Ohxxekcjjjj94hxkabaiarciGgkfcd7cetfax87ebdndnav:YgmaDNJbbbZJbbb:;avcu9kEMgP:lJbbb9p9DTmbaP:Ohvxekcjjjj94hvkalarcufciGcetfav87ebdndnawaw2:ZgPaPMaoaoN:taqaqN:tamamN:tgoJbbbbaoJbbbb9GE:raDNJbbbZMgD:lJbbb9p9DTmbaD:Ohrxekcjjjj94hrkalakcetfar87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2gdTmbinababydbgecwtcw91:Yaece91cjjj98Gcjjj;8if::NUdbabclfhbadcufgdmbkkk:Tvirud99eudndnadcl9hmbaeTmeindndnabRbbgiabcefgl8Sbbgvabcdfgo8Sbbgrf9R:YJbbuJabcifgwRbbgdce4adVgDcd4aDVgDcl4aDVgD:Z:vgqNJbbbZMgk:lJbbb9p9DTmbak:Ohxxekcjjjj94hxkaoax86bbdndnaraif:YaqNJbbbZMgk:lJbbb9p9DTmbak:Ohoxekcjjjj94hokalao86bbdndnavaifar9R:YaqNJbbbZMgk:lJbbb9p9DTmbak:Ohixekcjjjj94hikabai86bbdndnaDadcetGadceGV:ZaqNJbbbZMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkawad86bbabclfhbaecufgembxdkkaeTmbindndnab8Vebgiabcdfgl8Uebgvabclfgo8Uebgrf9R:YJbFu9habcofgw8Vebgdce4adVgDcd4aDVgDcl4aDVgDcw4aDVgD:Z:vgqNJbbbZMgk:lJbbb9p9DTmbak:Ohxxekcjjjj94hxkaoax87ebdndnaraif:YaqNJbbbZMgk:lJbbb9p9DTmbak:Ohoxekcjjjj94hokalao87ebdndnavaifar9R:YaqNJbbbZMgk:lJbbb9p9DTmbak:Ohixekcjjjj94hikabai87ebdndnaDadcetGadceGV:ZaqNJbbbZMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkawad87ebabcwfhbaecufgembkkk9teiucbcbyd:K:G:cjbgeabcifc98GfgbBd:K:G:cjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaeczfheaiczfhiadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkk83dbcj:Gdk8Kbbbbdbbblbbbwbbbbbbbebbbdbbblbbbwbbbbc:K:Gdkl8W:qbb`,t=`b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuixkbbebeeddddilve9Weeeviebeoweuecj:Gdkr;Neqo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949WbwY9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVJ9V29VVbDl79IV9Rbqq:W9Dklbzik94evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaeai86b:q:W:cjbaecitab8Piw83i:q:G:cjbaecefgecjd9hmbkk:JBl8Aud97dur978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnalTmbcuhoaiRbbgrc;WeGc:Ge9hmbarcsGgwce0mbc9:hoalcufadcd4cbawEgDadfgrcKcaawEgqaraq0Egk6mbaialfgxar9RhodnadTgmmbavaoad;8qbbkaicefhPcj;abad9Uc;WFbGcjdadca0EhsdndndnadTmbaoadfhzcbhHinaeaH9nmdaxaP9RaD6miabaHad2fhOaPaDfhAasaeaH9RaHasfae6EgCcsfgocl4cifcd4hXavcj;cbfaoc9WGgQcetfhLavcj;cbfaQci2fhKavcj;cbfaQfhYcbh8Aaoc;ab6hEincbh3dnawTmbaPa8Acd4fRbbh3kcbh5avcj;cbfh8Eindndndndna3a5cet4ciGgoc9:fPdebdkaxaA9RaQ6mwdnaQTmbavcj;cbfa5aQ2faAaQ;8qbbkaAaCfhAxdkaQTmeavcj;cbfa5aQ2fcbaQ;8kbxekaxaA9RaX6moaoclVcbawEhraAaXfhocbhidnaEmbaxao9Rc;Gb6mbcbhlina8EalfhidndndndndndnaAalco4fRbbgqciGarfPDbedibledibkaipxbbbbbbbbbbbbbbbbpklbxlkaiaopbblaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLg8Fcdp:mea8FpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogapxiiiiiiiiiiiiiiiip8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaoclffagRb:q:W:cjbfhoxikaiaopbbwaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogapxssssssssssssssssp8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaocwffagRb:q:W:cjbfhoxdkaiaopbbbpklbaoczfhoxekaiaopbbdaoRbbghcitpbi:q:G:cjbahRb:q:W:cjbghpsaoRbeggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPpklbahaocdffagRb:q:W:cjbfhokdndndndndndnaqcd4ciGarfPDbedibledibkaiczfpxbbbbbbbbbbbbbbbbpklbxlkaiczfaopbblaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLg8Fcdp:mea8FpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogapxiiiiiiiiiiiiiiiip8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaoclffagRb:q:W:cjbfhoxikaiczfaopbbwaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogapxssssssssssssssssp8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaocwffagRb:q:W:cjbfhoxdkaiczfaopbbbpklbaoczfhoxekaiczfaopbbdaoRbbghcitpbi:q:G:cjbahRb:q:W:cjbghpsaoRbeggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPpklbahaocdffagRb:q:W:cjbfhokdndndndndndnaqcl4ciGarfPDbedibledibkaicafpxbbbbbbbbbbbbbbbbpklbxlkaicafaopbblaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLg8Fcdp:mea8FpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogapxiiiiiiiiiiiiiiiip8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaoclffagRb:q:W:cjbfhoxikaicafaopbbwaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogapxssssssssssssssssp8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbahaocwffagRb:q:W:cjbfhoxdkaicafaopbbbpklbaoczfhoxekaicafaopbbdaoRbbghcitpbi:q:G:cjbahRb:q:W:cjbghpsaoRbeggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPpklbahaocdffagRb:q:W:cjbfhokdndndndndndnaqco4arfPDbedibledibkaic8Wfpxbbbbbbbbbbbbbbbbpklbxlkaic8Wfaopbblaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLg8Fcdp:mea8FpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogapxiiiiiiiiiiiiiiiip8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Ngicitpbi:q:G:cjbaiRb:q:W:cjbgipsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Ngqcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbaiaoclffaqRb:q:W:cjbfhoxikaic8Wfaopbbwaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogapxssssssssssssssssp8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Ngicitpbi:q:G:cjbaiRb:q:W:cjbgipsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Ngqcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spklbaiaocwffaqRb:q:W:cjbfhoxdkaic8Wfaopbbbpklbaoczfhoxekaic8WfaopbbdaoRbbgicitpbi:q:G:cjbaiRb:q:W:cjbgipsaoRbegqcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPpklbaiaocdffaqRb:q:W:cjbfhokalc;abfhialcjefaQ0meaihlaxao9Rc;Fb0mbkkdnaiaQ9pmbaici4hlinaxao9RcK6mwa8EaifhqdndndndndndnaAaico4fRbbalcoG4ciGarfPDbedibledibkaqpxbbbbbbbbbbbbbbbbpkbbxlkaqaopbblaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLg8Fcdp:mea8FpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogapxiiiiiiiiiiiiiiiip8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spkbbahaoclffagRb:q:W:cjbfhoxikaqaopbbwaopbbbg8Fclp:mea8FpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogapxssssssssssssssssp8Jg8Fp5b9cjF;8;4;W;G;ab9:9cU1:Nghcitpbi:q:G:cjbahRb:q:W:cjbghpsa8Fp5e9cjF;8;4;W;G;ab9:9cU1:Nggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPaaa8Fp9spkbbahaocwffagRb:q:W:cjbfhoxdkaqaopbbbpkbbaoczfhoxekaqaopbbdaoRbbghcitpbi:q:G:cjbahRb:q:W:cjbghpsaoRbeggcitpbi:q:G:cjbp9UpmbedilvorzHOACXQLpPpkbbahaocdffagRb:q:W:cjbfhokalcdfhlaiczfgiaQ6mbkkaohAaoTmoka8EaQfh8Ea5cefg5cl9hmbkdndndndnawTmbaza8Acd4fRbbglciGPlbedwbkaQTmdavcjdfa8Afhlava8Afpbdbh8Jcbhoinalavcj;cbfaofpblbg8KaYaofpblbg8LpmbzeHdOiAlCvXoQrLg8MaLaofpblbg8NaKaofpblbgypmbzeHdOiAlCvXoQrLg8PpmbezHdiOAlvCXorQLg8Fcep9Ta8Fpxeeeeeeeeeeeeeeeegap9op9Hp9rg8Fa8Jp9Ug8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp9Ug8Jp9Abbbaladfgla8Ja8Ma8PpmwDKYqk8AExm35Ps8E8Fg8Fcep9Ta8Faap9op9Hp9rg8Fp9Ug8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp9Ug8Jp9Abbbaladfgla8Ja8Ka8LpmwKDYq8AkEx3m5P8Es8Fg8Ka8NaypmwKDYq8AkEx3m5P8Es8Fg8LpmbezHdiOAlvCXorQLg8Fcep9Ta8Faap9op9Hp9rg8Fp9Ug8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp9Ug8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp9Ug8Jp9Abbbaladfgla8Ja8Ka8LpmwDKYqk8AExm35Ps8E8Fg8Fcep9Ta8Faap9op9Hp9rg8Fp9Ugap9Abbbaladfglaaa8Fa8Fpmlvorlvorlvorlvorp9Ugap9Abbbaladfglaaa8Fa8FpmwDqkwDqkwDqkwDqkp9Ugap9Abbbaladfglaaa8Fa8FpmxmPsxmPsxmPsxmPsp9Ug8Jp9AbbbaladfhlaoczfgoaQ6mbxikkaQTmeavcjdfa8Afhlava8Afpbdbh8Jcbhoinalavcj;cbfaofpblbg8KaYaofpblbg8LpmbzeHdOiAlCvXoQrLg8MaLaofpblbg8NaKaofpblbgypmbzeHdOiAlCvXoQrLg8PpmbezHdiOAlvCXorQLg8Fcep:nea8Fpxebebebebebebebebgap9op:bep9rg8Fa8Jp:oeg8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp:oeg8Jp9Abbbaladfgla8Ja8Ma8PpmwDKYqk8AExm35Ps8E8Fg8Fcep:nea8Faap9op:bep9rg8Fp:oeg8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp:oeg8Jp9Abbbaladfgla8Ja8Ka8LpmwKDYq8AkEx3m5P8Es8Fg8Ka8NaypmwKDYq8AkEx3m5P8Es8Fg8LpmbezHdiOAlvCXorQLg8Fcep:nea8Faap9op:bep9rg8Fp:oeg8Jp9Abbbaladfgla8Ja8Fa8Fpmlvorlvorlvorlvorp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmwDqkwDqkwDqkwDqkp:oeg8Jp9Abbbaladfgla8Ja8Fa8FpmxmPsxmPsxmPsxmPsp:oeg8Jp9Abbbaladfgla8Ja8Ka8LpmwDKYqk8AExm35Ps8E8Fg8Fcep:nea8Faap9op:bep9rg8Fp:oegap9Abbbaladfglaaa8Fa8Fpmlvorlvorlvorlvorp:oegap9Abbbaladfglaaa8Fa8FpmwDqkwDqkwDqkwDqkp:oegap9Abbbaladfglaaa8Fa8FpmxmPsxmPsxmPsxmPsp:oeg8Jp9AbbbaladfhlaoczfgoaQ6mbxdkkaQTmbcbhocbalcl4gl9Rc8FGhiavcjdfa8Afhrava8Afpbdbhainaravcj;cbfaofpblbg8JaYaofpblbg8KpmbzeHdOiAlCvXoQrLg8LaLaofpblbg8MaKaofpblbg8NpmbzeHdOiAlCvXoQrLgypmbezHdiOAlvCXorQLg8Faip:Rea8Falp:Tep9qg8Faap9rgap9Abbbaradfgraaa8Fa8Fpmlvorlvorlvorlvorp9rgap9Abbbaradfgraaa8Fa8FpmwDqkwDqkwDqkwDqkp9rgap9Abbbaradfgraaa8Fa8FpmxmPsxmPsxmPsxmPsp9rgap9Abbbaradfgraaa8LaypmwDKYqk8AExm35Ps8E8Fg8Faip:Rea8Falp:Tep9qg8Fp9rgap9Abbbaradfgraaa8Fa8Fpmlvorlvorlvorlvorp9rgap9Abbbaradfgraaa8Fa8FpmwDqkwDqkwDqkwDqkp9rgap9Abbbaradfgraaa8Fa8FpmxmPsxmPsxmPsxmPsp9rgap9Abbbaradfgraaa8Ja8KpmwKDYq8AkEx3m5P8Es8Fg8Ja8Ma8NpmwKDYq8AkEx3m5P8Es8Fg8KpmbezHdiOAlvCXorQLg8Faip:Rea8Falp:Tep9qg8Fp9rgap9Abbbaradfgraaa8Fa8Fpmlvorlvorlvorlvorp9rgap9Abbbaradfgraaa8Fa8FpmwDqkwDqkwDqkwDqkp9rgap9Abbbaradfgraaa8Fa8FpmxmPsxmPsxmPsxmPsp9rgap9Abbbaradfgraaa8Ja8KpmwDKYqk8AExm35Ps8E8Fg8Faip:Rea8Falp:Tep9qg8Fp9rgap9Abbbaradfgraaa8Fa8Fpmlvorlvorlvorlvorp9rgap9Abbbaradfgraaa8Fa8FpmwDqkwDqkwDqkwDqkp9rgap9Abbbaradfgraaa8Fa8FpmxmPsxmPsxmPsxmPsp9rgap9AbbbaradfhraoczfgoaQ6mbkka8Aclfg8Aad6mbkdnaCad2goTmbaOavcjdfao;8qbbkdnammbavavcjdfaCcufad2fad;8qbbkaCaHfhHc9:hoaAhPaAmbxlkkaeTmbaDalfhrcbhocuhlinaralaD9RglfaD6mdasaeao9Raoasfae6Eaofgoae6mbkaial9RhPkcbc99axaP9RakSEhoxekc9:hokavcj;kbf8Kjjjjbaokwbz:bjjjbkNsezu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnalaeci9UgrcHf6mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbav9cu83iUav9cu83i8Wav9cu83iyav9cu83iaav9cu83iKav9cu83izav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhldnaeTmbcmcsaDceSEhkcbhxcbhmcbhrcbhicbhoindnalaq9nmbc9:hoxikdndnawRbbgDc;Ve0mbavc;abfaoaDcu7gPcl4fcsGcitfgsydlhzasydbhHdndnaDcsGgsak9pmbavaiaPfcsGcdtfydbaxasEhDaxasTgOfhxxekdndnascsSmbcehOasc987asamffcefhDxekalcefhDal8SbbgscFeGhPdndnascu9mmbaDhlxekalcvfhlaPcFbGhPcrhsdninaD8SbbgOcFbGastaPVhPaOcu9kmeaDcefhDascrfgsc8J9hmbxdkkaDcefhlkcehOaPce4cbaPceG9R7amfhDkaDhmkavc;abfaocitfgsaDBdbasazBdlavaicdtfaDBdbavc;abfaocefcsGcitfgsaHBdbasaDBdlaocdfhoaOaifhidnadcd9hmbabarcetfgsaH87ebasclfaD87ebascdfaz87ebxdkabarcdtfgsaHBdbascwfaDBdbasclfazBdbxekdnaDcpe0mbavaiaqaDcsGfRbbgscl4gP9RcsGcdtfydbaxcefgOaPEhDavaias9RcsGcdtfydbaOaPTgzfgOascsGgPEhsaPThPdndnadcd9hmbabarcetfgHax87ebaHclfas87ebaHcdfaD87ebxekabarcdtfgHaxBdbaHcwfasBdbaHclfaDBdbkavaicdtfaxBdbavc;abfaocitfgHaDBdbaHaxBdlavaicefgicsGcdtfaDBdbavc;abfaocefcsGcitfgHasBdbaHaDBdlavaiazfgicsGcdtfasBdbavc;abfaocdfcsGcitfgDaxBdbaDasBdlaocifhoaiaPfhiaOaPfhxxekaxcbalRbbgsEgHaDc;:eSgDfhOascsGhAdndnascl4gCmbaOcefhzxekaOhzavaiaC9RcsGcdtfydbhOkdndnaAmbazcefhxxekazhxavaias9RcsGcdtfydbhzkdndnaDTmbalcefhDxekalcdfhDal8SbegPcFeGhsdnaPcu9kmbalcofhHascFbGhscrhldninaD8SbbgPcFbGaltasVhsaPcu9kmeaDcefhDalcrfglc8J9hmbkaHhDxekaDcefhDkasce4cbasceG9R7amfgmhHkdndnaCcsSmbaDhsxekaDcefhsaD8SbbglcFeGhPdnalcu9kmbaDcvfhOaPcFbGhPcrhldninas8SbbgDcFbGaltaPVhPaDcu9kmeascefhsalcrfglc8J9hmbkaOhsxekascefhskaPce4cbaPceG9R7amfgmhOkdndnaAcsSmbashlxekascefhlas8SbbgDcFeGhPdnaDcu9kmbascvfhzaPcFbGhPcrhDdninal8SbbgscFbGaDtaPVhPascu9kmealcefhlaDcrfgDc8J9hmbkazhlxekalcefhlkaPce4cbaPceG9R7amfgmhzkdndnadcd9hmbabarcetfgDaH87ebaDclfaz87ebaDcdfaO87ebxekabarcdtfgDaHBdbaDcwfazBdbaDclfaOBdbkavc;abfaocitfgDaOBdbaDaHBdlavaicdtfaHBdbavc;abfaocefcsGcitfgDazBdbaDaOBdlavaicefgicsGcdtfaOBdbavc;abfaocdfcsGcitfgDaHBdbaDazBdlavaiaCTaCcsSVfgicsGcdtfazBdbaiaATaAcsSVfhiaocifhokawcefhwaocsGhoaicsGhiarcifgrae6mbkkcbc99alaqSEhokavc;aef8Kjjjjbaok:clevu8Jjjjjbcz9Rhvdnalaecvf9pmbc9:skdnaiRbbc;:eGc;qeSmbcuskav9cb83iwaicefhoaialfc98fhrdnaeTmbdnadcdSmbcbhwindnaoar6mbc9:skaocefhlao8SbbgicFeGhddndnaicu9mmbalhoxekaocvfhoadcFbGhdcrhidninal8SbbgDcFbGaitadVhdaDcu9kmealcefhlaicrfgic8J9hmbxdkkalcefhokabawcdtfadc8Etc8F91adcd47avcwfadceGcdtVglydbfgiBdbalaiBdbawcefgwae9hmbxdkkcbhwindnaoar6mbc9:skaocefhlao8SbbgicFeGhddndnaicu9mmbalhoxekaocvfhoadcFbGhdcrhidninal8SbbgDcFbGaitadVhdaDcu9kmealcefhlaicrfgic8J9hmbxdkkalcefhokabawcetfadc8Etc8F91adcd47avcwfadceGcdtVglydbfgi87ebalaiBdbawcefgwae9hmbkkcbc99aoarSEk;Toio97eue97aec98Ghedndnadcl9hmbaeTmecbhdinababpbbbgicKp:RecKp:Sep;6eglaicwp:RecKp:Sep;6ealp;Geaiczp:RecKp:Sep;6egvp;Gep;Kep;Legopxbbbbbbbbbbbbbbbbp:2egralpxbbbjbbbjbbbjbbbjgwp9op9rp;Keglpxbb;:9cbb;:9cbb;:9cbb;:9calalp;Meaoaop;Meavaravawp9op9rp;Keglalp;Mep;Kep;Kep;Jep;Negvp;Mepxbbn0bbn0bbn0bbn0grp;KepxFbbbFbbbFbbbFbbbp9oaipxbbbFbbbFbbbFbbbFp9op9qalavp;Mearp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaoavp;Mearp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbabczfhbadclfgdae6mbxdkkaeTmbcbhdinabczfgDaDpbbbgipxbbbbbbFFbbbbbbFFgwp9oabpbbbgoaipmbediwDqkzHOAKY8AEgvczp:Reczp:Sep;6eglaoaipmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eavczp:Sep;6egvp;Gealp;Gep;Kep;Legipxbbbbbbbbbbbbbbbbp:2egralpxbbbjbbbjbbbjbbbjgqp9op9rp;Keglpxb;:FSb;:FSb;:FSb;:FSalalp;Meaiaip;Meavaravaqp9op9rp;Keglalp;Mep;Kep;Kep;Jep;Negvp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbp9oaiavp;Mearp;Keczp:Rep9qgialavp;Mearp;KepxFFbbFFbbFFbbFFbbp9oglpmwDKYqk8AExm35Ps8E8Fp9qpkbbabaoawp9oaialpmbezHdiOAlvCXorQLp9qpkbbabcafhbadclfgdae6mbkkk;2ileue97euo97dnaec98GgiTmbcbheinabcKfpx:ji:1S:ji:1S:ji:1S:ji:1SabpbbbglabczfgvpbbbgopmlvorxmPsCXQL358E8Fgrczp:Segwpxibbbibbbibbbibbbp9qp;6egDp;NegqaDaDp;MegDaDp;KealaopmbediwDqkzHOAKY8AEgDczp:Reczp:Sep;6eglalp;MeaDczp:Sep;6egoaop;Mearczp:Reczp:Sep;6egrarp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jep;Mepxbbn0bbn0bbn0bbn0gDp;KepxFFbbFFbbFFbbFFbbgkp9oaqaop;MeaDp;Keczp:Rep9qgoaqalp;MeaDp;Keakp9oaqarp;MeaDp;Keczp:Rep9qgDpmwDKYqk8AExm35Ps8E8Fglp5eawclp:RegqpEi:T:j83ibavalp5baqpEd:T:j83ibabcwfaoaDpmbezHdiOAlvCXorQLgDp5eaqpEe:T:j83ibabaDp5baqpEb:T:j83ibabcafhbaeclfgeai6mbkkkuee97dnadcd4ae2c98GgeTmbcbhdinababpbbbgicwp:Recwp:Sep;6eaicep:SepxbbjFbbjFbbjFbbjFp9opxbbjZbbjZbbjZbbjZp:Uep;Mepkbbabczfhbadclfgdae6mbkkk:Sodw97euaec98Ghedndnadcl9hmbaeTmecbhdinabpxbbuJbbuJbbuJbbuJabpbbbgicKp:TeglaicYp:Tep9qgvcdp:Teavp9qgvclp:Teavp9qgop;6ep;Negvaicwp:RecKp:SegraipxFbbbFbbbFbbbFbbbgwp9ogDp:Uep;6ep;Mepxbbn0bbn0bbn0bbn0gqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9oavaDarp:Xeaiczp:RecKp:Segip:Uep;6ep;Meaqp;Keawp9op9qavaDaraip:Uep:Xep;6ep;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qavaoalcep:Rep9oalpxebbbebbbebbbebbbp9op9qp;6ep;Meaqp;KecKp:Rep9qpkbbabczfhbadclfgdae6mbxdkkaeTmbcbhdinabczfgkpxbFu9hbFu9hbFu9hbFu9habpbbbglakpbbbgrpmlvorxmPsCXQL358E8Fgvczp:TegqavcHp:Tep9qgicdp:Teaip9qgiclp:Teaip9qgicwp:Teaip9qgop;6ep;NegialarpmbediwDqkzHOAKY8AEgDpxFFbbFFbbFFbbFFbbglp9ograDczp:Segwp:Ueavczp:Reczp:SegDp:Xep;6ep;Mepxbbn0bbn0bbn0bbn0gvp;Kealp9oaiarawaDp:Uep:Xep;6ep;Meavp;Keczp:Rep9qgwaiaoaqcep:Rep9oaqpxebbbebbbebbbebbbp9op9qp;6ep;Meavp;Keczp:ReaiaDarp:Uep;6ep;Meavp;Kealp9op9qgipmwDKYqk8AExm35Ps8E8FpkbbabawaipmbezHdiOAlvCXorQLpkbbabcafhbadclfgdae6mbkkk9teiucbcbydj:G:cjbgeabcifc98GfgbBdj:G:cjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkxebcj:Gdklz:zbb`,n=new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,3,2,0,0,5,3,1,0,1,12,1,0,10,22,2,12,0,65,0,65,0,65,0,252,10,0,0,11,7,0,65,0,253,15,26,11]),r=new Uint8Array([32,0,65,2,1,106,34,33,3,128,11,4,13,64,6,253,10,7,15,116,127,5,8,12,40,16,19,54,20,9,27,255,113,17,42,67,24,23,146,148,18,14,22,45,70,69,56,114,101,21,25,63,75,136,108,28,118,29,73,115]);if(typeof WebAssembly!=`object`)return{supported:!1};var i=WebAssembly.validate(n)?s(t):s(e),a,o=WebAssembly.instantiate(i,{}).then(function(e){a=e.instance,a.exports.__wasm_call_ctors()});function s(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;++n){var i=e.charCodeAt(n);t[n]=i>96?i-97:i>64?i-39:i+4}for(var a=0,n=0;n<e.length;++n)t[a++]=t[n]<60?r[t[n]]:(t[n]-60)*64+t[++n];return t.buffer.slice(0,a)}function c(e,t,n,r,i,a,o){var s=e.exports.sbrk,c=r+3&-4,l=s(c*i),u=s(a.length),d=new Uint8Array(e.exports.memory.buffer);d.set(a,u);var f=t(l,r,i,u,a.length);if(f==0&&o&&o(l,c,i),n.set(d.subarray(l,l+r*i)),s(l-s(0)),f!=0)throw Error(`Malformed buffer data: `+f)}var l={NONE:``,OCTAHEDRAL:`meshopt_decodeFilterOct`,QUATERNION:`meshopt_decodeFilterQuat`,EXPONENTIAL:`meshopt_decodeFilterExp`,COLOR:`meshopt_decodeFilterColor`},u={ATTRIBUTES:`meshopt_decodeVertexBuffer`,TRIANGLES:`meshopt_decodeIndexBuffer`,INDICES:`meshopt_decodeIndexSequence`},d=[],f=0;function p(e){var t={object:new Worker(e),pending:0,requests:{}};return t.object.onmessage=function(e){var n=e.data;t.pending-=n.count,t.requests[n.id][n.action](n.value),delete t.requests[n.id]},t}function m(e){for(var t=`self.ready = WebAssembly.instantiate(new Uint8Array([`+new Uint8Array(i)+`]), {}).then(function(result) { result.instance.exports.__wasm_call_ctors(); return result.instance; });self.onmessage = `+g.name+`;`+c.toString()+g.toString(),n=new Blob([t],{type:`text/javascript`}),r=URL.createObjectURL(n),a=d.length;a<e;++a)d[a]=p(r);for(var a=e;a<d.length;++a)d[a].object.postMessage({});d.length=e,URL.revokeObjectURL(r)}function h(e,t,n,r,i){for(var a=d[0],o=1;o<d.length;++o)d[o].pending<a.pending&&(a=d[o]);return new Promise(function(o,s){var c=new Uint8Array(n),l=++f;a.pending+=e,a.requests[l]={resolve:o,reject:s},a.object.postMessage({id:l,count:e,size:t,source:c,mode:r,filter:i},[c.buffer])})}function g(e){var t=e.data;self.ready.then(function(e){if(!t.id)return self.close();try{var n=new Uint8Array(t.count*t.size);c(e,e.exports[t.mode],n,t.count,t.size,t.source,e.exports[t.filter]),self.postMessage({id:t.id,count:t.count,action:`resolve`,value:n},[n.buffer])}catch(e){self.postMessage({id:t.id,count:t.count,action:`reject`,value:e})}})}return{ready:o,supported:!0,useWorkers:function(e){m(e)},decodeVertexBuffer:function(e,t,n,r,i){c(a,a.exports.meshopt_decodeVertexBuffer,e,t,n,r,a.exports[l[i]])},decodeIndexBuffer:function(e,t,n,r){c(a,a.exports.meshopt_decodeIndexBuffer,e,t,n,r)},decodeIndexSequence:function(e,t,n,r){c(a,a.exports.meshopt_decodeIndexSequence,e,t,n,r)},decodeGltfBuffer:function(e,t,n,r,i,o){c(a,a.exports[u[i]],e,t,n,r,a.exports[l[o]])},decodeGltfBufferAsync:function(e,t,n,r,i){return d.length>0?h(e,t,n,u[r],l[i]):o.then(function(){var o=new Uint8Array(e*t);return c(a,a.exports[u[r]],o,e,t,n,a.exports[l[i]]),o})}}})();function Wi(e){let t=/* @__PURE__ */ new Map,n=/* @__PURE__ */ new Map,r=e.clone();return Gi(e,r,function(e,r){t.set(r,e),n.set(e,r)}),r.traverse(function(e){if(!e.isSkinnedMesh)return;let r=e,i=t.get(e),a=i.skeleton.bones;r.skeleton=i.skeleton.clone(),r.bindMatrix.copy(i.bindMatrix),r.skeleton.bones=a.map(function(e){return n.get(e)}),r.bind(r.skeleton,r.bindMatrix)}),r}function Gi(e,t,n){n(e,t);for(let r=0;r<e.children.length;r++)Gi(e.children[r],t.children[r],n)}var Ki=class extends si{constructor(e){super(e),this.dracoLoader=null,this.ktx2Loader=null,this.meshoptDecoder=null,this.pluginCallbacks=[],this.register(function(e){return new Zi(e)}),this.register(function(e){return new Qi(e)}),this.register(function(e){return new sa(e)}),this.register(function(e){return new ca(e)}),this.register(function(e){return new la(e)}),this.register(function(e){return new ea(e)}),this.register(function(e){return new ta(e)}),this.register(function(e){return new na(e)}),this.register(function(e){return new ra(e)}),this.register(function(e){return new Xi(e)}),this.register(function(e){return new ia(e)}),this.register(function(e){return new $i(e)}),this.register(function(e){return new oa(e)}),this.register(function(e){return new aa(e)}),this.register(function(e){return new Ji(e)}),this.register(function(e){return new ua(e,$.EXT_MESHOPT_COMPRESSION)}),this.register(function(e){return new ua(e,$.KHR_MESHOPT_COMPRESSION)}),this.register(function(e){return new da(e)})}load(e,t,n,r){let i=this,a;if(this.resourcePath!==``)a=this.resourcePath;else if(this.path!==``){let t=Pi.extractUrlBase(e);a=Pi.resolveURL(t,this.path)}else a=Pi.extractUrlBase(e);this.manager.itemStart(e);let o=function(t){r?r(t):console.error(t),i.manager.itemError(e),i.manager.itemEnd(e)},s=new ui(this.manager);s.setPath(this.path),s.setResponseType(`arraybuffer`),s.setRequestHeader(this.requestHeader),s.setWithCredentials(this.withCredentials),s.load(e,function(n){try{i.parse(n,a,function(n){t(n),i.manager.itemEnd(e)},o)}catch(e){o(e)}},n,o)}setDRACOLoader(e){return this.dracoLoader=e,this}setKTX2Loader(e){return this.ktx2Loader=e,this}setMeshoptDecoder(e){return this.meshoptDecoder=e,this}register(e){return this.pluginCallbacks.indexOf(e)===-1&&this.pluginCallbacks.push(e),this}unregister(e){return this.pluginCallbacks.indexOf(e)!==-1&&this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e),1),this}parse(e,t,n,r){let i,a={},o={},s=new TextDecoder;if(typeof e==`string`)i=JSON.parse(e);else if(e instanceof ArrayBuffer){if(s.decode(new Uint8Array(e,0,4))===fa){try{a[$.KHR_BINARY_GLTF]=new ma(e)}catch(e){r&&r(e);return}i=JSON.parse(a[$.KHR_BINARY_GLTF].content)}else i=JSON.parse(s.decode(e))}else i=e;if(i.asset===void 0||i.asset.version[0]<2){r&&r(/* @__PURE__ */ Error(`THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.`));return}let c=new Ba(i,{path:t||this.resourcePath||``,crossOrigin:this.crossOrigin,requestHeader:this.requestHeader,manager:this.manager,ktx2Loader:this.ktx2Loader,meshoptDecoder:this.meshoptDecoder});c.fileLoader.setRequestHeader(this.requestHeader);for(let e=0;e<this.pluginCallbacks.length;e++){let t=this.pluginCallbacks[e](c);t.name||console.error(`THREE.GLTFLoader: Invalid plugin found: missing name`),o[t.name]=t,a[t.name]=!0}if(i.extensionsUsed)for(let e=0;e<i.extensionsUsed.length;++e){let t=i.extensionsUsed[e],n=i.extensionsRequired||[];switch(t){case $.KHR_MATERIALS_UNLIT:a[t]=new Yi;break;case $.KHR_DRACO_MESH_COMPRESSION:a[t]=new ha(i,this.dracoLoader);break;case $.KHR_TEXTURE_TRANSFORM:a[t]=new ga;break;case $.KHR_MESH_QUANTIZATION:a[t]=new _a;break;default:n.indexOf(t)>=0&&o[t]===void 0&&console.warn(`THREE.GLTFLoader: Unknown extension \"`+t+`\".`)}}c.setExtensions(a),c.setPlugins(o),c.parse(n,r)}parseAsync(e,t){let n=this;return new Promise(function(r,i){n.parse(e,t,r,i)})}};function qi(){let e={};return{get:function(t){return e[t]},add:function(t,n){e[t]=n},remove:function(t){delete e[t]},removeAll:function(){e={}}}}function Q(e,t,n){let r=e.json.materials[t];return r.extensions&&r.extensions[n]?r.extensions[n]:null}let $={KHR_BINARY_GLTF:`KHR_binary_glTF`,KHR_DRACO_MESH_COMPRESSION:`KHR_draco_mesh_compression`,KHR_LIGHTS_PUNCTUAL:`KHR_lights_punctual`,KHR_MATERIALS_CLEARCOAT:`KHR_materials_clearcoat`,KHR_MATERIALS_DISPERSION:`KHR_materials_dispersion`,KHR_MATERIALS_IOR:`KHR_materials_ior`,KHR_MATERIALS_SHEEN:`KHR_materials_sheen`,KHR_MATERIALS_SPECULAR:`KHR_materials_specular`,KHR_MATERIALS_TRANSMISSION:`KHR_materials_transmission`,KHR_MATERIALS_IRIDESCENCE:`KHR_materials_iridescence`,KHR_MATERIALS_ANISOTROPY:`KHR_materials_anisotropy`,KHR_MATERIALS_UNLIT:`KHR_materials_unlit`,KHR_MATERIALS_VOLUME:`KHR_materials_volume`,KHR_TEXTURE_BASISU:`KHR_texture_basisu`,KHR_TEXTURE_TRANSFORM:`KHR_texture_transform`,KHR_MESH_QUANTIZATION:`KHR_mesh_quantization`,KHR_MATERIALS_EMISSIVE_STRENGTH:`KHR_materials_emissive_strength`,EXT_MATERIALS_BUMP:`EXT_materials_bump`,EXT_TEXTURE_WEBP:`EXT_texture_webp`,EXT_TEXTURE_AVIF:`EXT_texture_avif`,EXT_MESHOPT_COMPRESSION:`EXT_meshopt_compression`,KHR_MESHOPT_COMPRESSION:`KHR_meshopt_compression`,EXT_MESH_GPU_INSTANCING:`EXT_mesh_gpu_instancing`};var Ji=class{constructor(e){this.parser=e,this.name=$.KHR_LIGHTS_PUNCTUAL,this.cache={refs:{},uses:{}}}_markDefs(){let e=this.parser,t=this.parser.json.nodes||[];for(let n=0,r=t.length;n<r;n++){let r=t[n];r.extensions&&r.extensions[this.name]&&r.extensions[this.name].light!==void 0&&e._addNodeRef(this.cache,r.extensions[this.name].light)}}_loadLight(e){let t=this.parser,n=`light:`+e,r=t.cache.get(n);if(r)return r;let i=t.json,a=((i.extensions&&i.extensions[this.name]||{}).lights||[])[e],o,s=new G(16777215);a.color!==void 0&&s.setRGB(a.color[0],a.color[1],a.color[2],_);let c=a.range===void 0?0:a.range;switch(a.type){case`directional`:o=new Ni(s),o.target.position.set(0,0,-1),o.add(o.target);break;case`point`:o=new Ai(s),o.distance=c;break;case`spot`:o=new Oi(s),o.distance=c,a.spot=a.spot||{},a.spot.innerConeAngle=a.spot.innerConeAngle===void 0?0:a.spot.innerConeAngle,a.spot.outerConeAngle=a.spot.outerConeAngle===void 0?Math.PI/4:a.spot.outerConeAngle,o.angle=a.spot.outerConeAngle,o.penumbra=1-a.spot.innerConeAngle/a.spot.outerConeAngle,o.target.position.set(0,0,-1),o.add(o.target);break;default:throw Error(`THREE.GLTFLoader: Unexpected light type: `+a.type)}return o.position.set(0,0,0),Ma(o,a),a.intensity!==void 0&&(o.intensity=a.intensity),o.name=t.createUniqueName(a.name||`light_`+e),r=Promise.resolve(o),t.cache.add(n,r),r}getDependency(e,t){if(e===`light`)return this._loadLight(t)}createNodeAttachment(e){let t=this,n=this.parser,r=n.json.nodes[e],i=(r.extensions&&r.extensions[this.name]||{}).light;return i===void 0?null:this._loadLight(i).then(function(e){return n._getNodeRef(t.cache,i,e)})}},Yi=class{constructor(){this.name=$.KHR_MATERIALS_UNLIT}getMaterialType(){return bn}extendParams(e,t,n){let r=[];e.color=new G(1,1,1),e.opacity=1;let i=t.pbrMetallicRoughness;if(i){if(Array.isArray(i.baseColorFactor)){let t=i.baseColorFactor;e.color.setRGB(t[0],t[1],t[2],_),e.opacity=t[3]}i.baseColorTexture!==void 0&&r.push(n.assignTexture(e,`map`,i.baseColorTexture,g))}return Promise.all(r)}},Xi=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_EMISSIVE_STRENGTH}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);return n===null||n.emissiveStrength!==void 0&&(t.emissiveIntensity=n.emissiveStrength),Promise.resolve()}},Zi=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_CLEARCOAT}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];if(n.clearcoatFactor!==void 0&&(t.clearcoat=n.clearcoatFactor),n.clearcoatTexture!==void 0&&r.push(this.parser.assignTexture(t,`clearcoatMap`,n.clearcoatTexture)),n.clearcoatRoughnessFactor!==void 0&&(t.clearcoatRoughness=n.clearcoatRoughnessFactor),n.clearcoatRoughnessTexture!==void 0&&r.push(this.parser.assignTexture(t,`clearcoatRoughnessMap`,n.clearcoatRoughnessTexture)),n.clearcoatNormalTexture!==void 0&&(r.push(this.parser.assignTexture(t,`clearcoatNormalMap`,n.clearcoatNormalTexture)),n.clearcoatNormalTexture.scale!==void 0)){let e=n.clearcoatNormalTexture.scale;t.clearcoatNormalScale=new z(e,e)}return Promise.all(r)}},Qi=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_DISPERSION}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);return n===null||(t.dispersion=n.dispersion===void 0?0:n.dispersion),Promise.resolve()}},$i=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_IRIDESCENCE}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];return n.iridescenceFactor!==void 0&&(t.iridescence=n.iridescenceFactor),n.iridescenceTexture!==void 0&&r.push(this.parser.assignTexture(t,`iridescenceMap`,n.iridescenceTexture)),n.iridescenceIor!==void 0&&(t.iridescenceIOR=n.iridescenceIor),t.iridescenceThicknessRange===void 0&&(t.iridescenceThicknessRange=[100,400]),n.iridescenceThicknessMinimum!==void 0&&(t.iridescenceThicknessRange[0]=n.iridescenceThicknessMinimum),n.iridescenceThicknessMaximum!==void 0&&(t.iridescenceThicknessRange[1]=n.iridescenceThicknessMaximum),n.iridescenceThicknessTexture!==void 0&&r.push(this.parser.assignTexture(t,`iridescenceThicknessMap`,n.iridescenceThicknessTexture)),Promise.all(r)}},ea=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_SHEEN}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];if(t.sheenColor=new G(0,0,0),t.sheenRoughness=0,t.sheen=1,n.sheenColorFactor!==void 0){let e=n.sheenColorFactor;t.sheenColor.setRGB(e[0],e[1],e[2],_)}return n.sheenRoughnessFactor!==void 0&&(t.sheenRoughness=n.sheenRoughnessFactor),n.sheenColorTexture!==void 0&&r.push(this.parser.assignTexture(t,`sheenColorMap`,n.sheenColorTexture,g)),n.sheenRoughnessTexture!==void 0&&r.push(this.parser.assignTexture(t,`sheenRoughnessMap`,n.sheenRoughnessTexture)),Promise.all(r)}},ta=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_TRANSMISSION}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];return n.transmissionFactor!==void 0&&(t.transmission=n.transmissionFactor),n.transmissionTexture!==void 0&&r.push(this.parser.assignTexture(t,`transmissionMap`,n.transmissionTexture)),Promise.all(r)}},na=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_VOLUME}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];t.thickness=n.thicknessFactor===void 0?0:n.thicknessFactor,n.thicknessTexture!==void 0&&r.push(this.parser.assignTexture(t,`thicknessMap`,n.thicknessTexture)),t.attenuationDistance=n.attenuationDistance||1/0;let i=n.attenuationColor||[1,1,1];return t.attenuationColor=new G().setRGB(i[0],i[1],i[2],_),Promise.all(r)}},ra=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_IOR}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);return n===null?Promise.resolve():(t.ior=n.ior===void 0?1.5:n.ior,t.ior===0&&(t.ior=1e3),Promise.resolve())}},ia=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_SPECULAR}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];t.specularIntensity=n.specularFactor===void 0?1:n.specularFactor,n.specularTexture!==void 0&&r.push(this.parser.assignTexture(t,`specularIntensityMap`,n.specularTexture));let i=n.specularColorFactor||[1,1,1];return t.specularColor=new G().setRGB(i[0],i[1],i[2],_),n.specularColorTexture!==void 0&&r.push(this.parser.assignTexture(t,`specularColorMap`,n.specularColorTexture,g)),Promise.all(r)}},aa=class{constructor(e){this.parser=e,this.name=$.EXT_MATERIALS_BUMP}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];return t.bumpScale=n.bumpFactor===void 0?1:n.bumpFactor,n.bumpTexture!==void 0&&r.push(this.parser.assignTexture(t,`bumpMap`,n.bumpTexture)),Promise.all(r)}},oa=class{constructor(e){this.parser=e,this.name=$.KHR_MATERIALS_ANISOTROPY}getMaterialType(e){return Q(this.parser,e,this.name)===null?null:jr}extendMaterialParams(e,t){let n=Q(this.parser,e,this.name);if(n===null)return Promise.resolve();let r=[];return n.anisotropyStrength!==void 0&&(t.anisotropy=n.anisotropyStrength),n.anisotropyRotation!==void 0&&(t.anisotropyRotation=n.anisotropyRotation),n.anisotropyTexture!==void 0&&r.push(this.parser.assignTexture(t,`anisotropyMap`,n.anisotropyTexture)),Promise.all(r)}},sa=class{constructor(e){this.parser=e,this.name=$.KHR_TEXTURE_BASISU}loadTexture(e){let t=this.parser,n=t.json,r=n.textures[e];if(!r.extensions||!r.extensions[this.name])return null;let i=r.extensions[this.name],a=t.options.ktx2Loader;if(!a){if(n.extensionsRequired&&n.extensionsRequired.indexOf(this.name)>=0)throw Error(`THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures`);return null}return t.loadTextureImage(e,i.source,a)}},ca=class{constructor(e){this.parser=e,this.name=$.EXT_TEXTURE_WEBP}loadTexture(e){let t=this.name,n=this.parser,r=n.json,i=r.textures[e];if(!i.extensions||!i.extensions[t])return null;let a=i.extensions[t],o=r.images[a.source],s=n.textureLoader;if(o.uri){let e=n.options.manager.getHandler(o.uri);e!==null&&(s=e)}return n.loadTextureImage(e,a.source,s)}},la=class{constructor(e){this.parser=e,this.name=$.EXT_TEXTURE_AVIF}loadTexture(e){let t=this.name,n=this.parser,r=n.json,i=r.textures[e];if(!i.extensions||!i.extensions[t])return null;let a=i.extensions[t],o=r.images[a.source],s=n.textureLoader;if(o.uri){let e=n.options.manager.getHandler(o.uri);e!==null&&(s=e)}return n.loadTextureImage(e,a.source,s)}},ua=class{constructor(e,t){this.name=t,this.parser=e}loadBufferView(e){let t=this.parser.json,n=t.bufferViews[e];if(n.extensions&&n.extensions[this.name]){let e=n.extensions[this.name],r=this.parser.getDependency(`buffer`,e.buffer),i=this.parser.options.meshoptDecoder;if(!i||!i.supported){if(t.extensionsRequired&&t.extensionsRequired.indexOf(this.name)>=0)throw Error(`THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files`);return null}return r.then(function(t){let n=e.byteOffset||0,r=e.byteLength||0,a=e.count,o=e.byteStride,s=new Uint8Array(t,n,r);return i.decodeGltfBufferAsync?i.decodeGltfBufferAsync(a,o,s,e.mode,e.filter).then(function(e){return e.buffer}):i.ready.then(function(){let t=new ArrayBuffer(a*o);return i.decodeGltfBuffer(new Uint8Array(t),a,o,s,e.mode,e.filter),t})})}return null}},da=class{constructor(e){this.name=$.EXT_MESH_GPU_INSTANCING,this.parser=e}createNodeMesh(e){let t=this.parser.json,n=t.nodes[e];if(!n.extensions||!n.extensions[this.name]||n.mesh===void 0)return null;let r=t.meshes[n.mesh];for(let e of r.primitives)if(e.mode!==xa.TRIANGLES&&e.mode!==xa.TRIANGLE_STRIP&&e.mode!==xa.TRIANGLE_FAN&&e.mode!==void 0)return null;let i=n.extensions[this.name].attributes,a=[],o={};for(let e in i)a.push(this.parser.getDependency(`accessor`,i[e]).then(t=>(o[e]=t,o[e])));return a.length<1?null:(a.push(this.parser.createNodeMesh(e)),Promise.all(a).then(e=>{let t=e.pop(),n=t.isGroup?t.children:[t],r=e[0].count,i=[];for(let e of n){let t=new H,n=new B,a=new be,s=new B(1,1,1),c=new ir(e.geometry,e.material,r);for(let e=0;e<r;e++)o.TRANSLATION&&n.fromBufferAttribute(o.TRANSLATION,e),o.ROTATION&&a.fromBufferAttribute(o.ROTATION,e),o.SCALE&&s.fromBufferAttribute(o.SCALE,e),c.setMatrixAt(e,t.compose(n,a,s));let l=null;for(let e in o)if(e===`_COLOR_0`){let t=o[e];c.instanceColor=new Xn(t.array,t.itemSize,t.normalized)}else if(e!==`TRANSLATION`&&e!==`ROTATION`&&e!==`SCALE`){if(l===null){let e=c.geometry;l=new on,l.name=e.name;for(let t in e.attributes)l.setAttribute(t,e.attributes[t]);for(let t in e.morphAttributes)l.morphAttributes[t]=e.morphAttributes[t];e.index!==null&&l.setIndex(e.index),l.morphTargetsRelative=e.morphTargetsRelative;for(let t of e.groups)l.addGroup(t.start,t.count,t.materialIndex);e.boundingBox!==null&&(l.boundingBox=e.boundingBox.clone()),e.boundingSphere!==null&&(l.boundingSphere=e.boundingSphere.clone()),l.drawRange.start=e.drawRange.start,l.drawRange.count=e.drawRange.count,l.userData=Object.assign({},e.userData),c.geometry=l}let t=o[e];l.setAttribute(e,new Xn(t.array,t.itemSize,t.normalized))}W.prototype.copy.call(c,e),this.parser.assignFinalMaterial(c),i.push(c)}return t.isGroup?(t.clear(),t.add(...i),t):i[0]}))}};let fa=`glTF`,pa={JSON:1313821514,BIN:5130562};var ma=class{constructor(e){this.name=$.KHR_BINARY_GLTF,this.content=null,this.body=null;let t=new DataView(e,0,12),n=new TextDecoder;if(this.header={magic:n.decode(new Uint8Array(e.slice(0,4))),version:t.getUint32(4,!0),length:t.getUint32(8,!0)},this.header.magic!==fa)throw Error(`THREE.GLTFLoader: Unsupported glTF-Binary header.`);if(this.header.version<2)throw Error(`THREE.GLTFLoader: Legacy binary file detected.`);let r=this.header.length-12,i=new DataView(e,12),a=0;for(;a<r;){let t=i.getUint32(a,!0);a+=4;let r=i.getUint32(a,!0);if(a+=4,r===pa.JSON){let r=new Uint8Array(e,12+a,t);this.content=n.decode(r)}else if(r===pa.BIN){let n=12+a;this.body=e.slice(n,n+t)}a+=t}if(this.content===null)throw Error(`THREE.GLTFLoader: JSON content not found.`)}},ha=class{constructor(e,t){if(!t)throw Error(`THREE.GLTFLoader: No DRACOLoader instance provided.`);this.name=$.KHR_DRACO_MESH_COMPRESSION,this.json=e,this.dracoLoader=t,this.dracoLoader.preload()}decodePrimitive(e,t){let n=this.json,r=this.dracoLoader,i=e.extensions[this.name].bufferView,a=e.extensions[this.name].attributes,o={},s={},c={};for(let e in a){let t=Ea[e]||e.toLowerCase();o[t]=a[e]}for(let t in e.attributes){let r=Ea[t]||t.toLowerCase();if(a[t]!==void 0){let i=n.accessors[e.attributes[t]];c[r]=Sa[i.componentType].name,s[r]=i.normalized===!0}}return t.getDependency(`bufferView`,i).then(function(e){return new Promise(function(t,n){r.decodeDracoFile(e,function(e){for(let t in e.attributes){let n=e.attributes[t],r=s[t];r!==void 0&&(n.normalized=r)}t(e)},o,c,_,n)})})}},ga=class{constructor(){this.name=$.KHR_TEXTURE_TRANSFORM}extendTexture(e,t){if((t.texCoord===void 0||t.texCoord===e.channel)&&t.offset===void 0&&t.rotation===void 0&&t.scale===void 0)return e;if(e=e.clone(),t.texCoord!==void 0&&(e.channel=t.texCoord),t.offset!==void 0&&e.offset.fromArray(t.offset),t.rotation!==void 0&&(e.rotation=t.rotation),t.scale!==void 0&&e.repeat.fromArray(t.scale),t.rotation!==void 0){let t=Math.cos(e.rotation),n=Math.sin(e.rotation);e.matrix.set(e.repeat.x*t,e.repeat.y*n,e.offset.x,-e.repeat.x*n,e.repeat.y*t,e.offset.y,0,0,1),e.matrixAutoUpdate=!1}return e.needsUpdate=!0,e}},_a=class{constructor(){this.name=$.KHR_MESH_QUANTIZATION}},va=class extends Rr{constructor(e,t,n,r){super(e,t,n,r)}copySampleValue_(e){let t=this.resultBuffer,n=this.sampleValues,r=this.valueSize,i=e*r*3+r;for(let e=0;e!==r;e++)t[e]=n[i+e];return t}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=o*2,c=o*3,l=r-t,u=(n-t)/l,d=u*u,f=d*u,p=e*c,m=p-c,h=-2*f+3*d,g=f-d,_=1-h,v=g-d+u;for(let e=0;e!==o;e++){let t=a[m+e+o],n=a[m+e+s]*l,r=a[p+e+o],c=a[p+e]*l;i[e]=_*t+v*n+h*r+g*c}return i}};let ya=new be;var ba=class extends va{interpolate_(e,t,n,r){let i=super.interpolate_(e,t,n,r);return ya.fromArray(i).normalize().toArray(i),i}};let xa={FLOAT:5126,FLOAT_MAT3:35675,FLOAT_MAT4:35676,FLOAT_VEC2:35664,FLOAT_VEC3:35665,FLOAT_VEC4:35666,LINEAR:9729,REPEAT:10497,SAMPLER_2D:35678,POINTS:0,LINES:1,LINE_LOOP:2,LINE_STRIP:3,TRIANGLES:4,TRIANGLE_STRIP:5,TRIANGLE_FAN:6,UNSIGNED_BYTE:5121,UNSIGNED_SHORT:5123},Sa={5120:Int8Array,5121:Uint8Array,5122:Int16Array,5123:Uint16Array,5125:Uint32Array,5126:Float32Array},Ca={9728:r,9729:i,9984:1004,9985:1007,9986:1005,9987:a},wa={33071:t,33648:n,10497:e},Ta={SCALAR:1,VEC2:2,VEC3:3,VEC4:4,MAT2:4,MAT3:9,MAT4:16},Ea={POSITION:`position`,NORMAL:`normal`,TANGENT:`tangent`,TEXCOORD_0:`uv`,TEXCOORD_1:`uv1`,TEXCOORD_2:`uv2`,TEXCOORD_3:`uv3`,COLOR_0:`color`,WEIGHTS_0:`skinWeight`,JOINTS_0:`skinIndex`},Da={scale:`scale`,translation:`position`,rotation:`quaternion`,weights:`morphTargetInfluences`},Oa={CUBICSPLINE:void 0,LINEAR:u,STEP:l},ka={OPAQUE:`OPAQUE`,MASK:`MASK`,BLEND:`BLEND`};function Aa(e){return e.DefaultMaterial===void 0&&(e.DefaultMaterial=new Ar({color:16777215,emissive:0,metalness:1,roughness:1,transparent:!1,depthTest:!0,side:0})),e.DefaultMaterial}function ja(e,t,n){for(let r in n.extensions)e[r]===void 0&&(t.userData.gltfExtensions=t.userData.gltfExtensions||{},t.userData.gltfExtensions[r]=n.extensions[r])}function Ma(e,t){t.extras!==void 0&&(typeof t.extras==`object`?Object.assign(e.userData,t.extras):console.warn(`THREE.GLTFLoader: Ignoring primitive type .extras, `+t.extras))}function Na(e,t,n){let r=!1,i=!1,a=!1;for(let e=0,n=t.length;e<n;e++){let n=t[e];if(n.POSITION!==void 0&&(r=!0),n.NORMAL!==void 0&&(i=!0),n.COLOR_0!==void 0&&(a=!0),r&&i&&a)break}if(!r&&!i&&!a)return Promise.resolve(e);let o=[],s=[],c=[];for(let l=0,u=t.length;l<u;l++){let u=t[l];if(r){let t=u.POSITION===void 0?e.attributes.position:n.getDependency(`accessor`,u.POSITION);o.push(t)}if(i){let t=u.NORMAL===void 0?e.attributes.normal:n.getDependency(`accessor`,u.NORMAL);s.push(t)}if(a){let t=u.COLOR_0===void 0?e.attributes.color:n.getDependency(`accessor`,u.COLOR_0);c.push(t)}}return Promise.all([Promise.all(o),Promise.all(s),Promise.all(c)]).then(function(t){let n=t[0],o=t[1],s=t[2];return r&&(e.morphAttributes.position=n),i&&(e.morphAttributes.normal=o),a&&(e.morphAttributes.color=s),e.morphTargetsRelative=!0,e})}function Pa(e,t){if(e.updateMorphTargets(),t.weights!==void 0)for(let n=0,r=t.weights.length;n<r;n++)e.morphTargetInfluences[n]=t.weights[n];if(t.extras&&Array.isArray(t.extras.targetNames)){let n=t.extras.targetNames;if(e.morphTargetInfluences.length===n.length){e.morphTargetDictionary={};for(let t=0,r=n.length;t<r;t++)e.morphTargetDictionary[n[t]]=t}else console.warn(`THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.`)}}function Fa(e){let t,n=e.extensions&&e.extensions[$.KHR_DRACO_MESH_COMPRESSION];if(t=n?`draco:`+n.bufferView+`:`+n.indices+`:`+Ia(n.attributes):e.indices+`:`+Ia(e.attributes)+`:`+e.mode,e.targets!==void 0)for(let n=0,r=e.targets.length;n<r;n++)t+=`:`+Ia(e.targets[n]);return t}function Ia(e){let t=``,n=Object.keys(e).sort();for(let r=0,i=n.length;r<i;r++)t+=n[r]+`:`+e[n[r]]+`;`;return t}function La(e){switch(e){case Int8Array:return 1/127;case Uint8Array:return 1/255;case Int16Array:return 1/32767;case Uint16Array:return 1/65535;default:throw Error(`THREE.GLTFLoader: Unsupported normalized accessor component type.`)}}function Ra(e){return e.search(/\\.jpe?g($|\\?)/i)>0||e.search(/^data\\:image\\/jpeg/)===0?`image/jpeg`:e.search(/\\.webp($|\\?)/i)>0||e.search(/^data\\:image\\/webp/)===0?`image/webp`:e.search(/\\.ktx2($|\\?)/i)>0||e.search(/^data\\:image\\/ktx2/)===0?`image/ktx2`:`image/png`}let za=new H;var Ba=class{constructor(e={},t={}){this.json=e,this.extensions={},this.plugins={},this.options=t,this.cache=new qi,this.associations=/* @__PURE__ */ new Map,this.primitiveCache={},this.nodeCache={},this.meshCache={refs:{},uses:{}},this.cameraCache={refs:{},uses:{}},this.lightCache={refs:{},uses:{}},this.sourceCache={},this.textureCache={},this.nodeNamesUsed={};let n=!1,r=-1,i=!1,a=-1;if(typeof navigator<`u`&&navigator.userAgent!==void 0){let e=navigator.userAgent;n=/^((?!chrome|android).)*safari/i.test(e)===!0;let t=e.match(/Version\\/(\\d+)/);r=n&&t?parseInt(t[1],10):-1,i=e.indexOf(`Firefox`)>-1,a=i?e.match(/Firefox\\/([0-9]+)\\./)[1]:-1}this.textureLoader=typeof createImageBitmap>`u`||n&&r<17||i&&a<98?new pi(this.options.manager):new Ii(this.options.manager),this.textureLoader.setCrossOrigin(this.options.crossOrigin),this.textureLoader.setRequestHeader(this.options.requestHeader),this.fileLoader=new ui(this.options.manager),this.fileLoader.setResponseType(`arraybuffer`),this.options.crossOrigin===`use-credentials`&&this.fileLoader.setWithCredentials(!0)}setExtensions(e){this.extensions=e}setPlugins(e){this.plugins=e}parse(e,t){let n=this,r=this.json,i=this.extensions;this.cache.removeAll(),this.nodeCache={},this._invokeAll(function(e){return e._markDefs&&e._markDefs()}),Promise.all(this._invokeAll(function(e){return e.beforeRoot&&e.beforeRoot()})).then(function(){return Promise.all([n.getDependencies(`scene`),n.getDependencies(`animation`),n.getDependencies(`camera`)])}).then(function(t){let a={scene:t[0][r.scene||0],scenes:t[0],animations:t[1],cameras:t[2],asset:r.asset,parser:n,userData:{}};return ja(i,a,r),Ma(a,r),Promise.all(n._invokeAll(function(e){return e.afterRoot&&e.afterRoot(a)})).then(function(){for(let e of a.scenes)e.updateMatrixWorld();e(a)})}).catch(t)}_markDefs(){let e=this.json.nodes||[],t=this.json.skins||[],n=this.json.meshes||[];for(let n=0,r=t.length;n<r;n++){let r=t[n].joints;for(let t=0,n=r.length;t<n;t++)e[r[t]].isBone=!0}for(let t=0,r=e.length;t<r;t++){let r=e[t];r.mesh!==void 0&&(this._addNodeRef(this.meshCache,r.mesh),r.skin!==void 0&&(n[r.mesh].isSkinnedMesh=!0)),r.camera!==void 0&&this._addNodeRef(this.cameraCache,r.camera)}}_addNodeRef(e,t){t!==void 0&&(e.refs[t]===void 0&&(e.refs[t]=e.uses[t]=0),e.refs[t]++)}_getNodeRef(e,t,n){if(e.refs[t]<=1)return n;let r=n.clone(),i=(e,t)=>{let n=this.associations.get(e);n!=null&&this.associations.set(t,n);for(let[n,r]of e.children.entries())i(r,t.children[n])};return i(n,r),r.name+=`_instance_`+e.uses[t]++,r}_invokeOne(e){let t=Object.values(this.plugins);t.push(this);for(let n=0;n<t.length;n++){let r=e(t[n]);if(r)return r}return null}_invokeAll(e){let t=Object.values(this.plugins);t.unshift(this);let n=[];for(let r=0;r<t.length;r++){let i=e(t[r]);i&&n.push(i)}return n}getDependency(e,t){let n=e+`:`+t,r=this.cache.get(n);if(!r){switch(e){case`scene`:r=this.loadScene(t);break;case`node`:r=this._invokeOne(function(e){return e.loadNode&&e.loadNode(t)});break;case`mesh`:r=this._invokeOne(function(e){return e.loadMesh&&e.loadMesh(t)});break;case`accessor`:r=this.loadAccessor(t);break;case`bufferView`:r=this._invokeOne(function(e){return e.loadBufferView&&e.loadBufferView(t)});break;case`buffer`:r=this.loadBuffer(t);break;case`material`:r=this._invokeOne(function(e){return e.loadMaterial&&e.loadMaterial(t)});break;case`texture`:r=this._invokeOne(function(e){return e.loadTexture&&e.loadTexture(t)});break;case`skin`:r=this.loadSkin(t);break;case`animation`:r=this._invokeOne(function(e){return e.loadAnimation&&e.loadAnimation(t)});break;case`camera`:r=this.loadCamera(t);break;default:if(r=this._invokeOne(function(n){return n!=this&&n.getDependency&&n.getDependency(e,t)}),!r)throw Error(`Unknown type: `+e)}this.cache.add(n,r)}return r}getDependencies(e){let t=this.cache.get(e);if(!t){let n=this,r=this.json[e+(e===`mesh`?`es`:`s`)]||[];t=Promise.all(r.map(function(t,r){return n.getDependency(e,r)})),this.cache.add(e,t)}return t}loadBuffer(e){let t=this.json.buffers[e],n=this.fileLoader;if(t.type&&t.type!==`arraybuffer`)throw Error(`THREE.GLTFLoader: `+t.type+` buffer type is not supported.`);if(t.uri===void 0&&e===0)return Promise.resolve(this.extensions[$.KHR_BINARY_GLTF].body);let r=this.options;return new Promise(function(e,i){n.load(Pi.resolveURL(t.uri,r.path),e,void 0,function(){i(/* @__PURE__ */ Error(`THREE.GLTFLoader: Failed to load buffer \"`+t.uri+`\".`))})})}loadBufferView(e){let t=this.json.bufferViews[e];return this.getDependency(`buffer`,t.buffer).then(function(e){let n=t.byteLength||0,r=t.byteOffset||0;return e.slice(r,r+n)})}loadAccessor(e){let t=this,n=this.json,r=this.json.accessors[e];if(r.bufferView===void 0&&r.sparse===void 0){let e=Ta[r.type],t=Sa[r.componentType],n=r.normalized===!0,i=new t(r.count*e);return Promise.resolve(new Kt(i,e,n))}let i=[];return r.bufferView===void 0?i.push(null):i.push(this.getDependency(`bufferView`,r.bufferView)),r.sparse!==void 0&&(i.push(this.getDependency(`bufferView`,r.sparse.indices.bufferView)),i.push(this.getDependency(`bufferView`,r.sparse.values.bufferView))),Promise.all(i).then(function(e){let i=e[0],a=Ta[r.type],o=Sa[r.componentType],s=o.BYTES_PER_ELEMENT,c=s*a,l=r.byteOffset||0,u=r.bufferView===void 0?void 0:n.bufferViews[r.bufferView].byteStride,d=r.normalized===!0,f,p;if(u&&u!==c){let e=Math.floor(l/u),n=`InterleavedBuffer:`+r.bufferView+`:`+r.componentType+`:`+e+`:`+r.count,c=t.cache.get(n);c||(f=new o(i,e*u,r.count*u/s),c=new sn(f,u/s),t.cache.add(n,c)),p=new cn(c,a,l%u/s,d)}else f=i===null?new o(r.count*a):new o(i,l,r.count*a),p=new Kt(f,a,d);if(r.sparse!==void 0){let t=Ta.SCALAR,n=Sa[r.sparse.indices.componentType],s=r.sparse.indices.byteOffset||0,c=r.sparse.values.byteOffset||0,l=new n(e[1],s,r.sparse.count*t),u=new o(e[2],c,r.sparse.count*a);i!==null&&(p=new Kt(p.array.slice(),p.itemSize,p.normalized)),p.normalized=!1;for(let e=0,t=l.length;e<t;e++){let t=l[e];if(p.setX(t,u[e*a]),a>=2&&p.setY(t,u[e*a+1]),a>=3&&p.setZ(t,u[e*a+2]),a>=4&&p.setW(t,u[e*a+3]),a>=5)throw Error(`THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.`)}p.normalized=d}return p})}loadTexture(e){let t=this.json,n=this.options,r=t.textures[e].source,i=t.images[r],a=this.textureLoader;if(i.uri){let e=n.manager.getHandler(i.uri);e!==null&&(a=e)}return this.loadTextureImage(e,r,a)}loadTextureImage(e,t,n){let r=this,i=this.json,a=i.textures[e],o=i.images[t],s=(o.uri||o.bufferView)+`:`+a.sampler;if(this.textureCache[s])return this.textureCache[s];let c=this.loadImageSource(t,n).then(function(t){t.flipY=!1,t.name=a.name||o.name||``,t.name===``&&typeof o.uri==`string`&&o.uri.startsWith(`data:image/`)===!1&&(t.name=o.uri);let n=(i.samplers||{})[a.sampler]||{};return t.magFilter=Ca[n.magFilter]||1006,t.minFilter=Ca[n.minFilter]||1008,t.wrapS=wa[n.wrapS]||1e3,t.wrapT=wa[n.wrapT]||1e3,t.generateMipmaps=!t.isCompressedTexture&&t.minFilter!==1003&&t.minFilter!==1006,r.associations.set(t,{textures:e}),t}).catch(function(){return null});return this.textureCache[s]=c,c}loadImageSource(e,t){let n=this,r=this.json,i=this.options;if(this.sourceCache[e]!==void 0)return this.sourceCache[e].then(e=>e.clone());let a=r.images[e],o=self.URL||self.webkitURL,s=a.uri||``,c=!1;if(a.bufferView!==void 0)s=n.getDependency(`bufferView`,a.bufferView).then(function(e){c=!0;let t=new Blob([e],{type:a.mimeType});return s=o.createObjectURL(t),s});else if(a.uri===void 0)throw Error(`THREE.GLTFLoader: Image `+e+` is missing URI and bufferView`);let l=Promise.resolve(s).then(function(e){return new Promise(function(n,r){let a=n;t.isImageBitmapLoader===!0&&(a=function(e){let t=new Le(e);t.needsUpdate=!0,n(t)}),t.load(Pi.resolveURL(e,i.path),a,void 0,r)})}).then(function(e){return c===!0&&o.revokeObjectURL(s),Ma(e,a),e.userData.mimeType=a.mimeType||Ra(a.uri),e}).catch(function(e){throw console.error(`THREE.GLTFLoader: Couldn't load texture`,s),e});return this.sourceCache[e]=l,l}assignTexture(e,t,n,r){let i=this;return this.getDependency(`texture`,n.index).then(function(a){if(!a)return null;if(n.texCoord!==void 0&&n.texCoord>0&&(a=a.clone(),a.channel=n.texCoord),i.extensions[$.KHR_TEXTURE_TRANSFORM]){let e=n.extensions===void 0?void 0:n.extensions[$.KHR_TEXTURE_TRANSFORM];if(e){let t=i.associations.get(a);a=i.extensions[$.KHR_TEXTURE_TRANSFORM].extendTexture(a,e),i.associations.set(a,t)}}return r!==void 0&&(a.colorSpace=r),e[t]=a,a})}assignFinalMaterial(e){let t=e.geometry,n=e.material,r=t.attributes.tangent===void 0,i=t.attributes.color!==void 0,a=t.attributes.normal===void 0;if(e.isPoints){let e=`PointsMaterial:`+n.uuid,t=this.cache.get(e);t||(t=new Cr,mn.prototype.copy.call(t,n),t.color.copy(n.color),t.map=n.map,t.sizeAttenuation=!1,this.cache.add(e,t)),n=t}else if(e.isLine){let e=`LineBasicMaterial:`+n.uuid,t=this.cache.get(e);t||(t=new lr,mn.prototype.copy.call(t,n),t.color.copy(n.color),t.map=n.map,this.cache.add(e,t)),n=t}if(r||i||a){let e=`ClonedMaterial:`+n.uuid+`:`;r&&(e+=`derivative-tangents:`),i&&(e+=`vertex-colors:`),a&&(e+=`flat-shading:`);let t=this.cache.get(e);t||(t=n.clone(),i&&(t.vertexColors=!0),a&&(t.flatShading=!0),r&&(t.normalScale&&(t.normalScale.y*=-1),t.clearcoatNormalScale&&(t.clearcoatNormalScale.y*=-1)),this.cache.add(e,t),this.associations.set(t,this.associations.get(n))),n=t}e.material=n}getMaterialType(){return Ar}loadMaterial(e){let t=this,n=this.json,r=this.extensions,i=n.materials[e],a,o={},s=i.extensions||{},c=[];if(s[$.KHR_MATERIALS_UNLIT]){let e=r[$.KHR_MATERIALS_UNLIT];a=e.getMaterialType(),c.push(e.extendParams(o,i,t))}else{let n=i.pbrMetallicRoughness||{};if(o.color=new G(1,1,1),o.opacity=1,Array.isArray(n.baseColorFactor)){let e=n.baseColorFactor;o.color.setRGB(e[0],e[1],e[2],_),o.opacity=e[3]}n.baseColorTexture!==void 0&&c.push(t.assignTexture(o,`map`,n.baseColorTexture,g)),o.metalness=n.metallicFactor===void 0?1:n.metallicFactor,o.roughness=n.roughnessFactor===void 0?1:n.roughnessFactor,n.metallicRoughnessTexture!==void 0&&(c.push(t.assignTexture(o,`metalnessMap`,n.metallicRoughnessTexture)),c.push(t.assignTexture(o,`roughnessMap`,n.metallicRoughnessTexture))),a=this._invokeOne(function(t){return t.getMaterialType&&t.getMaterialType(e)}),c.push(Promise.all(this._invokeAll(function(t){return t.extendMaterialParams&&t.extendMaterialParams(e,o)})))}i.doubleSided===!0&&(o.side=2);let l=i.alphaMode||ka.OPAQUE;if(l===ka.BLEND?(o.transparent=!0,o.depthWrite=!1):(o.transparent=!1,l===ka.MASK&&(o.alphaTest=i.alphaCutoff===void 0?.5:i.alphaCutoff)),i.normalTexture!==void 0&&a!==bn&&(c.push(t.assignTexture(o,`normalMap`,i.normalTexture)),o.normalScale=new z(1,1),i.normalTexture.scale!==void 0)){let e=i.normalTexture.scale;o.normalScale.set(e,e)}if(i.occlusionTexture!==void 0&&a!==bn&&(c.push(t.assignTexture(o,`aoMap`,i.occlusionTexture)),i.occlusionTexture.strength!==void 0&&(o.aoMapIntensity=i.occlusionTexture.strength)),i.emissiveFactor!==void 0&&a!==bn){let e=i.emissiveFactor;o.emissive=new G().setRGB(e[0],e[1],e[2],_)}return i.emissiveTexture!==void 0&&a!==bn&&c.push(t.assignTexture(o,`emissiveMap`,i.emissiveTexture,g)),Promise.all(c).then(function(){let n=new a(o);return i.name&&(n.name=i.name),Ma(n,i),t.associations.set(n,{materials:e}),i.extensions&&ja(r,n,i),n})}createUniqueName(e){let t=Z.sanitizeNodeName(e||``);return t in this.nodeNamesUsed?t+`_`+ ++this.nodeNamesUsed[t]:(this.nodeNamesUsed[t]=0,t)}loadGeometries(e){let t=this,n=this.extensions,r=this.primitiveCache;function i(e){return n[$.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(e,t).then(function(n){return Ha(n,e,t)})}let a=[];for(let n=0,o=e.length;n<o;n++){let o=e[n],s=Fa(o),c=r[s];if(c)a.push(c.promise);else{let e;e=o.extensions&&o.extensions[$.KHR_DRACO_MESH_COMPRESSION]?i(o):Ha(new on,o,t),o.mode===xa.TRIANGLE_STRIP?e=e.then(e=>Hi(e,1)):o.mode===xa.TRIANGLE_FAN&&(e=e.then(e=>Hi(e,2))),r[s]={primitive:o,promise:e},a.push(e)}}return Promise.all(a)}loadMesh(e){let t=this,n=this.json,r=this.extensions,i=n.meshes[e],a=i.primitives,o=[];for(let e=0,t=a.length;e<t;e++){let t=a[e].material===void 0?Aa(this.cache):this.getDependency(`material`,a[e].material);o.push(t)}return o.push(t.loadGeometries(a)),Promise.all(o).then(async function(n){let o=n.slice(0,n.length-1),s=n[n.length-1],c=[];for(let n=0,l=s.length;n<l;n++){let l=s[n],u=a[n],d,f=o[n];if(u.mode===xa.TRIANGLES||u.mode===xa.TRIANGLE_STRIP||u.mode===xa.TRIANGLE_FAN||u.mode===void 0){let e=i.isSkinnedMesh===!0,t=l.hasAttribute(`skinIndex`)&&l.hasAttribute(`skinWeight`);e&&t===!1&&console.warn(`THREE.GLTFLoader: Missing skinIndex or skinWeight attributes. Skinning disabled.`),d=e&&t?new Wn(l,f):new Mn(l,f),d.isSkinnedMesh===!0&&d.normalizeSkinWeights()}else if(u.mode===xa.LINES)d=new xr(l,f);else if(u.mode===xa.LINE_STRIP)d=new _r(l,f);else if(u.mode===xa.LINE_LOOP)d=new Sr(l,f);else if(u.mode===xa.POINTS)d=new Or(l,f);else throw Error(`THREE.GLTFLoader: Primitive mode unsupported: `+u.mode);Object.keys(d.geometry.morphAttributes).length>0&&Pa(d,i),d.name=t.createUniqueName(i.name||`mesh_`+e),Ma(d,i),u.extensions&&ja(r,d,u),t.assignFinalMaterial(d),c.push(d)}for(let n=0,r=c.length;n<r;n++)t.associations.set(c[n],{meshes:e,primitives:n});if(c.length===1)return i.extensions&&ja(r,c[0],i),c[0];let l=new ut;i.extensions&&ja(r,l,i),t.associations.set(l,{meshes:e});for(let e=0,t=c.length;e<t;e++)l.add(c[e]);return l})}loadCamera(e){let t,n=this.json.cameras[e],r=n[n.type];if(!r){console.warn(`THREE.GLTFLoader: Missing camera parameters.`);return}return n.type===`perspective`?t=new Ei(ye.radToDeg(r.yfov),r.aspectRatio||1,r.znear||1,r.zfar||2e6):n.type===`orthographic`&&(t=new ji(-r.xmag,r.xmag,r.ymag,-r.ymag,r.znear,r.zfar)),n.name&&(t.name=this.createUniqueName(n.name)),Ma(t,n),Promise.resolve(t)}loadSkin(e){let t=this.json.skins[e],n=[];for(let e=0,r=t.joints.length;e<r;e++)n.push(this._loadNodeShallow(t.joints[e]));return t.inverseBindMatrices===void 0?n.push(null):n.push(this.getDependency(`accessor`,t.inverseBindMatrices)),Promise.all(n).then(function(e){let n=e.pop(),r=e,i=[],a=[];for(let e=0,o=r.length;e<o;e++){let o=r[e];if(o){i.push(o);let t=new H;n!==null&&t.fromArray(n.array,e*16),a.push(t)}else console.warn(`THREE.GLTFLoader: Joint \"%s\" could not be found.`,t.joints[e])}return new Yn(i,a)})}loadAnimation(e){let t=this.json,n=this,r=t.animations[e],i=r.name?r.name:`animation_`+e,a=[],o=[],s=[],c=[],l=[];for(let e=0,t=r.channels.length;e<t;e++){let t=r.channels[e],n=r.samplers[t.sampler],i=t.target,u=i.node,d=r.parameters===void 0?n.input:r.parameters[n.input],f=r.parameters===void 0?n.output:r.parameters[n.output];i.node!==void 0&&(a.push(this.getDependency(`node`,u)),o.push(this.getDependency(`accessor`,d)),s.push(this.getDependency(`accessor`,f)),c.push(n),l.push(i))}return Promise.all([Promise.all(a),Promise.all(o),Promise.all(s),Promise.all(c),Promise.all(l)]).then(function(e){let t=e[0],a=e[1],o=e[2],s=e[3],c=e[4],l=[];for(let e=0,r=t.length;e<r;e++){let r=t[e],i=a[e],u=o[e],d=s[e],f=c[e];if(r===void 0)continue;r.updateMatrix&&r.updateMatrix();let p=n._createAnimationTracks(r,i,u,d,f);if(p)for(let e=0;e<p.length;e++)l.push(p[e])}let u=new ti(i,void 0,l);return Ma(u,r),u})}createNodeMesh(e){let t=this.json,n=this,r=t.nodes[e];return r.mesh===void 0?null:n.getDependency(`mesh`,r.mesh).then(function(e){let t=n._getNodeRef(n.meshCache,r.mesh,e);return r.weights!==void 0&&t.traverse(function(e){if(e.isMesh)for(let t=0,n=r.weights.length;t<n;t++)e.morphTargetInfluences[t]=r.weights[t]}),t})}loadNode(e){let t=this.json,n=this,r=t.nodes[e],i=n._loadNodeShallow(e),a=[],o=r.children||[];for(let e=0,t=o.length;e<t;e++)a.push(n.getDependency(`node`,o[e]));let s=r.skin===void 0?Promise.resolve(null):n.getDependency(`skin`,r.skin);return Promise.all([i,Promise.all(a),s]).then(function(e){let t=e[0],n=e[1],r=e[2];r!==null&&t.traverse(function(e){e.isSkinnedMesh&&e.bind(r,za)});for(let e=0,r=n.length;e<r;e++)t.add(n[e]);if(t.userData.pivot!==void 0&&n.length>0){let e=t.userData.pivot,r=n[0];t.pivot=new B().fromArray(e),t.position.x-=e[0],t.position.y-=e[1],t.position.z-=e[2],r.position.set(0,0,0),delete t.userData.pivot}return t})}_loadNodeShallow(e){let t=this.json,n=this.extensions,r=this;if(this.nodeCache[e]!==void 0)return this.nodeCache[e];let i=t.nodes[e],a=i.name?r.createUniqueName(i.name):``,o=[],s=r._invokeOne(function(t){return t.createNodeMesh&&t.createNodeMesh(e)});return s&&o.push(s),i.camera!==void 0&&o.push(r.getDependency(`camera`,i.camera).then(function(e){return r._getNodeRef(r.cameraCache,i.camera,e)})),r._invokeAll(function(t){return t.createNodeAttachment&&t.createNodeAttachment(e)}).forEach(function(e){o.push(e)}),this.nodeCache[e]=Promise.all(o).then(function(t){let o;if(o=i.isBone===!0?new Gn:t.length>1?new ut:t.length===1?t[0]:new W,o!==t[0])for(let e=0,n=t.length;e<n;e++)o.add(t[e]);if(i.name&&(o.userData.name=i.name,o.name=a),Ma(o,i),i.extensions&&ja(n,o,i),i.matrix!==void 0){let e=new H;e.fromArray(i.matrix),o.applyMatrix4(e)}else i.translation!==void 0&&o.position.fromArray(i.translation),i.rotation!==void 0&&o.quaternion.fromArray(i.rotation),i.scale!==void 0&&o.scale.fromArray(i.scale);if(!r.associations.has(o))r.associations.set(o,{});else if(i.mesh!==void 0&&r.meshCache.refs[i.mesh]>1){let e=r.associations.get(o);r.associations.set(o,{...e})}return r.associations.get(o).nodes=e,o}),this.nodeCache[e]}loadScene(e){let t=this.extensions,n=this.json.scenes[e],r=this,i=new ut;n.name&&(i.name=r.createUniqueName(n.name)),Ma(i,n),n.extensions&&ja(t,i,n);let a=n.nodes||[],o=[];for(let e=0,t=a.length;e<t;e++)o.push(r.getDependency(`node`,a[e]));return Promise.all(o).then(function(e){for(let t=0,n=e.length;t<n;t++){let n=e[t];n.parent===null?i.add(n):i.add(Wi(n))}return r.associations=(e=>{let t=/* @__PURE__ */ new Map;for(let[e,n]of r.associations)(e instanceof mn||e instanceof Le)&&t.set(e,n);return e.traverse(e=>{let n=r.associations.get(e);n!=null&&t.set(e,n)}),t})(i),i})}_createAnimationTracks(e,t,n,r,i){let a=[],o=e.name?e.name:e.uuid,s=[];function c(e){e.morphTargetInfluences&&s.push(e.name?e.name:e.uuid)}Da[i.path]===Da.weights?(c(e),e.isGroup&&e.children.forEach(c)):s.push(o);let l;switch(Da[i.path]){case Da.weights:l=Xr;break;case Da.rotation:l=Qr;break;case Da.translation:case Da.scale:l=ei;break;default:switch(n.itemSize){case 1:l=Xr;break;default:l=ei}}let d=r.interpolation===void 0?u:Oa[r.interpolation],f=this._getArrayFromAccessor(n);for(let e=0,n=s.length;e<n;e++){let n=new l(s[e]+`.`+Da[i.path],t.array,f,d);r.interpolation===`CUBICSPLINE`&&this._createCubicSplineTrackInterpolant(n),a.push(n)}return a}_getArrayFromAccessor(e){let t=e.array;if(e.normalized){let e=La(t.constructor),n=new Float32Array(t.length);for(let r=0,i=t.length;r<i;r++)n[r]=t[r]*e;t=n}return t}_createCubicSplineTrackInterpolant(e){e.createInterpolant=function(e){return new(this instanceof Qr?ba:va)(this.times,this.values,this.getValueSize()/3,e)},e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline=!0}};function Va(e,t,n){let r=t.attributes,i=new kt;if(r.POSITION!==void 0){let e=n.json.accessors[r.POSITION],t=e.min,a=e.max;if(t!==void 0&&a!==void 0){if(i.set(new B(t[0],t[1],t[2]),new B(a[0],a[1],a[2])),e.normalized){let t=La(Sa[e.componentType]);i.min.multiplyScalar(t),i.max.multiplyScalar(t)}}else{console.warn(`THREE.GLTFLoader: Missing min/max properties for accessor POSITION.`);return}}else return;let a=t.targets;if(a!==void 0){let e=new B,t=new B;for(let r=0,i=a.length;r<i;r++){let i=a[r];if(i.POSITION!==void 0){let r=n.json.accessors[i.POSITION],a=r.min,o=r.max;if(a!==void 0&&o!==void 0){if(t.setX(Math.max(Math.abs(a[0]),Math.abs(o[0]))),t.setY(Math.max(Math.abs(a[1]),Math.abs(o[1]))),t.setZ(Math.max(Math.abs(a[2]),Math.abs(o[2]))),r.normalized){let e=La(Sa[r.componentType]);t.multiplyScalar(e)}e.max(t)}else console.warn(`THREE.GLTFLoader: Missing min/max properties for accessor POSITION.`)}}i.expandByVector(e)}e.boundingBox=i;let o=new $t;i.getCenter(o.center),o.radius=i.min.distanceTo(i.max)/2,e.boundingSphere=o}function Ha(e,t,n){let r=t.attributes,i=[];function a(t,r){return n.getDependency(`accessor`,t).then(function(t){e.setAttribute(r,t)})}for(let t in r){let n=Ea[t]||t.toLowerCase();n in e.attributes||i.push(a(r[t],n))}if(t.indices!==void 0&&!e.index){let r=n.getDependency(`accessor`,t.indices).then(function(t){e.setIndex(t)});i.push(r)}return V.workingColorSpace!==`srgb-linear`&&`COLOR_0`in r&&console.warn(`THREE.GLTFLoader: Converting vertex colors from \"srgb-linear\" to \"${V.workingColorSpace}\" not supported.`),Ma(e,t),Va(e,t,n),Promise.all(i).then(function(){return t.targets===void 0?e:Na(e,t.targets,n)})}let Ua=/^[og]\\s*(.+)?/,Wa=/^mtllib /,Ga=/^usemtl /,Ka=/^usemap /,qa=/\\s+/,Ja=new B,Ya=new B,Xa=new B,Za=new B,Qa=new B,$a=new G;function eo(){let e={objects:[],object:{},vertices:[],normals:[],colors:[],uvs:[],materials:{},materialLibraries:[],startObject:function(e,t){if(this.object&&this.object.fromDeclaration===!1){this.object.name=e,this.object.fromDeclaration=t!==!1;return}let n=this.object&&typeof this.object.currentMaterial==`function`?this.object.currentMaterial():void 0;if(this.object&&typeof this.object._finalize==`function`&&this.object._finalize(!0),this.object={name:e||``,fromDeclaration:t!==!1,geometry:{vertices:[],normals:[],colors:[],uvs:[],hasUVIndices:!1},materials:[],smooth:!0,startMaterial:function(e,t){let n=this._finalize(!1);n&&(n.inherited||n.groupCount<=0)&&this.materials.splice(n.index,1);let r={index:this.materials.length,name:e||``,mtllib:Array.isArray(t)&&t.length>0?t[t.length-1]:``,smooth:n===void 0?this.smooth:n.smooth,groupStart:n===void 0?0:n.groupEnd,groupEnd:-1,groupCount:-1,inherited:!1,clone:function(e){let t={index:typeof e==`number`?e:this.index,name:this.name,mtllib:this.mtllib,smooth:this.smooth,groupStart:0,groupEnd:-1,groupCount:-1,inherited:!1};return t.clone=this.clone.bind(t),t}};return this.materials.push(r),r},currentMaterial:function(){if(this.materials.length>0)return this.materials[this.materials.length-1]},_finalize:function(e){let t=this.currentMaterial();if(t&&t.groupEnd===-1&&(t.groupEnd=this.geometry.vertices.length/3,t.groupCount=t.groupEnd-t.groupStart,t.inherited=!1),e&&this.materials.length>1)for(let e=this.materials.length-1;e>=0;e--)this.materials[e].groupCount<=0&&this.materials.splice(e,1);return e&&this.materials.length===0&&this.materials.push({name:``,smooth:this.smooth}),t}},n&&n.name&&typeof n.clone==`function`){let e=n.clone(0);e.inherited=!0,this.object.materials.push(e)}this.objects.push(this.object)},finalize:function(){this.object&&typeof this.object._finalize==`function`&&this.object._finalize(!0)},parseVertexIndex:function(e,t){let n=parseInt(e,10);return(n>=0?n-1:n+t/3)*3},parseNormalIndex:function(e,t){let n=parseInt(e,10);return(n>=0?n-1:n+t/3)*3},parseUVIndex:function(e,t){let n=parseInt(e,10);return(n>=0?n-1:n+t/2)*2},addVertex:function(e,t,n){let r=this.vertices,i=this.object.geometry.vertices;i.push(r[e+0],r[e+1],r[e+2]),i.push(r[t+0],r[t+1],r[t+2]),i.push(r[n+0],r[n+1],r[n+2])},addVertexPoint:function(e){let t=this.vertices;this.object.geometry.vertices.push(t[e+0],t[e+1],t[e+2])},addVertexLine:function(e){let t=this.vertices;this.object.geometry.vertices.push(t[e+0],t[e+1],t[e+2])},addNormal:function(e,t,n){let r=this.normals,i=this.object.geometry.normals;i.push(r[e+0],r[e+1],r[e+2]),i.push(r[t+0],r[t+1],r[t+2]),i.push(r[n+0],r[n+1],r[n+2])},addFaceNormal:function(e,t,n){let r=this.vertices,i=this.object.geometry.normals;Ja.fromArray(r,e),Ya.fromArray(r,t),Xa.fromArray(r,n),Qa.subVectors(Xa,Ya),Za.subVectors(Ja,Ya),Qa.cross(Za),Qa.normalize(),i.push(Qa.x,Qa.y,Qa.z),i.push(Qa.x,Qa.y,Qa.z),i.push(Qa.x,Qa.y,Qa.z)},addColor:function(e,t,n){let r=this.colors,i=this.object.geometry.colors;r[e]!==void 0&&i.push(r[e+0],r[e+1],r[e+2]),r[t]!==void 0&&i.push(r[t+0],r[t+1],r[t+2]),r[n]!==void 0&&i.push(r[n+0],r[n+1],r[n+2])},addUV:function(e,t,n){let r=this.uvs,i=this.object.geometry.uvs;i.push(r[e+0],r[e+1]),i.push(r[t+0],r[t+1]),i.push(r[n+0],r[n+1])},addDefaultUV:function(){let e=this.object.geometry.uvs;e.push(0,0),e.push(0,0),e.push(0,0)},addUVLine:function(e){let t=this.uvs;this.object.geometry.uvs.push(t[e+0],t[e+1])},addFace:function(e,t,n,r,i,a,o,s,c){let l=this.vertices.length,u=this.parseVertexIndex(e,l),d=this.parseVertexIndex(t,l),f=this.parseVertexIndex(n,l);if(this.addVertex(u,d,f),this.addColor(u,d,f),o!==void 0&&o!==``){let e=this.normals.length;u=this.parseNormalIndex(o,e),d=this.parseNormalIndex(s,e),f=this.parseNormalIndex(c,e),this.addNormal(u,d,f)}else this.addFaceNormal(u,d,f);if(r!==void 0&&r!==``){let e=this.uvs.length;u=this.parseUVIndex(r,e),d=this.parseUVIndex(i,e),f=this.parseUVIndex(a,e),this.addUV(u,d,f),this.object.geometry.hasUVIndices=!0}else this.addDefaultUV()},addPointGeometry:function(e){this.object.geometry.type=`Points`;let t=this.vertices.length;for(let n=0,r=e.length;n<r;n++){let r=this.parseVertexIndex(e[n],t);this.addVertexPoint(r),this.addColor(r)}},addLineGeometry:function(e,t){this.object.geometry.type=`Line`;let n=this.vertices.length,r=this.uvs.length;for(let t=0,r=e.length;t<r;t++)this.addVertexLine(this.parseVertexIndex(e[t],n));for(let e=0,n=t.length;e<n;e++)this.addUVLine(this.parseUVIndex(t[e],r))}};return e.startObject(``,!1),e}var to=class extends si{constructor(e){super(e),this.materials=null}load(e,t,n,r){let i=this,a=new ui(this.manager);a.setPath(this.path),a.setRequestHeader(this.requestHeader),a.setWithCredentials(this.withCredentials),a.load(e,function(n){try{t(i.parse(n))}catch(t){r?r(t):console.error(t),i.manager.itemError(e)}},n,r)}setMaterials(e){return this.materials=e,this}parse(e){let t=new eo;e.indexOf(`\\r\n`)!==-1&&(e=e.replace(/\\r\\n/g,`\n`)),e.indexOf(`\\\\\n`)!==-1&&(e=e.replace(/\\\\\\n/g,``));let n=e.split(`\n`),r=[];for(let e=0,i=n.length;e<i;e++){let i=n[e].trimStart();if(i.length===0)continue;let a=i.charAt(0);if(a!==`#`){if(a===`v`){let e=i.split(qa);switch(e[0]){case`v`:t.vertices.push(parseFloat(e[1]),parseFloat(e[2]),parseFloat(e[3])),e.length>=7?($a.setRGB(parseFloat(e[4]),parseFloat(e[5]),parseFloat(e[6]),g),t.colors.push($a.r,$a.g,$a.b)):t.colors.push(void 0,void 0,void 0);break;case`vn`:t.normals.push(parseFloat(e[1]),parseFloat(e[2]),parseFloat(e[3]));break;case`vt`:t.uvs.push(parseFloat(e[1]),parseFloat(e[2]))}}else if(a===`f`){let e=i.slice(1).trim().split(qa),n=[];for(let t=0,r=e.length;t<r;t++){let r=e[t];if(r.length>0){let e=r.split(`/`);n.push(e)}}let r=n[0];for(let e=1,i=n.length-1;e<i;e++){let i=n[e],a=n[e+1];t.addFace(r[0],i[0],a[0],r[1],i[1],a[1],r[2],i[2],a[2])}}else if(a===`l`){let e=i.substring(1).trim().split(` `),n=[],r=[];if(i.indexOf(`/`)===-1)n=e;else for(let t=0,i=e.length;t<i;t++){let i=e[t].split(`/`);i[0]!==``&&n.push(i[0]),i[1]!==``&&r.push(i[1])}t.addLineGeometry(n,r)}else if(a===`p`){let e=i.slice(1).trim().split(` `);t.addPointGeometry(e)}else if((r=Ua.exec(i))!==null){let e=(` `+r[0].slice(1).trim()).slice(1);t.startObject(e)}else if(Ga.test(i))t.object.startMaterial(i.substring(7).trim(),t.materialLibraries);else if(Wa.test(i))t.materialLibraries.push(i.substring(7).trim());else if(Ka.test(i))console.warn(`THREE.OBJLoader: Rendering identifier \"usemap\" not supported. Textures must be defined in MTL files.`);else if(a===`s`){if(r=i.split(` `),r.length>1){let e=r[1].trim().toLowerCase();t.object.smooth=e!==`0`&&e!==`off`}else t.object.smooth=!0;let e=t.object.currentMaterial();e&&(e.smooth=t.object.smooth)}else{if(i===`\\0`)continue;console.warn(`THREE.OBJLoader: Unexpected line: \"`+i+`\"`)}}}t.finalize();let i=new ut;if(i.materialLibraries=[].concat(t.materialLibraries),t.objects.length!==1||t.objects[0].geometry.vertices.length!==0)for(let e=0,n=t.objects.length;e<n;e++){let n=t.objects[e],r=n.geometry,a=n.materials,o=r.type===`Line`,s=r.type===`Points`,c=!1;if(r.vertices.length===0)continue;let l=new on;l.setAttribute(`position`,new Yt(r.vertices,3)),r.normals.length>0&&l.setAttribute(`normal`,new Yt(r.normals,3)),r.colors.length>0&&(c=!0,l.setAttribute(`color`,new Yt(r.colors,3))),r.hasUVIndices===!0&&l.setAttribute(`uv`,new Yt(r.uvs,2));let u=[];for(let e=0,n=a.length;e<n;e++){let n=a[e],r=n.name+`_`+n.smooth+`_`+c,i=t.materials[r];if(this.materials!==null){if(i=this.materials.create(n.name),o&&i&&!(i instanceof lr)){let e=new lr;mn.prototype.copy.call(e,i),e.color.copy(i.color),i=e}else if(s&&i&&!(i instanceof Cr)){let e=new Cr({size:10,sizeAttenuation:!1});mn.prototype.copy.call(e,i),e.color.copy(i.color),e.map=i.map,i=e}}i===void 0&&(i=o?new lr:s?new Cr({size:1,sizeAttenuation:!1}):new Mr,i.name=n.name,i.flatShading=!n.smooth,i.vertexColors=c,t.materials[r]=i),u.push(i)}let d;if(u.length>1){for(let e=0,t=a.length;e<t;e++){let t=a[e];l.addGroup(t.groupStart,t.groupCount,e)}d=o?new xr(l,u):s?new Or(l,u):new Mn(l,u)}else d=o?new xr(l,u[0]):s?new Or(l,u[0]):new Mn(l,u[0]);d.name=n.name,i.add(d)}else if(t.vertices.length>0){let e=new Cr({size:1,sizeAttenuation:!1}),n=new on;n.setAttribute(`position`,new Yt(t.vertices,3)),t.colors.length>0&&t.colors[0]!==void 0&&(n.setAttribute(`color`,new Yt(t.colors,3)),e.vertexColors=!0);let r=new Or(n,e);i.add(r)}return i}},no=class{static async load(e){try{let t=new Request(e.url,{...e}),n=await(await fetch(t)).blob();switch(e.format){case`OBJ`:return await io(n);case`GLTF`:return await ro(n)}}catch{throw console.error(`Failed to load file ${e.format} ${e.url}`),Error(`Failed to load file ${e.format} ${e.url}`)}}};async function ro(e){try{let t=new Ki;t.setMeshoptDecoder(Ui);let n=await e.arrayBuffer();return(await t.parseAsync(n,``)).scene}catch{throw Error(`Failed to load GLTF file`)}}async function io(e){try{let t=new to,n=await e.text();return t.parse(n)}catch{throw Error(`Failed to load OBJ file`)}}function ao(e,t){return{name:t,array:e.array,itemSize:e.itemSize}}function oo(e){let t=0,n;e.index&&(t=e.index.count,n=ao(e.index,`index`));let r=[];for(let t in e.attributes){let n=e.attributes[t];n.isBufferAttribute&&r.push(ao(n,t))}let i=e.attributes.position.count;return{uuid:e.uuid,index:n,attributes:r,vertexCount:i,indexCount:t,drawRange:{start:e.drawRange.start,count:e.drawRange.count}}}function so(e,t){e.index&&t.push(e.index.array.buffer);for(let n of e.attributes)t.push(n.array.buffer)}function co(e,t){let n=Array.isArray(e.material)?e.material[0]:e.material;return t.transparent=n.transparent,t.opacity=n.opacity,t.color.set(69905),`color`in n&&t.color.copy(n.color),t.emissive.set(0),`emissive`in n&&t.emissive.copy(n.emissive),t.metalness=0,`metalness`in n&&(t.metalness=n.metalness),t.roughness=1,`roughness`in n&&(t.roughness=n.roughness),t.name=n.name,t}function lo(e,t){let n=Array.isArray(e.material)?e.material[0]:e.material;return t.transparent=n.transparent,t.opacity=n.opacity,t.color.set(69905),`color`in n&&t.color.copy(n.color),t.name=n.name,t}function uo(e){return{transparent:e.transparent,color:e.color.getHex(),opacity:e.opacity}}function fo(e){return e.toArray()}function po(e){return{isSerializedObject3D:!0,isMeshGroup:!1,isInMeshGroup:!1,name:e.name,uuid:e.uuid,userData:e.userData,parentUuid:e.parent?.uuid??null}}let mo=new lr;function ho(e,t=`3D`){return lo(e,mo),{...po(e),geometryType:t,isSeriaLizedLineSegments:!0,material:uo(mo),matrixWorld:fo(e.matrixWorld)}}function go(e){return{name:e.name,transparent:e.transparent,roughness:e.roughness,color:e.color.getHex(),metalness:e.metalness,emissive:e.emissive.getHex(),opacity:e.opacity}}let _o=new Ar;function vo(e,t=`3D`){return co(e,_o),{...po(e),geometryType:t,isSerializedMesh:!0,material:go(_o),matrixWorld:fo(e.matrixWorld)}}var yo=class{static{this._time=0}static{this._times=/* @__PURE__ */ new Map}static startTime(e){return this._time=performance.now(),e&&this._times.set(e,this._time),this._time}static tickTime(e){let t=performance.now(),n=this._time;if(e){let t=this._times.get(e);if(t!==void 0)n=t;else throw Error(`Unknown timer id`)}return t-n}static endTime(e){let t=performance.now(),n=this._time;if(this._time=t,e){let r=this._times.get(e);if(r!==void 0)n=r,this._times.set(e,t);else throw Error(`Unknown timer id`)}return t-n}static timeStr(e){return`${e.toFixed(1)} ms`}},bo=class{constructor(){this.loadingTime=0,this.serializationTime=0,this.info={objectCount:0,meshCount:0,lineCount:0,geometryCount:0}}get totalTime(){return this.loadingTime+this.serializationTime}};onmessage=e=>{let{type:t}=e.data;t===`LoadFileRequest`&&xo(e.data)};async function xo(e){let{fileRequest:t}=e;yo.startTime();let n=new bo,r;try{r=await no.load(t)}catch{r=null}if(n.loadingTime=yo.endTime(),r){let{meshesMap:e,objects:i,linesMap:a}=So(r,t.geometryType);n.serializationTime=yo.endTime();let o=0;for(let t of e.values())o+=t.length;n.info.objectCount=i.length,n.info.meshCount=o,n.info.geometryCount=e.size,n.info.lineCount=a.size;let s={metrics:n,meshesMap:e,linesMap:a,objects:i,type:`FileLoaded`};self.postMessage(s)}else{n.serializationTime=0,n.info.objectCount=0,n.info.lineCount=0,n.info.meshCount=0,n.info.geometryCount=0;let e={type:`FileFailed`,metrics:n};self.postMessage(e)}}function So(e,t){let n=[],r=[],i=/* @__PURE__ */ new Map,a=/* @__PURE__ */ new Map,o=/* @__PURE__ */ new Map;e.updateMatrixWorld(!0);let s=/* @__PURE__ */ new Set,c=/* @__PURE__ */ new Set,l=/* @__PURE__ */ new Set,u=/* @__PURE__ */ new Set;function d(e){let t=i.get(e.uuid);return t||(t=oo(e),so(t,n),i.set(e.uuid,t)),t}let f=/* @__PURE__ */ new Set;function p(e){Co(e.geometry),s.add(e)}function m(e){f.has(e.geometry)||(To(e.geometry),f.add(e.geometry)),c.add(e)}function h(e){wo(e.geometry),c.add(e)}function g(e){u.add(e)}function _(e){l.add(e)}e.traverse(t=>{t!==e&&(t.parent===e&&(t.parent=null),t.isMesh?p(t):t.isLineSegments?h(t):t.isLine?m(t):t.isGroup?g(t):_(t))});for(let e of l){let t=po(e);r.push(t)}let v=/* @__PURE__ */ new Set;for(let e of u){let t=e.children.filter(e=>e.userData.stereograph?.guid===void 0),n=e.userData.stereograph?.guid!==void 0&&t.length>0;if(n)for(let e of t)v.add(e);let i=po(e);i.isMeshGroup=n,r.push(i)}for(let e of s){let n=vo(e,t);n.userData.stereograph?.geometryType&&(n.geometryType=n.userData.stereograph.geometryType),e.parent&&v.has(e)&&(n.userData={...e.parent.userData},n.isInMeshGroup=!0);let r=d(e.geometry),i=a.get(r);i||(i=[],a.set(r,i)),i.push(n)}for(let e of c){let n=ho(e,t);n.userData.stereograph?.geometryType&&(n.geometryType=n.userData.stereograph.geometryType),e.parent&&v.has(e)&&(n.userData={...e.parent.userData},n.isInMeshGroup=!0);let r=d(e.geometry),i=o.get(r);i||(i=[],o.set(r,i)),i.push(n)}return{meshesMap:a,objects:r,linesMap:o,transferables:n}}function Co(e){if(e.index!=null)return;let t=Vi(e,1e-4);e.setIndex(t.index),e.setAttribute(`position`,t.getAttribute(`position`)),t.hasAttribute(`normal`)&&e.setAttribute(`normal`,t.getAttribute(`normal`))}function wo(e){if(e.index===null)return;let t=e.toNonIndexed();e.setIndex(null),e.setAttribute(`position`,t.getAttribute(`position`)),t.hasAttribute(`normal`)&&e.setAttribute(`normal`,t.getAttribute(`normal`))}function To(e){let t=new on;wo(e);let n=e.getAttribute(`position`),r=[];for(let e=0;e<n.count-1;e++){let t=n.getX(e),i=n.getY(e),a=n.getZ(e),o=n.getX(e+1),s=n.getY(e+1),c=n.getZ(e+1);r.push(t,i,a,o,s,c)}t.setAttribute(`position`,new Yt(r,3))}})();\n//# sourceMappingURL=FileLoadingWorker-B4A8Xlt6.js.map", jt = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", At], { type: "text/javascript;charset=utf-8" });
function Mt(e) {
	let t;
	try {
		if (t = jt && (self.URL || self.webkitURL).createObjectURL(jt), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(At), { name: e?.name });
	}
}
//#endregion
//#region src/io/controllers/FileLoadingWorkerController.ts
var Nt = class {
	constructor(e) {
		this._viewer = e, this.onFileLoaded = () => {}, this.onFileFailed = () => {}, this._onMessage = async (e, t) => {
			let n = e.data;
			n.type === "FileLoaded" ? this._onFileLoadedMessage(n, t) : n.type === "FileFailed" && this._onFileFailedMessage(n, t);
		}, this.controller = new _t(Mt, "FileLoadingWorker", this._viewer.settings.loading.loadingWorkersCount.value), this.controller.onmessage = this._onMessage, this._setupSignals();
	}
	_setupSignals() {
		this._viewer.settings.loading.loadingWorkersCount.onChange.connect((e) => this.controller.maxWorkers = e);
	}
	loadFile(e) {
		let t = this.controller.nextFreeWorker();
		t !== null && this._sendFileLoadingMessage(e, t);
	}
	_sendFileLoadingMessage(e, t) {
		let n = {
			type: "LoadFileRequest",
			fileRequest: e
		};
		this.controller.lockWorker(t), this.controller.postMessageWithId(t, n);
	}
	_onFileLoadedMessage(e, t) {
		this.controller.freeWorker(t), this.onFileLoaded(e);
	}
	_onFileFailedMessage(e, t) {
		this.controller.freeWorker(t), this.onFileFailed(e);
	}
};
//#endregion
//#region src/scene/serialization/SerializedVector3.ts
function Pt(e) {
	return e.toArray();
}
function Ft(e, t) {
	return t.fromArray(e);
}
//#endregion
//#region src/scene/serialization/SerializedBox3.ts
function It(e) {
	return {
		min: Pt(e.min),
		max: Pt(e.max)
	};
}
function Lt(e, t) {
	return Ft(e.min, t.min), Ft(e.max, t.max), t;
}
//#endregion
//#region src/scene/serialization/SerializedSphere.ts
function Rt(e) {
	return {
		radius: e.radius,
		center: Pt(e.center)
	};
}
function zt(e, t) {
	return t.radius = e.radius, Ft(e.center, t.center), t;
}
//#endregion
//#region src/scene/geometry/batching/BatchedGeometry.ts
var Bt = "batchId", Vt = /* @__PURE__ */ new a(), Ht = /* @__PURE__ */ new y(), Ut = /* @__PURE__ */ new y(), Wt = /* @__PURE__ */ new b(), Gt = (/* @__PURE__ */ {
	start: -1,
	count: -1
}), Kt = (/* @__PURE__ */ {
	start: -1,
	count: -1
}), qt = (/* @__PURE__ */ {
	start: -1,
	count: -1
}), Jt = class e extends l {
	constructor(e = {}) {
		super(), this.isBatchedGeometry = !0, this.boundingBox = new a(), this.boundingSphere = new b(), this._vertexStart = 0, this._indexStart = 0, this._isInitialized = !1, this.needBoundingBoxUpdate = !1, this._freeGeometryIds = /* @__PURE__ */ new Set(), this._maxGeometryCount = e.maxGeometryCount ?? 1e4, this._maxVertexCount = e.maxVertexCount ?? 1e6, this._maxIndexCount = e.maxIndexCount ?? 1e6, this._useIndex = e.useIndex ?? !1, this._useNormals = e.useNormals ?? !1, this._geometryCount = 0;
		let t = e.buffers ?? {};
		this._bounds = t.bounds ?? new Float32Array(new SharedArrayBuffer(this._maxGeometryCount * 6 * 4)), this._indexRanges = t.indexRanges ?? new Uint32Array(new SharedArrayBuffer(this._useIndex ? this._maxGeometryCount * 2 * 4 : 0)), this._vertexRanges = t.vertexRanges ?? new Uint32Array(new SharedArrayBuffer(this._maxGeometryCount * 2 * 4)), this._matricesTexture = this._initMatrixTexture(t.matrices);
	}
	static serialize(e) {
		return {
			attributes: {
				index: e.index ? e.index.array : null,
				position: e.hasAttribute("position") ? e.getAttribute("position").array : null,
				normal: e.hasAttribute("normal") ? e.getAttribute("normal").array : null,
				batchId: e.hasAttribute(Bt) ? e.getAttribute(Bt).array : null
			},
			uuid: e.uuid,
			vertexStart: e._vertexStart,
			indexStart: e._indexStart,
			isInitialized: e._isInitialized,
			matrices: e._matricesTexture.image.data,
			geometryCount: e._geometryCount,
			useIndex: e._useIndex,
			useNormals: e._useNormals,
			bounds: e._bounds,
			indexRanges: e._indexRanges,
			vertexRanges: e._vertexRanges,
			maxVertexCount: e._maxVertexCount,
			maxIndexCount: e._maxIndexCount,
			maxGeometryCount: e._maxGeometryCount,
			boundingBox: It(e.boundingBox),
			boundingSphere: Rt(e.boundingSphere)
		};
	}
	static deserialize(t) {
		let n = new e({
			maxGeometryCount: t.maxGeometryCount,
			useIndex: t.useIndex,
			useNormals: t.useNormals,
			maxVertexCount: t.maxVertexCount,
			maxIndexCount: t.maxIndexCount,
			buffers: {
				matrices: t.matrices,
				vertexRanges: t.vertexRanges,
				indexRanges: t.indexRanges,
				bounds: t.bounds
			}
		});
		return e._setupGeometryAfterDeserialization(n, t), n;
	}
	static _setupGeometryAfterDeserialization(e, t) {
		e.uuid = t.uuid, e._vertexStart = t.vertexStart, e._indexStart = t.indexStart, e._geometryCount = t.geometryCount, e._isInitialized = t.isInitialized;
		let { position: n, batchId: r, normal: i, index: a } = t.attributes;
		a && e.setIndex(new c(a, 1)), n && e.setAttribute("position", new c(n, 3)), r && e.setAttribute(Bt, new c(r, 1)), i && e.setAttribute("normal", new c(i, 3)), Lt(t.boundingBox, e.boundingBox), zt(t.boundingSphere, e.boundingSphere);
	}
	get geometryCount() {
		return this._geometryCount;
	}
	get maxGeometryCount() {
		return this._maxGeometryCount;
	}
	getIndexFillRate() {
		return this.index ? this._indexStart / this.index.count : -1;
	}
	getVertexFillRate() {
		return this._vertexStart / this.getAttribute("position").count;
	}
	initialize() {
		if (this._isInitialized) throw Error("BatchedBufferGeometry is already initialized. Please dispose first.");
		let e;
		e = 12 * this._maxVertexCount;
		let t = new c(new Float32Array(new SharedArrayBuffer(e)), 3);
		if (t.setUsage(Pe), this.setAttribute("position", t), this._useNormals) {
			e = 12 * this._maxVertexCount;
			let t = new c(new Float32Array(new SharedArrayBuffer(e)), 3);
			t.setUsage(Pe), this.setAttribute("normal", t);
		}
		let n;
		if (this._useIndex) {
			this._maxVertexCount >= 65536 ? (e = this._maxIndexCount * 4, n = new Uint32Array(new SharedArrayBuffer(e))) : (e = this._maxIndexCount * 2, n = new Uint16Array(new SharedArrayBuffer(e)));
			let t = new c(n, 1);
			t.setUsage(Pe), this.setIndex(t);
		}
		this._maxGeometryCount >= 65536 ? (e = this._maxVertexCount * 4, n = new Uint32Array(new SharedArrayBuffer(e))) : (e = this._maxVertexCount * 2, n = new Uint16Array(new SharedArrayBuffer(e)));
		let r = new c(n, 1);
		r.setUsage(Pe), this.setAttribute(Bt, r), this._isInitialized = !0;
	}
	get stats() {
		return {
			vertexFillRate: this._vertexStart / this._maxVertexCount,
			indexFilRate: this._indexStart / this._maxIndexCount
		};
	}
	_checkVertexCountFits(e) {
		let t = this.getAttribute("position");
		return !(this._vertexStart + e > t.count);
	}
	_checkIndexCountFits(e) {
		let t = this.index;
		return !(t && this._indexStart + e > t.count);
	}
	_checkGeometryInsertion(e, t) {
		if (this._isInitialized || this.initialize(), t >= this._maxGeometryCount) throw Error("Maximum geometry count reached");
		for (let t in e.attributes) if (e.getAttribute(t).isInterleavedBufferAttribute) throw Error(`InterleavedBufferAttribute are not supported (attr=${t})`);
		let n = e.attributes.position;
		if (!n) throw Error("Added geometry has no position attribute");
		if (!this._checkVertexCountFits(n.count)) throw Error("Not enough place in position buffer for given geometry");
		let r = e.index;
		if (this._useIndex) {
			if (!r) throw Error("Added geometry has no index attribute");
			if (!this._checkIndexCountFits(r.count)) throw Error("Not enough place in index buffer for given geometry");
		}
		let i = e.getAttribute("normal");
		if (this._useNormals && !i) throw Error("Added geometry has no normal attribute");
	}
	canInsertGeometry(e) {
		let t = this._freeGeometryIds.values().next().value;
		t && this._freeGeometryIds.delete(t), t ??= this._geometryCount;
		try {
			return this._checkGeometryInsertion(e, t), !0;
		} catch {
			return !1;
		}
	}
	addGeometry(e) {
		let t = this._freeGeometryIds.values().next().value, n = !1;
		t === void 0 ? (n = !0, t = this._geometryCount) : this._freeGeometryIds.delete(t), this._checkGeometryInsertion(e, t);
		let r = {
			start: -1,
			count: -1
		}, i = {
			start: -1,
			count: -1
		}, a = e.index;
		if (this._useIndex && this.index) {
			let e = this.index;
			for (let t = 0; t < a.count; t++) e.setX(this._indexStart + t, a.getX(t) + this._vertexStart);
			e.needsUpdate = !0, r.start = this._indexStart, r.count = a.count, this._indexStart += a.count;
		}
		let o = ["position"];
		this._useNormals && o.push("normal");
		for (let t of o) Yt(e.getAttribute(t), this.getAttribute(t), this._vertexStart);
		let s = e.getAttribute("position");
		i.start = this._vertexStart, i.count = s.count;
		let c = this.getAttribute(Bt);
		for (let e = 0; e < s.count; e++) c.setX(this._vertexStart + e, t);
		return c.needsUpdate = !0, e.boundingBox || e.computeBoundingBox(), this._setLocalBoundingBoxAt(t, e.boundingBox), this._setVertexRange(t, i), this.index && this._setIndexRange(t, r), n && this._geometryCount++, this._vertexStart += s.count, this.setMatrixAt(t, Ut), this.needBoundingBoxUpdate = !0, t;
	}
	removeGeometry(e) {
		let t = this.getVertexRangeAt(e, Gt);
		if (this._useIndex && this.index) {
			let n = this.getIndexRangeAt(e, Kt), r = this.index;
			for (let e = n.start; e < r.count; e++) {
				let i = r.getX(e + n.count);
				i > 0 && (i -= t.count), r.setX(e, i);
			}
			this._indexStart -= n.count, r.needsUpdate = !0;
		}
		let n = ["position"];
		this._useNormals && n.push("normal");
		for (let e of n) {
			let n = this.getAttribute(e);
			n.clearUpdateRanges();
			for (let e = t.start; e < n.count - t.count; e++) for (let r = 0; r < n.itemSize; r++) {
				let i = n.getComponent(e + t.count, r);
				n.setComponent(e, r, i);
			}
			n.needsUpdate = !0;
		}
		this._vertexStart -= t.count;
		let r = this.getAttribute(Bt);
		for (let e = t.start; e < r.count; e++) {
			let n = r.getX(e + t.count);
			r.setX(e, n);
		}
		r.needsUpdate = !0;
		for (let e = 0; e < this._vertexRanges.length; e += 2) {
			let n = this._vertexRanges[e];
			n >= t.start + t.count && (this._vertexRanges[e] = n - t.count);
		}
		if (this.index) {
			let t = this.getIndexRangeAt(e, Kt);
			for (let e = 0; e < this._indexRanges.length; e += 2) {
				let n = this._indexRanges[e];
				n >= t.start + t.count && (this._indexRanges[e] = n - t.count);
			}
		}
		this._freeGeometryIds.add(e), this.needBoundingBoxUpdate = !0;
	}
	getDrawRangeAt(e, t) {
		return this.index ? this.getIndexRangeAt(e, t) : this.getVertexRangeAt(e, t);
	}
	getVertexRangeAt(e, t) {
		if (e >= this._geometryCount) throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);
		let n = e * 2;
		return t.start = this._vertexRanges[n], t.count = this._vertexRanges[n + 1], t;
	}
	getIndexRangeAt(e, t) {
		if (e >= this._geometryCount) throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);
		let n = e * 2;
		return t.start = this._indexRanges[n], t.count = this._indexRanges[n + 1], t;
	}
	computeBoundingSphere() {
		let e = this._geometryCount, t = this.boundingSphere;
		t.makeEmpty();
		for (let n = 0; n < e; n++) this._freeGeometryIds.has(n) || (this.getWorldBoundingSphereAt(n, Wt), t.union(Wt));
	}
	getLocalBoundingBoxAt(e, t) {
		if (e >= this._geometryCount) throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);
		let n = e * 6, r = this._bounds;
		return t.min.set(r[n], r[n + 1], r[n + 2]), t.max.set(r[n + 3], r[n + 4], r[n + 5]), t;
	}
	getLocalBoundingSphereAt(e, t) {
		return this.getLocalBoundingBoxAt(e, Vt), Vt.getBoundingSphere(t), t;
	}
	getWorldBoundingBoxAt(e, t) {
		return this.getMatrixAt(e, Ht), this.getLocalBoundingBoxAt(e, t).applyMatrix4(Ht);
	}
	getWorldBoundingSphereAt(e, t) {
		return this.getMatrixAt(e, Ht), this.getLocalBoundingSphereAt(e, t).applyMatrix4(Ht);
	}
	setMatrixAt(e, t) {
		if (e > this._geometryCount) throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);
		let n = this._matricesTexture.image.data;
		return t.toArray(n, e * 16), this._matricesTexture.needsUpdate = !0, this.needBoundingBoxUpdate = !0, t;
	}
	getMatrixAt(e, t) {
		if (e > this._geometryCount) throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);
		let n = this._matricesTexture.image.data;
		return t.fromArray(n, e * 16), t;
	}
	setPositionAt(e, t) {
		return this.getMatrixAt(e, Ht), Ht.setPosition(t), this.setMatrixAt(e, Ht), t;
	}
	getPositionAt(e, t) {
		return t.setFromMatrixPosition(this.getMatrixAt(e, Ht));
	}
	getGeometryAt(e, t) {
		this.getDrawRangeAt(e, qt);
		let n = qt.start, r = qt.start + qt.count;
		return this.index ? (t.setIndex(new c(this.index.array.subarray(n, r), 1)), t.setAttribute("position", this.attributes.position), this._useNormals && t.setAttribute("normal", this.attributes.normal)) : (n = qt.start * 3, r = (qt.start + qt.count) * 3, t.setIndex(null), t.setAttribute("position", new c(this.attributes.position.array.subarray(n, r), 3)), this._useNormals && t.setAttribute("normal", new c(this.attributes.normal.array.subarray(n, r), 3))), t;
	}
	copyGeometryAt(e, t) {
		this.getIndexRangeAt(e, Kt), this.getVertexRangeAt(e, Gt);
		let n = Gt.start * 3, r = (Gt.start + Gt.count) * 3;
		if (this.index) {
			let e;
			e = Kt.count >= 65536 ? new Uint32Array(Kt.count) : new Uint16Array(Kt.count);
			let n = new c(e, 1);
			for (let e = Kt.start; e < Kt.start + Kt.count; e++) n.setX(e - Kt.start, this.index.array[e] - Gt.start);
			t.setIndex(n);
		} else t.setIndex(null);
		return t.setAttribute("position", new c(this.attributes.position.array.subarray(n, r), 3)), this._useNormals && t.setAttribute("normal", new c(this.attributes.normal.array.subarray(n, r), 3)), t;
	}
	dispose() {
		this._matricesTexture.dispose(), super.dispose(), this._isInitialized = !1;
	}
	toUpdate() {
		return this.needBoundingBoxUpdate && (this.computeBoundingBox(), this.computeBoundingSphere()), {
			vertexStart: this._vertexStart,
			indexStart: this._indexStart,
			geometryCount: this._geometryCount,
			boundingBox: It(this.boundingBox),
			boundingSphere: Rt(this.boundingSphere)
		};
	}
	applyUpdate(e) {
		this._vertexStart = e.vertexStart, this._indexStart = e.indexStart, this._geometryCount = e.geometryCount, Lt(e.boundingBox, this.boundingBox), zt(e.boundingSphere, this.boundingSphere), this.index && (this.index.needsUpdate = !0), this._matricesTexture.needsUpdate = !0;
		let t = this.getAttribute("position");
		t.needsUpdate = !0;
		let n = this.getAttribute(Bt);
		n.needsUpdate = !0;
		let r = this.getAttribute("normal");
		r && (r.needsUpdate = !0);
	}
	_initMatrixTexture(e) {
		let t = Math.sqrt(this._maxGeometryCount * 4);
		t = Math.ceil(t / 4) * 4, t = Math.max(t, 4), e ??= new Float32Array(new SharedArrayBuffer(t * t * 4 * 4));
		let n = new p(e, t, t, Ee, _);
		return n.needsUpdate = !0, n;
	}
	_setLocalBoundingBoxAt(e, t) {
		let n = e * 6;
		this._bounds[n] = t.min.x, this._bounds[n + 1] = t.min.y, this._bounds[n + 2] = t.min.z, this._bounds[n + 3] = t.max.x, this._bounds[n + 4] = t.max.y, this._bounds[n + 5] = t.max.z;
	}
	_setIndexRange(e, t) {
		let n = e * 2;
		this._indexRanges[n] = t.start, this._indexRanges[n + 1] = t.count;
	}
	_setVertexRange(e, t) {
		let n = e * 2;
		this._vertexRanges[n] = t.start, this._vertexRanges[n + 1] = t.count;
	}
};
function Yt(e, t, n = 0) {
	let r = t.itemSize, i = e.count;
	if (e.isInterleavedBufferAttribute || e.array.constructor !== t.array.constructor) for (let a = 0; a < i; a++) for (let i = 0; i < r; i++) t.setComponent(a + n, i, e.getComponent(a, i));
	else t.array.set(e.array, n * r);
	t.addUpdateRange(n * r, i * r), t.needsUpdate = !0;
}
//#endregion
//#region src/scene/geometry/batching/BatchedLineGeometry.ts
var Xt = /* @__PURE__ */ new x(), Zt = /* @__PURE__ */ new x(), E = class e extends Jt {
	constructor(...e) {
		super(...e), this.isBatchedLineGeometry = !0;
	}
	addGeometry(e) {
		if (e.index) throw Error("Line geometries should not be indexed. Convert it first.");
		return super.addGeometry(e);
	}
	static deserialize(t) {
		let n = new e({
			maxGeometryCount: t.maxGeometryCount,
			useIndex: t.useIndex,
			useNormals: t.useNormals,
			maxVertexCount: t.maxVertexCount,
			maxIndexCount: t.maxIndexCount,
			buffers: {
				matrices: t.matrices,
				vertexRanges: t.vertexRanges,
				indexRanges: t.indexRanges,
				bounds: t.bounds
			}
		});
		return Jt._setupGeometryAfterDeserialization(n, t), n;
	}
	static serialize(e) {
		return {
			isBatchedLineGeometry: !0,
			...Jt.serialize(e)
		};
	}
	computeLineDistanceAttribute() {
		if (this.index === null) {
			let e = this.attributes.position, t = [0];
			for (let n = 1, r = e.count; n < r; n++) Xt.fromBufferAttribute(e, n - 1), Zt.fromBufferAttribute(e, n), t[n] = t[n - 1], t[n] += Xt.distanceTo(Zt);
			this.setAttribute("lineDistance", new te(t, 1));
		} else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
		return this;
	}
};
//#endregion
//#region src/scene/serialization/SerializedBufferGeometry.ts
function Qt(e, t) {
	e.index && t.push(e.index.array.buffer);
	for (let n of e.attributes) t.push(n.array.buffer);
}
//#endregion
//#region src/workers/GeometryBatchingWorker.ts?worker&inline
var $t = "(function(){\n/**\n* @license\n* Copyright 2010-2026 Three.js Authors\n* SPDX-License-Identifier: MIT\n*/\nlet e=1e3,t=1001,n=1002,r=1003,i=1015,a=1023,o=2300,s=2301,c=2302,l=2303,u=2400,d=2401,f=2402,p=`srgb`,m=`srgb-linear`,h=`linear`,g=35044,_=2e3;function v(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function y(e){return ArrayBuffer.isView(e)&&!(e instanceof DataView)}function b(e){return document.createElementNS(`http://www.w3.org/1999/xhtml`,e)}let x={};function S(e){let t=e[0];if(typeof t==`string`&&t.startsWith(`TSL:`)){let t=e[1];t&&t.isStackTrace?e[0]+=` `+t.getLocation():e[1]=`Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.`}return e}function C(...e){e=S(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.warn(n.getError(t)):console.warn(t,...e)}}function w(...e){e=S(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.error(n.getError(t)):console.error(t,...e)}}function T(...e){let t=e.join(` `);t in x||(x[t]=!0,C(...e))}var E=class{addEventListener(e,t){this._listeners===void 0&&(this._listeners={});let n=this._listeners;n[e]===void 0&&(n[e]=[]),n[e].indexOf(t)===-1&&n[e].push(t)}hasEventListener(e,t){let n=this._listeners;return n!==void 0&&n[e]!==void 0&&n[e].indexOf(t)!==-1}removeEventListener(e,t){let n=this._listeners;if(n===void 0)return;let r=n[e];if(r!==void 0){let e=r.indexOf(t);e!==-1&&r.splice(e,1)}}dispatchEvent(e){let t=this._listeners;if(t===void 0)return;let n=t[e.type];if(n!==void 0){e.target=this;let t=n.slice(0);for(let n=0,r=t.length;n<r;n++)t[n].call(this,e);e.target=null}}};let D=/* @__PURE__ */ `00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff`.split(`.`),O=Math.PI/180;function k(){let e=Math.random()*4294967295|0,t=Math.random()*4294967295|0,n=Math.random()*4294967295|0,r=Math.random()*4294967295|0;return(D[e&255]+D[e>>8&255]+D[e>>16&255]+D[e>>24&255]+`-`+D[t&255]+D[t>>8&255]+`-`+D[t>>16&15|64]+D[t>>24&255]+`-`+D[n&63|128]+D[n>>8&255]+`-`+D[n>>16&255]+D[n>>24&255]+D[r&255]+D[r>>8&255]+D[r>>16&255]+D[r>>24&255]).toLowerCase()}function A(e,t,n){return Math.max(t,Math.min(n,e))}function j(e,t){return(e%t+t)%t}function M(e,t,n){return(1-n)*e+n*t}function N(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:case Uint8ClampedArray:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}function P(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(e*4294967295);case Uint16Array:return Math.round(e*65535);case Uint8Array:case Uint8ClampedArray:return Math.round(e*255);case Int32Array:return Math.round(e*2147483647);case Int16Array:return Math.round(e*32767);case Int8Array:return Math.round(e*127);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}var F=class e{static{e.prototype.isVector2=!0}constructor(e=0,t=0){this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw Error(`THREE.Vector2: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw Error(`THREE.Vector2: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){let t=this.x,n=this.y,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6],this.y=r[1]*t+r[4]*n+r[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=A(this.x,e.x,t.x),this.y=A(this.y,e.y,t.y),this}clampScalar(e,t){return this.x=A(this.x,e,t),this.y=A(this.y,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(A(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(A(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){let n=Math.cos(t),r=Math.sin(t),i=this.x-e.x,a=this.y-e.y;return this.x=i*n-a*r+e.x,this.y=i*r+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}},ee=class{constructor(e=0,t=0,n=0,r=1){this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=r}static slerpFlat(e,t,n,r,i,a,o){let s=n[r+0],c=n[r+1],l=n[r+2],u=n[r+3],d=i[a+0],f=i[a+1],p=i[a+2],m=i[a+3];if(u!==m||s!==d||c!==f||l!==p){let e=s*d+c*f+l*p+u*m;e<0&&(d=-d,f=-f,p=-p,m=-m,e=-e);let t=1-o;if(e<.9995){let n=Math.acos(e),r=Math.sin(n);t=Math.sin(t*n)/r,o=Math.sin(o*n)/r,s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o}else{s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o;let e=1/Math.sqrt(s*s+c*c+l*l+u*u);s*=e,c*=e,l*=e,u*=e}}e[t]=s,e[t+1]=c,e[t+2]=l,e[t+3]=u}static multiplyQuaternionsFlat(e,t,n,r,i,a){let o=n[r],s=n[r+1],c=n[r+2],l=n[r+3],u=i[a],d=i[a+1],f=i[a+2],p=i[a+3];return e[t]=o*p+l*u+s*f-c*d,e[t+1]=s*p+l*d+c*u-o*f,e[t+2]=c*p+l*f+o*d-s*u,e[t+3]=l*p-o*u-s*d-c*f,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,r){return this._x=e,this._y=t,this._z=n,this._w=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t=!0){let n=e._x,r=e._y,i=e._z,a=e._order,o=Math.cos,s=Math.sin,c=o(n/2),l=o(r/2),u=o(i/2),d=s(n/2),f=s(r/2),p=s(i/2);switch(a){case`XYZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`YXZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`ZXY`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`ZYX`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`YZX`:this._x=d*l*u+c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u-d*f*p;break;case`XZY`:this._x=d*l*u-c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u+d*f*p;break;default:C(`Quaternion: .setFromEuler() encountered an unknown order: `+a)}return t===!0&&this._onChangeCallback(),this}setFromAxisAngle(e,t){let n=t/2,r=Math.sin(n);return this._x=e.x*r,this._y=e.y*r,this._z=e.z*r,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){let t=e.elements,n=t[0],r=t[4],i=t[8],a=t[1],o=t[5],s=t[9],c=t[2],l=t[6],u=t[10],d=n+o+u;if(d>0){let e=.5/Math.sqrt(d+1);this._w=.25/e,this._x=(l-s)*e,this._y=(i-c)*e,this._z=(a-r)*e}else if(n>o&&n>u){let e=2*Math.sqrt(1+n-o-u);this._w=(l-s)/e,this._x=.25*e,this._y=(r+a)/e,this._z=(i+c)/e}else if(o>u){let e=2*Math.sqrt(1+o-n-u);this._w=(i-c)/e,this._x=(r+a)/e,this._y=.25*e,this._z=(s+l)/e}else{let e=2*Math.sqrt(1+u-n-o);this._w=(a-r)/e,this._x=(i+c)/e,this._y=(s+l)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<1e-8?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(A(this.dot(e),-1,1)))}rotateTowards(e,t){let n=this.angleTo(e);if(n===0)return this;let r=Math.min(1,t/n);return this.slerp(e,r),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return e===0?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x*=e,this._y*=e,this._z*=e,this._w*=e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=t._x,s=t._y,c=t._z,l=t._w;return this._x=n*l+a*o+r*c-i*s,this._y=r*l+a*s+i*o-n*c,this._z=i*l+a*c+n*s-r*o,this._w=a*l-n*o-r*s-i*c,this._onChangeCallback(),this}slerp(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=this.dot(e);o<0&&(n=-n,r=-r,i=-i,a=-a,o=-o);let s=1-t;if(o<.9995){let e=Math.acos(o),c=Math.sin(e);s=Math.sin(s*e)/c,t=Math.sin(t*e)/c,this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this._onChangeCallback()}else this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this.normalize();return this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){let e=2*Math.PI*Math.random(),t=2*Math.PI*Math.random(),n=Math.random(),r=Math.sqrt(1-n),i=Math.sqrt(n);return this.set(r*Math.sin(e),r*Math.cos(e),i*Math.sin(t),i*Math.cos(t))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e,t=0){return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this._onChangeCallback(),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}},I=class e{static{e.prototype.isVector3=!0}constructor(e=0,t=0,n=0){this.x=e,this.y=t,this.z=n}set(e,t,n){return n===void 0&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw Error(`THREE.Vector3: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw Error(`THREE.Vector3: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(ne.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(ne.setFromAxisAngle(e,t))}applyMatrix3(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6]*r,this.y=i[1]*t+i[4]*n+i[7]*r,this.z=i[2]*t+i[5]*n+i[8]*r,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=e.elements,a=1/(i[3]*t+i[7]*n+i[11]*r+i[15]);return this.x=(i[0]*t+i[4]*n+i[8]*r+i[12])*a,this.y=(i[1]*t+i[5]*n+i[9]*r+i[13])*a,this.z=(i[2]*t+i[6]*n+i[10]*r+i[14])*a,this}applyQuaternion(e){let t=this.x,n=this.y,r=this.z,i=e.x,a=e.y,o=e.z,s=e.w,c=2*(a*r-o*n),l=2*(o*t-i*r),u=2*(i*n-a*t);return this.x=t+s*c+a*u-o*l,this.y=n+s*l+o*c-i*u,this.z=r+s*u+i*l-a*c,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[4]*n+i[8]*r,this.y=i[1]*t+i[5]*n+i[9]*r,this.z=i[2]*t+i[6]*n+i[10]*r,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=A(this.x,e.x,t.x),this.y=A(this.y,e.y,t.y),this.z=A(this.z,e.z,t.z),this}clampScalar(e,t){return this.x=A(this.x,e,t),this.y=A(this.y,e,t),this.z=A(this.z,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(A(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){let n=e.x,r=e.y,i=e.z,a=t.x,o=t.y,s=t.z;return this.x=r*s-i*o,this.y=i*a-n*s,this.z=n*o-r*a,this}projectOnVector(e){let t=e.lengthSq();if(t===0)return this.set(0,0,0);let n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return te.copy(this).projectOnVector(e),this.sub(te)}reflect(e){return this.sub(te.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(A(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y,r=this.z-e.z;return t*t+n*n+r*r}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){let r=Math.sin(t)*e;return this.x=r*Math.sin(n),this.y=Math.cos(t)*e,this.z=r*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){let t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),r=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=r,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,t*4)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,t*3)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){let e=Math.random()*Math.PI*2,t=Math.random()*2-1,n=Math.sqrt(1-t*t);return this.x=n*Math.cos(e),this.y=t,this.z=n*Math.sin(e),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}};let te=/*@__PURE__*/ new I,ne=/*@__PURE__*/ new ee;var re=class e{static{e.prototype.isMatrix3=!0}constructor(e,t,n,r,i,a,o,s,c){this.elements=[1,0,0,0,1,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c)}set(e,t,n,r,i,a,o,s,c){let l=this.elements;return l[0]=e,l[1]=r,l[2]=o,l[3]=t,l[4]=i,l[5]=s,l[6]=n,l[7]=a,l[8]=c,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){let t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[3],s=n[6],c=n[1],l=n[4],u=n[7],d=n[2],f=n[5],p=n[8],m=r[0],h=r[3],g=r[6],_=r[1],v=r[4],y=r[7],b=r[2],x=r[5],S=r[8];return i[0]=a*m+o*_+s*b,i[3]=a*h+o*v+s*x,i[6]=a*g+o*y+s*S,i[1]=c*m+l*_+u*b,i[4]=c*h+l*v+u*x,i[7]=c*g+l*y+u*S,i[2]=d*m+f*_+p*b,i[5]=d*h+f*v+p*x,i[8]=d*g+f*y+p*S,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8];return t*a*l-t*o*c-n*i*l+n*o*s+r*i*c-r*a*s}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=l*a-o*c,d=o*s-l*i,f=c*i-a*s,p=t*u+n*d+r*f;if(p===0)return this.set(0,0,0,0,0,0,0,0,0);let m=1/p;return e[0]=u*m,e[1]=(r*c-l*n)*m,e[2]=(o*n-r*a)*m,e[3]=d*m,e[4]=(l*t-r*s)*m,e[5]=(r*i-o*t)*m,e[6]=f*m,e[7]=(n*s-c*t)*m,e[8]=(a*t-n*i)*m,this}transpose(){let e,t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){let t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,r,i,a,o){let s=Math.cos(i),c=Math.sin(i);return this.set(n*s,n*c,-n*(s*a+c*o)+a+e,-r*c,r*s,-r*(-c*a+s*o)+o+t,0,0,1),this}scale(e,t){return T(`Matrix3: .scale() is deprecated. Use .makeScale() instead.`),this.premultiply(ie.makeScale(e,t)),this}rotate(e){return T(`Matrix3: .rotate() is deprecated. Use .makeRotation() instead.`),this.premultiply(ie.makeRotation(-e)),this}translate(e,t){return T(`Matrix3: .translate() is deprecated. Use .makeTranslation() instead.`),this.premultiply(ie.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return new this.constructor().fromArray(this.elements)}};let ie=/*@__PURE__*/ new re,ae=/*@__PURE__*/ new re().set(.4123908,.3575843,.1804808,.212639,.7151687,.0721923,.0193308,.1191948,.9505322),oe=/*@__PURE__*/ new re().set(3.2409699,-1.5373832,-.4986108,-.9692436,1.8759675,.0415551,.0556301,-.203977,1.0569715);function se(){let e={enabled:!0,workingColorSpace:m,spaces:{},convert:function(e,t,n){return this.enabled===!1||t===n||!t||!n?e:(this.spaces[t].transfer===`srgb`&&(e.r=ce(e.r),e.g=ce(e.g),e.b=ce(e.b)),this.spaces[t].primaries!==this.spaces[n].primaries&&(e.applyMatrix3(this.spaces[t].toXYZ),e.applyMatrix3(this.spaces[n].fromXYZ)),this.spaces[n].transfer===`srgb`&&(e.r=le(e.r),e.g=le(e.g),e.b=le(e.b)),e)},workingToColorSpace:function(e,t){return this.convert(e,this.workingColorSpace,t)},colorSpaceToWorking:function(e,t){return this.convert(e,t,this.workingColorSpace)},getPrimaries:function(e){return this.spaces[e].primaries},getTransfer:function(e){return e===``?h:this.spaces[e].transfer},getToneMappingMode:function(e){return this.spaces[e].outputColorSpaceConfig.toneMappingMode||`standard`},getLuminanceCoefficients:function(e,t=this.workingColorSpace){return e.fromArray(this.spaces[t].luminanceCoefficients)},define:function(e){Object.assign(this.spaces,e)},_getMatrix:function(e,t,n){return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ)},_getDrawingBufferColorSpace:function(e){return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace},_getUnpackColorSpace:function(e=this.workingColorSpace){return this.spaces[e].workingColorSpaceConfig.unpackColorSpace},fromWorkingColorSpace:function(t,n){return T(`ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().`),e.workingToColorSpace(t,n)},toWorkingColorSpace:function(t,n){return T(`ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().`),e.colorSpaceToWorking(t,n)}},t=[.64,.33,.3,.6,.15,.06],n=[.2126,.7152,.0722],r=[.3127,.329];return e.define({[m]:{primaries:t,whitePoint:r,transfer:h,toXYZ:ae,fromXYZ:oe,luminanceCoefficients:n,workingColorSpaceConfig:{unpackColorSpace:p},outputColorSpaceConfig:{drawingBufferColorSpace:p}},[p]:{primaries:t,whitePoint:r,transfer:`srgb`,toXYZ:ae,fromXYZ:oe,luminanceCoefficients:n,outputColorSpaceConfig:{drawingBufferColorSpace:p}}}),e}let L=/*@__PURE__*/ se();function ce(e){return e<.04045?e*.0773993808:(e*.9478672986+.0521327014)**2.4}function le(e){return e<.0031308?e*12.92:1.055*e**.41666-.055}let ue;var de=class{static getDataURL(e,t=`image/png`){if(/^data:/i.test(e.src)||typeof HTMLCanvasElement>`u`)return e.src;let n;if(e instanceof HTMLCanvasElement)n=e;else{ue===void 0&&(ue=b(`canvas`)),ue.width=e.width,ue.height=e.height;let t=ue.getContext(`2d`);e instanceof ImageData?t.putImageData(e,0,0):t.drawImage(e,0,0,e.width,e.height),n=ue}return n.toDataURL(t)}static sRGBToLinear(e){if(typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap){let t=b(`canvas`);t.width=e.width,t.height=e.height;let n=t.getContext(`2d`);n.drawImage(e,0,0,e.width,e.height);let r=n.getImageData(0,0,e.width,e.height),i=r.data;for(let e=0;e<i.length;e++)i[e]=ce(i[e]/255)*255;return n.putImageData(r,0,0),t}if(e.data){let t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(ce(t[e]/255)*255):t[e]=ce(t[e]);return{data:t,width:e.width,height:e.height}}return C(`ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.`),e}};let fe=0;var pe=class{constructor(e=null){this.isTextureSource=!0,Object.defineProperty(this,\"id\",{value:fe++}),this.uuid=k(),this.data=e,this.dataReady=!0,this.version=0}getSize(e){let t=this.data;return typeof HTMLVideoElement<`u`&&t instanceof HTMLVideoElement?e.set(t.videoWidth,t.videoHeight,0):typeof VideoFrame<`u`&&t instanceof VideoFrame?e.set(t.displayWidth,t.displayHeight,0):t===null?e.set(0,0,0):e.set(t.width,t.height,t.depth||0),e}set needsUpdate(e){e===!0&&this.version++}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.images[this.uuid]!==void 0)return e.images[this.uuid];let n={uuid:this.uuid,url:``},r=this.data;if(r!==null){let e;if(Array.isArray(r)){e=[];for(let t=0,n=r.length;t<n;t++)r[t].isDataTexture?e.push(me(r[t].image)):e.push(me(r[t]))}else e=me(r);n.url=e}return t||(e.images[this.uuid]=n),n}};function me(e){return typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap?de.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(C(`Texture: Unable to serialize Texture.`),{})}let he=0,ge=/*@__PURE__*/ new I;var _e=class r extends E{constructor(e=r.DEFAULT_IMAGE,n=r.DEFAULT_MAPPING,i=t,o=t,s=1006,c=1008,l=a,u=1009,d=r.DEFAULT_ANISOTROPY,f=``){super(),this.isTexture=!0,Object.defineProperty(this,\"id\",{value:he++}),this.uuid=k(),this.name=``,this.source=new pe(e),this.mipmaps=[],this.mapping=n,this.channel=0,this.wrapS=i,this.wrapT=o,this.magFilter=s,this.minFilter=c,this.anisotropy=d,this.format=l,this.internalFormat=null,this.type=u,this.offset=new F(0,0),this.repeat=new F(1,1),this.center=new F(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new re,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.colorSpace=f,this.userData={},this.updateRanges=[],this.version=0,this.onUpdate=null,this.renderTarget=null,this.isRenderTargetTexture=!1,this.isArrayTexture=!!(e&&e.depth&&e.depth>1),this.pmremVersion=0,this.normalized=!1}get width(){return this.source.getSize(ge).x}get height(){return this.source.getSize(ge).y}get depth(){return this.source.getSize(ge).z}get image(){return this.source.data}set image(e){this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}clone(){return new this.constructor().copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.normalized=e.normalized,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.renderTarget=e.renderTarget,this.isRenderTargetTexture=e.isRenderTargetTexture,this.isArrayTexture=e.isArrayTexture,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}setValues(e){for(let t in e){let n=e[t];if(n===void 0){C(`Texture.setValues(): parameter '${t}' has value of undefined.`);continue}let r=this[t];if(r===void 0){C(`Texture.setValues(): property '${t}' does not exist.`);continue}r&&n&&r.isVector2&&n.isVector2||r&&n&&r.isVector3&&n.isVector3||r&&n&&r.isMatrix3&&n.isMatrix3?r.copy(n):this[t]=n}}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.textures[this.uuid]!==void 0)return e.textures[this.uuid];let n={metadata:{version:4.7,type:`Texture`,generator:`Texture.toJSON`},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,normalized:this.normalized,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:`dispose`})}transformUv(r){if(this.mapping!==300)return r;if(r.applyMatrix3(this.matrix),r.x<0||r.x>1)switch(this.wrapS){case e:r.x-=Math.floor(r.x);break;case t:r.x=r.x<0?0:1;break;case n:Math.abs(Math.floor(r.x)%2)===1?r.x=Math.ceil(r.x)-r.x:r.x-=Math.floor(r.x)}if(r.y<0||r.y>1)switch(this.wrapT){case e:r.y-=Math.floor(r.y);break;case t:r.y=r.y<0?0:1;break;case n:Math.abs(Math.floor(r.y)%2)===1?r.y=Math.ceil(r.y)-r.y:r.y-=Math.floor(r.y)}return this.flipY&&(r.y=1-r.y),r}set needsUpdate(e){e===!0&&(this.version++,this.source.needsUpdate=!0)}set needsPMREMUpdate(e){e===!0&&this.pmremVersion++}};_e.DEFAULT_IMAGE=null,_e.DEFAULT_MAPPING=300,_e.DEFAULT_ANISOTROPY=1;var ve=class e{static{e.prototype.isVector4=!0}constructor(e=0,t=0,n=0,r=1){this.x=e,this.y=t,this.z=n,this.w=r}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,r){return this.x=e,this.y=t,this.z=n,this.w=r,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw Error(`THREE.Vector4: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw Error(`THREE.Vector4: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=e.w===void 0?1:e.w,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*r+a[12]*i,this.y=a[1]*t+a[5]*n+a[9]*r+a[13]*i,this.z=a[2]*t+a[6]*n+a[10]*r+a[14]*i,this.w=a[3]*t+a[7]*n+a[11]*r+a[15]*i,this}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this.w/=e.w,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);let t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,r,i,a=.01,o=.1,s=e.elements,c=s[0],l=s[4],u=s[8],d=s[1],f=s[5],p=s[9],m=s[2],h=s[6],g=s[10];if(Math.abs(l-d)<a&&Math.abs(u-m)<a&&Math.abs(p-h)<a){if(Math.abs(l+d)<o&&Math.abs(u+m)<o&&Math.abs(p+h)<o&&Math.abs(c+f+g-3)<o)return this.set(1,0,0,0),this;t=Math.PI;let e=(c+1)/2,s=(f+1)/2,_=(g+1)/2,v=(l+d)/4,y=(u+m)/4,b=(p+h)/4;return e>s&&e>_?e<a?(n=0,r=.707106781,i=.707106781):(n=Math.sqrt(e),r=v/n,i=y/n):s>_?s<a?(n=.707106781,r=0,i=.707106781):(r=Math.sqrt(s),n=v/r,i=b/r):_<a?(n=.707106781,r=.707106781,i=0):(i=Math.sqrt(_),n=y/i,r=b/i),this.set(n,r,i,t),this}let _=Math.sqrt((h-p)*(h-p)+(u-m)*(u-m)+(d-l)*(d-l));return Math.abs(_)<.001&&(_=1),this.x=(h-p)/_,this.y=(u-m)/_,this.z=(d-l)/_,this.w=Math.acos((c+f+g-1)/2),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this.w=t[15],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=A(this.x,e.x,t.x),this.y=A(this.y,e.y,t.y),this.z=A(this.z,e.z,t.z),this.w=A(this.w,e.w,t.w),this}clampScalar(e,t){return this.x=A(this.x,e,t),this.y=A(this.y,e,t),this.z=A(this.z,e,t),this.w=A(this.w,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(A(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}},R=class e{static{e.prototype.isMatrix4=!0}constructor(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h)}set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){let g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=r,g[1]=i,g[5]=a,g[9]=o,g[13]=s,g[2]=c,g[6]=l,g[10]=u,g[14]=d,g[3]=f,g[7]=p,g[11]=m,g[15]=h,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return new e().fromArray(this.elements)}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){let t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){let t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return this.determinantAffine()===0?(e.set(1,0,0),t.set(0,1,0),n.set(0,0,1),this):(e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this)}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){if(e.determinantAffine()===0)return this.identity();let t=this.elements,n=e.elements,r=1/ye.setFromMatrixColumn(e,0).length(),i=1/ye.setFromMatrixColumn(e,1).length(),a=1/ye.setFromMatrixColumn(e,2).length();return t[0]=n[0]*r,t[1]=n[1]*r,t[2]=n[2]*r,t[3]=0,t[4]=n[4]*i,t[5]=n[5]*i,t[6]=n[6]*i,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){let t=this.elements,n=e.x,r=e.y,i=e.z,a=Math.cos(n),o=Math.sin(n),s=Math.cos(r),c=Math.sin(r),l=Math.cos(i),u=Math.sin(i);if(e.order===`XYZ`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=-s*u,t[8]=c,t[1]=n+r*c,t[5]=e-i*c,t[9]=-o*s,t[2]=i-e*c,t[6]=r+n*c,t[10]=a*s}else if(e.order===`YXZ`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e+i*o,t[4]=r*o-n,t[8]=a*c,t[1]=a*u,t[5]=a*l,t[9]=-o,t[2]=n*o-r,t[6]=i+e*o,t[10]=a*s}else if(e.order===`ZXY`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e-i*o,t[4]=-a*u,t[8]=r+n*o,t[1]=n+r*o,t[5]=a*l,t[9]=i-e*o,t[2]=-a*c,t[6]=o,t[10]=a*s}else if(e.order===`ZYX`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=r*c-n,t[8]=e*c+i,t[1]=s*u,t[5]=i*c+e,t[9]=n*c-r,t[2]=-c,t[6]=o*s,t[10]=a*s}else if(e.order===`YZX`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=i-e*u,t[8]=r*u+n,t[1]=u,t[5]=a*l,t[9]=-o*l,t[2]=-c*l,t[6]=n*u+r,t[10]=e-i*u}else if(e.order===`XZY`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=-u,t[8]=c*l,t[1]=e*u+i,t[5]=a*l,t[9]=n*u-r,t[2]=r*u-n,t[6]=o*l,t[10]=i*u+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(xe,e,Se)}lookAt(e,t,n){let r=this.elements;return Te.subVectors(e,t),Te.lengthSq()===0&&(Te.z=1),Te.normalize(),Ce.crossVectors(n,Te),Ce.lengthSq()===0&&(Math.abs(n.z)===1?Te.x+=1e-4:Te.z+=1e-4,Te.normalize(),Ce.crossVectors(n,Te)),Ce.normalize(),we.crossVectors(Te,Ce),r[0]=Ce.x,r[4]=we.x,r[8]=Te.x,r[1]=Ce.y,r[5]=we.y,r[9]=Te.y,r[2]=Ce.z,r[6]=we.z,r[10]=Te.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[4],s=n[8],c=n[12],l=n[1],u=n[5],d=n[9],f=n[13],p=n[2],m=n[6],h=n[10],g=n[14],_=n[3],v=n[7],y=n[11],b=n[15],x=r[0],S=r[4],C=r[8],w=r[12],T=r[1],E=r[5],D=r[9],O=r[13],k=r[2],A=r[6],j=r[10],M=r[14],N=r[3],P=r[7],F=r[11],ee=r[15];return i[0]=a*x+o*T+s*k+c*N,i[4]=a*S+o*E+s*A+c*P,i[8]=a*C+o*D+s*j+c*F,i[12]=a*w+o*O+s*M+c*ee,i[1]=l*x+u*T+d*k+f*N,i[5]=l*S+u*E+d*A+f*P,i[9]=l*C+u*D+d*j+f*F,i[13]=l*w+u*O+d*M+f*ee,i[2]=p*x+m*T+h*k+g*N,i[6]=p*S+m*E+h*A+g*P,i[10]=p*C+m*D+h*j+g*F,i[14]=p*w+m*O+h*M+g*ee,i[3]=_*x+v*T+y*k+b*N,i[7]=_*S+v*E+y*A+b*P,i[11]=_*C+v*D+y*j+b*F,i[15]=_*w+v*O+y*M+b*ee,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[12],a=e[1],o=e[5],s=e[9],c=e[13],l=e[2],u=e[6],d=e[10],f=e[14],p=e[3],m=e[7],h=e[11],g=e[15],_=s*f-c*d,v=o*f-c*u,y=o*d-s*u,b=a*f-c*l,x=a*d-s*l,S=a*u-o*l;return t*(m*_-h*v+g*y)-n*(p*_-h*b+g*x)+r*(p*v-m*b+g*S)-i*(p*y-m*x+h*S)}determinantAffine(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[1],a=e[5],o=e[9],s=e[2],c=e[6],l=e[10];return t*(a*l-o*c)-n*(i*l-o*s)+r*(i*c-a*s)}transpose(){let e=this.elements,t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){let r=this.elements;return e.isVector3?(r[12]=e.x,r[13]=e.y,r[14]=e.z):(r[12]=e,r[13]=t,r[14]=n),this}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=e[9],d=e[10],f=e[11],p=e[12],m=e[13],h=e[14],g=e[15],_=t*o-n*a,v=t*s-r*a,y=t*c-i*a,b=n*s-r*o,x=n*c-i*o,S=r*c-i*s,C=l*m-u*p,w=l*h-d*p,T=l*g-f*p,E=u*h-d*m,D=u*g-f*m,O=d*g-f*h,k=_*O-v*D+y*E+b*T-x*w+S*C;if(k===0)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);let A=1/k;return e[0]=(o*O-s*D+c*E)*A,e[1]=(r*D-n*O-i*E)*A,e[2]=(m*S-h*x+g*b)*A,e[3]=(d*x-u*S-f*b)*A,e[4]=(s*T-a*O-c*w)*A,e[5]=(t*O-r*T+i*w)*A,e[6]=(h*y-p*S-g*v)*A,e[7]=(l*S-d*y+f*v)*A,e[8]=(a*D-o*T+c*C)*A,e[9]=(n*T-t*D-i*C)*A,e[10]=(p*x-m*y+g*_)*A,e[11]=(u*y-l*x-f*_)*A,e[12]=(o*w-a*E-s*C)*A,e[13]=(t*E-n*w+r*C)*A,e[14]=(m*v-p*b-h*_)*A,e[15]=(l*b-u*v+d*_)*A,this}scale(e){let t=this.elements,n=e.x,r=e.y,i=e.z;return t[0]*=n,t[4]*=r,t[8]*=i,t[1]*=n,t[5]*=r,t[9]*=i,t[2]*=n,t[6]*=r,t[10]*=i,t[3]*=n,t[7]*=r,t[11]*=i,this}getMaxScaleOnAxis(){let e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],r=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,r))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){let t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){let n=Math.cos(t),r=Math.sin(t),i=1-n,a=e.x,o=e.y,s=e.z,c=i*a,l=i*o;return this.set(c*a+n,c*o-r*s,c*s+r*o,0,c*o+r*s,l*o+n,l*s-r*a,0,c*s-r*o,l*s+r*a,i*s*s+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,r,i,a){return this.set(1,n,i,0,e,1,a,0,t,r,1,0,0,0,0,1),this}compose(e,t,n){let r=this.elements,i=t._x,a=t._y,o=t._z,s=t._w,c=i+i,l=a+a,u=o+o,d=i*c,f=i*l,p=i*u,m=a*l,h=a*u,g=o*u,_=s*c,v=s*l,y=s*u,b=n.x,x=n.y,S=n.z;return r[0]=(1-(m+g))*b,r[1]=(f+y)*b,r[2]=(p-v)*b,r[3]=0,r[4]=(f-y)*x,r[5]=(1-(d+g))*x,r[6]=(h+_)*x,r[7]=0,r[8]=(p+v)*S,r[9]=(h-_)*S,r[10]=(1-(d+m))*S,r[11]=0,r[12]=e.x,r[13]=e.y,r[14]=e.z,r[15]=1,this}decompose(e,t,n){let r=this.elements;e.x=r[12],e.y=r[13],e.z=r[14];let i=this.determinantAffine();if(i===0)return n.set(1,1,1),t.identity(),this;let a=ye.set(r[0],r[1],r[2]).length(),o=ye.set(r[4],r[5],r[6]).length(),s=ye.set(r[8],r[9],r[10]).length();i<0&&(a=-a),be.copy(this);let c=1/a,l=1/o,u=1/s;return be.elements[0]*=c,be.elements[1]*=c,be.elements[2]*=c,be.elements[4]*=l,be.elements[5]*=l,be.elements[6]*=l,be.elements[8]*=u,be.elements[9]*=u,be.elements[10]*=u,t.setFromRotationMatrix(be),n.x=a,n.y=o,n.z=s,this}makePerspective(e,t,n,r,i,a,o=_,s=!1){let c=this.elements,l=2*i/(t-e),u=2*i/(n-r),d=(t+e)/(t-e),f=(n+r)/(n-r),p,m;if(s)p=i/(a-i),m=a*i/(a-i);else if(o===2e3)p=-(a+i)/(a-i),m=-2*a*i/(a-i);else if(o===2001)p=-a/(a-i),m=-a*i/(a-i);else throw Error(`THREE.Matrix4.makePerspective(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=d,c[12]=0,c[1]=0,c[5]=u,c[9]=f,c[13]=0,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=-1,c[15]=0,this}makeOrthographic(e,t,n,r,i,a,o=_,s=!1){let c=this.elements,l=2/(t-e),u=2/(n-r),d=-(t+e)/(t-e),f=-(n+r)/(n-r),p,m;if(s)p=1/(a-i),m=a/(a-i);else if(o===2e3)p=-2/(a-i),m=-(a+i)/(a-i);else if(o===2001)p=-1/(a-i),m=-i/(a-i);else throw Error(`THREE.Matrix4.makeOrthographic(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=0,c[12]=d,c[1]=0,c[5]=u,c[9]=0,c[13]=f,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=0,c[15]=1,this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}};let ye=/*@__PURE__*/ new I,be=/*@__PURE__*/ new R,xe=/*@__PURE__*/ new I(0,0,0),Se=/*@__PURE__*/ new I(1,1,1),Ce=/*@__PURE__*/ new I,we=/*@__PURE__*/ new I,Te=/*@__PURE__*/ new I,Ee=/*@__PURE__*/ new R,De=/*@__PURE__*/ new ee;var Oe=class e{constructor(t=0,n=0,r=0,i=e.DEFAULT_ORDER){this.isEuler=!0,this._x=t,this._y=n,this._z=r,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n,r=this._order){return this._x=e,this._y=t,this._z=n,this._order=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e,t=this._order,n=!0){let r=e.elements,i=r[0],a=r[4],o=r[8],s=r[1],c=r[5],l=r[9],u=r[2],d=r[6],f=r[10];switch(t){case`XYZ`:this._y=Math.asin(A(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-l,f),this._z=Math.atan2(-a,i)):(this._x=Math.atan2(d,c),this._z=0);break;case`YXZ`:this._x=Math.asin(-A(l,-1,1)),Math.abs(l)<.9999999?(this._y=Math.atan2(o,f),this._z=Math.atan2(s,c)):(this._y=Math.atan2(-u,i),this._z=0);break;case`ZXY`:this._x=Math.asin(A(d,-1,1)),Math.abs(d)<.9999999?(this._y=Math.atan2(-u,f),this._z=Math.atan2(-a,c)):(this._y=0,this._z=Math.atan2(s,i));break;case`ZYX`:this._y=Math.asin(-A(u,-1,1)),Math.abs(u)<.9999999?(this._x=Math.atan2(d,f),this._z=Math.atan2(s,i)):(this._x=0,this._z=Math.atan2(-a,c));break;case`YZX`:this._z=Math.asin(A(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-l,c),this._y=Math.atan2(-u,i)):(this._x=0,this._y=Math.atan2(o,f));break;case`XZY`:this._z=Math.asin(-A(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(d,c),this._y=Math.atan2(o,i)):(this._x=Math.atan2(-l,f),this._y=0);break;default:C(`Euler: .setFromRotationMatrix() encountered an unknown order: `+t)}return this._order=t,n===!0&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return Ee.makeRotationFromQuaternion(e),this.setFromRotationMatrix(Ee,t,n)}setFromVector3(e,t=this._order){return this.set(e.x,e.y,e.z,t)}reorder(e){return De.setFromEuler(this),this.setFromQuaternion(De,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],e[3]!==void 0&&(this._order=e[3]),this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}};Oe.DEFAULT_ORDER=`XYZ`;var ke=class{constructor(){this.mask=1}set(e){this.mask=(1<<e|0)>>>0}enable(e){this.mask|=1<<e|0}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e|0}disable(e){this.mask&=~(1<<e|0)}disableAll(){this.mask=0}test(e){return(this.mask&e.mask)!==0}isEnabled(e){return!!(this.mask&(1<<e|0))}};let Ae=0,je=/*@__PURE__*/ new I,Me=/*@__PURE__*/ new ee,Ne=/*@__PURE__*/ new R,Pe=/*@__PURE__*/ new I,Fe=/*@__PURE__*/ new I,Ie=/*@__PURE__*/ new I,Le=/*@__PURE__*/ new ee,Re=/*@__PURE__*/ new I(1,0,0),ze=/*@__PURE__*/ new I(0,1,0),Be=/*@__PURE__*/ new I(0,0,1),Ve={type:`added`},He={type:`removed`},Ue={type:`childadded`,child:null},We={type:`childremoved`,child:null};var Ge=class e extends E{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,\"id\",{value:Ae++}),this.uuid=k(),this.name=``,this.type=`Object3D`,this.parent=null,this.children=[],this.up=e.DEFAULT_UP.clone();let t=new I,n=new Oe,r=new ee,i=new I(1,1,1);function a(){r.setFromEuler(n,!1)}function o(){n.setFromQuaternion(r,void 0,!1)}n._onChange(a),r._onChange(o),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:t},rotation:{configurable:!0,enumerable:!0,value:n},quaternion:{configurable:!0,enumerable:!0,value:r},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new R},normalMatrix:{value:new re}}),this.matrix=new R,this.matrixWorld=new R,this.matrixAutoUpdate=e.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldAutoUpdate=e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.layers=new ke,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.customDepthMaterial=void 0,this.customDistanceMaterial=void 0,this.static=!1,this.userData={},this.pivot=null}onBeforeShadow(){}onAfterShadow(){}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return Me.setFromAxisAngle(e,t),this.quaternion.multiply(Me),this}rotateOnWorldAxis(e,t){return Me.setFromAxisAngle(e,t),this.quaternion.premultiply(Me),this}rotateX(e){return this.rotateOnAxis(Re,e)}rotateY(e){return this.rotateOnAxis(ze,e)}rotateZ(e){return this.rotateOnAxis(Be,e)}translateOnAxis(e,t){return je.copy(e).applyQuaternion(this.quaternion),this.position.add(je.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(Re,e)}translateY(e){return this.translateOnAxis(ze,e)}translateZ(e){return this.translateOnAxis(Be,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(Ne.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?Pe.copy(e):Pe.set(e,t,n);let r=this.parent;this.updateWorldMatrix(!0,!1),Fe.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?Ne.lookAt(Fe,Pe,this.up):Ne.lookAt(Pe,Fe,this.up),this.quaternion.setFromRotationMatrix(Ne),r&&(Ne.extractRotation(r.matrixWorld),Me.setFromRotationMatrix(Ne),this.quaternion.premultiply(Me.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(w(`Object3D.add: object can't be added as a child of itself.`,e),this):(e&&e.isObject3D?(e.removeFromParent(),e.parent=this,this.children.push(e),e.dispatchEvent(Ve),Ue.child=e,this.dispatchEvent(Ue),Ue.child=null):w(`Object3D.add: object not an instance of THREE.Object3D.`,e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}let t=this.children.indexOf(e);return t!==-1&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(He),We.child=e,this.dispatchEvent(We),We.child=null),this}removeFromParent(){let e=this.parent;return e!==null&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),Ne.copy(this.matrixWorld).invert(),e.parent!==null&&(e.parent.updateWorldMatrix(!0,!1),Ne.multiply(e.parent.matrixWorld)),e.applyMatrix4(Ne),e.removeFromParent(),e.parent=this,this.children.push(e),e.updateWorldMatrix(!1,!0),e.dispatchEvent(Ve),Ue.child=e,this.dispatchEvent(Ue),Ue.child=null,this}getObjectById(e){return this.getObjectByProperty(`id`,e)}getObjectByName(e){return this.getObjectByProperty(`name`,e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,r=this.children.length;n<r;n++){let r=this.children[n].getObjectByProperty(e,t);if(r!==void 0)return r}}getObjectsByProperty(e,t,n=[]){this[e]===t&&n.push(this);let r=this.children;for(let i=0,a=r.length;i<a;i++)r[i].getObjectsByProperty(e,t,n);return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(Fe,e,Ie),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(Fe,Le,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);let t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}intersectsFrustum(){}traverse(e){e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverse(e)}traverseVisible(e){if(this.visible===!1)return;e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverseVisible(e)}traverseAncestors(e){let t=this.parent;t!==null&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale);let e=this.pivot;if(e!==null){let t=e.x,n=e.y,r=e.z,i=this.matrix.elements;i[12]+=t-i[0]*t-i[4]*n-i[8]*r,i[13]+=n-i[1]*t-i[5]*n-i[9]*r,i[14]+=r-i[2]*t-i[6]*n-i[10]*r}this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,e=!0);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].updateMatrixWorld(e)}updateWorldMatrix(e,t,n=!1){let r=this.parent;if(e===!0&&r!==null&&r.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||n)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,n=!0),t===!0){let e=this.children;for(let t=0,r=e.length;t<r;t++)e[t].updateWorldMatrix(!1,!0,n)}}toJSON(e){let t=e===void 0||typeof e==`string`,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.7,type:`Object`,generator:`Object3D.toJSON`});let r={};r.uuid=this.uuid,r.type=this.type,r.name=this.name,r.castShadow=this.castShadow,r.receiveShadow=this.receiveShadow,r.visible=this.visible,r.frustumCulled=this.frustumCulled,r.renderOrder=this.renderOrder,r.static=this.static,r.matrixAutoUpdate=this.matrixAutoUpdate,Object.keys(this.userData).length>0&&(r.userData=this.userData),r.layers=this.layers.mask,r.matrix=this.matrix.toArray(),r.up=this.up.toArray(),this.pivot!==null&&(r.pivot=this.pivot.toArray()),this.morphTargetDictionary!==void 0&&(r.morphTargetDictionary=Object.assign({},this.morphTargetDictionary)),this.morphTargetInfluences!==void 0&&(r.morphTargetInfluences=this.morphTargetInfluences.slice()),this.isInstancedMesh&&(r.type=`InstancedMesh`,r.count=this.count,r.instanceMatrix=this.instanceMatrix.toJSON(),this.instanceColor!==null&&(r.instanceColor=this.instanceColor.toJSON())),this.isBatchedMesh&&(r.type=`BatchedMesh`,r.perObjectFrustumCulled=this.perObjectFrustumCulled,r.sortObjects=this.sortObjects,r.drawRanges=this._drawRanges,r.reservedRanges=this._reservedRanges,r.geometryInfo=this._geometryInfo.map(e=>({...e,boundingBox:e.boundingBox?e.boundingBox.toJSON():void 0,boundingSphere:e.boundingSphere?e.boundingSphere.toJSON():void 0})),r.instanceInfo=this._instanceInfo.map(e=>({...e})),r.availableInstanceIds=this._availableInstanceIds.slice(),r.availableGeometryIds=this._availableGeometryIds.slice(),r.nextIndexStart=this._nextIndexStart,r.nextVertexStart=this._nextVertexStart,r.geometryCount=this._geometryCount,r.maxInstanceCount=this._maxInstanceCount,r.maxVertexCount=this._maxVertexCount,r.maxIndexCount=this._maxIndexCount,r.geometryInitialized=this._geometryInitialized,r.matricesTexture=this._matricesTexture.toJSON(e),r.indirectTexture=this._indirectTexture.toJSON(e),this._colorsTexture!==null&&(r.colorsTexture=this._colorsTexture.toJSON(e)),this.boundingSphere!==null&&(r.boundingSphere=this.boundingSphere.toJSON()),this.boundingBox!==null&&(r.boundingBox=this.boundingBox.toJSON()));function i(t,n){return t[n.uuid]===void 0&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(this.isScene)this.background&&(this.background.isColor?r.background=this.background.toJSON():this.background.isTexture&&(r.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&this.environment.isRenderTargetTexture!==!0&&(r.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){r.geometry=i(e.geometries,this.geometry);let t=this.geometry.parameters;if(t!==void 0&&t.shapes!==void 0){let n=t.shapes;if(Array.isArray(n))for(let t=0,r=n.length;t<r;t++){let r=n[t];i(e.shapes,r)}else i(e.shapes,n)}}if(this.isSkinnedMesh&&(r.bindMode=this.bindMode,r.bindMatrix=this.bindMatrix.toArray(),this.skeleton!==void 0&&(i(e.skeletons,this.skeleton),r.skeleton=this.skeleton.uuid)),this.material!==void 0){if(Array.isArray(this.material)){let t=[];for(let n=0,r=this.material.length;n<r;n++)t.push(i(e.materials,this.material[n]));r.material=t}else r.material=i(e.materials,this.material)}if(this.children.length>0){r.children=[];for(let t=0;t<this.children.length;t++)r.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){r.animations=[];for(let t=0;t<this.animations.length;t++){let n=this.animations[t];r.animations.push(i(e.animations,n))}}if(t){let t=a(e.geometries),r=a(e.materials),i=a(e.textures),o=a(e.images),s=a(e.shapes),c=a(e.skeletons),l=a(e.animations),u=a(e.nodes);t.length>0&&(n.geometries=t),r.length>0&&(n.materials=r),i.length>0&&(n.textures=i),o.length>0&&(n.images=o),s.length>0&&(n.shapes=s),c.length>0&&(n.skeletons=c),l.length>0&&(n.animations=l),u.length>0&&(n.nodes=u)}return n.object=r,n;function a(e){let t=[];for(let n in e){let r=e[n];delete r.metadata,t.push(r)}return t}}clone(e){return new this.constructor().copy(this,e)}copy(e,t=!0){if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.pivot=e.pivot===null?null:e.pivot.clone(),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.static=e.static,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),t===!0)for(let t=0;t<e.children.length;t++){let n=e.children[t];this.add(n.clone())}return this}dispose(){this.dispatchEvent({type:`dispose`})}};Ge.DEFAULT_UP=/*@__PURE__*/ new I(0,1,0),Ge.DEFAULT_MATRIX_AUTO_UPDATE=!0,Ge.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;let Ke={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},qe={h:0,s:0,l:0},Je={h:0,s:0,l:0};function Ye(e,t,n){return n<0&&(n+=1),n>1&&--n,n<1/6?e+(t-e)*6*n:n<1/2?t:n<2/3?e+(t-e)*6*(2/3-n):e}var Xe=class{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(t===void 0&&n===void 0){let t=e;t&&t.isColor?this.copy(t):typeof t==`number`?this.setHex(t):typeof t==`string`&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e,t=p){return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(e&255)/255,L.colorSpaceToWorking(this,t),this}setRGB(e,t,n,r=L.workingColorSpace){return this.r=e,this.g=t,this.b=n,L.colorSpaceToWorking(this,r),this}setHSL(e,t,n,r=L.workingColorSpace){if(e=j(e,1),t=A(t,0,1),n=A(n,0,1),t===0)this.r=this.g=this.b=n;else{let r=n<=.5?n*(1+t):n+t-n*t,i=2*n-r;this.r=Ye(i,r,e+1/3),this.g=Ye(i,r,e),this.b=Ye(i,r,e-1/3)}return L.colorSpaceToWorking(this,r),this}setStyle(e,t=p){function n(t){t!==void 0&&parseFloat(t)<1&&C(`Color: Alpha component of `+e+` will be ignored.`)}let r;if(r=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let i,a=r[1],o=r[2];switch(a){case`rgb`:case`rgba`:if(i=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(255,parseInt(i[1],10))/255,Math.min(255,parseInt(i[2],10))/255,Math.min(255,parseInt(i[3],10))/255,t);if(i=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(100,parseInt(i[1],10))/100,Math.min(100,parseInt(i[2],10))/100,Math.min(100,parseInt(i[3],10))/100,t);break;case`hsl`:case`hsla`:if(i=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setHSL(parseFloat(i[1])/360,parseFloat(i[2])/100,parseFloat(i[3])/100,t);break;default:C(`Color: Unknown color model `+e)}}else if(r=/^\\#([A-Fa-f\\d]+)$/.exec(e)){let n=r[1],i=n.length;if(i===3)return this.setRGB(parseInt(n.charAt(0),16)/15,parseInt(n.charAt(1),16)/15,parseInt(n.charAt(2),16)/15,t);if(i===6)return this.setHex(parseInt(n,16),t);C(`Color: Invalid hex color `+e)}else if(e&&e.length>0)return this.setColorName(e,t);return this}setColorName(e,t=p){let n=Ke[e.toLowerCase()];return n===void 0?C(`Color: Unknown color `+e):this.setHex(n,t),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=ce(e.r),this.g=ce(e.g),this.b=ce(e.b),this}copyLinearToSRGB(e){return this.r=le(e.r),this.g=le(e.g),this.b=le(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(e=p){return L.workingToColorSpace(z.copy(this),e),Math.round(A(z.r*255,0,255))*65536+Math.round(A(z.g*255,0,255))*256+Math.round(A(z.b*255,0,255))}getHexString(e=p){return(`000000`+this.getHex(e).toString(16)).slice(-6)}getHSL(e,t=L.workingColorSpace){L.workingToColorSpace(z.copy(this),t);let n=z.r,r=z.g,i=z.b,a=Math.max(n,r,i),o=Math.min(n,r,i),s,c,l=(o+a)/2;if(o===a)s=0,c=0;else{let e=a-o;switch(c=l<=.5?e/(a+o):e/(2-a-o),a){case n:s=(r-i)/e+(r<i?6:0);break;case r:s=(i-n)/e+2;break;case i:s=(n-r)/e+4}s/=6}return e.h=s,e.s=c,e.l=l,e}getRGB(e,t=L.workingColorSpace){return L.workingToColorSpace(z.copy(this),t),e.r=z.r,e.g=z.g,e.b=z.b,e}getStyle(e=p){L.workingToColorSpace(z.copy(this),e);let t=z.r,n=z.g,r=z.b;return e===`srgb`?`rgb(${Math.round(t*255)},${Math.round(n*255)},${Math.round(r*255)})`:`color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`}offsetHSL(e,t,n){return this.getHSL(qe),this.setHSL(qe.h+e,qe.s+t,qe.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(qe),e.getHSL(Je);let n=M(qe.h,Je.h,t),r=M(qe.s,Je.s,t),i=M(qe.l,Je.l,t);return this.setHSL(n,r,i),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){let t=this.r,n=this.g,r=this.b,i=e.elements;return this.r=i[0]*t+i[3]*n+i[6]*r,this.g=i[1]*t+i[4]*n+i[7]*r,this.b=i[2]*t+i[5]*n+i[8]*r,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e,t=0){return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(e=[],t=0){return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}};let z=/*@__PURE__*/ new Xe;Xe.NAMES=Ke;let Ze=/*@__PURE__*/ new I,Qe=/*@__PURE__*/ new I,$e=/*@__PURE__*/ new I,et=/*@__PURE__*/ new I,tt=/*@__PURE__*/ new I,nt=/*@__PURE__*/ new I,rt=/*@__PURE__*/ new I,it=/*@__PURE__*/ new I,at=/*@__PURE__*/ new I,ot=/*@__PURE__*/ new I,st=/*@__PURE__*/ new ve,ct=/*@__PURE__*/ new ve,lt=/*@__PURE__*/ new ve;var ut=class e{constructor(e=new I,t=new I,n=new I){this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,r){r.subVectors(n,t),Ze.subVectors(e,t),r.cross(Ze);let i=r.lengthSq();return i>0?r.multiplyScalar(1/Math.sqrt(i)):r.set(0,0,0)}static getBarycoord(e,t,n,r,i){Ze.subVectors(r,t),Qe.subVectors(n,t),$e.subVectors(e,t);let a=Ze.dot(Ze),o=Ze.dot(Qe),s=Ze.dot($e),c=Qe.dot(Qe),l=Qe.dot($e),u=a*c-o*o;if(u===0)return i.set(0,0,0),null;let d=1/u,f=(c*s-o*l)*d,p=(a*l-o*s)*d;return i.set(1-f-p,p,f)}static containsPoint(e,t,n,r){return this.getBarycoord(e,t,n,r,et)!==null&&et.x>=0&&et.y>=0&&et.x+et.y<=1}static getInterpolation(e,t,n,r,i,a,o,s){return this.getBarycoord(e,t,n,r,et)===null?(s.x=0,s.y=0,`z`in s&&(s.z=0),`w`in s&&(s.w=0),null):(s.setScalar(0),s.addScaledVector(i,et.x),s.addScaledVector(a,et.y),s.addScaledVector(o,et.z),s)}static getInterpolatedAttribute(e,t,n,r,i,a){return st.setScalar(0),ct.setScalar(0),lt.setScalar(0),st.fromBufferAttribute(e,t),ct.fromBufferAttribute(e,n),lt.fromBufferAttribute(e,r),a.setScalar(0),a.addScaledVector(st,i.x),a.addScaledVector(ct,i.y),a.addScaledVector(lt,i.z),a}static isFrontFacing(e,t,n,r){return Ze.subVectors(n,t),Qe.subVectors(e,t),Ze.cross(Qe).dot(r)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,r){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[r]),this}setFromAttributeAndIndices(e,t,n,r){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,r),this}clone(){return new this.constructor().copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return Ze.subVectors(this.c,this.b),Qe.subVectors(this.a,this.b),Ze.cross(Qe).length()*.5}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(t){return e.getNormal(this.a,this.b,this.c,t)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(t,n){return e.getBarycoord(t,this.a,this.b,this.c,n)}getInterpolation(t,n,r,i,a){return e.getInterpolation(t,this.a,this.b,this.c,n,r,i,a)}containsPoint(t){return e.containsPoint(t,this.a,this.b,this.c)}isFrontFacing(t){return e.isFrontFacing(this.a,this.b,this.c,t)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){let n=this.a,r=this.b,i=this.c,a,o;tt.subVectors(r,n),nt.subVectors(i,n),it.subVectors(e,n);let s=tt.dot(it),c=nt.dot(it);if(s<=0&&c<=0)return t.copy(n);at.subVectors(e,r);let l=tt.dot(at),u=nt.dot(at);if(l>=0&&u<=l)return t.copy(r);let d=s*u-l*c;if(d<=0&&s>=0&&l<=0)return a=s/(s-l),t.copy(n).addScaledVector(tt,a);ot.subVectors(e,i);let f=tt.dot(ot),p=nt.dot(ot);if(p>=0&&f<=p)return t.copy(i);let m=f*c-s*p;if(m<=0&&c>=0&&p<=0)return o=c/(c-p),t.copy(n).addScaledVector(nt,o);let h=l*p-f*u;if(h<=0&&u-l>=0&&f-p>=0)return rt.subVectors(i,r),o=(u-l)/(u-l+(f-p)),t.copy(r).addScaledVector(rt,o);let g=1/(h+m+d);return a=m*g,o=d*g,t.copy(n).addScaledVector(tt,a).addScaledVector(nt,o)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}},B=class{constructor(e=new I(1/0,1/0,1/0),t=new I(-1/0,-1/0,-1/0)){this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(ft.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(ft.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){let n=ft.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e,t=!1){return this.makeEmpty(),this.expandByObject(e,t)}clone(){return new this.constructor().copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e,t=!1){e.updateWorldMatrix(!1,!1);let n=e.geometry;if(n!==void 0){let r=n.getAttribute(`position`);if(t===!0&&r!==void 0&&e.isInstancedMesh!==!0)for(let t=0,n=r.count;t<n;t++)e.isMesh===!0?e.getVertexPosition(t,ft):ft.fromBufferAttribute(r,t),ft.applyMatrix4(e.matrixWorld),this.expandByPoint(ft);else e.boundingBox===void 0?(n.boundingBox===null&&n.computeBoundingBox(),pt.copy(n.boundingBox)):(e.boundingBox===null&&e.computeBoundingBox(),pt.copy(e.boundingBox)),pt.applyMatrix4(e.matrixWorld),this.union(pt)}let r=e.children;for(let e=0,n=r.length;e<n;e++)this.expandByObject(r[e],t);return this}containsPoint(e){return e.x>=this.min.x&&e.x<=this.max.x&&e.y>=this.min.y&&e.y<=this.max.y&&e.z>=this.min.z&&e.z<=this.max.z}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return e.max.x>=this.min.x&&e.min.x<=this.max.x&&e.max.y>=this.min.y&&e.min.y<=this.max.y&&e.max.z>=this.min.z&&e.min.z<=this.max.z}intersectsSphere(e){return this.clampPoint(e.center,ft),ft.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(bt),xt.subVectors(this.max,bt),mt.subVectors(e.a,bt),ht.subVectors(e.b,bt),gt.subVectors(e.c,bt),_t.subVectors(ht,mt),vt.subVectors(gt,ht),yt.subVectors(mt,gt);let t=[0,-_t.z,_t.y,0,-vt.z,vt.y,0,-yt.z,yt.y,_t.z,0,-_t.x,vt.z,0,-vt.x,yt.z,0,-yt.x,-_t.y,_t.x,0,-vt.y,vt.x,0,-yt.y,yt.x,0];return!wt(t,mt,ht,gt,xt)||(t=[1,0,0,0,1,0,0,0,1],!wt(t,mt,ht,gt,xt))?!1:(St.crossVectors(_t,vt),t=[St.x,St.y,St.z],wt(t,mt,ht,gt,xt))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,ft).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=this.getSize(ft).length()*.5),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()?this:(dt[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),dt[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),dt[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),dt[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),dt[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),dt[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),dt[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),dt[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(dt),this)}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}toJSON(){return{min:this.min.toArray(),max:this.max.toArray()}}fromJSON(e){return this.min.fromArray(e.min),this.max.fromArray(e.max),this}};let dt=[/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I,/*@__PURE__*/ new I],ft=/*@__PURE__*/ new I,pt=/*@__PURE__*/ new B,mt=/*@__PURE__*/ new I,ht=/*@__PURE__*/ new I,gt=/*@__PURE__*/ new I,_t=/*@__PURE__*/ new I,vt=/*@__PURE__*/ new I,yt=/*@__PURE__*/ new I,bt=/*@__PURE__*/ new I,xt=/*@__PURE__*/ new I,St=/*@__PURE__*/ new I,Ct=/*@__PURE__*/ new I;function wt(e,t,n,r,i){for(let a=0,o=e.length-3;a<=o;a+=3){Ct.fromArray(e,a);let o=i.x*Math.abs(Ct.x)+i.y*Math.abs(Ct.y)+i.z*Math.abs(Ct.z),s=t.dot(Ct),c=n.dot(Ct),l=r.dot(Ct);if(Math.max(-Math.max(s,c,l),Math.min(s,c,l))>o)return!1}return!0}let V=/*@__PURE__*/ new I,Tt=/*@__PURE__*/ new F,Et=0;var H=class extends E{constructor(e,t,n=!1){if(super(),Array.isArray(e))throw TypeError(`THREE.BufferAttribute: array should be a Typed Array.`);this.isBufferAttribute=!0,Object.defineProperty(this,\"id\",{value:Et++}),this.name=``,this.array=e,this.itemSize=t,this.count=e===void 0?0:e.length/t,this.normalized=n,this.usage=g,this.updateRanges=[],this.gpuType=i,this.version=0}onUploadCallback(){}set needsUpdate(e){e===!0&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let r=0,i=this.itemSize;r<i;r++)this.array[e+r]=t.array[n+r];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(this.itemSize===2)for(let t=0,n=this.count;t<n;t++)Tt.fromBufferAttribute(this,t),Tt.applyMatrix3(e),this.setXY(t,Tt.x,Tt.y);else if(this.itemSize===3)for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyMatrix3(e),this.setXYZ(t,V.x,V.y,V.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyMatrix4(e),this.setXYZ(t,V.x,V.y,V.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyNormalMatrix(e),this.setXYZ(t,V.x,V.y,V.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.transformDirection(e),this.setXYZ(t,V.x,V.y,V.z);return this}set(e,t=0){return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=N(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=P(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=N(t,this.array)),t}setX(e,t){return this.normalized&&(t=P(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=N(t,this.array)),t}setY(e,t){return this.normalized&&(t=P(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=N(t,this.array)),t}setZ(e,t){return this.normalized&&(t=P(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=N(t,this.array)),t}setW(e,t){return this.normalized&&(t=P(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=P(t,this.array),n=P(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,r){return e*=this.itemSize,this.normalized&&(t=P(t,this.array),n=P(n,this.array),r=P(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this}setXYZW(e,t,n,r,i){return e*=this.itemSize,this.normalized&&(t=P(t,this.array),n=P(n,this.array),r=P(r,this.array),i=P(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this.array[e+3]=i,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){let e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return e.name=this.name,e.usage=this.usage,e.gpuType=this.gpuType,e}dispose(){this.dispatchEvent({type:`dispose`})}},Dt=class extends H{constructor(e,t,n){super(new Uint16Array(e),t,n)}},Ot=class extends H{constructor(e,t,n){super(new Uint32Array(e),t,n)}},kt=class extends H{constructor(e,t,n){super(new Float32Array(e),t,n)}};let At=/*@__PURE__*/ new B,jt=/*@__PURE__*/ new I,Mt=/*@__PURE__*/ new I;var Nt=class{constructor(e=new I,t=-1){this.isSphere=!0,this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){let n=this.center;t===void 0?At.setFromPoints(e).getCenter(n):n.copy(t);let r=0;for(let t=0,i=e.length;t<i;t++)r=Math.max(r,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(r),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){let t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){let n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius*=e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;jt.subVectors(e,this.center);let t=jt.lengthSq();if(t>this.radius*this.radius){let e=Math.sqrt(t),n=(e-this.radius)*.5;this.center.addScaledVector(jt,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(this.center.equals(e.center)===!0?this.radius=Math.max(this.radius,e.radius):(Mt.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(jt.copy(e.center).add(Mt)),this.expandByPoint(jt.copy(e.center).sub(Mt))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return new this.constructor().copy(this)}toJSON(){return{radius:this.radius,center:this.center.toArray()}}fromJSON(e){return this.radius=e.radius,this.center.fromArray(e.center),this}};let Pt=0,Ft=/*@__PURE__*/ new R,It=/*@__PURE__*/ new Ge,Lt=/*@__PURE__*/ new I,Rt=/*@__PURE__*/ new B,zt=/*@__PURE__*/ new B,U=/*@__PURE__*/ new I;var Bt=class e extends E{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,\"id\",{value:Pt++}),this.uuid=k(),this.name=``,this.type=`BufferGeometry`,this.index=null,this.indirect=null,this.indirectOffset=0,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={},this._transformed=!1}getIndex(){return this.index}setIndex(e){return this.index=Array.isArray(e)?new(v(e)?Ot:Dt)(e,1):e,this}setIndirect(e,t=0){return this.indirect=e,this.indirectOffset=t,this}getIndirect(){return this.indirect}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return this.attributes[e]!==void 0}addGroup(e,t,n=0){this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){let t=this.attributes.position;t!==void 0&&(t.applyMatrix4(e),t.needsUpdate=!0);let n=this.attributes.normal;if(n!==void 0){let t=new re().getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}let r=this.attributes.tangent;return r!==void 0&&(r.transformDirection(e),r.needsUpdate=!0),this.boundingBox!==null&&this.computeBoundingBox(),this.boundingSphere!==null&&this.computeBoundingSphere(),this._transformed=!0,this}applyQuaternion(e){return Ft.makeRotationFromQuaternion(e),this.applyMatrix4(Ft),this}rotateX(e){return Ft.makeRotationX(e),this.applyMatrix4(Ft),this}rotateY(e){return Ft.makeRotationY(e),this.applyMatrix4(Ft),this}rotateZ(e){return Ft.makeRotationZ(e),this.applyMatrix4(Ft),this}translate(e,t,n){return Ft.makeTranslation(e,t,n),this.applyMatrix4(Ft),this}scale(e,t,n){return Ft.makeScale(e,t,n),this.applyMatrix4(Ft),this}lookAt(e){return It.lookAt(e),It.updateMatrix(),this.applyMatrix4(It.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter(Lt).negate(),this.translate(Lt.x,Lt.y,Lt.z),this}setFromPoints(e){let t=this.getAttribute(`position`);if(t===void 0){let t=[];for(let n=0,r=e.length;n<r;n++){let r=e[n];t.push(r.x,r.y,r.z||0)}this.setAttribute(`position`,new kt(t,3))}else{let n=Math.min(e.length,t.count);for(let r=0;r<n;r++){let n=e[r];t.setXYZ(r,n.x,n.y,n.z||0)}e.length>t.count&&C(`BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.`),t.needsUpdate=!0}return this}computeBoundingBox(){this.boundingBox===null&&(this.boundingBox=new B);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){w(`BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.`,this),this.boundingBox.set(new I(-1/0,-1/0,-1/0),new I(1/0,1/0,1/0));return}if(e!==void 0){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];Rt.setFromBufferAttribute(n),this.morphTargetsRelative?(U.addVectors(this.boundingBox.min,Rt.min),this.boundingBox.expandByPoint(U),U.addVectors(this.boundingBox.max,Rt.max),this.boundingBox.expandByPoint(U)):(this.boundingBox.expandByPoint(Rt.min),this.boundingBox.expandByPoint(Rt.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&w(`BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.`,this)}computeBoundingSphere(){this.boundingSphere===null&&(this.boundingSphere=new Nt);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){w(`BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.`,this),this.boundingSphere.set(new I,1/0);return}if(e){let n=this.boundingSphere.center;if(Rt.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];zt.setFromBufferAttribute(n),this.morphTargetsRelative?(U.addVectors(Rt.min,zt.min),Rt.expandByPoint(U),U.addVectors(Rt.max,zt.max),Rt.expandByPoint(U)):(Rt.expandByPoint(zt.min),Rt.expandByPoint(zt.max))}Rt.getCenter(n);let r=0;for(let t=0,i=e.count;t<i;t++)U.fromBufferAttribute(e,t),r=Math.max(r,n.distanceToSquared(U));if(t)for(let i=0,a=t.length;i<a;i++){let a=t[i],o=this.morphTargetsRelative;for(let t=0,i=a.count;t<i;t++)U.fromBufferAttribute(a,t),o&&(Lt.fromBufferAttribute(e,t),U.add(Lt)),r=Math.max(r,n.distanceToSquared(U))}this.boundingSphere.radius=Math.sqrt(r),isNaN(this.boundingSphere.radius)&&w(`BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.`,this)}}computeTangents(){let e=this.index,t=this.attributes;if(e===null||t.position===void 0||t.normal===void 0||t.uv===void 0){w(`BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)`);return}let n=t.position,r=t.normal,i=t.uv,a=this.getAttribute(`tangent`);(a===void 0||a.count!==n.count)&&(a=new H(new Float32Array(4*n.count),4),this.setAttribute(`tangent`,a));let o=[],s=[];for(let e=0;e<n.count;e++)o[e]=new I,s[e]=new I;let c=new I,l=new I,u=new I,d=new F,f=new F,p=new F,m=new I,h=new I;function g(e,t,r){c.fromBufferAttribute(n,e),l.fromBufferAttribute(n,t),u.fromBufferAttribute(n,r),d.fromBufferAttribute(i,e),f.fromBufferAttribute(i,t),p.fromBufferAttribute(i,r),l.sub(c),u.sub(c),f.sub(d),p.sub(d);let a=1/(f.x*p.y-p.x*f.y);isFinite(a)&&(m.copy(l).multiplyScalar(p.y).addScaledVector(u,-f.y).multiplyScalar(a),h.copy(u).multiplyScalar(f.x).addScaledVector(l,-p.x).multiplyScalar(a),o[e].add(m),o[t].add(m),o[r].add(m),s[e].add(h),s[t].add(h),s[r].add(h))}let _=this.groups;_.length===0&&(_=[{start:0,count:e.count}]);for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)g(e.getX(t+0),e.getX(t+1),e.getX(t+2))}let v=new I,y=new I,b=new I,x=new I;function S(e){b.fromBufferAttribute(r,e),x.copy(b);let t=o[e];v.copy(t),v.sub(b.multiplyScalar(b.dot(t))).normalize(),y.crossVectors(x,t);let n=y.dot(s[e])<0?-1:1;a.setXYZW(e,v.x,v.y,v.z,n)}for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)S(e.getX(t+0)),S(e.getX(t+1)),S(e.getX(t+2))}this._transformed=!0}computeVertexNormals(){let e=this.index,t=this.getAttribute(`position`);if(t!==void 0){let n=this.getAttribute(`normal`);if(n===void 0||n.count!==t.count)n=new H(new Float32Array(t.count*3),3),this.setAttribute(`normal`,n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);let r=new I,i=new I,a=new I,o=new I,s=new I,c=new I,l=new I,u=new I;if(e)for(let d=0,f=e.count;d<f;d+=3){let f=e.getX(d+0),p=e.getX(d+1),m=e.getX(d+2);r.fromBufferAttribute(t,f),i.fromBufferAttribute(t,p),a.fromBufferAttribute(t,m),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),o.fromBufferAttribute(n,f),s.fromBufferAttribute(n,p),c.fromBufferAttribute(n,m),o.add(l),s.add(l),c.add(l),n.setXYZ(f,o.x,o.y,o.z),n.setXYZ(p,s.x,s.y,s.z),n.setXYZ(m,c.x,c.y,c.z)}else for(let e=0,o=t.count;e<o;e+=3)r.fromBufferAttribute(t,e+0),i.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),n.setXYZ(e+0,l.x,l.y,l.z),n.setXYZ(e+1,l.x,l.y,l.z),n.setXYZ(e+2,l.x,l.y,l.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){let e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)U.fromBufferAttribute(e,t),U.normalize(),e.setXYZ(t,U.x,U.y,U.z)}toNonIndexed(){function t(e,t){let n=e.array,r=e.itemSize,i=e.normalized,a=new n.constructor(t.length*r),o=0,s=0;for(let i=0,c=t.length;i<c;i++){o=e.isInterleavedBufferAttribute?t[i]*e.data.stride+e.offset:t[i]*r;for(let e=0;e<r;e++)a[s++]=n[o++]}return new H(a,r,i)}if(this.index===null)return C(`BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.`),this;let n=new e,r=this.index.array,i=this.attributes;for(let e in i){let a=i[e],o=t(a,r);n.setAttribute(e,o)}let a=this.morphAttributes;for(let e in a){let i=[],o=a[e];for(let e=0,n=o.length;e<n;e++){let n=o[e],a=t(n,r);i.push(a)}n.morphAttributes[e]=i}n.morphTargetsRelative=this.morphTargetsRelative;let o=this.groups;for(let e=0,t=o.length;e<t;e++){let t=o[e];n.addGroup(t.start,t.count,t.materialIndex)}return n}toJSON(){let e={metadata:{version:4.7,type:`BufferGeometry`,generator:`BufferGeometry.toJSON`}};if(e.uuid=this.uuid,e.type=this.parameters!==void 0&&this._transformed===!0?`BufferGeometry`:this.type,e.name=this.name,Object.keys(this.userData).length>0&&(e.userData=this.userData),this.parameters!==void 0&&this._transformed!==!0){let t=this.parameters;for(let n in t)t[n]!==void 0&&(e[n]=t[n]);return e}e.data={attributes:{}};let t=this.index;t!==null&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});let n=this.attributes;for(let t in n){let r=n[t];e.data.attributes[t]=r.toJSON(e.data)}let r={},i=!1;for(let t in this.morphAttributes){let n=this.morphAttributes[t],a=[];for(let t=0,r=n.length;t<r;t++){let r=n[t];a.push(r.toJSON(e.data))}a.length>0&&(r[t]=a,i=!0)}i&&(e.data.morphAttributes=r,e.data.morphTargetsRelative=this.morphTargetsRelative);let a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));let o=this.boundingSphere;return o!==null&&(e.data.boundingSphere=o.toJSON()),e}clone(){return new this.constructor().copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;let t={};this.name=e.name;let n=e.index;n!==null&&this.setIndex(n.clone());let r=e.attributes;for(let e in r){let n=r[e];this.setAttribute(e,n.clone(t))}let i=e.morphAttributes;for(let e in i){let n=[],r=i[e];for(let e=0,i=r.length;e<i;e++)n.push(r[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;let a=e.groups;for(let e=0,t=a.length;e<t;e++){let t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}let o=e.boundingBox;o!==null&&(this.boundingBox=o.clone());let s=e.boundingSphere;return s!==null&&(this.boundingSphere=s.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this._transformed=e._transformed,this}dispose(){this.dispatchEvent({type:`dispose`})}};let Vt=/*@__PURE__*/ new I,Ht=/*@__PURE__*/ new I,Ut=/*@__PURE__*/ new re;var Wt=class{constructor(e=new I(1,0,0),t=0){this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,r){return this.normal.set(e,t,n),this.constant=r,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){let r=Vt.subVectors(n,t).cross(Ht.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(r,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){let e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t,n=!0){let r=e.delta(Vt),i=this.normal.dot(r);if(i===0)return this.distanceToPoint(e.start)===0?t.copy(e.start):null;let a=-(e.start.dot(this.normal)+this.constant)/i;return n===!0&&(a<0||a>1)?null:t.copy(e.start).addScaledVector(r,a)}intersectsLine(e){let t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){let n=t||Ut.getNormalMatrix(e),r=this.coplanarPoint(Vt).applyMatrix4(e),i=this.normal.applyMatrix3(n).normalize();return this.constant=-r.dot(i),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return new this.constructor().copy(this)}toJSON(){return{normal:this.normal.toArray(),constant:this.constant}}fromJSON(e){return this.normal.fromArray(e.normal),this.constant=e.constant,this}};let Gt=/*@__PURE__*/ new I,Kt=/*@__PURE__*/ new I,qt=/*@__PURE__*/ new I,Jt=/*@__PURE__*/ new I;var Yt=class{constructor(e=new I,t=new I(0,0,-1)){this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,Gt)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);let n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){let t=Gt.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(Gt.copy(this.origin).addScaledVector(this.direction,t),Gt.distanceToSquared(e))}distanceSqToSegment(e,t,n,r){Kt.copy(e).add(t).multiplyScalar(.5),qt.copy(t).sub(e).normalize(),Jt.copy(this.origin).sub(Kt);let i=e.distanceTo(t)*.5,a=-this.direction.dot(qt),o=Jt.dot(this.direction),s=-Jt.dot(qt),c=Jt.lengthSq(),l=Math.abs(1-a*a),u,d,f,p;if(l>0){if(u=a*s-o,d=a*o-s,p=i*l,u>=0){if(d>=-p){if(d<=p){let e=1/l;u*=e,d*=e,f=u*(u+a*d+2*o)+d*(a*u+d+2*s)+c}else d=i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d=-i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d<=-p?(u=Math.max(0,-(-a*i+o)),d=u>0?-i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c):d<=p?(u=0,d=Math.min(Math.max(-i,-s),i),f=d*(d+2*s)+c):(u=Math.max(0,-(a*i+o)),d=u>0?i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c)}else d=a>0?-i:i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c;return n&&n.copy(this.origin).addScaledVector(this.direction,u),r&&r.copy(Kt).addScaledVector(qt,d),f}intersectSphere(e,t){if(e.radius<0)return null;Gt.subVectors(e.center,this.origin);let n=Gt.dot(this.direction),r=Gt.dot(Gt)-n*n,i=e.radius*e.radius;if(r>i)return null;let a=Math.sqrt(i-r),o=n-a,s=n+a;return s<0?null:o<0?this.at(s,t):this.at(o,t)}intersectsSphere(e){return e.radius<0?!1:this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){let t=e.normal.dot(this.direction);if(t===0)return e.distanceToPoint(this.origin)===0?0:null;let n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){let n=this.distanceToPlane(e);return n===null?null:this.at(n,t)}intersectsPlane(e){let t=e.distanceToPoint(this.origin);return t===0||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,r,i,a,o,s,c=1/this.direction.x,l=1/this.direction.y,u=1/this.direction.z,d=this.origin;return c>=0?(n=(e.min.x-d.x)*c,r=(e.max.x-d.x)*c):(n=(e.max.x-d.x)*c,r=(e.min.x-d.x)*c),l>=0?(i=(e.min.y-d.y)*l,a=(e.max.y-d.y)*l):(i=(e.max.y-d.y)*l,a=(e.min.y-d.y)*l),n>a||i>r||((i>n||isNaN(n))&&(n=i),(a<r||isNaN(r))&&(r=a),u>=0?(o=(e.min.z-d.z)*u,s=(e.max.z-d.z)*u):(o=(e.max.z-d.z)*u,s=(e.min.z-d.z)*u),n>s||o>r)||((o>n||n!==n)&&(n=o),(s<r||r!==r)&&(r=s),r<0)?null:this.at(n>=0?n:r,t)}intersectsBox(e){return this.intersectBox(e,Gt)!==null}intersectTriangle(e,t,n,r,i){let a=this.origin,o=this.direction,s=o.x,c=o.y,l=o.z,u=e.x-a.x,d=e.y-a.y,f=e.z-a.z,p=t.x-a.x,m=t.y-a.y,h=t.z-a.z,g=n.x-a.x,_=n.y-a.y,v=n.z-a.z,y=Math.abs(s),b=Math.abs(c),x=Math.abs(l),S,C,w,T,E,D,O,k,A,j,M,N;if(y>=b&&y>=x?(w=s,D=u,A=p,N=g,s>=0?(S=c,C=l,T=d,E=f,O=m,k=h,j=_,M=v):(S=l,C=c,T=f,E=d,O=h,k=m,j=v,M=_)):b>=x?(w=c,D=d,A=m,N=_,c>=0?(S=l,C=s,T=f,E=u,O=h,k=p,j=v,M=g):(S=s,C=l,T=u,E=f,O=p,k=h,j=g,M=v)):(w=l,D=f,A=h,N=v,l>=0?(S=s,C=c,T=u,E=d,O=p,k=m,j=g,M=_):(S=c,C=s,T=d,E=u,O=m,k=p,j=_,M=g)),w===0)return null;let P=S/w,F=C/w,ee=1/w,I=T-P*D,te=E-F*D,ne=O-P*A,re=k-F*A,ie=j-P*N,ae=M-F*N,oe=ie*re-ae*ne,se=I*ae-te*ie,L=ne*te-re*I;if(r){if(oe<0||se<0||L<0)return null}else if((oe<0||se<0||L<0)&&(oe>0||se>0||L>0))return null;let ce=oe+se+L;if(ce===0)return null;let le=ee*(oe*D+se*A+L*N);return(ce>0?le<0:le>0)?null:this.at(le/ce,i)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return new this.constructor().copy(this)}},Xt=class extends _e{constructor(e=null,t=1,n=1,i,a,o,s,c,l=r,u=r,d,f){super(null,o,s,c,l,u,i,a,d,f),this.isDataTexture=!0,this.image={data:e,width:t,height:n},this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}};let Zt=/*@__PURE__*/ new I,Qt=/*@__PURE__*/ new I,$t=/*@__PURE__*/ new I,en=/*@__PURE__*/ new ut;var tn=class extends Bt{constructor(e=null,t=1){if(super(),this.type=`EdgesGeometry`,this.parameters={geometry:e,thresholdAngle:t},e!==null){let n=1e4,r=Math.cos(O*t),i=e.getIndex(),a=e.getAttribute(`position`),o=i?i.count:a.count,s=[0,0,0],c=[`a`,`b`,`c`],l=[,,,],u={},d=[];for(let e=0;e<o;e+=3){i?(s[0]=i.getX(e),s[1]=i.getX(e+1),s[2]=i.getX(e+2)):(s[0]=e,s[1]=e+1,s[2]=e+2);let{a:t,b:o,c:f}=en;if(t.fromBufferAttribute(a,s[0]),o.fromBufferAttribute(a,s[1]),f.fromBufferAttribute(a,s[2]),en.getNormal($t),l[0]=`${Math.round(t.x*n)},${Math.round(t.y*n)},${Math.round(t.z*n)}`,l[1]=`${Math.round(o.x*n)},${Math.round(o.y*n)},${Math.round(o.z*n)}`,l[2]=`${Math.round(f.x*n)},${Math.round(f.y*n)},${Math.round(f.z*n)}`,l[0]!==l[1]&&l[1]!==l[2]&&l[2]!==l[0])for(let e=0;e<3;e++){let t=(e+1)%3,n=l[e],i=l[t],a=en[c[e]],o=en[c[t]],f=`${n}_${i}`,p=`${i}_${n}`;p in u&&u[p]?($t.dot(u[p].normal)<=r&&(d.push(a.x,a.y,a.z),d.push(o.x,o.y,o.z)),u[p]=null):f in u||(u[f]={index0:s[e],index1:s[t],normal:$t.clone()})}}for(let e in u)if(u[e]){let{index0:t,index1:n}=u[e];Zt.fromBufferAttribute(a,t),Qt.fromBufferAttribute(a,n),d.push(Zt.x,Zt.y,Zt.z),d.push(Qt.x,Qt.y,Qt.z)}this.setAttribute(`position`,new kt(d,3))}}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}};function nn(e,t){return!e||e.constructor===t?e:typeof t.BYTES_PER_ELEMENT==`number`?new t(e):Array.prototype.slice.call(e)}function rn(e){return e!==void 0&&e.inTangents!==void 0&&e.outTangents!==void 0}var an=class{constructor(e,t,n,r){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=r===void 0?new t.constructor(n):r,this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){let t=this.parameterPositions,n=this._cachedIndex,r=t[n],i=t[n-1];validate_interval:{seek:{let a;linear_scan:{forward_scan:if(!(e<r)){for(let a=n+2;;){if(r===void 0){if(e<i)break forward_scan;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(i=r,r=t[++n],e<r)break seek}a=t.length;break linear_scan}if(!(e>=i)){let o=t[1];e<o&&(n=2,i=o);for(let a=n-2;;){if(i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(r=i,i=t[--n-1],e>=i)break seek}a=n,n=0;break linear_scan}break validate_interval}for(;n<a;){let r=n+a>>>1;e<t[r]?a=r:n=r+1}if(r=t[n],i=t[n-1],i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(r===void 0)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,i,r)}return this.interpolate_(n,i,e,r)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){let t=this.resultBuffer,n=this.sampleValues,r=this.valueSize,i=e*r;for(let e=0;e!==r;++e)t[e]=n[i+e];return t}interpolate_(){throw Error(`THREE.Interpolant: Call to abstract method.`)}intervalChanged_(){}},on=class extends an{constructor(e,t,n,r){super(e,t,n,r),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:u,endingEnd:u}}intervalChanged_(e,t,n){let r=this.parameterPositions,i=e-2,a=e+1,o=r[i],s=r[a];if(o===void 0)switch(this.getSettings_().endingStart){case d:i=e,o=2*t-n;break;case f:i=r.length-2,o=t+r[i]-r[i+1];break;default:i=e,o=n}if(s===void 0)switch(this.getSettings_().endingEnd){case d:a=e,s=2*n-t;break;case f:a=1,s=n+r[1]-r[0];break;default:a=e-1,s=t}let c=(n-t)*.5,l=this.valueSize;this._weightPrev=c/(t-o),this._weightNext=c/(s-n),this._offsetPrev=i*l,this._offsetNext=a*l}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this._offsetPrev,u=this._offsetNext,d=this._weightPrev,f=this._weightNext,p=(n-t)/(r-t),m=p*p,h=m*p,g=-d*h+2*d*m-d*p,_=(1+d)*h+(-1.5-2*d)*m+(-.5+d)*p+1,v=(-1-f)*h+(1.5+f)*m+.5*p,y=f*h-f*m;for(let e=0;e!==o;++e)i[e]=g*a[l+e]+_*a[c+e]+v*a[s+e]+y*a[u+e];return i}},sn=class extends an{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=(n-t)/(r-t),u=1-l;for(let e=0;e!==o;++e)i[e]=a[c+e]*u+a[s+e]*l;return i}},cn=class extends an{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e){return this.copySampleValue_(e-1)}},ln=class extends an{interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this.inTangents,u=this.outTangents;if(!l||!u){let e=(n-t)/(r-t),l=1-e;for(let t=0;t!==o;++t)i[t]=a[c+t]*l+a[s+t]*e;return i}let d=o*2,f=e-1;for(let p=0;p!==o;++p){let o=a[c+p],m=a[s+p],h=f*d+p*2,g=u[h],_=u[h+1],v=e*d+p*2,y=l[v],b=l[v+1],x=fn(n,t,g,y,r);i[p]=un(x,o,_,b,m)}return i}};function un(e,t,n,r,i){let a=1-e;return a*a*a*t+3*a*a*e*n+3*a*e*e*r+e*e*e*i}function dn(e,t,n,r,i){let a=1-e;return 3*a*a*(n-t)+6*a*e*(r-n)+3*e*e*(i-r)}function fn(e,t,n,r,i){let a=(e-t)/(i-t);for(let o=0;o<8;o++){let o=un(a,t,n,r,i)-e;if(Math.abs(o)<1e-10)break;let s=dn(a,t,n,r,i);if(Math.abs(s)<1e-10)break;a=Math.max(0,Math.min(1,a-o/s))}return a}var pn=class{constructor(e,t,n,r){if(e===void 0)throw Error(`THREE.KeyframeTrack: track name is undefined`);if(t===void 0||t.length===0)throw Error(`THREE.KeyframeTrack: no keyframes in track named `+e);this.name=e,this.times=nn(t,this.TimeBufferType),this.values=nn(n,this.ValueBufferType),this.setInterpolation(r||this.DefaultInterpolation)}static toJSON(e){let t=e.constructor,n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:nn(e.times,Array),values:nn(e.values,Array)};let t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t),rn(e.settings)&&(n.settings={inTangents:nn(e.settings.inTangents,Array),outTangents:nn(e.settings.outTangents,Array)})}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new cn(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new sn(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new on(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodBezier(e){let t=new ln(this.times,this.values,this.getValueSize(),e);return this.settings&&(t.inTangents=this.settings.inTangents,t.outTangents=this.settings.outTangents),t}setInterpolation(e){let t;switch(e){case o:t=this.InterpolantFactoryMethodDiscrete;break;case s:t=this.InterpolantFactoryMethodLinear;break;case c:t=this.InterpolantFactoryMethodSmooth;break;case l:t=this.InterpolantFactoryMethodBezier}if(t===void 0){let t=`unsupported interpolation for `+this.ValueTypeName+` keyframe track named `+this.name;if(this.createInterpolant===void 0){if(e!==this.DefaultInterpolation)this.setInterpolation(this.DefaultInterpolation);else throw Error(t)}return C(`KeyframeTrack:`,t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return o;case this.InterpolantFactoryMethodLinear:return s;case this.InterpolantFactoryMethodSmooth:return c;case this.InterpolantFactoryMethodBezier:return l}}getValueSize(){return this.values.length/this.times.length}shift(e){if(e!==0){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]+=e}return this}scale(e){if(e!==1){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]*=e;rn(this.settings)&&(mn(this.settings.inTangents,e),mn(this.settings.outTangents,e))}return this}trim(e,t){let n=this.times,r=n.length,i=0,a=r-1;for(;i!==r&&n[i]<e;)++i;for(;a!==-1&&n[a]>t;)--a;if(++a,i!==0||a!==r){i>=a&&(a=Math.max(a,1),i=a-1);let e=this.getValueSize();this.times=n.slice(i,a),this.values=this.values.slice(i*e,a*e)}return this}validate(){let e=!0,t=this.getValueSize();t-Math.floor(t)!==0&&(w(`KeyframeTrack: Invalid value size in track.`,this),e=!1);let n=this.times,r=this.values,i=n.length;i===0&&(w(`KeyframeTrack: Track is empty.`,this),e=!1);let a=null;for(let t=0;t!==i;t++){let r=n[t];if(typeof r==`number`&&isNaN(r)){w(`KeyframeTrack: Time is not a valid number.`,this,t,r),e=!1;break}if(a!==null&&a>r){w(`KeyframeTrack: Out of order keys.`,this,t,r,a),e=!1;break}a=r}if(r!==void 0&&y(r))for(let t=0,n=r.length;t!==n;++t){let n=r[t];if(isNaN(n)){w(`KeyframeTrack: Value is not a valid number.`,this,t,n),e=!1;break}}return e}optimize(){let e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),r=this.getInterpolation()===c,i=e.length-1,a=1;for(let o=1;o<i;++o){let i=!1,s=e[o];if(s!==e[o+1]&&(o!==1||s!==e[0])){if(r)i=!0;else{let e=o*n,r=e-n,a=e+n;for(let o=0;o!==n;++o){let n=t[e+o];if(n!==t[r+o]||n!==t[a+o]){i=!0;break}}}}if(i){if(o!==a){e[a]=e[o];let r=o*n,i=a*n;for(let e=0;e!==n;++e)t[i+e]=t[r+e]}++a}}if(i>0){e[a]=e[i];for(let e=i*n,r=a*n,o=0;o!==n;++o)t[r+o]=t[e+o];++a}return a===e.length?(this.times=e,this.values=t):(this.times=e.slice(0,a),this.values=t.slice(0,a*n)),this}clone(){let e=this.times.slice(),t=this.values.slice(),n=this.constructor,r=new n(this.name,e,t);return r.createInterpolant=this.createInterpolant,rn(this.settings)&&(r.settings={inTangents:this.settings.inTangents.slice(),outTangents:this.settings.outTangents.slice()}),r}};function mn(e,t){for(let n=0,r=e.length;n!==r;n+=2)e[n]*=t}pn.prototype.ValueTypeName=``,pn.prototype.TimeBufferType=Float32Array,pn.prototype.ValueBufferType=Float32Array,pn.prototype.DefaultInterpolation=s;var hn=class extends pn{constructor(e,t,n){super(e,t,n)}};hn.prototype.ValueTypeName=`bool`,hn.prototype.ValueBufferType=Array,hn.prototype.DefaultInterpolation=o,hn.prototype.InterpolantFactoryMethodLinear=void 0,hn.prototype.InterpolantFactoryMethodSmooth=void 0;var gn=class extends pn{constructor(e,t,n,r){super(e,t,n,r)}};gn.prototype.ValueTypeName=`color`;var _n=class extends pn{constructor(e,t,n,r){super(e,t,n,r)}};_n.prototype.ValueTypeName=`number`;var vn=class extends an{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=(n-t)/(r-t),c=e*o;for(let e=c+o;c!==e;c+=4)ee.slerpFlat(i,0,a,c-o,a,c,s);return i}},yn=class extends pn{constructor(e,t,n,r){super(e,t,n,r)}InterpolantFactoryMethodLinear(e){return new vn(this.times,this.values,this.getValueSize(),e)}};yn.prototype.ValueTypeName=`quaternion`,yn.prototype.InterpolantFactoryMethodSmooth=void 0;var bn=class extends pn{constructor(e,t,n){super(e,t,n)}};bn.prototype.ValueTypeName=`string`,bn.prototype.ValueBufferType=Array,bn.prototype.DefaultInterpolation=o,bn.prototype.InterpolantFactoryMethodLinear=void 0,bn.prototype.InterpolantFactoryMethodSmooth=void 0;var xn=class extends pn{constructor(e,t,n,r){super(e,t,n,r)}};xn.prototype.ValueTypeName=`vector`;let Sn=/* @__PURE__ */ RegExp(`[\\\\[\\\\]\\\\.:\\\\/]`,`g`),Cn=/* @__PURE__ */ RegExp(`^((?:[^\\\\[\\\\]\\\\.:\\\\/]+[\\\\/:])*)([^\\\\[\\\\]:\\\\/]+)?(?:\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?)?\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?$`),wn=[`material`,`materials`,`bones`,`map`];var Tn=class{constructor(e,t,n){let r=n||W.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,r)}getValue(e,t){this.bind();let n=this._targetGroup.nCachedObjects_,r=this._bindings[n];r!==void 0&&r.getValue(e,t)}setValue(e,t){let n=this._bindings;for(let r=this._targetGroup.nCachedObjects_,i=n.length;r!==i;++r)n[r].setValue(e,t)}bind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},W=class e{constructor(t,n,r){this.path=n,this.parsedPath=r||e.parseTrackName(n),this.node=e.findNode(t,this.parsedPath.nodeName),this.rootNode=t,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(t,n,r){return t&&t.isAnimationObjectGroup?new e.Composite(t,n,r):new e(t,n,r)}static sanitizeNodeName(e){return e.replace(/\\s/g,`_`).replace(Sn,``)}static parseTrackName(e){let t=Cn.exec(e);if(t===null)throw Error(`THREE.PropertyBinding: Cannot parse trackName: `+e);let n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},r=n.nodeName&&n.nodeName.lastIndexOf(`.`);if(r!==void 0&&r!==-1){let e=n.nodeName.substring(r+1);wn.indexOf(e)!==-1&&(n.nodeName=n.nodeName.substring(0,r),n.objectName=e)}if(n.propertyName===null||n.propertyName.length===0)throw Error(`THREE.PropertyBinding: can not parse propertyName from trackName: `+e);return n}static findNode(e,t){if(t===void 0||t===``||t===`.`||t===-1||t===e.name||t===e.uuid)return e;if(e.skeleton){let n=e.skeleton.getBoneByName(t);if(n!==void 0)return n}if(e.children){let n=function(e){for(let r=0;r<e.length;r++){let i=e[r];if(i.name===t||i.uuid===t)return i;let a=n(i.children);if(a)return a}return null},r=n(e.children);if(r)return r}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)e[t++]=n[r]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++]}_setValue_array_setNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let t=this.node,n=this.parsedPath,r=n.objectName,i=n.propertyName,a=n.propertyIndex;if(t||(t=e.findNode(this.rootNode,n.nodeName),this.node=t),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!t){C(`PropertyBinding: No target node found for track: `+this.path+`.`);return}if(r){let e=n.objectIndex;switch(r){case`materials`:if(!t.material){w(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.materials){w(`PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.`,this);return}t=t.material.materials;break;case`bones`:if(!t.skeleton){w(`PropertyBinding: Can not bind to bones as node does not have a skeleton.`,this);return}t=t.skeleton.bones;for(let n=0;n<t.length;n++)if(t[n].name===e){e=n;break}break;case`map`:if(`map`in t){t=t.map;break}if(!t.material){w(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.map){w(`PropertyBinding: Can not bind to material.map as node.material does not have a map.`,this);return}t=t.material.map;break;default:if(t[r]===void 0){w(`PropertyBinding: Can not bind to objectName of node undefined.`,this);return}t=t[r]}if(e!==void 0){if(t[e]===void 0){w(`PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.`,this,t);return}t=t[e]}}let o=t[i];if(o===void 0){let e=n.nodeName;w(`PropertyBinding: Trying to update property for track: `+e+`.`+i+` but it wasn't found.`,t);return}let s=this.Versioning.None;this.targetObject=t,t.isMaterial===!0?s=this.Versioning.NeedsUpdate:t.isObject3D===!0&&(s=this.Versioning.MatrixWorldNeedsUpdate);let c=this.BindingType.Direct;if(a!==void 0){if(i===`morphTargetInfluences`){if(!t.geometry){w(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.`,this);return}if(!t.geometry.morphAttributes){w(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.`,this);return}t.morphTargetDictionary[a]!==void 0&&(a=t.morphTargetDictionary[a])}c=this.BindingType.ArrayElement,this.resolvedProperty=o,this.propertyIndex=a}else o.fromArray!==void 0&&o.toArray!==void 0?(c=this.BindingType.HasFromToArray,this.resolvedProperty=o):Array.isArray(o)?(c=this.BindingType.EntireArray,this.resolvedProperty=o):this.propertyName=i;this.getValue=this.GetterByBindingType[c],this.setValue=this.SetterByBindingTypeAndVersioning[c][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}};W.Composite=Tn,W.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},W.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},W.prototype.GetterByBindingType=[W.prototype._getValue_direct,W.prototype._getValue_array,W.prototype._getValue_arrayElement,W.prototype._getValue_toArray],W.prototype.SetterByBindingTypeAndVersioning=[[W.prototype._setValue_direct,W.prototype._setValue_direct_setNeedsUpdate,W.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[W.prototype._setValue_array,W.prototype._setValue_array_setNeedsUpdate,W.prototype._setValue_array_setMatrixWorldNeedsUpdate],[W.prototype._setValue_arrayElement,W.prototype._setValue_arrayElement_setNeedsUpdate,W.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[W.prototype._setValue_fromArray,W.prototype._setValue_fromArray_setNeedsUpdate,W.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],class e{static{e.prototype.isMatrix2=!0}constructor(e,t,n,r){this.elements=[1,0,0,1],e!==void 0&&this.set(e,t,n,r)}identity(){return this.set(1,0,0,1),this}fromArray(e,t=0){for(let n=0;n<4;n++)this.elements[n]=e[n+t];return this}set(e,t,n,r){let i=this.elements;return i[0]=e,i[2]=t,i[1]=n,i[3]=r,this}};let En=/*@__PURE__*/ new I,Dn=/*@__PURE__*/ new I,On=/*@__PURE__*/ new I,kn=/*@__PURE__*/ new I,An=/*@__PURE__*/ new I,jn=/*@__PURE__*/ new I,Mn=/*@__PURE__*/ new I;var Nn=class{constructor(e=new I,t=new I){this.start=e,this.end=t}set(e,t){return this.start.copy(e),this.end.copy(t),this}copy(e){return this.start.copy(e.start),this.end.copy(e.end),this}getCenter(e){return e.addVectors(this.start,this.end).multiplyScalar(.5)}delta(e){return e.subVectors(this.end,this.start)}distanceSq(){return this.start.distanceToSquared(this.end)}distance(){return this.start.distanceTo(this.end)}at(e,t){return this.delta(t).multiplyScalar(e).add(this.start)}closestPointToPointParameter(e,t){En.subVectors(e,this.start),Dn.subVectors(this.end,this.start);let n=Dn.dot(Dn);if(n===0)return 0;let r=Dn.dot(En)/n;return t&&(r=A(r,0,1)),r}closestPointToPoint(e,t,n){let r=this.closestPointToPointParameter(e,t);return this.delta(n).multiplyScalar(r).add(this.start)}distanceSqToLine3(e,t=jn,n=Mn){let r=1e-8*1e-8,i,a,o=this.start,s=e.start,c=this.end,l=e.end;On.subVectors(c,o),kn.subVectors(l,s),An.subVectors(o,s);let u=On.dot(On),d=kn.dot(kn),f=kn.dot(An);if(u<=r&&d<=r)return t.copy(o),n.copy(s),t.sub(n),t.dot(t);if(u<=r)i=0,a=f/d,a=A(a,0,1);else{let e=On.dot(An);if(d<=r)a=0,i=A(-e/u,0,1);else{let t=On.dot(kn),n=u*d-t*t;i=n===0?0:A((t*f-e*d)/n,0,1),a=(t*i+f)/d,a<0?(a=0,i=A(-e/u,0,1)):a>1&&(a=1,i=A((t-e)/u,0,1))}}return t.copy(o).addScaledVector(On,i),n.copy(s).addScaledVector(kn,a),t.distanceToSquared(n)}applyMatrix4(e){return this.start.applyMatrix4(e),this.end.applyMatrix4(e),this}equals(e){return e.start.equals(this.start)&&e.end.equals(this.end)}clone(){return new this.constructor().copy(this)}};typeof __THREE_DEVTOOLS__<`u`&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`register`,{detail:{revision:`186`}})),typeof window<`u`&&(window.__THREE__?C(`WARNING: Multiple instances of Three.js being imported.`):window.__THREE__=`186`);let Pn=1.25,Fn=65535,In=2**-24,Ln=Symbol(`SKIP_GENERATION`),Rn={strategy:0,maxDepth:40,targetLeafSize:10,useSharedArrayBuffer:!1,setBoundingBox:!0,onProgress:null,indirect:!1,verbose:!0,range:null,[Ln]:!1};function G(e,t,n){return n.min.x=t[e],n.min.y=t[e+1],n.min.z=t[e+2],n.max.x=t[e+3],n.max.y=t[e+4],n.max.z=t[e+5],n}function zn(e){let t=-1,n=-1/0;for(let r=0;r<3;r++){let i=e[r+3]-e[r];i>n&&(n=i,t=r)}return t}function Bn(e,t){t.set(e)}function Vn(e,t,n){let r,i;for(let a=0;a<3;a++){let o=a+3;r=e[a],i=t[a],n[a]=r<i?r:i,r=e[o],i=t[o],n[o]=r>i?r:i}}function Hn(e,t,n){for(let r=0;r<3;r++){let i=t[e+2*r],a=t[e+2*r+1],o=i-a,s=i+a;o<n[r]&&(n[r]=o),s>n[r+3]&&(n[r+3]=s)}}function Un(e){let t=e[3]-e[0],n=e[4]-e[1],r=e[5]-e[2];return 2*(t*n+n*r+r*t)}function K(e,t){return t[e+15]===Fn}function q(e,t){return t[e+6]}function J(e,t){return t[e+14]}function Y(e){return e+8}function X(e,t){return e+t[e+6]*8}function Wn(e,t){return t[e+7]}function Z(e){return e}function Gn(e,t,n,r,i){let a=1/0,o=1/0,s=1/0,c=-1/0,l=-1/0,u=-1/0,d=1/0,f=1/0,p=1/0,m=-1/0,h=-1/0,g=-1/0,_=e.offset||0;for(let r=(t-_)*6,i=(t+n-_)*6;r<i;r+=6){let t=e[r+0],n=e[r+1],i=t-n,_=t+n;i<a&&(a=i),_>c&&(c=_),t<d&&(d=t),t>m&&(m=t);let v=e[r+2],y=e[r+3],b=v-y,x=v+y;b<o&&(o=b),x>l&&(l=x),v<f&&(f=v),v>h&&(h=v);let S=e[r+4],C=e[r+5],w=S-C,T=S+C;w<s&&(s=w),T>u&&(u=T),S<p&&(p=S),S>g&&(g=S)}r[0]=a,r[1]=o,r[2]=s,r[3]=c,r[4]=l,r[5]=u,i[0]=d,i[1]=f,i[2]=p,i[3]=m,i[4]=h,i[5]=g}let Kn=(e,t)=>e.candidate-t.candidate,qn=/* @__PURE__ */ Array(32).fill().map(()=>({count:0,bounds:/* @__PURE__ */ new Float32Array(6),rightCacheBounds:/* @__PURE__ */ new Float32Array(6),leftCacheBounds:/* @__PURE__ */ new Float32Array(6),candidate:0})),Jn=/* @__PURE__ */ new Float32Array(6);function Yn(e,t,n,r,i,a){let o=-1,s=0;if(a===0)o=zn(t),o!==-1&&(s=(t[o]+t[o+3])/2);else if(a===1)o=zn(e),o!==-1&&(s=Xn(n,r,i,o));else if(a===2){let a=Un(e),c=Pn*i,l=n.offset||0,u=(r-l)*6,d=(r+i-l)*6;for(let e=0;e<3;e++){let r=t[e],l=(t[e+3]-r)/32;if(i<8){let t=[...qn];t.length=i;let r=0;for(let i=u;i<d;i+=6,r++){let a=t[r];a.candidate=n[i+2*e],a.count=0;let{bounds:o,leftCacheBounds:s,rightCacheBounds:c}=a;for(let e=0;e<3;e++)c[e]=1/0,c[e+3]=-1/0,s[e]=1/0,s[e+3]=-1/0,o[e]=1/0,o[e+3]=-1/0;Hn(i,n,o)}t.sort(Kn);let l=i;for(let e=0;e<l;e++){let n=t[e];for(;e+1<l&&t[e+1].candidate===n.candidate;)t.splice(e+1,1),l--}for(let r=u;r<d;r+=6){let i=n[r+2*e];for(let e=0;e<l;e++){let a=t[e];i>=a.candidate?Hn(r,n,a.rightCacheBounds):(Hn(r,n,a.leftCacheBounds),a.count++)}}for(let n=0;n<l;n++){let r=t[n],l=r.count,u=i-r.count,d=r.leftCacheBounds,f=r.rightCacheBounds,p=0;l!==0&&(p=Un(d)/a);let m=0;u!==0&&(m=Un(f)/a);let h=1+Pn*(p*l+m*u);h<c&&(o=e,c=h,s=r.candidate)}}else{for(let e=0;e<32;e++){let t=qn[e];t.count=0,t.candidate=r+l+e*l;let n=t.bounds;for(let e=0;e<3;e++)n[e]=1/0,n[e+3]=-1/0}for(let t=u;t<d;t+=6){let i=~~((n[t+2*e]-r)/l);i>=32&&(i=31);let a=qn[i];a.count++,Hn(t,n,a.bounds)}let t=qn[31];Bn(t.bounds,t.rightCacheBounds);for(let e=30;e>=0;e--){let t=qn[e],n=qn[e+1];Vn(t.bounds,n.rightCacheBounds,t.rightCacheBounds)}let f=0;for(let t=0;t<31;t++){let n=qn[t],r=n.count,l=n.bounds,u=qn[t+1].rightCacheBounds;r!==0&&(f===0?Bn(l,Jn):Vn(l,Jn,Jn)),f+=r;let d=0,p=0;f!==0&&(d=Un(Jn)/a);let m=i-f;m!==0&&(p=Un(u)/a);let h=1+Pn*(d*f+p*m);h<c&&(o=e,c=h,s=n.candidate)}}}}else console.warn(`BVH: Invalid build strategy value ${a} used.`);return{axis:o,pos:s}}function Xn(e,t,n,r){let i=0,a=e.offset;for(let o=t,s=t+n;o<s;o++)i+=e[(o-a)*6+r*2];return i/n}var Zn=class{constructor(){this.boundingData=/* @__PURE__ */ new Float32Array(6)}};function Qn(e,t,n,r,i,a){let o=r,s=r+i-1,c=a.pos,l=a.axis*2,u=n.offset||0;for(;;){for(;o<=s&&n[(o-u)*6+l]<c;)o++;for(;o<=s&&n[(s-u)*6+l]>=c;)s--;if(o<s){for(let n=0;n<t;n++){let r=e[o*t+n];e[o*t+n]=e[s*t+n],e[s*t+n]=r}for(let e=0;e<6;e++){let t=o-u,r=s-u,i=n[t*6+e];n[t*6+e]=n[r*6+e],n[r*6+e]=i}o++,s--}else return o}}let $n,er,tr,nr,rr=2**32;function ir(e){return`count`in e?1:1+ir(e.left)+ir(e.right)}function ar(e,t,n){return $n=new Float32Array(n),er=new Uint32Array(n),tr=new Uint16Array(n),nr=new Uint8Array(n),or(e,t)}function or(e,t){let n=e/4,r=e/2,i=`count`in t,a=t.boundingData;for(let e=0;e<6;e++)$n[n+e]=a[e];if(i)return t.buffer?(nr.set(new Uint8Array(t.buffer),e),e+t.buffer.byteLength):(er[n+6]=t.offset,tr[r+14]=t.count,tr[r+15]=Fn,e+32);{let{left:r,right:i,splitAxis:a}=t,o=or(e+32,r),s=e/32,c=o/32-s;if(c>rr)throw Error(`MeshBVH: Cannot store relative child node offset greater than 32 bits.`);return er[n+6]=c,er[n+7]=a,or(o,i)}}function sr(e,t,n,r,i,a){let{maxDepth:o,verbose:s,targetLeafSize:c,_strictLeafSize:l=1/0,strategy:u,onProgress:d}=i,f=e.primitiveBuffer,p=e.primitiveBufferStride,m=/* @__PURE__ */ new Float32Array(6),h=!1,g=new Zn;return Gn(t,n,r,g.boundingData,m),v(g,n,r,m),g;function _(e){d&&d((e-a.offset)/a.count)}function v(e,n,r,i=null,a=0){!h&&a>=o&&(h=!0,s&&console.warn(`BVH: Max depth of ${o} reached when generating BVH. Consider increasing maxDepth.`));let d=r>l;if(r<=c&&!d||a>=o)return _(n+r),e.offset=n,e.count=r,e;let g=Yn(e.boundingData,i,t,n,r,u),y=g.axis===-1?-1:Qn(f,p,t,n,r,g);if(g.axis===-1||y===n||y===n+r){if(!d)return _(n+r),e.offset=n,e.count=r,e;g.axis=Math.max(0,zn(e.boundingData)),y=n+Math.max(1,Math.floor(r/2))}e.splitAxis=g.axis;let b=new Zn,x=n,S=y-n;e.left=b,Gn(t,x,S,b.boundingData,m),v(b,x,S,m,a+1);let C=new Zn,w=y,T=r-S;return e.right=C,Gn(t,w,T,C.boundingData,m),v(C,w,T,m,a+1),e}}function cr(e,t){let n=t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer,r=e.getRootRanges(t.range),i=r[0],a=r[r.length-1],o={offset:i.offset,count:a.offset+a.count-i.offset},s=new Float32Array(6*o.count);s.offset=o.offset,e.computePrimitiveBounds(o.offset,o.count,s),e._roots=r.map(r=>{let i=sr(e,s,r.offset,r.count,t,o),a=ir(i),c=new n(32*a);return ar(0,i,c),c})}var lr=class{constructor(e){this._getNewPrimitive=e,this._primitives=[]}getPrimitive(){let e=this._primitives;return e.length===0?this._getNewPrimitive():e.pop()}releasePrimitive(e){this._primitives.push(e)}};let Q=/* @__PURE__ */ new class{constructor(){this.float32Array=null,this.uint16Array=null,this.uint32Array=null;let e=[],t=null;this.setBuffer=n=>{t&&e.push(t),t=n,this.float32Array=new Float32Array(n),this.uint16Array=new Uint16Array(n),this.uint32Array=new Uint32Array(n)},this.clearBuffer=()=>{t=null,this.float32Array=null,this.uint16Array=null,this.uint32Array=null,e.length!==0&&this.setBuffer(e.pop())}}},ur,dr,fr=[],pr=/* @__PURE__ */ new lr(()=>new B);function mr(e,t,n,r,i,a){ur=pr.getPrimitive(),dr=pr.getPrimitive(),fr.push(ur,dr),Q.setBuffer(e._roots[t]);let o=hr(0,e.geometry,n,r,i,a);Q.clearBuffer(),pr.releasePrimitive(ur),pr.releasePrimitive(dr),fr.pop(),fr.pop();let s=fr.length;return s>0&&(dr=fr[s-1],ur=fr[s-2]),o}function hr(e,t,n,r,i=null,a=0,o=0){let{float32Array:s,uint16Array:c,uint32Array:l}=Q,u=e*2;if(K(u,c)){let t=q(e,l),n=J(u,c);return G(Z(e),s,ur),r(t,n,!1,o,a+e/8,ur)}{let u=Y(e),p=X(e,l),m=u,h=p,g,_,v,y;if(i&&(v=ur,y=dr,G(Z(m),s,v),G(Z(h),s,y),g=i(v),_=i(y),_<g)){m=p,h=u;let e=g;g=_,_=e,v=y}v||(v=ur,G(Z(m),s,v));let b=K(m*2,c),x=n(v,b,g,o+1,a+m/8),S;if(x===2){let e=d(m);S=r(e,f(m)-e,!0,o+1,a+m/8,v)}else S=x&&hr(m,t,n,r,i,a,o+1);if(S)return!0;y=dr,G(Z(h),s,y);let C=K(h*2,c),w=n(y,C,_,o+1,a+h/8),T;if(w===2){let e=d(h);T=r(e,f(h)-e,!0,o+1,a+h/8,y)}else T=w&&hr(h,t,n,r,i,a,o+1);return!!T;function d(e){let{uint16Array:t,uint32Array:n}=Q,r=e*2;for(;!K(r,t);)e=Y(e),r=e*2;return q(e,n)}function f(e){let{uint16Array:t,uint32Array:n}=Q,r=e*2;for(;!K(r,t);)e=X(e,n),r=e*2;return q(e,n)+J(r,t)}}}let gr=/* @__PURE__ */ new Q.constructor,_r=/* @__PURE__ */ new Q.constructor,vr=/* @__PURE__ */ new lr(()=>new B),yr=/* @__PURE__ */ new B,br=/* @__PURE__ */ new B,xr=/* @__PURE__ */ new B,Sr=/* @__PURE__ */ new B,Cr=!1;function wr(e,t,n,r){if(Cr)throw Error(`MeshBVH: Recursive calls to bvhcast not supported.`);Cr=!0;let i=e._roots,a=t._roots,o,s=0,c=0,l=new R().copy(n).invert();for(let e=0,t=i.length;e<t;e++){gr.setBuffer(i[e]),c=0;let t=vr.getPrimitive();G(Z(0),gr.float32Array,t),t.applyMatrix4(l);for(let e=0,i=a.length;e<i&&(_r.setBuffer(a[e]),o=Tr(0,0,n,l,r,s,c,0,0,t),_r.clearBuffer(),c+=a[e].byteLength/32,!o);e++);if(vr.releasePrimitive(t),gr.clearBuffer(),s+=i[e].byteLength/32,o)break}return Cr=!1,o}function Tr(e,t,n,r,i,a=0,o=0,s=0,c=0,l=null,u=!1){let d,f;u?(d=_r,f=gr):(d=gr,f=_r);let p=d.float32Array,m=d.uint32Array,h=d.uint16Array,g=f.float32Array,_=f.uint32Array,v=f.uint16Array,y=e*2,b=t*2,x=K(y,h),S=K(b,v),C=!1;if(S&&x)C=u?i(q(t,_),J(t*2,v),q(e,m),J(e*2,h),c,o+t/8,s,a+e/8):i(q(e,m),J(e*2,h),q(t,_),J(t*2,v),s,a+e/8,c,o+t/8);else if(S){let l=vr.getPrimitive();G(Z(t),g,l),l.applyMatrix4(n);let d=Y(e),f=X(e,m);G(Z(d),p,yr),G(Z(f),p,br);let h=l.intersectsBox(yr),_=l.intersectsBox(br);C=h&&Tr(t,d,r,n,i,o,a,c,s+1,l,!u)||_&&Tr(t,f,r,n,i,o,a,c,s+1,l,!u),vr.releasePrimitive(l)}else{let d=Y(t),f=X(t,_);G(Z(d),g,xr),G(Z(f),g,Sr);let h=l.intersectsBox(xr),v=l.intersectsBox(Sr);if(h&&v)C=Tr(e,d,n,r,i,a,o,s,c+1,l,u)||Tr(e,f,n,r,i,a,o,s,c+1,l,u);else if(h){if(x)C=Tr(e,d,n,r,i,a,o,s,c+1,l,u);else{let t=vr.getPrimitive();t.copy(xr).applyMatrix4(n);let l=Y(e),f=X(e,m);G(Z(l),p,yr),G(Z(f),p,br);let h=t.intersectsBox(yr),g=t.intersectsBox(br);C=h&&Tr(d,l,r,n,i,o,a,c,s+1,t,!u)||g&&Tr(d,f,r,n,i,o,a,c,s+1,t,!u),vr.releasePrimitive(t)}}else if(v){if(x)C=Tr(e,f,n,r,i,a,o,s,c+1,l,u);else{let t=vr.getPrimitive();t.copy(Sr).applyMatrix4(n);let l=Y(e),d=X(e,m);G(Z(l),p,yr),G(Z(d),p,br);let h=t.intersectsBox(yr),g=t.intersectsBox(br);C=h&&Tr(f,l,r,n,i,o,a,c,s+1,t,!u)||g&&Tr(f,d,r,n,i,o,a,c,s+1,t,!u),vr.releasePrimitive(t)}}}return C}let Er=new class{constructor(){let e=null,t=null,n=null,r=!1;this.root=null,this.buffer=null,this.uint32Array=null,this.uint16Array=null,this.setBVH=(i,a)=>{if(r)throw Error(`BVHTraversalHelper: cannot call setBVH during an active traversal.`);this.root=a,this.buffer=e=i._roots[a],this.uint16Array=n=new Uint16Array(e),this.uint32Array=t=new Uint32Array(e)},this.reset=()=>{this.root=null,this.buffer=e=null,this.uint16Array=n=null,this.uint32Array=t=null},this.getRangeStart=e=>{let r=e*2;for(;!K(r,n);)e=Y(e),r=e*2;return q(e,t)},this.getRangeEnd=e=>{let r=e*2;for(;!K(r,n);)e=X(e,t),r=e*2;return q(e,t)+J(r,n)};let i=(e,r,a)=>{let o=K(r*2,n);if(!e(a,o,r)&&!o){let n=Y(r),o=X(r,t);i(e,n,a+1),i(e,o,a+1)}};this.traverseBuffer=e=>{if(r)throw Error(`BVHTraversalHelper: cannot start a traversal during an active traversal.`);r=!0;try{i(e,0,0)}finally{r=!1}},this.traverse=r=>{this.traverseBuffer((i,a,o)=>{if(a){let s=o*2,c=t[o+6],l=n[s+14];return r(i,a,new Float32Array(e,o*4,6),c,l)}{let n=Wn(o,t);return r(i,a,new Float32Array(e,o*4,6),n)}})}}},Dr=/* @__PURE__ */ new B,Or=/* @__PURE__ */ new Float32Array(6);var kr=class{constructor(){this._roots=null,this.primitiveBuffer=null,this.primitiveBufferStride=null}init(e){e={...Rn,...e},`maxLeafSize`in e&&(console.warn(`BVH: \"maxLeafSize\" option has been deprecated. Use \"targetLeafSize\", instead.`),e={...e,targetLeafSize:e.maxLeafSize}),cr(this,e)}getRootRanges(){throw Error(`BVH: getRootRanges() not implemented`)}writePrimitiveBounds(){throw Error(`BVH: writePrimitiveBounds() not implemented`)}writePrimitiveRangeBounds(e,t,n,r){let i=1/0,a=1/0,o=1/0,s=-1/0,c=-1/0,l=-1/0;for(let n=e,r=e+t;n<r;n++){this.writePrimitiveBounds(n,Or,0);let[e,t,r,u,d,f]=Or;e<i&&(i=e),u>s&&(s=u),t<a&&(a=t),d>c&&(c=d),r<o&&(o=r),f>l&&(l=f)}return n[r+0]=i,n[r+1]=a,n[r+2]=o,n[r+3]=s,n[r+4]=c,n[r+5]=l,n}computePrimitiveBounds(e,t,n){let r=n.offset||0;for(let i=e,a=e+t;i<a;i++){this.writePrimitiveBounds(i,Or,0);let[e,t,a,o,s,c]=Or,l=(e+o)/2,u=(t+s)/2,d=(a+c)/2,f=(o-e)/2,p=(s-t)/2,m=(c-a)/2,h=(i-r)*6;n[h+0]=l,n[h+1]=f+(Math.abs(l)+f)*In,n[h+2]=u,n[h+3]=p+(Math.abs(u)+p)*In,n[h+4]=d,n[h+5]=m+(Math.abs(d)+m)*In}return n}shiftPrimitiveOffsets(e){let t=this._indirectBuffer;if(t)for(let n=0,r=t.length;n<r;n++)t[n]+=e;else{let t=this._roots;for(let n=0;n<t.length;n++){let r=t[n],i=new Uint32Array(r),a=new Uint16Array(r),o=r.byteLength/32;for(let t=0;t<o;t++){let n=8*t;K(2*n,a)&&(i[n+6]+=e)}}}}traverse(e,t=0){Er.setBVH(this,t),Er.traverse(e),Er.reset()}refit(){let e=this._roots;for(let t=0,n=e.length;t<n;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n),a=new Float32Array(n),o=n.byteLength/32;for(let e=o-1;e>=0;e--){let t=e*8,n=t*2;if(K(n,i)){let e=q(t,r),o=J(n,i);this.writePrimitiveRangeBounds(e,o,Or,0),a.set(Or,t)}else{let e=Y(t),n=X(t,r);for(let r=0;r<3;r++){let i=a[e+r],o=a[e+r+3],s=a[n+r],c=a[n+r+3];a[t+r]=i<s?i:s,a[t+r+3]=o>c?o:c}}}}}getBoundingBox(e){return e.makeEmpty(),this._roots.forEach(t=>{G(0,new Float32Array(t),Dr),e.union(Dr)}),e}shapecast(e){let{boundsTraverseOrder:t,intersectsBounds:n,intersectsRange:r,intersectsPrimitive:i,scratchPrimitive:a,iterate:o}=e;if(r&&i){let e=r;r=(t,n,r,s,c)=>e(t,n,r,s,c)?!0:o(t,n,this,i,r,s,a)}else r||=i?(e,t,n,r)=>o(e,t,this,i,n,r,a):(e,t,n)=>n;let s=!1,c=0,l=this._roots;for(let e=0,i=l.length;e<i;e++){let i=l[e];if(s=mr(this,e,n,r,t,c),s)break;c+=i.byteLength/32}return s}bvhcast(e,t,n){let{intersectsRanges:r}=n;return wr(this,e,t,r)}};function Ar(){return typeof SharedArrayBuffer<`u`}function jr(e){return e.index?e.index.count:e.attributes.position.count}function Mr(e){return jr(e)/3}function Nr(e,t=ArrayBuffer){return e>65535?new Uint32Array(new t(4*e)):new Uint16Array(new t(2*e))}function Pr(e,t){if(!e.index){let n=e.attributes.position.count,r=Nr(n,t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer);e.setIndex(new H(r,1));for(let e=0;e<n;e++)r[e]=e}}function Fr(e,t,n){let r=jr(e)/n,i=t||e.drawRange,a=i.start/n,o=(i.start+i.count)/n,s=Math.max(0,a),c=Math.min(r,o)-s;return{offset:Math.floor(s),count:Math.floor(c)}}function Ir(e,t){return e.groups.map(e=>({offset:e.start/t,count:e.count/t}))}function Lr(e,t,n){let r=Fr(e,t,n),i=Ir(e,n);if(!i.length)return[r];let a=[],o=r.offset,s=r.offset+r.count,c=jr(e)/n,l=[];for(let e of i){let{offset:t,count:n}=e,r=t,i=t+(isFinite(n)?n:c-t);r<s&&i>o&&(l.push({pos:Math.max(o,r),isStart:!0}),l.push({pos:Math.min(s,i),isStart:!1}))}l.sort((e,t)=>e.pos===t.pos?e.type===`end`?-1:1:e.pos-t.pos);let u=0,d=null;for(let e of l){let t=e.pos;u!==0&&t!==d&&a.push({offset:d,count:t-d}),u+=e.isStart?1:-1,d=t}return a}function Rr(e,t){let n=e[e.length-1],r=n.offset+n.count>2**16,i=e.reduce((e,t)=>e+t.count,0),a=r?4:2,o=t?new SharedArrayBuffer(i*a):new ArrayBuffer(i*a),s=r?new Uint32Array(o):new Uint16Array(o),c=0;for(let t=0;t<e.length;t++){let{offset:n,count:r}=e[t];for(let e=0;e<r;e++)s[c+e]=n+e;c+=r}return s}var zr=class extends kr{get indirect(){return!!this._indirectBuffer}get primitiveStride(){return null}get primitiveBufferStride(){return this.indirect?1:this.primitiveStride}set primitiveBufferStride(e){}get primitiveBuffer(){return this.indirect?this._indirectBuffer:this.geometry.index.array}set primitiveBuffer(e){}constructor(e,t={}){if(!e.isBufferGeometry)throw Error(`BVH: Only BufferGeometries are supported.`);if(e.index&&e.index.isInterleavedBufferAttribute)throw Error(`BVH: InterleavedBufferAttribute is not supported for the index attribute.`);if(t.useSharedArrayBuffer&&!Ar())throw Error(`BVH: SharedArrayBuffer is not available.`);super(),this.geometry=e,this.resolvePrimitiveIndex=t.indirect?e=>this._indirectBuffer[e]:e=>e,this.primitiveBuffer=null,this.primitiveBufferStride=null,this._indirectBuffer=null,t={...Rn,...t},t[Ln]||this.init(t)}init(e){let{geometry:t,primitiveStride:n}=this;if(e.indirect){let r=Rr(Lr(t,e.range,n),e.useSharedArrayBuffer);this._indirectBuffer=r}else Pr(t,e);super.init(e),!t.boundingBox&&e.setBoundingBox&&(t.boundingBox=this.getBoundingBox(new B))}getRootRanges(e){return this.indirect?[{offset:0,count:this._indirectBuffer.length}]:Lr(this.geometry,e,this.primitiveStride)}raycastObject3D(){throw Error(`BVH: raycastObject3D() not implemented`)}},Br=class{constructor(){this.min=1/0,this.max=-1/0}setFromPointsField(e,t){let n=1/0,r=-1/0;for(let i=0,a=e.length;i<a;i++){let a=e[i][t];n=a<n?a:n,r=a>r?a:r}this.min=n,this.max=r}setFromPoints(e,t){let n=1/0,r=-1/0;for(let i=0,a=t.length;i<a;i++){let a=t[i],o=e.dot(a);n=o<n?o:n,r=o>r?o:r}this.min=n,this.max=r}isSeparated(e){return this.min>e.max||e.min>this.max}};Br.prototype.setFromBox=(function(){let e=/* @__PURE__ */ new I;return function(t,n){let r=n.min,i=n.max,a=1/0,o=-1/0;for(let n=0;n<=1;n++)for(let s=0;s<=1;s++)for(let c=0;c<=1;c++){e.x=r.x*n+i.x*(1-n),e.y=r.y*s+i.y*(1-s),e.z=r.z*c+i.z*(1-c);let l=t.dot(e);a=Math.min(l,a),o=Math.max(l,o)}this.min=a,this.max=o}})();let Vr=(function(){let e=/* @__PURE__ */ new I,t=/* @__PURE__ */ new I,n=/* @__PURE__ */ new I;return function(r,i,a){let o=r.start,s=e,c=i.start,l=t;n.subVectors(o,c),e.subVectors(r.end,r.start),t.subVectors(i.end,i.start);let u=n.dot(l),d=l.dot(s),f=l.dot(l),p=n.dot(s),m=s.dot(s)*f-d*d,h,g;h=m===0?0:(u*d-p*f)/m,g=(u+h*d)/f,a.x=h,a.y=g}})(),Hr=(function(){let e=/* @__PURE__ */ new F,t=/* @__PURE__ */ new I,n=/* @__PURE__ */ new I;return function(r,i,a,o){Vr(r,i,e);let s=e.x,c=e.y;if(s>=0&&s<=1&&c>=0&&c<=1){r.at(s,a),i.at(c,o);return}if(s>=0&&s<=1){c<0?i.at(0,o):i.at(1,o),r.closestPointToPoint(o,!0,a);return}if(c>=0&&c<=1){s<0?r.at(0,a):r.at(1,a),i.closestPointToPoint(a,!0,o);return}{let e;e=s<0?r.start:r.end;let l;l=c<0?i.start:i.end;let u=t,d=n;if(r.closestPointToPoint(l,!0,t),i.closestPointToPoint(e,!0,n),u.distanceToSquared(l)<=d.distanceToSquared(e)){a.copy(u),o.copy(l);return}a.copy(e),o.copy(d);return}}})(),Ur=(function(){let e=/* @__PURE__ */ new I,t=/* @__PURE__ */ new I,n=/* @__PURE__ */ new Wt,r=/* @__PURE__ */ new Nn;return function(i,a){let{radius:o,center:s}=i,{a:c,b:l,c:u}=a;if(r.start=c,r.end=l,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o||(r.start=c,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o)||(r.start=l,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o))return!0;let d=a.getPlane(n);if(Math.abs(d.distanceToPoint(s))<=o){let e=d.projectPoint(s,t);if(a.containsPoint(e))return!0}return!1}})(),Wr=[`x`,`y`,`z`],Gr=1e-15,Kr=Gr*Gr;function qr(e){return Math.abs(e)<Gr}var Jr=class extends ut{constructor(...e){super(...e),this.isExtendedTriangle=!0,this.satAxes=[,,,,].fill().map(()=>new I),this.satBounds=[,,,,].fill().map(()=>new Br),this.points=[this.a,this.b,this.c],this.plane=new Wt,this.isDegenerateIntoSegment=!1,this.isDegenerateIntoPoint=!1,this.degenerateSegment=new Nn,this.needsUpdate=!0}intersectsSphere(e){return Ur(e,this)}update(){let e=this.a,t=this.b,n=this.c,r=this.points,i=this.satAxes,a=this.satBounds,o=i[0],s=a[0];this.getNormal(o),s.setFromPoints(o,r);let c=i[1],l=a[1];c.subVectors(e,t),l.setFromPoints(c,r);let u=i[2],d=a[2];u.subVectors(t,n),d.setFromPoints(u,r);let f=i[3],p=a[3];f.subVectors(n,e),p.setFromPoints(f,r);let m=c.length(),h=u.length(),g=f.length();this.isDegenerateIntoPoint=!1,this.isDegenerateIntoSegment=!1,m<Gr?h<Gr||g<Gr?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(e),this.degenerateSegment.end.copy(n)):h<Gr?g<Gr?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(t),this.degenerateSegment.end.copy(e)):g<Gr&&(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(n),this.degenerateSegment.end.copy(t)),this.plane.setFromNormalAndCoplanarPoint(o,e),this.needsUpdate=!1}};Jr.prototype.closestPointToSegment=(function(){let e=/* @__PURE__ */ new I,t=/* @__PURE__ */ new I,n=/* @__PURE__ */ new Nn;return function(r,i=null,a=null){let{start:o,end:s}=r,c=this.points,l,u=1/0;for(let o=0;o<3;o++){let s=(o+1)%3;n.start.copy(c[o]),n.end.copy(c[s]),Hr(n,r,e,t),l=e.distanceToSquared(t),l<u&&(u=l,i&&i.copy(e),a&&a.copy(t))}return this.closestPointToPoint(o,e),l=o.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(o)),this.closestPointToPoint(s,e),l=s.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(s)),Math.sqrt(u)}})(),Jr.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new Jr,t=/* @__PURE__ */ new Br,n=/* @__PURE__ */ new Br,r=/* @__PURE__ */ new I,i=/* @__PURE__ */ new I,a=/* @__PURE__ */ new I,o=/* @__PURE__ */ new I,s=/* @__PURE__ */ new Nn,c=/* @__PURE__ */ new Nn,l=/* @__PURE__ */ new I,u=/* @__PURE__ */ new F,d=/* @__PURE__ */ new F;function f(e,i,a,s){let c=r;!e.isDegenerateIntoPoint&&!e.isDegenerateIntoSegment?c.copy(e.plane.normal):c.copy(i.plane.normal);let l=e.satBounds,u=e.satAxes;for(let r=1;r<4;r++){let a=l[r],s=u[r];if(t.setFromPoints(s,i.points),a.isSeparated(t)||(o.copy(c).cross(s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}let d=i.satBounds,f=i.satAxes;for(let r=1;r<4;r++){let a=d[r],s=f[r];if(t.setFromPoints(s,e.points),a.isSeparated(t)||(o.crossVectors(c,s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}return a&&(s||console.warn(`ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.`),a.start.set(0,0,0),a.end.set(0,0,0)),!0}function p(e,t,n,r,i,a,o,s,c,l,u){let d=o/(o-s);l.x=r+(i-r)*d,u.start.subVectors(t,e).multiplyScalar(d).add(e),d=o/(o-c),l.y=r+(a-r)*d,u.end.subVectors(n,e).multiplyScalar(d).add(e)}function m(e,t,n,r,i,a,o,s,c,l,u){if(i>0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else if(a>0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(s*c>0||o!=0)p(e.a,e.b,e.c,t,n,r,o,s,c,l,u);else if(s!=0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(c!=0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else return!0;return!1}function h(e,t,n,i){let a=t.degenerateSegment,o=e.plane.distanceToPoint(a.start),s=e.plane.distanceToPoint(a.end);return qr(o)?qr(s)?f(e,t,n,i):(n&&(n.start.copy(a.start),n.end.copy(a.start)),e.containsPoint(a.start)):qr(s)?(n&&(n.start.copy(a.end),n.end.copy(a.end)),e.containsPoint(a.end)):e.plane.intersectLine(a,r)!=null&&(n&&(n.start.copy(r),n.end.copy(r)),e.containsPoint(r))}function g(e,t,n){let r=t.a;return qr(e.plane.distanceToPoint(r))&&e.containsPoint(r)?(n&&(n.start.copy(r),n.end.copy(r)),!0):!1}function _(e,t,n){let i=e.degenerateSegment,a=t.a;return i.closestPointToPoint(a,!0,r),a.distanceToSquared(r)<Kr&&(n&&(n.start.copy(a),n.end.copy(a)),!0)}function v(e,t,n,o){if(e.isDegenerateIntoSegment){if(t.isDegenerateIntoSegment){let o=e.degenerateSegment,s=t.degenerateSegment,c=i,l=a;o.delta(c),s.delta(l);let u=r.subVectors(s.start,o.start),d=c.x*l.y-c.y*l.x;if(qr(d))return!1;let f=(u.x*l.y-u.y*l.x)/d,p=-(c.x*u.y-c.y*u.x)/d;return f<0||f>1||p<0||p>1?!1:qr(o.start.z+c.z*f-(s.start.z+l.z*p))?(n&&(n.start.copy(o.start).addScaledVector(c,f),n.end.copy(o.start).addScaledVector(c,f)),!0):!1}return t.isDegenerateIntoPoint?_(e,t,n):h(t,e,n,o)}if(e.isDegenerateIntoPoint)return t.isDegenerateIntoPoint?t.a.distanceToSquared(e.a)<Kr&&(n&&(n.start.copy(e.a),n.end.copy(e.a)),!0):t.isDegenerateIntoSegment?_(t,e,n):g(t,e,n);if(t.isDegenerateIntoPoint)return g(e,t,n);if(t.isDegenerateIntoSegment)return h(e,t,n,o)}return function(t,n=null,r=!1){this.needsUpdate&&this.update(),t.isExtendedTriangle?t.needsUpdate&&t.update():(e.copy(t),e.update(),t=e);let o=v(this,t,n,r);if(o!==void 0)return o;let p=this.plane,h=t.plane,g=h.distanceToPoint(this.a),_=h.distanceToPoint(this.b),y=h.distanceToPoint(this.c);qr(g)&&(g=0),qr(_)&&(_=0),qr(y)&&(y=0);let b=g*_,x=g*y;if(b>0&&x>0)return!1;let S=p.distanceToPoint(t.a),C=p.distanceToPoint(t.b),w=p.distanceToPoint(t.c);qr(S)&&(S=0),qr(C)&&(C=0),qr(w)&&(w=0);let T=S*C,E=S*w;if(T>0&&E>0)return!1;i.copy(p.normal),a.copy(h.normal);let D=i.cross(a),O=0,k=Math.abs(D.x),A=Math.abs(D.y);A>k&&(k=A,O=1),Math.abs(D.z)>k&&(O=2);let j=Wr[O],M=this.a[j],N=this.b[j],P=this.c[j],F=t.a[j],ee=t.b[j],I=t.c[j];if(m(this,M,N,P,b,x,g,_,y,u,s)||m(t,F,ee,I,T,E,S,C,w,d,c))return f(this,t,n,r);if(u.y<u.x){let e=u.y;u.y=u.x,u.x=e,l.copy(s.start),s.start.copy(s.end),s.end.copy(l)}if(d.y<d.x){let e=d.y;d.y=d.x,d.x=e,l.copy(c.start),c.start.copy(c.end),c.end.copy(l)}return u.y<d.x||d.y<u.x?!1:(n&&(d.x>u.x?n.start.copy(c.start):n.start.copy(s.start),d.y<u.y?n.end.copy(c.end):n.end.copy(s.end)),!0)}})(),Jr.prototype.distanceToPoint=(function(){let e=/* @__PURE__ */ new I;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),Jr.prototype.distanceToTriangle=(function(){let e=/* @__PURE__ */ new I,t=/* @__PURE__ */ new I,n=[`a`,`b`,`c`],r=/* @__PURE__ */ new Nn,i=/* @__PURE__ */ new Nn;return function(a,o=null,s=null){let c=o||s?r:null;if(this.intersectsTriangle(a,c,!0))return(o||s)&&(o&&c.getCenter(o),s&&c.getCenter(s)),0;let l=1/0;for(let t=0;t<3;t++){let r,i=n[t],c=a[i];this.closestPointToPoint(c,e),r=c.distanceToSquared(e),r<l&&(l=r,o&&o.copy(e),s&&s.copy(c));let u=this[i];a.closestPointToPoint(u,e),r=u.distanceToSquared(e),r<l&&(l=r,o&&o.copy(u),s&&s.copy(e))}for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];r.set(this[u],this[d]);for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];i.set(a[u],a[d]),Hr(r,i,e,t);let f=e.distanceToSquared(t);f<l&&(l=f,o&&o.copy(e),s&&s.copy(t))}}return Math.sqrt(l)}})();var Yr=class{constructor(e,t,n){this.isOrientedBox=!0,this.min=new I,this.max=new I,this.matrix=new R,this.invMatrix=new R,this.points=Array(8).fill().map(()=>new I),this.satAxes=[,,,].fill().map(()=>new I),this.satBounds=[,,,].fill().map(()=>new Br),this.alignedSatBounds=[,,,].fill().map(()=>new Br),this.needsUpdate=!1,e&&this.min.copy(e),t&&this.max.copy(t),n&&this.matrix.copy(n)}set(e,t,n){this.min.copy(e),this.max.copy(t),this.matrix.copy(n),this.needsUpdate=!0}copy(e){this.min.copy(e.min),this.max.copy(e.max),this.matrix.copy(e.matrix),this.needsUpdate=!0}};Yr.prototype.update=(function(){return function(){let e=this.matrix,t=this.min,n=this.max,r=this.points;for(let i=0;i<=1;i++)for(let a=0;a<=1;a++)for(let o=0;o<=1;o++){let s=r[1*i|2*a|4*o];s.x=i?n.x:t.x,s.y=a?n.y:t.y,s.z=o?n.z:t.z,s.applyMatrix4(e)}let i=this.satBounds,a=this.satAxes,o=r[0];for(let e=0;e<3;e++){let t=a[e],n=i[e],s=r[1<<e];t.subVectors(o,s),n.setFromPoints(t,r)}let s=this.alignedSatBounds;s[0].setFromPointsField(r,`x`),s[1].setFromPointsField(r,`y`),s[2].setFromPointsField(r,`z`),this.invMatrix.copy(this.matrix).invert(),this.needsUpdate=!1}})(),Yr.prototype.intersectsBox=(function(){let e=/* @__PURE__ */ new Br;return function(t){this.needsUpdate&&this.update();let n=t.min,r=t.max,i=this.satBounds,a=this.satAxes,o=this.alignedSatBounds;if(e.min=n.x,e.max=r.x,o[0].isSeparated(e)||(e.min=n.y,e.max=r.y,o[1].isSeparated(e))||(e.min=n.z,e.max=r.z,o[2].isSeparated(e)))return!1;for(let n=0;n<3;n++){let r=a[n],o=i[n];if(e.setFromBox(r,t),o.isSeparated(e))return!1}return!0}})(),Yr.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new Jr,t=[,,,],n=/* @__PURE__ */ new Br,r=/* @__PURE__ */ new Br,i=/* @__PURE__ */ new I;return function(a){this.needsUpdate&&this.update(),a.isExtendedTriangle?a.needsUpdate&&a.update():(e.copy(a),e.update(),a=e);let o=this.satBounds,s=this.satAxes;t[0]=a.a,t[1]=a.b,t[2]=a.c;for(let e=0;e<3;e++){let r=o[e],i=s[e];if(n.setFromPoints(i,t),r.isSeparated(n))return!1}let c=a.satBounds,l=a.satAxes,u=this.points;for(let e=0;e<3;e++){let t=c[e],r=l[e];if(n.setFromPoints(r,u),t.isSeparated(n))return!1}for(let e=0;e<3;e++){let a=s[e];for(let e=0;e<4;e++){let o=l[e];if(i.crossVectors(a,o),n.setFromPoints(i,t),r.setFromPoints(i,u),n.isSeparated(r))return!1}}return!0}})(),Yr.prototype.closestPointToPoint=(function(){return function(e,t){return this.needsUpdate&&this.update(),t.copy(e).applyMatrix4(this.invMatrix).clamp(this.min,this.max).applyMatrix4(this.matrix),t}})(),Yr.prototype.distanceToPoint=(function(){let e=new I;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),Yr.prototype.distanceToBox=(function(){let e=[`x`,`y`,`z`],t=/* @__PURE__ */ Array(12).fill().map(()=>new Nn),n=/* @__PURE__ */ Array(12).fill().map(()=>new Nn),r=/* @__PURE__ */ new I,i=/* @__PURE__ */ new I;return function(a,o=0,s=null,c=null){if(this.needsUpdate&&this.update(),this.intersectsBox(a))return(s||c)&&(a.getCenter(i),this.closestPointToPoint(i,r),a.closestPointToPoint(r,i),s&&s.copy(r),c&&c.copy(i)),0;let l=o*o,u=a.min,d=a.max,f=this.points,p=1/0;for(let e=0;e<8;e++){let t=f[e];i.copy(t).clamp(u,d);let n=t.distanceToSquared(i);if(n<p&&(p=n,s&&s.copy(t),c&&c.copy(i),n<l))return Math.sqrt(n)}let m=0;for(let r=0;r<3;r++)for(let i=0;i<=1;i++)for(let a=0;a<=1;a++){let o=(r+1)%3,s=(r+2)%3,c=i<<o|a<<s,l=1<<r|i<<o|a<<s,p=f[c],h=f[l];t[m].set(p,h);let g=e[r],_=e[o],v=e[s],y=n[m],b=y.start,x=y.end;b[g]=u[g],b[_]=i?u[_]:d[_],b[v]=a?u[v]:d[_],x[g]=d[g],x[_]=i?u[_]:d[_],x[v]=a?u[v]:d[_],m++}for(let e=0;e<=1;e++)for(let t=0;t<=1;t++)for(let n=0;n<=1;n++){i.x=e?d.x:u.x,i.y=t?d.y:u.y,i.z=n?d.z:u.z,this.closestPointToPoint(i,r);let a=i.distanceToSquared(r);if(a<p&&(p=a,s&&s.copy(r),c&&c.copy(i),a<l))return Math.sqrt(a)}for(let e=0;e<12;e++){let a=t[e];for(let e=0;e<12;e++){let t=n[e];Hr(a,t,r,i);let o=r.distanceToSquared(i);if(o<p&&(p=o,s&&s.copy(r),c&&c.copy(i),o<l))return Math.sqrt(o)}}return Math.sqrt(p)}})();let Xr=/* @__PURE__ */ new class extends lr{constructor(){super(()=>new Jr)}},Zr=/* @__PURE__ */ new I,Qr=/* @__PURE__ */ new I;function $r(e,t,n={},r=0,i=1/0){let a=r*r,o=i*i,s=1/0,c=null;if(e.shapecast({boundsTraverseOrder:e=>(Zr.copy(t).clamp(e.min,e.max),Zr.distanceToSquared(t)),intersectsBounds:(e,t,n)=>n<s&&n<o,intersectsTriangle:(e,n)=>{e.closestPointToPoint(t,Zr);let r=t.distanceToSquared(Zr);return r<s&&(Qr.copy(Zr),s=r,c=n),r<a}}),s===1/0)return null;let l=Math.sqrt(s);return n.point?n.point.copy(Qr):n.point=Qr.clone(),n.distance=l,n.faceIndex=c,n}let ei=/* @__PURE__ */ new I,ti=/* @__PURE__ */ new I,ni=/* @__PURE__ */ new I,ri=/* @__PURE__ */ new F,ii=/* @__PURE__ */ new F,ai=/* @__PURE__ */ new F,oi=/* @__PURE__ */ new I,si=/* @__PURE__ */ new I,ci=/* @__PURE__ */ new I,li=/* @__PURE__ */ new I;function ui(e,t,n,r,i,a,o,s){let c;if(c=a===1?e.intersectTriangle(r,n,t,!0,i):e.intersectTriangle(t,n,r,a!==2,i),c===null)return null;let l=e.origin.distanceTo(i);return l<o||l>s?null:{distance:l,point:i.clone()}}function di(e,t,n,r,i,a,o,s,c,l,u){ei.fromBufferAttribute(t,a),ti.fromBufferAttribute(t,o),ni.fromBufferAttribute(t,s);let d=ui(e,ei,ti,ni,li,c,l,u);if(d){r&&(ri.fromBufferAttribute(r,a),ii.fromBufferAttribute(r,o),ai.fromBufferAttribute(r,s),d.uv=new F,ut.getInterpolation(li,ei,ti,ni,ri,ii,ai,d.uv)),i&&(ri.fromBufferAttribute(i,a),ii.fromBufferAttribute(i,o),ai.fromBufferAttribute(i,s),d.uv1=new F,ut.getInterpolation(li,ei,ti,ni,ri,ii,ai,d.uv1)),n&&(oi.fromBufferAttribute(n,a),si.fromBufferAttribute(n,o),ci.fromBufferAttribute(n,s),d.normal=new I,ut.getInterpolation(li,ei,ti,ni,oi,si,ci,d.normal),d.normal.dot(e.direction)>0&&d.normal.multiplyScalar(-1));let t={a,b:o,c:s,normal:new I,materialIndex:0};ut.getNormal(ei,ti,ni,t.normal),d.face=t,d.faceIndex=a;{let e=new I;ut.getBarycoord(li,ei,ti,ni,e),d.barycoord=e}}return d}function fi(e){return e&&e.isMaterial?e.side:e}function pi(e,t,n,r,i,a,o){let s=r*3,c=s+0,l=s+1,u=s+2,{index:d,groups:f}=e;e.index&&(c=d.getX(c),l=d.getX(l),u=d.getX(u));let{position:p,normal:m,uv:h,uv1:g}=e.attributes;if(Array.isArray(t)){let e=r*3;for(let s=0,d=f.length;s<d;s++){let{start:d,count:_,materialIndex:v}=f[s];if(e>=d&&e<d+_){let e=fi(t[v]),s=di(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=v,i)i.push(s);else return s}}}}else{let e=fi(t),s=di(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=0,i)i.push(s);else return s}}return null}function $(e,t,n,r){let i=e.a,a=e.b,o=e.c,s=t,c=t+1,l=t+2;n&&(s=n.getX(s),c=n.getX(c),l=n.getX(l)),i.x=r.getX(s),i.y=r.getY(s),i.z=r.getZ(s),a.x=r.getX(c),a.y=r.getY(c),a.z=r.getZ(c),o.x=r.getX(l),o.y=r.getY(l),o.z=r.getZ(l)}function mi(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,l=r+i;e<l;e++)pi(c,t,n,e,a,o,s)}function hi(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,c=r+i;e<c;e++){let r;r=pi(s,t,n,e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function gi(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let n=e,s=t+e;n<s;n++){let e;if(e=n,$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function _i(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(e,n,a=!1){let l=e*2;if(K(l,s)){let t=q(e,o),n=J(l,s),a=1/0,u=1/0,d=1/0,f=-1/0,p=-1/0,m=-1/0;for(let e=3*t,o=3*(t+n);e<o;e++){let t=r[e],n=i.getX(t),o=i.getY(t),s=i.getZ(t);n<a&&(a=n),n>f&&(f=n),o<u&&(u=o),o>p&&(p=o),s<d&&(d=s),s>m&&(m=s)}return c[e+0]!==a||c[e+1]!==u||c[e+2]!==d||c[e+3]!==f||c[e+4]!==p||c[e+5]!==m?(c[e+0]=a,c[e+1]=u,c[e+2]=d,c[e+3]=f,c[e+4]=p,c[e+5]=m,!0):!1}{let r=Y(e),i=X(e,o),s=a,l=!1,u=!1;if(t){if(!s){let e=r/8+n/32,a=i/8+n/32;l=t.has(e),u=t.has(a),s=!l&&!u}}else l=!0,u=!0;let f=s||l,p=s||u,m=!1;f&&(m=d(r,n,s));let h=!1;p&&(h=d(i,n,s));let g=m||h;if(g)for(let t=0;t<3;t++){let n=r+t,a=i+t,o=c[n],s=c[n+3],l=c[a],u=c[a+3];c[e+t]=o<l?o:l,c[e+t+3]=s>u?s:u}return g}}}function vi(e,t,n,r,i){let a,o,s,c,l,u,d=1/n.direction.x,f=1/n.direction.y,p=1/n.direction.z,m=n.origin.x,h=n.origin.y,g=n.origin.z,_=t[e],v=t[e+3],y=t[e+1],b=t[e+3+1],x=t[e+2],S=t[e+3+2];return d>=0?(a=(_-m)*d,o=(v-m)*d):(a=(v-m)*d,o=(_-m)*d),f>=0?(s=(y-h)*f,c=(b-h)*f):(s=(b-h)*f,c=(y-h)*f),a>c||s>o||((s>a||isNaN(a))&&(a=s),(c<o||isNaN(o))&&(o=c),p>=0?(l=(x-g)*p,u=(S-g)*p):(l=(S-g)*p,u=(x-g)*p),a>u||l>o)?!1:((l>a||a!==a)&&(a=l),(u<o||o!==o)&&(o=u),a<=i&&o>=r)}function yi(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,u=r+i;e<u;e++)pi(c,t,n,l?l[e]:e,a,o,s)}function bi(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,d=r+i;e<d;e++){let r;r=pi(s,t,n,c?c[e]:e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function xi(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let s=e,u=t+e;s<u;s++){let e;if(e=n.resolveTriangleIndex(s),$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function Si(e,t,n,r,i,a,o){Q.setBuffer(e._roots[t]),Ci(0,e,n,r,i,a,o),Q.clearBuffer()}function Ci(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Q,u=e*2;if(K(u,c))mi(t,n,r,q(e,l),J(u,c),i,a,o);else{let c=Y(e);vi(c,s,r,a,o)&&Ci(c,t,n,r,i,a,o);let u=X(e,l);vi(u,s,r,a,o)&&Ci(u,t,n,r,i,a,o)}}let wi=[`x`,`y`,`z`];function Ti(e,t,n,r,i,a){Q.setBuffer(e._roots[t]);let o=Ei(0,e,n,r,i,a);return Q.clearBuffer(),o}function Ei(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Q,l=e*2;if(K(l,s))return hi(t,n,r,q(e,c),J(l,s),i,a);{let s=Wn(e,c),l=wi[s],u=r.direction[l]>=0,d,f;u?(d=Y(e),f=X(e,c)):(d=X(e,c),f=Y(e));let p=vi(d,o,r,i,a)?Ei(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=vi(f,o,r,i,a)?Ei(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let Di=/* @__PURE__ */ new B,Oi=/* @__PURE__ */ new Jr,ki=/* @__PURE__ */ new Jr,Ai=/* @__PURE__ */ new R,ji=/* @__PURE__ */ new Yr,Mi=/* @__PURE__ */ new Yr;function Ni(e,t,n,r){Q.setBuffer(e._roots[t]);let i=Pi(0,e,n,r);return Q.clearBuffer(),i}function Pi(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Q,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),ji.set(n.boundingBox.min,n.boundingBox.max,r),i=ji),K(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=q(e,s),m=J(c,o);if(Ai.copy(r).invert(),n.boundsTree)return G(Z(e),a,Mi),Mi.matrix.copy(Ai),Mi.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>Mi.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let t=p*3,n=(m+p)*3;t<n;t+=3)if($(ki,t,l,u),ki.needsUpdate=!0,e.intersectsTriangle(ki))return!0;return!1}});{let e=Mr(n);for(let t=p*3,n=(m+p)*3;t<n;t+=3){$(Oi,t,l,u),Oi.a.applyMatrix4(Ai),Oi.b.applyMatrix4(Ai),Oi.c.applyMatrix4(Ai),Oi.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(ki,t,d,f),ki.needsUpdate=!0,Oi.intersectsTriangle(ki))return!0}}}else{let o=Y(e),c=X(e,s);return G(Z(o),a,Di),!!(i.intersectsBox(Di)&&Pi(o,t,n,r,i)||(G(Z(c),a,Di),i.intersectsBox(Di)&&Pi(c,t,n,r,i)))}}let Fi=/* @__PURE__ */ new R,Ii=/* @__PURE__ */ new Yr,Li=/* @__PURE__ */ new Yr,Ri=/* @__PURE__ */ new I,zi=/* @__PURE__ */ new I,Bi=/* @__PURE__ */ new I,Vi=/* @__PURE__ */ new I;function Hi(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),Ii.set(t.boundingBox.min,t.boundingBox.max,n),Ii.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=Xr.getPrimitive(),p=Xr.getPrimitive(),m=Ri,h=zi,g=null,_=null;i&&(g=Bi,_=Vi);let v=1/0,y=null,b=null;return Fi.copy(n).invert(),Li.matrix.copy(Fi),e.shapecast({boundsTraverseOrder:e=>Ii.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&(Li.min.copy(e.min),Li.max.copy(e.max),Li.needsUpdate=!0),!0),intersectsRange:(e,r)=>{if(t.boundsTree)return t.boundsTree.shapecast({boundsTraverseOrder:e=>Li.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,i)=>{for(let o=t,s=t+i;o<s;o++){$(p,3*o,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=e,n=e+r;t<n;t++){$(f,3*t,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=t,b=o),e<a)return!0}}}});{let i=Mr(t);for(let t=0,o=i;t<o;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=e,i=e+r;n<i;n++){$(f,3*n,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=n,b=t),e<a)return!0}}}}}),Xr.releasePrimitive(f),Xr.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(Fi),h.applyMatrix4(Fi),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function Ui(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(n,a,l=!1){let u=n*2;if(K(u,s)){let t=q(n,o),a=J(u,s),l=1/0,d=1/0,f=1/0,p=-1/0,m=-1/0,h=-1/0;for(let n=t,o=t+a;n<o;n++){let t=3*e.resolveTriangleIndex(n);for(let e=0;e<3;e++){let n=t+e;n=r?r[n]:n;let a=i.getX(n),o=i.getY(n),s=i.getZ(n);a<l&&(l=a),a>p&&(p=a),o<d&&(d=o),o>m&&(m=o),s<f&&(f=s),s>h&&(h=s)}}return c[n+0]!==l||c[n+1]!==d||c[n+2]!==f||c[n+3]!==p||c[n+4]!==m||c[n+5]!==h?(c[n+0]=l,c[n+1]=d,c[n+2]=f,c[n+3]=p,c[n+4]=m,c[n+5]=h,!0):!1}{let e=Y(n),r=X(n,o),i=l,s=!1,u=!1;if(t){if(!i){let n=e/8+a/32,o=r/8+a/32;s=t.has(n),u=t.has(o),i=!s&&!u}}else s=!0,u=!0;let f=i||s,p=i||u,m=!1;f&&(m=d(e,a,i));let h=!1;p&&(h=d(r,a,i));let g=m||h;if(g)for(let t=0;t<3;t++){let i=e+t,a=r+t,o=c[i],s=c[i+3],l=c[a],u=c[a+3];c[n+t]=o<l?o:l,c[n+t+3]=s>u?s:u}return g}}}function Wi(e,t,n,r,i,a,o){Q.setBuffer(e._roots[t]),Gi(0,e,n,r,i,a,o),Q.clearBuffer()}function Gi(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Q,u=e*2;if(K(u,c))yi(t,n,r,q(e,l),J(u,c),i,a,o);else{let c=Y(e);vi(c,s,r,a,o)&&Gi(c,t,n,r,i,a,o);let u=X(e,l);vi(u,s,r,a,o)&&Gi(u,t,n,r,i,a,o)}}let Ki=[`x`,`y`,`z`];function qi(e,t,n,r,i,a){Q.setBuffer(e._roots[t]);let o=Ji(0,e,n,r,i,a);return Q.clearBuffer(),o}function Ji(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Q,l=e*2;if(K(l,s))return bi(t,n,r,q(e,c),J(l,s),i,a);{let s=Wn(e,c),l=Ki[s],u=r.direction[l]>=0,d,f;u?(d=Y(e),f=X(e,c)):(d=X(e,c),f=Y(e));let p=vi(d,o,r,i,a)?Ji(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=vi(f,o,r,i,a)?Ji(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let Yi=/* @__PURE__ */ new B,Xi=/* @__PURE__ */ new Jr,Zi=/* @__PURE__ */ new Jr,Qi=/* @__PURE__ */ new R,$i=/* @__PURE__ */ new Yr,ea=/* @__PURE__ */ new Yr;function ta(e,t,n,r){Q.setBuffer(e._roots[t]);let i=na(0,e,n,r);return Q.clearBuffer(),i}function na(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Q,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),$i.set(n.boundingBox.min,n.boundingBox.max,r),i=$i),K(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=q(e,s),m=J(c,o);if(Qi.copy(r).invert(),n.boundsTree)return G(Z(e),a,ea),ea.matrix.copy(Qi),ea.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>ea.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let n=p,r=m+p;n<r;n++)if($(Zi,3*t.resolveTriangleIndex(n),l,u),Zi.needsUpdate=!0,e.intersectsTriangle(Zi))return!0;return!1}});{let e=Mr(n);for(let n=p,r=m+p;n<r;n++){let r=t.resolveTriangleIndex(n);$(Xi,3*r,l,u),Xi.a.applyMatrix4(Qi),Xi.b.applyMatrix4(Qi),Xi.c.applyMatrix4(Qi),Xi.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(Zi,t,d,f),Zi.needsUpdate=!0,Xi.intersectsTriangle(Zi))return!0}}}else{let o=Y(e),c=X(e,s);return G(Z(o),a,Yi),!!(i.intersectsBox(Yi)&&na(o,t,n,r,i)||(G(Z(c),a,Yi),i.intersectsBox(Yi)&&na(c,t,n,r,i)))}}let ra=/* @__PURE__ */ new R,ia=/* @__PURE__ */ new Yr,aa=/* @__PURE__ */ new Yr,oa=/* @__PURE__ */ new I,sa=/* @__PURE__ */ new I,ca=/* @__PURE__ */ new I,la=/* @__PURE__ */ new I;function ua(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),ia.set(t.boundingBox.min,t.boundingBox.max,n),ia.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=Xr.getPrimitive(),p=Xr.getPrimitive(),m=oa,h=sa,g=null,_=null;i&&(g=ca,_=la);let v=1/0,y=null,b=null;return ra.copy(n).invert(),aa.matrix.copy(ra),e.shapecast({boundsTraverseOrder:e=>ia.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&(aa.min.copy(e.min),aa.max.copy(e.max),aa.needsUpdate=!0),!0),intersectsRange:(r,i)=>{if(t.boundsTree){let s=t.boundsTree;return s.shapecast({boundsTraverseOrder:e=>aa.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,o)=>{for(let x=t,S=t+o;x<S;x++){let t=s.resolveTriangleIndex(x);$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=r,n=r+i;t<n;t++){let n=e.resolveTriangleIndex(t);$(f,3*n,l,c),f.needsUpdate=!0;let r=f.distanceToTriangle(p,m,g);if(r<v&&(h.copy(m),_&&_.copy(g),v=r,y=t,b=x),r<a)return!0}}}})}{let o=Mr(t);for(let t=0,s=o;t<s;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=r,o=r+i;n<o;n++){let r=e.resolveTriangleIndex(n);$(f,3*r,l,c),f.needsUpdate=!0;let i=f.distanceToTriangle(p,m,g);if(i<v&&(h.copy(m),_&&_.copy(g),v=i,y=n,b=t),i<a)return!0}}}}}),Xr.releasePrimitive(f),Xr.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(ra),h.applyMatrix4(ra),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function da(e,t,n){return e===null?null:(e.point.applyMatrix4(t.matrixWorld),e.distance=e.point.distanceTo(n.ray.origin),e.object=t,e)}let fa=/* @__PURE__ */ new Yr,pa=/* @__PURE__ */ new Yt,ma=/* @__PURE__ */ new I,ha=/* @__PURE__ */ new R,ga=/* @__PURE__ */ new I,_a=[`getX`,`getY`,`getZ`];var va=class e extends zr{static serialize(e,t={}){t={cloneBuffers:!0,...t};let n=e.geometry,r=e._roots,i=e._indirectBuffer,a=n.getIndex(),o={version:1,roots:null,index:null,indirectBuffer:null};return t.cloneBuffers?(o.roots=r.map(e=>e.slice()),o.index=a?a.array.slice():null,o.indirectBuffer=i?i.slice():null):(o.roots=r,o.index=a?a.array:null,o.indirectBuffer=i),o}static deserialize(t,n,r={}){r={setIndex:!0,indirect:!!t.indirectBuffer,...r};let{index:i,roots:a,indirectBuffer:o}=t;t.version||(console.warn(`MeshBVH.deserialize: Serialization format has been changed and will be fixed up. It is recommended to regenerate any stored serialized data.`),c(a));let s=new e(n,{...r,[Ln]:!0});if(s._roots=a,s._indirectBuffer=o||null,r.setIndex){let e=n.getIndex();if(e===null){let e=new H(t.index,1,!1);n.setIndex(e)}else e.array!==i&&(e.array.set(i),e.needsUpdate=!0)}return s;function c(e){for(let t=0;t<e.length;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n);for(let e=0,t=n.byteLength/32;e<t;e++){let t=8*e;K(2*t,i)||(r[t+6]=r[t+6]/8-e)}}}}get primitiveStride(){return 3}get resolveTriangleIndex(){return this.resolvePrimitiveIndex}constructor(e,t={}){t.maxLeafTris&&(console.warn(`MeshBVH: \"maxLeafTris\" option has been deprecated. Use \"targetLeafSize\", instead.`),t={...t,targetLeafSize:t.maxLeafTris}),super(e,t)}shiftTriangleOffsets(e){return super.shiftPrimitiveOffsets(e)}writePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=(i?i[e]:e)*3,c=s+0,l=s+1,u=s+2;o&&(c=o[c],l=o[l],u=o[u]);for(let e=0;e<3;e++){let r=a[_a[e]](c),i=a[_a[e]](l),o=a[_a[e]](u),s=r;i<s&&(s=i),o<s&&(s=o);let d=r;i>d&&(d=i),o>d&&(d=o),t[n+e]=s,t[n+e+3]=d}return t}computePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=a.normalized;if(e<0||t+e-n.offset>n.length/6)throw Error(`MeshBVH: compute triangle bounds range is invalid.`);let c=a.array,l=a.offset||0,u=3;a.isInterleavedBufferAttribute&&(u=a.data.stride);let d=[`getX`,`getY`,`getZ`],f=n.offset;for(let r=e,p=e+t;r<p;r++){let e=(i?i[r]:r)*3,t=(r-f)*6,p=e+0,m=e+1,h=e+2;o&&(p=o[p],m=o[m],h=o[h]),s||(p=p*u+l,m=m*u+l,h=h*u+l);for(let e=0;e<3;e++){let r,i,o;s?(r=a[d[e]](p),i=a[d[e]](m),o=a[d[e]](h)):(r=c[p+e],i=c[m+e],o=c[h+e]);let l=r;i<l&&(l=i),o<l&&(l=o);let u=r;i>u&&(u=i),o>u&&(u=o);let f=(u-l)/2,g=e*2;n[t+g+0]=l+f,n[t+g+1]=f+(Math.abs(l)+f)*In}}return n}raycastObject3D(e,t,n=[]){let{material:r}=e;if(r===void 0)return;ha.copy(e.matrixWorld).invert(),pa.copy(t.ray).applyMatrix4(ha),ga.setFromMatrixScale(e.matrixWorld),ma.copy(pa.direction).multiply(ga);let i=ma.length(),a=t.near/i,o=t.far/i;if(t.firstHitOnly===!0){let i=this.raycastFirst(pa,r,a,o);i=da(i,e,t),i&&n.push(i)}else{let i=this.raycast(pa,r,a,o);for(let r=0,a=i.length;r<a;r++){let a=da(i[r],e,t);a&&n.push(a)}}return n}refit(e=null){return(this.indirect?Ui:_i)(this,e)}raycast(e,t=0,n=0,r=1/0){let i=this._roots,a=[],o=this.indirect?Wi:Si;for(let s=0,c=i.length;s<c;s++)o(this,s,t,e,a,n,r);return a}raycastFirst(e,t=0,n=0,r=1/0){let i=this._roots,a=null,o=this.indirect?qi:Ti;for(let s=0,c=i.length;s<c;s++){let i=o(this,s,t,e,n,r);i!=null&&(a==null||i.distance<a.distance)&&(a=i)}return a}intersectsGeometry(e,t){let n=!1,r=this._roots,i=this.indirect?ta:Ni;for(let a=0,o=r.length;a<o&&(n=i(this,a,e,t),!n);a++);return n}shapecast(e){let t=Xr.getPrimitive(),n=super.shapecast({...e,intersectsPrimitive:e.intersectsTriangle,scratchPrimitive:t,iterate:this.indirect?xi:gi});return Xr.releasePrimitive(t),n}bvhcast(t,n,r){let{intersectsRanges:i,intersectsTriangles:a}=r,o=Xr.getPrimitive(),s=this.geometry.index,c=this.geometry.attributes.position,l=this.indirect?e=>{let t=this.resolveTriangleIndex(e);$(o,t*3,s,c)}:e=>{$(o,e*3,s,c)},u=Xr.getPrimitive(),d=t.geometry.index,f=t.geometry.attributes.position,p=t.indirect?e=>{let n=t.resolveTriangleIndex(e);$(u,n*3,d,f)}:e=>{$(u,e*3,d,f)};if(a){if(!(t instanceof e))throw Error(`MeshBVH: \"intersectsTriangles\" callback can only be used with another MeshBVH.`);let r=(e,t,r,i,s,c,d,f)=>{for(let m=r,h=r+i;m<h;m++){p(m),u.a.applyMatrix4(n),u.b.applyMatrix4(n),u.c.applyMatrix4(n),u.needsUpdate=!0;for(let n=e,r=e+t;n<r;n++)if(l(n),o.needsUpdate=!0,a(o,u,n,m,s,c,d,f))return!0}return!1};if(i){let e=i;i=function(t,n,i,a,o,s,c,l){return e(t,n,i,a,o,s,c,l)?!0:r(t,n,i,a,o,s,c,l)}}else i=r}return super.bvhcast(t,n,{intersectsRanges:i})}intersectsBox(e,t){return fa.set(e.min,e.max,t),fa.needsUpdate=!0,this.shapecast({intersectsBounds:e=>fa.intersectsBox(e),intersectsTriangle:e=>fa.intersectsTriangle(e)})}intersectsSphere(e){return this.shapecast({intersectsBounds:t=>e.intersectsBox(t),intersectsTriangle:t=>t.intersectsSphere(e)})}closestPointToGeometry(e,t,n={},r={},i=0,a=1/0){return(this.indirect?ua:Hi)(this,e,t,n,r,i,a)}closestPointToPoint(e,t={},n=0,r=1/0){return $r(this,e,t,n,r)}};function ya(e){return e.toArray()}function ba(e,t){return t.fromArray(e)}function xa(e){return{min:ya(e.min),max:ya(e.max)}}function Sa(e,t){return ba(e.min,t.min),ba(e.max,t.max),t}function Ca(e){return{radius:e.radius,center:ya(e.center)}}function wa(e,t){return t.radius=e.radius,ba(e.center,t.center),t}let Ta=`batchId`,Ea=/* @__PURE__ */ new B,Da=/* @__PURE__ */ new R,Oa=/* @__PURE__ */ new R,ka=/* @__PURE__ */ new Nt,Aa=(/* @__PURE__ */{start:-1,count:-1}),ja=(/* @__PURE__ */{start:-1,count:-1}),Ma=(/* @__PURE__ */{start:-1,count:-1});var Na=class e extends Bt{constructor(e={}){super(),this.isBatchedGeometry=!0,this.boundingBox=new B,this.boundingSphere=new Nt,this._vertexStart=0,this._indexStart=0,this._isInitialized=!1,this.needBoundingBoxUpdate=!1,this._freeGeometryIds=/* @__PURE__ */ new Set,this._maxGeometryCount=e.maxGeometryCount??1e4,this._maxVertexCount=e.maxVertexCount??1e6,this._maxIndexCount=e.maxIndexCount??1e6,this._useIndex=e.useIndex??!1,this._useNormals=e.useNormals??!1,this._geometryCount=0;let t=e.buffers??{};this._bounds=t.bounds??new Float32Array(new SharedArrayBuffer(this._maxGeometryCount*6*4)),this._indexRanges=t.indexRanges??new Uint32Array(new SharedArrayBuffer(this._useIndex?this._maxGeometryCount*2*4:0)),this._vertexRanges=t.vertexRanges??new Uint32Array(new SharedArrayBuffer(this._maxGeometryCount*2*4)),this._matricesTexture=this._initMatrixTexture(t.matrices)}static serialize(e){return{attributes:{index:e.index?e.index.array:null,position:e.hasAttribute(`position`)?e.getAttribute(`position`).array:null,normal:e.hasAttribute(`normal`)?e.getAttribute(`normal`).array:null,batchId:e.hasAttribute(Ta)?e.getAttribute(Ta).array:null},uuid:e.uuid,vertexStart:e._vertexStart,indexStart:e._indexStart,isInitialized:e._isInitialized,matrices:e._matricesTexture.image.data,geometryCount:e._geometryCount,useIndex:e._useIndex,useNormals:e._useNormals,bounds:e._bounds,indexRanges:e._indexRanges,vertexRanges:e._vertexRanges,maxVertexCount:e._maxVertexCount,maxIndexCount:e._maxIndexCount,maxGeometryCount:e._maxGeometryCount,boundingBox:xa(e.boundingBox),boundingSphere:Ca(e.boundingSphere)}}static deserialize(t){let n=new e({maxGeometryCount:t.maxGeometryCount,useIndex:t.useIndex,useNormals:t.useNormals,maxVertexCount:t.maxVertexCount,maxIndexCount:t.maxIndexCount,buffers:{matrices:t.matrices,vertexRanges:t.vertexRanges,indexRanges:t.indexRanges,bounds:t.bounds}});return e._setupGeometryAfterDeserialization(n,t),n}static _setupGeometryAfterDeserialization(e,t){e.uuid=t.uuid,e._vertexStart=t.vertexStart,e._indexStart=t.indexStart,e._geometryCount=t.geometryCount,e._isInitialized=t.isInitialized;let{position:n,batchId:r,normal:i,index:a}=t.attributes;a&&e.setIndex(new H(a,1)),n&&e.setAttribute(`position`,new H(n,3)),r&&e.setAttribute(Ta,new H(r,1)),i&&e.setAttribute(`normal`,new H(i,3)),Sa(t.boundingBox,e.boundingBox),wa(t.boundingSphere,e.boundingSphere)}get geometryCount(){return this._geometryCount}get maxGeometryCount(){return this._maxGeometryCount}getIndexFillRate(){return this.index?this._indexStart/this.index.count:-1}getVertexFillRate(){return this._vertexStart/this.getAttribute(`position`).count}initialize(){if(this._isInitialized)throw Error(`BatchedBufferGeometry is already initialized. Please dispose first.`);let e;e=12*this._maxVertexCount;let t=new H(new Float32Array(new SharedArrayBuffer(e)),3);if(t.setUsage(g),this.setAttribute(`position`,t),this._useNormals){e=12*this._maxVertexCount;let t=new H(new Float32Array(new SharedArrayBuffer(e)),3);t.setUsage(g),this.setAttribute(`normal`,t)}let n;if(this._useIndex){this._maxVertexCount>=65536?(e=this._maxIndexCount*4,n=new Uint32Array(new SharedArrayBuffer(e))):(e=this._maxIndexCount*2,n=new Uint16Array(new SharedArrayBuffer(e)));let t=new H(n,1);t.setUsage(g),this.setIndex(t)}this._maxGeometryCount>=65536?(e=this._maxVertexCount*4,n=new Uint32Array(new SharedArrayBuffer(e))):(e=this._maxVertexCount*2,n=new Uint16Array(new SharedArrayBuffer(e)));let r=new H(n,1);r.setUsage(g),this.setAttribute(Ta,r),this._isInitialized=!0}get stats(){return{vertexFillRate:this._vertexStart/this._maxVertexCount,indexFilRate:this._indexStart/this._maxIndexCount}}_checkVertexCountFits(e){let t=this.getAttribute(`position`);return!(this._vertexStart+e>t.count)}_checkIndexCountFits(e){let t=this.index;return!(t&&this._indexStart+e>t.count)}_checkGeometryInsertion(e,t){if(this._isInitialized||this.initialize(),t>=this._maxGeometryCount)throw Error(`Maximum geometry count reached`);for(let t in e.attributes)if(e.getAttribute(t).isInterleavedBufferAttribute)throw Error(`InterleavedBufferAttribute are not supported (attr=${t})`);let n=e.attributes.position;if(!n)throw Error(`Added geometry has no position attribute`);if(!this._checkVertexCountFits(n.count))throw Error(`Not enough place in position buffer for given geometry`);let r=e.index;if(this._useIndex){if(!r)throw Error(`Added geometry has no index attribute`);if(!this._checkIndexCountFits(r.count))throw Error(`Not enough place in index buffer for given geometry`)}let i=e.getAttribute(`normal`);if(this._useNormals&&!i)throw Error(`Added geometry has no normal attribute`)}canInsertGeometry(e){let t=this._freeGeometryIds.values().next().value;t&&this._freeGeometryIds.delete(t),t??=this._geometryCount;try{return this._checkGeometryInsertion(e,t),!0}catch{return!1}}addGeometry(e){let t=this._freeGeometryIds.values().next().value,n=!1;t===void 0?(n=!0,t=this._geometryCount):this._freeGeometryIds.delete(t),this._checkGeometryInsertion(e,t);let r={start:-1,count:-1},i={start:-1,count:-1},a=e.index;if(this._useIndex&&this.index){let e=this.index;for(let t=0;t<a.count;t++)e.setX(this._indexStart+t,a.getX(t)+this._vertexStart);e.needsUpdate=!0,r.start=this._indexStart,r.count=a.count,this._indexStart+=a.count}let o=[`position`];this._useNormals&&o.push(`normal`);for(let t of o)Pa(e.getAttribute(t),this.getAttribute(t),this._vertexStart);let s=e.getAttribute(`position`);i.start=this._vertexStart,i.count=s.count;let c=this.getAttribute(Ta);for(let e=0;e<s.count;e++)c.setX(this._vertexStart+e,t);return c.needsUpdate=!0,e.boundingBox||e.computeBoundingBox(),this._setLocalBoundingBoxAt(t,e.boundingBox),this._setVertexRange(t,i),this.index&&this._setIndexRange(t,r),n&&this._geometryCount++,this._vertexStart+=s.count,this.setMatrixAt(t,Oa),this.needBoundingBoxUpdate=!0,t}removeGeometry(e){let t=this.getVertexRangeAt(e,Aa);if(this._useIndex&&this.index){let n=this.getIndexRangeAt(e,ja),r=this.index;for(let e=n.start;e<r.count;e++){let i=r.getX(e+n.count);i>0&&(i-=t.count),r.setX(e,i)}this._indexStart-=n.count,r.needsUpdate=!0}let n=[`position`];this._useNormals&&n.push(`normal`);for(let e of n){let n=this.getAttribute(e);n.clearUpdateRanges();for(let e=t.start;e<n.count-t.count;e++)for(let r=0;r<n.itemSize;r++){let i=n.getComponent(e+t.count,r);n.setComponent(e,r,i)}n.needsUpdate=!0}this._vertexStart-=t.count;let r=this.getAttribute(Ta);for(let e=t.start;e<r.count;e++){let n=r.getX(e+t.count);r.setX(e,n)}r.needsUpdate=!0;for(let e=0;e<this._vertexRanges.length;e+=2){let n=this._vertexRanges[e];n>=t.start+t.count&&(this._vertexRanges[e]=n-t.count)}if(this.index){let t=this.getIndexRangeAt(e,ja);for(let e=0;e<this._indexRanges.length;e+=2){let n=this._indexRanges[e];n>=t.start+t.count&&(this._indexRanges[e]=n-t.count)}}this._freeGeometryIds.add(e),this.needBoundingBoxUpdate=!0}getDrawRangeAt(e,t){return this.index?this.getIndexRangeAt(e,t):this.getVertexRangeAt(e,t)}getVertexRangeAt(e,t){if(e>=this._geometryCount)throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);let n=e*2;return t.start=this._vertexRanges[n],t.count=this._vertexRanges[n+1],t}getIndexRangeAt(e,t){if(e>=this._geometryCount)throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);let n=e*2;return t.start=this._indexRanges[n],t.count=this._indexRanges[n+1],t}computeBoundingSphere(){let e=this._geometryCount,t=this.boundingSphere;t.makeEmpty();for(let n=0;n<e;n++)this._freeGeometryIds.has(n)||(this.getWorldBoundingSphereAt(n,ka),t.union(ka))}getLocalBoundingBoxAt(e,t){if(e>=this._geometryCount)throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);let n=e*6,r=this._bounds;return t.min.set(r[n],r[n+1],r[n+2]),t.max.set(r[n+3],r[n+4],r[n+5]),t}getLocalBoundingSphereAt(e,t){return this.getLocalBoundingBoxAt(e,Ea),Ea.getBoundingSphere(t),t}getWorldBoundingBoxAt(e,t){return this.getMatrixAt(e,Da),this.getLocalBoundingBoxAt(e,t).applyMatrix4(Da)}getWorldBoundingSphereAt(e,t){return this.getMatrixAt(e,Da),this.getLocalBoundingSphereAt(e,t).applyMatrix4(Da)}setMatrixAt(e,t){if(e>this._geometryCount)throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);let n=this._matricesTexture.image.data;return t.toArray(n,e*16),this._matricesTexture.needsUpdate=!0,this.needBoundingBoxUpdate=!0,t}getMatrixAt(e,t){if(e>this._geometryCount)throw RangeError(`geometryId is out of bounds ${e}/${this._geometryCount}`);let n=this._matricesTexture.image.data;return t.fromArray(n,e*16),t}setPositionAt(e,t){return this.getMatrixAt(e,Da),Da.setPosition(t),this.setMatrixAt(e,Da),t}getPositionAt(e,t){return t.setFromMatrixPosition(this.getMatrixAt(e,Da))}getGeometryAt(e,t){this.getDrawRangeAt(e,Ma);let n=Ma.start,r=Ma.start+Ma.count;return this.index?(t.setIndex(new H(this.index.array.subarray(n,r),1)),t.setAttribute(`position`,this.attributes.position),this._useNormals&&t.setAttribute(`normal`,this.attributes.normal)):(n=Ma.start*3,r=(Ma.start+Ma.count)*3,t.setIndex(null),t.setAttribute(`position`,new H(this.attributes.position.array.subarray(n,r),3)),this._useNormals&&t.setAttribute(`normal`,new H(this.attributes.normal.array.subarray(n,r),3))),t}copyGeometryAt(e,t){this.getIndexRangeAt(e,ja),this.getVertexRangeAt(e,Aa);let n=Aa.start*3,r=(Aa.start+Aa.count)*3;if(this.index){let e;e=ja.count>=65536?new Uint32Array(ja.count):new Uint16Array(ja.count);let n=new H(e,1);for(let e=ja.start;e<ja.start+ja.count;e++)n.setX(e-ja.start,this.index.array[e]-Aa.start);t.setIndex(n)}else t.setIndex(null);return t.setAttribute(`position`,new H(this.attributes.position.array.subarray(n,r),3)),this._useNormals&&t.setAttribute(`normal`,new H(this.attributes.normal.array.subarray(n,r),3)),t}dispose(){this._matricesTexture.dispose(),super.dispose(),this._isInitialized=!1}toUpdate(){return this.needBoundingBoxUpdate&&(this.computeBoundingBox(),this.computeBoundingSphere()),{vertexStart:this._vertexStart,indexStart:this._indexStart,geometryCount:this._geometryCount,boundingBox:xa(this.boundingBox),boundingSphere:Ca(this.boundingSphere)}}applyUpdate(e){this._vertexStart=e.vertexStart,this._indexStart=e.indexStart,this._geometryCount=e.geometryCount,Sa(e.boundingBox,this.boundingBox),wa(e.boundingSphere,this.boundingSphere),this.index&&(this.index.needsUpdate=!0),this._matricesTexture.needsUpdate=!0;let t=this.getAttribute(`position`);t.needsUpdate=!0;let n=this.getAttribute(Ta);n.needsUpdate=!0;let r=this.getAttribute(`normal`);r&&(r.needsUpdate=!0)}_initMatrixTexture(e){let t=Math.sqrt(this._maxGeometryCount*4);t=Math.ceil(t/4)*4,t=Math.max(t,4),e??=new Float32Array(new SharedArrayBuffer(t*t*4*4));let n=new Xt(e,t,t,a,i);return n.needsUpdate=!0,n}_setLocalBoundingBoxAt(e,t){let n=e*6;this._bounds[n]=t.min.x,this._bounds[n+1]=t.min.y,this._bounds[n+2]=t.min.z,this._bounds[n+3]=t.max.x,this._bounds[n+4]=t.max.y,this._bounds[n+5]=t.max.z}_setIndexRange(e,t){let n=e*2;this._indexRanges[n]=t.start,this._indexRanges[n+1]=t.count}_setVertexRange(e,t){let n=e*2;this._vertexRanges[n]=t.start,this._vertexRanges[n+1]=t.count}};function Pa(e,t,n=0){let r=t.itemSize,i=e.count;if(e.isInterleavedBufferAttribute||e.array.constructor!==t.array.constructor)for(let a=0;a<i;a++)for(let i=0;i<r;i++)t.setComponent(a+n,i,e.getComponent(a,i));else t.array.set(e.array,n*r);t.addUpdateRange(n*r,i*r),t.needsUpdate=!0}let Fa=/* @__PURE__ */ new I,Ia=/* @__PURE__ */ new I;var La=class e extends Na{constructor(...e){super(...e),this.isBatchedLineGeometry=!0}addGeometry(e){if(e.index)throw Error(`Line geometries should not be indexed. Convert it first.`);return super.addGeometry(e)}static deserialize(t){let n=new e({maxGeometryCount:t.maxGeometryCount,useIndex:t.useIndex,useNormals:t.useNormals,maxVertexCount:t.maxVertexCount,maxIndexCount:t.maxIndexCount,buffers:{matrices:t.matrices,vertexRanges:t.vertexRanges,indexRanges:t.indexRanges,bounds:t.bounds}});return Na._setupGeometryAfterDeserialization(n,t),n}static serialize(e){return{isBatchedLineGeometry:!0,...Na.serialize(e)}}computeLineDistanceAttribute(){if(this.index===null){let e=this.attributes.position,t=[0];for(let n=1,r=e.count;n<r;n++)Fa.fromBufferAttribute(e,n-1),Ia.fromBufferAttribute(e,n),t[n]=t[n-1],t[n]+=Fa.distanceTo(Ia);this.setAttribute(`lineDistance`,new kt(t,1))}else console.warn(`THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.`);return this}};function Ra(e){return new H(e.array,e.itemSize)}function za(e,t){e.index&&t.setIndex(Ra(e.index));for(let n of e.attributes)t.setAttribute(n.name,Ra(n));t.setDrawRange(e.drawRange.start,e.drawRange.count),t.uuid=e.uuid}var Ba=class{static{this._time=0}static{this._times=/* @__PURE__ */ new Map}static startTime(e){return this._time=performance.now(),e&&this._times.set(e,this._time),this._time}static tickTime(e){let t=performance.now(),n=this._time;if(e){let t=this._times.get(e);if(t!==void 0)n=t;else throw Error(`Unknown timer id`)}return t-n}static endTime(e){let t=performance.now(),n=this._time;if(this._time=t,e){let r=this._times.get(e);if(r!==void 0)n=r,this._times.set(e,t);else throw Error(`Unknown timer id`)}return t-n}static timeStr(e){return`${e.toFixed(1)} ms`}},Va=class{constructor(){this.meshCount=0,this.lineCount=0,this.geometryCount=0,this.maxObjectPerGeometry=0,this.deserializationTime=0,this.bvhComputationTime=0,this.normalComputationTime=0,this.edgesComputationTime=0,this.objectsNeedingNormalsUpdate=0,this.geometryInitializationTime=0,this.lineBatchingTime=0,this.meshBatchingTime=0,this.edgesBatchingTime=0}get totalTime(){return this.meshBatchingTime+this.deserializationTime+this.geometryInitializationTime+this.edgesBatchingTime+this.bvhComputationTime+this.edgesComputationTime+this.lineBatchingTime}};let Ha=1e4,Ua=new R;onmessage=e=>{let t=e.data;t.type===`BatchGeometries`&&Wa(t)};function Wa(e){let{context:t}=e,n={edgesMinAngle:70,updateCountThreshold:1e3,...e.options};t.type===`LineBatchingContext`?Ga(t,n):t.type===`MeshBatchingContext`?Ka(t,n):console.error(`Unknown batching context type`)}function Ga(e,t){let n=new Va;Ba.startTime();let{vertexCount:r,lines:i}=e,{updateCountThreshold:a}=t,o=[],s=[];for(let[e,t]of i){let n=new Bt;za(e,n),o.push(n),s.push(t)}n.deserializationTime=Ba.endTime();let c=new La({maxGeometryCount:Ha,useIndex:!1,useNormals:!1,maxVertexCount:r});c.initialize(),n.geometryInitializationTime=Ba.endTime(),Ya(c);let l=[],u=0;for(let e=0;e<o.length;e++){let t=s[e],r=o[e];n.maxObjectPerGeometry=Math.max(n.maxObjectPerGeometry,t.length);for(let e of t){Ua.fromArray(e.matrixWorld),Ba.startTime();let t=c.addGeometry(r);c.setMatrixAt(t,Ua),n.meshBatchingTime+=Ba.endTime(),l.push({isSerializedBatchedLineProxy:!0,parentUuid:e.parentUuid,line:{proxyId:t,batchedGeometryUuid:c.uuid,srcGeometryUuid:r.uuid,material:e.material},uuid:e.uuid,name:e.name,userData:e.userData,geometryType:e.geometryType}),u+=1,u%a===0&&(Xa(c,l),l.splice(0,l.length))}}Xa(c,l),n.lineCount=u,n.geometryCount=o.length,Za(n)}function Ka(e,t){let n=new Va;Ba.startTime();let{vertexCount:r,indexCount:i,meshes:a}=e,{edgesMinAngle:o,updateCountThreshold:s}=t,c=[],l=[],u=[],d=0;for(let[e,t]of a){let n=new Bt;za(e,n),c.push(n),u.push(t)}n.deserializationTime=Ba.endTime();for(let e of c)e.hasAttribute(`normal`)||(e.computeVertexNormals(),n.objectsNeedingNormalsUpdate+=1);n.normalComputationTime=Ba.endTime();for(let e=0;e<c.length;e++){let t=c[e],n=u[e],r=new tn(t,o);l.push(r),d+=r.attributes.position.count*n.length}n.edgesComputationTime=Ba.endTime();let f=[];for(let e of c){let t=new va(e,{useSharedArrayBuffer:!0}),n=va.serialize(t,{cloneBuffers:!1});f.push(n)}n.bvhComputationTime=Ba.endTime();let p=new Na({maxGeometryCount:Ha,useIndex:!0,useNormals:!0,maxVertexCount:r,maxIndexCount:i});p.initialize();let m=new La({maxGeometryCount:Ha,useIndex:!1,useNormals:!1,maxVertexCount:d});m.initialize(),n.geometryInitializationTime=Ba.endTime(),Ja(p,m);let h=[],g=0;for(let e=0;e<c.length;e++){let t=u[e],r=c[e],i=l[e],a=f[e];n.maxObjectPerGeometry=Math.max(n.maxObjectPerGeometry,t.length);for(let e of t){Ua.fromArray(e.matrixWorld),Ba.startTime();let t=p.addGeometry(r);p.setMatrixAt(t,Ua),n.meshBatchingTime+=Ba.endTime();let o=m.addGeometry(i);m.setMatrixAt(o,Ua),n.edgesBatchingTime+=Ba.endTime(),h.push({isSerializedBatchedMeshProxy:!0,parentUuid:e.parentUuid,mesh:{proxyId:t,batchedGeometryUuid:p.uuid,srcGeometryUuid:r.uuid,material:e.material,serializedBVH:a},edges:{proxyId:o,batchedGeometryUuid:m.uuid,srcGeometryUuid:i.uuid},uuid:e.uuid,name:e.name,userData:e.userData,isInMeshGroup:e.isInMeshGroup,geometryType:e.geometryType}),g+=1,g%s===0&&(qa(p,m,h),h.splice(0,h.length))}}qa(p,m,h),n.meshCount=g,n.geometryCount=c.length,Za(n)}function qa(e,t,n){let r=e.toUpdate(),i=t.toUpdate(),a={type:`BatchedMeshProxyTransfer`,meshes:n,batchedGeometryUuid:e.uuid,batchedEdgesGeometryUuid:t.uuid,meshGeometryUpdate:r,edgesGeometryUpdate:i};self.postMessage(a)}function Ja(e,t){let n={type:`BatchedMeshGeometryTransfer`,sMeshBatchedGeometry:Na.serialize(e),sEdgesBatchedGeometry:La.serialize(t)};self.postMessage(n)}function Ya(e){let t={type:`BatchedLineGeometryTransfer`,sBatchedLineGeometry:La.serialize(e)};self.postMessage(t)}function Xa(e,t){let n={type:`BatchedLineProxyTransfer`,lineGeometryUpdate:e.toUpdate(),lines:t,batchedLineGeometryUuid:e.uuid};self.postMessage(n)}function Za(e){postMessage({type:`BatchingFinished`,metrics:e})}})();\n//# sourceMappingURL=GeometryBatchingWorker-Ugrn4JgC.js.map", D = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", $t], { type: "text/javascript;charset=utf-8" });
function O(e) {
	let t;
	try {
		if (t = D && (self.URL || self.webkitURL).createObjectURL(D), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent($t), { name: e?.name });
	}
}
//#endregion
//#region src/io/controllers/GeometryBatchingWorkerController.ts
var en = class {
	constructor(e) {
		this._viewer = e, this._batchGeometryMap = /* @__PURE__ */ new Map(), this.onMeshBatchedGeometryLoaded = () => {}, this.onMeshBatchedGeometryProxyLoaded = () => {}, this.onLineBatchedGeometryLoaded = () => {}, this.onLineBatchedGeometryProxyLoaded = () => {}, this.onWorkerFinishedBatching = () => {}, this._onMessage = async (e, t) => {
			let n = e.data;
			switch (n.type) {
				case "BatchedMeshGeometryTransfer":
					this._onBatchedMeshGeometryTransferMessage(n, t);
					break;
				case "BatchedLineGeometryTransfer":
					this._onBatchedLineGeometryTransferMessage(n, t);
					break;
				case "BatchedLineProxyTransfer":
					this._onBatchedLineProxyTransferMessage(n, t);
					break;
				case "BatchedMeshProxyTransfer":
					this._onBatchedMeshProxyTransferMessage(n, t);
					break;
				case "BatchingFinished": this._onBatchingFinishedMessage(n, t);
			}
		}, this.controller = new _t(O, "GeometryBatchingWorker", this._viewer.settings.loading.batchingWorkersCount.value), this.controller.onmessage = this._onMessage, this._setupSignals();
	}
	_setupSignals() {
		this._viewer.settings.loading.batchingWorkersCount.onChange.connect((e) => this.controller.maxWorkers = e);
	}
	batchGeometries(e) {
		let t = this.controller.nextFreeWorker();
		if (t === null) throw Error("No available worker for batching");
		this._sendBatchingMessage(e, t);
	}
	clear() {
		this._batchGeometryMap.clear();
	}
	_sendBatchingMessage(e, t) {
		let n = {
			type: "BatchGeometries",
			context: e,
			options: {
				edgesMinAngle: this._viewer.settings.loading.edgeGeometryMinAngle.value,
				updateCountThreshold: this._viewer.settings.loading.batchingMeshCountUpdateThreshold.value
			}
		}, r = [];
		if (e.type === "LineBatchingContext") for (let t of e.lines.keys()) Qt(t, r);
		else if (e.type === "MeshBatchingContext") for (let t of e.meshes.keys()) Qt(t, r);
		this.controller.lockWorker(t), this.controller.postMessageWithId(t, n);
	}
	_onBatchedMeshGeometryTransferMessage(e, t) {
		let { sMeshBatchedGeometry: n, sEdgesBatchedGeometry: r } = e, i = Jt.deserialize(n), a = E.deserialize(r);
		if (this._batchGeometryMap.has(a.uuid)) throw Error("BatchedLineGeometry is already transfered");
		if (this._batchGeometryMap.has(i.uuid)) throw Error("BatchedMeshGeometry is already transfered");
		this._batchGeometryMap.set(a.uuid, a), this._batchGeometryMap.set(i.uuid, i), this.onMeshBatchedGeometryLoaded(i, a);
	}
	_onBatchedMeshProxyTransferMessage(e, t) {
		let { meshes: n, batchedGeometryUuid: r, batchedEdgesGeometryUuid: i, meshGeometryUpdate: a, edgesGeometryUpdate: o } = e, s = this._batchGeometryMap.get(r);
		if (!s) throw Error(`Cannot find batched geometry with uuid ${r}`);
		s.applyUpdate(a);
		let c = this._batchGeometryMap.get(i);
		if (!c) throw Error(`Cannot find batched line geometry with uuid ${i}`);
		c.applyUpdate(o);
		for (let e of n) this.onMeshBatchedGeometryProxyLoaded(e);
	}
	_onBatchedLineGeometryTransferMessage(e, t) {
		let { sBatchedLineGeometry: n } = e, r = E.deserialize(n);
		if (this._batchGeometryMap.has(r.uuid)) throw Error("BatchedLineGeometry is already transfered");
		this._batchGeometryMap.set(r.uuid, r), this.onLineBatchedGeometryLoaded(r);
	}
	_onBatchedLineProxyTransferMessage(e, t) {
		let { lines: n, lineGeometryUpdate: r, batchedLineGeometryUuid: i } = e, a = this._batchGeometryMap.get(i);
		if (!a) throw Error(`Cannot find batched line geometry with uuid ${i}`);
		a.applyUpdate(r);
		for (let e of n) this.onLineBatchedGeometryProxyLoaded(e);
	}
	_onBatchingFinishedMessage(e, t) {
		let { metrics: n } = e;
		this.controller.freeWorker(t), this.onWorkerFinishedBatching(n);
	}
}, tn = class {
	constructor(e) {
		this._requestsCount = 0, this._handledRequests = 0, this._lastProgressNotification = 0, this._requestsStack = [], this._clock = new d(), this._status = "finished", this._loadId = 0, this._preparationAbortController = null, this._loadingCompletion = Promise.resolve(), this._resolveLoadingCompletion = null, this._objectInsertionQueue = /* @__PURE__ */ new Map(), this._handledObjectUuids = /* @__PURE__ */ new Set(), this.start = () => {
			if (this.isRunning) return C.warn("Viewer is already loading."), this._loadingCompletion;
			this._loadingCompletion = new Promise((e) => {
				this._resolveLoadingCompletion = e;
			}), this._handledRequests = 0, this._lastProgressNotification = 0, this._fileController.controller.reset(), this._batchingController.controller.reset(), this._objectInsertionQueue.clear(), this._handledObjectUuids.clear(), this._clock.start();
			let e = ++this._loadId, t = this._importController, n = new AbortController();
			return this._preparationAbortController = n, this._status = "started", this._notifyProgress(), setTimeout(async () => {
				if (e === this._loadId) {
					this._status = "preparing", this._notifyProgress();
					try {
						await t.prepare(n.signal);
					} catch (t) {
						if (e === this._loadId) {
							C.error("Failed to prepare scene loading", t), this.stop();
							return;
						}
					} finally {
						this._preparationAbortController === n && (this._preparationAbortController = null);
					}
					if (e !== this._loadId) {
						t.clean();
						return;
					}
					for (let e of t.getInitialObjects()) this._createBimMesh(e);
					this._status = "loading", this._notifyProgress(), this._processFileRequests();
				}
			}, 50), this._loadingCompletion;
		}, this.stop = () => {
			this._clock.running && (this._loadId += 1, this._preparationAbortController?.abort(), this._preparationAbortController = null, this._requestsStack.clear(), this._store.clear(), this._fileController.controller.terminateWorkers(), this._batchingController.controller.terminateWorkers(), this._status = "stopped", this._notifyProgress());
		}, this._onFileLoaded = (e) => {
			let { metrics: t, objects: n, meshesMap: r, linesMap: i } = e;
			this._handledRequests += 1, this._viewer.stats.loading.push(t);
			for (let e of n) {
				try {
					this._importController.updateObject(e);
				} catch {
					C.error(`Object ignored ${e.uuid}`);
					continue;
				}
				this._importController.shouldKeepObject(e, this._handledObjectUuids) && this._createBimMesh(e);
			}
			for (let [e, t] of r) {
				let n = [];
				for (let e of t) {
					try {
						this._importController.updateObject(e);
					} catch {
						C.error(`Object ignored ${e.uuid}`);
						continue;
					}
					this._importController.shouldKeepObject(e, this._handledObjectUuids) && (this._createBimMesh(e), n.push(e));
				}
				this._store.addMeshes(e, n);
			}
			for (let [e, t] of i) {
				let n = [];
				for (let e of t) {
					try {
						this._importController.updateObject(e);
					} catch {
						C.error(`Object ignored ${e.uuid}`);
						continue;
					}
					this._importController.shouldKeepObject(e, this._handledObjectUuids) && (this._createBimMesh(e), n.push(e));
				}
				this._store.addLines(e, n);
			}
			this._notifyProgress(), this._processMeshStore(), this._processFileRequests();
		}, this._onFileFailed = (e) => {
			let { metrics: t } = e;
			this._handledRequests += 1, this._viewer.stats.loading.push(t), this._notifyProgress(), this._processFileRequests();
		}, this._onMeshBatchedGeometryLoaded = (e, t) => {
			this._viewer.scene.bimMeshController.addBatchedMeshContainer(e), this._viewer.scene.bimMeshController.addBatchedEdgesContainer(t);
		}, this._onMeshBatchedGeometryProxyLoaded = (e) => {
			let t = this._viewer.scene.bimMeshController.getObjectByUUID(e.uuid);
			if (!t) {
				console.error(`Cannot find mesh for uuid ${e.uuid}`);
				return;
			}
			let n = this._viewer.scene.bimMeshController.createMeshProxy(e);
			this._viewer.scene.bimMeshController.addSubMesh(t, n, e.geometryType);
		}, this._onLineBatchedGeometryLoaded = (e) => {
			this._viewer.scene.bimMeshController.addBatchedLineContainer(e);
		}, this._onLineBatchedGeometryProxyLoaded = (e) => {
			let t = this._viewer.scene.bimMeshController.getObjectByUUID(e.uuid);
			if (!t) {
				console.error(`Cannot find line for uuid ${e.uuid}`);
				return;
			}
			let n = this._viewer.scene.bimMeshController.createLineProxy(e);
			this._viewer.scene.bimMeshController.addSubMesh(t, n, e.geometryType);
		}, this._onWorkerFinishedBatching = (e) => {
			this._viewer.stats.batching.push(e), this._notifyProgress(), this._processMeshStore();
		}, this._viewer = e, this._store = new Dt({
			maxBatchingProxyCount: e.settings.loading.maxBatchingProxyCount.value,
			maxBatchingIndexCount: e.settings.loading.maxBatchingIndexCount.value,
			maxBatchingVertexCount: e.settings.loading.maxBatchingVertexCount.value
		}), this._importController = new St(e), this._fileController = new Nt(e), this._fileController.onFileLoaded = this._onFileLoaded, this._fileController.onFileFailed = this._onFileFailed, this._batchingController = new en(e), this._batchingController.onMeshBatchedGeometryLoaded = this._onMeshBatchedGeometryLoaded, this._batchingController.onMeshBatchedGeometryProxyLoaded = this._onMeshBatchedGeometryProxyLoaded, this._batchingController.onLineBatchedGeometryLoaded = this._onLineBatchedGeometryLoaded, this._batchingController.onLineBatchedGeometryProxyLoaded = this._onLineBatchedGeometryProxyLoaded, this._batchingController.onWorkerFinishedBatching = this._onWorkerFinishedBatching, this._setupSignals();
	}
	_setupSignals() {
		let e = this._viewer.settings.loading;
		e.maxBatchingIndexCount.onChange.connect((e) => this._store.maxBatchingIndexCount = e), e.maxBatchingProxyCount.onChange.connect((e) => this._store.maxBatchingProxyCount = e), e.maxBatchingVertexCount.onChange.connect((e) => this._store.maxBatchingVertexCount = e);
	}
	setObjectImportController(e) {
		this._importController = e;
	}
	addFileRequest(e) {
		this._requestsCount += 1, this._requestsStack.push(e);
	}
	_processFileRequests() {
		let e;
		do
			if (e = !1, this._fileController.controller.hasFreeWorkers()) {
				let t = this._requestsStack.shift();
				t && (this._fileController.loadFile(t), e = !0);
			}
		while (e);
		this._requestsStack.length === 0 && this._notifyProgress();
	}
	get isRunning() {
		return this._clock.running;
	}
	dispose() {
		this._loadId += 1, this._preparationAbortController?.abort(), this._preparationAbortController = null, this._clock.stop(), this._requestsStack.clear(), this._store.clear(), this._objectInsertionQueue.clear(), this._handledObjectUuids.clear(), this._fileController.controller.terminateWorkers(), this._batchingController.controller.terminateWorkers(), this._batchingController.clear(), this._importController.clean(), this._status = "stopped";
	}
	_processMeshStore() {
		let e = this._handledRequests === this._requestsCount, t;
		do
			if (t = !1, this._batchingController.controller.hasFreeWorkers()) {
				let n = this._store.nextBatchingContext(e);
				n && (this._batchingController.batchGeometries(n), t = !0);
			}
		while (t);
	}
	_computeLoadingState() {
		let e = this._batchingController.controller.areAllWorkersFree(), t = this._store.isEmpty, n = 1;
		this._requestsCount > 0 && (n = this._handledRequests / this._requestsCount), (!e || !t || n !== 1) && (n = Math.min(n, .99));
		let r = this._status === "loading" && n === 1 ? "finished" : this._status;
		return {
			progress: n,
			status: r
		};
	}
	_notifyProgress() {
		if (!this.isRunning) return;
		let { progress: e, status: t } = this._computeLoadingState();
		this._status = t;
		let n = Math.floor(e * 100), r = {
			elapsedTime: this._clock.getElapsedTime(),
			progress: e,
			status: this._status
		};
		switch (this._status) {
			case "started":
				this._viewer.signals.onLoadingStarted.emit(r);
				break;
			case "finished":
			case "stopped":
				this._finishLoading(), this._viewer.signals.onLoadingFinished.emit(r);
				break;
			case "preparing":
				this._viewer.signals.onLoadingProgress.emit(r);
				break;
			default: n > this._lastProgressNotification && this._viewer.signals.onLoadingProgress.emit(r);
		}
		this._viewer.requestRender(), this._lastProgressNotification = n;
	}
	_finishLoading() {
		this._status === "finished" && this._objectInsertionQueue.size > 0 && C.error(`${this._objectInsertionQueue.size} objects were not added in the scene`), this._batchingController.clear(), this._importController.clean(), this._requestsCount = 0, this._clock.stop(), this._resolveLoadingCompletion?.(), this._resolveLoadingCompletion = null;
	}
	_createBimMesh(e) {
		let t = this._viewer.scene.bimMeshController;
		if (t.hasObjectUUID(e.uuid)) return;
		let n = t.createMesh(e);
		return this._insertObjectIntoScene(n, e.parentUuid), n;
	}
	_insertObjectIntoScene(e, t) {
		if (this._handledObjectUuids.add(e.uuid), t === null || this._viewer.scene.hasObjectUUID(t)) this._viewer.scene.addObject(e, t), this._insertObjectChildrenIntoScene(e.uuid);
		else if (this._addObjectToInsertionQueue(e, t), !this._handledObjectUuids.has(t)) {
			let e = this._importController.getObject(t);
			if (e) {
				let t = this._viewer.scene.bimMeshController.createMesh(e);
				this._insertObjectIntoScene(t, e.parentUuid);
			}
		}
	}
	_insertObjectChildrenIntoScene(e) {
		let t = this._objectInsertionQueue.get(e);
		if (t) {
			this._objectInsertionQueue.delete(e);
			for (let n of t) this._viewer.scene.addObject(n, e), this._insertObjectChildrenIntoScene(n.uuid);
		}
	}
	_addObjectToInsertionQueue(e, t) {
		let n = this._objectInsertionQueue.get(t);
		n || (n = /* @__PURE__ */ new Set(), this._objectInsertionQueue.set(t, n)), n.add(e);
	}
}, nn = class extends Error {
	constructor(e) {
		super(`React context ${e} not found`);
	}
}, rn = class extends Error {
	constructor(e) {
		super(`Plugin ${e} is not registered`);
	}
}, an = class extends Error {
	constructor(e) {
		super(`Command ${e.name} has not been executed.`);
	}
}, on = class extends Error {
	constructor(e) {
		super(`Command ${e.name} is not updatable.`);
	}
}, k = class extends Error {
	constructor(e) {
		super(`Command ${e.name} is not undoable.`);
	}
}, A = class {
	constructor(e) {
		this.viewer = e, this.isUpdatable = !1, this._hasBeenExecuted = !1, this._addUndoToHistory = !0;
	}
	get commandHistory() {
		return this.viewer.commandHistory;
	}
	get hasBeenExecuted() {
		return this._hasBeenExecuted;
	}
	async execute(e = {}) {
		let { addToUndoHistory: t = !0, requestRender: n = !0 } = e;
		if (this._hasBeenExecuted) throw Error(`Command "${this.name}" has already been executed.`);
		let r = await this._do();
		return this._hasBeenExecuted = !0, this._addUndoToHistory = t, this.isUndoable && t && this.commandHistory._pushToUndoHistory(this), n && this.viewer.requestRender(), r;
	}
	async undo(e = {}) {
		let { addToRedoHistory: t = !0, requestRender: n = !0 } = e;
		if (!this._hasBeenExecuted) throw Error(`Command "${this.name}" has not been executed.`);
		if (!this.isUndoable) throw new k(this);
		await this._undo(), this._hasBeenExecuted = !1, n && this.viewer.requestRender(), this._addUndoToHistory && this.commandHistory._removeFromUndoHistory(this, t);
	}
	async toggle(e = {}) {
		if (!this.isUndoable) return this.execute(e);
		let t = this.commandHistory.lastCommand, n;
		return t?.name === this.name && t.equals(this) && this.commandHistory.canUndo ? (n = this.commandHistory.undoLastCommand(e), this._hasBeenExecuted = !0) : n = this.execute(e), n;
	}
	async _clean() {}
	equals(e) {
		return C.warn(`method equals not implemented for command ${e.name}`), !1;
	}
	async update(...e) {
		if (!this.isUpdatable) throw new on(this);
		if (!this._hasBeenExecuted) throw new an(this);
		this.viewer.requestRender();
	}
}, j = class extends A {
	constructor(e, t = {}) {
		super(e), this.name = "CenterCameraOnSceneCommand", this.isUndoable = !1, this.radiusFactor = t.radiusFactor ?? 1.7, this.duration = t.duration;
	}
	async _do() {
		this.viewer.viewport && this.viewer.viewport.cameraControls.resetCamera(this.radiusFactor, this.duration);
	}
	async _undo() {
		throw new k(this);
	}
}, sn = class extends yt {
	constructor(...e) {
		super(...e), this.name = "CenterSceneBehavior", this.userMovedCameraSinceLoading = !1, this.loadingConnections = [], this.settingConnection = null, this._connect = () => {
			this.loadingConnections.length > 0 || this.loadingConnections.push(this._viewer.signals.onLoadingStarted.connect(this._onLoadingStarted), this._viewer.signals.onLoadingProgress.connect(this._onLoadingProgress), this._viewer.signals.onLoadingFinished.connect(this._onLoadingFinished), this._viewer.signals.onUserCameraMove.connect(this._onUserCameraMove));
		}, this._disconnect = () => {
			for (let e of this.loadingConnections) e.disconnect();
			this.loadingConnections = [];
		}, this._onLoadingStarted = () => {
			this.userMovedCameraSinceLoading = !1;
		}, this._onLoadingProgress = () => {
			this.userMovedCameraSinceLoading || new j(this._viewer).execute();
		}, this._onLoadingFinished = () => {
			this.userMovedCameraSinceLoading || new j(this._viewer).execute();
		}, this._onUserCameraMove = () => {
			this.userMovedCameraSinceLoading = !0;
		};
	}
	setup(e) {
		this._viewer = e, e.settings.loading.centerSceneOnLoading.value && this._connect(), this.settingConnection = e.settings.loading.centerSceneOnLoading.onChange.connect((e) => {
			e ? this._connect() : this._disconnect();
		});
	}
	dispose() {
		this._disconnect(), this.settingConnection?.disconnect(), this.settingConnection = null;
	}
}, cn = /* @__PURE__ */ new b(), ln = class extends yt {
	constructor(...e) {
		super(...e), this.name = "ResizeClippingPlanesBehavior", this.onLoadingFinished = () => {
			this._viewer.scene.getBoxTreeBoundingSphere(cn), cn.radius <= 0 && (cn.radius = 1);
			let e = cn.radius * 2, t = this._viewer.scene.clippingPlaneController.getAllObjects();
			for (let n of t) n.mesh.scale.set(e, e, e), n.mesh.position.set(cn.center.x, cn.center.y, cn.center.z);
		};
	}
	setup(e) {
		this._viewer = e, this._viewer.signals.onLoadingFinished.connect(this.onLoadingFinished);
	}
	dispose() {
		this._viewer.signals.onLoadingFinished.disconnect(this.onLoadingFinished);
	}
};
//#endregion
//#region src/scene/geometry/batching/material/BatchedMaterialMixin.ts
function un(e) {
	class t extends e {
		constructor(...e) {
			let [t, n] = e, { useXray: r, useMaterialColor: i, xrayOpacity: a, ...o } = n ?? {};
			super(o), this.isBatchedMaterial = !0, this.uniformsNeedUpdate = !1, this.propertiesTexture = t, this.xrayOpacity = a ?? .5, this.useMaterialColor = i ?? !1, this.useXray = r ?? !1;
		}
		onBeforeCompile(e) {
			this.uniforms = e.uniforms, e.batching = !0, e.defines = {
				USE_MATERIAL_COLOR: this.useMaterialColor,
				USE_XRAY: this.useXray
			}, e.uniforms.propertiesTexture = { value: this.propertiesTexture }, e.uniforms.xrayOpacity = { value: this.xrayOpacity }, e.vertexShader = e.vertexShader.replace("#include <color_pars_vertex>", ""), e.vertexShader = e.vertexShader.replace("#include <color_vertex>", ""), e.vertexShader = e.vertexShader.replace("#include <batching_pars_vertex>", "\n\n        attribute float batchId;\n        varying float vBatchId;\n        uniform highp sampler2D batchingTexture;\n        \n        \n        mat4 getBatchingMatrix( const in float i ) {\n          int size = textureSize( batchingTexture, 0 ).x;\n          int j = int(i) * 4;\n          int x = j % size;\n          int y = j / size;\n          vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n          vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n          vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n          vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n          return mat4( v1, v2, v3, v4 );\n        }\n\n      "), e.vertexShader = e.vertexShader.replace("#include <batching_vertex>", "\n        mat4 batchingMatrix = getBatchingMatrix( batchId );\n      "), e.vertexShader = e.vertexShader.replace("void main() {", "\n        void main() {\n          vBatchId = batchId + .5;\n      "), e.fragmentShader = e.fragmentShader.replace("void main() {", `
        uniform highp sampler2D propertiesTexture;
        uniform float xrayOpacity;

        varying float vBatchId;
        void main() {

          // Save the original diffuse color
          vec3 materialDiffuse = diffuse;

          ${this.propertiesTexture.getGlsl()}
      `), e.fragmentShader = e.fragmentShader.replace("vec4 diffuseColor = vec4( diffuse", "\n        #ifdef USE_MATERIAL_COLOR\n          diffuse = materialDiffuse;\n        #endif\n\n        #ifdef USE_XRAY\n          opacity *= xrayOpacity;\n        #endif\n\n        vec4 diffuseColor = vec4( diffuse\n      ");
		}
		customProgramCacheKey() {
			return super.customProgramCacheKey() + `propertiesTexture=${this.propertiesTexture.id}useMaterialColor=${this.useMaterialColor}useXray=${this.useXray}`;
		}
		onBeforeRender() {
			this.uniforms && this.uniformsNeedUpdate && (this.uniforms.xrayOpacity.value = this.xrayOpacity, this.uniformsNeedUpdate = !1);
		}
	}
	return t;
}
//#endregion
//#region src/scene/geometry/batching/material/BatchedMaterial.ts
var M = class extends un(ve) {
	constructor(e, t = {}) {
		super(e, t);
	}
}, dn = class extends un(le) {
	constructor(e, t = {}) {
		super(e, t);
	}
}, fn = class extends un(ue) {
	constructor(e, t = {}) {
		super(e, t);
	}
	onBeforeCompile(e) {
		e.vertexShader = e.vertexShader.replace("void main() {", "\n        #include <batching_pars_vertex>\n\n        void main() {\n\n        #include <batching_vertex>\n      "), super.onBeforeCompile(e);
	}
}, pn = /* @__PURE__ */ function(e) {
	return e[e.Base = 0] = "Base", e[e.SelectedObject = 1] = "SelectedObject", e[e.ObjectOverlay = 2] = "ObjectOverlay", e[e.ObjectOverlayHover = 3] = "ObjectOverlayHover", e[e.AlwaysVisible = 4] = "AlwaysVisible", e[e.Tool = 5] = "Tool", e;
}({}), mn = [
	0,
	1,
	2,
	3,
	4,
	5
], N = /* @__PURE__ */ function(e) {
	return e.Opaque = "Opaque", e.Hover = "Hover", e.XRay = "XRay", e.XRaySelected = "XRaySelected", e.Transparent = "Transparent", e.SelectedOpaque = "SelectedOpaque", e.SelectedTransparent = "SelectedTransparent", e.SelectedXRay = "SelectedXRay", e;
}({}), hn = class {
	constructor(e) {
		this._viewer = e;
	}
	getBatchedMeshOpaqueMaterial(e, t = {}) {
		let n = this._viewer.settings;
		return {
			material: new M(e, {
				name: "BatchedMeshOpaqueMaterial",
				flatShading: n.objects.flatShading.value,
				side: n.objects.doubleSide.value ? h : v,
				polygonOffset: !0,
				polygonOffsetUnits: 1,
				polygonOffsetFactor: 1,
				depthWrite: !0,
				...t
			}),
			type: "Opaque",
			layer: 0
		};
	}
	getBatchedMeshOpaqueMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedMeshOpaqueMaterial(e, {
			name: "BatchedMeshOpaqueMaterial-selected",
			color: n.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return {
			material: r,
			type: "SelectedOpaque",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedMeshTransparentMaterial(e, t = {}) {
		let n = this._viewer.settings;
		return {
			material: new M(e, {
				name: "BatchedMeshTransparentMaterial",
				transparent: !0,
				side: n.objects.doubleSide.value ? h : v,
				flatShading: n.objects.flatShading.value,
				polygonOffset: !0,
				polygonOffsetUnits: 1.2,
				polygonOffsetFactor: 1.2,
				depthWrite: !1,
				...t
			}),
			type: "Transparent",
			layer: 0
		};
	}
	getBatchedMeshTransparentMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedMeshTransparentMaterial(e, {
			name: "BatchedMeshTransparentMaterial-selected",
			color: n.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return r.name += "-selected", {
			material: r,
			type: "SelectedTransparent",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedMeshXRayMaterial(e, t = {}) {
		let n = this._viewer.settings;
		return {
			material: new M(e, {
				name: "BatchedMeshXRayMaterial",
				transparent: !0,
				side: n.objects.doubleSide.value ? h : v,
				flatShading: n.objects.flatShading.value,
				polygonOffset: !0,
				polygonOffsetUnits: 1.2,
				polygonOffsetFactor: 1.2,
				depthWrite: !1,
				useXray: !0,
				xrayOpacity: n.objects.xRayOpacity.value,
				...t
			}),
			type: "XRay",
			layer: 0
		};
	}
	getBatchedMeshXRayMaterial_Selected(e, t = {}) {
		let { material: n } = this.getBatchedMeshXRayMaterial(e, {
			name: "BatchedMeshXRayMaterial-selected",
			color: this._viewer.settings.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return {
			material: n,
			type: "SelectedXRay",
			layer: 0
		};
	}
	getBatchedEdgesOpaqueMaterial(e, t = {}) {
		return {
			material: new fn(e, {
				name: "BatchedEdgesOpaqueMaterial",
				depthWrite: !0,
				depthTest: !0,
				gapSize: 0,
				dashSize: 1,
				...t
			}),
			type: "Opaque",
			layer: 0
		};
	}
	getBatchedEdgesOpaqueMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedEdgesOpaqueMaterial(e, {
			name: "BatchedEdgesOpaqueMaterial-selected",
			color: 16777215,
			useMaterialColor: !0,
			...t
		});
		return {
			material: r,
			type: "SelectedOpaque",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedEdgesTransparentMaterial(e, t = {}) {
		return {
			material: new fn(e, {
				name: "BatchedEdgesTransparentMaterial",
				depthWrite: !1,
				transparent: !0,
				gapSize: 0,
				dashSize: 1,
				...t
			}),
			type: "Transparent",
			layer: 0
		};
	}
	getBatchedEdgesTransparentMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedEdgesTransparentMaterial(e, {
			name: "BatchedEdgesTransparentMaterial-selected",
			color: 16777215,
			useMaterialColor: !0,
			...t
		});
		return r.name += "-selected", {
			material: r,
			type: "SelectedTransparent",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedEdgesXRayMaterial(e, t = {}) {
		let n = this._viewer.settings;
		return {
			material: new fn(e, {
				name: "BatchedEdgesXRayMaterial",
				depthWrite: !1,
				transparent: !0,
				gapSize: 0,
				dashSize: 1,
				useXray: !0,
				xrayOpacity: n.objects.xRayOpacity.value,
				...t
			}),
			type: "XRay",
			layer: 0
		};
	}
	getBatchedEdgesXRayMaterial_Selected(e, t = {}) {
		let { material: n } = this.getBatchedEdgesXRayMaterial(e, {
			name: "BatchedEdgesXRayMaterial-selected",
			color: 16777215,
			useMaterialColor: !0,
			...t
		});
		return n.name += "-selected", {
			material: n,
			type: "SelectedXRay",
			layer: 0
		};
	}
	getBatchedLineOpaqueMaterial(e, t = {}) {
		return {
			material: new fn(e, {
				name: "BatchedLineOpaqueMaterial",
				depthWrite: !0,
				gapSize: 0,
				dashSize: 1,
				...t
			}),
			type: "Opaque",
			layer: 0
		};
	}
	getBatchedLineOpaqueMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedLineOpaqueMaterial(e, {
			name: "BatchedLineOpaqueMaterial-selected",
			color: n.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return {
			material: r,
			type: "SelectedOpaque",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedLineTransparentMaterial(e, t = {}) {
		return {
			material: new fn(e, {
				name: "BatchedLineTransparentMaterial",
				depthWrite: !1,
				transparent: !0,
				gapSize: 0,
				dashSize: 1,
				...t
			}),
			type: "Transparent",
			layer: 0
		};
	}
	getBatchedLineTransparentMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedLineTransparentMaterial(e, {
			name: "BatchedLineTransparentMaterial-selected",
			color: n.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return r.name += "-selected", {
			material: r,
			type: "SelectedTransparent",
			layer: n.objects.selectionLayer.value
		};
	}
	getBatchedLineXRayMaterial(e, t = {}) {
		let n = this._viewer.settings;
		return {
			material: new fn(e, {
				name: "BatchedLineXRayMaterial",
				depthWrite: !1,
				transparent: !0,
				gapSize: 0,
				dashSize: 1,
				useXray: !0,
				xrayOpacity: n.objects.xRayOpacity.value,
				...t
			}),
			type: "XRay",
			layer: 0
		};
	}
	getBatchedLineXRayMaterial_Selected(e, t = {}) {
		let n = this._viewer.settings, { material: r } = this.getBatchedLineXRayMaterial(e, {
			name: "BatchedLineXRayMaterial-selected",
			color: n.objects.highlightColor.value,
			useMaterialColor: !0,
			...t
		});
		return r.name += "-selected", {
			material: r,
			type: "SelectedXRay",
			layer: 0
		};
	}
}, gn = (e, t) => t, _n = class {
	constructor(e, t = {}) {
		this.isValueController = !0, this.onChange = new w(), this._validateFunc = t.validate ?? gn, this.saveToLocalStorage = t.saveToLocalStorage ?? !0, this.showInDevTools = t.showInDevTools ?? !0, this.canReset = t.canReset ?? !0, this._defaultValue = e, this._value = this._validateFunc(e, e), this.tag = t.tag ?? "";
	}
	set value(e) {
		this._value = this._validateFunc(this._value, e), this.onChange.emit(this._value);
	}
	get value() {
		return this._value;
	}
	get defaultValue() {
		return this._defaultValue;
	}
	reset() {
		this.canReset && (this.value = this._defaultValue);
	}
}, P = class extends _n {
	constructor(...e) {
		super(...e), this.isBooleanController = !0;
	}
}, vn = class extends _n {
	constructor(...e) {
		super(...e), this.isColorController = !0;
	}
}, F = class extends _n {
	constructor(e = 0, t = {}) {
		super(e, t), this.isNumberController = !0, this.min = t.min ?? e, this.max = t.max ?? e, this.step = t.step ?? 1, this._checkMinMax(), this._checkValueInRange(e);
	}
	_checkMinMax() {
		if (this.max < this.min) throw RangeError(`Provided max value ${this.max} is inferior to min value ${this.min}.`);
	}
	_checkValueInRange(e) {
		(e < this.min || e > this.max) && (this.value = this.min, console.error(`Value ${e} is out of range [${this.min}, ${this.max}]. Defaults to min.`));
	}
	get value() {
		return super.value;
	}
	set value(e) {
		this._checkValueInRange(e), super.value = e;
	}
}, yn = class extends _n {
	constructor(e, t, n = {}) {
		super(e, n), this.options = t, this.isSelectController = !0;
	}
	get value() {
		return super.value;
	}
	set value(e) {
		this.options.includes(e) ? super.value = e : console.warn(`Value is not in the options ${this.options}`);
	}
}, bn = class extends _n {
	constructor(...e) {
		super(...e), this.isStringController = !0;
	}
}, xn = navigator.hardwareConcurrency, I = () => ({
	backupName: new bn("Default", {
		saveToLocalStorage: !1,
		showInDevTools: !1,
		canReset: !1
	}),
	doubleClickDelay: new F(250, {
		min: 100,
		max: 500
	}),
	debug: new P(!1),
	dev: {
		verbose: new P(!1, {}),
		drawDebug: new P(!1),
		showInfoTools: new P(!1),
		showDevTools: new P(!1)
	},
	loading: {
		loadingWorkersCount: new F(xn, {
			min: 1,
			max: xn,
			step: 1
		}),
		batchingWorkersCount: new F(xn, {
			min: 1,
			max: xn,
			step: 1
		}),
		maxBatchingProxyCount: new F(3e3, {
			min: 500,
			max: 7e3,
			step: 100
		}),
		maxBatchingVertexCount: new F(1e7, {
			min: 1e6,
			max: 1e7,
			step: 1e6
		}),
		maxBatchingIndexCount: new F(1e7, {
			min: 1e6,
			max: 1e7,
			step: 1e6
		}),
		edgeGeometryMinAngle: new F(60, {
			min: 0,
			max: 90,
			step: 1
		}),
		batchingMeshCountUpdateThreshold: new F(1e3, {
			min: 100,
			max: 2e3,
			step: 100
		}),
		centerSceneOnLoading: new P(!0)
	},
	scene: {
		backgroundColor: new vn("#7090d0"),
		showOriginAxisHelper: new P(!1),
		showSceneAxisHelper: new P(!1),
		showGrid: new P(!1),
		gridSize: new F(100, {
			min: 10,
			max: 1e3
		}),
		axesSize: new F(10, {
			min: 1,
			max: 1e3
		})
	},
	raycast: { marginError: new F(.1, {
		min: .01,
		max: 1,
		step: .01
	}) },
	snapping: { snappingEdgesThreshold: new F(.5, {
		min: .01,
		max: 1,
		step: .01
	}) },
	objects: {
		highlightColor: new vn("#fabd38"),
		flatShading: new P(!0),
		doubleSide: new P(!0),
		defaultEdgesColor: new vn("#aaaaaa"),
		xRayOpacity: new F(.3, {
			min: .01,
			max: .99,
			step: .01
		}),
		pivotPoint: new yn("Center", [
			"Center",
			"Min",
			"Max"
		]),
		selectionLayer: new yn(pn.SelectedObject, [pn.Base, pn.SelectedObject])
	},
	sprites: {
		altasSlotSize: new yn(256, [
			64,
			128,
			256,
			512,
			1024
		]),
		maxAtlasSize: new yn(2048, [
			1024,
			2048,
			4096,
			8192
		]),
		maxSpriteCount: new F(1e3, {
			min: 100,
			max: 1e4,
			step: 1
		}),
		frustumCulling: new P(!1)
	},
	lights: {
		cameraLightIntensity: new F(1, {
			min: 0,
			max: 10,
			step: .1
		}),
		envMapIntensity: new F(.5, {
			min: 0,
			max: 2,
			step: .1
		}),
		hemisphereLightIntensity: new F(.3, {
			min: 0,
			max: 10,
			step: .1
		}),
		directionalLightIntensity: new F(.3, {
			min: 0,
			max: 10,
			step: .1
		}),
		skyAzimuth: new F(45, {
			min: 0,
			max: 360,
			step: 1
		}),
		skyElevation: new F(45, {
			min: 0,
			max: 360,
			step: 1
		}),
		skyIsVisible: new P(!1),
		skyMieCoefficient: new F(.076, {
			min: 0,
			max: .1,
			step: .001
		}),
		skyMieDirectionalG: new F(.95, {
			min: 0,
			max: 1,
			step: .01
		}),
		skyRayleigh: new F(1.1, {
			min: 0,
			max: 4,
			step: .1
		}),
		skyTurbidity: new F(2.7, {
			min: 0,
			max: 20,
			step: .1
		})
	},
	ao: {
		enableAO: new P(!0),
		enableAA: new P(!0),
		enableMSAA: new P(!0),
		msaaSamples: new F(4, {
			min: 0,
			max: 8,
			step: 1
		}),
		quality: new yn("High", [
			"Performance",
			"Low",
			"Medium",
			"High",
			"Ultra"
		]),
		aoRadius: new F(.5, {
			min: .1,
			max: 10,
			step: .1
		}),
		distanceFalloff: new F(.5, {
			min: .1,
			max: 10,
			step: .1
		}),
		intensity: new F(5, {
			min: 1,
			max: 100,
			step: 1
		}),
		halfRes: new P(!1),
		depthAwareUpsampling: new P(!0),
		aoSamples: new F(16, {
			min: 4,
			max: 256,
			step: 1
		}),
		denoiseSamples: new F(8, {
			min: 4,
			max: 256,
			step: 1
		}),
		denoiseRadius: new F(12, {
			min: 4,
			max: 256,
			step: 1
		}),
		transparencyAware: new P(!0),
		color: new vn("#000000")
	},
	render: { resolutionScaling: new F(1, {
		min: .1,
		max: 1,
		step: .01
	}) },
	renderer: { powerPreference: new yn("high-performance", [
		"default",
		"high-performance",
		"low-power"
	]) },
	camera: {
		stepDistanceZoom: new F(10, {
			min: 0,
			max: 1e3
		}),
		centerCameraWhenLoading: new P(!0)
	},
	memory: {
		memoryUsageWarningLevel: new F(.5, {
			min: 0,
			max: 1,
			step: .1
		}),
		memoryUsageCriticalLevel: new F(.8, {
			min: 0,
			max: 1,
			step: .1
		})
	}
}), Sn = (e, t = I) => {
	let n = t();
	return wn(n, e, Tn, e.backupName ?? "Default"), n;
};
function Cn(e, t, n) {
	Object.entries(e).forEach(([e, r]) => {
		let i = t?.[e], a = n?.[e], o = i ?? a?.value;
		if (i !== void 0 || a !== void 0) {
			let e = r;
			if (e.isValueController && o !== void 0) {
				let t = a?.defaultValue ?? e.defaultValue, n = JSON.stringify(e.defaultValue) !== JSON.stringify(t), r = JSON.stringify(o) !== JSON.stringify(t), i = e.defaultValue !== t;
				e.value = typeof t == "object" && n && !r || typeof t != "object" && i && o === t ? e.defaultValue : o;
			} else Cn(r, i, a);
		}
	});
}
function wn(e, t, n, r) {
	Cn(e, t, vt.instance.getFromLocalStorageMap([n, r]));
}
var Tn = "TeiaViewerCfg", En = "PluginCfg-";
function Dn(e, t, n) {
	let r = {};
	function i(e, t, n) {
		for (let [r, a] of Object.entries(t)) {
			let t = a;
			t.isValueController ? t.saveToLocalStorage && (n[r] = {
				value: t.value,
				defaultValue: t.defaultValue
			}) : (n[r] = {}, i(e, a, n[r]));
		}
	}
	i(t, n, r), vt.instance.setLocalStorageMap([e, t], r);
}
var On = class {
	static buildSettings(e, t, n, r = {}) {
		let i = e(), a = n ?? "Default";
		return wn(i, r, `${En}${t}`, a), i;
	}
}, kn = class extends yt {
	constructor(...e) {
		super(...e), this.name = "SaveSettingsBehavior", this.onBeforeUnload = () => {
			for (let e of this._viewer.plugins) Dn(`${En}${e.name}`, this._viewer.settings.backupName.value, e.settings ?? {});
			Dn(Tn, this._viewer.settings.backupName.value, this._viewer.settings), vt.instance.saveSettingsToLocalStorage(), this._viewer.developerTools.save();
		};
	}
	setup(e) {
		this._viewer = e, addEventListener("beforeunload", this.onBeforeUnload);
	}
	dispose() {
		removeEventListener("beforeunload", this.onBeforeUnload);
	}
}, An = (/* @__PURE__ */ dt(((e, t) => {
	(function() {
		var n, r = "Expected a function", i = "__lodash_hash_undefined__", a = "__lodash_placeholder__", o = 1, s = 2, c = 8, l = 16, u = 32, d = 64, f = 128, p = 256, m = 512, h = 1 / 0, g = 9007199254740991, ee = 17976931348623157e292, te = NaN, _ = 4294967295, v = _ - 1, ne = _ >>> 1, re = [
			["ary", f],
			["bind", o],
			["bindKey", s],
			["curry", c],
			["curryRight", l],
			["flip", m],
			["partial", u],
			["partialRight", d],
			["rearg", p]
		], ie = "[object Arguments]", ae = "[object Array]", oe = "[object AsyncFunction]", se = "[object Boolean]", ce = "[object Date]", le = "[object DOMException]", ue = "[object Error]", de = "[object Function]", fe = "[object GeneratorFunction]", pe = "[object Map]", me = "[object Number]", he = "[object Null]", y = "[object Object]", ge = "[object Promise]", _e = "[object Proxy]", ve = "[object RegExp]", ye = "[object Set]", be = "[object String]", xe = "[object Symbol]", Se = "[object Undefined]", Ce = "[object WeakMap]", we = "[object WeakSet]", Te = "[object ArrayBuffer]", Ee = "[object DataView]", De = "[object Float32Array]", Oe = "[object Float64Array]", ke = "[object Int8Array]", Ae = "[object Int16Array]", b = "[object Int32Array]", je = "[object Uint8Array]", Me = "[object Uint8ClampedArray]", Ne = "[object Uint16Array]", Pe = "[object Uint32Array]", Fe = /\b__p \+= '';/g, x = /\b(__p \+=) '' \+/g, Ie = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Le = /&(?:amp|lt|gt|quot|#39);/g, Re = /[&<>"']/g, ze = RegExp(Le.source), Be = RegExp(Re.source), Ve = /<%-([\s\S]+?)%>/g, He = /<%([\s\S]+?)%>/g, Ue = /<%=([\s\S]+?)%>/g, We = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ge = /^\w*$/, Ke = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qe = /[\\^$.*+?()[\]{}|]/g, Je = RegExp(qe.source), Ye = /^\s+/, S = /\s/, Xe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ze = /\{\n\/\* \[wrapped with (.+)\] \*/, Qe = /,? & /, $e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, et = /[()=,{}\[\]\/\s]/, tt = /\\(\\)?/g, nt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, rt = /\w*$/, it = /^[-+]0x[0-9a-f]+$/i, at = /^0b[01]+$/i, ot = /^\[object .+?Constructor\]$/, st = /^0o[0-7]+$/i, ct = /^(?:0|[1-9]\d*)$/, lt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ut = /($^)/, dt = /['\n\r\u2028\u2029\\]/g, ft = "\\ud800-\\udfff", pt = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", mt = "\\u2700-\\u27bf", C = "a-z\\xdf-\\xf6\\xf8-\\xff", w = "\\xac\\xb1\\xd7\\xf7", ht = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", gt = "\\u2000-\\u206f", _t = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", vt = "A-Z\\xc0-\\xd6\\xd8-\\xde", yt = "\\ufe0e\\ufe0f", bt = w + ht + gt + _t, xt = "['’]", T = "[" + ft + "]", St = "[" + bt + "]", Ct = "[" + pt + "]", wt = "\\d+", Tt = "[" + mt + "]", Et = "[" + C + "]", Dt = "[^" + ft + bt + wt + mt + C + vt + "]", Ot = "\\ud83c[\\udffb-\\udfff]", kt = "(?:" + Ct + "|" + Ot + ")", At = "[^" + ft + "]", jt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Mt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nt = "[" + vt + "]", Pt = "\\u200d", Ft = "(?:" + Et + "|" + Dt + ")", It = "(?:" + Nt + "|" + Dt + ")", Lt = "(?:" + xt + "(?:d|ll|m|re|s|t|ve))?", Rt = "(?:" + xt + "(?:D|LL|M|RE|S|T|VE))?", zt = kt + "?", Bt = "[" + yt + "]?", Vt = "(?:" + Pt + "(?:" + [
			At,
			jt,
			Mt
		].join("|") + ")" + Bt + zt + ")*", Ht = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ut = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Wt = Bt + zt + Vt, Gt = "(?:" + [
			Tt,
			jt,
			Mt
		].join("|") + ")" + Wt, Kt = "(?:" + [
			At + Ct + "?",
			Ct,
			jt,
			Mt,
			T
		].join("|") + ")", qt = RegExp(xt, "g"), Jt = RegExp(Ct, "g"), Yt = RegExp(Ot + "(?=" + Ot + ")|" + Kt + Wt, "g"), Xt = RegExp([
			Nt + "?" + Et + "+" + Lt + "(?=" + [
				St,
				Nt,
				"$"
			].join("|") + ")",
			It + "+" + Rt + "(?=" + [
				St,
				Nt + Ft,
				"$"
			].join("|") + ")",
			Nt + "?" + Ft + "+" + Lt,
			Nt + "+" + Rt,
			Ut,
			Ht,
			wt,
			Gt
		].join("|"), "g"), Zt = RegExp("[" + Pt + ft + pt + yt + "]"), E = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Qt = /* @__PURE__ */ "Array.Buffer.DataView.Date.Error.Float32Array.Float64Array.Function.Int8Array.Int16Array.Int32Array.Map.Math.Object.Promise.RegExp.Set.String.Symbol.TypeError.Uint8Array.Uint8ClampedArray.Uint16Array.Uint32Array.WeakMap._.clearTimeout.isFinite.parseInt.setTimeout".split("."), $t = -1, D = {};
		D[De] = D[Oe] = D[ke] = D[Ae] = D[b] = D[je] = D[Me] = D[Ne] = D[Pe] = !0, D[ie] = D[ae] = D[Te] = D[se] = D[Ee] = D[ce] = D[ue] = D[de] = D[pe] = D[me] = D[y] = D[ve] = D[ye] = D[be] = D[Ce] = !1;
		var O = {};
		O[ie] = O[ae] = O[Te] = O[Ee] = O[se] = O[ce] = O[De] = O[Oe] = O[ke] = O[Ae] = O[b] = O[pe] = O[me] = O[y] = O[ve] = O[ye] = O[be] = O[xe] = O[je] = O[Me] = O[Ne] = O[Pe] = !0, O[ue] = O[de] = O[Ce] = !1;
		var en = {
			À: "A",
			Á: "A",
			Â: "A",
			Ã: "A",
			Ä: "A",
			Å: "A",
			à: "a",
			á: "a",
			â: "a",
			ã: "a",
			ä: "a",
			å: "a",
			Ç: "C",
			ç: "c",
			Ð: "D",
			ð: "d",
			È: "E",
			É: "E",
			Ê: "E",
			Ë: "E",
			è: "e",
			é: "e",
			ê: "e",
			ë: "e",
			Ì: "I",
			Í: "I",
			Î: "I",
			Ï: "I",
			ì: "i",
			í: "i",
			î: "i",
			ï: "i",
			Ñ: "N",
			ñ: "n",
			Ò: "O",
			Ó: "O",
			Ô: "O",
			Õ: "O",
			Ö: "O",
			Ø: "O",
			ò: "o",
			ó: "o",
			ô: "o",
			õ: "o",
			ö: "o",
			ø: "o",
			Ù: "U",
			Ú: "U",
			Û: "U",
			Ü: "U",
			ù: "u",
			ú: "u",
			û: "u",
			ü: "u",
			Ý: "Y",
			ý: "y",
			ÿ: "y",
			Æ: "Ae",
			æ: "ae",
			Þ: "Th",
			þ: "th",
			ß: "ss",
			Ā: "A",
			Ă: "A",
			Ą: "A",
			ā: "a",
			ă: "a",
			ą: "a",
			Ć: "C",
			Ĉ: "C",
			Ċ: "C",
			Č: "C",
			ć: "c",
			ĉ: "c",
			ċ: "c",
			č: "c",
			Ď: "D",
			Đ: "D",
			ď: "d",
			đ: "d",
			Ē: "E",
			Ĕ: "E",
			Ė: "E",
			Ę: "E",
			Ě: "E",
			ē: "e",
			ĕ: "e",
			ė: "e",
			ę: "e",
			ě: "e",
			Ĝ: "G",
			Ğ: "G",
			Ġ: "G",
			Ģ: "G",
			ĝ: "g",
			ğ: "g",
			ġ: "g",
			ģ: "g",
			Ĥ: "H",
			Ħ: "H",
			ĥ: "h",
			ħ: "h",
			Ĩ: "I",
			Ī: "I",
			Ĭ: "I",
			Į: "I",
			İ: "I",
			ĩ: "i",
			ī: "i",
			ĭ: "i",
			į: "i",
			ı: "i",
			Ĵ: "J",
			ĵ: "j",
			Ķ: "K",
			ķ: "k",
			ĸ: "k",
			Ĺ: "L",
			Ļ: "L",
			Ľ: "L",
			Ŀ: "L",
			Ł: "L",
			ĺ: "l",
			ļ: "l",
			ľ: "l",
			ŀ: "l",
			ł: "l",
			Ń: "N",
			Ņ: "N",
			Ň: "N",
			Ŋ: "N",
			ń: "n",
			ņ: "n",
			ň: "n",
			ŋ: "n",
			Ō: "O",
			Ŏ: "O",
			Ő: "O",
			ō: "o",
			ŏ: "o",
			ő: "o",
			Ŕ: "R",
			Ŗ: "R",
			Ř: "R",
			ŕ: "r",
			ŗ: "r",
			ř: "r",
			Ś: "S",
			Ŝ: "S",
			Ş: "S",
			Š: "S",
			ś: "s",
			ŝ: "s",
			ş: "s",
			š: "s",
			Ţ: "T",
			Ť: "T",
			Ŧ: "T",
			ţ: "t",
			ť: "t",
			ŧ: "t",
			Ũ: "U",
			Ū: "U",
			Ŭ: "U",
			Ů: "U",
			Ű: "U",
			Ų: "U",
			ũ: "u",
			ū: "u",
			ŭ: "u",
			ů: "u",
			ű: "u",
			ų: "u",
			Ŵ: "W",
			ŵ: "w",
			Ŷ: "Y",
			ŷ: "y",
			Ÿ: "Y",
			Ź: "Z",
			Ż: "Z",
			Ž: "Z",
			ź: "z",
			ż: "z",
			ž: "z",
			Ĳ: "IJ",
			ĳ: "ij",
			Œ: "Oe",
			œ: "oe",
			ŉ: "'n",
			ſ: "s"
		}, tn = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;",
			"'": "&#39;"
		}, nn = {
			"&amp;": "&",
			"&lt;": "<",
			"&gt;": ">",
			"&quot;": "\"",
			"&#39;": "'"
		}, rn = {
			"\\": "\\",
			"'": "'",
			"\n": "n",
			"\r": "r",
			"\u2028": "u2028",
			"\u2029": "u2029"
		}, an = parseFloat, on = parseInt, k = typeof global == "object" && global && global.Object === Object && global, A = typeof self == "object" && self && self.Object === Object && self, j = k || A || Function("return this")(), sn = typeof e == "object" && e && !e.nodeType && e, cn = sn && typeof t == "object" && t && !t.nodeType && t, ln = cn && cn.exports === sn, un = ln && k.process, M = function() {
			try {
				return cn && cn.require && cn.require("util").types || un && un.binding && un.binding("util");
			} catch {}
		}(), dn = M && M.isArrayBuffer, fn = M && M.isDate, pn = M && M.isMap, mn = M && M.isRegExp, N = M && M.isSet, hn = M && M.isTypedArray;
		function gn(e, t, n) {
			switch (n.length) {
				case 0: return e.call(t);
				case 1: return e.call(t, n[0]);
				case 2: return e.call(t, n[0], n[1]);
				case 3: return e.call(t, n[0], n[1], n[2]);
			}
			return e.apply(t, n);
		}
		function _n(e, t, n, r) {
			for (var i = -1, a = e == null ? 0 : e.length; ++i < a;) {
				var o = e[i];
				t(r, o, n(o), e);
			}
			return r;
		}
		function P(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
			return e;
		}
		function vn(e, t) {
			for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1;);
			return e;
		}
		function F(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
			return !0;
		}
		function yn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
				var o = e[n];
				t(o, n, e) && (a[i++] = o);
			}
			return a;
		}
		function bn(e, t) {
			return !!(e != null && e.length) && jn(e, t, 0) > -1;
		}
		function xn(e, t, n) {
			for (var r = -1, i = e == null ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
			return !1;
		}
		function I(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
			return i;
		}
		function Sn(e, t) {
			for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
			return e;
		}
		function Cn(e, t, n, r) {
			var i = -1, a = e == null ? 0 : e.length;
			for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
			return n;
		}
		function wn(e, t, n, r) {
			var i = e == null ? 0 : e.length;
			for (r && i && (n = e[--i]); i--;) n = t(n, e[i], i, e);
			return n;
		}
		function Tn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
			return !1;
		}
		var En = Fn("length");
		function Dn(e) {
			return e.split("");
		}
		function On(e) {
			return e.match($e) || [];
		}
		function kn(e, t, n) {
			var r;
			return n(e, function(e, n, i) {
				if (t(e, n, i)) return r = n, !1;
			}), r;
		}
		function An(e, t, n, r) {
			for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
			return -1;
		}
		function jn(e, t, n) {
			return t === t ? sr(e, t, n) : An(e, Nn, n);
		}
		function Mn(e, t, n, r) {
			for (var i = n - 1, a = e.length; ++i < a;) if (r(e[i], t)) return i;
			return -1;
		}
		function Nn(e) {
			return e !== e;
		}
		function Pn(e, t) {
			var n = e == null ? 0 : e.length;
			return n ? zn(e, t) / n : te;
		}
		function Fn(e) {
			return function(t) {
				return t == null ? n : t[e];
			};
		}
		function In(e) {
			return function(t) {
				return e == null ? n : e[t];
			};
		}
		function Ln(e, t, n, r, i) {
			return i(e, function(e, i, a) {
				n = r ? (r = !1, e) : t(n, e, i, a);
			}), n;
		}
		function Rn(e, t) {
			var n = e.length;
			for (e.sort(t); n--;) e[n] = e[n].value;
			return e;
		}
		function zn(e, t) {
			for (var r, i = -1, a = e.length; ++i < a;) {
				var o = t(e[i]);
				o !== n && (r = r === n ? o : r + o);
			}
			return r;
		}
		function Bn(e, t) {
			for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
			return r;
		}
		function Vn(e, t) {
			return I(t, function(t) {
				return [t, e[t]];
			});
		}
		function Hn(e) {
			return e && e.slice(0, dr(e) + 1).replace(Ye, "");
		}
		function Un(e) {
			return function(t) {
				return e(t);
			};
		}
		function Wn(e, t) {
			return I(t, function(t) {
				return e[t];
			});
		}
		function Gn(e, t) {
			return e.has(t);
		}
		function Kn(e, t) {
			for (var n = -1, r = e.length; ++n < r && jn(t, e[n], 0) > -1;);
			return n;
		}
		function qn(e, t) {
			for (var n = e.length; n-- && jn(t, e[n], 0) > -1;);
			return n;
		}
		function Jn(e, t) {
			for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
			return r;
		}
		var Yn = In(en), Xn = In(tn);
		function Zn(e) {
			return "\\" + rn[e];
		}
		function Qn(e, t) {
			return e == null ? n : e[t];
		}
		function $n(e) {
			return Zt.test(e);
		}
		function er(e) {
			return E.test(e);
		}
		function tr(e) {
			for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
			return n;
		}
		function nr(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e, r) {
				n[++t] = [r, e];
			}), n;
		}
		function rr(e, t) {
			return function(n) {
				return e(t(n));
			};
		}
		function ir(e, t) {
			for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
				var s = e[n];
				(s === t || s === a) && (e[n] = a, o[i++] = n);
			}
			return o;
		}
		function ar(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = e;
			}), n;
		}
		function or(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = [e, e];
			}), n;
		}
		function sr(e, t, n) {
			for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
			return -1;
		}
		function cr(e, t, n) {
			for (var r = n + 1; r--;) if (e[r] === t) return r;
			return r;
		}
		function lr(e) {
			return $n(e) ? pr(e) : En(e);
		}
		function ur(e) {
			return $n(e) ? mr(e) : Dn(e);
		}
		function dr(e) {
			for (var t = e.length; t-- && S.test(e.charAt(t)););
			return t;
		}
		var fr = In(nn);
		function pr(e) {
			for (var t = Yt.lastIndex = 0; Yt.test(e);) ++t;
			return t;
		}
		function mr(e) {
			return e.match(Yt) || [];
		}
		function hr(e) {
			return e.match(Xt) || [];
		}
		var gr = (function e(t) {
			t = t == null ? j : gr.defaults(j.Object(), t, gr.pick(j, Qt));
			var S = t.Array, $e = t.Date, ft = t.Error, pt = t.Function, mt = t.Math, C = t.Object, w = t.RegExp, ht = t.String, gt = t.TypeError, _t = S.prototype, vt = pt.prototype, yt = C.prototype, bt = t["__core-js_shared__"], xt = vt.toString, T = yt.hasOwnProperty, St = 0, Ct = function() {
				var e = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "");
				return e ? "Symbol(src)_1." + e : "";
			}(), wt = yt.toString, Tt = xt.call(C), Et = j._, Dt = w("^" + xt.call(T).replace(qe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ot = ln ? t.Buffer : n, kt = t.Symbol, At = t.Uint8Array, jt = Ot ? Ot.allocUnsafe : n, Mt = rr(C.getPrototypeOf, C), Nt = C.create, Pt = yt.propertyIsEnumerable, Ft = _t.splice, It = kt ? kt.isConcatSpreadable : n, Lt = kt ? kt.iterator : n, Rt = kt ? kt.toStringTag : n, zt = function() {
				try {
					var e = Lo(C, "defineProperty");
					return e({}, "", {}), e;
				} catch {}
			}(), Bt = t.clearTimeout !== j.clearTimeout && t.clearTimeout, Vt = $e && $e.now !== j.Date.now && $e.now, Ht = t.setTimeout !== j.setTimeout && t.setTimeout, Ut = mt.ceil, Wt = mt.floor, Gt = C.getOwnPropertySymbols, Kt = Ot ? Ot.isBuffer : n, Yt = t.isFinite, Xt = _t.join, Zt = rr(C.keys, C), E = mt.max, en = mt.min, tn = $e.now, nn = t.parseInt, rn = mt.random, k = _t.reverse, A = Lo(t, "DataView"), sn = Lo(t, "Map"), cn = Lo(t, "Promise"), un = Lo(t, "Set"), M = Lo(t, "WeakMap"), En = Lo(C, "create"), Dn = M && new M(), In = {}, sr = Ss(A), pr = Ss(sn), mr = Ss(cn), _r = Ss(un), vr = Ss(M), yr = kt ? kt.prototype : n, br = yr ? yr.valueOf : n, xr = yr ? yr.toString : n;
			function L(e) {
				if (X(e) && !q(e) && !(e instanceof R)) {
					if (e instanceof wr) return e;
					if (T.call(e, "__wrapped__")) return ws(e);
				}
				return new wr(e);
			}
			var Sr = function() {
				function e() {}
				return function(t) {
					if (!Y(t)) return {};
					if (Nt) return Nt(t);
					e.prototype = t;
					var r = new e();
					return e.prototype = n, r;
				};
			}();
			function Cr() {}
			function wr(e, t) {
				this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
			}
			L.templateSettings = {
				escape: Ve,
				evaluate: He,
				interpolate: Ue,
				variable: "",
				imports: { _: L }
			}, L.prototype = Cr.prototype, L.prototype.constructor = L, wr.prototype = Sr(Cr.prototype), wr.prototype.constructor = wr;
			function R(e) {
				this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = _, this.__views__ = [];
			}
			function Tr() {
				var e = new R(this.__wrapped__);
				return e.__actions__ = Ja(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ja(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ja(this.__views__), e;
			}
			function Er() {
				if (this.__filtered__) {
					var e = new R(this);
					e.__dir__ = -1, e.__filtered__ = !0;
				} else e = this.clone(), e.__dir__ *= -1;
				return e;
			}
			function Dr() {
				var e = this.__wrapped__.value(), t = this.__dir__, n = q(e), r = t < 0, i = n ? e.length : 0, a = Ho(0, i, this.__views__), o = a.start, s = a.end, c = s - o, l = r ? s : o - 1, u = this.__iteratees__, d = u.length, f = 0, p = en(c, this.__takeCount__);
				if (!n || !r && i == c && p == c) return ka(e, this.__actions__);
				var m = [];
				outer: for (; c-- && f < p;) {
					l += t;
					for (var h = -1, g = e[l]; ++h < d;) {
						var ee = u[h], te = ee.iteratee, _ = ee.type, v = te(g);
						if (_ == 2) g = v;
						else if (!v) {
							if (_ == 1) continue outer;
							break outer;
						}
					}
					m[f++] = g;
				}
				return m;
			}
			R.prototype = Sr(Cr.prototype), R.prototype.constructor = R;
			function Or(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function kr() {
				this.__data__ = En ? En(null) : {}, this.size = 0;
			}
			function Ar(e) {
				var t = this.has(e) && delete this.__data__[e];
				return this.size -= +!!t, t;
			}
			function jr(e) {
				var t = this.__data__;
				if (En) {
					var r = t[e];
					return r === i ? n : r;
				}
				return T.call(t, e) ? t[e] : n;
			}
			function Mr(e) {
				var t = this.__data__;
				return En ? t[e] !== n : T.call(t, e);
			}
			function Nr(e, t) {
				var r = this.__data__;
				return this.size += +!this.has(e), r[e] = En && t === n ? i : t, this;
			}
			Or.prototype.clear = kr, Or.prototype.delete = Ar, Or.prototype.get = jr, Or.prototype.has = Mr, Or.prototype.set = Nr;
			function Pr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Fr() {
				this.__data__ = [], this.size = 0;
			}
			function Ir(e) {
				var t = this.__data__, n = z(t, e);
				return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Ft.call(t, n, 1), --this.size, !0);
			}
			function Lr(e) {
				var t = this.__data__, r = z(t, e);
				return r < 0 ? n : t[r][1];
			}
			function Rr(e) {
				return z(this.__data__, e) > -1;
			}
			function zr(e, t) {
				var n = this.__data__, r = z(n, e);
				return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
			}
			Pr.prototype.clear = Fr, Pr.prototype.delete = Ir, Pr.prototype.get = Lr, Pr.prototype.has = Rr, Pr.prototype.set = zr;
			function Br(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Vr() {
				this.size = 0, this.__data__ = {
					hash: new Or(),
					map: new (sn || Pr)(),
					string: new Or()
				};
			}
			function Hr(e) {
				var t = Fo(this, e).delete(e);
				return this.size -= +!!t, t;
			}
			function Ur(e) {
				return Fo(this, e).get(e);
			}
			function Wr(e) {
				return Fo(this, e).has(e);
			}
			function Gr(e, t) {
				var n = Fo(this, e), r = n.size;
				return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
			}
			Br.prototype.clear = Vr, Br.prototype.delete = Hr, Br.prototype.get = Ur, Br.prototype.has = Wr, Br.prototype.set = Gr;
			function Kr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.__data__ = new Br(); ++t < n;) this.add(e[t]);
			}
			function qr(e) {
				return this.__data__.set(e, i), this;
			}
			function Jr(e) {
				return this.__data__.has(e);
			}
			Kr.prototype.add = Kr.prototype.push = qr, Kr.prototype.has = Jr;
			function Yr(e) {
				var t = this.__data__ = new Pr(e);
				this.size = t.size;
			}
			function Xr() {
				this.__data__ = new Pr(), this.size = 0;
			}
			function Zr(e) {
				var t = this.__data__, n = t.delete(e);
				return this.size = t.size, n;
			}
			function Qr(e) {
				return this.__data__.get(e);
			}
			function $r(e) {
				return this.__data__.has(e);
			}
			function ei(e, t) {
				var n = this.__data__;
				if (n instanceof Pr) {
					var r = n.__data__;
					if (!sn || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
					n = this.__data__ = new Br(r);
				}
				return n.set(e, t), this.size = n.size, this;
			}
			Yr.prototype.clear = Xr, Yr.prototype.delete = Zr, Yr.prototype.get = Qr, Yr.prototype.has = $r, Yr.prototype.set = ei;
			function ti(e, t) {
				var n = q(e), r = !n && Xl(e), i = !n && !r && eu(e), a = !n && !r && !i && Tu(e), o = n || r || i || a, s = o ? Bn(e.length, ht) : [], c = s.length;
				for (var l in e) (t || T.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Xo(l, c))) && s.push(l);
				return s;
			}
			function ni(e) {
				var t = e.length;
				return t ? e[ua(0, t - 1)] : n;
			}
			function ri(e, t) {
				return ys(Ja(e), fi(t, 0, e.length));
			}
			function ii(e) {
				return ys(Ja(e));
			}
			function ai(e, t, r) {
				(r !== n && !ql(e[t], r) || r === n && !(t in e)) && ui(e, t, r);
			}
			function oi(e, t, r) {
				var i = e[t];
				(!(T.call(e, t) && ql(i, r)) || r === n && !(t in e)) && ui(e, t, r);
			}
			function z(e, t) {
				for (var n = e.length; n--;) if (ql(e[n][0], t)) return n;
				return -1;
			}
			function si(e, t, n, r) {
				return vi(e, function(e, i, a) {
					t(r, e, n(e), a);
				}), r;
			}
			function ci(e, t) {
				return e && Ya(t, $(t), e);
			}
			function li(e, t) {
				return e && Ya(t, ad(t), e);
			}
			function ui(e, t, n) {
				t == "__proto__" && zt ? zt(e, t, {
					configurable: !0,
					enumerable: !0,
					value: n,
					writable: !0
				}) : e[t] = n;
			}
			function di(e, t) {
				for (var r = -1, i = t.length, a = S(i), o = e == null; ++r < i;) a[r] = o ? n : $u(e, t[r]);
				return a;
			}
			function fi(e, t, r) {
				return e === e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e;
			}
			function pi(e, t, r, i, a, o) {
				var s, c = t & 1, l = t & 2, u = t & 4;
				if (r && (s = a ? r(e, i, a, o) : r(e)), s !== n) return s;
				if (!Y(e)) return e;
				var d = q(e);
				if (d) {
					if (s = Go(e), !c) return Ja(e, s);
				} else {
					var f = Vo(e), p = f == de || f == fe;
					if (eu(e)) return Ra(e, c);
					if (f == y || f == ie || p && !a) {
						if (s = l || p ? {} : Ko(e), !c) return l ? Za(e, li(s, e)) : Xa(e, ci(s, e));
					} else {
						if (!O[f]) return a ? e : {};
						s = qo(e, f, c);
					}
				}
				o ||= new Yr();
				var m = o.get(e);
				if (m) return m;
				o.set(e, s), Su(e) ? e.forEach(function(n) {
					s.add(pi(n, t, r, n, e, o));
				}) : du(e) && e.forEach(function(n, i) {
					s.set(i, pi(n, t, r, i, e, o));
				});
				var h = d ? n : (u ? l ? jo : Ao : l ? ad : $)(e);
				return P(h || e, function(n, i) {
					h && (i = n, n = e[i]), oi(s, i, pi(n, t, r, i, e, o));
				}), s;
			}
			function mi(e) {
				var t = $(e);
				return function(n) {
					return hi(n, e, t);
				};
			}
			function hi(e, t, r) {
				var i = r.length;
				if (e == null) return !i;
				for (e = C(e); i--;) {
					var a = r[i], o = t[a], s = e[a];
					if (s === n && !(a in e) || !o(s)) return !1;
				}
				return !0;
			}
			function gi(e, t, i) {
				if (typeof e != "function") throw new gt(r);
				return hs(function() {
					e.apply(n, i);
				}, t);
			}
			function _i(e, t, n, r) {
				var i = -1, a = bn, o = !0, s = e.length, c = [], l = t.length;
				if (!s) return c;
				n && (t = I(t, Un(n))), r ? (a = xn, o = !1) : t.length >= 200 && (a = Gn, o = !1, t = new Kr(t));
				outer: for (; ++i < s;) {
					var u = e[i], d = n == null ? u : n(u);
					if (u = r || u !== 0 ? u : 0, o && d === d) {
						for (var f = l; f--;) if (t[f] === d) continue outer;
						c.push(u);
					} else a(t, d, r) || c.push(u);
				}
				return c;
			}
			var vi = eo(Di), yi = eo(Oi, !0);
			function bi(e, t) {
				var n = !0;
				return vi(e, function(e, r, i) {
					return n = !!t(e, r, i), n;
				}), n;
			}
			function xi(e, t, r) {
				for (var i = -1, a = e.length; ++i < a;) {
					var o = e[i], s = t(o);
					if (s != null && (c === n ? s === s && !wu(s) : r(s, c))) var c = s, l = o;
				}
				return l;
			}
			function Si(e, t, r, i) {
				var a = e.length;
				for (r = Z(r), r < 0 && (r = -r > a ? 0 : a + r), i = i === n || i > a ? a : Z(i), i < 0 && (i += a), i = r > i ? 0 : Nu(i); r < i;) e[r++] = t;
				return e;
			}
			function Ci(e, t) {
				var n = [];
				return vi(e, function(e, r, i) {
					t(e, r, i) && n.push(e);
				}), n;
			}
			function wi(e, t, n, r, i) {
				var a = -1, o = e.length;
				for (n ||= Yo, i ||= []; ++a < o;) {
					var s = e[a];
					t > 0 && n(s) ? t > 1 ? wi(s, t - 1, n, r, i) : Sn(i, s) : r || (i[i.length] = s);
				}
				return i;
			}
			var Ti = to(), Ei = to(!0);
			function Di(e, t) {
				return e && Ti(e, t, $);
			}
			function Oi(e, t) {
				return e && Ei(e, t, $);
			}
			function ki(e, t) {
				return yn(t, function(t) {
					return cu(e[t]);
				});
			}
			function Ai(e, t) {
				t = Pa(t, e);
				for (var r = 0, i = t.length; e != null && r < i;) e = e[xs(t[r++])];
				return r && r == i ? e : n;
			}
			function ji(e, t, n) {
				var r = t(e);
				return q(e) ? r : Sn(r, n(e));
			}
			function Mi(e) {
				return e == null ? e === n ? Se : he : Rt && Rt in C(e) ? Ro(e) : ls(e);
			}
			function Ni(e, t) {
				return e > t;
			}
			function Pi(e, t) {
				return e != null && T.call(e, t);
			}
			function Fi(e, t) {
				return e != null && t in C(e);
			}
			function Ii(e, t, n) {
				return e >= en(t, n) && e < E(t, n);
			}
			function Li(e, t, r) {
				for (var i = r ? xn : bn, a = e[0].length, o = e.length, s = o, c = S(o), l = Infinity, u = []; s--;) {
					var d = e[s];
					s && t && (d = I(d, Un(t))), l = en(d.length, l), c[s] = !r && (t || a >= 120 && d.length >= 120) ? new Kr(s && d) : n;
				}
				d = e[0];
				var f = -1, p = c[0];
				outer: for (; ++f < a && u.length < l;) {
					var m = d[f], h = t ? t(m) : m;
					if (m = r || m !== 0 ? m : 0, !(p ? Gn(p, h) : i(u, h, r))) {
						for (s = o; --s;) {
							var g = c[s];
							if (!(g ? Gn(g, h) : i(e[s], h, r))) continue outer;
						}
						p && p.push(h), u.push(m);
					}
				}
				return u;
			}
			function Ri(e, t, n, r) {
				return Di(e, function(e, i, a) {
					t(r, n(e), i, a);
				}), r;
			}
			function B(e, t, r) {
				t = Pa(t, e), e = ds(e, t);
				var i = e == null ? e : e[xs(Ys(t))];
				return i == null ? n : gn(i, e, r);
			}
			function zi(e) {
				return X(e) && Mi(e) == ie;
			}
			function Bi(e) {
				return X(e) && Mi(e) == Te;
			}
			function Vi(e) {
				return X(e) && Mi(e) == ce;
			}
			function V(e, t, n, r, i) {
				return e === t ? !0 : e == null || t == null || !X(e) && !X(t) ? e !== e && t !== t : Hi(e, t, n, r, V, i);
			}
			function Hi(e, t, n, r, i, a) {
				var o = q(e), s = q(t), c = o ? ae : Vo(e), l = s ? ae : Vo(t);
				c = c == ie ? y : c, l = l == ie ? y : l;
				var u = c == y, d = l == y, f = c == l;
				if (f && eu(e)) {
					if (!eu(t)) return !1;
					o = !0, u = !1;
				}
				if (f && !u) return a ||= new Yr(), o || Tu(e) ? Eo(e, t, n, r, i, a) : Do(e, t, c, n, r, i, a);
				if (!(n & 1)) {
					var p = u && T.call(e, "__wrapped__"), m = d && T.call(t, "__wrapped__");
					if (p || m) {
						var h = p ? e.value() : e, g = m ? t.value() : t;
						return a ||= new Yr(), i(h, g, n, r, a);
					}
				}
				return f ? (a ||= new Yr(), Oo(e, t, n, r, i, a)) : !1;
			}
			function Ui(e) {
				return X(e) && Vo(e) == pe;
			}
			function Wi(e, t, r, i) {
				var a = r.length, o = a, s = !i;
				if (e == null) return !o;
				for (e = C(e); a--;) {
					var c = r[a];
					if (s && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
				}
				for (; ++a < o;) {
					c = r[a];
					var l = c[0], u = e[l], d = c[1];
					if (s && c[2]) {
						if (u === n && !(l in e)) return !1;
					} else {
						var f = new Yr();
						if (i) var p = i(u, d, l, e, t, f);
						if (!(p === n ? V(d, u, 3, i, f) : p)) return !1;
					}
				}
				return !0;
			}
			function Gi(e) {
				return !Y(e) || ts(e) ? !1 : (cu(e) ? Dt : ot).test(Ss(e));
			}
			function Ki(e) {
				return X(e) && Mi(e) == ve;
			}
			function qi(e) {
				return X(e) && Vo(e) == ye;
			}
			function Ji(e) {
				return X(e) && uu(e.length) && !!D[Mi(e)];
			}
			function Yi(e) {
				return typeof e == "function" ? e : e == null ? pf : typeof e == "object" ? q(e) ? ea(e[0], e[1]) : $i(e) : Ef(e);
			}
			function H(e) {
				if (!rs(e)) return Zt(e);
				var t = [];
				for (var n in C(e)) T.call(e, n) && n != "constructor" && t.push(n);
				return t;
			}
			function Xi(e) {
				if (!Y(e)) return cs(e);
				var t = rs(e), n = [];
				for (var r in e) (r != "constructor" || !t && T.call(e, r)) && n.push(r);
				return n;
			}
			function Zi(e, t) {
				return e < t;
			}
			function Qi(e, t) {
				var n = -1, r = Ql(e) ? S(e.length) : [];
				return vi(e, function(e, i, a) {
					r[++n] = t(e, i, a);
				}), r;
			}
			function $i(e) {
				var t = Io(e);
				return t.length == 1 && t[0][2] ? as(t[0][0], t[0][1]) : function(n) {
					return n === e || Wi(n, e, t);
				};
			}
			function ea(e, t) {
				return Qo(e) && is(t) ? as(xs(e), t) : function(r) {
					var i = $u(r, e);
					return i === n && i === t ? td(r, e) : V(t, i, 3);
				};
			}
			function ta(e, t, r, i, a) {
				e !== t && Ti(t, function(o, s) {
					if (a ||= new Yr(), Y(o)) na(e, t, s, r, ta, i, a);
					else {
						var c = i ? i(ps(e, s), o, s + "", e, t, a) : n;
						c === n && (c = o), ai(e, s, c);
					}
				}, ad);
			}
			function na(e, t, r, i, a, o, s) {
				var c = ps(e, r), l = ps(t, r), u = s.get(l);
				if (u) {
					ai(e, r, u);
					return;
				}
				var d = o ? o(c, l, r + "", e, t, s) : n, f = d === n;
				if (f) {
					var p = q(l), m = !p && eu(l), h = !p && !m && Tu(l);
					d = l, p || m || h ? q(c) ? d = c : J(c) ? d = Ja(c) : m ? (f = !1, d = Ra(l, !0)) : h ? (f = !1, d = Ua(l, !0)) : d = [] : yu(l) || Xl(l) ? (d = c, Xl(c) ? d = Fu(c) : (!Y(c) || cu(c)) && (d = Ko(l))) : f = !1;
				}
				f && (s.set(l, d), a(d, l, i, o, s), s.delete(l)), ai(e, r, d);
			}
			function ra(e, t) {
				var r = e.length;
				if (r) return t += t < 0 ? r : 0, Xo(t, r) ? e[t] : n;
			}
			function ia(e, t, n) {
				t = t.length ? I(t, function(e) {
					return q(e) ? function(t) {
						return Ai(t, e.length === 1 ? e[0] : e);
					} : e;
				}) : [pf];
				var r = -1;
				return t = I(t, Un(G())), Rn(Qi(e, function(e, n, i) {
					return {
						criteria: I(t, function(t) {
							return t(e);
						}),
						index: ++r,
						value: e
					};
				}), function(e, t) {
					return Ga(e, t, n);
				});
			}
			function aa(e, t) {
				return oa(e, t, function(t, n) {
					return td(e, n);
				});
			}
			function oa(e, t, n) {
				for (var r = -1, i = t.length, a = {}; ++r < i;) {
					var o = t[r], s = Ai(e, o);
					n(s, o) && ha(a, Pa(o, e), s);
				}
				return a;
			}
			function sa(e) {
				return function(t) {
					return Ai(t, e);
				};
			}
			function ca(e, t, n, r) {
				var i = r ? Mn : jn, a = -1, o = t.length, s = e;
				for (e === t && (t = Ja(t)), n && (s = I(e, Un(n))); ++a < o;) for (var c = 0, l = t[a], u = n ? n(l) : l; (c = i(s, u, c, r)) > -1;) s !== e && Ft.call(s, c, 1), Ft.call(e, c, 1);
				return e;
			}
			function la(e, t) {
				for (var n = e ? t.length : 0, r = n - 1; n--;) {
					var i = t[n];
					if (n == r || i !== a) {
						var a = i;
						Xo(i) ? Ft.call(e, i, 1) : Ea(e, i);
					}
				}
				return e;
			}
			function ua(e, t) {
				return e + Wt(rn() * (t - e + 1));
			}
			function da(e, t, n, r) {
				for (var i = -1, a = E(Ut((t - e) / (n || 1)), 0), o = S(a); a--;) o[r ? a : ++i] = e, e += n;
				return o;
			}
			function fa(e, t) {
				var n = "";
				if (!e || t < 1 || t > g) return n;
				do
					t % 2 && (n += e), t = Wt(t / 2), t && (e += e);
				while (t);
				return n;
			}
			function U(e, t) {
				return gs(us(e, t, pf), e + "");
			}
			function pa(e) {
				return ni(Cd(e));
			}
			function ma(e, t) {
				var n = Cd(e);
				return ys(n, fi(t, 0, n.length));
			}
			function ha(e, t, r, i) {
				if (!Y(e)) return e;
				t = Pa(t, e);
				for (var a = -1, o = t.length, s = o - 1, c = e; c != null && ++a < o;) {
					var l = xs(t[a]), u = r;
					if (l === "__proto__" || l === "constructor" || l === "prototype") return e;
					if (a != s) {
						var d = c[l];
						u = i ? i(d, l, c) : n, u === n && (u = Y(d) ? d : Xo(t[a + 1]) ? [] : {});
					}
					oi(c, l, u), c = c[l];
				}
				return e;
			}
			var ga = Dn ? function(e, t) {
				return Dn.set(e, t), e;
			} : pf, _a = zt ? function(e, t) {
				return zt(e, "toString", {
					configurable: !0,
					enumerable: !1,
					value: lf(t),
					writable: !0
				});
			} : pf;
			function va(e) {
				return ys(Cd(e));
			}
			function W(e, t, n) {
				var r = -1, i = e.length;
				t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
				for (var a = S(i); ++r < i;) a[r] = e[r + t];
				return a;
			}
			function ya(e, t) {
				var n;
				return vi(e, function(e, r, i) {
					return n = t(e, r, i), !n;
				}), !!n;
			}
			function ba(e, t, n) {
				var r = 0, i = e == null ? r : e.length;
				if (typeof t == "number" && t === t && i <= ne) {
					for (; r < i;) {
						var a = r + i >>> 1, o = e[a];
						o !== null && !wu(o) && (n ? o <= t : o < t) ? r = a + 1 : i = a;
					}
					return i;
				}
				return xa(e, t, pf, n);
			}
			function xa(e, t, r, i) {
				var a = 0, o = e == null ? 0 : e.length;
				if (o === 0) return 0;
				t = r(t);
				for (var s = t !== t, c = t === null, l = wu(t), u = t === n; a < o;) {
					var d = Wt((a + o) / 2), f = r(e[d]), p = f !== n, m = f === null, h = f === f, g = wu(f);
					if (s) var ee = i || h;
					else ee = u ? h && (i || p) : c ? h && p && (i || !m) : l ? h && p && !m && (i || !g) : m || g ? !1 : i ? f <= t : f < t;
					ee ? a = d + 1 : o = d;
				}
				return en(o, v);
			}
			function Sa(e, t) {
				for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
					var o = e[n], s = t ? t(o) : o;
					if (!n || !ql(s, c)) {
						var c = s;
						a[i++] = o === 0 ? 0 : o;
					}
				}
				return a;
			}
			function Ca(e) {
				return typeof e == "number" ? e : wu(e) ? te : +e;
			}
			function wa(e) {
				if (typeof e == "string") return e;
				if (q(e)) return I(e, wa) + "";
				if (wu(e)) return xr ? xr.call(e) : "";
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function Ta(e, t, n) {
				var r = -1, i = bn, a = e.length, o = !0, s = [], c = s;
				if (n) o = !1, i = xn;
				else if (a >= 200) {
					var l = t ? null : bo(e);
					if (l) return ar(l);
					o = !1, i = Gn, c = new Kr();
				} else c = t ? [] : s;
				outer: for (; ++r < a;) {
					var u = e[r], d = t ? t(u) : u;
					if (u = n || u !== 0 ? u : 0, o && d === d) {
						for (var f = c.length; f--;) if (c[f] === d) continue outer;
						t && c.push(d), s.push(u);
					} else i(c, d, n) || (c !== s && c.push(d), s.push(u));
				}
				return s;
			}
			function Ea(e, t) {
				t = Pa(t, e);
				var n = -1, r = t.length;
				if (!r) return !0;
				for (; ++n < r;) {
					var i = xs(t[n]);
					if (i === "__proto__" && !T.call(e, "__proto__") || (i === "constructor" || i === "prototype") && n < r - 1) return !1;
				}
				var a = ds(e, t);
				return a == null || delete a[xs(Ys(t))];
			}
			function Da(e, t, n, r) {
				return ha(e, t, n(Ai(e, t)), r);
			}
			function Oa(e, t, n, r) {
				for (var i = e.length, a = r ? i : -1; (r ? a-- : ++a < i) && t(e[a], a, e););
				return n ? W(e, r ? 0 : a, r ? a + 1 : i) : W(e, r ? a + 1 : 0, r ? i : a);
			}
			function ka(e, t) {
				var n = e;
				return n instanceof R && (n = n.value()), Cn(t, function(e, t) {
					return t.func.apply(t.thisArg, Sn([e], t.args));
				}, n);
			}
			function Aa(e, t, n) {
				var r = e.length;
				if (r < 2) return r ? Ta(e[0]) : [];
				for (var i = -1, a = S(r); ++i < r;) for (var o = e[i], s = -1; ++s < r;) s != i && (a[i] = _i(a[i] || o, e[s], t, n));
				return Ta(wi(a, 1), t, n);
			}
			function ja(e, t, r) {
				for (var i = -1, a = e.length, o = t.length, s = {}; ++i < a;) {
					var c = i < o ? t[i] : n;
					r(s, e[i], c);
				}
				return s;
			}
			function Ma(e) {
				return J(e) ? e : [];
			}
			function Na(e) {
				return typeof e == "function" ? e : pf;
			}
			function Pa(e, t) {
				return q(e) ? e : Qo(e, t) ? [e] : bs(Q(e));
			}
			var Fa = U;
			function Ia(e, t, r) {
				var i = e.length;
				return r = r === n ? i : r, !t && r >= i ? e : W(e, t, r);
			}
			var La = Bt || function(e) {
				return j.clearTimeout(e);
			};
			function Ra(e, t) {
				if (t) return e.slice();
				var n = e.length, r = jt ? jt(n) : new e.constructor(n);
				return e.copy(r), r;
			}
			function za(e) {
				var t = new e.constructor(e.byteLength);
				return new At(t).set(new At(e)), t;
			}
			function Ba(e, t) {
				var n = t ? za(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.byteLength);
			}
			function Va(e) {
				var t = new e.constructor(e.source, rt.exec(e));
				return t.lastIndex = e.lastIndex, t;
			}
			function Ha(e) {
				return br ? C(br.call(e)) : {};
			}
			function Ua(e, t) {
				var n = t ? za(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.length);
			}
			function Wa(e, t) {
				if (e !== t) {
					var r = e !== n, i = e === null, a = e === e, o = wu(e), s = t !== n, c = t === null, l = t === t, u = wu(t);
					if (!c && !u && !o && e > t || o && s && l && !c && !u || i && s && l || !r && l || !a) return 1;
					if (!i && !o && !u && e < t || u && r && a && !i && !o || c && r && a || !s && a || !l) return -1;
				}
				return 0;
			}
			function Ga(e, t, n) {
				for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o;) {
					var c = Wa(i[r], a[r]);
					if (c) return r >= s ? c : c * (n[r] == "desc" ? -1 : 1);
				}
				return e.index - t.index;
			}
			function Ka(e, t, n, r) {
				for (var i = -1, a = e.length, o = n.length, s = -1, c = t.length, l = E(a - o, 0), u = S(c + l), d = !r; ++s < c;) u[s] = t[s];
				for (; ++i < o;) (d || i < a) && (u[n[i]] = e[i]);
				for (; l--;) u[s++] = e[i++];
				return u;
			}
			function qa(e, t, n, r) {
				for (var i = -1, a = e.length, o = -1, s = n.length, c = -1, l = t.length, u = E(a - s, 0), d = S(u + l), f = !r; ++i < u;) d[i] = e[i];
				for (var p = i; ++c < l;) d[p + c] = t[c];
				for (; ++o < s;) (f || i < a) && (d[p + n[o]] = e[i++]);
				return d;
			}
			function Ja(e, t) {
				var n = -1, r = e.length;
				for (t ||= S(r); ++n < r;) t[n] = e[n];
				return t;
			}
			function Ya(e, t, r, i) {
				var a = !r;
				r ||= {};
				for (var o = -1, s = t.length; ++o < s;) {
					var c = t[o], l = i ? i(r[c], e[c], c, r, e) : n;
					l === n && (l = e[c]), a ? ui(r, c, l) : oi(r, c, l);
				}
				return r;
			}
			function Xa(e, t) {
				return Ya(e, zo(e), t);
			}
			function Za(e, t) {
				return Ya(e, Bo(e), t);
			}
			function Qa(e, t) {
				return function(n, r) {
					var i = q(n) ? _n : si, a = t ? t() : {};
					return i(n, e, G(r, 2), a);
				};
			}
			function $a(e) {
				return U(function(t, r) {
					var i = -1, a = r.length, o = a > 1 ? r[a - 1] : n, s = a > 2 ? r[2] : n;
					for (o = e.length > 3 && typeof o == "function" ? (a--, o) : n, s && Zo(r[0], r[1], s) && (o = a < 3 ? n : o, a = 1), t = C(t); ++i < a;) {
						var c = r[i];
						c && e(t, c, i, o);
					}
					return t;
				});
			}
			function eo(e, t) {
				return function(n, r) {
					if (n == null) return n;
					if (!Ql(n)) return e(n, r);
					for (var i = n.length, a = t ? i : -1, o = C(n); (t ? a-- : ++a < i) && r(o[a], a, o) !== !1;);
					return n;
				};
			}
			function to(e) {
				return function(t, n, r) {
					for (var i = -1, a = C(t), o = r(t), s = o.length; s--;) {
						var c = o[e ? s : ++i];
						if (n(a[c], c, a) === !1) break;
					}
					return t;
				};
			}
			function no(e, t, n) {
				var r = t & o, i = ao(e);
				function a() {
					return (this && this !== j && this instanceof a ? i : e).apply(r ? n : this, arguments);
				}
				return a;
			}
			function ro(e) {
				return function(t) {
					t = Q(t);
					var r = $n(t) ? ur(t) : n, i = r ? r[0] : t.charAt(0), a = r ? Ia(r, 1).join("") : t.slice(1);
					return i[e]() + a;
				};
			}
			function io(e) {
				return function(t) {
					return Cn(rf(Ad(t).replace(qt, "")), e, "");
				};
			}
			function ao(e) {
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return new e();
						case 1: return new e(t[0]);
						case 2: return new e(t[0], t[1]);
						case 3: return new e(t[0], t[1], t[2]);
						case 4: return new e(t[0], t[1], t[2], t[3]);
						case 5: return new e(t[0], t[1], t[2], t[3], t[4]);
						case 6: return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
						case 7: return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
					}
					var n = Sr(e.prototype), r = e.apply(n, t);
					return Y(r) ? r : n;
				};
			}
			function oo(e, t, r) {
				var i = ao(e);
				function a() {
					for (var o = arguments.length, s = S(o), c = o, l = Po(a); c--;) s[c] = arguments[c];
					var u = o < 3 && s[0] !== l && s[o - 1] !== l ? [] : ir(s, l);
					return o -= u.length, o < r ? vo(e, t, lo, a.placeholder, n, s, u, n, n, r - o) : gn(this && this !== j && this instanceof a ? i : e, this, s);
				}
				return a;
			}
			function so(e) {
				return function(t, r, i) {
					var a = C(t);
					if (!Ql(t)) {
						var o = G(r, 3);
						t = $(t), r = function(e) {
							return o(a[e], e, a);
						};
					}
					var s = e(t, r, i);
					return s > -1 ? a[o ? t[s] : s] : n;
				};
			}
			function co(e) {
				return ko(function(t) {
					var i = t.length, a = i, o = wr.prototype.thru;
					for (e && t.reverse(); a--;) {
						var s = t[a];
						if (typeof s != "function") throw new gt(r);
						if (o && !l && No(s) == "wrapper") var l = new wr([], !0);
					}
					for (a = l ? a : i; ++a < i;) {
						s = t[a];
						var d = No(s), m = d == "wrapper" ? Mo(s) : n;
						l = m && es(m[0]) && m[1] == (f | c | u | p) && !m[4].length && m[9] == 1 ? l[No(m[0])].apply(l, m[3]) : s.length == 1 && es(s) ? l[d]() : l.thru(s);
					}
					return function() {
						var e = arguments, n = e[0];
						if (l && e.length == 1 && q(n)) return l.plant(n).value();
						for (var r = 0, a = i ? t[r].apply(this, e) : n; ++r < i;) a = t[r].call(this, a);
						return a;
					};
				});
			}
			function lo(e, t, r, i, a, u, d, p, h, g) {
				var ee = t & f, te = t & o, _ = t & s, v = t & (c | l), ne = t & m, re = _ ? n : ao(e);
				function ie() {
					for (var n = arguments.length, o = S(n), s = n; s--;) o[s] = arguments[s];
					if (v) var c = Po(ie), l = Jn(o, c);
					if (i && (o = Ka(o, i, a, v)), u && (o = qa(o, u, d, v)), n -= l, v && n < g) {
						var f = ir(o, c);
						return vo(e, t, lo, ie.placeholder, r, o, f, p, h, g - n);
					}
					var m = te ? r : this, ae = _ ? m[e] : e;
					return n = o.length, p ? o = fs(o, p) : ne && n > 1 && o.reverse(), ee && h < n && (o.length = h), this && this !== j && this instanceof ie && (ae = re || ao(ae)), ae.apply(m, o);
				}
				return ie;
			}
			function uo(e, t) {
				return function(n, r) {
					return Ri(n, e, t(r), {});
				};
			}
			function fo(e, t) {
				return function(r, i) {
					var a;
					if (r === n && i === n) return t;
					if (r !== n && (a = r), i !== n) {
						if (a === n) return i;
						typeof r == "string" || typeof i == "string" ? (r = wa(r), i = wa(i)) : (r = Ca(r), i = Ca(i)), a = e(r, i);
					}
					return a;
				};
			}
			function po(e) {
				return ko(function(t) {
					return t = I(t, Un(G())), U(function(n) {
						var r = this;
						return e(t, function(e) {
							return gn(e, r, n);
						});
					});
				});
			}
			function mo(e, t) {
				t = t === n ? " " : wa(t);
				var r = t.length;
				if (r < 2) return r ? fa(t, e) : t;
				var i = fa(t, Ut(e / lr(t)));
				return $n(t) ? Ia(ur(i), 0, e).join("") : i.slice(0, e);
			}
			function ho(e, t, n, r) {
				var i = t & o, a = ao(e);
				function s() {
					for (var t = -1, o = arguments.length, c = -1, l = r.length, u = S(l + o), d = this && this !== j && this instanceof s ? a : e; ++c < l;) u[c] = r[c];
					for (; o--;) u[c++] = arguments[++t];
					return gn(d, i ? n : this, u);
				}
				return s;
			}
			function go(e) {
				return function(t, r, i) {
					return i && typeof i != "number" && Zo(t, r, i) && (r = i = n), t = Mu(t), r === n ? (r = t, t = 0) : r = Mu(r), i = i === n ? t < r ? 1 : -1 : Mu(i), da(t, r, i, e);
				};
			}
			function _o(e) {
				return function(t, n) {
					return (typeof t != "string" || typeof n != "string") && (t = Pu(t), n = Pu(n)), e(t, n);
				};
			}
			function vo(e, t, r, i, a, l, f, p, m, h) {
				var g = t & c, ee = g ? f : n, te = g ? n : f, _ = g ? l : n, v = g ? n : l;
				t |= g ? u : d, t &= ~(g ? d : u), t & 4 || (t &= ~(o | s));
				var ne = [
					e,
					t,
					a,
					_,
					ee,
					v,
					te,
					p,
					m,
					h
				], re = r.apply(n, ne);
				return es(e) && ms(re, ne), re.placeholder = i, _s(re, e, t);
			}
			function yo(e) {
				var t = mt[e];
				return function(e, n) {
					if (e = Pu(e), n = n == null ? 0 : en(Z(n), 292), n && Yt(e)) {
						var r = (Q(e) + "e").split("e");
						return r = (Q(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"), +(r[0] + "e" + (+r[1] - n));
					}
					return t(e);
				};
			}
			var bo = un && 1 / ar(new un([, -0]))[1] == h ? function(e) {
				return new un(e);
			} : xf;
			function xo(e) {
				return function(t) {
					var n = Vo(t);
					return n == pe ? nr(t) : n == ye ? or(t) : Vn(t, e(t));
				};
			}
			function So(e, t, i, a, f, p, m, h) {
				var g = t & s;
				if (!g && typeof e != "function") throw new gt(r);
				var ee = a ? a.length : 0;
				if (ee || (t &= ~(u | d), a = f = n), m = m === n ? m : E(Z(m), 0), h = h === n ? h : Z(h), ee -= f ? f.length : 0, t & d) {
					var te = a, _ = f;
					a = f = n;
				}
				var v = g ? n : Mo(e), ne = [
					e,
					t,
					i,
					a,
					f,
					te,
					_,
					p,
					m,
					h
				];
				if (v && ss(ne, v), e = ne[0], t = ne[1], i = ne[2], a = ne[3], f = ne[4], h = ne[9] = ne[9] === n ? g ? 0 : e.length : E(ne[9] - ee, 0), !h && t & (c | l) && (t &= ~(c | l)), !t || t == o) var re = no(e, t, i);
				else re = t == c || t == l ? oo(e, t, h) : (t == u || t == (o | u)) && !f.length ? ho(e, t, i, a) : lo.apply(n, ne);
				return _s((v ? ga : ms)(re, ne), e, t);
			}
			function Co(e, t, r, i) {
				return e === n || ql(e, yt[r]) && !T.call(i, r) ? t : e;
			}
			function wo(e, t, r, i, a, o) {
				return Y(e) && Y(t) && (o.set(t, e), ta(e, t, n, wo, o), o.delete(t)), e;
			}
			function To(e) {
				return yu(e) ? n : e;
			}
			function Eo(e, t, r, i, a, o) {
				var s = r & 1, c = e.length, l = t.length;
				if (c != l && !(s && l > c)) return !1;
				var u = o.get(e), d = o.get(t);
				if (u && d) return u == t && d == e;
				var f = -1, p = !0, m = r & 2 ? new Kr() : n;
				for (o.set(e, t), o.set(t, e); ++f < c;) {
					var h = e[f], g = t[f];
					if (i) var ee = s ? i(g, h, f, t, e, o) : i(h, g, f, e, t, o);
					if (ee !== n) {
						if (ee) continue;
						p = !1;
						break;
					}
					if (m) {
						if (!Tn(t, function(e, t) {
							if (!Gn(m, t) && (h === e || a(h, e, r, i, o))) return m.push(t);
						})) {
							p = !1;
							break;
						}
					} else if (!(h === g || a(h, g, r, i, o))) {
						p = !1;
						break;
					}
				}
				return o.delete(e), o.delete(t), p;
			}
			function Do(e, t, n, r, i, a, o) {
				switch (n) {
					case Ee:
						if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
						e = e.buffer, t = t.buffer;
					case Te: return !(e.byteLength != t.byteLength || !a(new At(e), new At(t)));
					case se:
					case ce:
					case me: return ql(+e, +t);
					case ue: return e.name == t.name && e.message == t.message;
					case ve:
					case be: return e == t + "";
					case pe: var s = nr;
					case ye:
						var c = r & 1;
						if (s ||= ar, e.size != t.size && !c) return !1;
						var l = o.get(e);
						if (l) return l == t;
						r |= 2, o.set(e, t);
						var u = Eo(s(e), s(t), r, i, a, o);
						return o.delete(e), u;
					case xe: if (br) return br.call(e) == br.call(t);
				}
				return !1;
			}
			function Oo(e, t, r, i, a, o) {
				var s = r & 1, c = Ao(e), l = c.length;
				if (l != Ao(t).length && !s) return !1;
				for (var u = l; u--;) {
					var d = c[u];
					if (!(s ? d in t : T.call(t, d))) return !1;
				}
				var f = o.get(e), p = o.get(t);
				if (f && p) return f == t && p == e;
				var m = !0;
				o.set(e, t), o.set(t, e);
				for (var h = s; ++u < l;) {
					d = c[u];
					var g = e[d], ee = t[d];
					if (i) var te = s ? i(ee, g, d, t, e, o) : i(g, ee, d, e, t, o);
					if (!(te === n ? g === ee || a(g, ee, r, i, o) : te)) {
						m = !1;
						break;
					}
					h ||= d == "constructor";
				}
				if (m && !h) {
					var _ = e.constructor, v = t.constructor;
					_ != v && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v) && (m = !1);
				}
				return o.delete(e), o.delete(t), m;
			}
			function ko(e) {
				return gs(us(e, n, Rs), e + "");
			}
			function Ao(e) {
				return ji(e, $, zo);
			}
			function jo(e) {
				return ji(e, ad, Bo);
			}
			var Mo = Dn ? function(e) {
				return Dn.get(e);
			} : xf;
			function No(e) {
				for (var t = e.name + "", n = In[t], r = T.call(In, t) ? n.length : 0; r--;) {
					var i = n[r], a = i.func;
					if (a == null || a == e) return i.name;
				}
				return t;
			}
			function Po(e) {
				return (T.call(L, "placeholder") ? L : e).placeholder;
			}
			function G() {
				var e = L.iteratee || mf;
				return e = e === mf ? Yi : e, arguments.length ? e(arguments[0], arguments[1]) : e;
			}
			function Fo(e, t) {
				var n = e.__data__;
				return $o(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
			}
			function Io(e) {
				for (var t = $(e), n = t.length; n--;) {
					var r = t[n], i = e[r];
					t[n] = [
						r,
						i,
						is(i)
					];
				}
				return t;
			}
			function Lo(e, t) {
				var r = Qn(e, t);
				return Gi(r) ? r : n;
			}
			function Ro(e) {
				var t = T.call(e, Rt), r = e[Rt];
				try {
					e[Rt] = n;
					var i = !0;
				} catch {}
				var a = wt.call(e);
				return i && (t ? e[Rt] = r : delete e[Rt]), a;
			}
			var zo = Gt ? function(e) {
				return e == null ? [] : (e = C(e), yn(Gt(e), function(t) {
					return Pt.call(e, t);
				}));
			} : Af, Bo = Gt ? function(e) {
				for (var t = []; e;) Sn(t, zo(e)), e = Mt(e);
				return t;
			} : Af, Vo = Mi;
			(A && Vo(new A(/* @__PURE__ */ new ArrayBuffer(1))) != Ee || sn && Vo(new sn()) != pe || cn && Vo(cn.resolve()) != ge || un && Vo(new un()) != ye || M && Vo(new M()) != Ce) && (Vo = function(e) {
				var t = Mi(e), r = t == y ? e.constructor : n, i = r ? Ss(r) : "";
				if (i) switch (i) {
					case sr: return Ee;
					case pr: return pe;
					case mr: return ge;
					case _r: return ye;
					case vr: return Ce;
				}
				return t;
			});
			function Ho(e, t, n) {
				for (var r = -1, i = n.length; ++r < i;) {
					var a = n[r], o = a.size;
					switch (a.type) {
						case "drop":
							e += o;
							break;
						case "dropRight":
							t -= o;
							break;
						case "take":
							t = en(t, e + o);
							break;
						case "takeRight": e = E(e, t - o);
					}
				}
				return {
					start: e,
					end: t
				};
			}
			function Uo(e) {
				var t = e.match(Ze);
				return t ? t[1].split(Qe) : [];
			}
			function Wo(e, t, n) {
				t = Pa(t, e);
				for (var r = -1, i = t.length, a = !1; ++r < i;) {
					var o = xs(t[r]);
					if (!(a = e != null && n(e, o))) break;
					e = e[o];
				}
				return a || ++r != i ? a : (i = e == null ? 0 : e.length, !!i && uu(i) && Xo(o, i) && (q(e) || Xl(e)));
			}
			function Go(e) {
				var t = e.length, n = new e.constructor(t);
				return t && typeof e[0] == "string" && T.call(e, "index") && (n.index = e.index, n.input = e.input), n;
			}
			function Ko(e) {
				return typeof e.constructor == "function" && !rs(e) ? Sr(Mt(e)) : {};
			}
			function qo(e, t, n) {
				var r = e.constructor;
				switch (t) {
					case Te: return za(e);
					case se:
					case ce: return new r(+e);
					case Ee: return Ba(e, n);
					case De:
					case Oe:
					case ke:
					case Ae:
					case b:
					case je:
					case Me:
					case Ne:
					case Pe: return Ua(e, n);
					case pe: return new r();
					case me:
					case be: return new r(e);
					case ve: return Va(e);
					case ye: return new r();
					case xe: return Ha(e);
				}
			}
			function Jo(e, t) {
				var n = t.length;
				if (!n) return e;
				var r = n - 1;
				return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Xe, "{\n/* [wrapped with " + t + "] */\n");
			}
			function Yo(e) {
				return q(e) || Xl(e) || !!(It && e && e[It]);
			}
			function Xo(e, t) {
				var n = typeof e;
				return t ??= g, !!t && (n == "number" || n != "symbol" && ct.test(e)) && e > -1 && e % 1 == 0 && e < t;
			}
			function Zo(e, t, n) {
				if (!Y(n)) return !1;
				var r = typeof t;
				return (r == "number" ? Ql(n) && Xo(t, n.length) : r == "string" && t in n) ? ql(n[t], e) : !1;
			}
			function Qo(e, t) {
				if (q(e)) return !1;
				var n = typeof e;
				return n == "number" || n == "symbol" || n == "boolean" || e == null || wu(e) ? !0 : Ge.test(e) || !We.test(e) || t != null && e in C(t);
			}
			function $o(e) {
				var t = typeof e;
				return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
			}
			function es(e) {
				var t = No(e), n = L[t];
				if (typeof n != "function" || !(t in R.prototype)) return !1;
				if (e === n) return !0;
				var r = Mo(n);
				return !!r && e === r[0];
			}
			function ts(e) {
				return !!Ct && Ct in e;
			}
			var ns = bt ? cu : jf;
			function rs(e) {
				var t = e && e.constructor;
				return e === (typeof t == "function" && t.prototype || yt);
			}
			function is(e) {
				return e === e && !Y(e);
			}
			function as(e, t) {
				return function(r) {
					return r != null && r[e] === t && (t !== n || e in C(r));
				};
			}
			function os(e) {
				var t = kl(e, function(e) {
					return n.size === 500 && n.clear(), e;
				}), n = t.cache;
				return t;
			}
			function ss(e, t) {
				var n = e[1], r = t[1], i = n | r, l = i < (o | s | f), u = r == f && n == c || r == f && n == p && e[7].length <= t[8] || r == (f | p) && t[7].length <= t[8] && n == c;
				if (!(l || u)) return e;
				r & o && (e[2] = t[2], i |= n & o ? 0 : 4);
				var d = t[3];
				if (d) {
					var m = e[3];
					e[3] = m ? Ka(m, d, t[4]) : d, e[4] = m ? ir(e[3], a) : t[4];
				}
				return d = t[5], d && (m = e[5], e[5] = m ? qa(m, d, t[6]) : d, e[6] = m ? ir(e[5], a) : t[6]), d = t[7], d && (e[7] = d), r & f && (e[8] = e[8] == null ? t[8] : en(e[8], t[8])), e[9] ??= t[9], e[0] = t[0], e[1] = i, e;
			}
			function cs(e) {
				var t = [];
				if (e != null) for (var n in C(e)) t.push(n);
				return t;
			}
			function ls(e) {
				return wt.call(e);
			}
			function us(e, t, r) {
				return t = E(t === n ? e.length - 1 : t, 0), function() {
					for (var n = arguments, i = -1, a = E(n.length - t, 0), o = S(a); ++i < a;) o[i] = n[t + i];
					i = -1;
					for (var s = S(t + 1); ++i < t;) s[i] = n[i];
					return s[t] = r(o), gn(e, this, s);
				};
			}
			function ds(e, t) {
				return t.length < 2 ? e : Ai(e, W(t, 0, -1));
			}
			function fs(e, t) {
				for (var r = e.length, i = en(t.length, r), a = Ja(e); i--;) {
					var o = t[i];
					e[i] = Xo(o, r) ? a[o] : n;
				}
				return e;
			}
			function ps(e, t) {
				if ((t !== "constructor" || typeof e[t] != "function") && t != "__proto__") return e[t];
			}
			var ms = vs(ga), hs = Ht || function(e, t) {
				return j.setTimeout(e, t);
			}, gs = vs(_a);
			function _s(e, t, n) {
				var r = t + "";
				return gs(e, Jo(r, Cs(Uo(r), n)));
			}
			function vs(e) {
				var t = 0, r = 0;
				return function() {
					var i = tn(), a = 16 - (i - r);
					if (r = i, a > 0) {
						if (++t >= 800) return arguments[0];
					} else t = 0;
					return e.apply(n, arguments);
				};
			}
			function ys(e, t) {
				var r = -1, i = e.length, a = i - 1;
				for (t = t === n ? i : t; ++r < t;) {
					var o = ua(r, a), s = e[o];
					e[o] = e[r], e[r] = s;
				}
				return e.length = t, e;
			}
			var bs = os(function(e) {
				var t = [];
				return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ke, function(e, n, r, i) {
					t.push(r ? i.replace(tt, "$1") : n || e);
				}), t;
			});
			function xs(e) {
				if (typeof e == "string" || wu(e)) return e;
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function Ss(e) {
				if (e != null) {
					try {
						return xt.call(e);
					} catch {}
					try {
						return e + "";
					} catch {}
				}
				return "";
			}
			function Cs(e, t) {
				return P(re, function(n) {
					var r = "_." + n[0];
					t & n[1] && !bn(e, r) && e.push(r);
				}), e.sort();
			}
			function ws(e) {
				if (e instanceof R) return e.clone();
				var t = new wr(e.__wrapped__, e.__chain__);
				return t.__actions__ = Ja(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
			}
			function Ts(e, t, r) {
				t = (r ? Zo(e, t, r) : t === n) ? 1 : E(Z(t), 0);
				var i = e == null ? 0 : e.length;
				if (!i || t < 1) return [];
				for (var a = 0, o = 0, s = S(Ut(i / t)); a < i;) s[o++] = W(e, a, a += t);
				return s;
			}
			function Es(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n;) {
					var a = e[t];
					a && (i[r++] = a);
				}
				return i;
			}
			function Ds() {
				var e = arguments.length;
				if (!e) return [];
				for (var t = S(e - 1), n = arguments[0], r = e; r--;) t[r - 1] = arguments[r];
				return Sn(q(n) ? Ja(n) : [n], wi(t, 1));
			}
			var Os = U(function(e, t) {
				return J(e) ? _i(e, wi(t, 1, J, !0)) : [];
			}), ks = U(function(e, t) {
				var r = Ys(t);
				return J(r) && (r = n), J(e) ? _i(e, wi(t, 1, J, !0), G(r, 2)) : [];
			}), As = U(function(e, t) {
				var r = Ys(t);
				return J(r) && (r = n), J(e) ? _i(e, wi(t, 1, J, !0), n, r) : [];
			});
			function js(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Z(t), W(e, t < 0 ? 0 : t, i)) : [];
			}
			function Ms(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Z(t), t = i - t, W(e, 0, t < 0 ? 0 : t)) : [];
			}
			function Ns(e, t) {
				return e && e.length ? Oa(e, G(t, 3), !0, !0) : [];
			}
			function Ps(e, t) {
				return e && e.length ? Oa(e, G(t, 3), !0) : [];
			}
			function Fs(e, t, n, r) {
				var i = e == null ? 0 : e.length;
				return i ? (n && typeof n != "number" && Zo(e, t, n) && (n = 0, r = i), Si(e, t, n, r)) : [];
			}
			function Is(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Z(n);
				return i < 0 && (i = E(r + i, 0)), An(e, G(t, 3), i);
			}
			function Ls(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i - 1;
				return r !== n && (a = Z(r), a = r < 0 ? E(i + a, 0) : en(a, i - 1)), An(e, G(t, 3), a, !0);
			}
			function Rs(e) {
				return e != null && e.length ? wi(e, 1) : [];
			}
			function zs(e) {
				return e != null && e.length ? wi(e, h) : [];
			}
			function Bs(e, t) {
				return e != null && e.length ? (t = t === n ? 1 : Z(t), wi(e, t)) : [];
			}
			function Vs(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n;) {
					var i = e[t];
					ui(r, i[0], i[1]);
				}
				return r;
			}
			function Hs(e) {
				return e && e.length ? e[0] : n;
			}
			function Us(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Z(n);
				return i < 0 && (i = E(r + i, 0)), jn(e, t, i);
			}
			function Ws(e) {
				return e != null && e.length ? W(e, 0, -1) : [];
			}
			var Gs = U(function(e) {
				var t = I(e, Ma);
				return t.length && t[0] === e[0] ? Li(t) : [];
			}), Ks = U(function(e) {
				var t = Ys(e), r = I(e, Ma);
				return t === Ys(r) ? t = n : r.pop(), r.length && r[0] === e[0] ? Li(r, G(t, 2)) : [];
			}), qs = U(function(e) {
				var t = Ys(e), r = I(e, Ma);
				return t = typeof t == "function" ? t : n, t && r.pop(), r.length && r[0] === e[0] ? Li(r, n, t) : [];
			});
			function Js(e, t) {
				return e == null ? "" : Xt.call(e, t);
			}
			function Ys(e) {
				var t = e == null ? 0 : e.length;
				return t ? e[t - 1] : n;
			}
			function Xs(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i;
				return r !== n && (a = Z(r), a = a < 0 ? E(i + a, 0) : en(a, i - 1)), t === t ? cr(e, t, a) : An(e, Nn, a, !0);
			}
			function Zs(e, t) {
				return e && e.length ? ra(e, Z(t)) : n;
			}
			var Qs = U($s);
			function $s(e, t) {
				return e && e.length && t && t.length ? ca(e, t) : e;
			}
			function ec(e, t, n) {
				return e && e.length && t && t.length ? ca(e, t, G(n, 2)) : e;
			}
			function K(e, t, r) {
				return e && e.length && t && t.length ? ca(e, t, n, r) : e;
			}
			var tc = ko(function(e, t) {
				var n = e == null ? 0 : e.length, r = di(e, t);
				return la(e, I(t, function(e) {
					return Xo(e, n) ? +e : e;
				}).sort(Wa)), r;
			});
			function nc(e, t) {
				var n = [];
				if (!(e && e.length)) return n;
				var r = -1, i = [], a = e.length;
				for (t = G(t, 3); ++r < a;) {
					var o = e[r];
					t(o, r, e) && (n.push(o), i.push(r));
				}
				return la(e, i), n;
			}
			function rc(e) {
				return e == null ? e : k.call(e);
			}
			function ic(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (r && typeof r != "number" && Zo(e, t, r) ? (t = 0, r = i) : (t = t == null ? 0 : Z(t), r = r === n ? i : Z(r)), W(e, t, r)) : [];
			}
			function ac(e, t) {
				return ba(e, t);
			}
			function oc(e, t, n) {
				return xa(e, t, G(n, 2));
			}
			function sc(e, t) {
				var n = e == null ? 0 : e.length;
				if (n) {
					var r = ba(e, t);
					if (r < n && ql(e[r], t)) return r;
				}
				return -1;
			}
			function cc(e, t) {
				return ba(e, t, !0);
			}
			function lc(e, t, n) {
				return xa(e, t, G(n, 2), !0);
			}
			function uc(e, t) {
				if (e != null && e.length) {
					var n = ba(e, t, !0) - 1;
					if (ql(e[n], t)) return n;
				}
				return -1;
			}
			function dc(e) {
				return e && e.length ? Sa(e) : [];
			}
			function fc(e, t) {
				return e && e.length ? Sa(e, G(t, 2)) : [];
			}
			function pc(e) {
				var t = e == null ? 0 : e.length;
				return t ? W(e, 1, t) : [];
			}
			function mc(e, t, r) {
				return e && e.length ? (t = r || t === n ? 1 : Z(t), W(e, 0, t < 0 ? 0 : t)) : [];
			}
			function hc(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Z(t), t = i - t, W(e, t < 0 ? 0 : t, i)) : [];
			}
			function gc(e, t) {
				return e && e.length ? Oa(e, G(t, 3), !1, !0) : [];
			}
			function _c(e, t) {
				return e && e.length ? Oa(e, G(t, 3)) : [];
			}
			var vc = U(function(e) {
				return Ta(wi(e, 1, J, !0));
			}), yc = U(function(e) {
				var t = Ys(e);
				return J(t) && (t = n), Ta(wi(e, 1, J, !0), G(t, 2));
			}), bc = U(function(e) {
				var t = Ys(e);
				return t = typeof t == "function" ? t : n, Ta(wi(e, 1, J, !0), n, t);
			});
			function xc(e) {
				return e && e.length ? Ta(e) : [];
			}
			function Sc(e, t) {
				return e && e.length ? Ta(e, G(t, 2)) : [];
			}
			function Cc(e, t) {
				return t = typeof t == "function" ? t : n, e && e.length ? Ta(e, n, t) : [];
			}
			function wc(e) {
				if (!(e && e.length)) return [];
				var t = 0;
				return e = yn(e, function(e) {
					if (J(e)) return t = E(e.length, t), !0;
				}), Bn(t, function(t) {
					return I(e, Fn(t));
				});
			}
			function Tc(e, t) {
				if (!(e && e.length)) return [];
				var r = wc(e);
				return t == null ? r : I(r, function(e) {
					return gn(t, n, e);
				});
			}
			var Ec = U(function(e, t) {
				return J(e) ? _i(e, t) : [];
			}), Dc = U(function(e) {
				return Aa(yn(e, J));
			}), Oc = U(function(e) {
				var t = Ys(e);
				return J(t) && (t = n), Aa(yn(e, J), G(t, 2));
			}), kc = U(function(e) {
				var t = Ys(e);
				return t = typeof t == "function" ? t : n, Aa(yn(e, J), n, t);
			}), Ac = U(wc);
			function jc(e, t) {
				return ja(e || [], t || [], oi);
			}
			function Mc(e, t) {
				return ja(e || [], t || [], ha);
			}
			var Nc = U(function(e) {
				var t = e.length, r = t > 1 ? e[t - 1] : n;
				return r = typeof r == "function" ? (e.pop(), r) : n, Tc(e, r);
			});
			function Pc(e) {
				var t = L(e);
				return t.__chain__ = !0, t;
			}
			function Fc(e, t) {
				return t(e), e;
			}
			function Ic(e, t) {
				return t(e);
			}
			var Lc = ko(function(e) {
				var t = e.length, r = t ? e[0] : 0, i = this.__wrapped__, a = function(t) {
					return di(t, e);
				};
				return t > 1 || this.__actions__.length || !(i instanceof R) || !Xo(r) ? this.thru(a) : (i = i.slice(r, +r + +!!t), i.__actions__.push({
					func: Ic,
					args: [a],
					thisArg: n
				}), new wr(i, this.__chain__).thru(function(e) {
					return t && !e.length && e.push(n), e;
				}));
			});
			function Rc() {
				return Pc(this);
			}
			function zc() {
				return new wr(this.value(), this.__chain__);
			}
			function Bc() {
				this.__values__ === n && (this.__values__ = ju(this.value()));
				var e = this.__index__ >= this.__values__.length;
				return {
					done: e,
					value: e ? n : this.__values__[this.__index__++]
				};
			}
			function Vc() {
				return this;
			}
			function Hc(e) {
				for (var t, r = this; r instanceof Cr;) {
					var i = ws(r);
					i.__index__ = 0, i.__values__ = n, t ? a.__wrapped__ = i : t = i;
					var a = i;
					r = r.__wrapped__;
				}
				return a.__wrapped__ = e, t;
			}
			function Uc() {
				var e = this.__wrapped__;
				if (e instanceof R) {
					var t = e;
					return this.__actions__.length && (t = new R(this)), t = t.reverse(), t.__actions__.push({
						func: Ic,
						args: [rc],
						thisArg: n
					}), new wr(t, this.__chain__);
				}
				return this.thru(rc);
			}
			function Wc() {
				return ka(this.__wrapped__, this.__actions__);
			}
			var Gc = Qa(function(e, t, n) {
				T.call(e, n) ? ++e[n] : ui(e, n, 1);
			});
			function Kc(e, t, r) {
				var i = q(e) ? F : bi;
				return r && Zo(e, t, r) && (t = n), i(e, G(t, 3));
			}
			function qc(e, t) {
				return (q(e) ? yn : Ci)(e, G(t, 3));
			}
			var Jc = so(Is), Yc = so(Ls);
			function Xc(e, t) {
				return wi(al(e, t), 1);
			}
			function Zc(e, t) {
				return wi(al(e, t), h);
			}
			function Qc(e, t, r) {
				return r = r === n ? 1 : Z(r), wi(al(e, t), r);
			}
			function $c(e, t) {
				return (q(e) ? P : vi)(e, G(t, 3));
			}
			function el(e, t) {
				return (q(e) ? vn : yi)(e, G(t, 3));
			}
			var tl = Qa(function(e, t, n) {
				T.call(e, n) ? e[n].push(t) : ui(e, n, [t]);
			});
			function nl(e, t, n, r) {
				e = Ql(e) ? e : Cd(e), n = n && !r ? Z(n) : 0;
				var i = e.length;
				return n < 0 && (n = E(i + n, 0)), Cu(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && jn(e, t, n) > -1;
			}
			var rl = U(function(e, t, n) {
				var r = -1, i = typeof t == "function", a = Ql(e) ? S(e.length) : [];
				return vi(e, function(e) {
					a[++r] = i ? gn(t, e, n) : B(e, t, n);
				}), a;
			}), il = Qa(function(e, t, n) {
				ui(e, n, t);
			});
			function al(e, t) {
				return (q(e) ? I : Qi)(e, G(t, 3));
			}
			function ol(e, t, r, i) {
				return e == null ? [] : (q(t) || (t = t == null ? [] : [t]), r = i ? n : r, q(r) || (r = r == null ? [] : [r]), ia(e, t, r));
			}
			var sl = Qa(function(e, t, n) {
				e[+!n].push(t);
			}, function() {
				return [[], []];
			});
			function cl(e, t, n) {
				var r = q(e) ? Cn : Ln, i = arguments.length < 3;
				return r(e, G(t, 4), n, i, vi);
			}
			function ll(e, t, n) {
				var r = q(e) ? wn : Ln, i = arguments.length < 3;
				return r(e, G(t, 4), n, i, yi);
			}
			function ul(e, t) {
				return (q(e) ? yn : Ci)(e, Al(G(t, 3)));
			}
			function dl(e) {
				return (q(e) ? ni : pa)(e);
			}
			function fl(e, t, r) {
				return t = (r ? Zo(e, t, r) : t === n) ? 1 : Z(t), (q(e) ? ri : ma)(e, t);
			}
			function pl(e) {
				return (q(e) ? ii : va)(e);
			}
			function ml(e) {
				if (e == null) return 0;
				if (Ql(e)) return Cu(e) ? lr(e) : e.length;
				var t = Vo(e);
				return t == pe || t == ye ? e.size : H(e).length;
			}
			function hl(e, t, r) {
				var i = q(e) ? Tn : ya;
				return r && Zo(e, t, r) && (t = n), i(e, G(t, 3));
			}
			var gl = U(function(e, t) {
				if (e == null) return [];
				var n = t.length;
				return n > 1 && Zo(e, t[0], t[1]) ? t = [] : n > 2 && Zo(t[0], t[1], t[2]) && (t = [t[0]]), ia(e, wi(t, 1), []);
			}), _l = Vt || function() {
				return j.Date.now();
			};
			function vl(e, t) {
				if (typeof t != "function") throw new gt(r);
				return e = Z(e), function() {
					if (--e < 1) return t.apply(this, arguments);
				};
			}
			function yl(e, t, r) {
				return t = r ? n : t, t = e && t == null ? e.length : t, So(e, f, n, n, n, n, t);
			}
			function bl(e, t) {
				var i;
				if (typeof t != "function") throw new gt(r);
				return e = Z(e), function() {
					return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
				};
			}
			var xl = U(function(e, t, n) {
				var r = o;
				if (n.length) {
					var i = ir(n, Po(xl));
					r |= u;
				}
				return So(e, r, t, n, i);
			}), Sl = U(function(e, t, n) {
				var r = o | s;
				if (n.length) {
					var i = ir(n, Po(Sl));
					r |= u;
				}
				return So(t, r, e, n, i);
			});
			function Cl(e, t, r) {
				t = r ? n : t;
				var i = So(e, c, n, n, n, n, n, t);
				return i.placeholder = Cl.placeholder, i;
			}
			function wl(e, t, r) {
				t = r ? n : t;
				var i = So(e, l, n, n, n, n, n, t);
				return i.placeholder = wl.placeholder, i;
			}
			function Tl(e, t, i) {
				var a, o, s, c, l, u, d = 0, f = !1, p = !1, m = !0;
				if (typeof e != "function") throw new gt(r);
				t = Pu(t) || 0, Y(i) && (f = !!i.leading, p = "maxWait" in i, s = p ? E(Pu(i.maxWait) || 0, t) : s, m = "trailing" in i ? !!i.trailing : m);
				function h(t) {
					var r = a, i = o;
					return a = o = n, d = t, c = e.apply(i, r), c;
				}
				function g(e) {
					return d = e, l = hs(_, t), f ? h(e) : c;
				}
				function ee(e) {
					var n = e - u, r = e - d, i = t - n;
					return p ? en(i, s - r) : i;
				}
				function te(e) {
					var r = e - u, i = e - d;
					return u === n || r >= t || r < 0 || p && i >= s;
				}
				function _() {
					var e = _l();
					if (te(e)) return v(e);
					l = hs(_, ee(e));
				}
				function v(e) {
					return l = n, m && a ? h(e) : (a = o = n, c);
				}
				function ne() {
					l !== n && La(l), d = 0, a = u = o = l = n;
				}
				function re() {
					return l === n ? c : v(_l());
				}
				function ie() {
					var e = _l(), r = te(e);
					if (a = arguments, o = this, u = e, r) {
						if (l === n) return g(u);
						if (p) return La(l), l = hs(_, t), h(u);
					}
					return l === n && (l = hs(_, t)), c;
				}
				return ie.cancel = ne, ie.flush = re, ie;
			}
			var El = U(function(e, t) {
				return gi(e, 1, t);
			}), Dl = U(function(e, t, n) {
				return gi(e, Pu(t) || 0, n);
			});
			function Ol(e) {
				return So(e, m);
			}
			function kl(e, t) {
				if (typeof e != "function" || t != null && typeof t != "function") throw new gt(r);
				var n = function() {
					var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
					if (a.has(i)) return a.get(i);
					var o = e.apply(this, r);
					return n.cache = a.set(i, o) || a, o;
				};
				return n.cache = new (kl.Cache || Br)(), n;
			}
			kl.Cache = Br;
			function Al(e) {
				if (typeof e != "function") throw new gt(r);
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return !e.call(this);
						case 1: return !e.call(this, t[0]);
						case 2: return !e.call(this, t[0], t[1]);
						case 3: return !e.call(this, t[0], t[1], t[2]);
					}
					return !e.apply(this, t);
				};
			}
			function jl(e) {
				return bl(2, e);
			}
			var Ml = Fa(function(e, t) {
				t = t.length == 1 && q(t[0]) ? I(t[0], Un(G())) : I(wi(t, 1), Un(G()));
				var n = t.length;
				return U(function(r) {
					for (var i = -1, a = en(r.length, n); ++i < a;) r[i] = t[i].call(this, r[i]);
					return gn(e, this, r);
				});
			}), Nl = U(function(e, t) {
				return So(e, u, n, t, ir(t, Po(Nl)));
			}), Pl = U(function(e, t) {
				return So(e, d, n, t, ir(t, Po(Pl)));
			}), Fl = ko(function(e, t) {
				return So(e, p, n, n, n, t);
			});
			function Il(e, t) {
				if (typeof e != "function") throw new gt(r);
				return t = t === n ? t : Z(t), U(e, t);
			}
			function Ll(e, t) {
				if (typeof e != "function") throw new gt(r);
				return t = t == null ? 0 : E(Z(t), 0), U(function(n) {
					var r = n[t], i = Ia(n, 0, t);
					return r && Sn(i, r), gn(e, this, i);
				});
			}
			function Rl(e, t, n) {
				var i = !0, a = !0;
				if (typeof e != "function") throw new gt(r);
				return Y(n) && (i = "leading" in n ? !!n.leading : i, a = "trailing" in n ? !!n.trailing : a), Tl(e, t, {
					leading: i,
					maxWait: t,
					trailing: a
				});
			}
			function zl(e) {
				return yl(e, 1);
			}
			function Bl(e, t) {
				return Nl(Na(t), e);
			}
			function Vl() {
				if (!arguments.length) return [];
				var e = arguments[0];
				return q(e) ? e : [e];
			}
			function Hl(e) {
				return pi(e, 4);
			}
			function Ul(e, t) {
				return t = typeof t == "function" ? t : n, pi(e, 4, t);
			}
			function Wl(e) {
				return pi(e, 5);
			}
			function Gl(e, t) {
				return t = typeof t == "function" ? t : n, pi(e, 5, t);
			}
			function Kl(e, t) {
				return t == null || hi(e, t, $(t));
			}
			function ql(e, t) {
				return e === t || e !== e && t !== t;
			}
			var Jl = _o(Ni), Yl = _o(function(e, t) {
				return e >= t;
			}), Xl = zi(function() {
				return arguments;
			}()) ? zi : function(e) {
				return X(e) && T.call(e, "callee") && !Pt.call(e, "callee");
			}, q = S.isArray, Zl = dn ? Un(dn) : Bi;
			function Ql(e) {
				return e != null && uu(e.length) && !cu(e);
			}
			function J(e) {
				return X(e) && Ql(e);
			}
			function $l(e) {
				return e === !0 || e === !1 || X(e) && Mi(e) == se;
			}
			var eu = Kt || jf, tu = fn ? Un(fn) : Vi;
			function nu(e) {
				return X(e) && e.nodeType === 1 && !yu(e);
			}
			function ru(e) {
				if (e == null) return !0;
				if (Ql(e) && (q(e) || typeof e == "string" || typeof e.splice == "function" || eu(e) || Tu(e) || Xl(e))) return !e.length;
				var t = Vo(e);
				if (t == pe || t == ye) return !e.size;
				if (rs(e)) return !H(e).length;
				for (var n in e) if (T.call(e, n)) return !1;
				return !0;
			}
			function iu(e, t) {
				return V(e, t);
			}
			function au(e, t, r) {
				r = typeof r == "function" ? r : n;
				var i = r ? r(e, t) : n;
				return i === n ? V(e, t, n, r) : !!i;
			}
			function ou(e) {
				if (!X(e)) return !1;
				var t = Mi(e);
				return t == ue || t == le || typeof e.message == "string" && typeof e.name == "string" && !yu(e);
			}
			function su(e) {
				return typeof e == "number" && Yt(e);
			}
			function cu(e) {
				if (!Y(e)) return !1;
				var t = Mi(e);
				return t == de || t == fe || t == oe || t == _e;
			}
			function lu(e) {
				return typeof e == "number" && e == Z(e);
			}
			function uu(e) {
				return typeof e == "number" && e > -1 && e % 1 == 0 && e <= g;
			}
			function Y(e) {
				var t = typeof e;
				return e != null && (t == "object" || t == "function");
			}
			function X(e) {
				return typeof e == "object" && !!e;
			}
			var du = pn ? Un(pn) : Ui;
			function fu(e, t) {
				return e === t || Wi(e, t, Io(t));
			}
			function pu(e, t, r) {
				return r = typeof r == "function" ? r : n, Wi(e, t, Io(t), r);
			}
			function mu(e) {
				return vu(e) && e != +e;
			}
			function hu(e) {
				if (ns(e)) throw new ft("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
				return Gi(e);
			}
			function gu(e) {
				return e === null;
			}
			function _u(e) {
				return e == null;
			}
			function vu(e) {
				return typeof e == "number" || X(e) && Mi(e) == me;
			}
			function yu(e) {
				if (!X(e) || Mi(e) != y) return !1;
				var t = Mt(e);
				if (t === null) return !0;
				var n = T.call(t, "constructor") && t.constructor;
				return typeof n == "function" && n instanceof n && xt.call(n) == Tt;
			}
			var bu = mn ? Un(mn) : Ki;
			function xu(e) {
				return lu(e) && e >= -g && e <= g;
			}
			var Su = N ? Un(N) : qi;
			function Cu(e) {
				return typeof e == "string" || !q(e) && X(e) && Mi(e) == be;
			}
			function wu(e) {
				return typeof e == "symbol" || X(e) && Mi(e) == xe;
			}
			var Tu = hn ? Un(hn) : Ji;
			function Eu(e) {
				return e === n;
			}
			function Du(e) {
				return X(e) && Vo(e) == Ce;
			}
			function Ou(e) {
				return X(e) && Mi(e) == we;
			}
			var ku = _o(Zi), Au = _o(function(e, t) {
				return e <= t;
			});
			function ju(e) {
				if (!e) return [];
				if (Ql(e)) return Cu(e) ? ur(e) : Ja(e);
				if (Lt && e[Lt]) return tr(e[Lt]());
				var t = Vo(e);
				return (t == pe ? nr : t == ye ? ar : Cd)(e);
			}
			function Mu(e) {
				return e ? (e = Pu(e), e === h || e === -Infinity ? (e < 0 ? -1 : 1) * ee : e === e ? e : 0) : e === 0 ? e : 0;
			}
			function Z(e) {
				var t = Mu(e), n = t % 1;
				return t === t ? n ? t - n : t : 0;
			}
			function Nu(e) {
				return e ? fi(Z(e), 0, _) : 0;
			}
			function Pu(e) {
				if (typeof e == "number") return e;
				if (wu(e)) return te;
				if (Y(e)) {
					var t = typeof e.valueOf == "function" ? e.valueOf() : e;
					e = Y(t) ? t + "" : t;
				}
				if (typeof e != "string") return e === 0 ? e : +e;
				e = Hn(e);
				var n = at.test(e);
				return n || st.test(e) ? on(e.slice(2), n ? 2 : 8) : it.test(e) ? te : +e;
			}
			function Fu(e) {
				return Ya(e, ad(e));
			}
			function Iu(e) {
				return e ? fi(Z(e), -g, g) : e === 0 ? e : 0;
			}
			function Q(e) {
				return e == null ? "" : wa(e);
			}
			var Lu = $a(function(e, t) {
				if (rs(t) || Ql(t)) {
					Ya(t, $(t), e);
					return;
				}
				for (var n in t) T.call(t, n) && oi(e, n, t[n]);
			}), Ru = $a(function(e, t) {
				Ya(t, ad(t), e);
			}), zu = $a(function(e, t, n, r) {
				Ya(t, ad(t), e, r);
			}), Bu = $a(function(e, t, n, r) {
				Ya(t, $(t), e, r);
			}), Vu = ko(di);
			function Hu(e, t) {
				var n = Sr(e);
				return t == null ? n : ci(n, t);
			}
			var Uu = U(function(e, t) {
				e = C(e);
				var r = -1, i = t.length, a = i > 2 ? t[2] : n;
				for (a && Zo(t[0], t[1], a) && (i = 1); ++r < i;) for (var o = t[r], s = ad(o), c = -1, l = s.length; ++c < l;) {
					var u = s[c], d = e[u];
					(d === n || ql(d, yt[u]) && !T.call(e, u)) && (e[u] = o[u]);
				}
				return e;
			}), Wu = U(function(e) {
				return e.push(n, wo), gn(ld, n, e);
			});
			function Gu(e, t) {
				return kn(e, G(t, 3), Di);
			}
			function Ku(e, t) {
				return kn(e, G(t, 3), Oi);
			}
			function qu(e, t) {
				return e == null ? e : Ti(e, G(t, 3), ad);
			}
			function Ju(e, t) {
				return e == null ? e : Ei(e, G(t, 3), ad);
			}
			function Yu(e, t) {
				return e && Di(e, G(t, 3));
			}
			function Xu(e, t) {
				return e && Oi(e, G(t, 3));
			}
			function Zu(e) {
				return e == null ? [] : ki(e, $(e));
			}
			function Qu(e) {
				return e == null ? [] : ki(e, ad(e));
			}
			function $u(e, t, r) {
				var i = e == null ? n : Ai(e, t);
				return i === n ? r : i;
			}
			function ed(e, t) {
				return e != null && Wo(e, t, Pi);
			}
			function td(e, t) {
				return e != null && Wo(e, t, Fi);
			}
			var nd = uo(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = wt.call(t)), e[t] = n;
			}, lf(pf)), rd = uo(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = wt.call(t)), T.call(e, t) ? e[t].push(n) : e[t] = [n];
			}, G), id = U(B);
			function $(e) {
				return Ql(e) ? ti(e) : H(e);
			}
			function ad(e) {
				return Ql(e) ? ti(e, !0) : Xi(e);
			}
			function od(e, t) {
				var n = {};
				return t = G(t, 3), Di(e, function(e, r, i) {
					ui(n, t(e, r, i), e);
				}), n;
			}
			function sd(e, t) {
				var n = {};
				return t = G(t, 3), Di(e, function(e, r, i) {
					ui(n, r, t(e, r, i));
				}), n;
			}
			var cd = $a(function(e, t, n) {
				ta(e, t, n);
			}), ld = $a(function(e, t, n, r) {
				ta(e, t, n, r);
			}), ud = ko(function(e, t) {
				var n = {};
				if (e == null) return n;
				var r = !1;
				t = I(t, function(t) {
					return t = Pa(t, e), r ||= t.length > 1, t;
				}), Ya(e, jo(e), n), r && (n = pi(n, 7, To));
				for (var i = t.length; i--;) Ea(n, t[i]);
				return n;
			});
			function dd(e, t) {
				return pd(e, Al(G(t)));
			}
			var fd = ko(function(e, t) {
				return e == null ? {} : aa(e, t);
			});
			function pd(e, t) {
				if (e == null) return {};
				var n = I(jo(e), function(e) {
					return [e];
				});
				return t = G(t), oa(e, n, function(e, n) {
					return t(e, n[0]);
				});
			}
			function md(e, t, r) {
				t = Pa(t, e);
				var i = -1, a = t.length;
				for (a || (a = 1, e = n); ++i < a;) {
					var o = e == null ? n : e[xs(t[i])];
					o === n && (i = a, o = r), e = cu(o) ? o.call(e) : o;
				}
				return e;
			}
			function hd(e, t, n) {
				return e == null ? e : ha(e, t, n);
			}
			function gd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : ha(e, t, r, i);
			}
			var _d = xo($), vd = xo(ad);
			function yd(e, t, n) {
				var r = q(e), i = r || eu(e) || Tu(e);
				if (t = G(t, 4), n == null) {
					var a = e && e.constructor;
					n = i ? r ? new a() : [] : Y(e) && cu(a) ? Sr(Mt(e)) : {};
				}
				return (i ? P : Di)(e, function(e, r, i) {
					return t(n, e, r, i);
				}), n;
			}
			function bd(e, t) {
				return e == null || Ea(e, t);
			}
			function xd(e, t, n) {
				return e == null ? e : Da(e, t, Na(n));
			}
			function Sd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : Da(e, t, Na(r), i);
			}
			function Cd(e) {
				return e == null ? [] : Wn(e, $(e));
			}
			function wd(e) {
				return e == null ? [] : Wn(e, ad(e));
			}
			function Td(e, t, r) {
				return r === n && (r = t, t = n), r !== n && (r = Pu(r), r = r === r ? r : 0), t !== n && (t = Pu(t), t = t === t ? t : 0), fi(Pu(e), t, r);
			}
			function Ed(e, t, r) {
				return t = Mu(t), r === n ? (r = t, t = 0) : r = Mu(r), e = Pu(e), Ii(e, t, r);
			}
			function Dd(e, t, r) {
				if (r && typeof r != "boolean" && Zo(e, t, r) && (t = r = n), r === n && (typeof t == "boolean" ? (r = t, t = n) : typeof e == "boolean" && (r = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = Mu(e), t === n ? (t = e, e = 0) : t = Mu(t)), e > t) {
					var i = e;
					e = t, t = i;
				}
				if (r || e % 1 || t % 1) {
					var a = rn();
					return en(e + a * (t - e + an("1e-" + ((a + "").length - 1))), t);
				}
				return ua(e, t);
			}
			var Od = io(function(e, t, n) {
				return t = t.toLowerCase(), e + (n ? kd(t) : t);
			});
			function kd(e) {
				return nf(Q(e).toLowerCase());
			}
			function Ad(e) {
				return e = Q(e), e && e.replace(lt, Yn).replace(Jt, "");
			}
			function jd(e, t, r) {
				e = Q(e), t = wa(t);
				var i = e.length;
				r = r === n ? i : fi(Z(r), 0, i);
				var a = r;
				return r -= t.length, r >= 0 && e.slice(r, a) == t;
			}
			function Md(e) {
				return e = Q(e), e && Be.test(e) ? e.replace(Re, Xn) : e;
			}
			function Nd(e) {
				return e = Q(e), e && Je.test(e) ? e.replace(qe, "\\$&") : e;
			}
			var Pd = io(function(e, t, n) {
				return e + (n ? "-" : "") + t.toLowerCase();
			}), Fd = io(function(e, t, n) {
				return e + (n ? " " : "") + t.toLowerCase();
			}), Id = ro("toLowerCase");
			function Ld(e, t, n) {
				e = Q(e), t = Z(t);
				var r = t ? lr(e) : 0;
				if (!t || r >= t) return e;
				var i = (t - r) / 2;
				return mo(Wt(i), n) + e + mo(Ut(i), n);
			}
			function Rd(e, t, n) {
				e = Q(e), t = Z(t);
				var r = t ? lr(e) : 0;
				return t && r < t ? e + mo(t - r, n) : e;
			}
			function zd(e, t, n) {
				e = Q(e), t = Z(t);
				var r = t ? lr(e) : 0;
				return t && r < t ? mo(t - r, n) + e : e;
			}
			function Bd(e, t, n) {
				return n || t == null ? t = 0 : t &&= +t, nn(Q(e).replace(Ye, ""), t || 0);
			}
			function Vd(e, t, r) {
				return t = (r ? Zo(e, t, r) : t === n) ? 1 : Z(t), fa(Q(e), t);
			}
			function Hd() {
				var e = arguments, t = Q(e[0]);
				return e.length < 3 ? t : t.replace(e[1], e[2]);
			}
			var Ud = io(function(e, t, n) {
				return e + (n ? "_" : "") + t.toLowerCase();
			});
			function Wd(e, t, r) {
				return r && typeof r != "number" && Zo(e, t, r) && (t = r = n), r = r === n ? _ : r >>> 0, r ? (e = Q(e), e && (typeof t == "string" || t != null && !bu(t)) && (t = wa(t), !t && $n(e)) ? Ia(ur(e), 0, r) : e.split(t, r)) : [];
			}
			var Gd = io(function(e, t, n) {
				return e + (n ? " " : "") + nf(t);
			});
			function Kd(e, t, n) {
				return e = Q(e), n = n == null ? 0 : fi(Z(n), 0, e.length), t = wa(t), e.slice(n, n + t.length) == t;
			}
			function qd(e, t, r) {
				var i = L.templateSettings;
				r && Zo(e, t, r) && (t = n), e = Q(e), t = Bu({}, t, i, Co);
				var a = Bu({}, t.imports, i.imports, Co), o = $(a), s = Wn(a, o);
				P(o, function(e) {
					if (et.test(e)) throw new ft("Invalid `imports` option passed into `_.template`");
				});
				var c, l, u = 0, d = t.interpolate || ut, f = "__p += '", p = w((t.escape || ut).source + "|" + d.source + "|" + (d === Ue ? nt : ut).source + "|" + (t.evaluate || ut).source + "|$", "g"), m = "//# sourceURL=" + (T.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++$t + "]") + "\n";
				e.replace(p, function(t, n, r, i, a, o) {
					return r ||= i, f += e.slice(u, o).replace(dt, Zn), n && (c = !0, f += "' +\n__e(" + n + ") +\n'"), a && (l = !0, f += "';\n" + a + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), u = o + t.length, t;
				}), f += "';\n";
				var h = T.call(t, "variable") && t.variable;
				if (!h) f = "with (obj) {\n" + f + "\n}\n";
				else if (et.test(h)) throw new ft("Invalid `variable` option passed into `_.template`");
				f = (l ? f.replace(Fe, "") : f).replace(x, "$1").replace(Ie, "$1;"), f = "function(" + (h || "obj") + ") {\n" + (h ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
				var g = af(function() {
					return pt(o, m + "return " + f).apply(n, s);
				});
				if (g.source = f, ou(g)) throw g;
				return g;
			}
			function Jd(e) {
				return Q(e).toLowerCase();
			}
			function Yd(e) {
				return Q(e).toUpperCase();
			}
			function Xd(e, t, r) {
				if (e = Q(e), e && (r || t === n)) return Hn(e);
				if (!e || !(t = wa(t))) return e;
				var i = ur(e), a = ur(t);
				return Ia(i, Kn(i, a), qn(i, a) + 1).join("");
			}
			function Zd(e, t, r) {
				if (e = Q(e), e && (r || t === n)) return e.slice(0, dr(e) + 1);
				if (!e || !(t = wa(t))) return e;
				var i = ur(e);
				return Ia(i, 0, qn(i, ur(t)) + 1).join("");
			}
			function Qd(e, t, r) {
				if (e = Q(e), e && (r || t === n)) return e.replace(Ye, "");
				if (!e || !(t = wa(t))) return e;
				var i = ur(e);
				return Ia(i, Kn(i, ur(t))).join("");
			}
			function $d(e, t) {
				var r = 30, i = "...";
				if (Y(t)) {
					var a = "separator" in t ? t.separator : a;
					r = "length" in t ? Z(t.length) : r, i = "omission" in t ? wa(t.omission) : i;
				}
				e = Q(e);
				var o = e.length;
				if ($n(e)) {
					var s = ur(e);
					o = s.length;
				}
				if (r >= o) return e;
				var c = r - lr(i);
				if (c < 1) return i;
				var l = s ? Ia(s, 0, c).join("") : e.slice(0, c);
				if (a === n) return l + i;
				if (s && (c += l.length - c), bu(a)) {
					if (e.slice(c).search(a)) {
						var u, d = l;
						for (a.global || (a = w(a.source, Q(rt.exec(a)) + "g")), a.lastIndex = 0; u = a.exec(d);) var f = u.index;
						l = l.slice(0, f === n ? c : f);
					}
				} else if (e.indexOf(wa(a), c) != c) {
					var p = l.lastIndexOf(a);
					p > -1 && (l = l.slice(0, p));
				}
				return l + i;
			}
			function ef(e) {
				return e = Q(e), e && ze.test(e) ? e.replace(Le, fr) : e;
			}
			var tf = io(function(e, t, n) {
				return e + (n ? " " : "") + t.toUpperCase();
			}), nf = ro("toUpperCase");
			function rf(e, t, r) {
				return e = Q(e), t = r ? n : t, t === n ? er(e) ? hr(e) : On(e) : e.match(t) || [];
			}
			var af = U(function(e, t) {
				try {
					return gn(e, n, t);
				} catch (e) {
					return ou(e) ? e : new ft(e);
				}
			}), of = ko(function(e, t) {
				return P(t, function(t) {
					t = xs(t), ui(e, t, xl(e[t], e));
				}), e;
			});
			function sf(e) {
				var t = e == null ? 0 : e.length, n = G();
				return e = t ? I(e, function(e) {
					if (typeof e[1] != "function") throw new gt(r);
					return [n(e[0]), e[1]];
				}) : [], U(function(n) {
					for (var r = -1; ++r < t;) {
						var i = e[r];
						if (gn(i[0], this, n)) return gn(i[1], this, n);
					}
				});
			}
			function cf(e) {
				return mi(pi(e, 1));
			}
			function lf(e) {
				return function() {
					return e;
				};
			}
			function uf(e, t) {
				return e == null || e !== e ? t : e;
			}
			var df = co(), ff = co(!0);
			function pf(e) {
				return e;
			}
			function mf(e) {
				return Yi(typeof e == "function" ? e : pi(e, 1));
			}
			function hf(e) {
				return $i(pi(e, 1));
			}
			function gf(e, t) {
				return ea(e, pi(t, 1));
			}
			var _f = U(function(e, t) {
				return function(n) {
					return B(n, e, t);
				};
			}), vf = U(function(e, t) {
				return function(n) {
					return B(e, n, t);
				};
			});
			function yf(e, t, n) {
				var r = $(t), i = ki(t, r);
				n == null && (!Y(t) || !i.length && r.length) && (n = t, t = e, e = this, i = ki(t, $(t)));
				var a = !(Y(n) && "chain" in n) || !!n.chain, o = cu(e);
				return P(i, function(n) {
					var r = t[n];
					e[n] = r, o && (e.prototype[n] = function() {
						var t = this.__chain__;
						if (a || t) {
							var n = e(this.__wrapped__);
							return (n.__actions__ = Ja(this.__actions__)).push({
								func: r,
								args: arguments,
								thisArg: e
							}), n.__chain__ = t, n;
						}
						return r.apply(e, Sn([this.value()], arguments));
					});
				}), e;
			}
			function bf() {
				return j._ === this && (j._ = Et), this;
			}
			function xf() {}
			function Sf(e) {
				return e = Z(e), U(function(t) {
					return ra(t, e);
				});
			}
			var Cf = po(I), wf = po(F), Tf = po(Tn);
			function Ef(e) {
				return Qo(e) ? Fn(xs(e)) : sa(e);
			}
			function Df(e) {
				return function(t) {
					return e == null ? n : Ai(e, t);
				};
			}
			var Of = go(), kf = go(!0);
			function Af() {
				return [];
			}
			function jf() {
				return !1;
			}
			function Mf() {
				return {};
			}
			function Nf() {
				return "";
			}
			function Pf() {
				return !0;
			}
			function Ff(e, t) {
				if (e = Z(e), e < 1 || e > g) return [];
				var n = _, r = en(e, _);
				t = G(t), e -= _;
				for (var i = Bn(r, t); ++n < e;) t(n);
				return i;
			}
			function If(e) {
				return q(e) ? I(e, xs) : wu(e) ? [e] : Ja(bs(Q(e)));
			}
			function Lf(e) {
				var t = ++St;
				return Q(e) + t;
			}
			var Rf = fo(function(e, t) {
				return e + t;
			}, 0), zf = yo("ceil"), Bf = fo(function(e, t) {
				return e / t;
			}, 1), Vf = yo("floor");
			function Hf(e) {
				return e && e.length ? xi(e, pf, Ni) : n;
			}
			function Uf(e, t) {
				return e && e.length ? xi(e, G(t, 2), Ni) : n;
			}
			function Wf(e) {
				return Pn(e, pf);
			}
			function Gf(e, t) {
				return Pn(e, G(t, 2));
			}
			function Kf(e) {
				return e && e.length ? xi(e, pf, Zi) : n;
			}
			function qf(e, t) {
				return e && e.length ? xi(e, G(t, 2), Zi) : n;
			}
			var Jf = fo(function(e, t) {
				return e * t;
			}, 1), Yf = yo("round"), Xf = fo(function(e, t) {
				return e - t;
			}, 0);
			function Zf(e) {
				return e && e.length ? zn(e, pf) : 0;
			}
			function Qf(e, t) {
				return e && e.length ? zn(e, G(t, 2)) : 0;
			}
			return L.after = vl, L.ary = yl, L.assign = Lu, L.assignIn = Ru, L.assignInWith = zu, L.assignWith = Bu, L.at = Vu, L.before = bl, L.bind = xl, L.bindAll = of, L.bindKey = Sl, L.castArray = Vl, L.chain = Pc, L.chunk = Ts, L.compact = Es, L.concat = Ds, L.cond = sf, L.conforms = cf, L.constant = lf, L.countBy = Gc, L.create = Hu, L.curry = Cl, L.curryRight = wl, L.debounce = Tl, L.defaults = Uu, L.defaultsDeep = Wu, L.defer = El, L.delay = Dl, L.difference = Os, L.differenceBy = ks, L.differenceWith = As, L.drop = js, L.dropRight = Ms, L.dropRightWhile = Ns, L.dropWhile = Ps, L.fill = Fs, L.filter = qc, L.flatMap = Xc, L.flatMapDeep = Zc, L.flatMapDepth = Qc, L.flatten = Rs, L.flattenDeep = zs, L.flattenDepth = Bs, L.flip = Ol, L.flow = df, L.flowRight = ff, L.fromPairs = Vs, L.functions = Zu, L.functionsIn = Qu, L.groupBy = tl, L.initial = Ws, L.intersection = Gs, L.intersectionBy = Ks, L.intersectionWith = qs, L.invert = nd, L.invertBy = rd, L.invokeMap = rl, L.iteratee = mf, L.keyBy = il, L.keys = $, L.keysIn = ad, L.map = al, L.mapKeys = od, L.mapValues = sd, L.matches = hf, L.matchesProperty = gf, L.memoize = kl, L.merge = cd, L.mergeWith = ld, L.method = _f, L.methodOf = vf, L.mixin = yf, L.negate = Al, L.nthArg = Sf, L.omit = ud, L.omitBy = dd, L.once = jl, L.orderBy = ol, L.over = Cf, L.overArgs = Ml, L.overEvery = wf, L.overSome = Tf, L.partial = Nl, L.partialRight = Pl, L.partition = sl, L.pick = fd, L.pickBy = pd, L.property = Ef, L.propertyOf = Df, L.pull = Qs, L.pullAll = $s, L.pullAllBy = ec, L.pullAllWith = K, L.pullAt = tc, L.range = Of, L.rangeRight = kf, L.rearg = Fl, L.reject = ul, L.remove = nc, L.rest = Il, L.reverse = rc, L.sampleSize = fl, L.set = hd, L.setWith = gd, L.shuffle = pl, L.slice = ic, L.sortBy = gl, L.sortedUniq = dc, L.sortedUniqBy = fc, L.split = Wd, L.spread = Ll, L.tail = pc, L.take = mc, L.takeRight = hc, L.takeRightWhile = gc, L.takeWhile = _c, L.tap = Fc, L.throttle = Rl, L.thru = Ic, L.toArray = ju, L.toPairs = _d, L.toPairsIn = vd, L.toPath = If, L.toPlainObject = Fu, L.transform = yd, L.unary = zl, L.union = vc, L.unionBy = yc, L.unionWith = bc, L.uniq = xc, L.uniqBy = Sc, L.uniqWith = Cc, L.unset = bd, L.unzip = wc, L.unzipWith = Tc, L.update = xd, L.updateWith = Sd, L.values = Cd, L.valuesIn = wd, L.without = Ec, L.words = rf, L.wrap = Bl, L.xor = Dc, L.xorBy = Oc, L.xorWith = kc, L.zip = Ac, L.zipObject = jc, L.zipObjectDeep = Mc, L.zipWith = Nc, L.entries = _d, L.entriesIn = vd, L.extend = Ru, L.extendWith = zu, yf(L, L), L.add = Rf, L.attempt = af, L.camelCase = Od, L.capitalize = kd, L.ceil = zf, L.clamp = Td, L.clone = Hl, L.cloneDeep = Wl, L.cloneDeepWith = Gl, L.cloneWith = Ul, L.conformsTo = Kl, L.deburr = Ad, L.defaultTo = uf, L.divide = Bf, L.endsWith = jd, L.eq = ql, L.escape = Md, L.escapeRegExp = Nd, L.every = Kc, L.find = Jc, L.findIndex = Is, L.findKey = Gu, L.findLast = Yc, L.findLastIndex = Ls, L.findLastKey = Ku, L.floor = Vf, L.forEach = $c, L.forEachRight = el, L.forIn = qu, L.forInRight = Ju, L.forOwn = Yu, L.forOwnRight = Xu, L.get = $u, L.gt = Jl, L.gte = Yl, L.has = ed, L.hasIn = td, L.head = Hs, L.identity = pf, L.includes = nl, L.indexOf = Us, L.inRange = Ed, L.invoke = id, L.isArguments = Xl, L.isArray = q, L.isArrayBuffer = Zl, L.isArrayLike = Ql, L.isArrayLikeObject = J, L.isBoolean = $l, L.isBuffer = eu, L.isDate = tu, L.isElement = nu, L.isEmpty = ru, L.isEqual = iu, L.isEqualWith = au, L.isError = ou, L.isFinite = su, L.isFunction = cu, L.isInteger = lu, L.isLength = uu, L.isMap = du, L.isMatch = fu, L.isMatchWith = pu, L.isNaN = mu, L.isNative = hu, L.isNil = _u, L.isNull = gu, L.isNumber = vu, L.isObject = Y, L.isObjectLike = X, L.isPlainObject = yu, L.isRegExp = bu, L.isSafeInteger = xu, L.isSet = Su, L.isString = Cu, L.isSymbol = wu, L.isTypedArray = Tu, L.isUndefined = Eu, L.isWeakMap = Du, L.isWeakSet = Ou, L.join = Js, L.kebabCase = Pd, L.last = Ys, L.lastIndexOf = Xs, L.lowerCase = Fd, L.lowerFirst = Id, L.lt = ku, L.lte = Au, L.max = Hf, L.maxBy = Uf, L.mean = Wf, L.meanBy = Gf, L.min = Kf, L.minBy = qf, L.stubArray = Af, L.stubFalse = jf, L.stubObject = Mf, L.stubString = Nf, L.stubTrue = Pf, L.multiply = Jf, L.nth = Zs, L.noConflict = bf, L.noop = xf, L.now = _l, L.pad = Ld, L.padEnd = Rd, L.padStart = zd, L.parseInt = Bd, L.random = Dd, L.reduce = cl, L.reduceRight = ll, L.repeat = Vd, L.replace = Hd, L.result = md, L.round = Yf, L.runInContext = e, L.sample = dl, L.size = ml, L.snakeCase = Ud, L.some = hl, L.sortedIndex = ac, L.sortedIndexBy = oc, L.sortedIndexOf = sc, L.sortedLastIndex = cc, L.sortedLastIndexBy = lc, L.sortedLastIndexOf = uc, L.startCase = Gd, L.startsWith = Kd, L.subtract = Xf, L.sum = Zf, L.sumBy = Qf, L.template = qd, L.times = Ff, L.toFinite = Mu, L.toInteger = Z, L.toLength = Nu, L.toLower = Jd, L.toNumber = Pu, L.toSafeInteger = Iu, L.toString = Q, L.toUpper = Yd, L.trim = Xd, L.trimEnd = Zd, L.trimStart = Qd, L.truncate = $d, L.unescape = ef, L.uniqueId = Lf, L.upperCase = tf, L.upperFirst = nf, L.each = $c, L.eachRight = el, L.first = Hs, yf(L, function() {
				var e = {};
				return Di(L, function(t, n) {
					T.call(L.prototype, n) || (e[n] = t);
				}), e;
			}(), { chain: !1 }), L.VERSION = "4.18.1", P([
				"bind",
				"bindKey",
				"curry",
				"curryRight",
				"partial",
				"partialRight"
			], function(e) {
				L[e].placeholder = L;
			}), P(["drop", "take"], function(e, t) {
				R.prototype[e] = function(r) {
					r = r === n ? 1 : E(Z(r), 0);
					var i = this.__filtered__ && !t ? new R(this) : this.clone();
					return i.__filtered__ ? i.__takeCount__ = en(r, i.__takeCount__) : i.__views__.push({
						size: en(r, _),
						type: e + (i.__dir__ < 0 ? "Right" : "")
					}), i;
				}, R.prototype[e + "Right"] = function(t) {
					return this.reverse()[e](t).reverse();
				};
			}), P([
				"filter",
				"map",
				"takeWhile"
			], function(e, t) {
				var n = t + 1, r = n == 1 || n == 3;
				R.prototype[e] = function(e) {
					var t = this.clone();
					return t.__iteratees__.push({
						iteratee: G(e, 3),
						type: n
					}), t.__filtered__ = t.__filtered__ || r, t;
				};
			}), P(["head", "last"], function(e, t) {
				var n = "take" + (t ? "Right" : "");
				R.prototype[e] = function() {
					return this[n](1).value()[0];
				};
			}), P(["initial", "tail"], function(e, t) {
				var n = "drop" + (t ? "" : "Right");
				R.prototype[e] = function() {
					return this.__filtered__ ? new R(this) : this[n](1);
				};
			}), R.prototype.compact = function() {
				return this.filter(pf);
			}, R.prototype.find = function(e) {
				return this.filter(e).head();
			}, R.prototype.findLast = function(e) {
				return this.reverse().find(e);
			}, R.prototype.invokeMap = U(function(e, t) {
				return typeof e == "function" ? new R(this) : this.map(function(n) {
					return B(n, e, t);
				});
			}), R.prototype.reject = function(e) {
				return this.filter(Al(G(e)));
			}, R.prototype.slice = function(e, t) {
				e = Z(e);
				var r = this;
				return r.__filtered__ && (e > 0 || t < 0) ? new R(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== n && (t = Z(t), r = t < 0 ? r.dropRight(-t) : r.take(t - e)), r);
			}, R.prototype.takeRightWhile = function(e) {
				return this.reverse().takeWhile(e).reverse();
			}, R.prototype.toArray = function() {
				return this.take(_);
			}, Di(R.prototype, function(e, t) {
				var r = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), a = L[i ? "take" + (t == "last" ? "Right" : "") : t], o = i || /^find/.test(t);
				a && (L.prototype[t] = function() {
					var t = this.__wrapped__, s = i ? [1] : arguments, c = t instanceof R, l = s[0], u = c || q(t), d = function(e) {
						var t = a.apply(L, Sn([e], s));
						return i && f ? t[0] : t;
					};
					u && r && typeof l == "function" && l.length != 1 && (c = u = !1);
					var f = this.__chain__, p = !!this.__actions__.length, m = o && !f, h = c && !p;
					if (!o && u) {
						t = h ? t : new R(this);
						var g = e.apply(t, s);
						return g.__actions__.push({
							func: Ic,
							args: [d],
							thisArg: n
						}), new wr(g, f);
					}
					return m && h ? e.apply(this, s) : (g = this.thru(d), m ? i ? g.value()[0] : g.value() : g);
				});
			}), P([
				"pop",
				"push",
				"shift",
				"sort",
				"splice",
				"unshift"
			], function(e) {
				var t = _t[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
				L.prototype[e] = function() {
					var e = arguments;
					if (r && !this.__chain__) {
						var i = this.value();
						return t.apply(q(i) ? i : [], e);
					}
					return this[n](function(n) {
						return t.apply(q(n) ? n : [], e);
					});
				};
			}), Di(R.prototype, function(e, t) {
				var n = L[t];
				if (n) {
					var r = n.name + "";
					T.call(In, r) || (In[r] = []), In[r].push({
						name: t,
						func: n
					});
				}
			}), In[lo(n, s).name] = [{
				name: "wrapper",
				func: n
			}], R.prototype.clone = Tr, R.prototype.reverse = Er, R.prototype.value = Dr, L.prototype.at = Lc, L.prototype.chain = Rc, L.prototype.commit = zc, L.prototype.next = Bc, L.prototype.plant = Hc, L.prototype.reverse = Uc, L.prototype.toJSON = L.prototype.valueOf = L.prototype.value = Wc, L.prototype.first = L.prototype.head, Lt && (L.prototype[Lt] = Vc), L;
		})();
		typeof define == "function" && typeof define.amd == "object" && define.amd ? (j._ = gr, define(function() {
			return gr;
		})) : cn ? ((cn.exports = gr)._ = gr, sn._ = gr) : j._ = gr;
	}).call(e);
})))(), jn = /* @__PURE__ */ new Map(), Mn = new re();
Mn.name = "debug-objects";
function Nn() {
	return window.viewer?.settings.dev.drawDebug.value ?? !1;
}
function Pn(e, t) {
	let n = jn.get(e) ?? [];
	n.push(t), jn.set(e, n), window.viewer?.scene._internalScene.add(Mn), Mn.add(t), window.viewer?.requestRender();
}
function Fn(e) {
	e.forEach((e) => Mn.remove(e)), window.viewer?.requestRender();
}
function In(e, t = {}) {
	if (Nn()) {
		let { color: n = "red", size: r = .03, tag: i = "default" } = t, a = new ge(new je(r), new _e({ color: n }));
		a.position.copy(e), Pn(i, a);
	}
}
function Ln(e, t = {}) {
	if (Nn()) {
		let { color: n = "red", tag: r = "default" } = t;
		Pn(r, new o(e, n));
	}
}
function Rn(e, t = {}) {
	if (Nn()) {
		let { color: n = "red", tag: r = "default" } = t, i = new de(new l(), new le({ color: n }));
		i.geometry.setFromPoints(e), Pn(r, i);
	}
}
function zn(e = "default") {
	let t = jn.get(e);
	t && Fn(t), jn.delete(e);
}
function Bn() {
	for (let e of jn.values()) Fn(e);
	jn.clear();
}
var Vn = {
	drawBox: Ln,
	drawLine: Rn,
	drawSphere: In,
	clearAllObjects: Bn,
	clearTagObjects: zn
}, Hn = /* @__PURE__ */ new b(), Un = class extends yt {
	constructor(...e) {
		super(...e), this.name = "SettingsUpdateBehavior", this.signals = [], this.callbackMap = new Wn(), this._onDebugChanged = (e) => {
			this._viewer.settings.dev.showDevTools.value = e, e || (this._viewer.settings.dev.showInfoTools.value = !1);
		}, this._onShowInfoToolsChanged = (e) => {
			this._viewer.developerTools.showInfoTools = e;
		}, this._onShowDevToolsChanged = (e) => {
			this._viewer.developerTools.showDevTools = e;
		}, this._onResolutionScalingChanged = () => {
			this._viewer.viewport?.renderer.forceResize();
		}, this._onEdgesColorChanged = (0, An.debounce)((e) => {
			for (let t of this._viewer.scene.controllers) {
				let n = t;
				if (n.isSceneMeshController) for (let t of n.getAllObjects()) t.edgesColor = e;
			}
			this._viewer.requestRender();
		}, 300), this._onHighlightColorChanged = (e) => {
			for (let t of this._viewer.scene.controllers) {
				let n = t;
				if (n.isSceneMeshController) for (let t of n.containers()) {
					let n = t.getMaterials([
						N.SelectedOpaque,
						N.SelectedTransparent,
						N.SelectedXRay
					]);
					for (let t of n) t.name.includes("BatchedMesh") && t.color.set(e);
				}
			}
			this._viewer.requestRender();
		}, this._onBackgroundColorChanged = (e) => {
			this._viewer.scene.background !== e && (this._viewer.scene.background = e, this._viewer.requestRender());
		}, this._onRendererSettingsChanged = () => {
			this._viewer.viewport?.renderer.updateFromSettings(this._viewer.settings), this._viewer.requestRender();
		}, this._onSkyMieCoefficientChanged = (e) => {
			this._viewer.scene.lightsController.sky.material.uniforms.mieCoefficient.value = e, this._viewer.requestRender();
		}, this._onSkyMieDirectionalGChanged = (e) => {
			this._viewer.scene.lightsController.sky.material.uniforms.mieDirectionalG.value = e, this._viewer.requestRender();
		}, this._onSkyRayleighChanged = (e) => {
			this._viewer.scene.lightsController.sky.material.uniforms.rayleigh.value = e, this._viewer.requestRender();
		}, this._onSkyTurbidityChanged = (e) => {
			this._viewer.scene.lightsController.sky.material.uniforms.turbidity.value = e, this._viewer.requestRender();
		}, this._onHemisphereLightIntensityChanged = (e) => {
			this._viewer.scene.lightsController.hemisphereLight.intensity !== e && (this._viewer.scene.lightsController.hemisphereLight.intensity = e, this._viewer.requestRender());
		}, this._onDirectionalLightIntensityChanged = (e) => {
			this._viewer.scene.lightsController.directionalLight.intensity !== e && (this._viewer.scene.lightsController.skyElevation <= 90 || this._viewer.scene.lightsController.skyElevation >= 270) && (this._viewer.scene.lightsController.directionalLight.intensity = e, this._viewer.requestRender());
		}, this._onCameraLightIntensityChanged = (e) => {
			this._viewer.viewport && this._viewer.viewport.cameraLight.intensity !== e && (this._viewer.viewport.cameraLight.intensity = e, this._viewer.requestRender());
		}, this._onSkyElevationChanged = (e) => {
			this._viewer.scene.getBoundingSphere(Hn), this._viewer.scene.lightsController.skyElevation = e, this._viewer.scene.lightsController.updateSun(), this._viewer.requestRender();
		}, this._onSkyAzimuthChanged = (e) => {
			this._viewer.scene.getBoundingSphere(Hn), this._viewer.scene.lightsController.skyAzimuth = e, this._viewer.scene.lightsController.updateSun(), this._viewer.requestRender();
		}, this._onEnvMapIntensityChanged = (e) => {
			this._viewer.scene._internalScene.environmentIntensity !== e && (this._viewer.scene._internalScene.environmentIntensity = e, this._viewer.requestRender());
		}, this._onSkyIsVisbleChanged = (e) => {
			this._viewer.scene.lightsController.sky.visible !== e && (this._viewer.scene.lightsController.sky.visible = e, this._viewer.requestRender());
		}, this._onVerboseModeChanged = (e) => {
			C.enableLog = e, C.enableInfo = e, C.enableWarn = !0, C.enableError = !0, C.enableTime = e;
		}, this._onDrawDebugChanged = (e) => {
			e || Vn.clearAllObjects();
		}, this._onFlatShadingChanged = (0, An.debounce)((e) => {
			for (let t of this._viewer.scene.controllers) {
				let n = t;
				if (n.isSceneMeshController) {
					let t = n.meshContainers();
					for (let n of t) for (let t of n.getMaterials()) "flatShading" in t && (t.flatShading = e, t.needsUpdate = !0);
				}
			}
			this._viewer.requestRender();
		}, 300), this._onShowSceneAxisHelperChanged = (e) => {
			this._viewer.scene.sceneAxesHelper.visible !== e && (this._viewer.scene.sceneAxesHelper.visible = e);
		}, this._onShowOriginAxisHelperChanged = (e) => {
			this._viewer.scene.originAxesHelper.visible !== e && (this._viewer.scene.originAxesHelper.visible = e, this._viewer.requestRender());
		}, this._onShowGridChanged = (e) => {
			this._viewer.scene.grid.visible !== e && (this._viewer.scene.grid.visible = e, this._viewer.requestRender());
		}, this._onGridSizeChanged = (e) => {
			this._viewer.scene.grid.size !== e && (this._viewer.scene.grid.setSize(e), this._viewer.requestRender());
		}, this._onAxesSizeChanged = (e) => {
			this._viewer.scene.sceneAxesHelper.scale.x !== e && (this._viewer.scene.sceneAxesHelper.scale.set(e, e, e), this._viewer.scene.originAxesHelper.scale.set(e, e, e), this._viewer.requestRender());
		}, this._onXRayOpacityChanged = (e) => {
			for (let t of this._viewer.scene.controllers) {
				let n = t;
				if (n.isSceneMeshController) for (let t of n.containers()) {
					let n = t.getMaterials([N.XRay]);
					for (let t of n) {
						let n = t;
						n.isBatchedMaterial && (n.xrayOpacity = e, n.uniformsNeedUpdate = !0);
					}
				}
			}
			this._viewer.requestRender();
		}, this._onPivotToWorldChanged = () => {
			this._viewer.viewport?.transformController.setPivotPoint(this._viewer.settings.objects.pivotPoint.value);
		}, this._onSelectionLayerChanged = (e) => {
			for (let t of this._viewer.scene.controllers) {
				let n = t;
				if (n.isSceneMeshController) for (let t of n.meshContainers()) t.setMaterialLayer(N.SelectedOpaque, e);
			}
			this._viewer.requestRender();
		};
	}
	setup(e) {
		this._viewer = e;
		let t = this._viewer.settings, n = this.callbackMap;
		n.set(t.debug, this._onDebugChanged), n.set(t.dev.verbose, this._onVerboseModeChanged), n.set(t.dev.showDevTools, this._onShowDevToolsChanged), n.set(t.dev.showInfoTools, this._onShowInfoToolsChanged), n.set(t.dev.drawDebug, this._onDrawDebugChanged), n.set(t.objects.highlightColor, this._onHighlightColorChanged), n.set(t.lights.cameraLightIntensity, this._onCameraLightIntensityChanged), n.set(t.lights.directionalLightIntensity, this._onDirectionalLightIntensityChanged), n.set(t.lights.hemisphereLightIntensity, this._onHemisphereLightIntensityChanged), n.set(t.lights.skyAzimuth, this._onSkyAzimuthChanged), n.set(t.lights.skyElevation, this._onSkyElevationChanged), n.set(t.lights.skyIsVisible, this._onSkyIsVisbleChanged), n.set(t.lights.skyMieCoefficient, this._onSkyMieCoefficientChanged), n.set(t.lights.skyMieDirectionalG, this._onSkyMieDirectionalGChanged), n.set(t.lights.skyRayleigh, this._onSkyRayleighChanged), n.set(t.lights.skyTurbidity, this._onSkyTurbidityChanged), n.set(t.ao.enableAO, this._onRendererSettingsChanged), n.set(t.ao.enableAA, this._onRendererSettingsChanged), n.set(t.ao.enableMSAA, this._onRendererSettingsChanged), n.set(t.ao.msaaSamples, this._onRendererSettingsChanged), n.set(t.ao.aoRadius, this._onRendererSettingsChanged), n.set(t.ao.quality, this._onRendererSettingsChanged), n.set(t.ao.color, this._onRendererSettingsChanged), n.set(t.ao.distanceFalloff, this._onRendererSettingsChanged), n.set(t.ao.intensity, this._onRendererSettingsChanged), n.set(t.ao.denoiseRadius, this._onRendererSettingsChanged), n.set(t.ao.denoiseSamples, this._onRendererSettingsChanged), n.set(t.ao.depthAwareUpsampling, this._onRendererSettingsChanged), n.set(t.ao.halfRes, this._onRendererSettingsChanged), n.set(t.ao.aoSamples, this._onRendererSettingsChanged), n.set(t.ao.transparencyAware, this._onRendererSettingsChanged), n.set(t.render.resolutionScaling, this._onResolutionScalingChanged), n.set(t.scene.showOriginAxisHelper, this._onShowOriginAxisHelperChanged), n.set(t.scene.showSceneAxisHelper, this._onShowSceneAxisHelperChanged), n.set(t.scene.axesSize, this._onAxesSizeChanged), n.set(t.scene.gridSize, this._onGridSizeChanged), n.set(t.scene.showGrid, this._onShowGridChanged), n.set(t.scene.backgroundColor, this._onBackgroundColorChanged), n.set(t.lights.envMapIntensity, this._onEnvMapIntensityChanged), n.set(t.objects.flatShading, this._onFlatShadingChanged), n.set(t.objects.xRayOpacity, this._onXRayOpacityChanged), n.set(t.objects.defaultEdgesColor, this._onEdgesColorChanged), n.set(t.objects.pivotPoint, this._onPivotToWorldChanged), n.set(t.objects.selectionLayer, this._onSelectionLayerChanged);
		for (let [e, t] of n.entries()) this.signals.push(e.onChange.connect(t)), t(e.value);
		this._onFlatShadingChanged.flush(), this._onEdgesColorChanged.flush();
	}
	dispose() {
		this.signals.forEach((e) => e.disconnect()), this._onFlatShadingChanged.cancel(), this._onEdgesColorChanged.cancel();
	}
}, Wn = class {
	constructor() {
		this._internalMap = /* @__PURE__ */ new Map();
	}
	set(e, t) {
		this._internalMap.set(e, t);
	}
	*entries() {
		for (let [e, t] of this._internalMap.entries()) yield [e, t];
	}
}, Gn = class {
	constructor(e) {
		this._behaviors = /* @__PURE__ */ new Set(), this._viewer = e, this._addDefaultBehaviors();
	}
	_addDefaultBehaviors() {
		this.addBehavior(new sn()), this.addBehavior(new ln()), this.addBehavior(new kn()), this.addBehavior(new Un());
	}
	addBehavior(e) {
		this._behaviors.has(e) || (this._behaviors.add(e), e.setup(this._viewer));
	}
	removeBehavior(e) {
		this._behaviors.delete(e) && e.dispose();
	}
	dispose() {
		for (let e of this._behaviors) e.dispose();
		this._behaviors.clear();
	}
}, Kn = {
	name: "@stereograph/teiaviewer-workspace",
	description: "StereoGraph TeiaViewer",
	version: "19.14.0-dev",
	type: "module",
	packageManager: "npm@10.0.0",
	workspaces: ["apps/*", "packages/*"],
	scripts: {
		clean: "rimraf dist build node_modules/.vite .turbo && npm run -ws clean",
		lint: "eslint packages/*/src apps/*/src --rule '@stylistic/max-len:off'",
		"lint:errors": "eslint packages/*/src apps/*/src --rule '@stylistic/max-len:off' --quiet",
		"lint:fix": "eslint packages/*/src apps/*/src --rule '@stylistic/max-len:off' --fix",
		knip: "knip",
		build: "turbo run build",
		"build:watch": "turbo watch build",
		"build:apps": "turbo run build --filter='./apps/*'",
		"build:demo": "turbo run build --filter='./apps/demo'",
		"build:demo:watch": "turbo watch build --filter='./apps/demo'",
		"build:packages": "turbo run build --filter='./packages/*'",
		"build:website": "node build-website.js",
		"pack:local": "npm run build:packages && node pack-local.js",
		"publish:prepare": "node prepare-publish.js",
		serve: "node server.js",
		dev: "npm run dev -w @apps/demo",
		"dev:engine": "npm run dev -w @apps/engine-demo",
		path: "npm run dev -w @apps/poc-path",
		"i18n:status": "i18next-cli status",
		"i18n:extract": "i18next-cli extract",
		"i18n:extract:test": "i18next-cli extract --ci",
		"test:coverage": "vitest run --coverage",
		test: "vitest",
		"test:run": "vitest run",
		spell: "cspell"
	},
	devDependencies: {
		"@stylistic/eslint-plugin": "^5.7.1",
		"@testing-library/dom": "^10.4.2",
		"@testing-library/jest-dom": "^7.0.1",
		"@types/leaflet": "^1.9.21",
		"@types/lodash": "^4.17.23",
		"@types/node": "^25.2.0",
		"@types/three": "^0.186.0",
		"@types/tinycolor2": "^1.4.6",
		"@vitest/coverage-v8": "^5.0.5",
		"@vitest/web-worker": "^5.0.5",
		cspell: "^9.6.4",
		eslint: "^9.39.2",
		"eslint-import-resolver-typescript": "^4.4.4",
		"eslint-plugin-import": "^2.32.0",
		"eslint-plugin-jsx-a11y": "^6.10.2",
		"eslint-plugin-react": "^7.37.5",
		"eslint-plugin-react-hooks": "^5.2.0",
		"eslint-plugin-react-you-might-not-need-an-effect": "^0.1.5",
		express: "^5.2.1",
		"i18next-cli": "^1.46.0",
		jsdom: "^30.1.3",
		knip: "^6.41.0",
		postprocessing: "6.39.5",
		rimraf: "^6.1.3",
		shiki: "^3.22.0",
		turbo: "^2.8.3",
		typedoc: "^0.28.19",
		typescript: "^6.0.3",
		"typescript-eslint": "^8.59.1",
		vite: "^8.0.10",
		"vite-bundle-analyzer": "^1.3.8",
		"vite-plugin-checker": "^0.13.0",
		"vite-plugin-dts": "^5.0.0",
		"vite-plugin-svgr": "^5.2.0",
		vitest: "^5.0.5",
		"vitest-canvas-mock": "^1.2.0"
	},
	overrides: {
		"proxy-addr": "^2.0.8",
		"source-map-js": "^1.2.2"
	}
}, qn = class {
	constructor(e) {
		this._viewer = e, this._undoHistory = [], this._redoHistory = [];
	}
	get canUndo() {
		return this._undoHistory.length > 0;
	}
	get canRedo() {
		return this._redoHistory.length > 0;
	}
	get undoHistory() {
		return this._undoHistory;
	}
	get redoHistory() {
		return this._redoHistory;
	}
	async undoLastCommand(e = {}) {
		return await this._undoHistory.at(-1)?.undo(e);
	}
	async redoLastCommand(e = {}) {
		return await this._redoHistory.at(-1)?.execute(e);
	}
	get lastCommand() {
		return this._undoHistory.at(-1);
	}
	async _pushToUndoHistory(e) {
		this._undoHistory.push(e), this._redoHistory.find((t) => t == e) ? (C.info("Redo command: " + e.name), this._redoHistory.remove(e)) : await this.clearRedoHistory(), this._viewer.signals.historyChanged.emit();
	}
	_removeFromUndoHistory(e, t) {
		this._undoHistory.find((t) => t == e) && (this._undoHistory.remove(e), C.info("Undo command: " + e.name), t ? this._redoHistory.push(e) : e._clean(), this._viewer.signals.historyChanged.emit());
	}
	async clearRedoHistory() {
		for (let e of this._redoHistory) await e._clean();
		this._redoHistory.clear(), this._viewer.signals.historyChanged.emit();
	}
	async clearUndoHistory() {
		for (let e of this._undoHistory) await e._clean();
		this._undoHistory.clear();
	}
	async clearHistory() {
		await this.clearUndoHistory(), await this.clearRedoHistory(), this._viewer.signals.historyChanged.emit();
	}
}, Jn = class {
	toJSON() {
		return {};
	}
	fromJSON(e) {}
}, Yn = /* @__PURE__ */ new b(), Xn = /* @__PURE__ */ new a(), Zn = 0, Qn = class {
	constructor(e = [], t = !1) {
		this.allVisibleObjectsSelected = t, this.isObjectSelection = !0, this.id = Zn++, this._objects = new Set(e);
	}
	hasObject(e) {
		return this._objects.has(e);
	}
	*getUuids() {
		for (let e of this._objects) yield e.uuid;
	}
	*getBimMeshUuids() {
		for (let e of this.getBimMeshes()) yield e.uuid;
	}
	*getObjects() {
		for (let e of this._objects) yield e;
	}
	*getMeshesDeep(e = this._objects) {
		for (let t of e) if (t.isSceneMeshGroup) {
			let e = t;
			yield* this.getMeshesDeep(e.meshes);
		} else t.isSceneMesh && (yield t);
	}
	*getMeshes() {
		for (let e of this._objects) e.isSceneMesh && (yield e);
	}
	*getBimMeshes() {
		for (let e of this._objects) e.isBimMesh && (yield e);
	}
	getBoundingBox(e) {
		e.makeEmpty();
		for (let t of this.getMeshes()) t.getBoundingBox(Xn), e.union(Xn);
		return e;
	}
	getBoundingSphere(e) {
		e.makeEmpty();
		for (let t of this.getMeshes()) t.getBoundingSphere(Yn), e.union(Yn);
		return e;
	}
	getLastObject() {
		return Array.from(this.getObjects()).at(-1) ?? null;
	}
	getFirstObject() {
		let e = this.getObjects().next();
		return e.done ? null : e.value;
	}
	getFirstUuid() {
		return this.getFirstObject()?.uuid ?? null;
	}
	getLastUuid() {
		return this.getLastObject()?.uuid ?? null;
	}
	get length() {
		return this._objects.size;
	}
	get isEmpty() {
		return this._objects.size === 0;
	}
	equalsTo(e) {
		return e.id === this.id;
	}
	toString() {
		let e = "", t = this.getUuids(), n = t.next();
		if (n.done) return "";
		e += n.value;
		for (let n = t.next(); !n.done; n = t.next()) e += ";" + n.value;
		return e;
	}
}, $n = class extends A {
	constructor(e, t) {
		if (super(e), this.name = "SelectObjectsCommand", this.isUndoable = !1, t.isObjectSelection) this.newSelection = t;
		else {
			let n = e.scene.getObjectsByUUID(t);
			this.newSelection = new Qn(n);
		}
		this.oldSelection = e.scene.objectSelection;
	}
	async _do() {
		let e = this.oldSelection.getObjects();
		for (let t of e) t.selected = !1;
		let t = this.newSelection.getObjects();
		for (let e of t) e.selected = !0;
		this.viewer.scene.setObjectSelection(this.newSelection);
	}
	async _undo() {
		let e = this.newSelection.getObjects();
		for (let t of e) t.selected = !1;
		let t = this.oldSelection.getObjects();
		for (let e of t) e.selected = !0;
		this.viewer.scene.setObjectSelection(this.oldSelection);
	}
}, er = class extends A {
	constructor(e, t = {}) {
		super(e), this._options = t, this._object = null, this.isUndoable = !0;
	}
	async _do() {
		this._object ??= await this._createObject(), this.viewer.scene.addObject(this._object, this._options.parentId);
		let e = this._object;
		return this._options.selected && e.isSceneMesh && new $n(this.viewer, [e.uuid]).execute(), this._object;
	}
	async _undo() {
		if (this._object) {
			if (this.viewer.scene.objectSelection.hasObject(this._object)) {
				let e = [];
				for (let t of this.viewer.scene.objectSelection.getUuids()) t !== this._object.uuid && e.push(t);
				new $n(this.viewer, e).execute();
			}
			this.viewer.scene.removeObject(this._object);
		}
	}
	async _clean() {
		this.hasBeenExecuted || this._object?.dispose();
	}
}, tr = /* @__PURE__ */ new Fe(), nr = /* @__PURE__ */ new x(), rr = class extends er {
	constructor(e, t, n, r, i = {}) {
		super(e), this.x = t, this.y = n, this.z = r, this.options = i, this.name = "AddSpriteCommand";
	}
	async _do() {
		return this._object = await this._createObject(), super._do();
	}
	async _createObject() {
		let { size: e = 1, onClick: t, depthTest: n = !0, selectable: r = !0, text: i = "", imageUrl: a = "" } = this.options, o = this.viewer.scene.spriteController.createSprite(nr.set(this.x, this.y, this.z), tr.set(e, e), t, n);
		return o.isSelectable = r, await o.setTexture({
			imageUrl: a,
			text: i
		}), o;
	}
}, ir = (e, t) => {
	if (e === t) return !0;
	if (e.length !== t.length) return !1;
	let n = 0, r = e.length, i = !0;
	for (; n < r && i;) i = e[n] === t[n], n++;
	return i;
}, ar = class extends A {
	constructor(e, t) {
		super(e), this.name = "IsolateObjectCommand", this.isUndoable = !0, this._visibleStateId = null, this._hiddenStateId = null, this._isolatedObjects = Array.from(e.scene.getObjectsByUUID(t));
	}
	async _do() {
		this._visibleStateId = this.viewer.objectStateHistory.pushState(this.viewer.scene.getAllObjects(), { visible: !1 }), this._hiddenStateId = this.viewer.objectStateHistory.pushState(this._isolatedObjects, { visible: !0 });
	}
	async _undo() {
		this._visibleStateId !== null && this.viewer.objectStateHistory.removeState(this._visibleStateId), this._hiddenStateId !== null && this.viewer.objectStateHistory.removeState(this._hiddenStateId), this._hiddenStateId = null, this._visibleStateId = null;
	}
	equals(e) {
		return ir(this._isolatedObjects, e._isolatedObjects);
	}
}, or = class extends A {
	constructor(e, t, n) {
		super(e), this._state = n, this.isUndoable = !0, this._stateId = null, this._objects = Array.from(e.scene.getObjectsByUUID(t));
	}
	async _do() {
		return this._stateId = this.viewer.objectStateHistory.pushState(this._objects, this._state), this._state;
	}
	async _undo() {
		this._stateId !== null && (this.viewer.objectStateHistory.removeState(this._stateId), this._stateId = null);
	}
	async update(...e) {
		this._stateId !== null && (this._updateState(...e), this.viewer.objectStateHistory.updateState(this._stateId, this._state), await super.update());
	}
}, sr = class extends or {
	constructor(e, t) {
		super(e, t, { restore: !0 }), this.name = "RestoreObjectsMaterialCommand";
	}
	async _do() {
		return super._do(), this._updateInBoxTree(), this._state;
	}
	async _undo() {
		super._undo(), this._updateInBoxTree();
	}
	_updateState() {
		throw Error("Method not implemented.");
	}
	_updateInBoxTree() {
		for (let e of this._objects) {
			let t = e;
			t.isRaycastable && this.viewer.scene.isObjectInBoxTree(t) && this.viewer.scene.updateObjectInBoxTree(t);
		}
	}
}, cr = class extends or {
	constructor(e, t, n) {
		super(e, t, { visible: n }), this._viewer = e, this.name = "SetObjectsVisibilityCommand", this._newVisibility = n;
	}
	async _do() {
		return await super._do(), this._viewer.signals.onObjectVisibilityChanged.emit(), this._state;
	}
	async _undo() {
		await super._undo(), this._viewer.signals.onObjectVisibilityChanged.emit();
	}
	equals(e) {
		return ir(e._objects, this._objects) && e._newVisibility === this._newVisibility;
	}
	_updateState() {
		throw Error("Method not implemented.");
	}
}, lr = class extends A {
	constructor(e) {
		super(e), this.name = "SetAllObjectsVisibleCommand", this.isUndoable = !0;
		let t = e.scene.bimMeshController.getAllObjectUuids();
		this.command = new cr(e, t, !0);
	}
	async _do() {
		this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		this.command.undo({
			requestRender: !1,
			addToRedoHistory: !1
		});
	}
	async _clean() {
		this.command._clean();
	}
};
//#endregion
//#region src/scene/serialization/SerializedMatrix4.ts
function ur(e) {
	return e.toArray();
}
function dr(e, t) {
	t.fromArray(e);
}
//#endregion
//#region src/command/objects/SetObjectTransformCommand.ts
var fr = class extends or {
	constructor(e, t, n) {
		super(e, [t], { matrix: ur(n) }), this.name = "SetObjectTransformCommand", this.isUpdatable = !0;
	}
	async _do() {
		return super._do(), this._updateBoxTree(), this.viewer.signals.onObjectsMoved.emit(), this._state;
	}
	async _undo() {
		super._undo(), this._updateBoxTree(), this.viewer.signals.onObjectsMoved.emit();
	}
	_updateState(e) {
		this._state.matrix = ur(e);
	}
	async update(e) {
		await super.update(e), this._updateBoxTree(), this.viewer.signals.onObjectsMoved.emit();
	}
	_updateBoxTree() {
		for (let e of this._objects) {
			let t = e;
			t.isSceneMesh && this.viewer.scene.isObjectInBoxTree(t) && this.viewer.scene.updateObjectInBoxTree(t);
		}
	}
}, pr = /* @__PURE__ */ new y(), mr = class extends A {
	constructor(e, t, n) {
		super(e), this.uuid = t, this.position = n, this.name = "SetObjectPositionCommand", this.isUpdatable = !0, this.isUndoable = !0, this._setObjectTransformCmd = null;
	}
	async _do() {
		if (!this._setObjectTransformCmd) {
			let e = this.viewer.scene.getObjectByUUID(this.uuid);
			if (!e) return;
			e.getMatrix(pr), pr.setPosition(this.position), this._setObjectTransformCmd = new fr(this.viewer, this.uuid, pr);
		}
		await this._setObjectTransformCmd.execute({ addToUndoHistory: !1 });
	}
	async _undo() {
		this._setObjectTransformCmd?.undo();
	}
	async update(e) {
		pr.setPosition(e), this._setObjectTransformCmd?.update(pr);
	}
}, hr = /* @__PURE__ */ new y(), gr = /* @__PURE__ */ new y(), _r = /* @__PURE__ */ new y(), vr = /* @__PURE__ */ new x(), yr = /* @__PURE__ */ new Te(), br = /* @__PURE__ */ new x(), xr = /* @__PURE__ */ new x(), L = /* @__PURE__ */ new Te(), Sr = /* @__PURE__ */ new x(), Cr = new x(1, 0, 0), wr = new x(0, 1, 0), R = new x(0, 0, 1), Tr = /* @__PURE__ */ function(e) {
	return e[e.x = 0] = "x", e[e.y = 1] = "y", e[e.z = 2] = "z", e;
}({}), Er = class extends A {
	constructor(e, t, n, r) {
		super(e), this.uuid = t, this.angle = n, this.axis = r, this.name = "SetObjectRotationCommand", this.isUpdatable = !0, this.isUndoable = !0, this._setObjectTransformCmd = null;
	}
	async _do() {
		if (!this._setObjectTransformCmd) {
			let e = this.viewer.scene.getObjectByUUID(this.uuid);
			if (!e) return;
			let t = this.axis === 0 ? Cr : this.axis === 1 ? wr : R, n = me.degToRad(this.angle);
			_r.makeRotationAxis(t, n), e.getMatrix(gr), gr.decompose(vr, yr, br), hr.makeRotationFromQuaternion(yr), hr.premultiply(_r), hr.decompose(xr, L, Sr), gr.compose(vr, L, br), this._setObjectTransformCmd = new fr(this.viewer, this.uuid, gr);
		}
		await this._setObjectTransformCmd.execute({ addToUndoHistory: !1 });
	}
	async _undo() {
		this._setObjectTransformCmd?.undo();
	}
	async update(e) {
		hr.setPosition(e), this._setObjectTransformCmd?.update(hr);
	}
}, Dr = /* @__PURE__ */ new y(), Or = /* @__PURE__ */ new y(), kr = /* @__PURE__ */ new x(), Ar = /* @__PURE__ */ new Te(), jr = /* @__PURE__ */ new x(), Mr = class extends A {
	constructor(e, t, n) {
		if (super(e), this.uuid = t, this.scale = n, this.name = "SetObjectScaleCommand", this.isUpdatable = !0, this.isUndoable = !0, this._setObjectTransformCmd = null, n.x === 0 || n.y === 0 || n.z === 0) throw Error("Scale cannot be zero.");
	}
	async _do() {
		if (!this._setObjectTransformCmd) {
			let e = this.viewer.scene.getObjectByUUID(this.uuid);
			if (!e) return;
			e.getMatrix(Dr), Dr.decompose(kr, Ar, jr), Or.compose(kr, Ar, this.scale), this._setObjectTransformCmd = new fr(this.viewer, this.uuid, Or);
		}
		await this._setObjectTransformCmd.execute({ addToUndoHistory: !1 });
	}
	async _undo() {
		this._setObjectTransformCmd?.undo();
	}
	async update(e) {
		Dr.setPosition(e), this._setObjectTransformCmd?.update(Dr);
	}
}, Nr = class extends or {
	constructor(e, t, n) {
		super(e, t, { diffuseColor: n }), this.name = "SetObjectsColorCommand", this.isUpdatable = !0;
	}
	_updateState(e) {
		this._state.diffuseColor = e;
	}
	async update(e) {
		await super.update(e);
	}
}, Pr = class extends or {
	constructor(e, t, n) {
		super(e, t, { edgesVisible: n }), this.name = "SetObjectsEdgesVisibilityCommand";
	}
	_updateState() {
		throw Error("Method not implemented.");
	}
}, Fr = class extends or {
	constructor(e, t, n, r = !0) {
		let i = { opacity: n };
		r && (i.edgesOpacity = n), super(e, t, i), this.name = "SetObjectsOpacityCommand", this.isUpdatable = !0;
	}
	async _do() {
		return super._do(), this._state;
	}
	async _undo() {
		super._undo();
	}
	_updateState(e) {
		this._state.opacity = e;
	}
	async update(e) {
		await super.update(e);
	}
}, Ir = class extends or {
	constructor(e, t, n) {
		super(e, t, { xRay: n }), this.name = "SetObjectsXRayStatusCommand", this._xray = n;
	}
	equals(e) {
		return ir(this._objects, e._objects) && e._xray === this._xray;
	}
	_updateState() {
		throw Error("Method not implemented.");
	}
}, Lr = class extends A {
	constructor(e, t, n) {
		if (super(e), this.name = "SetCameraPositionCommand", this.isUndoable = !0, this.oldPosition = new x(), this.oldTarget = new x(), this.newPosition = new x(), this.newTarget = new x(), !e.viewport) throw Error("No Viewport attached to the viewer");
		this.viewport = e.viewport, this.newPosition.copy(t), this.newTarget.copy(n), this.viewport.cameraControls.getPosition(this.oldPosition), this.viewport.cameraControls.getTarget(this.oldTarget);
	}
	async _do() {
		this.viewport.cameraControls.lookAt(this.newPosition, this.newTarget);
	}
	async _undo() {
		this.viewport.cameraControls.lookAt(this.oldPosition, this.oldTarget);
	}
}, Rr = /* @__PURE__ */ new b(), zr = /* @__PURE__ */ new x(), Br = /* @__PURE__ */ new x(), Vr = /* @__PURE__ */ function(e) {
	return e[e.left = 0] = "left", e[e.right = 1] = "right", e[e.top = 2] = "top", e[e.bottom = 3] = "bottom", e[e.front = 4] = "front", e[e.back = 5] = "back", e;
}({}), Hr = class extends A {
	constructor(e, t, n = 1.7) {
		switch (super(e), this.orbitPosition = t, this.radiusFactor = n, this.name = "SetCameraSpherePositionCommand", this.isUndoable = !0, this.direction = new x(), this.orbitPosition) {
			case 0:
				this.direction.set(1, 0, 0);
				break;
			case 1:
				this.direction.set(-1, 0, 0);
				break;
			case 2:
				this.direction.set(0, 1, 0);
				break;
			case 3:
				this.direction.set(0, -1, 0);
				break;
			case 4:
				this.direction.set(0, 0, 1);
				break;
			default: this.direction.set(0, 0, -1);
		}
		this.viewer.scene.getBoxTreeBoundingSphere(Rr), zr.copy(this.direction).multiplyScalar(Rr.radius * this.radiusFactor), Br.addVectors(Rr.center, zr), this.command = new Lr(this.viewer, Br, Rr.center);
	}
	async _do() {
		this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		this.command.undo({
			requestRender: !1,
			addToRedoHistory: !1
		});
	}
}, Ur = {
	SelectObjects: Wr,
	SetObjectsColor: Gr,
	SetObjectsEdgesVisibility: qr,
	SetObjectsOpacity: Kr,
	SetObjectsVisibility: Jr,
	SetObjectsXRay: ii,
	IsolateObjects: Yr,
	SetAllObjectsVisible: Xr,
	RestoreObjectsMaterial: Zr,
	AddSprite: Qr,
	SetObjectPosition: $r,
	SetObjectRotation: ei,
	SetObjectScale: ti,
	SetCameraPosition: ni,
	SetCameraSpherePosition: ri
};
function Wr(e, t) {
	let n = { uuids: t.scene.objectSelection.toString() };
	return e.addBinding(n, "uuids"), { execute: () => {
		new $n(t, n.uuids.replaceAll(/\s|\n/g, "").split(";")).execute();
	} };
}
function Gr(e, t) {
	let n = {
		uuids: t.scene.objectSelection.toString(),
		color: {
			r: 50,
			g: 50,
			b: 214
		}
	};
	return e.addBinding(n, "uuids"), e.addBinding(n, "color", {
		view: "color",
		color: { alpha: !1 }
	}), { execute: () => {
		let { r: e, g: r, b: i } = n.color, a = `rgb(${e.toFixed(0)}, ${r.toFixed(0)}, ${i.toFixed(0)})`;
		new Nr(t, n.uuids.replaceAll(/\s|\n/g, "").split(";"), a).execute();
	} };
}
function Kr(e, t) {
	let n = {
		uuids: t.scene.objectSelection.toString(),
		opacity: 1
	};
	return e.addBinding(n, "uuids"), e.addBinding(n, "opacity", {
		min: 0,
		max: 1
	}), { execute: () => {
		let { opacity: e } = n;
		new Fr(t, n.uuids.replaceAll(/\s|\n/g, "").split(";"), e).execute();
	} };
}
function qr(e, t) {
	let n = {
		uuids: t.scene.objectSelection.toString(),
		visible: !0
	};
	return e.addBinding(n, "uuids"), e.addBinding(n, "visible"), { execute: () => {
		new Pr(t, n.uuids.replaceAll(/\s|\n/g, "").split(";"), n.visible).execute();
	} };
}
function Jr(e, t) {
	let n = {
		uuids: t.scene.objectSelection.toString(),
		visible: !0
	};
	return e.addBinding(n, "uuids"), e.addBinding(n, "visible"), { execute: () => {
		new cr(t, n.uuids.replaceAll(/\s|\n/g, "").split(";"), n.visible).execute();
	} };
}
function Yr(e, t) {
	let n = { uuids: t.scene.objectSelection.toString() };
	return e.addBinding(n, "uuids"), { execute: () => {
		new ar(t, n.uuids.replaceAll(/\s|\n/g, "").split(";")).execute();
	} };
}
function Xr(e, t) {
	return { execute: () => {
		new lr(t).execute();
	} };
}
function Zr(e, t) {
	let n = { uuids: t.scene.objectSelection.toString() };
	return e.addBinding(n, "uuids"), { execute: () => {
		new sr(t, n.uuids.replaceAll(/\s|\n/g, "").split(";")).execute();
	} };
}
function Qr(e, t) {
	let n = {
		position: {
			x: 0,
			y: 0,
			z: 0
		},
		text: "",
		image: "",
		size: 1,
		selectable: !0,
		alwaysVisible: !1
	};
	return e.addBinding(n, "position"), e.addBinding(n, "text"), e.addBinding(n, "image", { options: {
		none: "none",
		bell: "BellIcon.svg",
		bug: "BugAntIcon.svg"
	} }), e.addBinding(n, "size", {
		step: .1,
		min: .1,
		max: 10
	}), e.addBinding(n, "selectable"), e.addBinding(n, "alwaysVisible"), { execute: () => {
		let { text: e, image: r, size: i, position: a, selectable: o, alwaysVisible: s } = n, { x: c, y: l, z: u } = a;
		new rr(t, c, l, u, {
			text: e,
			imageUrl: r === "none" ? "" : "/images/" + r,
			size: i,
			selectable: o,
			depthTest: !s
		}).execute();
	} };
}
function $r(e, t) {
	let n = {
		uuid: t.scene.objectSelection.getFirstUuid() ?? "",
		position: new x(0, 0, 0)
	};
	return e.addBinding(n, "uuid"), e.addBinding(n, "position"), { execute: () => {
		let { uuid: e, position: r } = n;
		new mr(t, e, r).execute();
	} };
}
function ei(e, t) {
	let n = {
		uuid: t.scene.objectSelection.getFirstUuid() ?? "",
		angle: 0,
		axis: Tr.x
	};
	return e.addBinding(n, "uuid"), e.addBinding(n, "angle"), e.addBinding(n, "axis", { options: {
		x: Tr.x,
		y: Tr.y,
		z: Tr.z
	} }), { execute: () => {
		let { uuid: e, angle: r, axis: i } = n;
		new Er(t, e, r, i).execute();
	} };
}
function ti(e, t) {
	let n = {
		uuid: t.scene.objectSelection.getFirstUuid() ?? "",
		scale: new x(1, 1, 1)
	};
	return e.addBinding(n, "uuid"), e.addBinding(n, "scale"), { execute: () => {
		let { uuid: e, scale: r } = n;
		new Mr(t, e, r).execute();
	} };
}
function ni(e, t) {
	let n = {
		position: new x(0, 0, 0),
		target: new x(0, 0, 0)
	};
	return e.addBinding(n, "position"), e.addBinding(n, "target"), { execute: () => {
		let { position: e, target: r } = n;
		new Lr(t, e, r).execute();
	} };
}
function ri(e, t) {
	let n = {
		cameraOrbitPosition: Vr.left,
		radiusFactor: 1.7
	};
	return e.addBinding(n, "cameraOrbitPosition", { options: {
		left: Vr.left,
		right: Vr.right,
		top: Vr.top,
		bottom: Vr.bottom,
		front: Vr.front,
		back: Vr.back
	} }), e.addBinding(n, "radiusFactor"), { execute: () => {
		let { cameraOrbitPosition: e, radiusFactor: r } = n;
		new Hr(t, e, r).execute();
	} };
}
function ii(e, t) {
	let n = {
		uuids: t.scene.objectSelection.toString(),
		enabled: !1
	};
	return e.addBinding(n, "uuids"), e.addBinding(n, "enabled"), { execute: () => {
		let { enabled: e } = n;
		new Ir(t, n.uuids.replaceAll(/\s|\n/g, "").split(";"), e).execute();
	} };
}
//#endregion
//#region src/developertools/devtools/CommandDevTool.tsx
var ai = Object.keys(Ur), oi = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "command", this.type = "dev", this._params = { command: ai.length > 0 ? ai[0] : "" }, this._drawCmdSelector = (e, t) => {
			this._commandSelector = e.addBinding(this._params, "command", {
				label: "command",
				options: ai.map((e) => ({
					text: e,
					value: e
				}))
			}).on("change", () => this._drawCmdControls(e, t));
		}, this._drawCmdControls = (e, t) => {
			let n = [...e.children];
			for (let e of n) e !== this._commandSelector && e.dispose();
			let r = this._params.command;
			this._currentCommand = Ur[r](e, t), e.addButton({ title: "Execute" }).on("click", this._executeCommand);
		}, this._executeCommand = () => {
			this._currentCommand?.execute();
		};
	}
	setup(e, t) {
		let n = t.addFolder({
			title: "Commands",
			expanded: !1
		});
		this._folder = n, this._drawCmdSelector(n, e), this._drawCmdControls(n, e);
	}
	dispose() {
		this._folder?.dispose();
	}
};
//#endregion
//#region src/utils/AssertUtils.ts
function z(e, t) {
	if (e == null) throw Error(t ?? "Assert failed");
}
function si(e, t, n) {
	if (e !== t) throw Error(n ?? "Values are not equals");
}
function ci(e, t) {
	if (!e) throw Error(t ?? "Condition assertion failed");
}
//#endregion
//#region src/developertools/utils.ts
function li(e, t) {
	Object.entries(t).forEach(([t, n]) => {
		n instanceof _n ? n.showInDevTools && ui(e, n, t) : li(e.addFolder({
			title: t,
			expanded: !1
		}), n);
	});
}
function ui(e, t, n) {
	let r;
	if (t.isNumberController) {
		let n = t;
		r = e.addBinding(n, "value", {
			min: n.min,
			max: n.max,
			step: n.step
		});
	} else if (t.isSelectController) {
		let n = t;
		r = e.addBinding(n, "value", { options: n.options.reduce((e, t) => (e[t] = t, e), {}) });
	} else r = e.addBinding(t, "value");
	return r.label = n, r;
}
//#endregion
//#region src/developertools/devtools/PluginSettingsDevTool.ts
var di = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "plugins", this.type = "dev", this._pluginFolderMap = /* @__PURE__ */ new Map(), this._onPluginAdded = (e) => {
			this._addPluginControls(e);
		}, this._onPluginRemoved = (e) => {
			this._removePluginControls(e);
		};
	}
	setup(e, t) {
		this._viewer = e, this._folder = t.addFolder({
			title: "Plugins",
			expanded: !1
		});
		for (let t of e.pluginKeys) this._addPluginControls(t);
		this._viewer.signals.onPluginAdded.connect(this._onPluginAdded), this._viewer.signals.onPluginRemoved.connect(this._onPluginRemoved);
	}
	_addPluginControls(e) {
		z(this._folder), z(this._viewer);
		let t = this._viewer.getPlugin(e);
		if (t.hasSettings()) {
			let n = this._folder.addFolder({
				title: t.name,
				expanded: !1
			});
			li(n, t.settings), this._pluginFolderMap.set(e, n);
		}
	}
	_removePluginControls(e) {
		let t = this._pluginFolderMap.get(e);
		t && t.dispose(), this._pluginFolderMap.delete(e);
	}
	dispose() {
		z(this._viewer), this._folder?.dispose(), this._viewer.signals.onPluginAdded.disconnect(this._onPluginAdded), this._viewer.signals.onPluginRemoved.disconnect(this._onPluginRemoved);
	}
}, fi = class extends A {
	constructor(e) {
		super(e), this.name = "ResetSettingsCommand", this.isUndoable = !1;
	}
	async _do() {
		this._recursiveOnSettings(this.viewer.settings);
		for (let e of this.viewer.plugins) this._recursiveOnSettings(e.settings);
	}
	_recursiveOnSettings(e) {
		for (let t of Object.values(e)) {
			let e = t;
			e.isValueController ? e.reset() : this._recursiveOnSettings(t);
		}
	}
	async _undo() {
		throw new k(this);
	}
}, pi = class extends A {
	constructor(e, t) {
		super(e), this.isUndoable = !1, this.isUpdatable = !1, this.name = "GroupCommand", this.commands = [...t];
	}
	async _do() {
		return Promise.all(this.commands.map((e) => e.execute({
			requestRender: !1,
			addToUndoHistory: !1
		})));
	}
	async _undo() {
		let e = [...this.commands].reverse();
		await Promise.all(e.map((e) => e.undo({
			requestRender: !1,
			addToRedoHistory: !1
		})));
	}
	async _clean() {
		await Promise.all(this.commands.map((e) => e._clean()));
	}
}, mi = class extends er {
	constructor(e, t, n = { selected: !1 }) {
		super(e, n), this.object = t, this.name = "AddExistingObjectCommand";
	}
	async _createObject() {
		return this.object;
	}
}, hi = class extends A {
	constructor(e, t) {
		super(e), this.name = "DeleteObjectCommand", this.isUndoable = !0, this._object = t, this._parentId = t.parent?.uuid ?? null;
	}
	async _do() {
		this.viewer.scene.removeObject(this._object);
		let e = this._object;
		if (e.isSceneMesh) {
			if (e.selected) {
				let t = this.viewer.scene.objectSelection.getUuids(), n = [];
				for (let r of t) r !== e.uuid && n.push(r);
				new $n(this.viewer, n).execute({
					addToUndoHistory: !1,
					requestRender: !1
				}), e.selected = !1;
			}
			if (this.viewer.viewport?.transformController.isObjectAttached(this._object)) {
				let e = this.viewer.scene.objectSelection.getMeshes();
				this.viewer.viewport?.transformController.attachObjects(e);
			}
		}
		return this._object;
	}
	async _undo() {
		this.viewer.scene.addObject(this._object, this._parentId);
	}
}, gi = class extends A {
	constructor(e, t) {
		super(e), this.name = "ClearSceneObjectControllerCommand", this.isUndoable = !0, this._oldObjects = [];
		for (let e of t.getAllObjects()) this._oldObjects.push(e);
	}
	async _do() {
		for (let e of this._oldObjects) new hi(this.viewer, e).execute({
			addToUndoHistory: !1,
			requestRender: !1
		});
	}
	async _undo() {
		for (let e of this._oldObjects) new mi(this.viewer, e).execute({
			addToUndoHistory: !1,
			requestRender: !1
		});
	}
	async _clean() {
		if (this.hasBeenExecuted) for (let e of this._oldObjects) e.dispose();
	}
}, _i = class extends A {
	constructor(...e) {
		super(...e), this.name = "ClearSceneCommand", this.isUndoable = !1;
	}
	async _do() {
		new pi(this.viewer, [new gi(this.viewer, this.viewer.scene.clippingPlaneController)]).execute(), this.viewer.sceneLoader.stop(), this.viewer.clear();
	}
	async _undo() {
		throw new k(this);
	}
}, vi = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "quick_actions", this.type = "dev", this._viewer = null, this._components = [], this._infoButton = null, this._onShowStatsToolChanged = () => {
			z(this._infoButton), this._infoButton.refresh();
		}, this._copySelectionToClipboard = () => {
			z(this._viewer), navigator.clipboard.writeText(this._viewer.scene.objectSelection.toString());
		}, this._clearScene = () => {
			z(this._viewer), new _i(this._viewer).execute();
		}, this._resetSettings = () => {
			z(this._viewer), new fi(this._viewer).execute();
		};
	}
	setup(e, t) {
		this._viewer = e, this._infoButton = t.addBinding(this._viewer.settings.dev.showInfoTools, "value", { label: "Show stats" });
		let n = t.addButton({ title: "Copy selected GUIDs" }).on("click", this._copySelectionToClipboard), r = t.addButton({ title: "Clear" }).on("click", this._clearScene), i = t.addButton({ title: "Reset all settings" }).on("click", this._resetSettings);
		t.addBinding(this._viewer, "version", {
			label: "version",
			readonly: !0
		}), this._components.push(this._infoButton, n, r, i), this._viewer.settings.dev.showInfoTools.onChange.connect(this._onShowStatsToolChanged);
	}
	dispose() {
		z(this._viewer), z(this._infoButton), this._viewer.settings.dev.showInfoTools.onChange.disconnect(this._onShowStatsToolChanged);
		for (let e of this._components) e.dispose();
	}
}, yi = class extends A {
	constructor(e, t, n) {
		super(e), this.name = "ShowMeshObjectsBoundingBoxCommand", this.isUndoable = !1, this.newVisibility = n, this.meshes = Array.from(t);
	}
	async _do() {
		for (let e of this.meshes) e.showBoundingBoxHelper(this.viewer.scene.objectsHelpers, this.newVisibility);
	}
	async _undo() {
		throw new k(this);
	}
}, bi = class extends A {
	constructor(e, t, n) {
		super(e), this.name = "ShowMeshNormalHelperCommand", this.isUndoable = !1, this.newVisibility = n, this.meshes = Array.from(t);
	}
	async _do() {
		for (let e of this.meshes) e.showNormalsHelper(this.viewer.scene.objectsHelpers, this.newVisibility);
	}
	async _undo() {
		throw new k(this);
	}
}, xi = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "scene", this.type = "dev", this._folder = null, this._viewer = null, this._params = {
			showBBbox: !1,
			showNormals: !1,
			bvh: {
				show: !1,
				depth: 5,
				showParents: !1
			}
		}, this._onShowHideBoxHelpers = () => {
			z(this._viewer), new yi(this._viewer, this._viewer.scene.objectSelection.getMeshes(), this._params.showBBbox).execute();
		}, this._onShowHideNormalHelpers = () => {
			z(this._viewer), new bi(this._viewer, this._viewer.scene.objectSelection.getMeshes(), this._params.showNormals).execute();
		}, this._onShowSceneTree = () => {
			z(this._viewer), this._viewer.scene.showBoxTreeHelper(this._params.bvh.show), this._viewer.requestRender();
		}, this._onTreeDepthChange = () => {
			z(this._viewer), this._viewer.scene._boxTreeHelper.setDepth(this._params.bvh.depth), this._viewer.requestRender();
		}, this._onShowBvhParents = () => {
			z(this._viewer), this._viewer.scene._boxTreeHelper.showParents(this._params.bvh.showParents), this._viewer.requestRender();
		};
	}
	setup(e, t) {
		this._viewer = e, this._folder = t.addFolder({
			title: "Scene",
			expanded: !1
		}), this._folder.addBinding(this._params, "showBBbox").on("change", this._onShowHideBoxHelpers), this._folder.addBinding(this._params, "showNormals").on("change", this._onShowHideNormalHelpers);
		let n = this._folder.addFolder({ title: "bvh" });
		n.addBinding(this._params.bvh, "show").on("change", this._onShowSceneTree), n.addBinding(this._params.bvh, "showParents").on("change", this._onShowBvhParents), n.addBinding(this._params.bvh, "depth", {
			min: 0,
			max: 30,
			step: 1
		}).on("change", this._onTreeDepthChange);
	}
	dispose() {
		this._folder?.dispose(), this._folder = null;
	}
}, Si = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "settings", this.type = "dev", this._folder = null, this._filterInput = null, this._params = { filter: "" }, this._onFilterChange = () => {
			z(this._folder), Ci(this._folder, this._params.filter.toLowerCase(), this._filterInput);
		};
	}
	setup(e, t) {
		this._folder = t.addFolder({
			title: "Settings",
			expanded: !1
		});
		let n = this._folder.element.getElementsByClassName("tp-fldv_c");
		for (let e = 0; e < n.length; e++) {
			let t = n.item(e);
			t && (t.style.maxHeight = "300px", t.style.overflowY = "scroll");
		}
		this._filterInput = this._folder.addBinding(this._params, "filter", { label: "<filter>" }).on("change", this._onFilterChange);
		let r = this._filterInput.element.querySelector(".tp-lblv_v");
		r && (r.style.flexGrow = "2"), li(this._folder, e.settings);
	}
	dispose() {
		this._folder?.dispose(), this._folder = null;
	}
};
function Ci(e, t, n) {
	let r = !0;
	return e.children.forEach((e) => {
		e !== n && (e.hidden = !1, e.hidden = e instanceof We ? Ci(e, t, n) : !e.controller.labelController.view.element.textContent.toLocaleLowerCase().includes(t), r &&= e.hidden);
	}), r;
}
//#endregion
//#region src/developertools/infotools/RenderInfoTool.ts
var wi = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "RenderInfo", this.type = "info", this._folder = null, this._viewer = null, this._fpsBlade = null, this._info = {
			fps: 0,
			calls: 0,
			frame: 0,
			lines: 0,
			triangles: 0,
			geometries: 0,
			frametime: 0,
			renderTime: 0,
			usedMemory: Et.instance.percentageOfUsedMemory.toFixed(2)
		}, this._onViewportAdded = () => {
			this._viewer?.viewport?.renderer.signals.frameHasRendered.connect(this._onFrameRendered);
		}, this._onViewportRemoved = () => {
			this._viewer?.viewport?.renderer.signals.frameHasRendered.disconnect(this._onFrameRendered);
		}, this._onFrameRendered = () => {
			z(this._viewer?.viewport), z(this._fpsBlade), this._fpsBlade.end(), this._fpsBlade.begin();
			let e = this._viewer.viewport.renderer.info;
			this._info.fps = e.fps, this._info.calls = e.render.calls, this._info.triangles = e.render.triangles, this._info.lines = e.render.lines, this._info.frame = e.render.frame, this._info.geometries = e.memory.geometries, this._info.frametime = e.frametime, this._info.renderTime = e.renderTime;
			let t = Et.instance;
			this._info.usedMemory = t.isAvailable ? t.percentageOfUsedMemory.toFixed(2) : "Not available", this._folder?.refresh();
		};
	}
	setup(e, t) {
		this._viewer = e, this._folder = t.addFolder({ title: "Render stats" }), this._viewer.signals.onViewportAdded.connect(this._onViewportAdded), this._viewer.signals.onViewportRemoved.connect(this._onViewportRemoved), this._fpsBlade = this._folder.addBlade({
			value: this._info.fps,
			view: "fpsgraph",
			label: "fpsgraph",
			interval: 100
		}), this._fpsBlade.begin(), this._folder.addBinding(this._info, "frametime", {
			readonly: !0,
			format: (e) => e.toFixed(0) + " ms"
		}), this._folder.addBinding(this._info, "renderTime", {
			readonly: !0,
			format: (e) => e.toFixed(0) + " ms"
		}), this._folder.addBinding(this._info, "calls", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "frame", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "lines", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "triangles", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "geometries", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "usedMemory", { readonly: !0 });
	}
	dispose() {
		this._folder?.dispose(), this._viewer?.viewport?.renderer.signals.frameHasRendered.disconnect(this._onFrameRendered);
	}
}, Ti = class extends Jn {
	constructor(...e) {
		super(...e), this.name = "SceneInfo", this.type = "info", this._folder = null, this._viewer = null, this._info = {
			bimMeshes: 0,
			sprites: 0,
			bufferSize: 0,
			lines: 0,
			geometries: 0
		}, this._updateInfo = () => {
			z(this._viewer), this._info.bufferSize = 0, this._info.geometries = 0, this._info.lines = 0, this._info.bimMeshes = this._viewer.scene.bimMeshController.count, this._info.sprites = this._viewer.scene.spriteController.count;
			let e = /* @__PURE__ */ new Set();
			this._viewer.scene._internalScene.traverse((t) => {
				let n = t, r = t;
				if (n.isMesh || r.isLine) {
					let t = n.geometry;
					e.has(t.id) || (e.add(t.id), this._info.geometries += 1, this._info.bufferSize += Ke(t) / 1024 / 1024);
				}
			}), this._folder?.refresh();
		};
	}
	setup(e, t) {
		this._viewer = e, this._folder = t.addFolder({ title: "Scene stats" }), this._folder.addBinding(this._info, "bimMeshes", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "lines", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "sprites", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "geometries", {
			readonly: !0,
			format: (e) => e.toFixed(0)
		}), this._folder.addBinding(this._info, "bufferSize", {
			readonly: !0,
			format: (e) => e.toFixed(0) + " MB"
		}), this._viewer.signals.onSceneGraphChanged.connect(this._updateInfo), this._updateInfo();
	}
	dispose() {
		z(this._viewer), this._folder?.dispose(), this._viewer.signals.onSceneGraphChanged.disconnect(this._updateInfo);
	}
}, Ei = document.createElement("style");
Ei.innerText = "\n  :root {\n    --tp-base-background-color: hsla(230, 0%, 100%, 1.00);\n    --tp-base-shadow-color: hsla(0, 0%, 100%, 0.20);\n    --tp-button-background-color: hsla(230, 7%, 75%, 1.00);\n    --tp-button-background-color-active: hsla(230, 7%, 60%, 1.00);\n    --tp-button-background-color-focus: hsla(230, 7%, 65%, 1.00);\n    --tp-button-background-color-hover: hsla(230, 7%, 70%, 1.00);\n    --tp-button-foreground-color: hsla(230, 10%, 30%, 1.00);\n    --tp-container-background-color: hsla(230, 15%, 30%, 0.20);\n    --tp-container-background-color-active: hsla(230, 15%, 30%, 0.32);\n    --tp-container-background-color-focus: hsla(230, 15%, 30%, 0.28);\n    --tp-container-background-color-hover: hsla(230, 15%, 30%, 0.24);\n    --tp-container-foreground-color: hsla(230, 10%, 30%, 1.00);\n    --tp-groove-foreground-color: hsla(230, 15%, 30%, 0.10);\n    --tp-input-background-color: hsla(230, 15%, 30%, 0.10);\n    --tp-input-background-color-active: hsla(230, 15%, 30%, 0.22);\n    --tp-input-background-color-focus: hsla(230, 15%, 30%, 0.18);\n    --tp-input-background-color-hover: hsla(230, 15%, 30%, 0.14);\n    --tp-input-foreground-color: hsla(230, 10%, 30%, 1.00);\n    --tp-label-foreground-color: hsla(230, 10%, 30%, 0.70);\n    --tp-monitor-background-color: hsla(230, 15%, 30%, 0.10);\n    --tp-monitor-foreground-color: hsla(230, 10%, 30%, 0.50);\n  }\n";
var Di = "viewer.devtools.", Oi = [
	new Si(),
	new oi(),
	new di(),
	new xi(),
	new vi(),
	new Ti(),
	new wi()
];
document.head.appendChild(Ei);
var ki = class e {
	static init(t) {
		globalThis.__devtools?.dispose();
		let n = new e(t);
		return globalThis.__devtools = n, n;
	}
	constructor(e) {
		this._tools = /* @__PURE__ */ new Set(), this._isDisposed = !1, this._onWindowResize = () => {
			Ni(this._devContainer), Ni(this._infoContainer);
		}, this._devContainer = Mi("DevToolsContainer", {
			x: window.innerWidth - 450,
			onClose: () => {
				e.settings.dev.showDevTools.value = !1;
			}
		}), this._devPane = new Ge({
			expanded: !0,
			title: "Developer tools",
			container: this._devContainer
		}), this._devPane.element.parentElement.style.width = "350px", this._devPane.element.parentElement.style.right = "70px", this._devPane.registerPlugin(Ue), this._devPane.registerPlugin(He), this._infoContainer = Mi("InfoToolsContainer", { onClose: () => {
			e.settings.dev.showInfoTools.value = !1;
		} }), this._infoPane = new Ge({
			expanded: !0,
			title: "Stats",
			container: this._infoContainer
		}), this._infoPane.element.parentElement.style.left = "10px", this._infoPane.element.parentElement.style.width = "350px", this._infoPane.registerPlugin(Ue), this._infoPane.registerPlugin(He), this._devContainer.hidden = !e.settings.debug.value, this._infoContainer.hidden = !e.settings.dev.showInfoTools.value, this._viewer = e, this.addDefaultTools(), this.loadContainerPositions(), this.showDevTools = e.settings.debug.value, addEventListener("resize", this._onWindowResize);
	}
	dispose() {
		this._isDisposed || (this._isDisposed = !0, removeEventListener("resize", this._onWindowResize), this._infoContainer.remove(), this._devContainer.remove(), this._devPane.dispose(), this._infoPane.dispose(), globalThis.__devtools === this && (globalThis.__devtools = null));
	}
	clear() {
		for (let e of this._tools.values()) this.removeTool(e);
	}
	addDefaultTools() {
		for (let e of Oi) this.addTool(e);
	}
	addTool(e) {
		if (!this._tools.has(e)) {
			this._tools.add(e);
			let t = this._paneForToolType(e.type);
			Ai(e), e.setup(this._viewer, t), t.refresh();
		}
	}
	removeTool(e) {
		if (this._tools.delete(e)) {
			ji(e);
			let t = this._paneForToolType(e.type);
			e.dispose(), t.refresh();
		}
	}
	save() {
		for (let e of this._tools) ji(e);
		this.saveContainerPositions();
	}
	_paneForToolType(e) {
		return {
			dev: this._devPane,
			info: this._infoPane
		}[e];
	}
	set showDevTools(e) {
		this._devContainer.hidden = !e;
	}
	set showInfoTools(e) {
		this._infoContainer.hidden = !e;
	}
	saveContainerPositions() {
		localStorage.setItem("viewer.devtools.devtoolcontainer", JSON.stringify({
			x: this._devContainer.offsetLeft,
			y: this._devContainer.offsetTop
		})), localStorage.setItem("viewer.devtools.infotoolcontainer", JSON.stringify({
			x: this._infoContainer.offsetLeft,
			y: this._infoContainer.offsetTop
		}));
	}
	loadContainerPositions() {
		let e = localStorage.getItem("viewer.devtools.devtoolcontainer");
		if (e) {
			let t = JSON.parse(e);
			this._devContainer.style.left = `${t.x}px`, this._devContainer.style.top = `${t.y}px`;
		}
		let t = localStorage.getItem("viewer.devtools.infotoolcontainer");
		if (t) {
			let e = JSON.parse(t);
			this._infoContainer.style.left = `${e.x}px`, this._infoContainer.style.top = `${e.y}px`;
		}
	}
};
function Ai(e) {
	let t = Di + e.name, n = localStorage.getItem(t) ?? "{}";
	e.fromJSON(JSON.parse(n));
}
function ji(e) {
	let t = Di + e.name;
	localStorage.setItem(t, JSON.stringify(e.toJSON()));
}
function Mi(e, t) {
	let n = document.createElement("div");
	n.id = e, document.body.appendChild(n), n.style.position = "absolute", n.style.left = `${t?.x ?? 16}px`, n.style.top = `${t?.y ?? 16}px`, n.style.zIndex = "9999";
	let r = document.createElement("div");
	r.style.cursor = "grab", r.style.position = "absolute", r.style.width = "100%", r.style.height = "24px", r.style.userSelect = "none", r.style.touchAction = "none", r.style.zIndex = "99999", r.style.display = "flex", r.style.justifyContent = "flex-end", r.style.alignItems = "center", n.appendChild(r);
	let i = document.createElement("button");
	i.textContent = "×", i.style.border = "none", i.style.background = "lightgray", i.style.borderRadius = "10px", i.style.color = "inherit", i.style.cursor = "pointer", i.style.fontSize = "20px", i.style.lineHeight = "1", i.style.padding = "0 4px", i.title = "Close", i.style.transition = "background-color 120ms ease", i.addEventListener("pointerenter", () => {
		i.style.background = "#b3b3b3";
	}), i.addEventListener("pointerleave", () => {
		i.style.background = "lightgray";
	}), i.addEventListener("click", () => {
		n.hidden = !0, t?.onClose?.();
	}), r.appendChild(i);
	let a = 0, o = 0, s = 0, c = 0, l = !1, u = (e) => {
		if (e.target === i) return;
		l = !0, r.setPointerCapture(e.pointerId), r.style.cursor = "grabbing";
		let t = n.getBoundingClientRect();
		s = t.left, c = t.top, a = e.clientX, o = e.clientY, e.preventDefault();
	}, d = (e) => {
		if (!l) return;
		let t = e.clientX - a, r = e.clientY - o;
		n.style.left = `${s + t}px`, n.style.top = `${c + r}px`, Ni(n);
	}, f = (e) => {
		l = !1, r.releasePointerCapture(e.pointerId), r.style.cursor = "grab";
	};
	return r.addEventListener("pointerdown", u), r.addEventListener("pointermove", d), r.addEventListener("pointerup", f), r.addEventListener("pointercancel", f), n;
}
function Ni(e) {
	let t = e.getBoundingClientRect(), n = window.innerWidth - t.width, r = window.innerHeight - t.height, i = Math.min(Math.max(0, t.x), n), a = Math.min(Math.max(0, t.y), r);
	e.style.left = `${i}px`, e.style.top = `${a}px`;
}
//#endregion
//#region src/scene/state/ObjectStateHistory.ts
var Pi = class {
	constructor() {
		this._controllers = /* @__PURE__ */ new WeakMap(), this._stateControllers = /* @__PURE__ */ new Map(), this._stateMap = /* @__PURE__ */ new Map(), this._stateCounter = 0;
	}
	initializeState(e) {
		let t = this._controllers.get(e);
		return t || (t = e.getStateController(), this._controllers.set(e, t)), t;
	}
	getState(e) {
		return this._stateMap.get(e);
	}
	pushState(e, t) {
		let n = e[Symbol.iterator](), r = n.next();
		if (r.done) return null;
		let i = this._stateCounter;
		this._stateMap.set(i, t);
		let a = /* @__PURE__ */ new Set();
		for (this._stateControllers.set(i, a); !r.done;) {
			let e = r.value, t = this.initializeState(e);
			t.addState(i), a.add(t), t.updateObjectState(this._stateMap), r = n.next();
		}
		return this._stateCounter++, i;
	}
	get size() {
		return this._stateMap.size;
	}
	clear() {
		this._stateMap.clear(), this._stateControllers.clear(), this._controllers = /* @__PURE__ */ new WeakMap();
	}
	removeState(e) {
		if (!this._stateMap.get(e)) throw Error("Unknown state id");
		let t = this._stateControllers.get(e) ?? [];
		for (let n of t) n.removeState(e), n.updateObjectState(this._stateMap);
		this._stateMap.delete(e), this._stateControllers.delete(e);
	}
	updateState(e, t) {
		this._stateMap.set(e, t);
		let n = this._stateControllers.get(e) ?? [];
		for (let e of n) e.updateObjectState(this._stateMap);
	}
}, Fi = /* @__PURE__ */ new b(), Ii = /* @__PURE__ */ new f(), Li = /* @__PURE__ */ new x(), Ri = class {
	constructor(e) {
		this._viewer = e, this.hemisphereLight = new ie(16777215, 4867901, 2), this.directionalLight = new m(16777215, 2), this.sky = new Je(), this.skyAzimuth = 180, this.skyElevation = 90, this.updateSun = () => {
			this._viewer.scene.getBoundingSphere(Fi);
			let e = Fi.radius + 10, t = me.degToRad(this.skyElevation), n = me.degToRad(this.skyAzimuth), r = Li.setFromSphericalCoords(e, t, n);
			this.sky.material.uniforms.sunPosition.value = r, this.directionalLight.position.copy(r), this._updateColorAndIntensityDirectionalLight();
		}, this._updateColorAndIntensityDirectionalLight = () => {
			this.directionalLight.intensity = this._viewer.settings.lights.directionalLightIntensity.value;
			let e = 1;
			if (this.skyElevation <= 100 && this.skyElevation >= 80 ? e = qe(this.skyElevation, 80, 90, 1, .55) : this.skyElevation >= 260 && this.skyElevation <= 280 && (e = qe(this.skyElevation, 270, 280, .55, 1)), this.skyElevation > 90 && this.skyElevation < 100) {
				let e = qe(this.skyElevation, 90, 100, 1, 0);
				this.directionalLight.intensity = this._viewer.settings.lights.directionalLightIntensity.value * e;
			} else if (this.skyElevation > 260 && this.skyElevation < 270) {
				let e = qe(this.skyElevation, 260, 270, 0, 1);
				this.directionalLight.intensity = this._viewer.settings.lights.directionalLightIntensity.value * e;
			} else this.skyElevation > 90 && this.skyElevation < 270 && (e = 0, this.directionalLight.intensity = 0);
			let t = e < .6 ? 0 : (e - .6) / .4, n = Ii.setRGB(1, 1 * e, 1 * t);
			this.directionalLight.color = n;
		}, this.sky.scale.setScalar(45e4);
	}
	setupLights() {
		this.hemisphereLight.name = "HemisphereLight", this.directionalLight.name = "DirectionalLight";
		for (let e of mn) this.hemisphereLight.layers.enable(e), this.directionalLight.layers.enable(e);
		this._viewer.signals.onLoadingFinished.connect(this.updateSun);
	}
}, B = {
	STRIDE: 10,
	MIN_X: 0,
	MIN_Y: 1,
	MIN_Z: 2,
	MAX_X: 3,
	MAX_Y: 4,
	MAX_Z: 5,
	PARENT: 6,
	LEFT: 7,
	RIGHT: 8,
	OBJID: 9
}, zi = {
	STRIDE: 1,
	ROOT: 0
}, Bi = -1, Vi = {
	header: zi,
	node: B,
	notDefined: -1
};
function V(e) {
	return zi.STRIDE + e * B.STRIDE;
}
//#endregion
//#region src/scene/boxtree/BoxTreeUtils.ts
function Hi(e, t, n, r) {
	let i = V(n);
	return r.box.min.set(e[i + B.MIN_X], e[i + B.MIN_Y], e[i + B.MIN_Z]), r.box.max.set(e[i + B.MAX_X], e[i + B.MAX_Y], e[i + B.MAX_Z]), r.parent = t[i + B.PARENT], r.left = t[i + B.LEFT], r.right = t[i + B.RIGHT], r.objectId = t[i + B.OBJID], r;
}
function Ui(e, t, n, r) {
	let i = V(n);
	e[i + B.MIN_X] = r.box.min.x, e[i + B.MIN_Y] = r.box.min.y, e[i + B.MIN_Z] = r.box.min.z, e[i + B.MAX_X] = r.box.max.x, e[i + B.MAX_Y] = r.box.max.y, e[i + B.MAX_Z] = r.box.max.z, t[i + B.PARENT] = r.parent, t[i + B.LEFT] = r.left, t[i + B.RIGHT] = r.right, t[i + B.OBJID] = r.objectId;
}
function Wi(e, t, n, r) {
	let i = V(n), a = V(r), o = V(t);
	e[o + B.MIN_X] = Math.min(e[i + B.MIN_X], e[a + B.MIN_X]), e[o + B.MIN_Y] = Math.min(e[i + B.MIN_Y], e[a + B.MIN_Y]), e[o + B.MIN_Z] = Math.min(e[i + B.MIN_Z], e[a + B.MIN_Z]), e[o + B.MAX_X] = Math.max(e[i + B.MAX_X], e[a + B.MAX_X]), e[o + B.MAX_Y] = Math.max(e[i + B.MAX_Y], e[a + B.MAX_Y]), e[o + B.MAX_Z] = Math.max(e[i + B.MAX_Z], e[a + B.MAX_Z]);
}
function Gi(e, t) {
	let n = V(t), r = e[n + B.MAX_X] - e[n + B.MIN_X], i = e[n + B.MAX_Y] - e[n + B.MIN_Y], a = e[n + B.MAX_Z] - e[n + B.MIN_Z];
	return 2 * (r * i + i * a + a * r);
}
function Ki(e, t, n) {
	let r = V(t), i = V(n), a = Math.min(e[r + B.MIN_X], e[i + B.MIN_X]), o = Math.min(e[r + B.MIN_Y], e[i + B.MIN_Y]), s = Math.min(e[r + B.MIN_Z], e[i + B.MIN_Z]), c = Math.max(e[r + B.MAX_X], e[i + B.MAX_X]), l = Math.max(e[r + B.MAX_Y], e[i + B.MAX_Y]), u = Math.max(e[r + B.MAX_Z], e[i + B.MAX_Z]), d = c - a, f = l - o, p = u - s;
	return 2 * (d * f + f * p + p * d);
}
//#endregion
//#region src/scene/boxtree/BoxTree.ts
var qi = new a(), Ji = new x(), Yi = new x(), H = na(), Xi = na(), Zi = na(), Qi = na(), $i = new Ye((e, t) => e.inheritedCost - t.inheritedCost), ea = class {
	constructor(e = 1e6) {
		this.isBoxTree = !0, this._nodeCount = 0, this._freeList = [], this._itemToNodeMap = /* @__PURE__ */ new Map(), this._nodeToItemMap = /* @__PURE__ */ new Map(), this._maxNodes = e, this.buffer = new SharedArrayBuffer((zi.STRIDE + e * B.STRIDE) * 4), this.f32 = new Float32Array(this.buffer), this.i32 = new Int32Array(this.buffer), this._root = -1;
	}
	get _root() {
		return this.i32[zi.ROOT];
	}
	set _root(e) {
		this.i32[zi.ROOT] = e;
	}
	get size() {
		return this._itemToNodeMap.size;
	}
	createSnapshot(e) {
		let t = (zi.STRIDE + this._nodeCount * B.STRIDE) * 4, n = new SharedArrayBuffer(t), r = new Uint8Array(n), i = new Uint8Array(this.buffer, 0, t);
		r.set(i);
		let a = Array(this._nodeCount).fill(null);
		for (let [t, n] of this._nodeToItemMap) a[t] = e(n);
		return {
			buffer: n,
			layout: Vi,
			identifiers: a,
			nodeCount: this._nodeCount,
			root: this._root
		};
	}
	reset() {
		this._root = -1, this._nodeCount = 0, this._freeList.length = 0, this._itemToNodeMap.clear(), this._nodeToItemMap.clear();
	}
	addItem(e) {
		let t = this._allocNode();
		e.getBoundingBox(qi), ta(H), H.box.copy(qi), H.objectId = t, Ui(this.f32, this.i32, t, H), this._itemToNodeMap.set(e, t), this._nodeToItemMap.set(t, e), this._insertLeaf(t);
	}
	removeItem(e) {
		let t = this._itemToNodeMap.get(e);
		if (t === void 0) throw Error("Item is not in the tree");
		this._removeLeaf(t), this._freeNode(t), this._itemToNodeMap.delete(e), this._nodeToItemMap.delete(t);
	}
	hasItem(e) {
		return this._itemToNodeMap.has(e);
	}
	updateItem(e) {
		let t = this._itemToNodeMap.get(e);
		if (t === void 0) throw Error("Item is not in the tree");
		this._removeLeaf(t), e.getBoundingBox(qi), ta(H), H.box.copy(qi), H.objectId = t, Ui(this.f32, this.i32, t, H), this._insertLeaf(t);
	}
	getBoundingBox(e) {
		return this._root === -1 ? e.makeEmpty() : (Hi(this.f32, this.i32, this._root, H), e.copy(H.box)), e;
	}
	readNode(e, t) {
		return Hi(this.f32, this.i32, e, t);
	}
	writeNode(e, t) {
		Ui(this.f32, this.i32, e, t);
	}
	raycast(e, t = 0) {
		if (this._root === -1) return [];
		let n = [];
		return this._raycastNode(this._root, e, t, n), n.sort((e, t) => e.distance - t.distance), n;
	}
	intersectPoint(e, t = 0) {
		if (this._root === -1) return [];
		let n = [];
		return this._intersectPointNode(this._root, e, t, n), n.sort((e, t) => e.distance - t.distance), n;
	}
	countNodes(e = {}) {
		let t = 0;
		return this.traverse(() => {
			t++;
		}, e), t;
	}
	_allocNode() {
		let e;
		if (this._freeList.length > 0) e = this._freeList.pop();
		else if (this._nodeCount >= this._maxNodes) throw Error("BoxTree: node pool exhausted");
		else e = this._nodeCount++;
		let t = V(e);
		return this.i32[t + B.OBJID] = -1, e;
	}
	_freeNode(e) {
		let t = V(e);
		this.i32[t + B.PARENT] = -1, this.i32[t + B.OBJID] = -1, this.i32[t + B.LEFT] = -1, this.i32[t + B.RIGHT] = -1, this._freeList.push(e);
	}
	_insertLeaf(e) {
		if (this._root === -1) {
			this._root = e;
			return;
		}
		let t = this._root, n = Ki(this.f32, this._root, e), r = Gi(this.f32, e);
		for ($i.clear(), $i.push({
			nodeIdx: this._root,
			inheritedCost: 0
		}); $i.length > 0;) {
			let { nodeIdx: i, inheritedCost: a } = $i.pop(), o = Ki(this.f32, i, e), s = o + a;
			s < n && (n = s, t = i);
			let c = a + o - Gi(this.f32, i), l = r + c, u = V(i);
			l < n && this.i32[u + B.OBJID] === -1 && $i.push({
				nodeIdx: this.i32[u + B.LEFT],
				inheritedCost: c
			}, {
				nodeIdx: this.i32[u + B.RIGHT],
				inheritedCost: c
			});
		}
		let i = Hi(this.f32, this.i32, t, H), a = Hi(this.f32, this.i32, e, Xi), o = i.parent, s = this._allocNode(), c = ta(Zi);
		if (c.box.copy(i.box).union(a.box), c.parent = o, c.left = t, c.right = e, Ui(this.f32, this.i32, s, c), this._setParent(t, s), this._setParent(e, s), o === -1) this._root = s;
		else {
			let e = V(o);
			this.i32[e + B.LEFT] === t ? this.i32[e + B.LEFT] = s : this.i32[e + B.RIGHT] = s;
		}
		this._refitTree(s, !1);
	}
	_removeLeaf(e) {
		let t = Hi(this.f32, this.i32, e, H).parent;
		if (t === -1) {
			this._root = -1;
			return;
		}
		let n = Hi(this.f32, this.i32, t, Xi), r = n.parent, i = n.left === e ? n.right : n.left;
		if (r === -1) this._root = i, this._setParent(i, -1);
		else {
			this._setParent(i, r);
			let e = V(r);
			this.i32[e + B.LEFT] === t ? this.i32[e + B.LEFT] = i : this.i32[e + B.RIGHT] = i, this._refitTree(r, !0);
		}
		this._freeNode(t);
	}
	_refitTree(e, t) {
		let n = e;
		for (; n !== -1;) Hi(this.f32, this.i32, n, Qi), Qi.objectId === -1 && (Wi(this.f32, n, Qi.left, Qi.right), t && this._rotate(n)), n = Qi.parent;
	}
	_rotate(e) {
		let t = Hi(this.f32, this.i32, e, H), n = Hi(this.f32, this.i32, t.left, Xi), r = Hi(this.f32, this.i32, t.right, Zi), i = t.left, a = t.right, o = [
			0,
			0,
			0,
			0
		];
		if (n.objectId === -1) {
			let e = Gi(this.f32, i);
			o[0] = Ki(this.f32, n.left, a) - e, o[1] = Ki(this.f32, n.right, a) - e;
		}
		if (r.objectId === -1) {
			let e = Gi(this.f32, a);
			o[2] = Ki(this.f32, r.left, i) - e, o[3] = Ki(this.f32, r.right, i) - e;
		}
		let s = 0;
		for (let e = 1; e < 4; e++) o[e] < o[s] && (s = e);
		if (!(o[s] >= 0)) switch (s) {
			case 0:
				this._setParent(n.right, e), this._setRight(e, n.right), this._setRight(i, a), this._setParent(a, i), Wi(this.f32, i, n.left, a);
				break;
			case 1:
				this._setParent(n.left, e), this._setRight(e, n.left), this._setLeft(i, a), this._setParent(a, i), Wi(this.f32, i, a, n.right);
				break;
			case 2:
				this._setParent(r.right, e), this._setLeft(e, r.right), this._setRight(a, i), this._setParent(i, a), Wi(this.f32, a, r.left, i);
				break;
			case 3: this._setParent(r.left, e), this._setLeft(e, r.left), this._setLeft(a, i), this._setParent(i, a), Wi(this.f32, a, i, r.right);
		}
	}
	_setParent(e, t) {
		this.i32[V(e) + B.PARENT] = t;
	}
	_setLeft(e, t) {
		this.i32[V(e) + B.LEFT] = t;
	}
	_setRight(e, t) {
		this.i32[V(e) + B.RIGHT] = t;
	}
	_raycastNode(e, t, n, r) {
		let i = [e];
		for (; i.length > 0;) {
			let e = i.pop();
			if (Hi(this.f32, this.i32, e, H), qi.copy(H.box), n !== 0 && qi.expandByScalar(n), t.intersectBox(qi, Ji)) {
				if (H.objectId === -1) i.push(H.left, H.right);
				else {
					let e = this._nodeToItemMap.get(H.objectId);
					z(e), r.push({
						object: e,
						distance: t.origin.distanceTo(Ji),
						point: Ji.clone(),
						box: H.box.clone()
					});
				}
			}
		}
	}
	_intersectPointNode(e, t, n, r) {
		let i = [e];
		for (; i.length > 0;) {
			let e = i.pop();
			if (Hi(this.f32, this.i32, e, H), qi.copy(H.box), n !== 0 && qi.expandByScalar(n), qi.containsPoint(t)) {
				if (H.objectId === -1) i.push(H.left, H.right);
				else {
					H.box.getCenter(Yi);
					let e = this._nodeToItemMap.get(H.objectId);
					z(e), r.push({
						object: e,
						distance: t.distanceTo(Yi),
						point: t.clone(),
						box: H.box.clone()
					});
				}
			}
		}
	}
	traverse(e, t = {}) {
		if (this._root === -1) return;
		let n = t.leavesOnly ?? !1, r = t.maxDepth ?? Infinity, i = [{
			idx: this._root,
			depth: 0
		}], a = na();
		for (; i.length > 0;) {
			let { idx: t, depth: o } = i.pop();
			if (o > r) continue;
			Hi(this.f32, this.i32, t, a);
			let s = a.left, c = a.right, l = a.objectId;
			(!n || l !== -1) && e(a, t, o), l === -1 && i.push({
				idx: s,
				depth: o + 1
			}, {
				idx: c,
				depth: o + 1
			});
		}
	}
};
function ta(e) {
	return e.box.makeEmpty(), e.parent = -1, e.left = -1, e.right = -1, e.objectId = -1, e;
}
function na() {
	return {
		box: new a(),
		parent: -1,
		left: -1,
		right: -1,
		objectId: -1
	};
}
//#endregion
//#region src/scene/boxtree/BoxTreeHelper.ts
var ra = class extends de {
	constructor(e, t = {}) {
		super(new l(), new le({
			color: 65535,
			depthTest: !1,
			depthWrite: !1,
			transparent: !0
		})), this._tree = e, this._options = {
			showParents: !1,
			maxDepth: 5,
			...t
		};
	}
	showParents(e) {
		this._options.showParents = e, this.update();
	}
	setDepth(e) {
		this._options.maxDepth = e, this.update();
	}
	update() {
		this.geometry.dispose(), this.geometry = new l();
		let { showParents: e, maxDepth: t } = this._options, n = this._tree.countNodes({ maxDepth: t });
		if (n === 0) return;
		let r = new Float32Array(n * 8 * 3), i = new Uint8Array([
			0,
			4,
			1,
			5,
			2,
			6,
			3,
			7,
			0,
			2,
			1,
			3,
			4,
			6,
			5,
			7,
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7
		]), a = i.length, o = n * a, s = o > 65535 ? new Uint32Array(o) : new Uint16Array(o), u = 0, d = 0;
		this._tree.traverse((n, o, c) => {
			if (!e && c < t && n.objectId === -1) return;
			let { min: l, max: f } = n.box;
			for (let e = 0; e < 2; e++) {
				let t = e === 0 ? l.x : f.x;
				for (let e = 0; e < 2; e++) {
					let n = e === 0 ? l.y : f.y;
					for (let e = 0; e < 2; e++) r[u] = t, r[u + 1] = n, r[u + 2] = e === 0 ? l.z : f.z, u += 3;
				}
			}
			let p = d * 8, m = d * a;
			for (let e = 0; e < a; e++) s[m + e] = p + i[e];
			d++;
		}, { maxDepth: t });
		let f = new Float32Array(r.buffer, 0, d * 8 * 3), p = s.slice(0, d * a);
		this.geometry.setIndex(new c(p, 1, !1)), this.geometry.setAttribute("position", new c(f, 3, !1));
	}
}, ia = new le({ color: 16711680 }), aa = new le({ color: 65280 }), oa = new le({ color: 255 }), sa = new x(-1e3, 0, 0), ca = new x(1e3, 0, 0), la = new x(0, -1e3, 0), ua = new x(0, 1e3, 0), da = new x(0, 0, -1e3), fa = new x(0, 0, 1e3), U = new l().setFromPoints([sa, ca]), pa = new l().setFromPoints([la, ua]), ma = new l().setFromPoints([da, fa]), ha = /* @__PURE__ */ new x(), ga = class extends re {
	constructor() {
		super(), this.xLine = new ce(U, ia), this.yLine = new ce(pa, aa), this.zLine = new ce(ma, oa), this.add(this.xLine), this.add(this.yLine), this.add(this.zLine), this.xLine.visible = !1, this.yLine.visible = !1, this.zLine.visible = !1;
	}
	setLinePosition(e) {
		ha.setFromMatrixPosition(e), this.xLine.position.set(ha.x, ha.y, ha.z), this.yLine.position.set(ha.x, ha.y, ha.z), this.zLine.position.set(ha.x, ha.y, ha.z);
	}
}, _a = class {
	constructor() {
		this.pool = [], this._length = 0;
	}
	get length() {
		return this._length;
	}
	push(e) {
		if (this._length >= this.pool.length) this.pool.push({
			start: e.start,
			count: e.count
		});
		else {
			let t = this.pool[this._length];
			t.start = e.start, t.count = e.count;
		}
		this._length++;
	}
	updateMultiDrawBuffers(e, t, n) {
		if (this._length === 0) return 0;
		let r = this.pool.slice(0, this._length);
		r.sort((e, t) => e.start - t.start);
		let i = 0, a = r[0].start, o = a + r[0].count;
		for (let s = 1; s < r.length; s++) {
			let c = r[s].start, l = c + r[s].count;
			c <= o ? o = Math.max(o, l) : (e[i] = a * n, t[i] = o - a, i++, a = c, o = l);
		}
		return e[i] = a * n, t[i] = o - a, i + 1;
	}
	reset() {
		this._length = 0;
	}
}, va = (/* @__PURE__ */ {
	start: -1,
	count: -1
}), W = [
	,
	,
	,
], ya = new f(), ba = new _a();
function xa(e) {
	return class extends e {
		constructor(...e) {
			super(...e), this._visibilityChanged = !0, this._activeChanged = !0, this._multiDrawInstances = null, this._colorsTexture = null, this.isBatchedMesh = !0, this.type = "Mesh", this._visibility = Array(this.geometry.maxGeometryCount).fill(!1), this._active = Array(this.geometry.maxGeometryCount).fill(!1), this._multiDrawStarts = new Int32Array(this.geometry.maxGeometryCount), this._multiDrawCounts = new Int32Array(this.geometry.maxGeometryCount), this._multiDrawCount = 0, this._indirectTexture = this._initIndirectTexture(), this.onBeforeRender = this.onObjectBeforeRender, this._lastGeometryCount = this.geometry.geometryCount, this.frustumCulled = !1;
		}
		get geometryCount() {
			return this.geometry.geometryCount;
		}
		get _matricesTexture() {
			return this.geometry._matricesTexture;
		}
		setAllVisibility(e) {
			this._visibility.fill(e);
		}
		setVisibleAt(e, t) {
			this.checkGeometryId(e), this._visibility[e] !== t && (this._visibility[e] = t, this._visibilityChanged = !0);
		}
		getVisibleAt(e) {
			return this.checkGeometryId(e), this._visibility[e];
		}
		setActiveAt(e, t) {
			this.checkGeometryId(e), this._active[e] !== t && (this._active[e] = t, this._activeChanged = !0);
		}
		getActiveAt(e) {
			return this.checkGeometryId(e), this._active[e];
		}
		setDiffuseColorAt(e, t) {
			this.checkGeometryId(e), ya.set(t);
			let { r: n, g: r, b: i } = ya;
			this.material.propertiesTexture.setMaterialProperty(e, "diffuse", n, r, i);
		}
		setAllDiffuseColor(e) {
			ya.set(e);
			let { r: t, g: n, b: r } = ya;
			for (let e = 0; e < this.geometry.geometryCount; e++) this.material.propertiesTexture.setMaterialProperty(e, "diffuse", t, n, r);
		}
		getDiffuseColorAt(e) {
			return this.checkGeometryId(e), this.material.propertiesTexture.getMaterialProperty(e, "diffuse", W) ? ya.set(W[0], W[1], W[2]).getHex() : ya.set(0, 0, 0).getHex();
		}
		setEmissiveColorAt(e, t) {
			this.checkGeometryId(e), ya.set(t);
			let { r: n, g: r, b: i } = ya;
			this.material.propertiesTexture.setMaterialProperty(e, "emissive", n, r, i);
		}
		getEmissiveColorAt(e) {
			return this.checkGeometryId(e), this.material.propertiesTexture.getMaterialProperty(e, "emissive", W) ? ya.set(W[0], W[1], W[2]).getHex() : ya.set(0, 0, 0).getHex();
		}
		setOpacityAt(e, t) {
			this.checkGeometryId(e), this.material.propertiesTexture.setMaterialProperty(e, "opacity", t);
		}
		getOpacityAt(e) {
			return this.checkGeometryId(e), this.material.propertiesTexture.getMaterialProperty(e, "opacity", W) ? W[0] : 1;
		}
		setMetalnessAt(e, t) {
			this.checkGeometryId(e), this.material.propertiesTexture.setMaterialProperty(e, "metalness", t);
		}
		getMetalnessAt(e) {
			return this.checkGeometryId(e), this.material.propertiesTexture.getMaterialProperty(e, "metalness", W) ? W[0] : 0;
		}
		setRoughnessAt(e, t) {
			this.checkGeometryId(e), this.material.propertiesTexture.setMaterialProperty(e, "roughness", t);
		}
		getRoughnessAt(e) {
			return this.checkGeometryId(e), this.material.propertiesTexture.getMaterialProperty(e, "roughness", W) ? W[0] : 1;
		}
		checkGeometryId(e) {
			if (e > this.geometry.geometryCount) throw RangeError(`GeometryId is out of bounds. Received ${e}, max ${this.geometry.geometryCount}`);
		}
		_initIndirectTexture() {
			return new p(/* @__PURE__ */ new Uint32Array(), 0, 0);
		}
		onObjectBeforeRender() {
			this.geometry.needBoundingBoxUpdate && (this.geometry.computeBoundingBox(), this.geometry.computeBoundingSphere(), this.geometry.needBoundingBoxUpdate = !1);
			let e = this.geometry.geometryCount !== this._lastGeometryCount;
			this._lastGeometryCount = this.geometry.geometryCount, (this._visibilityChanged || this._activeChanged || e) && this.updateMultiDrawRenderList(), this._visibilityChanged = !1, this._activeChanged = !1;
		}
		updateMultiDrawRenderList() {
			let e = this.geometry, t = e.index, n = t === null ? 1 : t.array.BYTES_PER_ELEMENT, r = this._visibility, i = this._active, a = this.geometry.geometryCount;
			ba.reset();
			for (let t = 0, n = a; t < n; t++) r[t] && i[t] && (e.getDrawRangeAt(t, va), ba.push(va));
			this._multiDrawCount = ba.updateMultiDrawBuffers(this._multiDrawStarts, this._multiDrawCounts, n);
		}
	};
}
//#endregion
//#region src/scene/geometry/batching/BatchedObject.ts
var Sa = class extends xa(ge) {}, Ca = class extends xa(de) {}, wa = class extends re {
	constructor(e, t, n) {
		if (super(), this._bypassMaterialIndex = null, this.isMultiMaterialBatchedObject = !0, n.length === 0) throw Error("MultiMaterialBatchedObject must have at least one material");
		if (n.length > 256) throw Error("MultiMaterialBatchedObject cannot have more than 256 materials");
		this.geometry = t, this._batchedObjects = [], this._materialIndices = new Uint8Array(e), this.materialConfigs = n, this._initBatchedObjects(n);
	}
	_initBatchedObjects(e) {
		for (let t of e) {
			let e = this.newBatchedObject(this.geometry, t.material);
			this._batchedObjects.push(e), this.add(e), e.layers.set(t.layer);
		}
		this._batchedObjects[0].setAllVisibility(!0);
	}
	*getMaterials(e = []) {
		for (let t of this.materialConfigs) (e.length === 0 || e.includes(t.type)) && (yield t.material);
	}
	get count() {
		return this._batchedObjects[0].geometryCount;
	}
	get batchedObjects() {
		return this._batchedObjects;
	}
	setMaterialLayer(e, t) {
		let n = this.getMaterialIndexFromType(e);
		n !== null && this.batchedObjects[n].layers.set(t);
	}
	getMaterialIndexFromType(e) {
		let t = this.materialConfigs.findIndex((t) => t.type === e);
		return t === -1 ? null : t;
	}
	setClippingPlanes(e) {
		for (let t of this.batchedObjects) t.material.clippingPlanes = e, t.material.needsUpdate = !0;
	}
	setMaterialTypeAt(e, t) {
		let n = this.getMaterialIndexFromType(t);
		n !== null && this.setMaterialIndexAt(e, n);
	}
	getMaterialTypeAt(e) {
		let t = this.getMaterialIndexAt(e);
		return this.materialConfigs[t].type;
	}
	setMaterialIndexAt(e, t) {
		let n = this._materialIndices[e];
		if (this._materialIndices[e] = t, this._bypassMaterialIndex !== null) return;
		let r = this._batchedObjects[n].getVisibleAt(e);
		this._batchedObjects[n].setVisibleAt(e, !1), this._batchedObjects[t].setVisibleAt(e, r);
	}
	getMaterialIndexAt(e) {
		return this._bypassMaterialIndex === null ? this._materialIndices[e] : this._bypassMaterialIndex;
	}
	setVisibleAt(e, t) {
		let n = this.getMaterialIndexAt(e);
		this._batchedObjects[n].setVisibleAt(e, t);
	}
	getVisibleAt(e) {
		let t = this.getMaterialIndexAt(e);
		return this._batchedObjects[t].getVisibleAt(e);
	}
	setActiveAt(e, t) {
		for (let n of this._batchedObjects) n.setActiveAt(e, t);
	}
	getActiveAt(e) {
		let t = this.getMaterialIndexAt(e);
		return this._batchedObjects[t].getActiveAt(e);
	}
	setDiffuseColorAt(e, t) {
		for (let n of this._batchedObjects) n.setDiffuseColorAt(e, t);
	}
	setAllDiffuseColor(e) {
		for (let t of this._batchedObjects) t.setAllDiffuseColor(e);
	}
	getDiffuseColorAt(e) {
		return this._batchedObjects[0].getDiffuseColorAt(e);
	}
	setEmissiveColorAt(e, t) {
		for (let n of this._batchedObjects) n.setEmissiveColorAt(e, t);
	}
	getEmissiveColorAt(e) {
		return this._batchedObjects[0].getEmissiveColorAt(e);
	}
	setOpacityAt(e, t) {
		for (let n of this._batchedObjects) n.setOpacityAt(e, t);
	}
	getOpacityAt(e) {
		return this._batchedObjects[0].getOpacityAt(e);
	}
	setMetalnessAt(e, t) {
		for (let n of this._batchedObjects) n.setMetalnessAt(e, t);
	}
	getMetalnessAt(e) {
		return this._batchedObjects[0].getMetalnessAt(e);
	}
	setRoughnessAt(e, t) {
		for (let n of this._batchedObjects) n.setRoughnessAt(e, t);
	}
	getRoughnessAt(e) {
		return this._batchedObjects[0].getRoughnessAt(e);
	}
	dispose() {
		this.geometry.dispose();
		let e = new Set(this.materialConfigs.map((e) => e.material.propertiesTexture));
		for (let e of this.materialConfigs) e.material.dispose();
		for (let t of e) t.dispose();
	}
	setBypassMaterial(e) {
		let t = this.getMaterialIndexFromType(e);
		if (t !== null && t !== this._bypassMaterialIndex) {
			for (let e = 0; e < this.batchedObjects[0].geometryCount; e++) {
				let n = this._materialIndices[e], r = this.getVisibleAt(e);
				this._batchedObjects[n].setVisibleAt(e, !1), this._batchedObjects[t].setVisibleAt(e, r);
			}
			this._bypassMaterialIndex = t;
		}
	}
	removeBypassMaterial() {
		if (this._bypassMaterialIndex !== null) {
			for (let e = 0; e < this.batchedObjects[0].geometryCount; e++) {
				let t = this._materialIndices[e], n = this.getVisibleAt(e);
				this._batchedObjects[this._bypassMaterialIndex].setVisibleAt(e, !1), this._batchedObjects[t].setVisibleAt(e, n);
			}
			this._bypassMaterialIndex = null;
		}
	}
}, Ta = class extends wa {
	newBatchedObject(e, t) {
		return new Ca(e, t);
	}
}, Ea = new Xe(), Da = class {
	constructor() {
		this.a = new Ze(), this.b = new Ze();
	}
	getBoundingBox(e) {
		return e.makeEmpty(), e.expandByPoint(this.a), e.expandByPoint(this.b), e.expandByScalar(.03), e;
	}
}, Oa = class {
	constructor() {
		this.isMeshContainer = !0, this._edgeBoxTrees = /* @__PURE__ */ new Map(), this._bvhs = /* @__PURE__ */ new Map();
	}
	contains(e) {
		return e.belongsToContainer(this);
	}
	dispose() {}
	getEdgeBoxTree(e) {
		let t = this._edgeBoxTrees.get(e.srcGeometryUuid);
		return t ??= this.computeEdgeTree(e), t;
	}
	computeEdgeTree(e) {
		let t = this._edgeBoxTrees.get(e.srcGeometryUuid);
		if (t) return t;
		if (t = new ea(), this.getGeometryAt(e.proxyId, Ea), Ea.index) throw Error("Geometry should not be indexed");
		for (let e = 0; e < Ea.getAttribute("position").count - 1; e += 2) {
			let n = new Da();
			n.a.fromBufferAttribute(Ea.getAttribute("position"), e), n.b.fromBufferAttribute(Ea.getAttribute("position"), e + 1), t.addItem(n);
		}
		return this._edgeBoxTrees.set(e.srcGeometryUuid, t), t;
	}
	getGeometryBVH(e) {
		return this._bvhs.get(e);
	}
	registerBVH(e, t) {
		this._bvhs.set(e, t);
	}
}, ka = class extends Oa {
	constructor(e) {
		super(), this._batchObject = e;
	}
	get root() {
		return this._batchObject;
	}
	get geometry() {
		return this._batchObject.geometry;
	}
	set visible(e) {
		this._batchObject.visible = e;
	}
	get visible() {
		return this._batchObject.visible;
	}
	get count() {
		return this._batchObject.count;
	}
	clear() {
		this._batchObject.clear();
	}
	dispose() {
		this._batchObject.dispose();
	}
	setMaterialLayer(e, t) {
		this._batchObject.setMaterialLayer(e, t);
	}
	getMaterials(e = []) {
		return this._batchObject.getMaterials(e);
	}
	setClippingPlanes(e) {
		this._batchObject.setClippingPlanes(e);
	}
	setMaterialTypeAt(e, t) {
		return this._batchObject.setMaterialTypeAt(e, t);
	}
	getMaterialTypeAt(e) {
		return this._batchObject.getMaterialTypeAt(e);
	}
	setActiveAt(e, t) {
		return this._batchObject.setActiveAt(e, t);
	}
	getActiveAt(e) {
		return this._batchObject.getActiveAt(e);
	}
	setVisibilityAt(e, t) {
		return this._batchObject.setVisibleAt(e, t);
	}
	getVisibilityAt(e) {
		return this._batchObject.getVisibleAt(e);
	}
	setPositionAt(e, t) {
		return this._batchObject.geometry.setPositionAt(e, t);
	}
	getPositionAt(e, t) {
		return this._batchObject.geometry.getPositionAt(e, t);
	}
	setMatrixAt(e, t) {
		return this._batchObject.geometry.setMatrixAt(e, t);
	}
	getMatrixAt(e, t) {
		return this._batchObject.geometry.getMatrixAt(e, t);
	}
	setDiffuseColorAt(e, t) {
		return this._batchObject.setDiffuseColorAt(e, t);
	}
	getDiffuseColorAt(e) {
		return this._batchObject.getDiffuseColorAt(e);
	}
	getBoundingBoxAt(e, t) {
		return this._batchObject.geometry.getWorldBoundingBoxAt(e, t);
	}
	getBoundingSphereAt(e, t) {
		return this._batchObject.geometry.getWorldBoundingSphereAt(e, t);
	}
	setOpacityAt(e, t) {
		return this._batchObject.setOpacityAt(e, t);
	}
	getOpacityAt(e) {
		return this._batchObject.getOpacityAt(e);
	}
	setMetalnessAt(e, t) {
		return this._batchObject.setMetalnessAt(e, t);
	}
	getMetalnessAt(e) {
		return this._batchObject.getMetalnessAt(e);
	}
	setRoughnessAt(e, t) {
		return this._batchObject.setRoughnessAt(e, t);
	}
	getRoughnessAt(e) {
		return this._batchObject.getRoughnessAt(e);
	}
	setEmissiveColorAt(e, t) {
		return this._batchObject.setEmissiveColorAt(e, t);
	}
	getEmissiveColorAt(e) {
		return this._batchObject.getEmissiveColorAt(e);
	}
	getGeometryAt(e, t) {
		return this._batchObject.geometry.getGeometryAt(e, t);
	}
	getDeepGeometryAt(e, t) {
		return this._batchObject.geometry.copyGeometryAt(e, t);
	}
}, Aa = class extends ka {
	constructor(e, t, n) {
		let r = new Ta(e, t, n);
		super(r);
	}
}, ja = /* @__PURE__ */ new x(), Ma = /* @__PURE__ */ new x(), Na = /* @__PURE__ */ new x(), Pa = /* @__PURE__ */ new x();
function Fa(e, t) {
	if (e.length === 0) throw Error("Cannot compute center of empty vector list.");
	t.set(0, 0, 0);
	for (let n of e) t.add(n);
	return t.divideScalar(e.length);
}
function Ia(e, t, n) {
	return n.set(t.x - e.x, t.y - e.y, t.z - e.z), n.normalize(), n;
}
function La(e, t, n, r) {
	Ia(e, t, ja), Ma.crossVectors(n, ja), Math.abs(Ma.x) == 0 && Math.abs(Ma.y) == 0 && Math.abs(Ma.z) == 0 && (e.x < t.x ? Ma.set(0, 0, 1) : Ma.set(0, 0, -1)), Ma.normalize();
	let i = Math.acos(n.dot(ja));
	return r.setFromAxisAngle(Ma, i), r;
}
function Ra(e, t, n, r, i = 0, a = 1) {
	Na.subVectors(t, e), Pa.subVectors(n, e);
	let o = Na.lengthSq();
	if (o === 0) {
		r.copy(e);
		return;
	}
	let s = me.clamp(Na.dot(Pa) / o, 0, 1);
	s < i ? r.copy(e) : s > a ? r.copy(t) : r.copy(Na).multiplyScalar(s).add(e);
}
//#endregion
//#region src/scene/geometry/containers/base/BaseProxy.ts
var za = class {
	constructor(e, t, n) {
		this.geometry = new l(), this.proxyId = t, this.srcGeometryUuid = n, this.container = e, this.container.getGeometryAt(this.proxyId, this.geometry);
	}
	belongsToContainer(e) {
		return this.container === e;
	}
	showBoundingBoxHelper(e, t) {
		if (!this._boxHelper) {
			let e = new a();
			this.getBoundingBox(e), this._boxHelper = new o(e);
		}
		t ? e.add(this._boxHelper) : this._boxHelper.removeFromParent();
	}
	setMaterial(e) {
		return this.container.setMaterialTypeAt(this.proxyId, e);
	}
	getMaterial() {
		return this.container.getMaterialTypeAt(this.proxyId);
	}
	setPosition(e) {
		return this.container.setPositionAt(this.proxyId, e);
	}
	getPosition(e) {
		return this.container.getPositionAt(this.proxyId, e);
	}
	setMatrix(e) {
		return this.container.setMatrixAt(this.proxyId, e);
	}
	getMatrix(e) {
		return this.container.getMatrixAt(this.proxyId, e);
	}
	getBoundingBox(e) {
		return this.container.getBoundingBoxAt(this.proxyId, e);
	}
	getBoundingSphere(e) {
		return this.container.getBoundingSphereAt(this.proxyId, e);
	}
	setVisible(e) {
		return this.container.setVisibilityAt(this.proxyId, e);
	}
	getVisible() {
		return this.container.getVisibilityAt(this.proxyId);
	}
	setMetalness(e) {
		return this.container.setMetalnessAt(this.proxyId, e);
	}
	getMetalness() {
		return this.container.getMetalnessAt(this.proxyId);
	}
	setOpacity(e) {
		return this.container.setOpacityAt(this.proxyId, e);
	}
	getOpacity() {
		return this.container.getOpacityAt(this.proxyId);
	}
	setDiffuseColor(e) {
		return this.container.setDiffuseColorAt(this.proxyId, e);
	}
	getDiffuseColor() {
		return this.container.getDiffuseColorAt(this.proxyId);
	}
	setEmissiveColor(e) {
		return this.container.setEmissiveColorAt(this.proxyId, e);
	}
	getEmissiveColor() {
		return this.container.getEmissiveColorAt(this.proxyId);
	}
	setRoughness(e) {
		return this.container.setRoughnessAt(this.proxyId, e);
	}
	getRoughness() {
		return this.container.getRoughnessAt(this.proxyId);
	}
	setActive(e) {
		return this.container.setActiveAt(this.proxyId, e);
	}
	getActive() {
		return this.container.getActiveAt(this.proxyId);
	}
	getDeepGeometry(e) {
		return this.container.getDeepGeometryAt(this.proxyId, e);
	}
}, Ba = /* @__PURE__ */ new y(), Va = /* @__PURE__ */ new y(), Ha = /* @__PURE__ */ new De(), Ua = /* @__PURE__ */ new x(), Wa = /* @__PURE__ */ new x(), Ga = /* @__PURE__ */ new x(), Ka = class extends za {
	raycast(e, t, n = .05) {
		this.getMatrix(Va), Ba.copy(Va).invert(), Ha.copy(e.ray).applyMatrix4(Ba);
		let r = this.container.getEdgeBoxTree(this), i = Ba.getMaxScaleOnAxis() * n, a = r.raycast(Ha, i);
		for (let e of a) {
			let { object: n } = e, r = new x();
			Ha.distanceSqToSegment(n.a, n.b, Ga, r), Ga.applyMatrix4(Va), r.applyMatrix4(Va);
			let i = Ga.distanceTo(r);
			t.push({
				rayDistance: i,
				distance: i,
				point: r
			});
		}
	}
	projectPointOnEdges(e, t, n = .3) {
		this.getMatrix(Va), Ba.copy(Va).invert(), Wa.copy(e).applyMatrix4(Ba);
		let r = this.container.getEdgeBoxTree(this).intersectPoint(Wa, n), i = new x(), a = Infinity, o = !1;
		for (let e of r) {
			let { object: t } = e;
			Ra(t.a, t.b, Wa, Ua, .05, .95);
			let n = Wa.distanceTo(Ua);
			n < a && (a = n, i.copy(Ua), o = !0);
		}
		return t.copy(i).applyMatrix4(Va), o;
	}
}, qa = class extends Ka {
	constructor(...e) {
		super(...e), this.isBatchedLineProxy = !0;
	}
}, Ja = class extends wa {
	newBatchedObject(e, t) {
		return new Sa(e, t);
	}
}, Ya = class extends ka {
	constructor(e, t, n) {
		let r = new Ja(e, t, n);
		super(r);
	}
}, Xa = new x(), Za = new x(), Qa = new he(), $a = class extends de {
	constructor(e, t = 1, n = 16711680) {
		super(new l(), new le({
			color: n,
			toneMapped: !1,
			depthTest: !0,
			depthWrite: !1,
			transparent: !0
		})), this.type = "VertexNormalsHelper", this.object = e, this.size = t, this.update();
	}
	update() {
		this.object.updateMatrixWorld(!0), Qa.getNormalMatrix(this.object.matrixWorld);
		let e = this.object.matrixWorld, t = this.object.geometry, n = t.index, r = t.attributes.position, i = t.attributes.normal, { start: a, count: o } = t.drawRange, s = n ? n.count : r.count, c = Math.min(o === Infinity ? s : o, s - a), l = c * 2 * 3, u = this.geometry.attributes.position;
		(!u || u.array.length < l) && (this.geometry.deleteAttribute("position"), u = new te(l, 3), this.geometry.setAttribute("position", u));
		let d = 0;
		for (let t = a; t < a + c; t++) {
			let a = n ? n.getX(t) : t;
			Xa.fromBufferAttribute(r, a).applyMatrix4(e), Za.fromBufferAttribute(i, a).applyMatrix3(Qa).normalize().multiplyScalar(this.size).add(Xa), u.setXYZ(d++, Xa.x, Xa.y, Xa.z), u.setXYZ(d++, Za.x, Za.y, Za.z);
		}
		this.geometry.setDrawRange(0, d), u.needsUpdate = !0;
	}
	dispose() {
		this.geometry.dispose(), this.material.dispose();
	}
}, eo = new y(), to = new y(), no = new De(), ro = [], io = class extends za {
	showNormalsHelper(e, t) {
		if (!this._normalsHelper) {
			let e = new ge(this.geometry);
			this._normalsHelper = new $a(e, .2);
		}
		t ? (e.add(this._normalsHelper), this.getMatrix(eo), this._normalsHelper.applyMatrix4(eo)) : (this._normalsHelper.removeFromParent(), this._normalsHelper.dispose(), this._normalsHelper = void 0);
	}
	get triangleCount() {
		let e = this.geometry.getIndex(), t = this.geometry.getAttribute("position");
		return e ? e.count / 3 : t.count / 3;
	}
	getGeometryBVH() {
		return this.container.getGeometryBVH(this.srcGeometryUuid) ?? null;
	}
	raycast(e, t) {
		let n = this.container.getGeometryBVH(this.srcGeometryUuid);
		if (n) {
			this.getMatrix(to), eo.copy(to).invert(), no.copy(e.ray).applyMatrix4(eo);
			let r = n.raycastFirst(no, h);
			if (r) {
				let n = r.point;
				n.applyMatrix4(to);
				let i = r.point.distanceTo(e.ray.origin);
				t.push({
					distance: i,
					point: n,
					rayDistance: 0
				});
			}
		} else {
			ro.clear();
			let n = new ge(this.geometry);
			this.getMatrix(n.matrixWorld), n.raycast(e, ro);
			for (let e of ro) t.push({
				rayDistance: 0,
				point: e.point,
				distance: e.distance
			});
		}
		t.sort((e, t) => e.distance - t.distance);
	}
}, ao = class extends io {
	constructor(...e) {
		super(...e), this.isBatchedMeshProxy = !0;
	}
};
//#endregion
//#region src/scene/geometry/MaterialPropertyTexture.ts
function oo(e) {
	let t = e, n = Number.parseFloat(e.replaceAll(/[^1-3]/g, "")) || 1;
	/$vec/.test(e) && (t = "float"), /$uvec/.test(e) && (t = "uint"), /$ivec/.test(e) && (t = "int");
	let r = "";
	switch (n) {
		case 1:
			r = "r";
			break;
		case 2:
			r = "rg";
			break;
		case 3:
			r = "rgb";
			break;
		case 4: r = "rgba";
	}
	return {
		type: e,
		subtype: t,
		dimension: n,
		composant: r
	};
}
var so = class extends p {
	constructor(e, t) {
		let n = Object.keys(t).length, r = 0;
		n > 0 && (r = Math.sqrt(e * n), r = Math.ceil(r / n) * n, r = Math.max(r, n)), super(new Float32Array(r * r * 4), r, r, Ee, _), this.isBatchedMaterialDataTexture = !0, this._fields = Object.entries(t).map(([e, t]) => ({
			name: e,
			...oo(t)
		})).sort((e, t) => e.dimension - t.dimension), this._fieldsIndexMap = /* @__PURE__ */ new Map();
		for (let e = 0; e < this._fields.length; e++) this._fieldsIndexMap.set(this._fields[e].name, e);
	}
	get fieldsCount() {
		return this._fields.length;
	}
	hasMaterialProperty(e) {
		return this._fieldsIndexMap.has(e);
	}
	setMaterialProperty(e, t, ...n) {
		let r = this._fieldsIndexMap.get(t);
		if (r === void 0) return;
		let i = this._fields.length, a = this._fields[r].dimension, o = this.image.data, s = e * i * 4 + r * 4;
		if (n.length !== a) throw RangeError(`Wrong dimension values for field ${t}, expected ${a}, got ${n.length}`);
		for (let e = 0; e < a; e++) o[s + e] = n[e];
		this.needsUpdate = !0;
	}
	getMaterialProperty(e, t, n) {
		let r = this._fieldsIndexMap.get(t);
		if (r === void 0) return null;
		let i = this._fields.length, a = this._fields[r].dimension, o = this.image.data, s = e * i * 4 + r * 4;
		for (let e = 0; e < a; e++) n[e] = o[s + e];
		return n;
	}
	getGlsl(e = "vBatchId", t = "propertiesTexture", n = "") {
		let r = this.image.width, i = this._fields.length, a = `
int fieldsCount = ${i};
int batchId = int( ${e} );
int textureSize = ${r};
int offset = batchId * fieldsCount;
int materialTextureLine = offset % textureSize;
int materialTextureColumn = offset / textureSize;
`;
		for (let e = 0, r = i; e < r; e++) {
			let { name: r, type: i, composant: o } = this._fields[e];
			if (r === "active") continue;
			let s = `texelFetch( ${t}, ivec2( materialTextureLine + ${e}, materialTextureColumn ), 0 ).${o}`;
			a += `${n}${i} ${r} = ${i}( ${s} );\n`;
		}
		return a;
	}
	getGlslPropertyValue(e = "vBatchId", t = "propertiesTexture", n = "", r = "") {
		let i = this._fieldsIndexMap.get(n);
		if (i === void 0) return null;
		let a = this.image.width, o = `
      int fieldsCount = ${this._fields.length};
      int batchId = int( ${e} );
      int textureSize = ${a};
      int offset = batchId * fieldsCount;
      int materialTextureLine = offset % textureSize;
      int materialTextureColumn = offset / textureSize;
    `, { type: s, composant: c } = this._fields[i], l = `texelFetch( ${t}, ivec2( materialTextureLine + ${i}, materialTextureColumn ), 0 ).${c} `;
		return o += `${r} = ${s}( ${l} );\n`, o;
	}
}, co = /* @__PURE__ */ new y(), lo = class {
	constructor(e) {
		this._stateIds = /* @__PURE__ */ new Set(), this._object = e, this._initialState = this._stateFromObject();
	}
	hasState(e) {
		return this._stateIds.has(e);
	}
	addState(e) {
		this._stateIds.add(e);
	}
	removeState(e) {
		return this._stateIds.delete(e);
	}
	updateObjectState(e) {
		this._computeFinalState(() => this.getPartialStatesGenerator(e));
	}
	_applyStateToObject(e) {
		this._object.visible = e.visible, dr(e.matrix, co), this._object.setMatrix(co.clone());
	}
	_stateFromObject() {
		return {
			visible: this._object.visible,
			matrix: ur(this._object.getMatrix(co))
		};
	}
	_computeOneState(e, t) {
		Object.assign(e, t);
	}
	_computeFinalState(e) {
		let t = { ...this._initialState }, n = e();
		for (let e of n) e.restore ? Object.assign(t, this._initialState) : this._computeOneState(t, e);
		this._applyStateToObject(t);
	}
	*getPartialStatesGenerator(e) {
		for (let t of this._stateIds) {
			let n = e.get(t);
			if (!n) throw Error("No state for given id");
			yield n;
		}
	}
}, uo = new f(), fo = class extends lo {
	_stateFromObject() {
		return {
			...super._stateFromObject(),
			opacity: this._object.opacity,
			xRay: this._object.xRay,
			diffuseColor: uo.set(this._object.diffuseColor).getHex(),
			roughness: this._object.roughness,
			metalness: this._object.metalness,
			emissiveColor: uo.set(this._object.emissiveColor).getHex(),
			edgesColor: uo.set(this._object.edgesColor).getHex(),
			edgesOpacity: this._object.edgesOpacity,
			edgesVisible: this._object.edgesVisible
		};
	}
	_applyStateToObject(e) {
		super._applyStateToObject(e), this._object.opacity = e.opacity, this._object.xRay = e.xRay, this._object.diffuseColor = e.diffuseColor, this._object.emissiveColor = e.emissiveColor, this._object.metalness = e.metalness, this._object.roughness = e.roughness, this._object.edgesColor = e.edgesColor, this._object.edgesOpacity = e.edgesOpacity, this._object.edgesVisible = e.edgesVisible;
	}
};
//#endregion
//#region src/utils/meshutils.ts
function po(e, t) {
	let n = Array.isArray(e.material) ? e.material[0] : e.material;
	return t.transparent = n.transparent, t.opacity = n.opacity, t.color.set(69905), "color" in n && t.color.copy(n.color), t.emissive.set(0), "emissive" in n && t.emissive.copy(n.emissive), t.metalness = 0, "metalness" in n && (t.metalness = n.metalness), t.roughness = 1, "roughness" in n && (t.roughness = n.roughness), t.name = n.name, t;
}
function mo(e, t) {
	let n = Array.isArray(e.material) ? e.material[0] : e.material;
	return t.transparent = n.transparent, t.opacity = n.opacity, t.color.set(69905), "color" in n && t.color.copy(n.color), t.name = n.name, t;
}
function ho(e, t = 2) {
	return {
		x: e.x.toFixed(t),
		y: e.y.toFixed(t),
		z: e.z.toFixed(t)
	};
}
//#endregion
//#region src/scene/objects/SceneObject.ts
var go = /* @__PURE__ */ new y(), _o = /* @__PURE__ */ new x(), vo = /* @__PURE__ */ new ee(), yo = class {
	constructor(e = me.generateUUID()) {
		this._visible = !0, this._selected = !1, this._active = !1, this.transformConfig = {
			rotate: {
				x: !0,
				y: !0,
				z: !0
			},
			scale: {
				x: !0,
				y: !0,
				z: !0
			},
			translate: {
				x: !0,
				y: !0,
				z: !0
			}
		}, this.signals = {
			onVisibilityChanged: new w(),
			onSelectedChanged: new w()
		}, this.isSceneObject = !0, this.isSelectable = !0, this.isTransformable = !0, this.userData = {}, this.name = "", this.parent = null, this.children = [], this.uuid = e;
	}
	get type() {
		return this.constructor.name;
	}
	getPosition(e) {
		return this.getMatrix(go), e.setFromMatrixPosition(go);
	}
	setPosition(e) {
		this.getMatrix(go), go.setPosition(e), this.setMatrix(go);
	}
	applyMatrix(e) {
		this.getMatrix(go), go.premultiply(e), this.setMatrix(go);
	}
	addChild(e) {
		if (e === this) throw Error("Cannot add object as parent of itself");
		e.parent !== this && (e.removeFromParent(), e.parent = this, this.children.push(e));
	}
	*parentsGenerator() {
		let e = this.parent;
		for (; e;) yield e, e = e.parent;
	}
	removeFromParent() {
		this.parent &&= (this.parent.children.remove(this), null);
	}
	getStateController() {
		return new lo(this);
	}
	set visible(e) {
		this._visible !== e && (this._visible = e, this.signals.onVisibilityChanged.emit());
	}
	get visible() {
		return this._visible;
	}
	set active(e) {
		this._active !== e && (this._active = e);
	}
	get active() {
		return this._active;
	}
	set selected(e) {
		this._selected !== e && (this._selected = e, this.signals.onSelectedChanged.emit());
	}
	get selected() {
		return this._selected;
	}
	toJson() {
		return this.getMatrix(go), {
			name: this.name,
			uuid: this.uuid,
			transform: {
				position: ho(_o.setFromMatrixPosition(go)),
				rotation: ho(bo(go, _o)),
				scale: ho(_o.setFromMatrixScale(go))
			},
			type: this.type,
			userData: this.userData,
			children: this.children.map((e) => e.toJson())
		};
	}
	dispose() {}
};
function bo(e, t) {
	return vo.setFromRotationMatrix(e), t.setFromEuler(vo), t.x = Qe(t.x), t.y = Qe(t.y), t.z = Qe(t.z), t;
}
//#endregion
//#region src/scene/objects/utils/DrawableSceneObject.ts
var xo = class extends yo {
	constructor(...e) {
		super(...e), this.isDisplayable = !0;
	}
}, So = class extends xo {
	constructor(...e) {
		super(...e), this.isRaycastable = !0;
	}
}, Co = /* @__PURE__ */ new f(), wo = class e extends So {
	constructor(...e) {
		super(...e), this._isInMeshGroup = !1, this.isSceneMesh = !0, this._hover = !1, this._materialName = "", this._edgesVisible = !0;
	}
	static {
		this.TRANSPARENCY_THRESHOLD = .95;
	}
	getStateController() {
		return new fo(this);
	}
	set edgesVisible(e) {
		this._edgesVisible = e;
	}
	get edgesVisible() {
		return this._edgesVisible;
	}
	get isTransparent() {
		return this.opacity < e.TRANSPARENCY_THRESHOLD;
	}
	get areEdgesTransparent() {
		return this.opacity < e.TRANSPARENCY_THRESHOLD;
	}
	set hover(e) {
		this._hover !== e && (this._hover = e);
	}
	get hover() {
		return this._hover;
	}
	set materialName(e) {
		this._materialName = e;
	}
	get materialName() {
		return this._materialName;
	}
	copyMaterials(e) {
		this.edgesColor = e.edgesColor, this.diffuseColor = e.diffuseColor, this.emissiveColor = e.emissiveColor, this.xRay = e.xRay, this.opacity = e.opacity, this.roughness = e.roughness, this.metalness = e.metalness;
	}
	toJson() {
		return {
			...super.toJson(),
			xRay: this.xRay,
			isRaycastable: this.isRaycastable,
			material: {
				name: this.materialName,
				diffuseColor: Co.set(this.diffuseColor).getHexString(),
				emissiveColor: Co.set(this.emissiveColor).getHexString(),
				opacity: this.opacity,
				roughness: this.roughness,
				metalness: this.metalness,
				transparent: this.isTransparent
			},
			edgesMaterial: {
				color: Co.set(this.edgesColor).getHexString(),
				opacity: this.edgesOpacity,
				transparent: this.areEdgesTransparent
			}
		};
	}
}, To = [], Eo = class extends wo {
	constructor(e, t) {
		super(t), this.isSceneLineProxy = !0, this._xRay = !1, this.lineProxy = e;
	}
	getStateController() {
		return new fo(this);
	}
	set visible(e) {
		super.visible = e, this.lineProxy.setVisible(e);
	}
	get visible() {
		return super.visible;
	}
	set active(e) {
		super.active = e, this.lineProxy.setActive(e);
	}
	get active() {
		return super.active;
	}
	set diffuseColor(e) {
		this.lineProxy.setDiffuseColor(e);
	}
	get diffuseColor() {
		return this.lineProxy.getDiffuseColor();
	}
	set opacity(e) {
		this.lineProxy.setOpacity(e), this._updateLineMaterial();
	}
	get opacity() {
		return this.lineProxy.getOpacity();
	}
	set xRay(e) {
		this._xRay = e, this._updateLineMaterial();
	}
	get xRay() {
		return this._xRay;
	}
	set metalness(e) {}
	get metalness() {
		return 0;
	}
	set roughness(e) {}
	get roughness() {
		return 0;
	}
	set emissiveColor(e) {}
	get emissiveColor() {
		return 0;
	}
	set edgesColor(e) {}
	get edgesColor() {
		return 0;
	}
	set edgesOpacity(e) {}
	get edgesOpacity() {
		return 1;
	}
	set selected(e) {
		super.selected = e, this._updateLineMaterial();
	}
	get selected() {
		return super.selected;
	}
	raycast(e, t, n) {
		To.clear(), this.lineProxy.raycast(e, To, n);
		for (let e of To) t.push({
			...e,
			object: this
		});
	}
	projectPointOnEdges(e, t, n) {
		return this.lineProxy.projectPointOnEdges(e, t, n);
	}
	showNormalsHelper(e, t) {}
	showBoundingBoxHelper(e, t) {
		this.lineProxy.showBoundingBoxHelper(e, t);
	}
	getBoundingBox(e) {
		return this.lineProxy.getBoundingBox(e);
	}
	getBoundingSphere(e) {
		return this.lineProxy.getBoundingSphere(e);
	}
	getMatrix(e) {
		return this.lineProxy.getMatrix(e);
	}
	setMatrix(e) {
		return this.lineProxy.setMatrix(e);
	}
	_updateLineMaterial() {
		let e = this.selected, t;
		t = this.xRay ? e ? N.SelectedXRay : N.XRay : this.isTransparent ? e ? N.SelectedTransparent : N.Transparent : e ? N.SelectedOpaque : N.Opaque, this.lineProxy.setMaterial(t);
	}
	getMaterial() {
		return this.lineProxy.getMaterial();
	}
	toJson() {
		return {
			...super.toJson(),
			lineProxy: {
				proxyId: this.lineProxy.proxyId,
				active: this.lineProxy.getActive(),
				materialType: this.lineProxy.getMaterial()
			}
		};
	}
}, Do = class {
	constructor(e) {
		this.isSceneObjectController = !0, this._objects = /* @__PURE__ */ new Map(), this.signals = this._createSignals(), this._visible = !0, this._viewer = e;
	}
	_createSignals() {
		return {
			onObjectUpdated: new w(),
			onObjectRemoved: new w(),
			onObjectAdded: new w(),
			onVisibilityChanged: new w()
		};
	}
	set visible(e) {
		e !== this._visible && (this._visible = e, this._setVisibility(e), this.signals.onVisibilityChanged.emit(), this._viewer.signals.onObjectControllerVisibilityChanged.emit(this));
	}
	get visible() {
		return this._visible;
	}
	get count() {
		return this._objects.size;
	}
	get firstObject() {
		let e = this._objects.values().next();
		return e.done ? null : e.value;
	}
	addObject(e, t) {
		this._objects.set(e.uuid, e), e.active = !0, this.signals.onObjectAdded.emit(e), this._viewer.signals.onSceneGraphChanged.emit();
	}
	removeObject(e) {
		this._objects.delete(e.uuid), e.active = !1, this.signals.onObjectRemoved.emit(e), this._viewer.signals.onSceneGraphChanged.emit();
	}
	getFirstObject() {
		let e = this.getAllObjects().next();
		return e.done ? null : e.value;
	}
	get uuids() {
		return this._objects.keys();
	}
	hasObjectUUID(e) {
		return this._objects.has(e);
	}
	getObjectByUUID(e) {
		return this._objects.get(e) ?? null;
	}
	*getObjectsByUUID(e) {
		for (let t of e) {
			let e = this.getObjectByUUID(t);
			e && (yield e);
		}
	}
	*getAllObjects() {
		yield* this._objects.values();
	}
	*getAllObjectUuids() {
		yield* this._objects.keys();
	}
	*getAllVisibleObjects() {
		let e = this.getAllObjects();
		for (let t of e) t.visible && (yield t);
	}
	*getAllHiddenObjects() {
		let e = this.getAllObjects();
		for (let t of e) t.visible || (yield t);
	}
	*getAllVisibleObjectUuids() {
		let e = this.getAllVisibleObjects();
		for (let t of e) yield t.uuid;
	}
	*getAllHiddenObjectUuids() {
		let e = this.getAllHiddenObjects();
		for (let t of e) yield t.uuid;
	}
	dispose() {
		for (let e of this._objects.values()) e.dispose();
	}
	clear() {
		this._objects.clear();
	}
}, Oo = class extends Do {
	constructor(...e) {
		super(...e), this.isSceneMeshController = !0, this.ignoreViewportRenderMode = !1;
	}
	*containers() {
		yield* this.meshContainers(), yield* this.edgesContainers(), yield* this.lineContainers();
	}
	_setVisibility(e) {
		for (let t of this.containers()) t.visible = e;
	}
	setClippingPlanes(e) {
		for (let t of this.containers()) t.setClippingPlanes(e);
	}
	setMeshesVisibility(e) {
		for (let t of this.meshContainers()) t.visible = e;
		for (let t of this.lineContainers()) t.visible = e;
	}
	setEdgesVisibility(e) {
		for (let t of this.edgesContainers()) t.visible = e;
	}
}, ko = [], Ao = class extends wo {
	constructor(e, t = null, n) {
		super(n), this.isSceneMeshProxy = !0, this._xRay = !1, this.meshProxy = e, this.edgesProxy = t;
	}
	getStateController() {
		return new fo(this);
	}
	set visible(e) {
		super.visible = e, this.meshProxy.setVisible(e), this.edgesProxy?.setVisible(e && this.edgesVisible);
	}
	get visible() {
		return super.visible;
	}
	set edgesVisible(e) {
		super.edgesVisible = e, this.edgesProxy?.setVisible(this.visible && e);
	}
	get edgesVisible() {
		return super.edgesVisible;
	}
	set active(e) {
		super.active = e, this.meshProxy.setActive(e), this.edgesProxy?.setActive(e);
	}
	get active() {
		return super.active;
	}
	get hover() {
		return super.hover;
	}
	set hover(e) {
		super.hover = e, this._updateMeshMaterial(), this._updateEdgesMaterial();
	}
	set diffuseColor(e) {
		this.meshProxy.setDiffuseColor(e);
	}
	get diffuseColor() {
		return this.meshProxy.getDiffuseColor();
	}
	set opacity(e) {
		this.meshProxy.setOpacity(e), this._updateMeshMaterial();
	}
	get opacity() {
		return this.meshProxy.getOpacity();
	}
	set xRay(e) {
		this._xRay = e, this._updateMeshMaterial(), this._updateEdgesMaterial();
	}
	get xRay() {
		return this._xRay;
	}
	set metalness(e) {
		this.meshProxy.setMetalness(e);
	}
	get metalness() {
		return this.meshProxy.getMetalness();
	}
	set roughness(e) {
		this.meshProxy?.setRoughness(e);
	}
	get roughness() {
		return this.meshProxy?.getRoughness() ?? 0;
	}
	set emissiveColor(e) {
		this.meshProxy.setEmissiveColor(e);
	}
	get emissiveColor() {
		return this.meshProxy.getEmissiveColor();
	}
	set edgesColor(e) {
		this.edgesProxy?.setDiffuseColor(e), this._updateEdgesMaterial();
	}
	get edgesColor() {
		return this.edgesProxy?.getDiffuseColor() ?? 0;
	}
	set edgesOpacity(e) {
		this.edgesProxy?.setOpacity(e), this._updateEdgesMaterial();
	}
	get edgesOpacity() {
		return this.edgesProxy?.getOpacity() ?? 1;
	}
	set selected(e) {
		super.selected = e, this._updateMeshMaterial(), this._updateEdgesMaterial();
	}
	get selected() {
		return super.selected;
	}
	raycast(e, t) {
		ko.clear(), this.meshProxy.raycast(e, ko);
		for (let e of ko) t.push({
			...e,
			object: this
		});
	}
	projectPointOnEdges(e, t, n) {
		return this.edgesProxy ? this.edgesProxy?.projectPointOnEdges(e, t, n) : !1;
	}
	showNormalsHelper(e, t) {
		this.meshProxy.showNormalsHelper(e, t);
	}
	showBoundingBoxHelper(e, t) {
		this.meshProxy.showBoundingBoxHelper(e, t);
	}
	getBoundingBox(e) {
		return this.meshProxy.getBoundingBox(e);
	}
	getBoundingSphere(e) {
		return this.meshProxy.getBoundingSphere(e);
	}
	getMatrix(e) {
		return this.meshProxy.getMatrix(e);
	}
	setMatrix(e) {
		this.meshProxy.setMatrix(e), this.edgesProxy?.setMatrix(e);
	}
	_updateMeshMaterial() {
		let e = this.selected, t;
		t = this.xRay ? e ? N.SelectedXRay : N.XRay : this.hover ? e ? N.SelectedOpaque : N.Hover : this.isTransparent ? e ? N.SelectedTransparent : N.Transparent : e ? N.SelectedOpaque : N.Opaque, this.meshProxy.setMaterial(t);
	}
	_updateEdgesMaterial() {
		let e = this.selected, t;
		t = this.xRay ? e ? N.SelectedXRay : N.XRay : this.hover ? e ? N.SelectedOpaque : N.Hover : this.areEdgesTransparent ? e ? N.SelectedTransparent : N.Transparent : e ? N.SelectedOpaque : N.Opaque, this.edgesProxy?.setMaterial(t);
	}
	getMaterial() {
		return this.meshProxy.getMaterial();
	}
	toJson() {
		return {
			...super.toJson(),
			meshProxy: {
				proxyId: this.meshProxy.proxyId,
				active: this.meshProxy.getActive(),
				materialType: this.meshProxy.getMaterial()
			},
			edgesProxy: {
				proxyId: this.edgesProxy?.proxyId,
				active: this.edgesProxy?.getActive(),
				materialType: this.edgesProxy?.getMaterial()
			}
		};
	}
}, jo = class extends lo {
	constructor(e, t) {
		super(e), this._controllers = [], this._controllers.push(new fo(e));
		for (let e of t) this._controllers.push(new fo(e));
	}
	addMesh(e) {
		this._controllers.push(new fo(e));
	}
	removeMesh(e) {
		let t = this._controllers.findIndex((t) => t._object === e);
		t !== -1 && this._controllers.splice(t, 1);
	}
	_computeFinalState(e) {
		for (let t of this._controllers) t._computeFinalState(e);
	}
}, Mo = /* @__PURE__ */ new a(), No = /* @__PURE__ */ new a(), Po = /* @__PURE__ */ new b(), G = /* @__PURE__ */ new x(), Fo = class extends wo {
	constructor(...e) {
		super(...e), this.isSceneMeshGroup = !0, this.meshes = [], this._stateController = null;
	}
	set materialName(e) {
		super.materialName = e;
	}
	get materialName() {
		return this.meshes.length > 0 ? this.meshes[0].materialName : "";
	}
	addSubMesh(e) {
		this.meshes.push(e), e.parent = this, e._isInMeshGroup = !0, this._stateController?.addMesh(e), e.edgesVisible = this.edgesVisible, e.active = this.active;
	}
	removeSubMesh(e) {
		this.meshes.remove(e), e.parent = null, this._stateController?.removeMesh(e);
	}
	getMatrix(e) {
		return this.meshes.length > 0 && this.meshes[0].getMatrix(e), e;
	}
	setMatrix(e) {
		for (let t of this.meshes) t.setMatrix(e);
		return e;
	}
	getPosition(e) {
		return this.meshes.length > 0 && this.meshes[0].getPosition(e), e;
	}
	setPosition(e) {
		for (let t of this.meshes) t.setPosition(e);
	}
	showBoundingBoxHelper(e, t) {
		for (let n of this.meshes) n.showBoundingBoxHelper(e, t);
	}
	showNormalsHelper(e, t) {
		for (let n of this.meshes) n.showNormalsHelper(e, t);
	}
	getBoundingBox(e) {
		Mo.makeEmpty();
		for (let e of this.meshes) e.getBoundingBox(No), Mo.union(No);
		return e.copy(Mo);
	}
	getBoundingSphere(e) {
		e.makeEmpty();
		for (let t of this.meshes) t.getBoundingSphere(Po), e.union(Po);
		return e;
	}
	getStateController() {
		return this._stateController ??= new jo(this, this.meshes), this._stateController;
	}
	set active(e) {
		for (let t of this.meshes) t.active = e;
		super.active = e;
	}
	get active() {
		return super.active;
	}
	set selected(e) {
		for (let t of this.meshes) t.selected = e;
		super.selected = e;
	}
	get selected() {
		return super.selected;
	}
	set visible(e) {
		for (let t of this.meshes) t.visible = e;
		super.visible = e;
	}
	get visible() {
		return super.visible;
	}
	set opacity(e) {
		for (let t of this.meshes) t.opacity = e;
	}
	get opacity() {
		return this.meshes.length > 0 ? this.meshes[0].opacity : 1;
	}
	set xRay(e) {
		for (let t of this.meshes) t.xRay = e;
	}
	get xRay() {
		return this.meshes.length > 0 && this.meshes[0].xRay;
	}
	set diffuseColor(e) {
		for (let t of this.meshes) t.diffuseColor = e;
	}
	get diffuseColor() {
		return this.meshes.length > 0 ? this.meshes[0].diffuseColor : 0;
	}
	set emissiveColor(e) {
		for (let t of this.meshes) t.emissiveColor = e;
	}
	get emissiveColor() {
		return this.meshes.length > 0 ? this.meshes[0].emissiveColor : 0;
	}
	set roughness(e) {
		for (let t of this.meshes) t.roughness = e;
	}
	get roughness() {
		return this.meshes.length > 0 ? this.meshes[0].roughness : 0;
	}
	set metalness(e) {
		for (let t of this.meshes) t.metalness = e;
	}
	get metalness() {
		return this.meshes.length > 0 ? this.meshes[0].metalness : 0;
	}
	set edgesColor(e) {
		for (let t of this.meshes) t.edgesColor = e;
	}
	get edgesColor() {
		return this.meshes.length > 0 ? this.meshes[0].edgesColor : 0;
	}
	set edgesOpacity(e) {
		for (let t of this.meshes) t.edgesOpacity = e;
	}
	get edgesOpacity() {
		return this.meshes.length > 0 ? this.meshes[0].edgesOpacity : 1;
	}
	set edgesVisible(e) {
		super.edgesVisible = e;
		for (let t of this.meshes) t.edgesVisible = e;
	}
	get edgesVisible() {
		return super.edgesVisible;
	}
	raycast(e, t) {
		for (let n of this.meshes) n.raycast(e, t);
	}
	projectPointOnEdges(e, t, n) {
		let r = Infinity, i = !1;
		for (let a of this.meshes) if (a.projectPointOnEdges(e, G, n)) {
			i = !0;
			let n = e.distanceTo(G);
			n < r && (r = n, t.copy(G));
		}
		return i;
	}
	toJson() {
		return {
			...super.toJson(),
			subMeshes: this.meshes.map((e) => e.toJson())
		};
	}
}, Io = class extends Fo {
	constructor(...e) {
		super(...e), this.isBimMesh = !0, this._activeType = "3D", this._2dMeshes = [], this._3dMeshes = [];
	}
	addSubMesh(e, t = "3D") {
		this._2dMeshes.length === 0 && this._3dMeshes.length === 0 && (this._activeType = t), t === "2D" ? this._2dMeshes.push(e) : this._3dMeshes.push(e), super.addSubMesh(e), e.active = this._activeType === t;
	}
	removeSubMesh(e) {
		this._2dMeshes.remove(e), this._3dMeshes.remove(e), super.removeSubMesh(e);
	}
	*getSubMeshes() {
		yield* this._2dMeshes, yield* this._3dMeshes;
	}
	set active(e) {
		if (super.active = e, e) {
			for (let e of this._2dMeshes) e.active = this._activeType === "2D";
			for (let e of this._3dMeshes) e.active = this._activeType === "3D";
		}
	}
	get active() {
		return super.active;
	}
	get has2dMeshes() {
		return this._2dMeshes.length > 0;
	}
	get has3dMeshes() {
		return this._3dMeshes.length > 0;
	}
	setActiveType(e) {
		if (e !== this._activeType) {
			this._activeType = e;
			for (let t of this._2dMeshes) t.active = e === "2D";
			for (let t of this._3dMeshes) t.active = e === "3D";
		}
	}
	raycast(e, t) {
		let n;
		n = this._activeType === "2D" ? this._2dMeshes : this._3dMeshes;
		for (let r of n) r.raycast(e, t);
	}
	toJson() {
		return {
			...super.toJson(),
			activeType: this._activeType,
			meshes2d: this._2dMeshes.map((e) => e.toJson()),
			meshes3d: this._3dMeshes.map((e) => e.toJson())
		};
	}
}, Lo = class extends Oo {
	constructor(...e) {
		super(...e), this.isBimMeshController = !0, this.roots = /* @__PURE__ */ new Set(), this._meshContainers = /* @__PURE__ */ new Map(), this._edgeContainers = /* @__PURE__ */ new Map(), this._lineContainers = /* @__PURE__ */ new Map(), this.signals = this._createSignals();
	}
	_createSignals() {
		return {
			...super._createSignals(),
			onMeshAdded: new w()
		};
	}
	get hasVisibleObjects() {
		return !!this.getAllVisibleObjects().next().value;
	}
	onSceneSetup(e) {
		for (let t of this.containers()) e.addInternalObject(t.root);
	}
	onSceneClear(e) {
		for (let t of this.containers()) e.removeInternalObject(t.root);
	}
	addBatchedMeshContainer(e) {
		if (this._meshContainers.has(e.uuid)) throw Error("Mesh BatchedGeometry already added to the scene");
		let t = e.maxGeometryCount, n = new Ya(t, e, this._getMeshMaterials(t));
		n.root.renderOrder = 0, this._meshContainers.set(e.uuid, n), this._viewer.scene.addInternalObject(n.root);
	}
	addBatchedEdgesContainer(e) {
		if (this._edgeContainers.has(e.uuid)) throw Error("Edges BatchedLineGeometry already added to the scene");
		let t = e.maxGeometryCount, n = new Aa(t, e, this._getEdgesMaterials(t));
		n.root.renderOrder = 1, this._edgeContainers.set(e.uuid, n), this._viewer.scene.addInternalObject(n.root);
	}
	addBatchedLineContainer(e) {
		if (this._lineContainers.has(e.uuid)) throw Error("Line BatchedLineGeometry already added to the scene");
		let t = e.maxGeometryCount, n = new Aa(t, e, this._getLineMaterials(t));
		n.root.renderOrder = 1, this._lineContainers.set(e.uuid, n), this._viewer.scene.addInternalObject(n.root);
	}
	createMesh(e) {
		let t = new Io(e.uuid);
		return t.userData = e.userData, t.name = e.name, t;
	}
	createLineProxy(e) {
		let t = this._lineContainers.get(e.line.batchedGeometryUuid);
		if (!t) throw Error("Trying to add proxy into batched object that does not exist");
		let n = new Eo(new qa(t, e.line.proxyId, e.line.srcGeometryUuid), e.uuid);
		return n.name = this.setMeshesVisibility.name, n.diffuseColor = e.line.material.color, n.opacity = e.line.material.opacity, n.userData = e.userData, n;
	}
	createMeshProxy(e) {
		let t = this._meshContainers.get(e.mesh.batchedGeometryUuid), n = this._edgeContainers.get(e.edges.batchedGeometryUuid);
		if (!t || !n) throw Error("Trying to add proxy into batched object that does not exist");
		let r = new ao(t, e.mesh.proxyId, e.mesh.srcGeometryUuid), i = new qa(n, e.edges.proxyId, e.edges.srcGeometryUuid);
		if (!t.getGeometryBVH(e.mesh.srcGeometryUuid)) {
			let n = S.deserialize(e.mesh.serializedBVH, r.geometry, { setIndex: !1 });
			t.registerBVH(e.mesh.srcGeometryUuid, n);
		}
		let a = new Ao(r, i, e.uuid);
		return a.name = e.name, a.diffuseColor = e.mesh.material.color, a.edgesOpacity = 1, a.edgesColor = this._viewer.settings.objects.defaultEdgesColor.value, a.opacity = e.mesh.material.opacity, a.userData = e.userData, a.metalness = e.mesh.material.metalness, a.roughness = e.mesh.material.roughness, a.emissiveColor = e.mesh.material.emissive, a._isInMeshGroup = e.isInMeshGroup, a.materialName = e.mesh.material.name, a;
	}
	addSubMesh(e, t, n) {
		e.addSubMesh(t, n), this._viewer.scene.isObjectInBoxTree(e) ? this._viewer.scene.updateObjectInBoxTree(e) : this._viewer.scene.addObjectIntoBoxTree(e), this.signals.onMeshAdded.emit(t);
	}
	accepts(e) {
		return e.isBimMesh;
	}
	addObject(e, t) {
		if (this.hasObjectUUID(e.uuid)) {
			C.error(`An object with same uuid (${e.uuid}) already exists`);
			return;
		}
		if (t === null) this.roots.add(e);
		else {
			let n = this.getObjectByUUID(t);
			if (!n) {
				C.error(`Parent (${e.uuid}) does not exist`);
				return;
			}
			n.addChild(e);
		}
		super.addObject(e, t);
	}
	*meshContainers() {
		yield* this._meshContainers.values();
	}
	*edgesContainers() {
		yield* this._edgeContainers.values();
	}
	*lineContainers() {
		yield* this._lineContainers.values();
	}
	clear() {
		this.roots.clear();
		for (let e of this.containers()) e.dispose();
		this._meshContainers.clear(), this._edgeContainers.clear(), this._lineContainers.clear(), super.clear();
	}
	_getMeshMaterials(e) {
		let t = this._viewer.materialFactory, n = new so(e, {
			opacity: "float",
			diffuse: "vec3",
			emissive: "vec3",
			metalness: "float",
			roughness: "float"
		});
		return [
			t.getBatchedMeshOpaqueMaterial(n),
			t.getBatchedMeshOpaqueMaterial_Selected(n),
			t.getBatchedMeshTransparentMaterial(n),
			t.getBatchedMeshTransparentMaterial_Selected(n),
			t.getBatchedMeshXRayMaterial(n),
			t.getBatchedMeshXRayMaterial_Selected(n)
		];
	}
	_getEdgesMaterials(e) {
		let t = this._viewer.materialFactory, n = new so(e, {
			opacity: "float",
			diffuse: "vec3"
		});
		return [
			t.getBatchedEdgesOpaqueMaterial(n),
			t.getBatchedEdgesOpaqueMaterial_Selected(n),
			t.getBatchedEdgesXRayMaterial(n),
			t.getBatchedEdgesXRayMaterial_Selected(n),
			t.getBatchedEdgesTransparentMaterial(n),
			t.getBatchedEdgesTransparentMaterial_Selected(n)
		];
	}
	_getLineMaterials(e) {
		let t = this._viewer.materialFactory, n = new so(e, {
			opacity: "float",
			diffuse: "vec3"
		});
		return [
			t.getBatchedLineOpaqueMaterial(n),
			t.getBatchedLineOpaqueMaterial_Selected(n),
			t.getBatchedLineXRayMaterial(n),
			t.getBatchedLineXRayMaterial_Selected(n),
			t.getBatchedLineTransparentMaterial(n),
			t.getBatchedLineTransparentMaterial_Selected(n)
		];
	}
}, Ro = /* @__PURE__ */ function(e) {
	return e[e.x = 0] = "x", e[e.y = 1] = "y", e[e.z = 2] = "z", e;
}({}), zo = new x(-1, 0, 0), Bo = new x(0, -1, 0), Vo = new x(0, 0, -1), Ho = new a(), Uo = new x(), Wo = new x(), Go = new y(), Ko = new _e({
	color: 9868693,
	side: h,
	wireframe: !0
}), qo = class extends wo {
	constructor(e, t) {
		super(), this.isClippingPlane = !0, this.transformConfig = {
			...this.transformConfig,
			scale: {
				x: !1,
				y: !1,
				z: !1
			}
		}, this.name = "ClippingPlane", this.emissiveColor = 0, this.roughness = 1, this.metalness = 0, this.edgesColor = 0, this.edgesOpacity = 1, this._planeColor = 16777215, this.diffuseColor = 16777215, this.xRay = !1, this._material = new _e({
			transparent: !0,
			side: h,
			depthWrite: !1
		}), this.planeType = e;
		let n;
		n = e === 0 ? zo.clone() : e === 1 ? Bo.clone() : Vo.clone(), this._updateMaterialWithType();
		let r = new we(1, 1);
		this.mesh = new ge(r, this._material);
		let i = new ge(r, Ko);
		this.mesh.add(i), this.mesh.lookAt(n), this.mesh.position.copy(t), this.plane = new Ce(n, 0), this._alignMeshAndPlane(), this._updatePlaneType();
	}
	setSize(e) {
		this.mesh.scale.set(e, e, e);
	}
	get visible() {
		return super.visible;
	}
	set visible(e) {
		this.mesh.visible = e, super.visible = e;
	}
	get opacity() {
		return this._material.opacity;
	}
	set opacity(e) {
		this._material.opacity = e;
	}
	getPosition(e) {
		return e.copy(this.mesh.position);
	}
	setPosition(e) {
		this.getMatrix(Go), Go.setPosition(e), this.setMatrix(Go);
	}
	getMatrix(e) {
		return this.mesh.updateMatrixWorld(!0), e.copy(this.mesh.matrixWorld);
	}
	setMatrix(e) {
		this.mesh.position.set(0, 0, 0), this.mesh.quaternion.identity(), this.mesh.scale.set(1, 1, 1), this.mesh.applyMatrix4(e), this._alignMeshAndPlane(), this._updatePlaneType(), this._updateMaterialWithType();
	}
	_alignMeshAndPlane() {
		Uo.set(0, 0, 1).applyQuaternion(this.mesh.quaternion), Wo.copy(this.mesh.position), this.plane.setFromNormalAndCoplanarPoint(Uo, Wo);
	}
	_updatePlaneType() {
		let e = Math.abs(this.plane.normal.x), t = Math.abs(this.plane.normal.y), n = Math.abs(this.plane.normal.z);
		this.transformConfig.translate.x = !1, this.transformConfig.translate.y = !1, this.transformConfig.translate.z = !1, e > t && e > n ? (this.planeType = 0, this.transformConfig.translate.x = !0) : t > e && t > n ? (this.planeType = 1, this.transformConfig.translate.y = !0) : (this.planeType = 2, this.transformConfig.translate.z = !0);
	}
	_updateMaterialWithType() {
		this.planeType === 0 ? (this._planeColor = 16711680, this._material.alphaMap = Jo("X")) : this.planeType === 1 ? (this._planeColor = 65280, this._material.alphaMap = Jo("Y")) : (this._planeColor = 255, this._material.alphaMap = Jo("Z")), this._material.color.set(this._planeColor);
	}
	raycast(e, t) {
		let n = [];
		this.mesh.raycast(e, n);
		for (let e of n) t.push({
			object: this,
			distance: e.distance,
			point: e.point,
			rayDistance: 0
		});
	}
	projectPointOnEdges(e, t, n) {
		return !1;
	}
	showNormalsHelper(e, t) {
		this._normalsHelper ??= new $e(this.mesh, 1), t ? e.add(this._normalsHelper) : this._normalsHelper.removeFromParent();
	}
	showBoundingBoxHelper(e, t) {
		this.getBoundingBox(Ho), this._boxHelper = new o(Ho), t ? e.add(this._boxHelper) : this._boxHelper.removeFromParent();
	}
	getBoundingBox(e) {
		return e.setFromObject(this.mesh);
	}
	getBoundingSphere(e) {
		return this.mesh.geometry.computeBoundingSphere(), e.copy(this.mesh.geometry.boundingSphere ?? new b());
	}
}, Jo = (e) => {
	let t = document.createElement("canvas"), n = t.getContext("2d"), r = new u(t);
	return t.width = 1024, t.height = 1024, n && (n.fillStyle = "rgb(50, 50, 50)", n.fillRect(0, 0, t.width, t.height), n.font = "40px sans-serif", n.fillStyle = "white", n.fillText(e, 20, 50)), r.flipY = !0, r.needsUpdate = !0, r;
}, Yo = class extends Do {
	constructor(e) {
		super(e), this.isClippingPlaneController = !0, this.planeSize = 0, this._planesGroup = new re(), this._planesGroup.name = "ClippingPlaneGroup";
	}
	onSceneSetup(e) {
		e.addInternalObject(this._planesGroup);
	}
	onSceneClear(e) {
		e.removeInternalObject(this._planesGroup);
	}
	*planes() {
		for (let [, e] of this._objects) yield e.plane;
	}
	createPlane(e, t, n) {
		(this.planeSize === 0 || this._objects.size === 0) && (this.planeSize = n);
		let r = new qo(e, t);
		return r.setSize(this.planeSize), r;
	}
	addObject(e, t) {
		this._planesGroup.add(e.mesh), this._viewer.scene.addObjectIntoBoxTree(e), super.addObject(e, t), this._viewer.scene.updateClippingPlanes();
	}
	removeObject(e) {
		this._planesGroup.remove(e.mesh), this._viewer.scene.removeObjectFromBoxTree(e), super.removeObject(e), this._viewer.scene.updateClippingPlanes();
	}
	accepts(e) {
		return e.isClippingPlane;
	}
	_setVisibility(e) {
		this._planesGroup.visible = e;
	}
	clear() {
		this._planesGroup.clear(), super.clear();
	}
}, Xo = class extends Error {
	constructor(e) {
		super(`Collection '${e}' not found`), this.collectionId = e, this.name = "CollectionNotFoundError";
	}
}, Zo = class {
	constructor() {
		this._collections = /* @__PURE__ */ new Map();
	}
	_getMutableCollection(e) {
		let t = this._collections.get(e);
		if (!t) throw new Xo(e);
		return t;
	}
	get(e) {
		let t = this._collections.get(e);
		if (!t) throw new Xo(e);
		return t;
	}
	add(e) {
		let t = me.generateUUID();
		return this._collections.set(t, new Set(e ?? [])), t;
	}
	delete(e) {
		return this._collections.delete(e);
	}
	has(e) {
		return this._collections.has(e);
	}
	hasObject(e, t) {
		let n = this._collections.get(e);
		return !!n && n.has(t);
	}
	addObject(e, t) {
		this._getMutableCollection(e).add(t);
	}
	addObjects(e, t) {
		let n = this._getMutableCollection(e);
		for (let e of t) n.add(e);
	}
	deleteObject(e, t) {
		this._getMutableCollection(e).delete(t);
	}
	deleteObjects(e, t) {
		let n = this._getMutableCollection(e);
		for (let e of t) n.delete(e);
	}
	deleteAllCollections() {
		this._collections.clear();
	}
	clearAllCollections() {
		for (let e of this._collections.values()) e.clear();
	}
	*getCollectionsForObject(e) {
		for (let [t, n] of this._collections) n.has(e) && (yield t);
	}
}, Qo = /* @__PURE__ */ new Fe(), $o = /* @__PURE__ */ new Set(), es = class {
	constructor(e, t) {
		this.signals = { onGrow: new Re() }, this.slotUseCounts = /* @__PURE__ */ new Map(), this.slotsHashSlotId = /* @__PURE__ */ new Map(), this.slotsHashImageUrl = /* @__PURE__ */ new Map(), this.renderer = e, this.altasSlotSize = t.altasSlotSize, this.maxAtlasSize = t.maxSize, this.currentAtlasSize = t.maxSize, this.canvas = this.createCanvas(this.altasSlotSize), this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), this.dataTexture = this.createDataTexture(this.currentAtlasSize), this.canvasTexture = this.createCanvasTexture(), this.atlasSlotCount = this.currentAtlasSize / this.altasSlotSize;
	}
	get getAtlasSlotCount() {
		return this.atlasSlotCount;
	}
	get maxTextures() {
		let e = this.maxAtlasSize / this.altasSlotSize;
		return e * e;
	}
	get hasFreeSlot() {
		return this.slotsHashSlotId.size < this.maxTextures;
	}
	encodeSlotId(e, t) {
		return e << 16 | t & 65535;
	}
	decodeSlotId(e) {
		return {
			row: e >> 16 & 65535,
			col: e & 65535
		};
	}
	createDataTexture(e) {
		let t = new Uint8Array(e * e * 4), n = new p(t, e, e, Ee);
		return n.flipY = !1, n.magFilter = fe, n.minFilter = pe, n.needsUpdate = !0, n;
	}
	createCanvasTexture() {
		let e = new Uint8Array(this.altasSlotSize * this.altasSlotSize * 4);
		return new p(e, this.altasSlotSize, this.altasSlotSize);
	}
	createCanvas(e) {
		let t = document.createElement("canvas");
		return t.width = e, t.height = e, t;
	}
	grow() {
		if (this.currentAtlasSize < this.maxAtlasSize) this.currentAtlasSize *= 2, this.updateCanvasSize(this.currentAtlasSize), this.signals.onGrow.emit();
		else throw Error("The texture cannot be scale up");
	}
	updateCanvasSize(e) {
		this.atlasSlotCount = e / this.altasSlotSize, this.dataTexture.dispose(), this.dataTexture = this.createDataTexture(e), this.slotsHashSlotId.map(([e, t]) => {
			let n = this.slotsHashImageUrl.get(e);
			n && this.drawImage(t, n);
		});
	}
	getNexAvailableId() {
		$o.clear();
		for (let e of this.slotsHashSlotId.values()) $o.add(e);
		for (let e = 0; e < this.atlasSlotCount; e++) for (let t = 0; t < this.atlasSlotCount; t++) {
			let n = this.encodeSlotId(e, t);
			if (!$o.has(n)) return n;
		}
		return -1;
	}
	getCellPosition(e) {
		let { row: t, col: n } = this.decodeSlotId(e);
		return {
			col: n,
			row: t,
			cellX: n * this.altasSlotSize,
			cellY: t * this.altasSlotSize
		};
	}
	clearCell(e, t, n) {
		e?.clearRect(t, n, this.altasSlotSize, this.altasSlotSize);
	}
	drawImageInZone(e, t, n, r, i) {
		if (!e) return;
		let a = t.width / t.height, o = Math.min(i, a >= 1 ? this.altasSlotSize / a : i), s = o * a, c = n + (this.altasSlotSize - s) / 2, l = r + (i - o) / 2;
		e.drawImage(t, c, l, s, o);
	}
	loadImage(e) {
		return new Promise((t, n) => {
			let r = new Image();
			r.onload = () => t(r), r.onerror = n, r.src = e;
		});
	}
	drawImage(e, t) {
		return this.loadImage(t).then((t) => {
			let { cellX: n, cellY: r } = this.getCellPosition(e);
			this.clearCell(this.ctx, 0, 0), this.drawImageInZone(this.ctx, t, 0, 0, this.altasSlotSize);
			let i = this.ctx.getImageData(0, 0, this.altasSlotSize, this.altasSlotSize);
			this.canvasTexture.image.data.set(i.data), this.renderer.copyTextureToTexture(this.canvasTexture, this.dataTexture, void 0, Qo.set(n, r)), this.renderer.requestAnimationFrame();
		});
	}
	freeTexture(e) {
		let t = this.slotsHashSlotId.get(e), n = this.slotsHashImageUrl.get(e);
		t == null ? console.warn(`This hash is not in the altas: ${e}`) : this.slotsHashSlotId.delete(e), n !== void 0 && this.slotsHashImageUrl.delete(e);
	}
	getSlotId(e) {
		return this.slotsHashSlotId.get(e);
	}
	freeOneTextureInstance(e) {
		let t = this.slotUseCounts.get(e);
		t && (--t, this.slotUseCounts.set(e, t)), t === 0 && this.freeTexture(e);
	}
	freeOneTextureInstanceWithSlotId(e) {
		for (let [t, n] of this.slotsHashSlotId) if (n === e) {
			this.freeOneTextureInstance(t);
			break;
		}
	}
	lockSlotId(e) {
		let t = this.slotsHashSlotId.get(e);
		if (t !== void 0) {
			let n = this.slotUseCounts.get(e) ?? 0;
			return this.slotUseCounts.set(e, n + 1), t;
		}
		let n = this.getNexAvailableId();
		return n == -1 && (this.grow(), n = this.getNexAvailableId()), this.slotsHashSlotId.set(e, n), this.slotUseCounts.set(e, 1), n;
	}
	addTexture(e, t) {
		let n = this.lockSlotId(e);
		return (this.slotUseCounts.get(e) ?? 1) > 1 ? {
			slotId: n,
			drawPromise: new Promise((e) => e())
		} : (this.slotsHashImageUrl.set(e, t), {
			slotId: n,
			drawPromise: this.drawImage(n, t)
		});
	}
	async clear() {
		this.slotsHashImageUrl.clear(), this.slotsHashSlotId.clear(), this.slotUseCounts.clear(), $o.clear(), this.currentAtlasSize = this.maxAtlasSize, this.atlasSlotCount = this.currentAtlasSize / this.altasSlotSize, this.dataTexture.dispose(), this.dataTexture = this.createDataTexture(this.currentAtlasSize);
	}
}, ts = class extends es {
	constructor(e, t) {
		super(e, t), this.textCanvas = this.createCanvas(this.altasSlotSize), this.textCtx = this.textCanvas.getContext("2d");
	}
	drawTextInZone(e, t, n, r) {
		if (!this.textCtx) return;
		let i = 44 * (this.altasSlotSize / 256);
		this.textCtx.font = `${i}px serif`, this.textCtx.fillStyle = "black";
		let a = this.textCtx.measureText(e), o = n + (r + (a.actualBoundingBoxAscent + a.actualBoundingBoxDescent)) / 2, s = a.width > this.altasSlotSize ? t : t + (this.altasSlotSize - a.width) / 2;
		this.textCtx.fillText(e, s, o);
	}
	drawText(e) {
		this.clearCell(this.textCtx, 0, 0), this.drawTextInZone(e, 0, 0, this.altasSlotSize - 1);
	}
	drawImageAndText(e, t) {
		return this.loadImage(e).then((e) => {
			this.clearCell(this.textCtx, 0, 0);
			let n = this.altasSlotSize * .33, r = this.altasSlotSize * .67;
			this.drawTextInZone(t, 0, 0, n), this.drawImageInZone(this.textCtx, e, 0, 0 + n, r);
		});
	}
	addTextureWithText(e) {
		let t = e.imageUrl ?? "", n = e.text ?? "";
		if (t === "" && n === "") throw Error("At least one image url or text is mandatory");
		let r = `${t}${n}`, i = this.lockSlotId(r);
		if ((this.slotUseCounts.get(r) ?? 1) > 1) return {
			slotId: i,
			drawPromise: new Promise((e) => e())
		};
		let a;
		if (n !== "") {
			if (t === "") {
				this.drawText(n);
				let e = this.textCanvas.toDataURL();
				this.slotsHashImageUrl.set(r, e), a = this.drawImage(i, e);
			} else a = new Promise((e) => this.drawImageAndText(t, n).then(() => {
				let t = this.textCanvas.toDataURL();
				this.slotsHashImageUrl.set(r, t), this.drawImage(i, t).then(() => e());
			}));
		} else this.slotsHashImageUrl.set(r, t), a = this.drawImage(i, t);
		return {
			slotId: i,
			drawPromise: a
		};
	}
}, ns = /* @__PURE__ */ new x(), rs = /* @__PURE__ */ new x(), is = /* @__PURE__ */ new Te(), as = /* @__PURE__ */ new x(), os = /* @__PURE__ */ new Fe(), ss = /* @__PURE__ */ new a(), cs = class extends So {
	constructor(e, t, n, r = me.generateUUID()) {
		super(r), this.isSceneSprite = !0, this.proxyId = t, this.container = e, this.clickCallback = n;
	}
	get isAlwaysVisible() {
		return this.container.isAlwaysVisible;
	}
	setMatrix(e) {
		e.decompose(rs, is, as), os.set(as.x, as.y), this.setPosition(rs), this.setScale(os);
	}
	getMatrix(e) {
		return this.getPosition(rs), this.getScale(os), as.set(as.x, as.y, 1), e.compose(rs, is, as), e;
	}
	getPosition(e) {
		return this.container.getPositionAt(this.proxyId, e);
	}
	setPosition(e) {
		return this.container.setPositionAt(this.proxyId, e);
	}
	getScale(e) {
		return this.container.getScaleAt(this.proxyId, e);
	}
	setScale(e) {
		return this.container.setScaleAt(this.proxyId, e);
	}
	getActive() {
		return this.container.getActiveAt(this.proxyId);
	}
	setActive(e) {
		return this.container.setActiveAt(this.proxyId, e);
	}
	setTexture(e) {
		return this.container.freeOneTextureInstanceWithProxyId(this.proxyId), this.container.addTexture(this.proxyId, e);
	}
	delete() {
		this.container.deleteProxy(this);
	}
	addChild(e) {
		throw Error("Sprite cannot have child");
	}
	set visible(e) {
		this.setActive(e), super.visible = e;
	}
	get visible() {
		return this.getActive();
	}
	set active(e) {
		super.active = e, this.setActive(e);
	}
	get active() {
		return this.getActive();
	}
	set selected(e) {
		super.selected = e;
	}
	get selected() {
		return super.selected;
	}
	raycast(e, t) {
		this.getBoundingBox(ss), e.ray.intersectBox(ss, ns) && t.push({
			object: this,
			rayDistance: 0,
			point: ns.clone(),
			distance: e.ray.origin.distanceTo(ns)
		});
	}
	getBoundingBox(e) {
		return this.container.getBoundingBoxAt(this.proxyId, e);
	}
	getBoundingSphere(e) {
		return this.getBoundingBox(ss).getBoundingSphere(e), e;
	}
	projectPointOnEdges(e, t, n) {
		return !1;
	}
};
//#endregion
//#region src/scene/objects/sprites/SpriteContainerMaterialMixin.ts
function ls(e) {
	class t extends e {
		constructor(...e) {
			let [t, n] = e;
			super(n), this.atlasSlotCount = { value: 0 }, this.onTextureGrow = () => {
				this.atlasSlotCount.value = this.atlas.getAtlasSlotCount, this.map = this.atlas.dataTexture;
			}, this.onBeforeCompile = (e) => {
				this.propertiesTexture && (e.uniforms.atlasSlotCount = this.atlasSlotCount, e.uniforms.propertiesTexture = { value: this.propertiesTexture }, this._setVertexShader(this.propertiesTexture, e));
			}, this._setVertexShader = (e, t) => {
				t.vertexShader = `
        uniform float rotation;
        uniform vec2 center;
        uniform float atlasSlotCount;
        uniform highp sampler2D propertiesTexture;

        attribute float instanceId;

        #include <common>
        #include <uv_pars_vertex>
        #include <fog_pars_vertex>
        #include <logdepthbuf_pars_vertex>
        #include <clipping_planes_pars_vertex>

        void main() {
          ${e.getGlsl("instanceId", "propertiesTexture")}

          if (instanceActive < 0.5 || instanceCulling < 0.5) {
            gl_Position = vec4(0.0, 0.0, 0.0, 0.0);
            return;
          }

          #include <uv_vertex>

          int id = int(instanceTextureId);

          int col = id & 0xFFFF;
          int row = (id >> 16) & 0xFFFF;

          vec2 cellSize = vec2(1.0 / float(atlasSlotCount), 1.0 / float(atlasSlotCount));

          // local UV inside the tile (with flip)
          vec2 localUv = vec2(uv.x, 1.0 - uv.y);

          // final atlas UV
          vMapUv = (localUv + vec2(float(col), float(row))) * cellSize;

          // vec4 mvPosition = modelViewMatrix[ 3 ];
          vec4 mvPosition = modelViewMatrix * vec4(instancePosition, 1.0);

          // vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );

          #ifndef USE_SIZEATTENUATION

            bool isPerspective = isPerspectiveMatrix( projectionMatrix );

            if ( isPerspective ) instanceScale *= - mvPosition.z;

          #endif

          vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * instanceScale;

          vec2 rotatedPosition;
          rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
          rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;

          mvPosition.xy += rotatedPosition;

          gl_Position = projectionMatrix * mvPosition;

          #include <logdepthbuf_vertex>
          #include <clipping_planes_vertex>
          #include <fog_vertex>
        }`;
			}, this.atlas = t, this.map = t.dataTexture, t.signals.onGrow.connect(this.onTextureGrow), this.atlasSlotCount.value = t.getAtlasSlotCount;
		}
		get hasFreeSlot() {
			return this.atlas.hasFreeSlot;
		}
		addTextureWithText(e) {
			return this.atlas.addTextureWithText(e);
		}
		freeOneTextureInstance(e) {
			this.atlas.freeOneTextureInstance(e);
		}
		freeOneTextureInstanceWithSlotId(e) {
			this.atlas.freeOneTextureInstanceWithSlotId(e);
		}
		setPropertiesTexture(e) {
			this.propertiesTexture = e;
		}
		dispose() {
			super.dispose(), this.atlas.signals.onGrow.disconnect(this.onTextureGrow), this.atlas.dataTexture.dispose();
		}
	}
	return t;
}
//#endregion
//#region src/scene/objects/sprites/SpriteContainerMaterial.ts
var us = class extends ls(Ne) {}, ds = /* @__PURE__ */ new Fe(), fs = /* @__PURE__ */ new x(), ps = [
	,
	,
	,
], ms = [
	,
	,
	,
], hs = [,], gs = [
	-.5,
	-.5,
	0,
	.5,
	-.5,
	0,
	.5,
	.5,
	0,
	-.5,
	.5,
	0
], _s = [
	0,
	0,
	1,
	0,
	1,
	1,
	0,
	1
], vs = [
	0,
	1,
	2,
	0,
	2,
	3
], ys = new ne(), bs = new y(), xs = new x(), Ss = new x();
function Cs(e, t) {
	e.sort((e, t) => t.depth - e.depth), t.length = 0;
	for (let n of e) t.push(n.id);
}
var ws = class extends ye {
	constructor(e, t) {
		super(), this.isSprite = !0, this.center = new Fe(.5, .5), this.isSpriteContainer = !0, this.type = "SpriteContainer", this.proxies = [], this.availableIds = [], this.currentId = 0, this.visibleSprites = [], this.sortedIds = [], this.spriteDepthById = [], this.sortingDirty = !0, this.frustumCulled = !1;
		let n = t.sprites.maxAtlasSize.value, r = e.maxTextureSize;
		r && r <= 8192 && n === 8192 && (n = 4096), this.settings = t, this.maxSpriteCount = this.settings.sprites.maxSpriteCount.value, this.altasSlotSize = this.settings.sprites.altasSlotSize.value, this.sortedIdFlags = new Uint8Array(this.maxSpriteCount), this.propertiesTexture = this.getPropertyTexture();
		let i = new ts(e, {
			maxSize: n,
			altasSlotSize: this.altasSlotSize
		});
		this.material = this.createMaterial(i), this.material.setPropertiesTexture(this.propertiesTexture), this.geometry = new oe(), this.geometry.instanceCount = 0, this.setBuffer();
	}
	get count() {
		return this.geometry.instanceCount;
	}
	get isAlwaysVisible() {
		return this.layers.isEnabled(pn.AlwaysVisible);
	}
	updateFrustumCulling(e) {
		bs.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), ys.setFromProjectionMatrix(bs);
		for (let e = 0; e < this.maxSpriteCount; e++) {
			let t = this.propertiesTexture.getMaterialProperty(e, "instanceActive", hs);
			if (t && t[0] < .5) {
				this.propertiesTexture.setMaterialProperty(e, "instanceCulling", 0);
				continue;
			}
			let n = this.propertiesTexture.getMaterialProperty(e, "instancePosition", ms);
			n && fs.fromArray(n);
			let r = +!!ys.containsPoint(fs);
			this.propertiesTexture.setMaterialProperty(e, "instanceCulling", r);
		}
	}
	hasFreeSlot(e) {
		return (this.geometry.instanceCount < this.maxSpriteCount || this.availableIds.length > 0) && this.material.hasFreeSlot && this.isAlwaysVisible != e;
	}
	createProxy(e, t, n) {
		let r = this.availableIds.pop();
		if (r ?? (r = this.currentId, this.currentId++, this.geometry.instanceCount += 1), r > this.maxSpriteCount) throw Error("Not enough space in the SpriteContainer");
		let i = new cs(this, r, n);
		return i.setPosition(e), i.setScale(t), i.active = !0, this.setCullingAt(r, !0), this.setTextureIdAt(r, -1), this.proxies.push(i), this.sortingDirty = !0, i;
	}
	deleteProxy(e) {
		e.active = !1, this.availableIds.push(e.proxyId), this.proxies.remove(e), this.freeOneTextureInstanceWithProxyId(e.proxyId);
	}
	createMaterial(e) {
		return new us(e, {
			transparent: !0,
			alphaTest: .01,
			depthWrite: !1
		});
	}
	getPropertyTexture() {
		return new so(this.maxSpriteCount, {
			instancePosition: "vec3",
			instanceScale: "vec2",
			instanceActive: "float",
			instanceCulling: "float",
			instanceTextureId: "float"
		});
	}
	setBuffer() {
		let e = new Float32Array(this.maxSpriteCount);
		for (let t = 0; t < this.maxSpriteCount; t++) e[t] = t;
		this.geometry.setAttribute("instanceId", new ae(e, 1)), this.geometry.setIndex(vs);
		let t = new Float32Array(gs);
		this.geometry.setAttribute("position", new c(t, 3, !1));
		let n = new Float32Array(_s);
		this.geometry.setAttribute("uv", new c(n, 2, !1));
	}
	sortTransparentSprites(e, t = !1) {
		if (t && (this.sortingDirty = !0), !this.sortingDirty) return;
		let n = this.collectVisibleSprites(e);
		Cs(this.visibleSprites, this.sortedIds), this.applySortedInstanceIds(), this.updateRenderOrder(n), this.sortingDirty = !1;
	}
	collectVisibleSprites(e) {
		this.visibleSprites.length = 0;
		let t = e.projectionMatrix.elements, n = "isPerspectiveCamera" in e && e.isPerspectiveCamera, r = 0;
		for (let i = 0; i < this.geometry.instanceCount; i++) {
			if (!this.getActiveAt(i)) continue;
			this.getPositionAt(i, fs), this.getScaleAt(i, ds), xs.copy(fs).applyMatrix4(e.matrixWorldInverse);
			let a = -xs.z;
			if (n && a <= 0) continue;
			Ss.copy(xs).applyMatrix4(e.projectionMatrix);
			let o = n ? a : 1, s = Math.abs(ds.x * t[0] / o) * .5, c = Math.abs(ds.y * t[5] / o) * .5;
			if (Ss.x + s < -1 || Ss.x - s > 1 || Ss.y + c < -1 || Ss.y - c > 1) continue;
			r += a;
			let l = this.spriteDepthById[i] ?? {
				id: i,
				depth: 0
			};
			l.depth = a, this.spriteDepthById[i] = l, this.visibleSprites.push(l);
		}
		return r;
	}
	applySortedInstanceIds() {
		let e = this.geometry.getAttribute("instanceId");
		this.sortedIdFlags.fill(0);
		let t = 0;
		for (let n of this.sortedIds) e.setX(t++, n), this.sortedIdFlags[n] = 1;
		for (let n = 0; n < this.geometry.instanceCount; n++) this.sortedIdFlags[n] === 0 && e.setX(t++, n);
		e.needsUpdate = !0;
	}
	updateRenderOrder(e) {
		this.renderOrder = this.visibleSprites.length > 0 ? -e / this.visibleSprites.length : 0;
	}
	setCullingAt(e, t) {
		return this.propertiesTexture.setMaterialProperty(e, "instanceCulling", +!!t), t;
	}
	setPositionAt(e, t) {
		return this.propertiesTexture.setMaterialProperty(e, "instancePosition", t.x, t.y, t.z), this.sortingDirty = !0, t;
	}
	getPositionAt(e, t) {
		return this.propertiesTexture.getMaterialProperty(e, "instancePosition", ps), t.fromArray(ps), t;
	}
	setScaleAt(e, t) {
		return this.propertiesTexture.setMaterialProperty(e, "instanceScale", t.x, t.y), this.sortingDirty = !0, t;
	}
	getScaleAt(e, t) {
		return this.propertiesTexture.getMaterialProperty(e, "instanceScale", ps), t.fromArray(ps), t;
	}
	setActiveAt(e, t) {
		let n = +!!t;
		return this.propertiesTexture.setMaterialProperty(e, "instanceActive", n), this.sortingDirty = !0, t;
	}
	getActiveAt(e) {
		return this.propertiesTexture.getMaterialProperty(e, "instanceActive", ps), !!ps[0];
	}
	getBoundingBoxAt(e, t) {
		this.getPositionAt(e, fs), this.getScaleAt(e, ds);
		let n = ds.x / 2, r = ds.y / 2;
		return t.min.set(fs.x - n, fs.y - r, fs.z - n), t.max.set(fs.x + n, fs.y + r, fs.z + n), t;
	}
	setTextureIdAt(e, t) {
		return this.propertiesTexture.setMaterialProperty(e, "instanceTextureId", t), t;
	}
	getTextureIdAt(e) {
		return this.propertiesTexture.getMaterialProperty(e, "instanceTextureId", ps), ps[0];
	}
	addTexture(e, t) {
		let { slotId: n, drawPromise: r } = this.material.addTextureWithText(t);
		return this.setTextureIdAt(e, n), r;
	}
	freeOneTextureInstance(e) {
		this.material.freeOneTextureInstance(e);
	}
	freeOneTextureInstanceWithProxyId(e) {
		let t = this.getTextureIdAt(e);
		t < 0 || this.material.freeOneTextureInstanceWithSlotId(t);
	}
	clear() {
		this.proxies.clear(), this.geometry.instanceCount = 0, this.currentId = 0, this.availableIds.length = 0, this.propertiesTexture.dispose();
		for (let e = 0; e < this.maxSpriteCount; e++) this.setActiveAt(e, !1), this.setTextureIdAt(e, -1), this.setCullingAt(e, !1);
		return this.material.atlas.clear(), this;
	}
	onBeforeRender(e, t, n) {
		this.sortTransparentSprites(n), this.settings.sprites.frustumCulling.value && this.updateFrustumCulling(n);
	}
}, Ts = class extends Do {
	constructor(e) {
		super(e), this.instances = [], this.isVisible = !0, this.sortTransparentSprites = () => {
			let e = this._viewer.viewport?.camera;
			if (e) for (let t of this.instances) t.sortTransparentSprites(e, !0);
		}, e.signals.onCameraMove.connect(this.sortTransparentSprites);
	}
	onSceneSetup(e) {
		for (let t of this.instances) e.addInternalObject(t);
	}
	onSceneClear(e) {
		for (let t of this.instances) e.removeInternalObject(t);
	}
	accepts(e) {
		return e.isSceneSprite;
	}
	_setVisibility(e) {
		for (let t of this.instances) t.visible = e;
		this.isVisible = e;
	}
	createInstance(e) {
		if (!this._viewer.viewport) throw Error("Viewport must be available");
		let t = new ws(this._viewer.viewport.renderer, this._viewer.settings);
		return t.visible = this.isVisible, e || t.layers.set(pn.AlwaysVisible), this.instances.push(t), this._viewer.scene.addInternalObject(t), t;
	}
	getInstance(e) {
		for (let t of this.instances) if (t.hasFreeSlot(e)) return t;
		return this.createInstance(e);
	}
	addObject(e, t) {
		this._viewer.scene.addObjectIntoBoxTree(e), super.addObject(e, t);
	}
	removeObject(e) {
		e.delete(), this._viewer.scene.removeObjectFromBoxTree(e), super.removeObject(e);
	}
	createSprite(e, t, n, r = !0) {
		return this.getInstance(r).createProxy(e, t, n);
	}
	clear() {
		for (let e of this.instances) this._viewer.scene.removeInternalObject(e), e.clear();
		this.instances.clear(), super.clear();
	}
	dispose() {
		this._viewer.signals.onCameraMove.disconnect(this.sortTransparentSprites), super.dispose();
		for (let e of this.instances) this._viewer.scene.removeInternalObject(e), e.clear(), e.geometry.dispose(), e.material.dispose();
		this.instances.clear();
	}
}, Es = 1, Ds = 1e3, Os = class extends de {
	constructor(e = 10, t = 7829367) {
		let n = new c(/* @__PURE__ */ new Float32Array(24012), 3), r = new l();
		r.setAttribute("position", n);
		let i = new le({
			color: t,
			toneMapped: !1
		});
		super(r, i), this._size = Math.min(Math.max(e, Es), Ds), this.color = new f(t), this.updateVertices();
	}
	updateVertices() {
		let e = this.geometry.getAttribute("position");
		e.setXYZ(0, 0, 0, this.size), e.setXYZ(1, 0, 0, -this.size), e.setXYZ(2, this.size, 0, 0), e.setXYZ(3, -this.size, 0, 0);
		let t = 4;
		for (let n = 1; n <= this.size; n++) e.setXYZ(t++, n, 0, this.size), e.setXYZ(t++, n, 0, -this.size), e.setXYZ(t++, -n, 0, this.size), e.setXYZ(t++, -n, 0, -this.size), e.setXYZ(t++, this.size, 0, n), e.setXYZ(t++, -this.size, 0, n), e.setXYZ(t++, this.size, 0, -n), e.setXYZ(t++, -this.size, 0, -n);
		this.geometry.setDrawRange(0, 4 + this.size * 8), e.needsUpdate = !0;
	}
	get size() {
		return this._size;
	}
	setColor(e) {
		this.material.color.set(e), this.material.needsUpdate = !0;
	}
	setSize(e) {
		this._size = Math.min(Math.max(e, Es), Ds), this.updateVertices();
	}
}, ks = /* @__PURE__ */ new a(), As = /* @__PURE__ */ new a(), js = class {
	constructor(e) {
		this._viewer = e, this._internalScene = new ke(), this._boxTree = new ea(), this.objectsHelpers = new re(), this._objectSelection = new Qn(), this.grid = new Os(), this.ambientLight = new r(16777215, 2), this.originAxesHelper = new i(1), this.sceneAxesHelper = new i(1), this._snapModeHelper = new ga(), this._controllers = /* @__PURE__ */ new Set(), this._boundingBoxObjects = /* @__PURE__ */ new Set(), this.boundingBox = new a(), this._internalScene.name = "Scene", this._internalScene.background = new f(e.settings.scene.backgroundColor.value), this.grid.name = "Grid", this.grid.visible = e.settings.scene.showGrid.value, this.originAxesHelper.name = "OriginAxesHelper", this.originAxesHelper.visible = e.settings.scene.showOriginAxisHelper.value, this.originAxesHelper.scale.set(10, 10, 10), this.sceneAxesHelper.name = "SceneAxesHelper", this.sceneAxesHelper.visible = e.settings.scene.showSceneAxisHelper.value, this.sceneAxesHelper.scale.set(10, 10, 10), this._boxTreeHelper = new ra(this._boxTree), this._boxTreeHelper.visible = !1, this.lightsController = new Ri(this._viewer), this.clippingPlaneController = new Yo(this._viewer), this.spriteController = new Ts(this._viewer), this.bimMeshController = new Lo(this._viewer), this._addDefaultObjects(), this.addController(this.clippingPlaneController), this.addController(this.bimMeshController), this.addController(this.spriteController), this.lightsController.setupLights(), this.collections = new Zo();
	}
	_addDefaultObjects() {
		this._addLights(), this._internalScene.add(this.grid), this._internalScene.add(this.originAxesHelper), this._internalScene.add(this.sceneAxesHelper), this._internalScene.add(this._snapModeHelper), this._internalScene.add(this.objectsHelpers), this._internalScene.add(this._boxTreeHelper), this._viewer.viewport?.transformController.addToScene();
	}
	_addLights() {
		this._internalScene.add(this.lightsController.hemisphereLight), this._internalScene.add(this.lightsController.sky), this._internalScene.add(this.lightsController.directionalLight);
	}
	get objectSelection() {
		return this._objectSelection;
	}
	setObjectSelection(e) {
		this._objectSelection = e, this._viewer.signals.onObjectSelectionChanged.emit();
	}
	*getAllObjects() {
		for (let e of this._controllers) yield* e.getAllObjects();
	}
	*getAllObjectUuids() {
		for (let e of this._controllers) yield* e.getAllObjectUuids();
	}
	*getAllVisibleObjects() {
		for (let e of this._controllers) yield* e.getAllVisibleObjects();
	}
	*getAllHiddenObjects() {
		for (let e of this._controllers) yield* e.getAllHiddenObjects();
	}
	*getAllVisibleObjectUuids() {
		for (let e of this._controllers) yield* e.getAllVisibleObjectUuids();
	}
	*getAllHiddenObjectUuids() {
		for (let e of this._controllers) yield* e.getAllHiddenObjectUuids();
	}
	hasObjectUUID(e) {
		for (let t of this._controllers) if (t.hasObjectUUID(e)) return !0;
		return !1;
	}
	getObjectByUUID(e) {
		let t;
		for (let n of this._controllers) if (t = n.getObjectByUUID(e), t) return t;
		return null;
	}
	*getObjectsByUUID(e) {
		for (let t of e) {
			let e = this.getObjectByUUID(t);
			e && (yield e);
		}
	}
	getControllerForObject(e) {
		for (let t of this._controllers) if (t.hasObjectUUID(e.uuid)) return t;
		return null;
	}
	get controllers() {
		return this._controllers;
	}
	addController(e) {
		this._controllers.has(e) || (this._controllers.add(e), e.onSceneSetup(this));
	}
	removeController(e) {
		e.onSceneClear(this), this._controllers.delete(e);
	}
	addObject(e, t = null) {
		for (let n of this._controllers) if (n.accepts(e)) {
			n.addObject(e, t);
			return;
		}
	}
	removeObject(e) {
		for (let t of this._controllers) if (t.hasObjectUUID(e.uuid)) {
			t.removeObject(e);
			return;
		}
	}
	isObjectInBoxTree(e) {
		return this._boxTree.hasItem(e);
	}
	addObjectIntoBoxTree(e) {
		this._boxTree.addItem(e), this.updateBoundingBox();
	}
	removeObjectFromBoxTree(e) {
		this._boxTree.removeItem(e), this.updateBoundingBox();
	}
	updateObjectInBoxTree(e) {
		this._boxTree.updateItem(e), this.updateBoundingBox();
	}
	updateBoundingBox() {
		this._boxTree.getBoundingBox(ks);
		for (let e of this._boundingBoxObjects) e.getBoundingBox(As), ks.union(As);
		ks.getCenter(this.sceneAxesHelper.position), !ks.equals(this.boundingBox) && (this.boundingBox.copy(ks), this._viewer.signals.onSceneBoundsChanged.emit());
	}
	clear() {
		for (let e of this._controllers) e.onSceneClear(this), e.clear();
		this.setObjectSelection(new Qn()), this._boundingBoxObjects.clear(), this._internalScene.clear(), this._boxTree.reset(), this.updateBoundingBox(), this._addDefaultObjects();
		for (let e of this._controllers) e.onSceneSetup(this);
		this._viewer.signals.onSceneGraphChanged.emit(), this._viewer.scene.collections.deleteAllCollections();
	}
	dispose() {
		for (let e of this._controllers) e.dispose(), e.clear();
		this._controllers.clear(), this._internalScene.environment?.dispose(), this._internalScene.environment = null, this.grid.geometry.dispose(), Ms(this.grid.material), this.originAxesHelper.geometry.dispose(), Ms(this.originAxesHelper.material), this.sceneAxesHelper.geometry.dispose(), Ms(this.sceneAxesHelper.material), this._boxTreeHelper.geometry.dispose(), Ms(this._boxTreeHelper.material), this.lightsController.sky.geometry.dispose(), Ms(this.lightsController.sky.material), this._internalScene.clear(), this._boxTree.reset(), this._boundingBoxObjects.clear(), this.collections.deleteAllCollections();
	}
	addObjectToBoundingBox(e) {
		if (this._boxTree.hasItem(e)) throw Error("Cannot add object to bounding box, it is already in the box tree.");
		let t = this._boundingBoxObjects.size;
		this._boundingBoxObjects.add(e), this._boundingBoxObjects.size !== t && this.updateBoundingBox();
	}
	removeObjectFromBoundingBox(e) {
		this._boundingBoxObjects.delete(e) && this.updateBoundingBox();
	}
	raycastBoxTree(e, t = 1) {
		return this._boxTree.raycast(e, t);
	}
	addInternalObject(e) {
		this._internalScene.add(e);
	}
	removeInternalObject(e) {
		this._internalScene.remove(e);
	}
	set background(e) {
		this._internalScene.background.set(e);
	}
	get background() {
		return this._internalScene.background.getHexString();
	}
	updateClippingPlanes() {
		let e = Array.from(this.clippingPlaneController.planes());
		for (let t of this.controllers) {
			let n = t;
			n.isSceneMeshController && n.setClippingPlanes(e);
		}
	}
	getBoxTreeSize() {
		return this._boxTree.size;
	}
	getBoxTreeSnapshot() {
		return this._boxTree.createSnapshot((e) => e.uuid);
	}
	getBoxTreeBoundingBox(e) {
		return this._boxTree.getBoundingBox(e);
	}
	getBoxTreeBoundingSphere(e) {
		return this._boxTree.getBoundingBox(ks), ks.getBoundingSphere(e);
	}
	getBoundingBox(e) {
		return e.copy(this.boundingBox);
	}
	getBoundingSphere(e) {
		this.getBoundingBox(ks), ks.getBoundingSphere(e);
	}
	showBoxTreeHelper(e) {
		e && this._boxTreeHelper.update(), this._boxTreeHelper.visible = e;
	}
};
function Ms(e) {
	let t = Array.isArray(e) ? e : [e];
	for (let e of t) e.dispose();
}
//#endregion
//#region src/viewport/controllers/InteractionController.ts
var Ns = class {
	constructor(e) {
		this._selectionFilters = /* @__PURE__ */ new Set(), this._raycastFilters = /* @__PURE__ */ new Set(), this._transformFilters = /* @__PURE__ */ new Set(), this.isObjectSelectable = (e) => e.isSelectable && this._passAllFilters(this._selectionFilters, e), this.isObjectRaycastable = (e) => e.isRaycastable && this._passAllFilters(this._raycastFilters, e), this.isObjectTransformable = (e) => e.isTransformable && this._passAllFilters(this._transformFilters, e), this._viewport = e;
	}
	addSelectionFilter(e) {
		this._selectionFilters.add(e);
	}
	removeSelectionFilter(e) {
		this._selectionFilters.delete(e);
	}
	addRaycastFilter(e) {
		this._raycastFilters.add(e);
	}
	removeRaycastFilter(e) {
		this._raycastFilters.delete(e);
	}
	addTransformFilter(e) {
		this._transformFilters.add(e);
	}
	removeTransformFilter(e) {
		this._transformFilters.delete(e);
	}
	_passAllFilters(e, t) {
		for (let n of e) if (!n(t, this._viewport)) return !1;
		return !0;
	}
}, Ps = 1e3, Fs = /* @__PURE__ */ function(e) {
	return e[e.Orbital = 0] = "Orbital", e[e.FirstPerson = 1] = "FirstPerson", e[e.FloorPlan = 2] = "FloorPlan", e[e.CursorOrbital = 3] = "CursorOrbital", e;
}({}), Is = /* @__PURE__ */ new x(), Ls = /* @__PURE__ */ new x(), Rs = /* @__PURE__ */ new b(), zs = class {
	constructor(e, t, n = {}) {
		this.controls = t, this._viewport = e, this.distance = n.radius ?? 20, this.distance === 0 && (this.distance = 20), this.center = new x(), n.center && this.center.copy(n.center);
	}
	updateSceneSettings(e) {
		let t = e.radius ?? 20, n = t === 0 ? 20 : t, r = e.center ?? Ls.set(0, 0, 0);
		return this.distance === n && this.center.equals(r) ? !1 : (this.distance = n, this.center.copy(r), this.updateSceneConstraints(), !0);
	}
	onPointerDown(e) {}
	onPointerMove(e) {}
	onPointerUp(e) {}
	onWheel(e) {}
	dispose() {}
	async fitToSphere(e, t = .25) {
		this.controls.smoothTime = t, await this.controls.fitToSphere(e, t > 0);
	}
	async moveForwardTargetDirection(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.truck(0, -e, t > 0);
	}
	async moveSideTargetDirection(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.truck(e, 0, t > 0);
	}
	setPosition(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.setPosition(e.x, e.y, e.z, t > 0);
	}
	setTarget(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.setTarget(e.x, e.y, e.z, t > 0);
	}
	zoomTo(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.zoomTo(e, t > 0);
	}
	async reset(e = 1.5, t = .25) {
		this._viewport.viewer.scene.getBoundingSphere(Rs), Rs.radius *= e, await Promise.all([this.lookAt(Is.set(10, 10, 10), Ls.set(0, 0, 0), t), this.fitToSphere(Rs, t)]);
	}
	lookAt(e, t, n = .25) {
		return this.controls.smoothTime = n, this.controls.setLookAt(e.x, e.y, e.z, t.x, t.y, t.z, n > 0);
	}
}, Bs = /* @__PURE__ */ new x(), Vs = /* @__PURE__ */ new x(), Hs = /* @__PURE__ */ new x(), Us = /* @__PURE__ */ new x(), Ws = /* @__PURE__ */ new x(), Gs = Array.from({ length: 8 }, () => /* @__PURE__ */ new x());
function Ks(e, t) {
	return e.getWorldDirection(Hs), e.getWorldPosition(Us), Ws.subVectors(t, Us).dot(Hs);
}
function qs(e, t, n) {
	let { min: r, max: i } = t;
	Gs[0].set(r.x, r.y, r.z), Gs[1].set(r.x, r.y, i.z), Gs[2].set(r.x, i.y, r.z), Gs[3].set(r.x, i.y, i.z), Gs[4].set(i.x, r.y, r.z), Gs[5].set(i.x, r.y, i.z), Gs[6].set(i.x, i.y, r.z), Gs[7].set(i.x, i.y, i.z), n.minimum = Infinity, n.maximum = -Infinity;
	for (let t of Gs) {
		let r = Ks(e, t);
		n.minimum = Math.min(n.minimum, r), n.maximum = Math.max(n.maximum, r);
	}
	return n;
}
function Js(e, t) {
	e.getPosition(Bs, !1), e.getTarget(Vs, !1);
	let n = Bs.distanceTo(Vs);
	n >= t || (n > 0 ? Hs.subVectors(Bs, Vs).normalize() : e.camera.getWorldDirection(Hs).negate(), Vs.copy(Bs).addScaledVector(Hs, -t), e.setLookAt(Bs.x, Bs.y, Bs.z, Vs.x, Vs.y, Vs.z, !1), e.update(0));
}
//#endregion
//#region src/viewport/camera/PerspectiveMode.ts
var Ys = 1e3, Xs = class extends zs {
	constructor(e, t, n = {}) {
		super(e, t, n);
	}
	zoomIn(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.zoom(e / Ys, t > 0);
	}
	zoomOut(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.zoom(-e / Ys, t > 0);
	}
}, Zs = /* @__PURE__ */ new x(), Qs = /* @__PURE__ */ new x(), $s = class extends Xs {
	constructor(e, t, n = {}) {
		super(e, t, n), this.type = Fs.CursorOrbital, this.orbitPoint = new x(), this.cursorNeedsUpdate = !1, this.maxDistance = 0, this._sphereCursor = new ge(new je(), new _e({
			color: "black",
			transparent: !0,
			depthTest: !1
		})), this._sphereCursor.layers.set(pn.Tool), this.updateSceneConstraints();
	}
	updateSceneConstraints() {
		this.maxDistance = this.distance * 2 + Ps;
	}
	async setup(e, t = .5) {
		e.controls.getPosition(Zs), e.controls.getTarget(Qs), this.controls.dollyToCursor = !0, this.controls.infinityDolly = !0, this.controls.minDistance = 5, this.controls.maxDistance = 3e5, await this.lookAt(Zs, Qs, t);
	}
	onWheel(e) {
		this.controls.getPosition(Zs);
		let t = Zs.distanceTo(this.center);
		if (this.controls.enabled && !e.ctrlKey && this.controls.mouseButtons.wheel === et.ACTION.DOLLY && e.deltaY === 0 || e.deltaY > 0 && t >= this.maxDistance) {
			e.preventDefault(), e.stopPropagation();
			return;
		}
		this.controls.minDistance = 5;
	}
	onPointerDown(e) {
		let t = this._viewport.raycaster.raycastEvent(e);
		t.length > 0 ? this.orbitPoint.copy(t[0].point) : this.controls.getTarget(this.orbitPoint), e.button == 0 && (this.controls.minDistance = 0, this.controls.setOrbitPoint(this.orbitPoint.x, this.orbitPoint.y, this.orbitPoint.z), this.controls.minDistance = 5, Js(this.controls, this.controls.minDistance), this.cursorNeedsUpdate = !0);
	}
	onPointerMove(e) {
		this.cursorNeedsUpdate &&= (this._drawCursorSphere(), !1);
	}
	onPointerUp(e) {
		this._hideSphereCursor();
	}
	_drawCursorSphere() {
		let e = this._viewport.canvas.getBoundingClientRect(), t = this.controls.camera.position.distanceTo(this.orbitPoint), n = ec(this.controls.camera, t, 3, e.height);
		this._sphereCursor.position.copy(this.orbitPoint), this._sphereCursor.scale.set(n, n, n), this._viewport.viewer.scene._internalScene.add(this._sphereCursor);
	}
	_hideSphereCursor() {
		this._viewport.viewer.scene._internalScene.remove(this._sphereCursor);
	}
	dispose() {
		this._viewport.viewer.scene._internalScene.remove(this._sphereCursor), this._sphereCursor.geometry.dispose(), this._sphereCursor.material.dispose();
	}
};
function ec(e, t, n, r) {
	if (r <= 0) throw Error("viewportHeightPx must be > 0");
	if (e.isOrthographicCamera) {
		let t = e;
		return n * ((t.top - t.bottom) / r);
	}
	if (e.isPerspectiveCamera) {
		let i = e, a = me.degToRad(i.fov);
		return t * Math.tan(a / 2) * (2 * n / r);
	}
	throw Error("Unsupported camera type");
}
//#endregion
//#region src/viewport/camera/FirstPersonMode.ts
var K = /* @__PURE__ */ new x(), tc = /* @__PURE__ */ new x(), nc = /* @__PURE__ */ new x(), rc = /* @__PURE__ */ new x(), ic = /* @__PURE__ */ new b(), ac = class extends zs {
	constructor(...e) {
		super(...e), this.type = Fs.FirstPerson;
	}
	updateSceneConstraints() {}
	async setup(e, t = .5) {
		e.controls.getPosition(tc), e.controls.getTarget(K), this.controls.dollyToCursor = !1, this.controls.infinityDolly = !1, this.controls.azimuthRotateSpeed = .5, this.controls.polarRotateSpeed = .5, this.controls.minDistance = 1, this.controls.maxDistance = 1, this.lookAt(tc, K, t);
	}
	zoomIn(e) {
		return this.moveForwardTargetDirection(e);
	}
	zoomOut(e) {
		return this.moveForwardTargetDirection(-e);
	}
	fitToSphere(e, t = .25) {
		this.controls.smoothTime = t;
		let n = this.controls.getDistanceToFitSphere(e.radius);
		return K.copy(e.center), this.controls.getPosition(tc), rc.subVectors(tc, K).normalize().multiplyScalar(n), K.add(rc), this.controls.moveTo(K.x, K.y, K.z, t > 0);
	}
	moveForwardTargetDirection(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.getTarget(K), this.controls.getPosition(tc), nc.subVectors(K, tc).normalize().multiplyScalar(e), K.add(nc), this.controls.moveTo(K.x, K.y, K.z, t > 0);
	}
	moveSideTargetDirection(e, t = .25) {
		return this.controls.smoothTime = t, this.controls.getTarget(K), this.controls.getPosition(tc), nc.subVectors(K, tc).normalize(), rc.crossVectors(nc, this.controls.camera.up).normalize().multiplyScalar(e), K.add(rc), this.controls.moveTo(K.x, K.y, K.z, t > 0);
	}
	async lookAt(e, t, n = .25) {
		this.controls.smoothTime = n, rc.subVectors(e, t).normalize(), K.copy(e).addScaledVector(rc, this.controls.minDistance), await Promise.all([this.controls.moveTo(e.x, e.y, e.z, n > 0), this.controls.setPosition(K.x, K.y, K.z, n > 0)]);
	}
	async reset(e = 1.5, t = .25) {
		this._viewport.viewer.scene.getBoundingSphere(ic), ic.radius *= e, await this.fitToSphere(ic, t);
	}
}, oc = 1e3, sc = class extends zs {
	constructor(e, t, n = {}) {
		super(e, t, n), n.radius = this.controls.getDistanceToFitSphere(n.radius ?? 20);
	}
	zoomIn(e) {
		return this.controls.zoom(e / oc, !0);
	}
	zoomOut(e) {
		return this.controls.zoom(-e / oc, !0);
	}
}, cc = /* @__PURE__ */ new x(), lc = /* @__PURE__ */ new x(), uc = /* @__PURE__ */ new b(), dc = class extends sc {
	constructor(...e) {
		super(...e), this.type = Fs.FloorPlan;
	}
	updateSceneConstraints() {
		this.controls.minZoom = 1 / (this.distance * 10);
	}
	async setup(e, t = .5) {
		e.controls.getPosition(cc), e.controls.getTarget(lc), await this.lookAt(cc, lc, 0), this.controls.dollyToCursor = !1, this.updateSceneConstraints(), this.controls.maxZoom = 100, this.controls.azimuthRotateSpeed = 1, this.controls.polarRotateSpeed = 1, cc.copy(lc).setY(lc.y + this.distance), await Promise.all([this.lookAt(cc, lc, t), this.reset(1.5, t)]), this.controls.minPolarAngle = 0, this.controls.maxPolarAngle = 0;
	}
	async reset(e = 1.5, t = .25) {
		this._viewport.viewer.scene.getBoundingSphere(uc), uc.radius *= e, await this.fitToSphere(uc, t);
	}
}, fc = /* @__PURE__ */ new x(), pc = /* @__PURE__ */ new x(), mc = class extends Xs {
	constructor(...e) {
		super(...e), this.type = Fs.Orbital;
	}
	updateSceneConstraints() {
		this.controls.maxDistance = this.distance * 2 + Ps;
	}
	async setup(e, t = .5) {
		e.controls.getPosition(fc), e.controls.getTarget(pc), this.controls.dollyToCursor = !1, this.controls.minDistance = .01, this.updateSceneConstraints(), this.controls.infinityDolly = !1, this.controls.azimuthRotateSpeed = 1, this.controls.polarRotateSpeed = 1, await this.lookAt(fc, pc, t);
	}
}, hc = {
	Vector2: Fe,
	Vector3: x,
	Vector4: Ie,
	Quaternion: Te,
	Matrix4: y,
	Spherical: Me,
	Box3: a,
	Sphere: b,
	Raycaster: Oe
}, gc = {
	minimum: 0,
	maximum: 0
}, _c = .1, vc = 1, yc = 1, bc = .01, xc = 1e4, Sc = class {
	constructor(e, t) {
		this.clock = new d(), this.sceneBoundingBox = new a(), this.sceneBoundingSphere = new b(), this.animationFrameId = null, this.onLoadingFinished = () => {
			this.updateMode(Fs.CursorOrbital, .5);
		}, this.moveForwardTargetDirection = (e, t = .25) => {
			this.controlMode.moveForwardTargetDirection(e, t);
		}, this.moveSideTargetDirection = (e, t = .25) => {
			this.controlMode.moveSideTargetDirection(e, t);
		}, this._onControlsWake = () => {
			this._viewport.viewer.signals.onCameraMoveStart.emit();
		}, this._onControlsRest = () => {
			this._viewport.viewer.signals.onCameraRest.emit();
		}, this._onControlsSleep = () => {
			this._viewport.viewer.signals.onCameraMoveEnd.emit();
		}, this._onControlsUpdate = () => {
			this._updateNearFarCamera(), this._viewport.viewer.signals.onCameraMove.emit();
		}, this._onControlsUserUpdate = () => {
			this._viewport.viewer.signals.onUserCameraMove.emit();
		}, this.onPointerDown = (e) => {
			this.controlMode.onPointerDown(e);
		}, this.onPointerMove = (e) => {
			this.controlMode.onPointerMove(e);
		}, this.onPointerUp = (e) => {
			this.controlMode.onPointerUp(e);
		}, this.onWheel = (e) => {
			this.controlMode.onWheel(e);
		}, this.startAnimate = () => {
			this.animationFrameId = requestAnimationFrame(this.animate);
		}, this.animate = () => {
			this.animationFrameId = null;
			let e = this.clock.getDelta();
			this.controlMode.controls.update(e) && this._viewport.viewer.requestRender(), this.animationFrameId = requestAnimationFrame(this.animate);
		}, this._updateNearFarCamera = () => {
			if (this.camera.isPerspectiveCamera) {
				if (this.sceneBoundingBox.isEmpty()) return;
				qs(this.camera, this.sceneBoundingBox, gc);
				let e = gc.maximum - gc.minimum, t = Math.max(e * bc, _c), n = this.controlMode.type === Fs.FirstPerson ? vc : _c, r = Math.max(n, gc.minimum - t), i = Math.max(r + yc, gc.maximum + t), a = Math.max(r, i / xc);
				(this.camera.near !== a || this.camera.far !== i) && (this.camera.near = a, this.camera.far = i, this.camera.updateProjectionMatrix());
			}
		}, this.updateSceneBounds = () => {
			this._viewport.viewer.scene.getBoundingBox(this.sceneBoundingBox), this.sceneBoundingBox.getBoundingSphere(this.sceneBoundingSphere), this.controlMode.updateSceneSettings({
				radius: this.sceneBoundingSphere.radius,
				center: this.sceneBoundingSphere.center
			}), this._updateNearFarCamera();
		}, et.install({ THREE: hc }), this._viewport = e;
		let n = new be();
		n.name = "OrthographicCamera", n.near = .1, n.far = 3e3, n.position.set(10, 10, 10);
		let r = new Se();
		r.name = "PerspectiveCamera", r.near = .1, r.far = 3e3, r.position.set(10, 10, 10), this.orthographicControls = new et(n, t), this.perspectiveControls = new et(r, t), this.controlMode = new $s(this._viewport, this.perspectiveControls), this.controlMode.setup(this.controlMode), this.updateSceneBounds(), this._viewport.viewer.signals.onSceneBoundsChanged.connect(this.updateSceneBounds), this._viewport.viewer.signals.onLoadingFinished.connect(this.onLoadingFinished), this.startAnimate();
		let { width: i, height: o } = t.getBoundingClientRect();
		this.resize(i, o), this.setupListeners();
	}
	get camera() {
		return this.controlMode.controls.camera;
	}
	setupListeners() {
		this.controlMode.controls.removeAllEventListeners(), this.controlMode.controls.addEventListener("update", this._onControlsUpdate), this.controlMode.controls.addEventListener("wake", this._onControlsWake), this.controlMode.controls.addEventListener("sleep", this._onControlsSleep), this.controlMode.controls.addEventListener("rest", this._onControlsRest), this.controlMode.controls.addEventListener("control", this._onControlsUserUpdate);
	}
	reset() {
		this.controlMode.controls.reset();
	}
	dispose() {
		this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null), this.controlMode.controls.removeAllEventListeners(), this.controlMode.dispose(), this.orthographicControls.dispose(), this.perspectiveControls.dispose(), this._viewport.viewer.signals.onLoadingFinished.disconnect(this.onLoadingFinished), this._viewport.viewer.signals.onSceneBoundsChanged.disconnect(this.updateSceneBounds);
	}
	set enabled(e) {
		this.controlMode.controls.enabled = e;
	}
	get enabled() {
		return this.controlMode.controls.enabled;
	}
	resize(e, t) {
		let n = e / t, r = this.orthographicControls.camera, i = this.perspectiveControls.camera;
		r.left = 1 * n / -2, r.right = 1 * n / 2, r.top = 1 / 2, r.bottom = 1 / -2, i.aspect = n, this.camera.updateProjectionMatrix();
	}
	lookAt(e, t, n = .25) {
		return this.controlMode.lookAt(e, t, n);
	}
	fitToSphere(e, t = .25) {
		return this.controlMode.fitToSphere(e, t);
	}
	getTarget(e) {
		return this.controlMode.controls.getTarget(e);
	}
	getPosition(e) {
		return this.controlMode.controls.getPosition(e);
	}
	getZoom() {
		return this.controlMode.controls.camera.zoom;
	}
	getDistance() {
		return this.controlMode.controls.distance;
	}
	async updateMode(e, t = .5) {
		let n = {
			radius: this.sceneBoundingSphere.radius,
			center: this.sceneBoundingSphere.center
		};
		if (e === this.controlMode.type) {
			this.controlMode.updateSceneSettings(n);
			return;
		}
		let r = this.controlMode;
		r.controls.removeAllEventListeners(), this.controlMode = e === Fs.FirstPerson ? new ac(this._viewport, this.perspectiveControls, n) : e === Fs.Orbital ? new mc(this._viewport, this.perspectiveControls, n) : e === Fs.CursorOrbital ? new $s(this._viewport, this.perspectiveControls, n) : new dc(this._viewport, this.orthographicControls, n), this.controlMode.controls.stop(), this._viewport.switchCamera(r.controls.camera, this.controlMode.controls.camera), this.setupListeners(), await this.controlMode.setup(r, t), r.dispose(), this._viewport.viewer.signals.onCameraModeChanged.emit();
	}
	async setMode(e, t = .5) {
		e == this.controlMode.type ? this.resetCamera() : this.updateMode(e, t);
	}
	getMode() {
		return this.controlMode.type;
	}
	async zoomTo(e, t = .25) {
		return this.controlMode.zoomTo(e, t);
	}
	zoomIn(e = 5, t = .25) {
		return this.controlMode.zoomIn(e, t);
	}
	zoomOut(e = 5, t = .25) {
		return this.controlMode.zoomOut(e, t);
	}
	async resetCamera(e = 1.5, t = .25) {
		return this.controlMode.reset(e, t);
	}
}, Cc = class {
	constructor(e) {
		this.signals = { onChange: new Re() }, this._items = new Set(e);
	}
	add(e) {
		return this._items.has(e) || (this._items.add(e), this.signals.onChange.emit()), this;
	}
	delete(e) {
		let t = this._items.delete(e);
		return t && this.signals.onChange.emit(), t;
	}
	has(e) {
		return this._items.has(e);
	}
	values() {
		return this._items.values();
	}
	keys() {
		return this._items.keys();
	}
	entries() {
		return this._items.entries();
	}
	[Symbol.iterator]() {
		return this._items[Symbol.iterator]();
	}
};
//#endregion
//#region src/viewport/contextMenu/defaultMenus/ClippingPlaneContextMenuBuilder.ts
function wc(e) {
	let n = [], { hitObject: r, viewer: i } = e;
	return r && r.isClippingPlane && n.push({
		type: "group",
		text: "Clipping Plane",
		items: [{
			type: "action",
			text: t("teiaviewer:context_menu.remove_clipping_plane.text"),
			action: () => {
				new hi(i, r).execute();
			}
		}, {
			type: "action",
			text: t("teiaviewer:context_menu.remove_all_clipping_planes.text"),
			action: () => {
				new gi(i, i.scene.clippingPlaneController).execute();
			}
		}]
	}), n;
}
//#endregion
//#region src/viewport/contextMenu/defaultMenus/MeshContextMenuBuilder.ts
function Tc(e) {
	let n = [], { viewer: r } = e, i = r.scene.objectSelection.length;
	return n.push({
		type: "group",
		text: "Mesh",
		items: [{
			type: "action",
			text: t("teiaviewer:context_menu.isolate.text", { count: i }),
			disabled: r.scene.objectSelection.isEmpty,
			action: () => {
				new ar(r, r.scene.objectSelection.getUuids()).execute();
			}
		}, {
			type: "action",
			text: t("teiaviewer:context_menu.hide.text", { count: i }),
			disabled: r.scene.objectSelection.isEmpty,
			action: () => {
				new cr(r, r.scene.objectSelection.getUuids(), !1).execute();
			}
		}]
	}), n;
}
//#endregion
//#region src/viewport/contextMenu/defaultMenus/SceneContextMenuBuilder.ts
function Ec(e) {
	let n = [], { viewer: r } = e;
	return r.settings.debug.value && n.push({
		type: "group",
		text: "Scene",
		items: [{
			type: "action",
			text: t("teiaviewer:context_menu.clear_scene.text"),
			action: () => {
				new _i(r).execute();
			}
		}]
	}), n;
}
//#endregion
//#region src/viewport/contextMenu/ContextMenuController.ts
var Dc = class {
	constructor(e) {
		this._isOpen = !1, this.builders = new Cc(), this.signals = { onStateChanged: new w() }, this._viewer = e, this.addDefaultContextMenuBuilder();
	}
	addDefaultContextMenuBuilder() {
		this.builders.add(Tc), this.builders.add(wc), this.builders.add(Ec);
	}
	close() {
		this._isOpen && (this._isOpen = !1, this.signals.onStateChanged.emit({
			isOpen: !1,
			x: 0,
			y: 0,
			object: null
		}));
	}
	show(e, t) {
		let n = [], r = {
			viewer: this._viewer,
			hitObject: t
		};
		for (let e of this.builders) {
			let t = e(r);
			for (let e of t) n.push(...Oc(e));
		}
		n.at(-1)?.isDivider && n.pop(), tt.show(n, e);
	}
	get isOpen() {
		return this._isOpen;
	}
};
function Oc(e) {
	return e.hidden ? [] : e.type == "action" ? [e] : e.type == "group" ? [
		{ ...e },
		...e.items.flatMap((e) => Oc(e)),
		{ isDivider: !0 }
	] : [{
		...e,
		subMenu: e.items.flatMap((e) => Oc(e)),
		subMenuAttributes: {}
	}];
}
//#endregion
//#region src/viewport/controllers/RenderModeController.ts
var kc = /* @__PURE__ */ function(e) {
	return e[e.XRay = 0] = "XRay", e[e.Textured = 1] = "Textured", e[e.Wireframe = 2] = "Wireframe", e[e.NoEdges = 3] = "NoEdges", e[e.XRayNoEdges = 4] = "XRayNoEdges", e;
}({}), Ac = class {
	constructor(e) {
		this._viewer = e, this._renderMode = 1;
	}
	get renderMode() {
		return this._renderMode;
	}
	set renderMode(e) {
		e !== this._renderMode && (this._renderMode = e, this._applyOnModeSceneControllers(e), this._viewer.signals.onRenderModeChanged.emit(e));
	}
	_applyOnModeSceneControllers(e) {
		for (let t of this._viewer.scene.controllers) {
			let n = t;
			n.isSceneMeshController && !n.ignoreViewportRenderMode && this.applyRenderModeOnController(e, n);
		}
	}
	applyCurrentRenderModeOnController(e) {
		this.applyRenderModeOnController(this.renderMode, e);
	}
	applyRenderModeOnController(e, t) {
		for (let n of t.getAllObjects()) n.xRay = e === 0 || e === 4;
		switch (e) {
			case 1:
			case 0:
				t.setMeshesVisibility(!0), t.setEdgesVisibility(!0);
				break;
			case 3:
			case 4:
				t.setMeshesVisibility(!0), t.setEdgesVisibility(!1);
				break;
			case 2: t.setMeshesVisibility(!1), t.setEdgesVisibility(!0);
		}
	}
}, jc = /* @__PURE__ */ function(e) {
	return e.x = "X", e.y = "Y", e.z = "Z", e.none = "none", e;
}({}), Mc = /* @__PURE__ */ new x(), Nc = /* @__PURE__ */ new x(), Pc = /* @__PURE__ */ new Te(), Fc = /* @__PURE__ */ new x(), Ic = class {
	constructor(e) {
		this._viewer = e, this._snapMode = "none";
	}
	get snapMode() {
		return this._snapMode;
	}
	setSnapMode(e) {
		if (e !== this._snapMode) {
			switch (this._snapMode = e, this._viewer.scene._snapModeHelper.xLine.visible = !1, this._viewer.scene._snapModeHelper.yLine.visible = !1, this._viewer.scene._snapModeHelper.zLine.visible = !1, e) {
				case "X":
					this._viewer.scene._snapModeHelper.xLine.visible = !0;
					break;
				case "Y":
					this._viewer.scene._snapModeHelper.yLine.visible = !0;
					break;
				case "Z": this._viewer.scene._snapModeHelper.zLine.visible = !0;
			}
			this._viewer.requestRender();
		}
	}
	getNewMatrixWithSnapMode(e, t, n) {
		if (this._snapMode === "none") return n.copy(t);
		switch (Mc.setFromMatrixPosition(t), this._snapMode) {
			case "X":
				Mc.set(Mc.x, e.y, e.z);
				break;
			case "Y":
				Mc.set(e.x, Mc.y, e.z);
				break;
			case "Z":
				Mc.set(e.x, e.y, Mc.z);
				break;
			default: Mc.set(Mc.x, Mc.y, Mc.z);
		}
		return t.decompose(Nc, Pc, Fc), n.compose(Mc, Pc, Fc), this._setHelperPosition(n), n;
	}
	_setHelperPosition(e) {
		this._viewer.scene._snapModeHelper.setLinePosition(e);
	}
}, Lc = class extends A {
	constructor(e) {
		super(e), this.name = "SelectAllVisibleObjectsCommand", this.isUndoable = !1;
		let t = new Qn(e.scene.bimMeshController.getAllVisibleObjects(), !0);
		this.command = new $n(e, t);
	}
	async _do() {
		this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		throw new k(this);
	}
	async _clean() {
		await this.command._clean();
	}
}, Rc = /* @__PURE__ */ new b(), zc = /* @__PURE__ */ new a(), Bc = /* @__PURE__ */ new a(), Vc = class extends A {
	constructor(e, t, n = {}) {
		if (super(e), this.name = "CameraFocusObjectsCommand", this.isUndoable = !0, this._oldPosition = new x(), this._oldTarget = new x(), !e.viewport) throw Error("No Viewport attached to the viewer");
		this._radiusMultiplier = n.radiusMultiplier ?? 1.1, this._duration = n.duration, this._focusedMeshes = [];
		let r = e.scene.getObjectsByUUID(t);
		for (let e of r) {
			let t = e;
			t.isSceneMesh && this._focusedMeshes.push(t);
		}
		this._viewport = e.viewport, this._viewport.cameraControls.getPosition(this._oldPosition), this._viewport.cameraControls.getTarget(this._oldTarget), this._oldZoom = this._viewport.cameraControls.getZoom();
	}
	async _do() {
		if (this.viewer.viewport && this._focusedMeshes.length !== 0) {
			Rc.makeEmpty(), zc.makeEmpty();
			for (let e of this._focusedMeshes) zc.union(e.getBoundingBox(Bc));
			if (!zc.isEmpty()) return zc.getBoundingSphere(Rc), Rc.radius *= this._radiusMultiplier, this.viewer.viewport.cameraControls.fitToSphere(Rc, this._duration);
		}
	}
	async _undo() {
		return new Promise((e) => {
			Promise.all([this._viewport.cameraControls.lookAt(this._oldPosition, this._oldTarget), this._viewport.cameraControls.zoomTo(this._oldZoom)]).then(() => e());
		});
	}
	equals(e) {
		return ir(this._focusedMeshes, e._focusedMeshes);
	}
}, Hc = class extends A {
	constructor(e, t) {
		if (super(e), this.name = "MoveCameraCommand", this.isUndoable = !1, !e.viewport) throw Error("No Viewport attached to the viewer");
		this.viewport = e.viewport, this.options = t;
	}
	async _do() {
		this.viewport.cameraControls.moveForwardTargetDirection(this.options.forwardDistance, this.options.duration), this.viewport.cameraControls.moveSideTargetDirection(this.options.sideDistance, this.options.duration);
	}
	async _undo() {
		this.viewport.cameraControls.moveForwardTargetDirection(-this.options.forwardDistance, this.options.duration), this.viewport.cameraControls.moveSideTargetDirection(-this.options.sideDistance, this.options.duration);
	}
	async update(e, t, n = .25) {
		this.viewport.cameraControls.moveForwardTargetDirection(e, n), this.viewport.cameraControls.moveSideTargetDirection(t, n), this.options.forwardDistance += e, this.options.sideDistance += t;
	}
};
//#endregion
//#region src/utils/webtools.ts
function Uc(e, t) {
	let n = document.createElement("a");
	n.style.display = "none", n.href = e, n.target = "_blank", n.download = t, document.body.appendChild(n), n.click(), setTimeout(() => {
		URL.revokeObjectURL(n.href), n.parentNode?.removeChild(n);
	}, 10);
}
var Wc = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent), Gc = /(Windows)/.test(navigator.userAgent), Kc = (e) => Wc && e.metaKey || e.ctrlKey, qc = [
	"unknown",
	"azerty",
	"qwerty"
], Jc = "unknown", Yc = class e {
	static {
		this.signals = { onLayoutUpdated: new w() };
	}
	static get layout() {
		return Jc;
	}
	static detectKeyboardLayout(t) {
		let n = t.code, r = t.key.toLowerCase(), i = e.layout;
		n === "KeyW" && r === "z" ? i = "azerty" : n === "KeyW" && r === "w" && (i = "qwerty"), i != e.layout && (Jc = i, e.signals.onLayoutUpdated.emit());
	}
	static getKeyCodeValue(e) {
		return this.layout === "azerty" && Xc[e] ? Xc[e] : e.replace("Key", "");
	}
}, Xc = {
	KeyA: "q",
	KeyB: "b",
	KeyC: "c",
	KeyD: "d",
	KeyE: "e",
	KeyF: "f",
	KeyG: "g",
	KeyH: "h",
	KeyI: "i",
	KeyJ: "j",
	KeyK: "k",
	KeyL: "l",
	KeyM: ",",
	KeyN: "n",
	KeyO: "o",
	KeyP: "p",
	KeyQ: "a",
	KeyR: "r",
	KeyS: "s",
	KeyT: "t",
	KeyU: "u",
	KeyV: "v",
	KeyW: "z",
	KeyX: "x",
	KeyY: "y",
	KeyZ: "w"
}, Zc = class {
	constructor(e) {
		this.isToggable = !1, this.enabled = !0, this._binding = e, this._defaultBinding = { ...e };
	}
	setBinding(e) {
		this._binding = e;
	}
	resetDefaultBinding() {
		this._binding = { ...this._defaultBinding };
	}
	getKeyboardShortcutString() {
		let e = this._binding.key;
		return this._binding.useKeycode ? e = Yc.getKeyCodeValue(this._binding.key) : this._binding.key === " " && (e = "␣"), e = e.toUpperCase(), this._binding.shift && (e = `shift+${e}`), this._binding.ctrl && (e = `ctrl+${e}`), this._binding.alt && (e = `alt+${e}`), e;
	}
	matchEvent(e) {
		let { key: t, useKeycode: n = !1, shift: r = !1, ctrl: i = !1, alt: a = !1 } = this._binding, o = !1;
		o = n ? t === e.code : t.toLowerCase() === e.key.toLowerCase();
		let s = e.shiftKey === r, c = e.altKey === a, l;
		return l = Wc ? e.metaKey === i : e.ctrlKey === i, o && s && l && c;
	}
}, Qc = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "history.undo";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.undo.text");
	}
	async execute(e) {
		e.commandHistory.canUndo && e.commandHistory.undoLastCommand();
	}
}, $c = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "history.redo";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.redo.text");
	}
	async execute(e) {
		e.commandHistory.canRedo && e.commandHistory.redoLastCommand();
	}
}, el = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "objects.isolate";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.isolate_selected_objects.text");
	}
	async execute(e) {
		let t = e.scene.objectSelection;
		if (!t.isEmpty) return new ar(e, t.getUuids()).toggle();
	}
}, tl = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "objects.hide";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.hide_selected_objects.text");
	}
	async execute(e) {
		let t = e.scene.objectSelection;
		t.isEmpty || new cr(e, t.getUuids(), !1).toggle();
	}
}, nl = class extends Zc {
	constructor(e, t) {
		super(t), this._cmd = null, this._direction = e;
	}
	get label() {
		switch (this._direction) {
			case "forward": return t("teiaviewer:widgets.shortcuts_widget.shortcuts.move_camera_up.text");
			case "backward": return t("teiaviewer:widgets.shortcuts_widget.shortcuts.move_camera_down.text");
			case "left": return t("teiaviewer:widgets.shortcuts_widget.shortcuts.move_camera_left.text");
			default: return t("teiaviewer:widgets.shortcuts_widget.shortcuts.move_camera_right.text");
		}
	}
	get forwardDistance() {
		return this._direction == "forward" ? 2 : this._direction == "backward" ? -2 : 0;
	}
	get sideDistance() {
		return this._direction == "left" ? -2 : this._direction == "right" ? 2 : 0;
	}
	async execute(e, t) {
		t ? this._cmd?.update(this.forwardDistance, this.sideDistance) : (this._cmd = new Hc(e, {
			forwardDistance: this.forwardDistance,
			sideDistance: this.sideDistance
		}), await this._cmd.execute());
	}
}, rl = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.move_forward";
	}
}, il = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.move_backward";
	}
}, al = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.move_left";
	}
}, ol = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.move_right";
	}
}, sl = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.arrows.move_forward";
	}
}, cl = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.arrows.move_backward";
	}
}, ll = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.arrows.move_left";
	}
}, ul = class extends nl {
	constructor(...e) {
		super(...e), this.action = "camera.arrows.move_right";
	}
}, dl = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "objects.select_all_visible";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.select_all_visible_objects.text");
	}
	async execute(e) {
		await new Lc(e).execute();
	}
}, fl = class extends Zc {
	constructor(...e) {
		super(...e), this.action = "objects.focus";
	}
	get label() {
		return t("teiaviewer:widgets.shortcuts_widget.shortcuts.focus_selected_objects.text");
	}
	async execute(e) {
		let t = e.scene.objectSelection;
		return new Vc(e, t.getUuids()).toggle();
	}
}, pl = /* @__PURE__ */ new Set([
	"shift",
	"control",
	"alt",
	"meta"
]), ml = [
	new el({ key: " " }),
	new tl({
		shift: !0,
		key: " "
	}),
	new Qc({
		ctrl: !0,
		key: "z"
	}),
	new $c({
		shift: !0,
		ctrl: !0,
		key: "z"
	}),
	new rl("forward", {
		useKeycode: !0,
		key: "KeyW"
	}),
	new il("backward", {
		useKeycode: !0,
		key: "KeyS"
	}),
	new al("left", {
		useKeycode: !0,
		key: "KeyA"
	}),
	new ol("right", {
		useKeycode: !0,
		key: "KeyD"
	}),
	new sl("forward", { key: "ArrowUp" }),
	new cl("backward", { key: "ArrowDown" }),
	new ll("left", { key: "ArrowLeft" }),
	new ul("right", { key: "ArrowRight" }),
	new dl({
		ctrl: !0,
		key: "a"
	}),
	new fl({ key: "f" })
], hl = class {
	constructor(e) {
		this._shortcuts = /* @__PURE__ */ new Map(), this._holdingKeys = /* @__PURE__ */ new Set(), this._lastShortcut = null, this._lastShortcutInterval = null, this.signals = { onShortcutsChanged: new Re() }, this._onKeyDown = (e) => {
			Yc.detectKeyboardLayout(e);
			let t = e.key.toLowerCase(), n = this._holdingKeys.has(t);
			if (pl.has(t) || this._holdingKeys.add(t), this._holdingKeys.size !== 1) return;
			let r = this._getMatchingShortcut(e);
			if (r && this._canExecuteShortcut(e)) {
				C.info("Executing shortcut", r.action);
				let t = this._lastShortcut === r, i = n && t;
				r.execute(this._viewer, i), this._lastShortcut = r, e.preventDefault();
			}
		}, this._getMatchingShortcut = (e) => {
			for (let t of this._shortcuts.values()) if (t.enabled && t.matchEvent(e)) return t;
			return null;
		}, this._onKeyUp = (e) => {
			this._holdingKeys.delete(e.key.toLowerCase()), this._canExecuteShortcut(e) && this._holdingKeys.size > 0 ? this._simulateKeyHold(this._holdingKeys.values().next().value) : this._stopKeyHold();
		}, this._reset = () => {
			this._holdingKeys.clear(), this._stopKeyHold();
		}, this._simulateKeyHold = (e, t) => {
			this._stopKeyHold(), this._lastShortcutInterval = setInterval(() => {
				dispatchEvent(new KeyboardEvent("keydown", {
					key: e,
					code: t
				}));
			}, 50);
		}, this._stopKeyHold = () => {
			this._lastShortcutInterval && clearInterval(this._lastShortcutInterval);
		}, this._viewer = e;
		for (let e of ml) this.addShortcut(e);
		addEventListener("keydown", this._onKeyDown), addEventListener("keyup", this._onKeyUp), addEventListener("focus", this._reset), addEventListener("blur", this._reset), document.addEventListener("visibilitychange", this._reset);
	}
	dispose() {
		removeEventListener("keydown", this._onKeyDown), removeEventListener("keyup", this._onKeyUp), removeEventListener("focus", this._reset), removeEventListener("blur", this._reset), document.removeEventListener("visibilitychange", this._reset);
	}
	get shortcuts() {
		return this._shortcuts.values();
	}
	_canExecuteShortcut(e) {
		return !(["INPUT", "TEXTAREA"].includes(e.target?.nodeName) || !document.hasFocus());
	}
	addShortcut(e) {
		if (this._shortcuts.has(e.action)) throw Error(`A shortcut already exists for the type ${e.action}`);
		this._shortcuts.set(e.action, e), this.signals.onShortcutsChanged.emit();
	}
	removeShortcut(e) {
		let t = this._shortcuts.delete(e.action);
		return t && this.signals.onShortcutsChanged.emit(), t;
	}
	enableShortcut(e, t = !0) {
		let n = this._shortcuts.get(e);
		if (!n) {
			console.warn(`There is not shortcut associated to the action ${e}`);
			return;
		}
		n.enabled = t;
	}
	setBinding(e, t) {
		let n = this._shortcuts.get(e);
		if (!n) {
			console.warn(`There is not shortcut associated to the action ${e}`);
			return;
		}
		n.setBinding(t);
	}
}, gl = class extends A {
	constructor(e) {
		super(e), this.name = "ClearSelectionCommand", this.isUndoable = !1, this.command = new $n(e, []);
	}
	async _do() {
		this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		throw new k(this);
	}
	async _clean() {
		this.command._clean();
	}
}, _l = class {
	constructor(e) {
		this.needsValidation = !1, this.stopCameraControlOnDrag = !1, this._viewport = e;
	}
	initialize() {}
	onPointerDown(e) {}
	onPointerDrag(e) {}
	onPointerMove(e) {}
	onPointerUp(e) {}
	onPointerClick(e) {
		let t = this._viewport.raycaster.raycastEvent(e, { raycastTransparentMeshes: e.shiftKey }), n = t.length > 0 ? t[0].object : null;
		e.button === 0 && n ? this._viewport.viewer.signals.onObjectClicked.emit(n) : e.button === 2 && this.showContextMenu(e, n);
	}
	onPointerDoubleClick(e) {
		let t = this._viewport.raycaster.raycastEvent(e, { raycastTransparentMeshes: e.shiftKey }), n = t.length > 0 ? t[0].object : null;
		e.button === 0 && n && this._viewport.viewer.signals.onObjectDoubleClicked.emit(n);
	}
	onKeyDown(e) {
		e.key == "Escape" && this.cancel();
	}
	onKeyUp(e) {}
	showContextMenu(e, t) {
		this._viewport.contextMenuController.show(e, t);
	}
	validate() {}
	cancel() {}
	dispose() {}
}, vl = class extends _l {
	constructor(...e) {
		super(...e), this.name = "RaycastSelectOperator", this.isRaycastSelectOperator = !0, this._continuousSelectionMode = null;
	}
	initialize() {
		super.initialize();
	}
	dispose() {
		super.dispose();
	}
	onPointerDown(e) {
		let t = this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: e.shiftKey,
			filterFunc: this._viewport.interactionController.isObjectRaycastable
		});
		this.sortIntersects(t), Kc(e) && t.length > 0 && this._onObjectClickedDown(t[0].object);
	}
	onPointerDrag(e) {
		if (this._continuousSelectionMode != null && Kc(e)) {
			let t = this._viewport.raycaster.raycastEvent(e, {
				raycastTransparentMeshes: e.shiftKey,
				filterFunc: this._viewport.interactionController.isObjectRaycastable
			});
			this.sortIntersects(t), t.length > 0 && this._onObjectDrag(t[0].object);
		}
	}
	onPointerUp(e) {
		this.stopCameraControlOnDrag = !1, this._continuousSelectionMode = null;
	}
	onPointerClick(e) {
		if (e.button === 0) {
			let t = Kc(e), n = this._viewport.raycaster.raycastEvent(e, {
				raycastTransparentMeshes: e.shiftKey,
				filterFunc: this._viewport.interactionController.isObjectRaycastable
			});
			this.sortIntersects(n), n.length > 0 ? this._onObjectClicked(n[0].object, t) : t || this._resetCurrentInteraction();
		}
		super.onPointerClick(e);
	}
	onPointerDoubleClick(e) {
		let t = this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: e.shiftKey,
			filterFunc: this._viewport.interactionController.isObjectRaycastable
		});
		this.sortIntersects(t), t.length > 0 && this._viewport.viewer.signals.onObjectDoubleClicked.emit(t[0].object);
	}
	_onObjectClickedDown(e) {
		let t = e;
		t?.isSceneMesh ? (this._continuousSelectionMode = +!!this._viewport.viewer.scene.objectSelection.hasObject(t), this.stopCameraControlOnDrag = !0) : this._continuousSelectionMode = null;
	}
	_onObjectDrag(e) {
		let t = e;
		if (t?.isSceneMesh) {
			let e = new Set(this._viewport.viewer.scene.objectSelection.getUuids());
			switch (this._continuousSelectionMode) {
				case 0:
					e.add(t.uuid);
					break;
				case 1: e.delete(t.uuid);
			}
			new $n(this._viewport.viewer, e).execute();
		}
	}
	_onObjectClicked(e, t) {
		let n = e;
		n.isSceneSprite ? this._onSceneSpriteClicked(n, t) : this._onAnyObjectClicked(e, t), this._viewport.viewer.signals.onObjectClicked.emit(e);
	}
	_onAnyObjectClicked(e, t) {
		if (!this._viewport.interactionController.isObjectSelectable(e)) return;
		let n;
		if (t) {
			let t = new Set(this._viewport.viewer.scene.objectSelection.getUuids());
			t.has(e.uuid) ? t.delete(e.uuid) : t.add(e.uuid), n = Array.from(t);
		} else n = [e.uuid];
		if (new $n(this._viewport.viewer, n).execute(), this._viewport.interactionController.isObjectTransformable(e)) {
			let e = this._viewport.viewer.scene.getObjectsByUUID(n);
			this._viewport.transformController.attachObjects(e);
		} else this._viewport.transformController.detachObjects();
		this._viewport.viewer.requestRender();
	}
	_onSceneSpriteClicked(e, t) {
		t || (this._resetCurrentInteraction(), this._viewport.viewer.signals.onSpriteClicked.emit(e.uuid), e.clickCallback?.());
	}
	_resetCurrentInteraction() {
		this._viewport.transformController.detachObjects(), this._viewport.viewer.scene.objectSelection.isEmpty || new gl(this._viewport.viewer).execute(), this._viewport.viewer.requestRender();
	}
	sortIntersects(e) {
		e.sort((e, t) => {
			let n = e.object, r = t.object;
			return n.isSceneSprite && n.isAlwaysVisible && (!r.isSceneSprite || !r.isAlwaysVisible) ? -1 : r.isSceneSprite && r.isAlwaysVisible && (!n.isSceneSprite || !n.isAlwaysVisible) ? 1 : e.distance - t.distance;
		});
	}
	cancel() {}
}, yl = /* @__PURE__ */ new Fe(), bl = /* @__PURE__ */ new Fe(), xl = () => !0, Sl = {
	raycastTransparentMeshes: !0,
	keepOnlyClosestLine: !0
}, Cl = class {
	constructor(e) {
		this._intersectionCache = /* @__PURE__ */ new Map(), this._raycaster = new Oe(), this._resetCache = () => {
			this._intersectionCache.clear();
		}, this._viewport = e, this._viewport.viewer.signals.onCameraMove.connect(this._resetCache);
	}
	_getCacheIntersections(e) {
		let t = `${e.offsetX}-${e.offsetY}`;
		return this._intersectionCache.get(t);
	}
	_setCacheIntersections(e, t) {
		let n = `${e.offsetX}-${e.offsetY}`, r = this._intersectionCache;
		if (r.has(n) && r.delete(n), r.set(n, t), r.size > 30) {
			let e = r.keys().next().value;
			e && r.delete(e);
		}
	}
	dispose() {
		this._viewport.viewer.signals.onCameraMove.disconnect(this._resetCache);
	}
	raycastEvent(e, t = {}) {
		let n = this._getCacheIntersections(e);
		return n || (n = this._raycastEvent(e), this._setCacheIntersections(e, n)), this._filterIntersections(n, t);
	}
	_raycastEvent(e) {
		return yl.set(e.offsetX, e.offsetY), this._raycast(yl);
	}
	_filterIntersections(e, t = {}) {
		let { filterFunc: n = xl, keepOnlyClosestLine: r, raycastTransparentMeshes: i } = {
			...Sl,
			...t
		}, a = [], o;
		for (let t of e) {
			o = !1;
			let e = t.object;
			e.isSceneMesh && (o = e.isTransparent && !i);
			let r = e;
			for (; r._isInMeshGroup;) z(r.parent, "Mesh is in MeshGroup but does not have a parent"), r = r.parent;
			t.object = r, !o && n(t.object) && a.push(t);
		}
		return r && (a = Tl(a)), a;
	}
	_raycast(e) {
		this._setupRaycaster(e);
		let t = this._viewport.viewer.scene.raycastBoxTree(this._raycaster.ray, .5);
		t = t.filter((e) => e.object.visible && e.object.isRaycastable);
		let n = [];
		for (let e of t) this._raycastObject(e.object, n);
		return n.sort((e, t) => e.distance - t.distance), n;
	}
	_setupRaycaster(e) {
		let t = this._viewport.canvas;
		bl.set(e.x / t.clientWidth * 2 - 1, -(e.y / t.clientHeight) * 2 + 1), this._raycaster.setFromCamera(bl, this._viewport.camera);
	}
	_raycastObject(e, t) {
		let n = e;
		n.isSceneMesh ? this._raycastMesh(n, t) : e.raycast(this._raycaster, t, this._viewport.viewer.settings.raycast.marginError.value);
	}
	_raycastMesh(e, t) {
		let n = [];
		e.raycast(this._raycaster, n, this._viewport.viewer.settings.raycast.marginError.value);
		for (let e of n) wl(e, this._viewport.viewer.scene.clippingPlaneController.planes()) || t.push(e);
	}
};
function wl(e, t) {
	let n = !1, r = t.next();
	for (; !n && !r.done;) n = r.value.distanceToPoint(e.point) <= 0, r = t.next();
	return n && !e.object.isClippingPlane;
}
function Tl(e) {
	let t = [], n = Infinity, r = null;
	for (let i of e) i.object.isSceneLineProxy && i.rayDistance < n ? (r = i, n = i.rayDistance) : t.push(i);
	return r && t.push(r), t;
}
//#endregion
//#region src/viewport/render/RenderComposer.ts
var El = class {
	constructor(e, t, n, r) {
		this._composer = new at(e), this._maxSamples = e.capabilities.maxSamples, this._renderPass = new st(n, r), this._composer.addPass(this._renderPass), this._n8AOPass = new rt(n, r, e.domElement.clientWidth, e.domElement.clientHeight), this._composer.addPass(this._n8AOPass), this._aaPass = new ot(r, new ct({ preset: lt.ULTRA })), this._composer.addPass(this._aaPass);
		let i = new it();
		i.renderToScreen = !0, this._composer.addPass(i), this.updateFromSettings(t);
	}
	updateFromSettings(e) {
		this._aaPass.enabled = e.ao.enableAA.value;
		let t = e.ao.enableMSAA.value ? Math.min(e.ao.msaaSamples.value, this._maxSamples) : 0;
		this._composer.multisampling !== t && (this._composer.multisampling = t), this._n8AOPass.enabled = e.ao.enableAO.value, this._n8AOPass.setQualityMode(e.ao.quality.value), this._n8AOPass.configuration.aoRadius = e.ao.aoRadius.value, this._n8AOPass.configuration.color = new f(e.ao.color.value), this._n8AOPass.configuration.distanceFalloff = e.ao.distanceFalloff.value, this._n8AOPass.configuration.intensity = e.ao.intensity.value, this._n8AOPass.configuration.denoiseRadius = e.ao.denoiseRadius.value, this._n8AOPass.configuration.denoiseSamples = e.ao.denoiseSamples.value, this._n8AOPass.configuration.depthAwareUpsampling = e.ao.depthAwareUpsampling.value, this._n8AOPass.configuration.halfRes = e.ao.halfRes.value, this._n8AOPass.configuration.aoSamples = e.ao.aoSamples.value, this._n8AOPass.configuration.transparencyAware = e.ao.transparencyAware.value;
	}
	set aoEnabled(e) {
		this._n8AOPass.enabled = e;
	}
	get aoEnabled() {
		return this._n8AOPass.enabled;
	}
	setCamera(e) {
		this._composer.setMainCamera(e);
	}
	render(e) {
		this._composer.render(e);
	}
	dispose() {
		this._composer.dispose?.();
	}
	setSize(e, t) {
		this._composer.setSize(e, t, !1);
	}
}, Dl = [...mn], Ol = Dl.indexOf(pn.Base);
Dl.splice(Ol, 1);
var kl = class {
	constructor(e, t, n, r) {
		this.signals = { frameHasRendered: new w() }, this._isFrameRequested = !1, this._isAnimating = !1, this._targetRenderWidth = 0, this._targetRenderHeight = 0, this._needResize = !0, this._clock = new d(), this._framePerformanceTracker = new Al(), this._camera = e, this._scene = t, this._settings = n, this._camera.layers.enable(pn.AlwaysVisible), this._webGLRenderer = new Le({
			canvas: r,
			antialias: !0,
			powerPreference: n.renderer.powerPreference.value
		}), this._webGLRenderer.info.autoReset = !1, this._webGLRenderer.localClippingEnabled = !0, this._webGLRenderer.autoClear = !1, this._webGLRenderer.autoClearColor = !1;
		let i = new xe(this._webGLRenderer);
		i.compileEquirectangularShader(), t._internalScene.environment = i.fromScene(new nt()).texture, t._internalScene.environmentIntensity = .5, this.info = {
			...this._webGLRenderer.info,
			frametime: 0,
			renderTime: 0,
			fps: 0
		}, this._composer = new El(this._webGLRenderer, n, t._internalScene, e), this._clock.start(), this.requestAnimationFrame();
	}
	get canvas() {
		return this._webGLRenderer.domElement;
	}
	get maxTextureSize() {
		return this._webGLRenderer.capabilities.maxTextureSize;
	}
	updateFromSettings(e) {
		this._composer.updateFromSettings(e);
	}
	setCamera(e) {
		this._camera = e, this._composer.setCamera(e);
	}
	resize(e, t) {
		this._webGLRenderer.setPixelRatio(window.devicePixelRatio), this._targetRenderWidth = e, this._targetRenderHeight = t, this._needResize = !0, this.requestAnimationFrame();
	}
	forceResize() {
		this._needResize = !0, this.requestAnimationFrame();
	}
	dispose() {
		this._isAnimating = !1, this._composer.dispose(), this._webGLRenderer.dispose();
	}
	startAnimate() {
		this._isAnimating = !0, this.requestAnimationFrame();
	}
	stopAnimate() {
		this._isAnimating = !1;
	}
	requestAnimationFrame() {
		this._isAnimating || this._isFrameRequested || (this._isFrameRequested = !0, requestAnimationFrame(() => this.animationFrameCallback()));
	}
	animationFrameCallback() {
		this._framePerformanceTracker.begin(), this._isFrameRequested = !1, this.renderFrame(), this.signals.frameHasRendered.emit(), this._framePerformanceTracker.end(), this.info.frametime = this._framePerformanceTracker.frametime, this.info.fps = this._framePerformanceTracker.fps, this._isAnimating && requestAnimationFrame(() => this.animationFrameCallback());
	}
	copyTextureToTexture(e, t, n = null, r = null, i = 0, a = 0) {
		this._webGLRenderer.copyTextureToTexture(e, t, n, r, i, a);
	}
	renderFrame() {
		let e = this._clock.getDelta(), t = this._scene._internalScene, n = this._camera;
		if (this._needResize) {
			let e = this._settings.render.resolutionScaling.value;
			this._webGLRenderer.setSize(this._targetRenderWidth * e, this._targetRenderHeight * e, !1), this._composer.setSize(this._targetRenderWidth * e, this._targetRenderHeight * e), this._needResize = !1;
		}
		let r = performance.now();
		this._webGLRenderer.info.reset(), this._webGLRenderer.clear(), n.layers.set(pn.Base), this._composer.render(e);
		for (let e of Dl) n.layers.set(e), this._webGLRenderer.render(t, n);
		let i = performance.now();
		Object.assign(this.info, this._webGLRenderer.info), this.info.renderTime = i - r;
	}
}, Al = class {
	constructor() {
		this.beginTime = performance.now(), this.prevTime = 0, this.frames = 0, this.frametime = 0, this.fps = 0;
	}
	begin() {
		this.beginTime = performance.now();
	}
	end() {
		this.frames++;
		let e = performance.now();
		return this.frametime = e - this.beginTime, e >= this.prevTime + 1e3 && (this.fps = this.frames * 1e3 / (e - this.prevTime), this.prevTime = e, this.frames = 0), e;
	}
	update() {
		this.beginTime = this.end();
	}
}, jl = new y();
function Ml(e, t, n) {
	return jl.copy(t).invert(), n.multiplyMatrices(jl, e), n;
}
function Nl(e, t, n) {
	return n.multiplyMatrices(t, e), n;
}
//#endregion
//#region src/viewport/transform/TransformGroup.ts
var Pl = /* @__PURE__ */ new y(), Fl = /* @__PURE__ */ new a(), Il = /* @__PURE__ */ new a(), Ll = /* @__PURE__ */ new x(), Rl = class extends ye {
	constructor(e = "Center") {
		super(), this.isGroupTransform = !0, this.sceneObjects = [], this._childrenLocalMatrices = /* @__PURE__ */ new Map(), this._childrenWorldMatrices = /* @__PURE__ */ new Map(), this._transformPivotPoint = e;
	}
	get firstChild() {
		return this.sceneObjects[0];
	}
	get transformPivotPoint() {
		return this._transformPivotPoint;
	}
	set transformPivotPoint(e) {
		this._transformPivotPoint = e, this.setup();
	}
	addObject(e) {
		this.sceneObjects.push(e);
	}
	removeObject(e) {
		this.sceneObjects.remove(e);
	}
	setup() {
		this.position.set(0, 0, 0), this.quaternion.identity(), this.scale.set(1, 1, 1), this._getBoundingBox(Il), this._transformPivotPoint === "Center" ? Il.getCenter(Ll) : this._transformPivotPoint === "Min" ? Ll.copy(Il.min) : this._transformPivotPoint === "Max" && Ll.copy(Il.max), Pl.makeTranslation(Ll.x, Ll.y, Ll.z), this.applyMatrix4(Pl);
		for (let e of this.sceneObjects) this._setupLocalMatrix(e);
	}
	update() {
		this._computeChildrenWorldMatrices(), this.sceneObjects.forEach((e) => {
			let t = this._childrenWorldMatrices.get(e.uuid);
			t && e.setMatrix(t);
		});
	}
	getWorldMatrix(e) {
		return this._childrenWorldMatrices.get(e);
	}
	reset() {
		this.sceneObjects.clear(), this._childrenLocalMatrices.clear(), this._childrenWorldMatrices.clear();
	}
	_computeChildrenWorldMatrices() {
		for (let e of this.sceneObjects) {
			let t = this._childrenWorldMatrices.get(e.uuid) ?? new y(), n = this._getChildWorldMatrix(e.uuid, t);
			this._childrenWorldMatrices.set(e.uuid, n);
		}
	}
	_getChildWorldMatrix(e, t) {
		let n = this._childrenLocalMatrices.get(e);
		if (!n) throw Error(`Child ${e} not found`);
		return Nl(n, this.matrix, t);
	}
	_setupLocalMatrix(e) {
		let t = e.uuid, n = Ml(e.getMatrix(Pl), this.matrix, new y());
		this._childrenLocalMatrices.set(t, n);
	}
	_getBoundingBox(e) {
		e.makeEmpty();
		for (let t of this.sceneObjects) {
			let n = t;
			n.isSceneMesh && (n.getBoundingBox(Fl), e.union(Fl));
		}
		return e;
	}
}, zl = class {
	constructor(e, t, n) {
		this._viewer = e, this._canTranslate = !0, this._canRotate = !0, this._canScale = !0, this.signals = { onTransformGizmoUpdated: new w() }, this._lastTimeoutOnObjectsMove = null, this.onObjectsMoved = () => {
			this._lastTimeoutOnObjectsMove && clearTimeout(this._lastTimeoutOnObjectsMove), this._lastTimeoutOnObjectsMove = setTimeout(() => {
				this._transformGroup.setup(), this._lastTimeoutOnObjectsMove = null, this._viewer.requestRender();
			}, 5);
		}, this._onCameraModeChanged = () => {
			this._viewer.viewport && (this._controls.camera = this._viewer.viewport.camera);
		}, this._onMouseDown = () => {
			this._viewer.viewport && (this._viewer.viewport.cameraControls.enabled = !1);
		}, this._onMouseUp = () => {
			if (!this._viewer.viewport) return;
			this._viewer.viewport.cameraControls.enabled = !0, this._transformGroup.update();
			let e = [];
			for (let t of this._transformGroup.sceneObjects) {
				let n = this._transformGroup.getWorldMatrix(t.uuid);
				n && e.push(new fr(this._viewer, t.uuid, n));
			}
			let t = new pi(this._viewer, e);
			t.isUndoable = !0, t.execute(), this._viewer.requestRender();
		}, this._onObjectChange = () => {
			this._transformGroup.update(), this._viewer.requestRender();
		}, this._controls = new ut(t, n), this._transformGroup = new Rl(this._viewer.settings.objects.pivotPoint.value), this._transformGroup.name = "TransformGroup", this._gizmoHelper = this._controls.getHelper(), this._gizmoHelper.name = "TransformControls", this._gizmoHelper.traverse((e) => {
			e.layers.set(pn.Tool);
		}), this._controls.getRaycaster().layers.set(pn.Tool), this.addToScene(), this.setMode("translate"), this._setup();
	}
	get canRotate() {
		return this._canRotate;
	}
	get canTranslate() {
		return this._canTranslate;
	}
	get canScale() {
		return this._canScale;
	}
	get mode() {
		return this._controls.getMode();
	}
	isObjectAttached(e) {
		return this._transformGroup.sceneObjects.includes(e);
	}
	addToScene() {
		this._viewer.scene.addInternalObject(this._gizmoHelper), this._viewer.scene.addInternalObject(this._transformGroup);
	}
	setMode(e) {
		e !== this._controls.mode && (this._controls.setMode(e), this.attachObjects());
	}
	dispose() {
		this._controls.removeEventListener("mouseDown", this._onMouseDown), this._controls.removeEventListener("mouseUp", this._onMouseUp), this._controls.removeEventListener("objectChange", this._onObjectChange), this._viewer.signals.onCameraModeChanged.disconnect(this._onCameraModeChanged), this._viewer.signals.onObjectsMoved.disconnect(this.onObjectsMoved), this._controls.dispose(), this._viewer.scene.removeInternalObject(this._gizmoHelper), this._viewer.scene.removeInternalObject(this._transformGroup);
	}
	detachObjects() {
		this._detachAll(), this._viewer.signals.onObjectsTransformDetached.emit();
	}
	_detachAll() {
		this._transformGroup.reset(), this._controls.detach();
	}
	setPivotPoint(e) {
		this._transformGroup.transformPivotPoint = e, this._viewer.requestRender();
	}
	attachObjects(e) {
		e && this._detachAll();
		let t = {
			translate: {
				x: !0,
				y: !0,
				z: !0
			},
			rotate: {
				x: !0,
				y: !0,
				z: !0
			},
			scale: {
				x: !0,
				y: !0,
				z: !0
			}
		}, n = !0, r = e ?? this._transformGroup.sceneObjects;
		for (let i of r) {
			n = !1;
			let r = this._viewer.scene.getControllerForObject(i), a = i.transformConfig;
			i.isTransformable && i.visible && r?.visible && (a.rotate || a.translate || a.scale) && (e && (this._viewer.objectStateHistory.initializeState(i), this._transformGroup.addObject(i)), t.translate.x &&= a.translate.x, t.translate.y &&= a.translate.y, t.translate.z &&= a.translate.z, t.rotate.x &&= a.rotate.x, t.rotate.y &&= a.rotate.y, t.rotate.z &&= a.rotate.z, t.scale.x &&= a.scale.x, t.scale.y &&= a.scale.y, t.scale.z &&= a.scale.z);
		}
		if (n) return;
		this._transformGroup.setup(), this._controls.attach(this._transformGroup);
		let i = t[this._controls.mode];
		i && (this._canRotate = Object.values(t.rotate).includes(!0), this._canScale = Object.values(t.scale).includes(!0), this._canTranslate = Object.values(t.translate).includes(!0), {
			translate: this._canTranslate,
			rotate: this._canRotate,
			scale: this._canScale
		}[this._controls.mode] || (this._canTranslate ? this.setMode("translate") : this._canRotate ? this.setMode("rotate") : this._canScale && this.setMode("scale")), this._controls.showX = i.x, this._controls.showY = i.y, this._controls.showZ = i.z, e && this._viewer.signals.onObjectsTransformAttached.emit(), this.signals.onTransformGizmoUpdated.emit(this._controls.mode));
	}
	_setup() {
		this._controls.addEventListener("mouseDown", this._onMouseDown), this._controls.addEventListener("mouseUp", this._onMouseUp), this._controls.addEventListener("objectChange", this._onObjectChange), this._viewer.signals.onCameraModeChanged.connect(this._onCameraModeChanged), this._viewer.signals.onObjectsMoved.connect(this.onObjectsMoved);
	}
}, Bl = class {
	constructor(e, t) {
		this._isDragging = !1, this._isPressing = !1, this._lastClickTime = Date.now(), this._startPointerX = 0, this._startPointerY = 0, this._maxPointerDx = 0, this._maxPointerDy = 0, this._onCanvasResize = () => {
			let { width: e, height: t } = this.canvas.getBoundingClientRect();
			(this.canvas.width != e || this.canvas.height != t) && (this.renderer.resize(e, t), this.cameraControls.resize(e, t));
		}, this.preventDefaultZoomWheel = (e) => {
			e.ctrlKey && (e.preventDefault(), e.stopPropagation());
		}, this.preventDefault = (e) => {
			e.preventDefault(), e.stopPropagation();
		}, this.onWheel = (e) => {
			this.cameraControls.onWheel(e);
		}, this.onPointerDown = (e) => {
			this.cameraControls.onPointerDown(e), document.getSelection()?.empty(), this.cameraControls.enabled = !this.contextMenuController.isOpen, this.canSendPointerEventToOperator() && this._operator.onPointerDown(e), this._isPressing = !0, this._startPointerX = e.clientX, this._startPointerY = e.clientY, this._maxPointerDx = 0, this._maxPointerDy = 0;
		}, this.onPointerMove = (e) => {
			this.cameraControls.onPointerMove(e), this.cameraControls.enabled = !this._operator.stopCameraControlOnDrag, this._isDragging = this._isPressing, this.canSendPointerEventToOperator() && (this._operator.onPointerMove(e), this._isDragging && this._operator.onPointerDrag(e)), this._maxPointerDx = Math.max(this._maxPointerDx, Math.abs(e.clientX - this._startPointerX)), this._maxPointerDy = Math.max(this._maxPointerDy, Math.abs(e.clientY - this._startPointerY));
		}, this.onPointerUp = (e) => {
			if (this.cameraControls.onPointerUp(e), this._isPressing) {
				if (this.canSendPointerEventToOperator() && this._operator.onPointerUp(e), !(this._maxPointerDx > 2 || this._maxPointerDy > 2)) {
					let t = this.viewer.settings.doubleClickDelay.value, n = Date.now();
					n - this._lastClickTime < t ? this.onPointerDoubleClick(e) : this.onPointerClick(e), this._lastClickTime = n;
				}
				this._isDragging = !1, this._isPressing = !1;
			}
		}, this.onPointerClick = (e) => {
			this.canSendPointerEventToOperator() && this._operator.onPointerClick(e);
		}, this.onPointerDoubleClick = (e) => {
			this.canSendPointerEventToOperator() && this._operator.onPointerDoubleClick(e);
		}, this.onKeyDown = (e) => {
			this.canSendKeyboardEventToOperator(e) && this._operator.onKeyDown(e);
		}, this.onKeyUp = (e) => {
			this.canSendKeyboardEventToOperator(e) && this._operator.onKeyUp(e);
		}, this.onContextMenu = (e) => {
			e.preventDefault();
		}, this.viewer = e, this.renderModeController = new Ac(e), this.cameraControls = new Sc(this, t), this.transformController = new zl(e, this.camera, t), this.shortcutController = new hl(e), this.contextMenuController = new Dc(e), this.interactionController = new Ns(this), this.snapModeController = new Ic(e), this.renderer = new kl(this.camera, e.scene, e.settings, t), this.raycaster = new Cl(this);
		let n = new vl(this);
		this._operator = n, this.defaultOperator = n, this.cameraLight = new m(16777215, 2), this._setLights(), this._addEventListeners(), this.setup(), this.renderer.requestAnimationFrame(), this._onCanvasResize(), this._canvasResizeObserver = new ResizeObserver(this._onCanvasResize), this._canvasResizeObserver.observe(this.canvas);
	}
	_setLights() {
		this.cameraLight.name = "CameraLight";
		for (let e of mn) this.cameraLight.layers.enable(e);
	}
	_addEventListeners() {
		this.canvas.addEventListener("pointerdown", this.onPointerDown), this.canvas.addEventListener("pointermove", this.onPointerMove), this.canvas.addEventListener("wheel", this.onWheel, { capture: !0 }), this.canvas.addEventListener("pointerup", this.onPointerUp), this.canvas.addEventListener("keydown", this.onKeyDown), this.canvas.addEventListener("keyup", this.onKeyUp), this.canvas.addEventListener("contextmenu", this.onContextMenu), document.addEventListener("gesturestart", this.preventDefault), document.addEventListener("gesturechange", this.preventDefault), document.addEventListener("gestureend", this.preventDefault), document.addEventListener("wheel", this.preventDefaultZoomWheel, {
			capture: !0,
			passive: !1
		});
	}
	_removeEventListeners() {
		this.canvas.removeEventListener("pointerdown", this.onPointerDown), this.canvas.removeEventListener("pointermove", this.onPointerMove), this.canvas.removeEventListener("wheel", this.onWheel, { capture: !0 }), this.canvas.removeEventListener("pointerup", this.onPointerUp), this.canvas.removeEventListener("keydown", this.onKeyDown), this.canvas.removeEventListener("keyup", this.onKeyUp), this.canvas.removeEventListener("contextmenu", this.onContextMenu), document.removeEventListener("gesturestart", this.preventDefault), document.removeEventListener("gesturechange", this.preventDefault), document.removeEventListener("gestureend", this.preventDefault), document.removeEventListener("wheel", this.preventDefaultZoomWheel, { capture: !0 });
	}
	get camera() {
		return this.cameraControls.camera;
	}
	get canvas() {
		return this.renderer.canvas;
	}
	setup() {
		this.camera.add(this.cameraLight), this.viewer.scene.addInternalObject(this.camera);
	}
	switchCamera(e, t) {
		this.viewer.scene.removeInternalObject(e), this.viewer.scene.addInternalObject(t), this.renderer.setCamera(t), this.camera.add(this.cameraLight);
	}
	clear() {
		this.resetDefaultOperator(), this.cameraControls.reset(), this.setup();
	}
	dispose() {
		this._removeEventListeners(), this._operator.dispose(), this.raycaster.dispose(), this.renderer.dispose(), this.camera.removeFromParent(), this.cameraControls.dispose(), this.transformController.dispose(), this.shortcutController.dispose(), this._canvasResizeObserver.unobserve(this.canvas);
	}
	get operator() {
		return this._operator;
	}
	setOperator(e) {
		this._operator && this._operator.dispose(), this._operator = e, this._operator.initialize(), this.viewer.signals.onOperatorChanged.emit(this._operator);
	}
	resetDefaultOperator() {
		this.setOperator(this.defaultOperator);
	}
	canSendPointerEventToOperator() {
		return !this.contextMenuController.isOpen;
	}
	canSendKeyboardEventToOperator(e) {
		return !this.contextMenuController.isOpen;
	}
}, Vl = class {
	constructor() {
		this.onLoadingStarted = new w(), this.onLoadingProgress = new w(), this.onLoadingFinished = new w(), this.onLoadingError = new w(), this.onObjectSelectionChanged = new w(), this.onSpriteClicked = new w(), this.onViewportAdded = new w(), this.onViewportRemoved = new w(), this.onSceneGraphChanged = new w(), this.onSceneBoundsChanged = new w(), this.onSceneClear = new w(), this.onSceneReset = new w(), this.onRenderModeChanged = new w(), this.onCameraModeChanged = new w(), this.onCameraMoveStart = new w(), this.onCameraMove = new w(), this.onCameraRest = new w(), this.onCameraMoveEnd = new w(), this.onUserCameraMove = new w(), this.historyChanged = new w(), this.onOperatorChanged = new w(), this.onObjectsMoved = new w(), this.onObjectClicked = new w(), this.onObjectDoubleClicked = new w(), this.onObjectVisibilityChanged = new w(), this.onObjectControllerVisibilityChanged = new w(), this.onObjectsTransformAttached = new w(), this.onObjectsTransformDetached = new w(), this.onPluginAdded = new w(), this.onPluginRemoved = new w();
	}
}, Hl = class {
	constructor() {
		this.cumulatedBuildTime = 0;
	}
	reset() {
		this.cumulatedBuildTime = 0;
	}
}, Ul = class {
	constructor() {
		this.boxTree = new Hl(), this.loading = [], this.batching = [];
	}
	reset() {
		this.boxTree.reset(), this.loading.clear(), this.batching.clear();
	}
};
//#endregion
//#region src/core/Viewer.ts
window.THREE = n;
var Wl = class {
	constructor(e = {}) {
		this._plugins = /* @__PURE__ */ new Map(), this._viewport = null, this._isDisposed = !1, this.stats = new Ul(), window.viewer = this, this.settings = Sn(e), this.signals = new Vl(), this.objectStateHistory = new Pi(), this.materialFactory = new hn(this), this.scene = new js(this), this.sceneLoader = new tn(this), this.commandHistory = new qn(this), this.developerTools = ki.init(this), this.behaviorController = new Gn(this);
	}
	attachViewport(e) {
		return this._viewport && this.detachViewport(), this._viewport = new Bl(this, e), this.requestRender(), this.signals.onViewportAdded.emit(), this._viewport;
	}
	requestRender() {
		this.viewport?.renderer.requestAnimationFrame();
	}
	detachViewport() {
		this._viewport?.dispose(), this._viewport = null, this.signals.onViewportRemoved.emit();
	}
	get viewport() {
		return this._viewport;
	}
	dispose() {
		if (this._isDisposed) return;
		this._isDisposed = !0;
		let e = Array.from(this.pluginKeys).reverse();
		for (let t of e) this._plugins.has(t) && this.unregisterPlugin(t);
		this.sceneLoader.dispose(), this.detachViewport(), this.behaviorController.dispose(), this.developerTools.dispose(), this.scene.dispose(), this.commandHistory.clearHistory().catch((e) => {
			C.error("Failed to clear command history while disposing viewer", e);
		}), this.objectStateHistory.clear(), ht.instance.clear(), window.viewer === this && (window.viewer = void 0);
	}
	clear() {
		this.scene.clear();
		for (let e of this.plugins) e.clear();
		this.commandHistory.clearHistory().catch((e) => {
			C.error("Failed to clear command history while clearing viewer", e);
		}), this.stats.reset(), this.signals.onSceneClear.emit(), this.objectStateHistory.clear(), this.viewport?.clear(), ht.instance.clear();
	}
	get plugins() {
		return this._plugins.values();
	}
	get pluginKeys() {
		return this._plugins.keys();
	}
	getPlugin(e) {
		let t = this._plugins.get(e);
		if (!t) throw new rn(e);
		return t;
	}
	hasPlugin(e) {
		return this._plugins.has(e);
	}
	registerPlugin(e, t) {
		let n = t;
		if (n.viewer !== this) {
			console.error("Plugin has not the same instance of this viewer");
			return;
		}
		if (this._plugins.has(e)) {
			console.error(`A plugin is already registered for the key ${e}`);
			return;
		}
		let r = n.dependencies().filter((e) => !this._plugins.has(e));
		if (r.length > 0) throw Error(`Could not register plugin ${n.name}:
          missing plugin dependencies ${r.join(", ")}`);
		this._plugins.set(e, t), n.onRegister(), this.signals.onPluginAdded.emit(e);
	}
	unregisterPlugin(e) {
		let t = this.getPlugin(e);
		for (let t of this._getDependentPluginKeys(e)) this._plugins.has(t) && this.unregisterPlugin(t);
		this._plugins.delete(e), t.onUnregister(), this.signals.onPluginRemoved.emit(e);
	}
	_getDependentPluginKeys(e) {
		let t = [];
		for (let [n, r] of this._plugins) r.dependencies().includes(e) && t.push(n);
		return t.reverse();
	}
	get version() {
		return Kn.version;
	}
};
//#endregion
//#region src/core/ViewerPlugin.ts
function Gl(e, t) {
	return () => ({
		...e(),
		...t()
	});
}
var Kl = class {
	constructor(e, t, n, r) {
		this.viewer = e, this.name = t, this.settings = On.buildSettings(n, t, e.settings.backupName.value, r);
	}
	hasSettings() {
		return Object.keys(this.settings).length > 0;
	}
	dependencies() {
		return [];
	}
	onRegister() {}
	onUnregister() {}
	clear() {}
	static Create(e, t = () => ({})) {
		class n extends Kl {
			constructor(n, r) {
				super(n, e, t, r);
			}
		}
		return n;
	}
};
//#endregion
//#region src/viewport/utils/SceneObjectFilters.ts
function ql(e) {
	return e.isSceneMesh;
}
function Jl(e) {
	return e.isSceneMesh || e.isSceneSprite;
}
function Yl(e) {
	return e.isBimMesh;
}
function Xl(e) {
	return e.isSceneSprite;
}
var q = {
	BimMeshFilter: Yl,
	SpriteFilter: Xl,
	MeshFilter: ql,
	MeshAndSpriteFilter: Jl
}, Zl = [
	,
	,
	,
], Ql = new f(), J = class extends se {
	constructor(e, t, n) {
		super(e, t, n), this._maxCount = n;
	}
	copy(e, t) {
		return super.copy(e, t), this;
	}
	setAllActive(e) {
		let t = this.material.propertiesTexture;
		for (let n = 0; n < this._maxCount; n++) t.setMaterialProperty(n, "active", +!!e);
		t.needsUpdate = !0;
	}
	getActive(e) {
		return this.material.propertiesTexture.getMaterialProperty(e, "active", Zl) ? Zl[0] : 1;
	}
	setActive(e, t) {
		let n = this.material.propertiesTexture;
		n.setMaterialProperty(e, "active", +!!t), n.needsUpdate = !0;
	}
	getColorAt(e, t) {
		return this.material.propertiesTexture.getMaterialProperty(e, "diffuse", Zl) || t.set(0, 0, 0).getHex(), t.set(Zl[0], Zl[1], Zl[2]).getHex(), t;
	}
	setColorAt(e, t) {
		let n = this.material.propertiesTexture;
		Ql.set(t);
		let { r, g: i, b: a } = Ql;
		return n.setMaterialProperty(e, "diffuse", r, i, a), n.needsUpdate = !0, this;
	}
}, $l = /* @__PURE__ */ new y(), eu = /* @__PURE__ */ new f(), tu = class extends Oa {
	constructor(e, t, n) {
		if (super(), this._instances = [], this._group = new re(), this._freeInstances = [], e.length === 0) throw Error("You must pass at least one instancedObjects");
		if (n.length === 0) throw Error("You must pass at least one material configuration");
		this._meshes = e, this._materialIndices = new Uint8Array(this._meshes[0].count).fill(0);
		for (let e of this._meshes) e.count = 0, this._group.add(e);
		this._meshes[0].setAllActive(!1), this.maxInstance = t, this.geometry.computeBoundingBox(), this.geometry.computeBoundingSphere(), this._materialConfigs = n;
	}
	get root() {
		return this._group;
	}
	get geometry() {
		return this._meshes[0].geometry;
	}
	set visible(e) {
		for (let t of this._meshes) t.visible = e;
	}
	get visible() {
		return this._meshes[0].visible;
	}
	get count() {
		return this._instances.length;
	}
	get visibleCount() {
		return this._meshes[0].count;
	}
	clear() {
		for (let e of this._meshes) e.count = 0;
		this._instances.clear(), this._materialIndices.fill(0), this._freeInstances.clear();
	}
	getMaterialIndexFromType(e) {
		let t = this._materialConfigs.findIndex((t) => t.type === e);
		return t === -1 ? null : t;
	}
	setMaterialTypeAt(e, t) {
		let n = this.getMaterialIndexFromType(t);
		n !== null && this.setMaterialIndexAt(e, n);
	}
	setMaterialIndexAt(e, t) {
		if (e < 0) return;
		let n = this._materialIndices[e];
		this._materialIndices[e] = t;
		let r = this._meshes[n].getActive(e);
		this._meshes[n].setActive(e, !1), this._meshes[t].setActive(e, !!r);
	}
	getMaterialIndexAt(e) {
		return this._materialIndices[e];
	}
	setClippingPlanes(e) {
		for (let t of this._meshes) t.material.clippingPlanes = e, t.material.needsUpdate = !0;
	}
	setMaterialLayer(e, t) {
		let n = this.getMaterialIndexFromType(e);
		n !== null && this._meshes[n].layers.set(t);
	}
	*getMaterials(e = []) {
		for (let t of this._materialConfigs) (e.length === 0 || e.includes(t.type)) && (yield t.material);
	}
	addInstance(e) {
		if (this.visibleCount >= this.maxInstance && this._freeInstances.length === 0) throw Error("Maximum number of instanced proxy reached");
		if (this._instances.includes(e)) throw Error("Given proxy is already in this container");
		if (!e.belongsToContainer(this)) throw Error("Proxy belongs to another container");
		let t = !1, n = this._freeInstances.pop();
		if (n !== void 0 && (t = !0), e.proxyId = n ?? this.visibleCount, this._instances.push(e), e.setActive(!0), !t) for (let e of this._meshes) e.count += 1;
		return e;
	}
	removeInstance(e) {
		if (!this._instances.includes(e)) throw Error("Given proxy does not belong to this container");
		e.setActive(!1), this._instances.remove(e), this._freeInstances.push(e.proxyId), e.proxyId = -1;
	}
	setVisibilityAt(e, t) {
		this.setActiveAt(e, t);
	}
	getVisibilityAt(e) {
		let t = this.getMaterialIndexAt(e);
		return !!this._meshes[t].getActive(e);
	}
	setActiveAt(e, t) {
		if (e < 0) return;
		let n = this.getMaterialIndexAt(e);
		return this._meshes[n].setActive(e, t);
	}
	getActiveAt(e) {
		let t = this.getMaterialIndexAt(e);
		return !!this._meshes[t].getActive(e);
	}
	setPositionAt(e, t) {
		for (let n of this._meshes) n.getMatrixAt(e, $l), $l.makeTranslation(t), n.setMatrixAt(e, $l), n.instanceMatrix.needsUpdate = !0, n.computeBoundingSphere();
		return t;
	}
	getPositionAt(e, t) {
		return this._meshes[0].getMatrixAt(e, $l), t.setFromMatrixPosition($l);
	}
	setMatrixAt(e, t) {
		for (let n of this._meshes) n.setMatrixAt(e, t), n.instanceMatrix.needsUpdate = !0, n.computeBoundingSphere();
		return t;
	}
	getMatrixAt(e, t) {
		return this._meshes[0].getMatrixAt(e, t), t;
	}
	getBoundingBoxAt(e, t) {
		let n = this._meshes[0];
		return n.geometry.boundingBox || n.computeBoundingBox(), n.getMatrixAt(e, $l), t.copy(n.geometry.boundingBox).applyMatrix4($l);
	}
	getBoundingSphereAt(e, t) {
		let n = this._meshes[0];
		return n.geometry.boundingSphere || n.computeBoundingSphere(), n.getMatrixAt(e, $l), t.copy(n.geometry.boundingSphere).applyMatrix4($l);
	}
	getGeometryAt(e, t) {
		return t.copy(this.geometry), t;
	}
	getDeepGeometryAt(e, t) {
		throw Error("Method not implemented");
	}
	setDiffuseColorAt(e, t) {
		for (let n of this._meshes) eu.set(t), n.setColorAt(e, eu);
	}
	getDiffuseColorAt(e) {
		return this._meshes[0].getColorAt(e, eu), eu;
	}
	getMaterialTypeAt(e) {
		throw Error("Method not implemented.");
	}
	setOpacityAt(e, t) {}
	getOpacityAt(e) {
		return this._meshes[0].material.opacity;
	}
	setMetalnessAt(e, t) {}
	getMetalnessAt(e) {
		return "metalness" in this._meshes[0].material ? this._meshes[0].material.metalness : 0;
	}
	setRoughnessAt(e, t) {}
	getRoughnessAt(e) {
		return "roughness" in this._meshes[0].material ? this._meshes[0].material.roughness : 0;
	}
	setEmissiveColorAt(e, t) {}
	getEmissiveColorAt(e) {
		return "emissive" in this._meshes[0].material ? this._meshes[0].material.emissive : 0;
	}
}, nu = class extends tu {
	constructor(e, t, n) {
		let r = [];
		for (let i of t) {
			let t = new J(e, i.material, n);
			t.layers.set(i.layer), r.push(t);
		}
		super(r, n, t);
		let i = new S(e);
		this.registerBVH(e.uuid, i);
	}
}, ru = class extends io {
	constructor(...e) {
		super(...e), this.isInstancedMeshProxy = !0;
	}
}, iu = "\n  attribute vec3 instanceStart;\n  attribute vec3 instanceEnd;\n  attribute float instanceProxyId;\n\n  uniform highp sampler2D propertiesTexture;\n  uniform highp sampler2D matricesTexture;\n  uniform vec3 lineNormal;\n  uniform float lineWidth;\n  uniform float minScreenWidth;\n  uniform vec2 resolution;\n  uniform vec3 highlightColor;\n\n  varying float vLineDistance;\n  varying vec3 vLineColor;\n  varying float vLineOpacity;\n  varying float vLineState;\n  varying float vLineSide;\n  varying float vLineHalfWidth;\n  varying float vSegmentLength;\n\n  #include <clipping_planes_pars_vertex>\n\n  mat4 getWideLineMatrix(const in float proxyId) {\n    int size = textureSize(matricesTexture, 0).x;\n    int offset = int(proxyId) * 4;\n    int x = offset % size;\n    int y = offset / size;\n    vec4 column0 = texelFetch(matricesTexture, ivec2(x, y), 0);\n    vec4 column1 = texelFetch(matricesTexture, ivec2(x + 1, y), 0);\n    vec4 column2 = texelFetch(matricesTexture, ivec2(x + 2, y), 0);\n    vec4 column3 = texelFetch(matricesTexture, ivec2(x + 3, y), 0);\n\n    return mat4(column0, column1, column2, column3);\n  }\n\n  void main() {\n    if (instanceProxyId < 0.0) {\n      vLineDistance = 0.0;\n      vLineColor = vec3(0.0);\n      vLineOpacity = 0.0;\n      vLineState = 0.0;\n      vLineSide = 0.0;\n      vLineHalfWidth = 0.0;\n      vSegmentLength = 0.0;\n      gl_Position = vec4(2.0, 2.0, 2.0, 1.0);\n      return;\n    }\n\n    #include <wide_line_properties>\n\n    mat4 proxyMatrix = getWideLineMatrix(instanceProxyId);\n    mat4 worldMatrix = modelMatrix * proxyMatrix;\n    vec3 worldStart = (worldMatrix * vec4(instanceStart, 1.0)).xyz;\n    vec3 worldEnd = (worldMatrix * vec4(instanceEnd, 1.0)).xyz;\n    vec3 tangent = normalize(worldEnd - worldStart);\n    vec3 worldNormal = normalize(mat3(worldMatrix) * lineNormal);\n    vec3 side = normalize(cross(worldNormal, tangent));\n    vec4 clipStart = projectionMatrix * viewMatrix * vec4(worldStart, 1.0);\n    vec4 clipEnd = projectionMatrix * viewMatrix * vec4(worldEnd, 1.0);\n    float clipW = position.y < 0.5 ? clipStart.w : clipEnd.w;\n    float worldUnitsPerPixel = 2.0 * abs(clipW)\n      / (abs(projectionMatrix[1][1]) * resolution.y);\n    float effectiveLineWidth = max(lineWidth, minScreenWidth * worldUnitsPerPixel);\n    float halfWidth = effectiveLineWidth * 0.5;\n    float endpointDirection = position.y < 0.5 ? -1.0 : 1.0;\n    float segmentLength = length(worldEnd - worldStart);\n    vec3 worldPosition = mix(worldStart, worldEnd, position.y)\n      + side * position.x * halfWidth\n      + tangent * endpointDirection * halfWidth;\n\n    vLineDistance = segmentLength * position.y + endpointDirection * halfWidth;\n    vLineColor = mix(proxyColor, highlightColor, proxyHighlighted);\n    vLineOpacity = proxyOpacity;\n    vLineState = proxyActive * proxyVisible;\n    vLineSide = position.x * halfWidth;\n    vLineHalfWidth = halfWidth;\n    vSegmentLength = segmentLength;\n\n    vec4 mvPosition = viewMatrix * vec4(worldPosition, 1.0);\n    gl_Position = projectionMatrix * mvPosition;\n\n    #include <clipping_planes_vertex>\n  }\n", au = "\n  uniform float dashSize;\n  uniform float gapSize;\n\n  varying float vLineDistance;\n  varying vec3 vLineColor;\n  varying float vLineOpacity;\n  varying float vLineState;\n  varying float vLineSide;\n  varying float vLineHalfWidth;\n  varying float vSegmentLength;\n\n  #include <clipping_planes_pars_fragment>\n\n  void main() {\n    if (vLineState < 0.5) discard;\n\n    // Clip the extended quad into a capsule with a round cap at each segment endpoint.\n    if (vLineDistance < 0.0) {\n      if (length(vec2(vLineDistance, vLineSide)) > vLineHalfWidth) discard;\n    } else if (vLineDistance > vSegmentLength) {\n      float distanceFromEnd = vLineDistance - vSegmentLength;\n      if (length(vec2(distanceFromEnd, vLineSide)) > vLineHalfWidth) discard;\n    }\n\n    float dashDistance = clamp(vLineDistance, 0.0, vSegmentLength);\n    float dashPeriod = dashSize + gapSize;\n    if (gapSize > 0.0 && mod(dashDistance, dashPeriod) > dashSize) discard;\n\n    vec4 diffuseColor = vec4(vLineColor, vLineOpacity);\n    #include <clipping_planes_fragment>\n    gl_FragColor = diffuseColor;\n  }\n", ou = class extends Ae {
	constructor(e) {
		let t = iu.replace("#include <wide_line_properties>", e.propertiesTexture.getGlsl("instanceProxyId", "propertiesTexture"));
		super({
			vertexShader: t,
			fragmentShader: au,
			uniforms: {
				propertiesTexture: { value: e.propertiesTexture },
				matricesTexture: { value: e.matricesTexture },
				lineNormal: { value: e.normal.clone().normalize() },
				lineWidth: { value: e.width },
				dashSize: { value: e.dashSize },
				gapSize: { value: e.gapSize },
				minScreenWidth: { value: e.minScreenWidth },
				resolution: { value: new Fe(1, 1) },
				highlightColor: { value: new f(e.highlightColor) }
			},
			transparent: !0,
			side: h,
			depthTest: e.depthTest ?? !0,
			depthWrite: e.depthWrite ?? !1
		});
	}
}, su = class extends Ka {
	constructor(...e) {
		super(...e), this.isInstancedWideLineProxy = !0;
	}
	raycast(e, t, n = .05) {
		let r = this.container.lineWidth * .5;
		super.raycast(e, t, Math.max(n, r));
	}
}, cu = /* @__PURE__ */ new y(), lu = /* @__PURE__ */ new y(), uu = /* @__PURE__ */ new a(), Y = /* @__PURE__ */ new f(), X = [,], du = [
	,
	,
	,
], fu = /* @__PURE__ */ new x(), pu = /* @__PURE__ */ new x(), mu = class extends Oa {
	constructor(e) {
		super(), this.freeProxyIds = [], this.freeInstanceRanges = [], this.activeProxyCount = 0, this.nextInstance = 0;
		let t = gu(e);
		_u(t), this.maxProxyCount = t.maxProxyCount, this.maxSegmentCount = t.maxSegmentCount, this.lineWidth = t.width, this.rangeStarts = new Int32Array(t.maxProxyCount).fill(-1), this.rangeCounts = new Int32Array(t.maxProxyCount), this.materialTypes = Array(t.maxProxyCount).fill(null), this.geometry = hu(t.maxSegmentCount), this.propertiesTexture = vu(t.maxProxyCount), this.matricesTexture = yu(t.maxProxyCount), this.material = new ou({
			propertiesTexture: this.propertiesTexture,
			matricesTexture: this.matricesTexture,
			width: t.width,
			normal: t.normal,
			dashSize: t.dashSize,
			gapSize: t.gapSize,
			minScreenWidth: t.minScreenWidth,
			depthTest: t.depthTest,
			depthWrite: t.depthWrite,
			highlightColor: t.highlightColor
		}), this.root = new ge(this.geometry, this.material), this.root.name = "InstancedWideLines", this.root.matrixAutoUpdate = !1, this.root.frustumCulled = !1, this.root.onBeforeRender = (e) => {
			e.getDrawingBufferSize(this.material.uniforms.resolution.value);
		};
	}
	createProxy(e, t, n = 1) {
		let r = e.getAttribute("position");
		if (!r || e.index) throw Error("Wide line geometry must contain non-indexed position pairs");
		if (r.count === 0) throw Error("Wide line geometry must contain at least one segment");
		if (r.count % 2 != 0) throw Error("Wide line geometry must contain an even number of positions");
		if (this.freeProxyIds.length === 0 && this.activeProxyCount >= this.maxProxyCount) throw Error("Maximum wide line proxy count reached");
		let i = this.allocateInstanceRange(r.count / 2), a = this.allocateProxyId();
		return this.rangeStarts[a] = i.start, this.rangeCounts[a] = i.count, this.activeProxyCount++, this.writeSegments(a, i, e), this.writeMatrix(a, cu), this.setOpacityAt(a, n), this.setActiveAt(a, !0), this.setVisibilityAt(a, !0), this.setMaterialTypeAt(a, N.Opaque), this.setDiffuseColorAt(a, t), new su(this, a, e.uuid);
	}
	deleteProxy(e) {
		if (!this.contains(e) || e.proxyId < 0) throw Error("Wide line proxy does not belong to this container");
		let t = e.proxyId, n = this.getProxyRange(t);
		this.clearInstanceRange(n), this.freeInstanceRanges.push({ ...n }), xu(this.freeInstanceRanges), this.rangeStarts[t] = -1, this.rangeCounts[t] = 0, this.materialTypes[t] = null, this.freeProxyIds.push(t), this.activeProxyCount--, e.proxyId = -1, this.updateInstanceCount();
	}
	allocateProxyId() {
		let e = this.freeProxyIds.pop();
		return e === void 0 ? this.rangeStarts.findIndex((e) => e < 0) : e;
	}
	allocateInstanceRange(e) {
		let t = this.freeInstanceRanges.findIndex((t) => t.count >= e);
		if (t >= 0) {
			let n = this.freeInstanceRanges[t], r = {
				start: n.start,
				count: e
			};
			return n.start += e, n.count -= e, n.count === 0 && this.freeInstanceRanges.splice(t, 1), r;
		}
		if (this.nextInstance + e > this.maxSegmentCount) throw Error("Maximum wide line segment count reached");
		let n = {
			start: this.nextInstance,
			count: e
		};
		return this.nextInstance += e, n;
	}
	writeSegments(e, t, n) {
		let r = n.getAttribute("position"), i = this.geometry.getAttribute("instanceStart"), a = this.geometry.getAttribute("instanceEnd"), o = this.geometry.getAttribute("instanceProxyId");
		for (let n = 0; n < t.count; n++) {
			let s = t.start + n, c = n * 2;
			i.setXYZ(s, r.getX(c), r.getY(c), r.getZ(c)), a.setXYZ(s, r.getX(c + 1), r.getY(c + 1), r.getZ(c + 1)), o.setX(s, e);
		}
		i.needsUpdate = !0, a.needsUpdate = !0, o.needsUpdate = !0, this.geometry.instanceCount = Math.max(this.geometry.instanceCount, t.start + t.count);
	}
	clearInstanceRange(e) {
		let t = this.geometry.getAttribute("instanceProxyId");
		for (let n = e.start; n < e.start + e.count; n++) t.setX(n, -1);
		t.needsUpdate = !0;
	}
	updateInstanceCount() {
		let e = 0;
		for (let t = 0; t < this.maxProxyCount; t++) this.rangeStarts[t] >= 0 && (e = Math.max(e, this.rangeStarts[t] + this.rangeCounts[t]));
		this.geometry.instanceCount = e;
	}
	getProxyRange(e) {
		return this.assertProxyExists(e), {
			start: this.rangeStarts[e],
			count: this.rangeCounts[e]
		};
	}
	assertProxyExists(e) {
		if (e < 0 || e >= this.maxProxyCount || this.rangeStarts[e] < 0) throw Error(`Unknown wide line proxy: ${e}`);
	}
	writeMatrix(e, t) {
		let n = this.matricesTexture.image.data;
		t.toArray(n, e * 16), this.matricesTexture.needsUpdate = !0;
	}
	readProperty(e, t) {
		return this.propertiesTexture.getMaterialProperty(e, t, X), X[0];
	}
	writeGeometry(e, t) {
		let n = this.getProxyRange(e), r = this.geometry.getAttribute("instanceStart"), i = this.geometry.getAttribute("instanceEnd"), a = new Float32Array(n.count * 6);
		for (let e = 0; e < n.count; e++) {
			let t = n.start + e, o = e * 6;
			a[o] = r.getX(t), a[o + 1] = r.getY(t), a[o + 2] = r.getZ(t), a[o + 3] = i.getX(t), a[o + 4] = i.getY(t), a[o + 5] = i.getZ(t);
		}
		for (let e of Object.keys(t.attributes)) t.deleteAttribute(e);
		return t.setIndex(null), t.setAttribute("position", new te(a, 3)), t;
	}
	get count() {
		return this.activeProxyCount;
	}
	get visible() {
		return this.root.visible;
	}
	set visible(e) {
		this.root.visible = e;
	}
	*getMaterials() {
		yield this.material;
	}
	setMaterialLayer(e, t) {
		this.root.layers.set(t);
	}
	setClippingPlanes(e) {
		this.material.clippingPlanes = e, this.material.needsUpdate = !0;
	}
	clear() {
		this.rangeStarts.fill(-1), this.rangeCounts.fill(0), this.materialTypes.fill(null), this.freeProxyIds.length = 0, this.freeInstanceRanges.length = 0, this.activeProxyCount = 0, this.nextInstance = 0, this.geometry.instanceCount = 0;
		let e = this.geometry.getAttribute("instanceProxyId");
		e.array.fill(-1), e.needsUpdate = !0;
	}
	getGeometryAt(e, t) {
		return this.writeGeometry(e, t);
	}
	getDeepGeometryAt(e, t) {
		return this.writeGeometry(e, t);
	}
	getMaterialTypeAt(e) {
		return this.assertProxyExists(e), this.materialTypes[e];
	}
	setMaterialTypeAt(e, t) {
		this.assertProxyExists(e), this.materialTypes[e] = t, this.propertiesTexture.setMaterialProperty(e, "proxyHighlighted", Number(bu(t)));
	}
	setActiveAt(e, t) {
		this.assertProxyExists(e), this.propertiesTexture.setMaterialProperty(e, "proxyActive", Number(t));
	}
	getActiveAt(e) {
		return this.assertProxyExists(e), this.readProperty(e, "proxyActive") > .5;
	}
	setVisibilityAt(e, t) {
		this.assertProxyExists(e), this.propertiesTexture.setMaterialProperty(e, "proxyVisible", Number(t));
	}
	getVisibilityAt(e) {
		return this.assertProxyExists(e), this.readProperty(e, "proxyVisible") > .5;
	}
	setPositionAt(e, t) {
		return this.getMatrixAt(e, lu), lu.setPosition(t), this.writeMatrix(e, lu), t;
	}
	getPositionAt(e, t) {
		return t.setFromMatrixPosition(this.getMatrixAt(e, lu));
	}
	setMatrixAt(e, t) {
		return this.assertProxyExists(e), this.writeMatrix(e, t), t;
	}
	getMatrixAt(e, t) {
		this.assertProxyExists(e);
		let n = this.matricesTexture.image.data;
		return t.fromArray(n, e * 16);
	}
	getBoundingBoxAt(e, t) {
		let n = this.getProxyRange(e), r = this.geometry.getAttribute("instanceStart"), i = this.geometry.getAttribute("instanceEnd");
		t.makeEmpty();
		for (let e = 0; e < n.count; e++) {
			let a = n.start + e;
			fu.fromBufferAttribute(r, a), pu.fromBufferAttribute(i, a), t.expandByPoint(fu), t.expandByPoint(pu);
		}
		return t.applyMatrix4(this.getMatrixAt(e, lu)), t.expandByScalar(this.lineWidth * .5);
	}
	getBoundingSphereAt(e, t) {
		return this.getBoundingBoxAt(e, uu).getBoundingSphere(t);
	}
	setOpacityAt(e, t) {
		this.assertProxyExists(e), this.propertiesTexture.setMaterialProperty(e, "proxyOpacity", t);
	}
	getOpacityAt(e) {
		return this.assertProxyExists(e), this.readProperty(e, "proxyOpacity");
	}
	setDiffuseColorAt(e, t) {
		this.assertProxyExists(e), Y.set(t), this.propertiesTexture.setMaterialProperty(e, "proxyColor", Y.r, Y.g, Y.b);
	}
	getDiffuseColorAt(e) {
		return this.assertProxyExists(e), this.propertiesTexture.getMaterialProperty(e, "proxyColor", du), Y.fromArray(du).getHex();
	}
	setMetalnessAt(e, t) {}
	getMetalnessAt(e) {
		return 0;
	}
	setRoughnessAt(e, t) {}
	getRoughnessAt(e) {
		return 1;
	}
	setEmissiveColorAt(e, t) {}
	getEmissiveColorAt(e) {
		return this.getDiffuseColorAt(e);
	}
	dispose() {
		this.root.removeFromParent(), this.geometry.dispose(), this.propertiesTexture.dispose(), this.matricesTexture.dispose(), this.material.dispose();
	}
};
function hu(e) {
	let t = new oe();
	t.setAttribute("position", new te([
		-1,
		0,
		0,
		1,
		0,
		0,
		-1,
		1,
		0,
		1,
		1,
		0
	], 3)), t.setIndex([
		0,
		1,
		2,
		2,
		1,
		3
	]), t.setAttribute("instanceStart", new ae(new Float32Array(e * 3), 3)), t.setAttribute("instanceEnd", new ae(new Float32Array(e * 3), 3));
	let n = new Float32Array(e);
	return n.fill(-1), t.setAttribute("instanceProxyId", new ae(n, 1)), t.instanceCount = 0, t;
}
function gu(e) {
	return {
		...e,
		dashSize: e.dashSize ?? 1,
		gapSize: e.gapSize ?? 0,
		minScreenWidth: e.minScreenWidth ?? 1
	};
}
function _u(e) {
	if (!Number.isInteger(e.maxProxyCount) || e.maxProxyCount <= 0) throw RangeError("maxProxyCount must be a positive integer");
	if (!Number.isInteger(e.maxSegmentCount) || e.maxSegmentCount <= 0) throw RangeError("maxSegmentCount must be a positive integer");
	if (!Number.isFinite(e.width) || e.width < 0) throw RangeError("width must be a non-negative finite number");
	if (!Number.isFinite(e.dashSize) || e.dashSize < 0) throw RangeError("dashSize must be a non-negative finite number");
	if (!Number.isFinite(e.gapSize) || e.gapSize < 0) throw RangeError("gapSize must be a non-negative finite number");
	if (!Number.isFinite(e.minScreenWidth) || e.minScreenWidth < 0) throw RangeError("minScreenWidth must be a non-negative finite number");
	let t = e.normal.lengthSq();
	if (!Number.isFinite(t) || t === 0) throw RangeError("normal must not be a zero-length vector");
}
function vu(e) {
	return new so(e, {
		proxyColor: "vec3",
		proxyOpacity: "float",
		proxyActive: "float",
		proxyVisible: "float",
		proxyHighlighted: "float"
	});
}
function yu(e) {
	let t = Math.sqrt(e * 4);
	t = Math.ceil(t / 4) * 4, t = Math.max(t, 4);
	let n = new Float32Array(t * t * 4), r = new p(n, t, t, Ee, _);
	return r.needsUpdate = !0, r;
}
function bu(e) {
	return e === N.SelectedOpaque || e === N.SelectedTransparent || e === N.SelectedXRay;
}
function xu(e) {
	e.sort((e, t) => e.start - t.start);
	for (let t = 0; t + 1 < e.length;) {
		let n = e[t], r = e[t + 1];
		n.start + n.count === r.start ? (n.count += r.count, e.splice(t + 1, 1)) : t++;
	}
}
//#endregion
//#region src/scene/geometry/instancing/InstancedMaterialMixin.ts
function Su(e) {
	class t extends e {
		constructor(...e) {
			let [t, n] = e, { useMaterialColor: r, ...i } = n ?? {};
			super(i), this.propertiesTexture = t, this.useMaterialColor = r ?? !1;
		}
		onBeforeCompile(e) {
			e.defines = { USE_MATERIAL_COLOR: this.useMaterialColor }, e.uniforms.propertiesTexture = { value: this.propertiesTexture }, e.vertexShader = e.vertexShader.replace("void main() {", `
          uniform sampler2D propertiesTexture;
          uniform float instanceCount;

          varying float vActive;
          varying float vProxyId;
          void main() {
          vProxyId = float(gl_InstanceID);
          ${this.propertiesTexture.getGlslPropertyValue("vProxyId", "propertiesTexture", "active", "vActive")}
        `), e.fragmentShader = e.fragmentShader.replace("void main() {", "\n          uniform highp sampler2D propertiesTexture;\n          varying float vActive;\n          varying float vProxyId;\n          void main() {\n        "), e.fragmentShader = e.fragmentShader.replace("#include <color_fragment>", `
          if (vActive < 0.5) {
            discard; 
          }


          // Save the original diffuse color
          vec3 materialDiffuse = diffuse;

          ${this.propertiesTexture.getGlsl("vProxyId")}

          #ifdef USE_MATERIAL_COLOR
            diffuse = materialDiffuse;
          #endif

          diffuseColor = vec4( diffuse, opacity );
        `);
		}
		customProgramCacheKey() {
			return super.customProgramCacheKey() + `propertiesTexture=${this.propertiesTexture.id}useMaterialColor=${this.useMaterialColor}`;
		}
	}
	return t;
}
//#endregion
//#region src/scene/geometry/instancing/InstancedMaterial.ts
var Cu = class extends Su(_e) {
	constructor(e, t = {}) {
		super(e, t);
	}
}, wu = class extends Su(le) {
	constructor(e, t = {}) {
		super(e, t);
	}
}, Tu = new y(), Eu = class {}, Du = class extends So {
	constructor(e, t = {}) {
		super(), this.isSceneSpriteLegacy = !0, this.sprite = e, this.clickCallback = t.clickCallback;
	}
	setTexture(e) {
		this.sprite.material.map = e, this.sprite.material.map.needsUpdate = !0;
	}
	get material() {
		return this.sprite.material;
	}
	raycast(e, t) {
		let n = [];
		this.sprite.raycast(e, n), n.length > 0 && t.push({
			object: this,
			rayDistance: 0,
			point: n[0].point,
			distance: n[0].distance
		});
	}
	projectPointOnEdges(e, t, n) {
		return !1;
	}
	getBoundingBox(e) {
		return this.sprite.geometry.boundingBox || this.sprite.geometry.computeBoundingSphere(), this.sprite.geometry.boundingSphere.getBoundingBox(e), this.getMatrix(Tu), e.applyMatrix4(Tu);
	}
	getBoundingSphere(e) {
		return this.sprite.geometry.boundingSphere || this.sprite.geometry.computeBoundingSphere(), this.getMatrix(Tu), e.copy(this.sprite.geometry.boundingSphere).applyMatrix4(Tu);
	}
	getMatrix(e) {
		return e.copy(this.sprite.matrix);
	}
	setMatrix(e) {
		return this.sprite.matrix.copy(e);
	}
	getPosition(e) {
		return e.copy(this.sprite.position);
	}
	setPosition(e) {
		return this.sprite.position.set(e.x, e.y, e.z), this.sprite.updateMatrix(), e;
	}
	set visible(e) {
		super.visible = e, this.sprite.visible = this.visible;
	}
	get visible() {
		return super.visible;
	}
};
//#endregion
//#region src/scene/serialization/SerializedLineBasicMaterial.ts
function Ou(e) {
	return {
		transparent: e.transparent,
		color: e.color.getHex(),
		opacity: e.opacity
	};
}
function ku(e, t) {
	return t.transparent = e.transparent, t.color.set(e.color), t.opacity = e.opacity, t;
}
//#endregion
//#region src/scene/serialization/SerializedObject3D.ts
function Au(e) {
	return {
		isSerializedObject3D: !0,
		isMeshGroup: !1,
		isInMeshGroup: !1,
		name: e.name,
		uuid: e.uuid,
		userData: e.userData,
		parentUuid: e.parent?.uuid ?? null
	};
}
function ju(e, t) {
	return t.name = e.name, t.uuid = e.uuid, t.userData = e.userData, t;
}
//#endregion
//#region src/scene/serialization/SerializedLineSegments.ts
var Mu = new le();
function Z(e, t = "3D") {
	return mo(e, Mu), {
		...Au(e),
		geometryType: t,
		isSeriaLizedLineSegments: !0,
		material: Ou(Mu),
		matrixWorld: ur(e.matrixWorld)
	};
}
function Nu(e, t) {
	return ju(e, t), ku(e.material, t.material), dr(e.matrixWorld, t.matrixWorld), t;
}
//#endregion
//#region src/scene/serialization/SerializedMeshStandardMaterial.ts
function Pu(e) {
	return {
		name: e.name,
		transparent: e.transparent,
		roughness: e.roughness,
		color: e.color.getHex(),
		metalness: e.metalness,
		emissive: e.emissive.getHex(),
		opacity: e.opacity
	};
}
function Fu(e, t) {
	return t.name = e.name, t.transparent = e.transparent, t.roughness = e.roughness, t.metalness = e.metalness, t.emissive.set(e.emissive), t.color.set(e.color), t.opacity = e.opacity, t;
}
//#endregion
//#region src/scene/serialization/SerializedMesh.ts
var Iu = new ve();
function Q(e, t = "3D") {
	return po(e, Iu), {
		...Au(e),
		geometryType: t,
		isSerializedMesh: !0,
		material: Pu(Iu),
		matrixWorld: ur(e.matrixWorld)
	};
}
function Lu(e, t) {
	return ju(e, t), Fu(e.material, t.material), dr(e.matrixWorld, t.matrixWorld), t;
}
//#endregion
//#region src/command/io/LoadCommand.ts
var Ru = class extends A {
	constructor(e, t, n = new St(e)) {
		super(e), this.name = "LoadCommand", this.isUndoable = !1, this._fileRequests = Array.from(t), this._importController = n;
	}
	async _do() {
		if (this.viewer.sceneLoader.isRunning) throw Error("Viewer is already loading");
		for (let e of this._fileRequests) this.viewer.sceneLoader.addFileRequest(e);
		this.viewer.sceneLoader.setObjectImportController(this._importController), await this.viewer.sceneLoader.start();
	}
	async _undo() {
		throw new k(this);
	}
}, zu = class {
	static createFileRequest(e, t) {
		let n = e.name.toLowerCase().split(".").pop(), r;
		switch (n) {
			case "gltf":
			case "glb":
				r = "GLTF";
				break;
			case "obj":
				r = "OBJ";
				break;
			default: throw TypeError(`Cannot load files of type ${n}`);
		}
		return {
			url: URL.createObjectURL(e),
			format: r,
			geometryType: t
		};
	}
}, Bu = class extends A {
	constructor(e, t, n = {}) {
		super(e), this.name = "LoadFilesCommand", this.isUndoable = !1;
		let { geometryType: r = "3D" } = n, i = [];
		for (let e = 0; e < t.length; e++) {
			let n = zu.createFileRequest(t[e], r);
			i.push(n);
		}
		this._command = new Ru(this.viewer, i);
	}
	async _do() {
		await this._command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		throw new k(this);
	}
}, Vu = class extends A {
	constructor(...e) {
		super(...e), this.name = "StopLoadingCommand", this.isUndoable = !1;
	}
	async _do() {
		this.viewer.sceneLoader.stop();
	}
	async _undo() {
		throw Error("Method not implemented.");
	}
	async _clean() {
		throw Error("Method not implemented.");
	}
}, Hu = /* @__PURE__ */ new b(), Uu = class extends er {
	constructor(e, t, n = { selected: !1 }) {
		super(e, n), this._type = t, this.name = "AddClippingPlaneCommand";
	}
	async _createObject() {
		return this.viewer.scene.getBoxTreeBoundingSphere(Hu), Hu.radius <= 0 && (Hu.radius = 1), this.viewer.scene.clippingPlaneController.createPlane(this._type, Hu.center, Hu.radius * 2);
	}
}, Wu = class extends A {
	constructor(e) {
		super(e), this.name = "GetSelectedObjectsCommand", this.isUpdatable = !1, this.isUndoable = !1;
	}
	async _do() {
		return this.viewer.scene.objectSelection.getUuids();
	}
	async _undo() {
		throw new k(this);
	}
}, Gu = class extends A {
	constructor(e) {
		super(e), this.name = "RestoreAllObjectsMaterialCommand", this.isUndoable = !0, this.command = new sr(e, this.viewer.scene.bimMeshController.getAllObjectUuids());
	}
	async _do() {
		this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		this.command.undo({
			requestRender: !1,
			addToRedoHistory: !1
		});
	}
	async _clean() {
		this.command._clean();
	}
}, Ku = class extends A {
	constructor(e, t, n) {
		super(e), this.name = "SetObjectControllerVisibilityCommand", this.isUndoable = !0, this._controller = t, this._newVisibility = n, this._oldVisibility = t.visible;
	}
	async _do() {
		this._controller.visible = this._newVisibility;
	}
	async _undo() {
		this._controller.visible = this._oldVisibility;
	}
	equals(e) {
		return this._controller === e._controller && this._newVisibility === e._newVisibility;
	}
}, qu = class extends A {
	constructor(e, t) {
		if (super(e), this.name = "SetRenderModeCommand", this.isUndoable = !0, !e.viewport) throw Error("No Viewport attached to the viewer");
		this.viewport = e.viewport, this.oldMode = e.viewport.renderModeController.renderMode, this.newMode = t;
	}
	async _do() {
		this.viewport.renderModeController.renderMode = this.newMode;
	}
	async _undo() {
		this.viewport.renderModeController.renderMode = this.oldMode;
	}
}, Ju = class extends A {
	constructor(...e) {
		super(...e), this.name = "ClearCommandHistoryCommand", this.isUndoable = !1;
	}
	async _do() {
		this.viewer.commandHistory.clearHistory();
	}
	async _undo() {
		throw new k(this);
	}
}, Yu = class extends A {
	constructor(e) {
		super(e), this.name = "ClearAllSceneObjectControllerCommand", this.isUndoable = !0, this._groupCmd = null;
	}
	async _do() {
		if (!this._groupCmd) {
			let e = [];
			for (let t of this.viewer.scene.controllers) t.isBimMeshController || e.push(new gi(this.viewer, t));
			this._groupCmd = new pi(this.viewer, e), this._groupCmd.isUndoable = !0;
		}
		this._groupCmd.execute({ addToUndoHistory: !1 });
	}
	async _undo() {
		this._groupCmd?.undo({ addToRedoHistory: !1 });
	}
}, Xu = class extends A {
	constructor(e, t) {
		if (super(e), this.name = "SetCameraModeCommand", this.isUndoable = !0, !e.viewport) throw Error("No Viewport attached to the viewer");
		this.viewport = e.viewport, this.oldMode = e.viewport.cameraControls.getMode(), this.newMode = t;
	}
	async _do() {
		this.viewport.cameraControls.setMode(this.newMode);
	}
	async _undo() {
		this.viewport.cameraControls.setMode(this.oldMode);
	}
}, Zu = class extends A {
	constructor(e) {
		super(e), this.name = "ResetSceneCommand", this.isUndoable = !1, this.command = new pi(e, [
			new lr(this.viewer),
			new gl(this.viewer),
			new Gu(this.viewer),
			new Ju(this.viewer),
			new Yu(this.viewer),
			new Xu(this.viewer, Fs.CursorOrbital),
			new j(this.viewer)
		]);
	}
	async _do() {
		this.command.execute({
			addToUndoHistory: !1,
			requestRender: !1
		}), this.viewer.signals.onSceneReset.emit();
	}
	async _undo() {
		throw new k(this);
	}
}, Qu = class extends A {
	constructor(e, t = {}) {
		super(e), this.name = "CameraFocusSelectedObjectsCommand", this.isUndoable = !0, this.command = new Vc(this.viewer, this.viewer.scene.objectSelection.getUuids(), t);
	}
	async _do() {
		return this.command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		});
	}
	async _undo() {
		this.command.undo({
			requestRender: !1,
			addToRedoHistory: !1
		});
	}
	async _clean() {
		return this.command._clean();
	}
}, $u = class extends A {
	constructor(e, t = .25) {
		super(e), this.name = "CameraZoomInCommand", this.isUndoable = !1, this.duration = t;
	}
	async _do() {
		if (this.viewer.viewport) return this.viewer.viewport.cameraControls.zoomIn(this.viewer.settings.camera.stepDistanceZoom.value, this.duration);
	}
	async _undo() {
		throw new k(this);
	}
}, ed = class extends A {
	constructor(e, t = .25) {
		super(e), this.name = "CameraZoomOutCommand", this.isUndoable = !1, this.duration = t;
	}
	async _do() {
		if (this.viewer.viewport) return this.viewer.viewport.cameraControls.zoomOut(this.viewer.settings.camera.stepDistanceZoom.value, this.duration);
	}
	async _undo() {
		throw new k(this);
	}
}, td = class extends A {
	constructor(...e) {
		super(...e), this.name = "DownloadViewportScreenshotCommand", this.isUndoable = !1;
	}
	async _do() {
		if (!this.viewer.viewport) throw Error("Viewport is not registered to the viewer");
		this.viewer.viewport.renderer.renderFrame(), Uc(this.viewer.viewport.renderer.canvas.toDataURL("image/png"), "Screenshot.png");
	}
	async _undo() {
		throw Error("Method not implemented.");
	}
}, nd = class extends A {
	constructor(e, t) {
		if (super(e), this.mode = t, this.name = "SetGizmoModeCommand", this.isUndoable = !1, !e.viewport) throw Error("No Viewport attached to the viewer");
		this.viewport = e.viewport;
	}
	async _do() {
		this.viewport.transformController.setMode(this.mode);
	}
	async _undo() {
		throw new k(this);
	}
}, rd = class extends A {
	constructor(...e) {
		super(...e), this.name = "ViewportScreenshotCommand", this.isUpdatable = !1, this.isUndoable = !1;
	}
	async _do() {
		if (!this.viewer.viewport) throw Error("Viewport is not registered to the viewer");
		return this.viewer.viewport.renderer.renderFrame(), this.viewer.viewport.renderer.canvas.toDataURL("image/png").replace(/^data:image\/(png|jpg);base64,/, "");
	}
	async _undo() {
		throw new k(this);
	}
}, id = class extends Error {
	constructor() {
		super("Task was cancelled"), this.isCancelledAsyncTaskError = !0;
	}
}, $ = class {
	constructor(e = {}) {
		this._queue = [], this._activeTasks = 0, this._concurrency = e.concurrency ?? 1, this._delayBetweenTasks = e.delayBetweenTasks ?? 0;
	}
	get activeTasks() {
		return this._activeTasks;
	}
	get pendingTasks() {
		return this._queue.length;
	}
	addTask(e, t = !1) {
		return new Promise((n, r) => {
			let i = {
				run: () => e().then(n).catch(r),
				reject: r
			};
			this._queue.push(i), t && this._processQueue(!0);
		});
	}
	dequeue(e = !1) {
		this._processQueue(e);
	}
	_processQueue(e) {
		for (; this._activeTasks < this._concurrency && this._queue.length > 0;) {
			let t = this._queue.shift();
			this._activeTasks++, t.run().finally(() => {
				this._activeTasks--, e && setTimeout(() => {
					this._processQueue(!0);
				}, this._delayBetweenTasks);
			});
		}
	}
	clear() {
		for (; this._queue.length > 0;) this._queue.shift().reject(new id());
	}
}, ad = (e, t) => {
	let n = {};
	for (let [r, i] of Object.entries(e ?? {})) if (r.toLowerCase().includes(t)) n[r] = i;
	else if ((typeof i == "string" || typeof i == "number" || typeof i == "boolean") && i.toString().toLowerCase().includes(t)) n[r] = i;
	else if (Array.isArray(i)) {
		let e = i.map((e) => typeof e == "object" ? ad(e, t) : e.toString().toLowerCase().includes(t) ? e : null).filter((e) => e != null);
		e.length > 0 && (n[r] = e);
	} else if (typeof i == "object") {
		let e = ad(i, t);
		e && (n[r] = e);
	}
	return Object.keys(n).length > 0 ? n : null;
}, od = (e) => {
	let t = 1;
	for (let [n, r] of Object.entries(e ?? {})) if (typeof r == "object") {
		let e = od(r) + 1;
		t = Math.max(t, e);
	}
	return t;
};
function sd(e) {
	if (Array.isArray(e)) return e.map(sd);
	if (typeof e == "object" && e) {
		let t = {};
		return Object.keys(e).sort().forEach((n) => {
			let r = e[n];
			typeof r == "object" && r ? t[n] = sd(r) : t[n] = r;
		}), t;
	}
	return e;
}
//#endregion
//#region src/utils/TimeUtils.ts
var cd = class {
	static {
		this._time = 0;
	}
	static {
		this._times = /* @__PURE__ */ new Map();
	}
	static startTime(e) {
		return this._time = performance.now(), e && this._times.set(e, this._time), this._time;
	}
	static tickTime(e) {
		let t = performance.now(), n = this._time;
		if (e) {
			let t = this._times.get(e);
			if (t !== void 0) n = t;
			else throw Error("Unknown timer id");
		}
		return t - n;
	}
	static endTime(e) {
		let t = performance.now(), n = this._time;
		if (this._time = t, e) {
			let r = this._times.get(e);
			if (r !== void 0) n = r, this._times.set(e, t);
			else throw Error("Unknown timer id");
		}
		return t - n;
	}
	static timeStr(e) {
		return `${e.toFixed(1)} ms`;
	}
}, ld = new s(1, 1, 1), ud = new g(ld), dd = new S(ld), fd = S.serialize(dd);
function pd(e, t = {}) {
	let { meshCount: n = 10, withViewport: r = !1 } = t;
	e.clear();
	let i = [], a = new Jt(), o = new E();
	e.scene.bimMeshController.addBatchedMeshContainer(a), e.scene.bimMeshController.addBatchedEdgesContainer(o);
	for (let t = 0; t < n; t++) {
		let n = md(e, "Mesh" + t);
		e.scene.addObject(n);
		let r = gd(a, o, "subMesh-i"), s = e.scene.bimMeshController.createMeshProxy(r);
		e.scene.bimMeshController.addSubMesh(n, s, "3D"), i.push(n);
	}
	return r && e.attachViewport(document.createElement("canvas")), { meshes: i };
}
function md(e, t) {
	let n = hd(t);
	return e.scene.bimMeshController.createMesh(n);
}
function hd(e) {
	let t = new ge();
	return e && (t.uuid = e), Q(t);
}
function gd(e, t, n) {
	let r = e.addGeometry(ld), i = t.addGeometry(ud);
	return {
		isSerializedBatchedMeshProxy: !0,
		isInMeshGroup: !1,
		uuid: n ?? "BatchedMeshProxy",
		parentUuid: null,
		geometryType: "3D",
		mesh: {
			serializedBVH: fd,
			srcGeometryUuid: ld.uuid,
			batchedGeometryUuid: e.uuid,
			proxyId: r,
			material: {
				name: "TestMaterial",
				transparent: !1,
				roughness: 1,
				color: 16777215,
				metalness: 0,
				emissive: 0,
				opacity: 1
			}
		},
		edges: {
			srcGeometryUuid: ld.uuid,
			proxyId: i,
			batchedGeometryUuid: t.uuid
		},
		name: "BatchedMeshProxy",
		userData: {}
	};
}
//#endregion
export { Uu as AddClippingPlaneCommand, er as AddObjectCommand, rr as AddSpriteCommand, $ as AsyncTaskQueue, Vi as BOX_TREE_BUFFER_LAYOUT, Oa as BaseContainer, za as BaseProxy, Jt as BatchedGeometry, dn as BatchedLineBasicMaterial, Aa as BatchedLineContainer, fn as BatchedLineDashedMaterial, E as BatchedLineGeometry, qa as BatchedLineProxy, un as BatchedMaterialMixin, Ya as BatchedMeshContainer, ao as BatchedMeshProxy, M as BatchedMeshStandardMaterial, Gn as BehaviorController, Io as BimMesh, Lo as BimMeshController, P as BooleanController, ea as BoxTree, Vc as CameraFocusObjectsCommand, Qu as CameraFocusSelectedObjectsCommand, zs as CameraMode, Fs as CameraModeType, $u as CameraZoomInCommand, ed as CameraZoomOutCommand, id as CancelledAsyncTaskError, j as CenterCameraOnSceneCommand, Ju as ClearCommandHistoryCommand, _i as ClearSceneCommand, gi as ClearSceneObjectControllerCommand, gl as ClearSelectionCommand, qo as ClippingPlane, wc as ClippingPlaneContextMenuBuilder, Yo as ClippingPlaneController, Ro as ClippingPlaneType, Xo as CollectionNotFoundError, vn as ColorController, A as Command, an as CommandNotExecutedError, Dc as ContextMenuController, C as Debug, Sl as DefaultOptions, hi as DeleteObjectCommand, Jn as DeveloperTool, ki as DeveloperToolController, td as DownloadViewportScreenshotCommand, xo as DrawableSceneObject, Da as Edge, Ct as File3DLoader, Wu as GetSelectedObjectsCommand, Os as Grid, pi as GroupCommand, zi as HEADER, Cu as InstancedBasicMaterial, wu as InstancedLineBasicMaterial, Su as InstancedMaterialMixin, J as InstancedMesh, nu as InstancedMeshContainer, ru as InstancedMeshProxy, mu as InstancedWideLineContainer, ou as InstancedWideLineMaterial, su as InstancedWideLineProxy, ar as IsolateObjectCommand, Et as JsHeapMemoryTracker, Yc as KeyboardLayoutController, qc as KeyboardLayouts, Zc as KeyboardShortcut, hl as KeyboardShortcutController, Tn as LOCAL_STORAGE_KEY, En as LOCAL_STORAGE_PLUGIN_BASE_KEY, Ka as LineProxy, Ru as LoadCommand, Bu as LoadFilesCommand, vt as LocalStorageManager, hn as MaterialFactory, pn as MaterialLayer, mn as MaterialLayers, so as MaterialPropertyTexture, N as MaterialType, Tc as MeshContextMenuBuilder, io as MeshProxy, Ta as MultiMaterialBatchedLine, Ja as MultiMaterialBatchedMesh, wa as MultiMaterialBatchedObject, B as NODE, Bi as NOT_DEFINED, k as NotUndoableCommandError, on as NotUpdatableCommandError, ht as NotificationCenter, F as NumberController, St as ObjectImportController, Qn as ObjectSelection, lo as ObjectStateController, Cc as ObservableSet, Vr as OrbitPosition, rn as PluginNotFoundError, vl as RaycastSelectOperator, So as RaycastableSceneObject, nn as ReactContextNotFoundError, kc as RenderMode, Ac as RenderModeController, Zu as ResetSceneCommand, Gu as RestoreAllObjectsMaterialCommand, sr as RestoreObjectsMaterialCommand, Ec as SceneContextMenuBuilder, tn as SceneLoader, wo as SceneMesh, Oo as SceneMeshController, Fo as SceneMeshGroup, Ao as SceneMeshProxy, yo as SceneObject, Zo as SceneObjectCollection, Do as SceneObjectController, q as SceneObjectFilters, cs as SceneSprite, Du as SceneSpriteLegacy, Eu as SceneSpriteLegacyParams, Lc as SelectAllVisibleObjectsCommand, yn as SelectController, $n as SelectObjectsCommand, lr as SetAllObjectsVisibleCommand, Xu as SetCameraModeCommand, Lr as SetCameraPositionCommand, Hr as SetCameraSpherePositionCommand, nd as SetGizmoModeCommand, Ku as SetObjectControllerVisibilityCommand, fr as SetObjectTransformCommand, Nr as SetObjectsColorCommand, Pr as SetObjectsEdgesVisibilityCommand, Fr as SetObjectsOpacityCommand, cr as SetObjectsVisibilityCommand, Ir as SetObjectsXRayStatusCommand, qu as SetRenderModeCommand, On as SettingsBuilder, yi as ShowMeshObjectsBoundingBoxCommand, jc as SnapMode, Ic as SnapModeController, Ts as SpriteController, Vu as StopLoadingCommand, bn as StringController, es as TextureAtlas, cd as TimeUtils, _n as ValueController, Wl as Viewer, yt as ViewerBehavior, Kl as ViewerPlugin, js as ViewerScene, w as ViewerSignal, Vl as ViewerSignals, Ul as ViewerStats, Bl as Viewport, _l as ViewportOperator, Cl as ViewportRaycaster, rd as ViewportScreenshotCommand, _t as WorkerController, T as __UnusedParams__, Ps as _scaleDistanceFactor, wn as applyDefautSettingsValues, ci as assert, si as assertEquals, z as assertNotNull, md as createMesh, hd as createSerializedMesh, gd as createSerializedMeshProxy, I as createViewerBaseSettings, Sn as createViewerSettings, Nu as deserializeLineSegments, Lu as deserializeMesh, ju as deserializeObject3D, Uc as downloadFile, ad as filterObject, Fa as getCenter, od as getDepthObject, Ia as getDirectionFromVectors, xt as getIteratorCountValues, bt as getIteratorFirstValue, V as getNodeOffset, La as getQuaternionFromVectors, Wc as isAppleLike, Kc as isCtrlEvent, wl as isSceneMeshClipped, Gc as isWindowsLike, Gl as mergePluginSettingfunctions, Ra as projectPointOnEdge, Dn as saveSettingsToLocalStorageMap, Z as serializeLineSegments, Q as serializeMesh, Au as serializeObject3D, pd as setupTestViewer, mt as setupViewerTranslation, sd as sortRecordKeys };

//# sourceMappingURL=exports.js.map